/**
 * Created by Leonel Gonçalves on 7/2/16.
 */
(function () {
  angular.module('Cargo77.orders', [
    'ui.router',
    'ngMaterial',
    'firebase',
    'ui.utils.masks',
    'infinite-scroll',
    'ngFileUpload',
    'ngMessages',
    'ngResource',
    'lbServices',
    'ngMdIcons',
    'ngRateIt',
    'Common',
    'credit-cards',
    'uiGmapgoogle-maps',
    'Main.module',
    'Cargo77.profile',
  ]).config(Routing)
    .run(['$templateCache', function ($templateCache) {
      $templateCache.put('searchbox.tpl.html', '<input id="pac-input" class="pac-controls" type="text" placeholder="Buscar">');
    }]);

  /** @ngInject */
  function Routing($stateProvider) {
    $stateProvider
      .state('cargo.createOrder', {
        url: '/orders/create-accepted-order',
        template: '<cargo77-create-order></cargo77-create-order>',
        data: {
          pageTitle: 'Crear Flete',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER'],
          },
        },
      });

    $stateProvider
      .state('cargo.shipperCreateOrder', {
        url: '/orders/create-order',
        template: '<cargo77-shipper-create-order></cargo77-shipper-create-order>',
        data: {
          pageTitle: 'Crear Flete',
          permissions: {
            only: ['SHIPPER_OWNER', 'SHIPPER_USER'],
          },
        },
      });

    $stateProvider
      .state('cargo.editAcceptedOrder', {
        url: '/orders/{id}/edit',
        template: '<cargo77-create-order></cargo77-create-order>',
        data: {
          pageTitle: 'Editar Flete',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER'],
          },
        },
      });

    $stateProvider
      .state('cargo.listShipperOrders', {
        url: '/shipper-orders',
        template: '<cargo77-shipper-order-list></cargo77-shipper-order-list>',
        data: {
          pageTitle: 'Fletes',
          permissions: {
            only: ['SHIPPER_OWNER', 'SHIPPER_USER', 'SHIPPER_VIEWER'],
          },
          isOnDashboard: false,
          fabMenuRedirectionState: 'cargo.shipperCreateOrder',
        },
      });

    $stateProvider
      .state('cargo.listAdminOrders', {
        url: '/admin-orders',
        template: '<cargo77-admin-order-list></cargo77-admin-order-list>',
        data: {
          pageTitle: 'Fletes',
          permissions: {
            only: ['CARGO_ADMIN'],
          },
        },
      });

    $stateProvider
      .state('cargo.listOrders', {
        url: '/orders',
        template: '<cargo77-carrier-order-list></cargo77-carrier-order-list>',
        data: {
          pageTitle: 'Solicitudes',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER'],
          },
        },
      });
    $stateProvider
      .state('cargo.listAcceptedOrders', {
        url: '/accepted-orders',
        template: '<cargo77-carrier-accepted-order-list></cargo77-carrier-accepted-order-list>',
        data: {
          pageTitle: 'Fletes',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'DRIVER', 'CARRIER_VIEWER'],
          },
          isOnDashboard: false,
          fabMenuRedirectionState: 'cargo.createOrder',
        },
      });
    $stateProvider
      .state('cargo.orderDetails', {
        url: '/orders/{id}',
        template: '<cargo77-carrier-accepted-order-details></cargo77-carrier-accepted-order-details>',
        params: {
          tab: null,
        },
        data: {
          pageTitle: undefined,
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN', 'DRIVER', 'CARRIER_VIEWER'],
          },
        },
      });

    $stateProvider
      .state('cargo.shipperOrderDetails', {
        url: '/shipper-orders/{id}',
        template: '<cargo77-shipper-order-details></cargo77-shipper-order-details>',
        data: {
          pageTitle: undefined,
          permissions: {
            only: ['SHIPPER_OWNER', 'SHIPPER_USER'],
          },
        },
      });

    $stateProvider
      .state('cargo.shipperAcceptOffer', {
        url: '/shipper-orders/{id}/accept-offer/{offerId}',
        template: '<cargo77-shipper-accept-offer></cargo77-shipper-accept-offer>',
        data: {
          pageTitle: undefined,
          permissions: {
            only: ['SHIPPER_OWNER', 'SHIPPER_USER'],
          },
        },
      });

    $stateProvider
      .state('cargo.createOffer', {
        url: '/orders/{id}/offer/create',
        template: '<cargo77-carrier-send-offer></cargo77-carrier-send-offer>',
        data: {
          pageTitle: undefined,
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER'],
          },
        },
      });
    $stateProvider
      .state('cargo.editOffer', {
        url: '/orders/{id}/offer/{offerId}',
        template: '<cargo77-carrier-send-offer></cargo77-carrier-send-offer>',
        data: {
          pageTitle: 'Editar Oferta',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER'],
          },
        },
      });
    $stateProvider
      .state('cargo.listDriversByCompany', {
        url: '/orders/{id}/assignment/driver/{companyId}',
        template: '<cargo77-drivers-list-by-company></cargo77-drivers-list-by-company>',
        data: {
          pageTitle: 'Asignar conductor',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
        },
      });
    $stateProvider
      .state('cargo.listVehiclesByCompany', {
        url: '/orders/{id}/assignment/vehicle/{companyId}',
        template: '<cargo77-vehicles-list-by-company></cargo77-vehicles-list-by-company>',
        data: {
          pageTitle: 'Asignar vehículo',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
        },
      });
    $stateProvider
      .state('cargo.listTrailersByCompany', {
        url: '/orders/{id}/assignment/trailer/{companyId}',
        template: '<cargo77-trailers-list-by-company></cargo77-trailers-list-by-company>',
        data: {
          pageTitle: 'Asignar Arrastre',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
        },
      });
  }

}());

(function () {
  angular.module('Cargo77.orders').component('cargo77TransferPayment', {
    templateUrl: 'app/components/orders/components/shipperAcceptOffer/components/transferPayment/transfer-payment.html',
    controller: TransferPaymentController,
    bindings: {
      base64: '=?photo',
      documentNumber: '=',
    },
  });

  /** @ngInject */
  function TransferPaymentController() {
    var vm = this;

    vm.getBase64 = getBase64;

    function getBase64() {
      var reader = new FileReader();
      reader.readAsDataURL(vm.photo);

      reader.addEventListener('load', function () {
        vm.base64 = reader.result;
      });
      reader.addEventListener('error', function () {
        vm.photo = null;
        vm.base64 = null;
      });
    }

  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77CreditCardPayment', {
    templateUrl: 'app/components/orders/components/shipperAcceptOffer/components/creditCardPayment/credit-card-payment.html',
    controller: CreditCardPaymentController,
    bindings: {
      creditCard: '=',
    },
  });

  /** @ngInject */
  function CreditCardPaymentController(Profile) {
    var vm = this;
    vm.$onInit = onInit;

    function onInit() {
      vm.previousCreditCards = Profile.getCurrentUser().creditCards;

      vm.months = Array.apply(0, Array(12)).map(function (_, i) {
        return moment().month(i).format('MMMM') + ' (' + (i + 1) + ')';
      });
      vm.availableYears = getCreditCardYears();

      if (vm.previousCreditCards.length === 0) {
        vm.newCreditCard = true;
      }
    }

    function getCreditCardYears() {
      var years = [];
      for (var i = 0; i < 10; i++) {
        years.push(moment().add(i, 'year').format('YYYY'));
      }
      return years;
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77CovenantPayment', {
    templateUrl: 'app/components/orders/components/shipperAcceptOffer/components/covenantPayment/covenant-payment.html',
    controller: PaymentAgreementController,
    bindings: {
      areTermsAccepted: '=',
    },
  });

  /** @ngInject */
  function PaymentAgreementController($mdDialog, GlobalSettings) {

    var vm = this;

    vm.showTerms = showTerms;

    function showTerms() {
      GlobalSettings.findOne()
        .$promise
        .then(function (response) {
          $mdDialog.show({
            templateUrl: 'app/components/common/termsAndConditions/termsConditions.html',
            controller: 'TermsDialogController',
            locals: {
              terms: response.paymentAgreementTerms,
            },
            bindToController: true,
            controllerAs: '$ctrl',
          })
            .then(function () {
              vm.areTermsAccepted = true;
            })
            .catch(function () {
              vm.areTermsAccepted = false;
            });
        });
    }

  }

}());

(function () {
  angular.module('Cargo77.orders').service('VehiclesListByCompanyService', VehiclesListByCompanyService);

  /** @ngInject */
  function VehiclesListByCompanyService(Vehicle) {
    var self = this;
    self.getVehiclesByCompany = getVehiclesByCompany;

    function getVehiclesByCompany(companyId, searchText) {

      var include = [
        {
          relation: 'defaultDriver',
          scope: {
            where: {
              isActive: true,
            },
            fields: ['firstName', 'lastName', 'id', 'photo'],
          },
        },
        {
          relation: 'defaultTrailer',
          scope: {
            where: {
              isActive: true,
            },
            fields: ['name','identification', 'id', 'photo'],
          },
        },
      ];

      var where = {
        and:[
          {ownerCompanyId: companyId},
          {isActive: true},
        ],
      };

      if (searchText) {
        var regexpFilter = {like: searchText, options: 'i'};
        where.and.push({
          or: [
            {brand: regexpFilter},
            {plate: regexpFilter},
          ],
        });
      }
      return Vehicle.find({filter: {include: include, where: where, order:['plate ASC']}});
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77VehiclesListByCompanyCard', {
    templateUrl: 'app/components/orders/components/reassignment/vehiclesListByCompany/components/vehicles-list-by-company-card.html',
    controller: Cargo77VehiclesListByCompanyCardController,
    bindings: {
      vehicle: '<',
      order: '<',
    },
  });
  /** @ngInject */
  function Cargo77VehiclesListByCompanyCardController($mdDialog) {
    var vm = this;
    vm.openVehicleModal = openVehicleModal;
    vm.getEncodedURI = getEncodedURI;

    function openVehicleModal(ev) {
      $mdDialog.show({
        controller: 'AssignationModalController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {mainResource: vm.vehicle, secondaryResource: vm.vehicle.defaultDriver, order:vm.order, context: 'vehicle'},
        templateUrl: 'app/components/orders/components/common/assignationModal/assignationModal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
      });
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').service('TrailersListByCompanyService', TrailersListByCompanyService);

  /** @ngInject */
  function TrailersListByCompanyService(Trailer) {
    var self = this;
    self.getTrailersByCompany = getTrailersByCompany;

    function getTrailersByCompany(companyId, searchText) {
      var where = {
        and:[
          {ownerCompanyId: companyId},
          {isActive: true},
        ],
      };

      if (searchText) {
        var regexpFilter = {like: searchText, options: 'i'};
        where.and.push({
          or: [
            {name: regexpFilter},
            {brand: regexpFilter},
          ],
        });
      }

      return Trailer.find({filter: {where: where, order: ['name ASC']}});
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77TrailersListByCompanyCard', {
    templateUrl: 'app/components/orders/components/reassignment/trailersListByCompany/components/trailers-list-by-company-card.html',
    controller: Cargo77TrailersListByCompanyCardController,
    bindings: {
      trailer: '<',
      order: '<',
    },
  });
  /** @ngInject */
  function Cargo77TrailersListByCompanyCardController($mdDialog) {
    var vm = this;
    vm.openTrailerModal = openTrailerModal;
    vm.getEncodedURI = getEncodedURI;

    function openTrailerModal(ev) {
      $mdDialog.show({
        controller: 'AssignationModalController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {mainResource: vm.trailer, secondaryResource: null, order:vm.order, context: 'trailer'},
        templateUrl: 'app/components/orders/components/common/assignationModal/assignationModal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
      });
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').service('DriversListByCompanyService', DriversListByCompanyService);

  /** @ngInject */
  function DriversListByCompanyService(CargoUser) {
    var self = this;
    self.getDriversByCompany = getDriversByCompany;

    function getDriversByCompany(companyId, searchText) {
      var include = {
        relation: 'defaultVehicle',
        scope: {
          include: {
            relation: 'defaultTrailer',
            scope: {
              fields: ['id', 'name', 'identification'],
            },
          },
          fields: ['id', 'brand', 'model', 'year', 'plate', 'photo', 'defaultTrailerId', 'defaultTrailer'],
          where: {isActive: true},
        },
      };

      var where = {
        and:[
          {cargoCompanyId: companyId},
          {roles: {'inq': ['DRIVER']}},
          {isActive: true},
        ],
      };

      if (searchText) {
        var regexpFilter = {like: searchText, options: 'i'};
        where.and.push({
          or: [
            {firstName: regexpFilter},
            {lastName: regexpFilter},
            {phone: regexpFilter},
          ],
        });
      }

      return CargoUser.find({filter: {include: include, order: ['firstName ASC'], where: where}});
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77DriversListByCompanyCard', {
    templateUrl: 'app/components/orders/components/reassignment/driversListByCompany/components/drivers-list-by-company-card.html',
    controller: Cargo77DriversListByCompanyCardController,
    bindings: {
      user: '<',
      order: '<',
    },
  });

  /** @ngInject */
  function Cargo77DriversListByCompanyCardController($mdDialog) {
    var vm = this;
    vm.openDriverModal = openDriverModal;
    vm.getEncodedURI = getEncodedURI;

    function openDriverModal(ev) {
      $mdDialog.show({
        controller: 'AssignationModalController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {mainResource: vm.user, secondaryResource: vm.user.defaultVehicle, order:vm.order, context: 'driver'},
        templateUrl: 'app/components/orders/components/common/assignationModal/assignationModal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
      });
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }

}());

(function () {
  angular
    .module('Cargo77.orders')
    .controller('UpsertStopoverModalController', UpsertStopoverModalController);

  /** @ngInject */
  function UpsertStopoverModalController(
    Order,
    Cargo77Toast,
    $mdDialog,
    StopoversService
  ) {
    var vm = this;
    vm.$onInit = onInit;
    vm.saveStopover = saveStopover;
    vm.deleteStopover = deleteStopover;
    vm.closeDialog = closeDialog;
    vm.isSaving = false;
    vm.setMaxDate = setMaxDate;

    function onInit() {
      vm.date = vm.stopover.datetime || new Date();
      vm.time = vm.stopover.datetime || new Date();
      vm.initDate = moment(vm.date).toISOString();
      vm.date = new Date(
        moment(vm.date).second(0).milliseconds(0).toISOString()
      );
      vm.time = new Date(
        moment(vm.time).second(0).milliseconds(0).toISOString()
      );
      vm.id = vm.stopover.id;
    }

    function setMaxDate() {
      vm.maxDate = new Date(moment().second(0).milliseconds(0).toISOString());
    }

    function saveStopover() {
      vm.isSaving = true;
      setMaxDate();
      if (
        !moment(mergeDateAndTimeIntoISO(vm.date, vm.time)).isSameOrBefore(
          moment(vm.maxDate)
        )
      ) {
        hideDialog();
        Cargo77Toast.errorToast('La fecha seleccionada es inválida.');
        return;
      }

      StopoversService.constructStopoversHistoryData(
        vm.order,
        vm.stopoversNames,
        vm.disable
      ).then(function (response) {
        var existingStopover = response.find(function (stopover) {
          if (stopover.index === vm.stopover.index && stopover.id) {
            return true;
          }
        });
        var datetimeISO = mergeDateAndTimeIntoISO(vm.date, vm.time);
        var stopoverData = buildStopoverPostData(datetimeISO);

        if (!existingStopover) {
          StopoversService.saveStopover(vm.stopover.orderId, stopoverData)
            .$promise.then(function () {
              vm.isSaving = false;
              triggerSuccessActions();
            })
            .catch(function (error) {
              vm.isSaving = false;
              triggerErrorActions(error);
            });
          return;
        }

        StopoversService.updateStopoverDatetime(
          existingStopover.orderId,
          existingStopover.id,
          stopoverData.datetime
        )
          .$promise.then(function () {
            vm.isSaving = false;
            triggerSuccessActions();
          })
          .catch(function (error) {
            vm.isSaving = false;
            hideDialog();
            Cargo77Toast.errorToast(
              null,
              Object.assign(
                {},
                {
                  details: error.data.error.details,
                  message: error.data.error.message,
                }
              )
            );
          });
      });
    }

    function deleteStopover() {
      vm.isSaving = true;
      StopoversService.deleteStopover(vm.stopover.orderId, vm.stopover.id)
        .$promise.then(function () {
          vm.isSaving = false;
          triggerSuccessActions();
        })
        .catch(function (error) {
          vm.isSaving = false;
          triggerErrorActions(error);
        });
    }

    function mergeDateAndTimeIntoISO() {
      var dayMonthYear = vm.date.split('/');
      var fullISODate = vm.time;
      fullISODate.setYear(parseInt(dayMonthYear[2]));
      fullISODate.setMonth(parseInt(dayMonthYear[1]) - 1);
      fullISODate.setDate(parseInt(dayMonthYear[0]));
      return fullISODate.toISOString();
    }

    function hideDialog() {
      $mdDialog.hide();
    }

    function closeDialog() {
      hideDialog();
    }

    function buildStopoverPostData(dateTimeISO) {
      return {
        type: vm.stopover.type,
        datetime: dateTimeISO,
        locationId: vm.stopover.locationId,
      };
    }

    function triggerSuccessActions() {
      hideDialog();
      vm.callerCallBack();
      Cargo77Toast.successToast('Actualizado correctamente');
    }

    function triggerErrorActions(error) {
      hideDialog();
      Cargo77Toast.errorToast(
        null,
        Object.assign(
          {},
          {
            details: error.data.error.details,
            message: error.data.error.message,
          }
        )
      );
    }
  }
})();

(function () {
  angular
    .module('Cargo77.orders')
    .service('StopoversService', StopoversService);

  function StopoversService(Order, $q) {
    var self = this;
    self.findByOrderId = findByOrderId;
    self.saveStopover = saveStopover;
    self.updateStopoverDatetime = updateStopoverDatetime;
    self.deleteStopover = deleteStopover;
    self.constructStopoversHistoryData = constructStopoversHistoryData;

    function findByOrderId(orderId) {
      return Order.prototype$__get__stopoverHistory({ id: orderId });
    }

    function saveStopover(orderId, stopoverData) {
      return Order.prototype$__create__stopoverHistory(
        { id: orderId },
        stopoverData
      );
    }

    function updateStopoverDatetime(orderId, stopoverId, datetime) {
      return Order.prototype$__updateById__stopoverHistory(
        { id: orderId, fk: stopoverId },
        { datetime: datetime }
      );
    }

    function deleteStopover(orderId, stopoverId) {
      return Order.prototype$__destroyById__stopoverHistory({
        id: orderId,
        fk: stopoverId,
      });
    }

    function constructStopoversHistoryData(order, stopoversNames, disable) {
      var stopovers = [];
      return $q(function (resolve) {
        findByOrderId(order.id).$promise.then(function (stopoversResponse) {
          var stopoversBaseData = buildStopoversBaseData(order);
          appendDatetimeDataAndId(
            stopoversBaseData,
            stopoversResponse,
            order,
            disable
          );
          insertStopoverTitles(stopoversBaseData, stopoversNames);
          stopovers = stopoversBaseData.map(function (stopover, i) {
            if (stopover.class === 'data') {
              stopover.index = i;
              return stopover;
            }
            return stopover;
          });
          resolve(stopovers);
        });
      });
    }

    function buildStopoverDataEntry(locationId, type, orderId) {
      return {
        class: 'data',
        id: undefined,
        locationId: locationId,
        datetime: undefined,
        type: type,
        clickable: false,
        defaultMessage: '',
        orderId: orderId,
      };
    }

    function buildStopoversBaseData(order) {
      var stopoversBaseData = [];
      stopoversBaseData.push(
        buildStopoverDataEntry(
          order.route.segments[0].fromLocationId,
          'ARRIVAL',
          order.id
        )
      );
      stopoversBaseData.push(
        buildStopoverDataEntry(
          order.route.segments[0].fromLocationId,
          'DEPARTURE',
          order.id
        )
      );

      for (var i = 0; i < order.route.segments.length; i++) {
        stopoversBaseData.push(
          buildStopoverDataEntry(
            order.route.segments[i].toLocationId,
            'ARRIVAL',
            order.id
          )
        );
        stopoversBaseData.push(
          buildStopoverDataEntry(
            order.route.segments[i].toLocationId,
            'DEPARTURE',
            order.id
          )
        );
      }

      return stopoversBaseData;
    }

    function appendDatetimeDataAndId(
      stopoversBaseData,
      stopovers,
      order,
      disable
    ) {
      for (var i = 0; i < stopovers.length; i++) {
        if (
          stopoversBaseData[i].locationId !== stopovers[i].locationId ||
          stopoversBaseData[i].type !== stopovers[i].type
        ) {
          console.error(
            'Malformed stopover history.\nstopoversBaseData[i]:',
            stopoversBaseData[i],
            '\nstopovers[i]: ',
            stopovers[i],
            '\ni:',
            i
          );
          break;
        }
        stopoversBaseData[i].datetime = stopovers[i].datetime;
        stopoversBaseData[i].id = stopovers[i].id;
      }

      setupEntries(stopoversBaseData, stopovers, order, disable);
    }

    function setupEntries(stopoversBaseData, stopovers, order, disable) {
      var i;
      var isClickable = order.orderStatus === 'IN_TRANSIT' && disable !== true;
      for (i = 0; i < stopovers.length; i++) {
        stopoversBaseData[i].clickable = isClickable;
      }
      if (i < stopoversBaseData.length) {
        stopoversBaseData[i].clickable = isClickable;
        stopoversBaseData[i].defaultMessage = 'añadir';
      }
    }

    function insertStopoverTitles(stopoversBaseData, titles) {
      for (var i = 0; i < titles.length; i++) {
        stopoversBaseData.splice(i * 3, 0, buildStopoverTitleEntry(titles[i]));
      }
    }

    function buildStopoverTitleEntry(name) {
      return {
        class: 'title',
        name: name,
      };
    }
  }
})();

(function () {
  angular.module('Cargo77.notificationInbox', [
    'ngMessages',
    'ngResource',
    'lbServices',
    'ui.router',
    'ngMaterial',
    'Common',
    'Cargo77.orders',
  ]).config(Routing);

  /** @ngInject */
  function Routing($stateProvider) {
    $stateProvider
      .state('cargo.notificationInbox', {
        url: '/notification-inbox',
        template: '<cargo77-notification-inbox-list></cargo77-notification-inbox-list>',
        data: {
          pageTitle: 'Bandeja de Notificaciones',
          permissions: {
            only: ['SHIPPER_OWNER', 'SHIPPER_USER', 'CARRIER_OWNER', 'CARRIER_USER'],
          },
        },
      });
  }
}());

(function () {
  angular.module('Cargo77.notificationInbox').component('cargo77ExtrafieldChangedNotification', {
    templateUrl: 'app/components/notification-inbox/components/notificationInboxList/components/extrafieldChanged/extrafield-changed.html',
    controller: ExtraFieldChangedNotificationController,
    bindings: {
      notification: '<',
    },
  });

  function ExtraFieldChangedNotificationController($window, Cargo77Toast, NotificationsService) {
    var vm = this;
    vm.openFile = openFile;

    function openFile(event, url, notification) {
      NotificationsService.markAsRead(notification);
      $window.open(url, '_blank');

      event.stopPropagation();
      event.preventDefault();
    }
  }

}());

/**
 * Created by Leonel Gonçalves on 6/29/16.
 */

(function () {
  angular.module('Common', [
    'uiGmapgoogle-maps',
    'NavBar.component',
    'angularMoment',
    'Cargo77.notifications',
    'Cargo77.locations',
    'Sidebar.component',
    'ngMaterialDatePicker'])
    .run(momentRun);

  /** @ngInject */
  function momentRun(amMoment) {
    amMoment.changeLocale('es');
  }
}());

(function () {
  angular.module('Common').component('cargo77TextSelector', {
    templateUrl: 'app/components/companies/components/common/multiple-text-selector/text-selector/text-selector.html',
    controller: TextSelectorController,
    bindings: {
      option:  '=',
      onChangeOption: '<',
      onDeleteOption: '<',
    },
  });

  function TextSelectorController() {
    var vm = this;
    var optionIndex;
    vm.changeOption = changeOption;
    vm.deleteOption = deleteOption;

    vm.$onInit = onInit;

    function onInit() {
      optionIndex = vm.option.index;
      vm.value = vm.option.value;
      vm.mayOptionBeDeleted = optionIndex > 0;
    }

    function changeOption() {
      var newValue = vm.value;
      vm.onChangeOption(optionIndex, newValue);
    }

    function deleteOption() {
      vm.onDeleteOption(optionIndex);
    }
  }

}());

(function () {
  angular.module('Cargo77.notifications', ['drop-ng','firebase']);
}());

(function () {
  angular.module('Cargo77.notifications').component('cargo77StopoverRegistryNotification', {
    templateUrl: 'app/components/common/notifications/notificationsComponent/components/stopoverRegistry/stopover-registry-notification.html',
    controller: StopoverRegistryNotificationController,
    bindings: {
      notification: '<',
    },
  });
  function StopoverRegistryNotificationController() {
    var vm = this;
    vm.getMainTitle = getMainTitle;
    vm.getSecondaryDetails = getSecondaryDetails;

    function getMainTitle() {
      var registryType = vm.notification.stopoverType === 'ARRIVAL' ? 'llegó a ' : 'salió de ';
      return 'Flete ' + registryType + vm.notification.locationName;
    }

    function getSecondaryDetails() {
      return '#' + vm.notification.orderNumber + ' - ' + vm.notification.companyName + ' - ' + vm.notification.clientName;
    }
  }
}());

(function () {
  angular.module('Cargo77.notifications').component('cargo77PaymentStatus', {
    templateUrl: 'app/components/common/notifications/notificationsComponent/components/paymentStatus/payment-status.html',
    bindings: {
      notification: '<',
    },
  });
}());

(function () {
  angular.module('Cargo77.notifications').component('cargo77OrdersReminder', {
    templateUrl: 'app/components/common/notifications/notificationsComponent/components/ordersReminder/orders-reminder.html',
    bindings: {
      notification: '<',
    },
  });
}());

(function () {
  angular.module('Cargo77.notifications').component('cargo77NotificationOrderStatus', {
    templateUrl: 'app/components/common/notifications/notificationsComponent/components/orderStatus/order-status.html',
    bindings: {
      notification: '<',
    },
  });
}());

(function () {
  angular.module('Cargo77.notifications').component('cargo77OrderReminder', {
    templateUrl: 'app/components/common/notifications/notificationsComponent/components/orderReminder/order-reminder.html',

    bindings: {
      notification: '<',
    },
    controller: OrderReminderController,
  });
  function OrderReminderController() {
    var vm = this;
    vm.formatDate = formatDate;
    function formatDate() {
      return moment(vm.notification.date, 'YYYY-MM-DD HH-mm').format('HH:mm A');
    }
  }
}());

(function () {
  angular.module('Cargo77.notifications').component('cargo77OrderDailyReminder', {
    templateUrl: 'app/components/common/notifications/notificationsComponent/components/orderDailyReminder/order-daily-reminder.html',

    bindings: {
      notification: '<',
    },
  });
}());

(function () {
  angular.module('Cargo77.notifications').component('cargo77OrderAssigned', {
    templateUrl: 'app/components/common/notifications/notificationsComponent/components/orderAssigned/order-assigned.html',
    bindings: {
      notification: '<',
    },
    controller: OfferAssignedController,
  });

  function OfferAssignedController() {
    var vm = this;
    vm.formatDate = formatDate;
    function formatDate() {
      return moment(vm.notification.date, 'YYYY-MM-DD HH-mm').format('dddd D MMMM, YYYY - HH:mm A');
    }
  }

}());

(function () {
  angular.module('Cargo77.notifications').component('cargo77OfferReceived', {
    templateUrl: 'app/components/common/notifications/notificationsComponent/components/offerReceived/offer-received.html',
    bindings: {
      notification: '<',
    },
  });
}());

(function () {
  angular.module('Cargo77.notifications').component('cargo77OfferAccepted', {
    templateUrl: 'app/components/common/notifications/notificationsComponent/components/offerAccepted/offer-accepted.html',
    bindings: {
      notification: '<',
    },
    controller: OfferAcceptedController,
  });

  function OfferAcceptedController() {
    var vm = this;
    vm.formatDate = formatDate;
    function formatDate() {
      return moment(vm.notification.date, 'YYYY-MM-DD HH-mm').format('dddd D MMMM, YYYY - HH:mm A');
    }
  }

}());

(function () {
  angular.module('Cargo77.notifications').component('cargo77NewScore', {
    templateUrl: 'app/components/common/notifications/notificationsComponent/components/newScore/new-score.html',
    bindings: {
      notification: '<',
    },
  });

}());

(function () {
  angular.module('Cargo77.dashboard', [
    'ngResource',
    'lbServices',
    'ui.router',
    'ngMaterial',
    'Common',
    'highcharts-ng',
    'Cargo77.profile',
    'Cargo77.config',
  ])
    .config(Routing);

  /** @ngInject */
  function Routing($stateProvider) {
    $stateProvider
      .state('cargo.dashboard', {
        url: '/dashboard',
        template: '<cargo77-dashboard></cargo77-dashboard>',
        data: {
          pageTitle: 'Dashboard',
          isOnDashboard: true,
          fabMenuRedirectionState: undefined,
        },
      });
  }
}());

(function () {
  angular.module('Cargo77.dashboard').controller('DeleteGraphicModalController', DeleteGraphicModalController);

  /** @ngInject */
  function DeleteGraphicModalController($mdDialog, $state, Cargo77GraphicsService, Cargo77Toast) {
    var vm = this;
    vm.$onInit = onInit;
    vm.deleteGraphic = deleteGraphic;
    vm.closeDialog = closeDialog;

    function onInit() {
      vm.id = vm.graphic.id;
    }

    function deleteGraphic() {
      Cargo77GraphicsService.deleteGraphic(vm.id)
        .then(function () {
          Cargo77Toast.successToast('El gráfico ha sido ELIMINADO');
          $state.reload();
          hideDialog();
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function hideDialog() {
      $mdDialog.hide();
    }

    function closeDialog() {
      hideDialog();
    }

  }
}());

(function () {
  angular.module("Cargo77.dashboard").component("cargo77AddDashboardGraphic", {
    templateUrl:
      "app/components/dashboard/components/dashboardGraphics/addDashboardGraphic/addDashboardGraphic.html",
    controller: AddDashboardGraphicController,
    bindings: {
      graphic: "<",
      update: "<",
    },
  });

  /** @ngInject */
  function AddDashboardGraphicController(
    Cargo77GraphicsService,
    Cargo77ReportsService,
    $state,
    Cargo77Toast,
    Cargo77Dictionary,
    $mdDialog
  ) {
    var vm = this;
    var graphicId;
    var chartDataType;
    var graphicType;
    var graphicReportTypes = Cargo77Dictionary.getGraphicReportTypes();
    var chartDataTypes = Cargo77Dictionary.getGraphicDataTypes();
    var chartsColors = Cargo77Dictionary.getChartColors();
    vm.$onInit = onInit;
    vm.updateGraphic = updateGraphic;
    vm.openDeleteGraphicModal = openDeleteGraphicModal;

    function onInit() {
      chartDataType = vm.graphic.dataType;
      graphicType = vm.graphic.graphicType;
      graphicId = vm.graphic.id;
      vm.chartConfig = JSON.parse(vm.graphic.graphicConfig);
      vm.chartFilters = JSON.parse(vm.graphic.filters);
      vm.barChart = graphicReportTypes.BAR_CHART;
    }

    function updateGraphic() {
      // Actual Dates
      const now = new Date();
      var actualYear = now.getFullYear().toString();
      var actualMonth = (now.getMonth() + 1).toString();
      const graphicFilters = JSON.parse(vm.graphic.filters);
      const filters = graphicFilters.generalFilter;
      var company = _.find(filters.and, function (element) {
        return element.secondaryCarrierCompanyId != undefined;
      });
      var companyId;
      if (company != undefined) {
        companyId = company.secondaryCarrierCompanyId;
      }
      var newFilters = Cargo77GraphicsService.getFilters(
        actualYear,
        actualMonth,
        companyId
      );
      newFilters = filters;
      vm.chartFilters.generalFilter = newFilters;
      if (
        chartDataType === chartDataTypes.TRIPS &&
        graphicType === vm.barChart
      ) {
        Cargo77GraphicsService.processTripsGraphicData(
          newFilters,
          actualYear,
          actualMonth
        )
          .then(function (seriesAndCategories) {
            if (!_.isEmpty(seriesAndCategories)) {
              configBarChart(
                companyId,
                seriesAndCategories,
                actualYear,
                actualMonth,
                chartsColors.TRIPS
              );
            }
          })
          .catch(function (error) {
            Cargo77Toast.errorToast(null, error.data.error);
          });
      }

      if (
        chartDataType === chartDataTypes.TIMES &&
        graphicType === vm.barChart
      ) {
        Cargo77GraphicsService.processTimesGraphicData(
          newFilters,
          graphicFilters.fromLocationFilter,
          graphicFilters.toLocationsFilter
        )
          .then(function (seriesAndCategories) {
            if (!_.isEmpty(seriesAndCategories)) {
              configBarChart(
                companyId,
                seriesAndCategories,
                actualYear,
                actualMonth,
                chartsColors.TIMES
              );
            }
          })
          .catch(function (error) {
            Cargo77Toast.errorToast(null, error.data.error);
          });
      }
    }

    // CONFIG BAR CHART GRAPHIC
    function configBarChart(
      company,
      seriesAndCategories,
      actualYear,
      actualMonth,
      chartColors
    ) {
      var month = Cargo77ReportsService.getMonthName(actualMonth);
      // Setup graphic with new values
      vm.chartConfig.options.xAxis.categories = seriesAndCategories.categories;
      var rawSubtitles = Cargo77GraphicsService.getChartSubtitle(
        vm.chartConfig.options.subtitle.text
      );
      var tripsPerDriver = _.find(
        seriesAndCategories.series,
        function (element) {
          return element.name === "Viajes";
        }
      );
      var totalTrips = 0;
      if (tripsPerDriver) {
        tripsPerDriver.data.forEach(function (trips) {
          totalTrips += trips;
        });
      }
      vm.chartConfig.options.subtitle.text =
        rawSubtitles[0] +
        " <br>" +
        month +
        " " +
        actualYear +
        " <br>" +
        "Total de Viajes: " +
        totalTrips +
        " <br>" +
        rawSubtitles[2];
      vm.chartConfig.series = seriesAndCategories.series;
      vm.chartConfig.options.chart.height =
        Cargo77ReportsService.calculateChartHeight(
          seriesAndCategories.categories,
          seriesAndCategories.series,
          company
        );
      vm.chartConfig.options.colors = chartColors;

      // Save graphic with new configuration
      vm.graphic.graphicConfig = JSON.stringify(vm.chartConfig);
      vm.graphic.filters = JSON.stringify(vm.chartFilters);
      vm.graphic.lastUpdated = new Date();
      Cargo77GraphicsService.updateGraphic(vm.graphic)
        .then(function () {
          $state.reload();
          Cargo77Toast.successToast("El gráfico ha sido ACTUALIZADO");
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function openDeleteGraphicModal(ev) {
      $mdDialog.show({
        controller: "DeleteGraphicModalController",
        controllerAs: "$ctrl",
        bindToController: true,
        locals: { graphic: vm.graphic },
        templateUrl:
          "app/components/dashboard/components/dashboardGraphics/deleteGraphicModal/deleteGraphicModal.html",
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
      });
    }
  }
})();

(function () {
  angular.module('Cargo77.vehicles', [
    'ngMessages',
    'ngResource',
    'lbServices',
    'ui.router',
    'ngMaterial',
    'ngFileUpload',
    'ngImgCrop',
    'Common',
    'Cargo77.profile',
    'Cargo77.trailers',
  ]).config(Routing);

  /** @ngInject */
  function Routing($stateProvider) {
    $stateProvider
      .state('cargo.listVehicles', {
        url: '/vehicles',
        template: '<cargo77-vehicle-list></cargo77-vehicle-list>',
        data: {
          pageTitle: 'Unidades',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
          fabMenuRedirectionState: 'cargo.createVehicle',
        },
      });

    $stateProvider
      .state('cargo.createVehicle', {
        url: '/vehicles/create',
        template: '<cargo77-create-vehicle></cargo77-create-vehicle>',
        data: {
          pageTitle: 'Registrar Unidad',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
        },
      });
    $stateProvider
      .state('cargo.editVehicle', {
        url: '/vehicles/{id}',
        template: '<cargo77-edit-vehicle></cargo77-edit-vehicle>',
        data: {
          pageTitle: 'Editar Unidad',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
        },
      });

  }
}());

(function () {
  angular.module('Cargo77.vehicles').service('VehicleListService', VehicleListService);

  /** @ngInject */
  function VehicleListService(Vehicle, $q, Profile) {
    var self = this;

    //Pagination
    var vehiclesBackup = [];
    var skipStep = 20;

    self.getVehicles = getVehicles;
    self.VehiclesList = VehiclesList;

    function getVehicles(passedFilters, skip, reset) {
      var deferred = $q.defer();
      var filters = angular.copy(passedFilters);
      var searchText = filters.searchText;
      var ownerCompanyId = filters.ownerCompanyId;
      delete filters.searchText;
      delete filters.ownerCompanyId;

      if (ownerCompanyId.length > 0) {
        filters.and = [];
        filters.and.push({'ownerCompanyId': ownerCompanyId});
      }

      if (searchText.length > 0) {
        filters.or = [];
        filters.or.push({'brand': {'like': searchText, 'options': 'i'}});
        filters.or.push({'plate': {'like': searchText, 'options': 'i'}});
        filters.or.push({'model': {'like': searchText, 'options': 'i'}});
      }

      findVehicles(filters, skip)
      .$promise
      .then(function(vehicles){
        if (reset) {
          vehiclesBackup = [];
          skip = 0;
          vehiclesList.isListEnded = false;
        }
        if (vehicles.length < skipStep) {
          vehiclesList.isListEnded = true;
        }

        vehiclesBackup = _.uniqBy(vehiclesBackup.concat(vehicles));
        deferred.resolve({vehicles: vehiclesBackup, skip: (skip || 0) + skipStep});
      })
      .catch(function(error){
        deferred.reject(error);
      });
      return deferred.promise;
    }

    function findVehicles(filters, skip) {

      deleteCompanyFilterWhenUserIsAdmin(filters);

      return Vehicle.find(
        {filter: 
          {
            limit: skipStep,
            include: 'ownerCompany', 
            where: filters,
            order: ['plate ASC'],
            skip: skip || 0,
          },
        });
    }

    function deleteCompanyFilterWhenUserIsAdmin (filters) {
      if (Profile.getUserRole().indexOf('CARGO_ADMIN') >= 0) {
        delete filters.cargoCompanyId;
      }
    }

  //PAGINATION
  var vehiclesList;

  function VehiclesList(filters) {
    vehiclesList = this;
    vehiclesList.isListEnded = false;
    vehiclesList.items = [];
    vehiclesList.init = true;
    vehiclesList.busy = false;
    vehiclesList.skip = 0;
    vehiclesList.filters = filters;
    vehiclesBackup = [];
  }

  VehiclesList.prototype.nextPage = function () {
    if (vehiclesList.busy || (vehiclesList.isListEnded && !vehiclesList.busy)) {
      return;
    }

    vehiclesList.busy = true;

    self.getVehicles(vehiclesList.filters, vehiclesList.skip)
      .then(function (response) {
        vehiclesList.items = response.vehicles;
        vehiclesList.busy = false;
        vehiclesList.init = false;
        vehiclesList.skip = response.skip;
      });
  };

  }
}());

(function () {
  angular.module('Cargo77.vehicles').component('cargo77VehicleListCard', {
    templateUrl: 'app/components/vehicles/components/vehicleList/components/vehicle-list-card.html',
    controller: Cargo77VehicleListCardController,
    bindings: {
      vehicle: '<',
    },
  });

  /** @ngInject */
  function Cargo77VehicleListCardController(Cargo77Dictionary) {
    var vm = this;
    vm.getVehicleTypeName = getVehicleTypeName;
    vm.getEncodedURI = getEncodedURI;

    function getVehicleTypeName() {
      return Cargo77Dictionary.getTitleForObjectLabel('drawerTypes', vm.vehicle.type).title;
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }
}());

(function () {
  angular.module('Cargo77.users', [
    'ngMessages',
    'ngResource',
    'lbServices',
    'ui.utils.masks',
    'ui.router',
    'ngMaterial',
    'ngFileUpload',
    'ngImgCrop',
    'Common',
    'ngPassword',
    'permission',
    'Cargo77.profile',
  ]).config(Routing);

  /** @ngInject */
  function Routing($stateProvider) {
    $stateProvider
      .state('cargo.listUsers', {
        url: '/users',
        template: '<cargo77-user-list></cargo77-user-list>',
        data: {
          pageTitle: 'Usuarios',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN', 'SHIPPER_OWNER', 'SHIPPER_USER'],
          },
          fabMenuRedirectionState: 'cargo.createUser',
        },
      });
    $stateProvider
      .state('cargo.createUser', {
        url: '/users/create',
        template: '<cargo77-create-user></cargo77-create-user>',
        data: {
          pageTitle: 'Registrar usuario',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN', 'SHIPPER_OWNER', 'SHIPPER_USER'],
          },
        },
      });
    $stateProvider
      .state('cargo.editUser', {
        url: '/users/{id}',
        template: '<cargo77-edit-user></cargo77-edit-user>',
        data: {
          pageTitle: 'Editar usuario',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN', 'SHIPPER_OWNER', 'SHIPPER_USER'],
          },
        },
      });

    $stateProvider
      .state('cargo.editCurrentUser', {
        url: '/my-profile',
        template: '<cargo77-edit-current-user></cargo77-edit-current-user>',
        data: {pageTitle: 'Mi perfil'},
      });

    $stateProvider
      .state('cargo.updatePassword', {
        url: '/my-profile/update-password',
        template: '<cargo77-update-password></cargo77-update-password>',
        data: {pageTitle: 'Cambiar contraseña'},
      });
  }
}());

(function () {
  angular.module('Cargo77.users').component('cargo77UserListCard', {
    templateUrl: 'app/components/users/components/userList/components/user-list-card.html',
    controller: Cargo77UserListCardController,
    bindings: {
      user: '<',
    },
  });

  /** @ngInject */
  function Cargo77UserListCardController(Cargo77Dictionary, Profile) {
    var vm = this;
    vm.getUserTypeName = getUserTypeName;
    vm.getEncodedURI = getEncodedURI;
    vm.userRolesMap = {
      'DRIVER': 'conductor',
      'SUPER_ADMIN': 'super admin',
      'CARGO_ADMIN': 'admin',
      'SHIPPER_USER': 'operador',
      'CARRIER_USER': 'operador',
      'CARRIER_VIEWER': 'espectador',
      'CARRIER_OWNER': 'propietario',
      'SHIPPER_OWNER': 'propietario',
    };
    vm.userIsAdmin = Profile.getUserRole().indexOf('CARGO_ADMIN') >= 0 ||
      Profile.getUserRole().indexOf('SUPER_ADMIN') >= 0;

    function getUserTypeName() {
      return Cargo77Dictionary.getTitleForObjectLabel('drawerTypes', vm.user.type).title;
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }
}());

(function () {
  angular.module('Cargo77.users').service('UserListService', UserListService);

  /** @ngInject */
  function UserListService(CargoUser, $q, Profile) {
    var self = this;

    self.getUsers = getUsers;
    // Variables for pagination
    var usersBackup = [];
    var skipStep = 20;
    //---

    self.getUsers = getUsers;
    self.UsersList = UsersList;

    function getUsers(passedFilters, skip, reset) {
      var deferred = $q.defer();
      var filters = angular.copy(passedFilters);
      var searchText = filters.searchText;
      var cargoCompanyId = filters.cargoCompanyId;
      delete filters.searchText;
      delete filters.cargoCompanyId;   
      
      if(filters.roles){
        filters.and = [];
        filters.and.push({'roles': filters.roles});
      }

      if(cargoCompanyId.length > 0){
        filters.and = [];
        filters.and.push({'cargoCompanyId': cargoCompanyId});
      }

      if(searchText.length > 0) {
        filters.or = [];
        filters.or.push({ 'email': { 'like': searchText, 'options': 'i' } });
        filters.or.push({ 'firstName': { 'like': searchText, 'options': 'i' } });
        filters.or.push({ 'lastName': { 'like': searchText, 'options': 'i' } });
        filters.or.push({ 'phone': { 'like': searchText, 'options': 'i' } });

        deleteCompanyFilterWhenUserIsAdmin(filters);
        excludeSuperAdminWhenUserIsAdmin(filters);

      }

      findUsers(filters, skip)
      .$promise
      .then(function (users) {
        if (reset) {
          usersBackup = [];
          skip = 0;
          usersList.isListEnded = false;
        }
        if (users.length < skipStep) {
          usersList.isListEnded = true;
        }
        usersBackup = _.uniqBy(usersBackup.concat(users));
        deferred.resolve({users: usersBackup, skip: (skip || 0) + skipStep});
      })
      .catch(function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    // Find Users
    function findUsers(filters, skip){
      return CargoUser.find({
        filter: {
          limit: skipStep,
          include: 'cargoCompany',
          order: ['firstName ASC'],
          where: filters,
          skip: skip || 0,
        },
      });
    }

    function deleteCompanyFilterWhenUserIsAdmin (filters) {
      if (Profile.getUserRole().indexOf('CARGO_ADMIN') >= 0) {
        delete filters.cargoCompanyId;
      }
    }

    function excludeSuperAdminWhenUserIsAdmin (filters){
      if (Profile.getUserPrimaryRole() === 'CARGO_ADMIN' || Profile.getUserPrimaryRole() === 'SUPER_ADMIN') {
        filters.and.push({'roles': {'nin' : ['CARGO_ADMIN', 'SUPER_ADMIN'] }});
      }
    }

  //PAGINATION
  var usersList;

  function UsersList(filters) {
    usersList = this;
    usersList.isListEnded = false;
    usersList.items = [];
    usersList.init = true;
    usersList.busy = false;
    usersList.skip = 0;
    usersList.filters = filters;
    usersBackup = [];
  }

  UsersList.prototype.nextPage = function () {
    if (usersList.busy || (usersList.isListEnded && !usersList.busy)) {
      return;
    }

    usersList.busy = true;

    self.getUsers(usersList.filters, usersList.skip)
      .then(function (response) {
        usersList.items = response.users;
        usersList.busy = false;
        usersList.init = false;
        usersList.skip = response.skip;
      });
  };

  }

}());

(function () {
  angular.module('Cargo77.trailers', [
    'ngMessages',
    'ngResource',
    'lbServices',
    'ui.router',
    'ngMaterial',
    'ngFileUpload',
    'ngImgCrop',
    'Common',
    'Cargo77.profile',
  ]).config(Routing);

  /** @ngInject */
  function Routing($stateProvider) {
    $stateProvider
      .state('cargo.listTrailers', {
        url: '/trailers',
        template: '<cargo77-trailers-list></cargo77-trailers-list>',
        data: {
          pageTitle: 'Arrastres',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
          fabMenuRedirectionState: 'cargo.createTrailer',
        },
      });

    $stateProvider
      .state('cargo.createTrailer', {
        url: '/trailers/create',
        template: '<cargo77-create-trailer></cargo77-create-trailer>',
        data: {
          pageTitle: 'Registrar Arrastre',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
        },
      });

    $stateProvider
      .state('cargo.editTrailer', {
        url: '/trailers/{id}',
        template: '<cargo77-edit-trailer></cargo77-edit-trailer>',
        data: {
          pageTitle: 'Editar Arrastre',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
        },
      });

  }
}());

(function () {
  angular.module('Cargo77.trailers').component('cargo77TrailersListCard', {
    templateUrl: 'app/components/trailers/components/trailersList/components/trailers-list-card.html',
    controller: Cargo77TrailersListCardController,
    bindings: {
      trailer: '<',
    },
  });

  /** @ngInject */
  function Cargo77TrailersListCardController(Cargo77Dictionary) {
    var vm = this;
    vm.getTrailerTypeName = getTrailerTypeName;
    vm.getEncodedURI = getEncodedURI;

    function getTrailerTypeName() {
      return Cargo77Dictionary.getTitleForObjectLabel('trailerTypes', vm.trailer.type).title;
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }
}());

(function () {
  angular.module('Cargo77.trailers').service('TrailersListService', TrailersListService);

  /** @ngInject */
  function TrailersListService(Trailer, $q, Profile) {
    var self = this;

    //Pagination
    var trailersBackup = [];
    var skipStep = 20;
    //--

    self.getTrailers = getTrailers;
    self.TrailersList = TrailersList;
    self.getAllTrailers = getAllTrailers;

    function getAllTrailers() {
      return Trailer.find({
        filter: {
          include: {
            relation: 'ownerCompany',
            scope: {
              fields: [
                'id',
                'name',
              ],
            },
          },
        },
      });
    }

    function getTrailers(passedFilters, skip, reset) {
      var deferred = $q.defer();
      var filters = angular.copy(passedFilters);
      var searchText = filters.searchText;
      var ownerCompanyId = filters.ownerCompanyId;
      delete filters.searchText;    
      delete filters.ownerCompanyId; 
      
      if (ownerCompanyId.length > 0) {
        filters.and = [];
        filters.and.push({'ownerCompanyId': ownerCompanyId});
      }

      if (searchText.length > 0) {
        filters.or = [];
        filters.or.push({'name': { 'like': searchText, 'options': 'i' } });
        filters.or.push({'brand': { 'like': searchText, 'options': 'i' } });
        filters.or.push({'identification': { 'like': searchText, 'options': 'i' } });
      }

      findTrailers(filters, skip)
      .$promise
      .then(function(trailers){
        if (reset) {
          trailersBackup = [];
          skip = 0;
          trailersList.isListEnded = false;
        }
        if (trailers.length < skipStep) {
          trailersList.isListEnded = true;
        }

        trailersBackup = _.uniqBy(trailersBackup.concat(trailers));
        deferred.resolve({trailers: trailersBackup, skip : (skip || 0) + skipStep});
      }) .catch(function(error){
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function findTrailers(filters, skip) {

      if (Profile.getUserRole().indexOf('CARGO_ADMIN') >= 0) {
        delete filters.ownerCompanyId;
      }

      return Trailer.find({
        filter: {
          limit: skipStep,
          include: {
            relation: 'ownerCompany',
            scope: {
              fields: [
                'id',
                'name',
              ],
            },
          },
          order: ['name ASC'],
          where: filters,
          skip: skip || 0,
        },
      });
    }

      //PAGINATION
  var trailersList;

  function TrailersList(filters) {
    trailersList = this;
    trailersList.isListEnded = false;
    trailersList.items = [];
    trailersList.init = true;
    trailersList.busy = false;
    trailersList.skip = 0;
    trailersList.filters = filters;
    trailersBackup = [];
  }

  TrailersList.prototype.nextPage = function () {
    if (trailersList.busy || (trailersList.isListEnded && !trailersList.busy)) {
      return;
    }

    trailersList.busy = true;

    self.getTrailers(trailersList.filters, trailersList.skip)
      .then(function (response) {
        trailersList.items = response.trailers;
        trailersList.busy = false;
        trailersList.init = false;
        trailersList.skip = response.skip;
      });
  };

  }
}());

(function () {
  angular.module('Cargo77.reports', [
    'ngMessages',
    'ngResource',
    'lbServices',
    'ui.router',
    'ngMaterial',
    'Common',
    'Cargo77.orders',
  ]).config(Routing);

  /** @ngInject */
  function Routing($stateProvider) {
    $stateProvider
      .state('cargo.orderReport', {
        url: '/report',
        template: '<cargo77-order-report></cargo77-order-report>',
        data: {
          pageTitle: 'Reporte',
          permissions: {
            only: ['SHIPPER_OWNER', 'SHIPPER_USER'],
          },
        },
      });

    $stateProvider
      .state('cargo.reports', {
        url: '/reports',
        template: '<cargo77-reports></cargo77-reports>',
        data: {
          pageTitle: 'Reportes',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
        },
      });

    $stateProvider
      .state('cargo.orders', {
        url: '/reports/general-report',
        template: '<cargo77-order-report></cargo77-order-report>',
        data: {
          pageTitle: 'Reporte de Fletes',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
        },
      });

    $stateProvider
      .state('cargo.timesReport', {
        url: '/reports/times-report',
        template: '<cargo77-times-report></cargo77-times-report>',
        data: {
          pageTitle: 'Reporte por Tiempos de Tránsito',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
        },
      });

    $stateProvider
      .state('cargo.tripsReport', {
        url: '/reports/trips-report',
        template: '<cargo77-trips-report></cargo77-trips-report>',
        data: {
          pageTitle: 'Reporte de Viajes por Conductor y Unidad',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
        },
      });

  }
}());

(function () {
  angular.module('Cargo77.reports').component('cargo77ReportTypesCard', {
    templateUrl: 'app/components/reports/components/common/reportTypesCard/reportTypesCard.html',
    bindings: {
      title: '<',
      description: '<',
      icon: '<',
      align: '<',
    },
  });
}());

(function () {
  angular.module('Cargo77.reports').controller('OrderReportConfirmModalController', OrderReportConfirmModalController);

  /** @ngInject */
  function OrderReportConfirmModalController($mdDialog) {
    var self = this;
    self.close = close;
    self.accept = accept;

    function close() {
      $mdDialog.cancel();
    }

    function accept() {
      $mdDialog.hide(true);
    }
  }
}());


/**
 * Created by Leonel Gonçalves on 7/7/16.
 */
(function () {
  angular.module('Cargo77.orders').service('ShipperOrderListService', ShipperOrderListService);
  angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 2000);

  /** @ngInject */
  function ShipperOrderListService(Order, $q, CargoCompany, OrdersCommonService) {
    var self = this;
    var ordersBackup = [];
    var orderList;
    var skipStep = 10;

    self.getSortedOrdersByScheduledDate = getSortedOrdersByScheduledDate;
    self.OrdersList = OrdersList;

    function getSortedOrdersByScheduledDate(passedFilters, skip, reset) {
      var deferred = $q.defer();
      var filters = angular.copy(passedFilters);
      var searchText = filters.searchText;
      var searchNumber = Number(filters.searchText);
      delete filters.searchText;
      if(searchText && searchText.length > 0 ) {
        filters.or = [];
        filters.or.push({ 'extraFields.value': { 'like': searchText, 'options': 'i' } });
        filters.or.push({ 'extraFields.value': searchNumber });
        filters.or.push({ 'route.segments.extraFields.value': { 'like': searchText, 'options': 'i' } });
        filters.or.push({ 'route.segments.extraFields.value': searchNumber });
        filters.or.push({ 'orderNumber': searchText });
      }

      Order.findWithSegmentsResources({
        filter: {
          include: [
            {
              relation: 'mainCarrierCompany',
              scope: {
                fields: ['name', 'id', 'extraFields'],
              },
            },
            {
              relation: 'creator',
            },
            {
              relation: 'ownerCompany',
            },
            {
              relation: 'offers',
            },
            {
              relation: 'stopoverHistory',
              scope: {
                include: {
                  relation: 'stopoverLocation',
                  scope: {
                    fields: [
                      'id',
                      'name',
                    ],
                  },
                },
              },
            },
          ],
          limit: skipStep,
          order: ['scheduledDate DESC','duplicatesDetails DESC'],
          where: filters,
          skip: skip || 0,
        },
      })
        .$promise
        .then(function (orders) {
          OrdersCommonService.appendDefinitionToExtraFieldEntries(orders);
          return OrdersCommonService.convertOrderDatesToLocalFormat(orders);
        })
        .then(function (orders) {
          if (reset) {
            ordersBackup = [];
            skip = 0;
            orderList.hasListEnded = false;
          }
          if (orders.length < skipStep) {
            orderList.hasListEnded = true;
          }

          ordersBackup = _.uniqBy(ordersBackup.concat(orders));

          deferred.resolve({orders: OrdersCommonService.groupOrdersByDayAndMonth(ordersBackup), skip: (skip || 0) + skipStep});
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function OrdersList(filters) {
      orderList = this;
      orderList.hasListEnded = false;
      orderList.items = [];
      orderList.init = true;
      orderList.busy = false;
      orderList.skip = 0;
      orderList.filters = filters;
      ordersBackup = [];
    }

    OrdersList.prototype.nextPage = function () {
      if (orderList.busy || (orderList.hasListEnded && !orderList.busy)) {
        return;
      }

      orderList.busy = true;

      self.getSortedOrdersByScheduledDate(orderList.filters, orderList.skip)
        .then(function (response) {
          orderList.items = response.orders;
          orderList.busy = false;
          orderList.init = false;
          orderList.skip = response.skip;
        });
    };

  }
}());

(function () {

  angular.module('Cargo77.orders').service('ShipperCreateOrderService', ShipperCreateOrderService);

  /** @ngInject */
  function ShipperCreateOrderService(Order, Profile) {
    var self = this;

    self.createOrder = createOrder;

    function createOrder(order) {
      var orderToSave = angular.copy(order);
      orderToSave.creatorId = Profile.getId();
      return Order.create(orderToSave).$promise;
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77VehiclesListByCompany', {
    templateUrl: 'app/components/orders/components/reassignment/vehiclesListByCompany/vehicles-list-by-company.html',
    controller: VehiclesListByCompanyController,
  });

  /** @ngInject */
  function VehiclesListByCompanyController(VehiclesListByCompanyService, $stateParams, Order) {
    var vm = this;
    vm.companyId = $stateParams.companyId;
    vm.vehicles = VehiclesListByCompanyService.getVehiclesByCompany(vm.companyId);
    vm.$onInit = onInit;
    vm.orderId = $stateParams.id;
    vm.updateSearchText = updateSearchText;

    function onInit() {
      Order.findById({
        id: vm.orderId,
        filter: {
          include: [

            {
              relation: 'assignmentHistory',
            },
          ],
          fields: ['id', 'route'],
        },
      }).$promise
        .then(function (response) {
          vm.order = response;
        });
    }

    function updateSearchText(searchText) {
      vm.vehicles = VehiclesListByCompanyService.getVehiclesByCompany(vm.companyId, searchText);
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77TrailersListByCompany', {
    templateUrl: 'app/components/orders/components/reassignment/trailersListByCompany/trailers-list-by-company.html',
    controller: TrailersListByCompanyController,
  });

  /** @ngInject */
  function TrailersListByCompanyController(TrailersListByCompanyService, $stateParams, Order) {
    var vm = this;
    vm.companyId = $stateParams.companyId;
    vm.trailers = TrailersListByCompanyService.getTrailersByCompany(vm.companyId);
    vm.$onInit = onInit;
    vm.orderId = $stateParams.id;
    vm.updateSearchText = updateSearchText;

    function onInit() {
      Order.findById({
        id: vm.orderId,
        filter: {
          include: [
            {
              relation: 'assignmentHistory',
            },
          ],
          fields: ['id', 'route'],
        },
      }).$promise
        .then(function (response) {
          vm.order = response;
        });
    }

    function updateSearchText(searchText) {
      vm.trailers = TrailersListByCompanyService.getTrailersByCompany(vm.companyId, searchText);
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77DriversListByCompany', {
    templateUrl: 'app/components/orders/components/reassignment/driversListByCompany/drivers-list-by-company.html',
    controller: DriversListByCompanyController,
  });

  /** @ngInject */
  function DriversListByCompanyController(DriversListByCompanyService, $stateParams, Order) {
    var vm = this;
    vm.companyId = $stateParams.companyId;
    vm.users = DriversListByCompanyService.getDriversByCompany(vm.companyId);
    vm.updateSearchText = updateSearchText;
    vm.$onInit = onInit;
    vm.orderId = $stateParams.id;

    function onInit() {
      Order.findById({
        id: vm.orderId,
        filter: {
          include: [
            {
              relation: 'assignmentHistory',
            },
          ],
          fields: ['id', 'route'],
        },
      }).$promise
        .then(function (response) {
          vm.order = response;
        });
    }

    function updateSearchText(searchText) {
      vm.users = DriversListByCompanyService.getDriversByCompany(vm.companyId, searchText);
    }
  }
}());

(function () {

  angular.module('Cargo77.orders').service('CreateOrderService', CreateOrderService);

  /** @ngInject */
  function CreateOrderService(Order, Vehicle, CargoUser, Profile) {
    var self = this;

    self.createOrder = createOrder;
    self.getAcceptedOrder = getAcceptedOrder;
    self.getVehicles = getVehicles;
    self.getDrivers = getDrivers;
    self.deleteFileFromStorage = deleteFileFromStorage;

    // TODO: check filters in this function.
    function getAcceptedOrder(id) {
      return Order.findById({
        id: id,
        filter: {
          include: [
            {
              relation: 'offers',
              scope: {
                include: ['vehicle', 'driver'],
              },
            },
            {
              relation: 'cargoUser',
              scope: {
                include: {
                  relation: 'cargoCompany',
                },
              },
            },
            {
              relation: 'shipper',
            },
          ],
        },
      });
    }

    function createOrder(order) {
      var orderToSave = angular.copy(order);

      // TODO: cargoUpdate is no longer supported. Use: "prototype$updateAttributes" instead
      if (orderToSave.id) {
        return Order.cargoUpdate(orderToSave);
      }

      return Order.create(orderToSave);
    }

    function getVehicles() {
      return Vehicle.find({filter: {where: {ownerCompanyId: Profile.getCargoCompanyId()}}});
    }

    function getDrivers() {
      return CargoUser.find({filter: {where: {roles: {inq: ['DRIVER']}, cargoCompanyId: Profile.getCargoCompanyId()}}});
    }

    function deleteFileFromStorage(fileUrl){
      Order.deleteFiles({'fileUrl': fileUrl}).$promise;
    }

  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77OrderTimeline', {
    templateUrl: 'app/components/orders/components/common/orderTimeline/orderTimeline.html',
    controller: OrderTimelineController,
    bindings: {
      order: '<',
    },
  });

  /** @ngInject */
  function OrderTimelineController(Vehicle, Trailer, CargoUser, $q, Cargo77Toast, Cargo77Dictionary, OrdersCommonService) {
    var vm = this;
    var timeStatusDictionary;
    vm.$onInit = onInit;
    vm.shouldRenderTimeStatus = shouldRenderTimeStatus;
    vm.getTimeStatus = getTimeStatus;
    vm.getTimeStatusClass = getTimeStatusClass;
    vm.formatEventDate = formatEventDate;
    vm.$onChanges = onChanges;
    var arrivalDepartureLabels = Cargo77Dictionary.getOrderArrivalDepartureLabels();

    function onInit() {
      vm.events = [];
      timeStatusDictionary = Cargo77Dictionary.getOrderArrivalDepartureStatuses();
    }

    function onChanges() {
      generateEvents();
    }

    function generateEvents() {
      vm.events = [];
      getCreationEvent()
        .then(function (creationEvent) {
          vm.events.push(creationEvent);
          return getAssignationEvents();
        })
        .then(function (assignationEvents) {
          vm.events = vm.events.concat(assignationEvents);
          if (vm.order.stopoverHistory && vm.order.stopoverHistory.length > 0) {
            return getStopoverEvents();
          }
          return $q.resolve([]);
        })
        .then(function (stopoverEvents) {
          vm.events = vm.events.concat(stopoverEvents);
        })
        .catch(function () {
          var errorMessage = 'Ha ocurrido un error al obtener la información de la linea de tiempo';
          Cargo77Toast.errorToast(errorMessage);
        });
    }

    function getAssignationRelatedInfo(assignations, assignationType) {
      var deferred = $q.defer();
      if (assignations.length === 0) {
        deferred.resolve([]);
        return deferred.promise;
      }
      var resourceIds = [];
      assignations.forEach(function (assignation) {
        assignation.data.forEach(function (resource) {
          resourceIds = addUnrepeatedElementToList(resourceIds, resource.resourceId.toString());
          resource.segments = [];
          resource.segmentIds.forEach(function (segmentId, index) {
            resource.segments[index] = _.find(vm.order.route.segments, function (segment) {
              return segment.id.toString() === segmentId.toString();
            });
          });
          delete resource.segmentIds;
        });
      });
      getResourcesInfo(assignationType, resourceIds)
        .then(function (foundResources) {
          assignations.forEach(function (assignation) {
            assignation.data.forEach(function (resource) {
              var relatedFoundResource = _.find(foundResources, function (foundResource) {
                return foundResource.id.toString() === resource.resourceId.toString();
              });
              if (!relatedFoundResource) {
                return;
              }
              if (assignationType === 'Vehicle') {
                resource.brand = relatedFoundResource.brand;
                resource.plate = relatedFoundResource.plate;
              }
              if (assignationType === 'CargoUser') {
                resource.name = relatedFoundResource.firstName + ' ' + relatedFoundResource.lastName;
              }
              if (assignationType === 'Trailer') {
                resource.name = relatedFoundResource.name;
                resource.identification = relatedFoundResource.identification;
              }
            });
          });
          deferred.resolve(assignations);
        })
        .catch(function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    function getResourcesInfo(assignationType, resourceIds) {
      var assignationModel;
      var assignationTypeDictionary = {
        'Vehicle': Vehicle,
        'CargoUser': CargoUser,
        'Trailer': Trailer,
      };
      assignationModel = assignationTypeDictionary[assignationType];
      return assignationModel.find({ 'where': { 'id': resourceIds } }).$promise;
    }

    function getAssignationEvents() {
      var deferred = $q.defer();
      var result = [];
      if (!vm.order.assignmentHistory || vm.order.assignmentHistory.length === 0) {
        deferred.resolve([]);
        return deferred.promise;
      }
      getAssignationsByType('Vehicle')
        .then(function (vehicleAssignations) {
          if (assignationsAreNotAnArray(vehicleAssignations)) {
            vehicleAssignations = [];
          }
          result = result.concat(vehicleAssignations);
          return getAssignationsByType('CargoUser');
        })
        .then(function (driverAssignations) {
          if (assignationsAreNotAnArray(driverAssignations)) {
            driverAssignations = [];
          }
          result = result.concat(driverAssignations);
          return getAssignationsByType('Trailer');
        })
        .then(function (trailerAssignations) {
          if (assignationsAreNotAnArray(trailerAssignations)) {
            trailerAssignations = [];
          }
          result = result.concat(trailerAssignations);
          result = _.orderBy(result, ['date'], ['asc']);
          deferred.resolve(result);
        })
        .catch(function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    function getCreationEvent() {
      return $q.resolve({
        date: vm.order.createdAt,
        title: 'Creación de la orden',
        type: 'orderCreation',
      });
    }

    function getAssignationsByType(assignationType) {
      var assignationByType = _.filter(vm.order.assignmentHistory, function (assignmentDocument) {
        return assignmentDocument.resourceType === assignationType;
      });
      var groupedEventsByDateTypeAndResource = groupEventsByTypeDateAndResource(assignationByType, assignationType);
      return getAssignationRelatedInfo(groupedEventsByDateTypeAndResource, assignationType);
    }

    function groupEventsByTypeDateAndResource(sortedByTypeAssignations, resourceType) {
      var convertedAssignations = [];
      if (sortedByTypeAssignations.length === 0) {
        return convertedAssignations;
      }

      var filteredDates = [];
      var filteredResourcesId = [];
      sortedByTypeAssignations.forEach(function (assignation) {
        var assignationDate = assignation.createdAt.toString().split('T')[0];
        var resourceId = assignation.resourceId.toString();
        filteredDates = addUnrepeatedElementToList(filteredDates, assignationDate);
        filteredResourcesId = addUnrepeatedElementToList(filteredResourcesId, resourceId);
      });

      filteredDates.forEach(function (date) {

        var dateAssignationRegistry = {
          title: getAssignationTitle(resourceType),
          type: resourceType,
          date: date,
          data: [],
        };

        filteredResourcesId.forEach(function (resourceId) {
          var segmentIds = [];
          var specificDateAndResourceAssignations = _.filter(sortedByTypeAssignations, function (assignation) {
            return assignation.createdAt.toString().indexOf(date) > -1 && assignation.resourceId.toString() === resourceId;
          });
          specificDateAndResourceAssignations.forEach(function (relatedAssignation, index) {
            segmentIds.push(relatedAssignation.segmentId);
            if (index === 0) {
              dateAssignationRegistry.date = relatedAssignation.createdAt;
            }
          });
          if (segmentIds.length === 0) {
            return;
          }
          dateAssignationRegistry.data.push({
            resourceId: resourceId,
            segmentIds: segmentIds,
          });
        });
        convertedAssignations.push(dateAssignationRegistry);
      });

      return convertedAssignations;
    }

    function getAssignationTitle(assignationType) {
      var assignationTitles = {
        'CargoUser': 'Asignación de conductor',
        'Trailer': 'Asignación de arrastre',
        'Vehicle': 'Asignación de vehículo',
      };
      return assignationTitles[assignationType];
    }

    function shouldRenderTimeStatus(event) {
      return event.type === 'arrival' || event.type === 'departure';
    }

    function getTimeStatus(event) {
      return timeStatusDictionary[event.data.timeStatus];
    }

    function getTimeStatusClass(event) {
      return event.data.timeStatus === 'onTime' ? 'on-time-status' : 'delayed-status';
    }

    function assignationsAreNotAnArray(assignations) {
      return !assignations.length;
    }

    function formatEventDate(date) {
      return moment(date).format('DD') + ' de ' + moment(date).format('MMMM, HH:mm');
    }

    function addUnrepeatedElementToList(list, elementToAdd) {
      if (list.indexOf(elementToAdd) === -1) {
        list.push(elementToAdd);
      }
      return list;
    }

    function getStopoverEvents() {
      var result = [];

      OrdersCommonService.setStopoverTime(vm.order);

      var cont = 1;
      vm.order.stopoverHistory.forEach(function (stopover) {
        var relatedEvent = {
          date: stopover.datetime,
          type: stopover.type,
          data: {
            timeStatus: 'onTime',
          },
        };
        var stopoverTypeForTitle = stopover.type === arrivalDepartureLabels[0].label ? 'Ingreso a ' : 'Salida de ';
        relatedEvent.title = stopoverTypeForTitle + stopover.stopoverLocation.name;

        if (vm.order.stopoverHistory[cont]) {
          relatedEvent.data.time = vm.order.stopoverHistory[cont].time;
        }
        result.push(relatedEvent);
        cont++;
      });

      if (vm.order.orderStatus === 'DELIVERED') {
        var lastEvent = {
          date: vm.order.stopoverHistory.slice(-1)[0].datetime,
          type: 'departure',
          title: 'Flete finalizado',
        };
        result.push(lastEvent);
      }
      return result;
    }

  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77UpdateTimelineEventsCard', {
    templateUrl: 'app/components/orders/components/common/updateTimelineEventsCard/updateTimelineEventsCard.html',
    controller: UpdateTimelineEventsController,
    bindings: {
      'order': '<',
    },
  });

  /** @ngInject */
  function UpdateTimelineEventsController(Cargo77Dictionary, Location) {
    var vm = this;
    vm.$onInit = onInit;
    vm.updateTimeline = updateTimeline;
    vm.verifyHour = verifyHour;
    vm.orderStatus;
    vm.dateObj;

    function onInit() {
      vm.orderStatus = Cargo77Dictionary.getOrderStatusObject(vm.order.orderStatus);
      vm.orderStatus.title = vm.orderStatus.title.toUpperCase();
      createLocationsRegistry();
    }

    function verifyHour(registryDateObject) {
      var hour = registryDateObject.hour;
      var hourComponents = hour.split(':');
      if(hour.length < 5 || hourComponents[0] < '24') {
        return;
      }
      registryDateObject.hour = '23:59';
    }

    function createLocationsRegistry() {
      vm.locationsRegistry = [];
      vm.startOrderData = {};
      var locationRegistryObject = {
        arrivalDate: {
          date: '',
          hour: '',
        },
        departureDate: {
          date: '',
          hour: '',
        },
      };

      Location.getAllLocations().$promise
        .then(function(locations) {
            vm.order.route.segments.forEach(function(segment) {
              var fromLocation = _.find(locations, function(location) {
                return location.id.toString() === segment.fromLocationId.toString();
              });
              var toLocation = _.find(locations, function(location) {
                return location.id.toString() === segment.toLocationId.toString();
              });
              locationRegistryObject.location = fromLocation;
              vm.locationsRegistry.push(angular.copy(locationRegistryObject));
              locationRegistryObject.location = toLocation;
              vm.locationsRegistry.push(angular.copy(locationRegistryObject));
            });
        });
    }

    function updateTimeline() {
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77StopoversHistory', {
    templateUrl:
      'app/components/orders/components/common/stopovers/stopoversHistory.html',
    controller: StopoversHistoryController,
    bindings: {
      order: '<',
      updateOrder: '&',
      disable: '<',
    },
  });

  /** @ngInject */
  function StopoversHistoryController($mdDialog, StopoversService) {
    var vm = this;
    vm.$onInit = onInit;
    vm.openUpsertStopoverModal = openUpsertStopoverModal;

    function onInit() {
      vm.stopovers = [];
      vm.stopoversNames = [];
      fillStopoversNames();
      setStopoversHistory();
    }

    function setStopoversHistory(refresh) {
      StopoversService.constructStopoversHistoryData(
        vm.order,
        vm.stopoversNames,
        vm.disable
      ).then(function (response) {
        vm.stopovers = response;
        if (refresh) {
          vm.updateOrder();
        }
      });
    }

    function refreshStopoverHistory() {
      setStopoversHistory();
    }

    function openUpsertStopoverModal(ev, stopover) {
      $mdDialog.show({
        controller: 'UpsertStopoverModalController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {
          callerCallBack: refreshStopoverHistory,
          stopover: stopover,
          order: vm.order,
          stopoversNames: vm.stopoversNames,
          disable: vm.disable,
        },
        templateUrl:
          'app/components/orders/components/common/stopovers/upsertStopoverModal/upsertStopoverModal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
      });
    }

    function fillStopoversNames() {
      vm.stopoversNames.push(
        vm.order.route.segments[0].fromLocationInstance.name
      );

      for (var i = 0; i < vm.order.route.segments.length; i++) {
        vm.stopoversNames.push(
          vm.order.route.segments[i].toLocationInstance.name
        );
      }
    }
  }
})();

(function () {
  angular.module('Cargo77.orders').controller('StatusModalController', StatusModalController);

  /** @ngInject */
  function StatusModalController(Cargo77Dictionary, Order, Cargo77Toast, $state, $mdDialog) {
    var vm = this;
    vm.$onInit = onInit;
    vm.changeStatus = changeStatus;

    function onInit() {
      vm.selectedStatus = null;
      vm.availableStatuses = Cargo77Dictionary.getAvailableStatuses(vm.order.orderStatus);
    }

    function changeStatus() {
      var statusObject = {
        newStatus: vm.selectedStatus,
      };
      Order.prototype$changeStatus({'id': vm.order.id}, statusObject).$promise
        .then(function() {
          Cargo77Toast.successToast('Se cambio el estado de la orden con exito.');
          $state.reload();
          $mdDialog.hide();
        })
        .catch(function() {
          Cargo77Toast.errorToast('No tiene permisos para realizar este cambio.');
        });
    }

  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77ShipperOrderId', {
    templateUrl: 'app/components/orders/components/common/shipperOrderIdCard/shipper-order-id-card.html',
    controller: ShipperOrderIdController,
    bindings: {
      order: '<',
      from: '<',
      to: '<',
      onCancelOrder: '&',
      mayUserCancelOrder: '&',
    },
  });

  /** @ngInject */
  function ShipperOrderIdController(Cargo77Dictionary) {
    var vm = this;
    vm.getStatusForOrder = getStatusForOrder;

    function getStatusForOrder(status) {
      return Cargo77Dictionary.getTitleForObjectLabel('status', status.toUpperCase());
    }

  }
}());

(function () {
  angular.module('Cargo77.orders').service('OrdersCommonService', OrdersCommonService);

  function OrdersCommonService($q, CargoCompany) {
    var self = this;

    self.getRouteTextForOrder = getRouteTextForOrder;
    self.generateTitleForOrder = generateTitleForOrder;
    self.convertOrderDatesToLocalFormat = convertOrderDatesToLocalFormat;
    self.getOrdersWithCarrierCompanies = getOrdersWithCarrierCompanies;
    self.groupOrdersByDayAndMonth = groupOrdersByDayAndMonth;
    self.appendDefinitionToExtraFieldEntries = appendDefinitionToExtraFieldEntries;
    self.calculateTimeBetweenStopovers = calculateTimeBetweenStopovers;
    self.calculateTime = calculateTime;
    self.setStopoverTime = setStopoverTime;

    function getRouteTextForOrder(order, location) {
      var routeText = '';
      var text = (order.route[location + 'Address'].subLocality || order.route[location + 'Address'].neighborhood);
      if (text) {
        routeText += text + ' - ' + (order.route[location + 'Address'].locality || order.route[location + 'Address'].state);
      } else {
        routeText = order.route[location + 'Address'].address;
      }
      return routeText;
    }

    function generateTitleForOrder(order) {
      var title = '#' + order.id + ' ';
      var pickupLocality = order.route.pickupAddress.locality || order.route.pickupAddress.subLocality;
      var deliveryLocality = order.route.deliveryAddress.locality || order.route.deliveryAddress.subLocality;
      if (pickupLocality === deliveryLocality && deliveryLocality !== undefined) {
        title += 'En ' + deliveryLocality + ' - ' + order.route.deliveryAddress.state;
        return title;
      }
      title += pickupLocality + ' - ' + order.route.pickupAddress.state;
      title += ' -> ' + deliveryLocality + ' - ' + order.route.deliveryAddress.state;
      return title;
    }

    function convertOrderDatesToLocalFormat(orders) {
      return orders.map(function (order) {
        order.scheduledDate = moment.tz(order.scheduledDate, 'America/Guayaquil').format();
        return order;
      });
    }

    function getOrdersWithCarrierCompanies(orders) {
      var ordersWithCargoCompanyPromises = [];

      orders.forEach(function (order) {
        if (order.acceptedOfferSummary) {
          order.cargoCompany = CargoCompany.findById({ id: order.acceptedOfferSummary.carrierCompanyId });
        }
        ordersWithCargoCompanyPromises.push(order);
      });

      return $q.all(ordersWithCargoCompanyPromises);
    }

    function groupOrdersByDayAndMonth(orders) {
      var ordersGroupedByDay = _.groupBy(orders, function (element) {
        return moment(element.scheduledDate).format('YYYY-MM-DD');
      });

      var ordersGroupedByMonth = [];
      for (var key in ordersGroupedByDay) {

        /* istanbul ignore else */
        if (ordersGroupedByDay.hasOwnProperty(key)) {
          var month = moment(key).format('MMMM YYYY');
          var day = moment(key).format('DD ddd');
          day = day.slice(0, -1);

          var monthItem = _.find(ordersGroupedByMonth, { label: month });

          if (angular.isDefined(monthItem)) {
            monthItem.orders[day] = ordersGroupedByDay[key];
          } else {
            monthItem = { label: month, orders: {} };
            monthItem.orders[day] = ordersGroupedByDay[key];
            ordersGroupedByMonth.push(monthItem);
          }
        }
      }
      return ordersGroupedByMonth;
    }

    function appendDefinitionToExtraFieldEntries(orders) {
      orders.forEach(function (order) {

        var extraFieldsDefinitions = order.mainCarrierCompany ? order.mainCarrierCompany.extraFields : [];
        var extraFieldDefinitionById = createDefinitionsDictionary(extraFieldsDefinitions);
        order.extraFields.forEach(function (extraFieldEntry) {
          extraFieldEntry.definition = extraFieldDefinitionById[extraFieldEntry.definitionId.toString()];
        });
        order.route.segments.forEach(function (segment) {
          segment.extraFields.forEach(function (extraFieldEntry) {
            extraFieldEntry.definition = extraFieldDefinitionById[extraFieldEntry.definitionId.toString()];
          });
        });
      });
    }

    function createDefinitionsDictionary(definitions) {
      var dictionary = {};
      definitions.forEach(function (definition) {
        dictionary[definition.id.toString()] = definition;
      });
      return dictionary;
    }

    function calculateTimeBetweenStopovers(orders) {
      orders.forEach(function (order) {
        setStopoverTime(order);
      });
    }

    function setStopoverTime(order) {
      var stopoversHistory = order.stopoverHistory;
      if (stopoversHistory.length >= 2) {
        var cont = 0;
        stopoversHistory.forEach(function (stopover) {
          if (cont != 0) {
            var element = stopoversHistory[cont - 1];
            stopoversHistory[cont].time = calculateTime(element.datetime, stopover.datetime);
          }
          cont++;
        });
      }
    }

    function calculateTime(time1, time2) {
      if (time1 == undefined || time2 == undefined) {
        return undefined;
      }
      var auxTime1 = new Date(moment.tz(time1, 'America/Guayaquil').format());
      var auxTime2 = new Date(moment.tz(time2, 'America/Guayaquil').format());
      var milliseconds = moment.duration(auxTime2.getTime() - auxTime1.getTime());
      var h = milliseconds.hours();
      var m = milliseconds.minutes();
      var s = milliseconds.seconds();
      var days = milliseconds.days();
      var hours = h >= 0 && h <= 9 ? '0' + h : h;
      var minutes = m >= 0 && m <= 9 ? '0' + m : m;
      var seconds = s >= 0 && s <= 9 ? '0' + s : s;
      if (days > 0) {
        return ((days * 24) + h) + ':' + minutes + ':' + seconds;
      } 
      if (days <= 0 && hours <= 0 && minutes <= 0 ) {return '0:0:0'}
      return hours + ':' + minutes + ':' + seconds;
    }
  }

}());

/**
 * Created by cristinapatino on 7/14/16.
 */
(function () {
  angular.module('Cargo77.orders').component('cargo77OrderTime', {
    templateUrl: 'app/components/orders/components/common/orderTime/orderTime.html',
    controller: OrderTimeController,
    bindings: {
      scheduledDate: '<',
      orderRoute: '<',
    },
  });

  /** @ngInject */
  function OrderTimeController(Cargo77Dictionary) {
    var vm = this;
    var dateTimestamp =  Date.parse(vm.scheduledDate.date);
    var summerOffset = vm.orderRoute.pickupTimeZone.dstOffset * 1000;
    var timeZoneOffset =  moment.tz(vm.orderRoute.pickupTimeZone.timeZoneId).utcOffset() * 60 * 1000;
    var locationOffset = timeZoneOffset - summerOffset;
    var orderDate = new Date(dateTimestamp + locationOffset).toISOString();

    if (vm.scheduledDate.flexibleTime === false) {
      vm.time = moment.utc(orderDate).format('HH:mm a');
    }

    if(vm.scheduledDate.flexibleTime === true){
      vm.label = Cargo77Dictionary.getTitleForObjectLabel('times', getHourRangeLabel(orderDate)).title;
    }

    vm.dayOfWeek = moment.utc(orderDate).format('dddd');
    vm.dayMonth = moment.utc(orderDate).format('DD MMM');
    vm.dayMonth = vm.dayMonth.slice(0, -1);

    function getHourRangeLabel(date) {
      var hour = parseInt(date.split('T')[1].slice(0,2));
      return Cargo77Dictionary.getHourRangeLabel(hour);
    }

  }

}());

(function () {
  angular.module('Cargo77.orders').component('cargo77OrderState', {
    templateUrl: 'app/components/orders/components/common/orderState/orderState.html',
    controller: OrderStateController,
    bindings: {
      statusParam: '<status',
      onChangeStatus: '&',
    },
  });

  angular.module('Cargo77.orders').controller('DialogController', DialogController);
  /** @ngInject */
  function DialogController($mdDialog) {
    var vm = this;vm.cancel = function () {
      $mdDialog.cancel();
    };
    vm.changeState = function () {
      $mdDialog.hide(vm.state);
    };
  }

  /** @ngInject */
  function OrderStateController(Cargo77Dictionary, $mdDialog) {
    var vm = this;
    var statusDictionary = {
      ACTIVE: ['PICKUP_PENDING', 'CANCELLED'],
      PICKUP_PENDING: ['DELIVERY_PENDING', 'CANCELLED'],
      DELIVERY_PENDING: ['DELIVERED', 'CANCELLED'],
      DELIVERED: ['COMPLETED', 'CANCELLED'],
      COMPLETED: [],
      REQUESTING_OFFERS: [],
      PROCESSING_PAYMENT: [],
      CANCELLED: [],
      EXPIRED: [],
    };

    vm.$onChanges = onChanges;
    vm.showDialog = showDialog;

    function onChanges(response) {
      vm.status = Cargo77Dictionary.getTitleForObjectLabel('status', response.statusParam.currentValue);
    }

    function showDialog(ev) {
      $mdDialog.show({
        controller: 'DialogController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {statusDictionary: statusDictionary[vm.statusParam]},
        templateUrl: 'app/components/orders/components/common/orderState/change-state-popup.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
      })
        .then(function (response) {
          vm.onChangeStatus({status: response});
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77OrderSizeId', {
    templateUrl: 'app/components/orders/components/common/orderSizeId/orderSizeId.html',
    controller: OrderSizeIdController,
    bindings: {
      order: '<',
      status: '<',
      shouldHideUpdateButton: '<',
    },
  });

  /** @ngInject */
  function OrderSizeIdController(Cargo77Dictionary, Profile, OrderCommonService, $mdDialog) {
    var vm = this;
    vm.$onChanges = onChanges;
    vm.$onInit = onInit;
    vm.isOrderEditable = isOrderEditable;
    vm.changeStatus = changeStatus;

    function onInit() {
      vm.getOrderDetails = OrderCommonService.getOrderDetails;
      vm.getOrderFiles = OrderCommonService.getOrderFiles;
      vm.areFilesRelatedToOrderDetail = OrderCommonService.areFilesRelatedToOrderDetail;
      if(vm.order && vm.order.id) {
        vm.orderExtraFieldsValues = vm.order.extraFields;
        vm.orderExtraFieldsDefinitions = vm.order.ownerCompany.extraFields;
      }
    }

    function onChanges(changes) {
      var orderWasNotDefined = !vm.order ||
        (changes.order && (!changes.order.previousValue || (changes.order.previousValue && !changes.order.previousValue.id)));
      var orderIsNowDefined = changes.order && changes.order.currentValue && changes.order.currentValue.id;
      if(orderWasNotDefined && orderIsNowDefined) {
        vm.order = changes.order.currentValue;
        vm.orderExtraFieldsValues = vm.order.extraFields;
        vm.orderExtraFieldsDefinitions = vm.order.ownerCompany.extraFields;
      }
      if(changes.status) {
        vm.status = Cargo77Dictionary.getTitleForObjectLabel('status', changes.status.currentValue);
      }
    }

    function changeStatus(ev) {
      $mdDialog.show({
        controller: 'StatusModalController',
        controllerAs: '$ctrl',
        bindToController: true,
        locals: {order:vm.order},
        templateUrl: 'app/components/orders/components/common/statusModal/statusModal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
      });
    }

    function isOrderEditable () {

      var isUserAdmin = Profile.getUserPrimaryRole() === 'CARGO_ADMIN';
      var isOrderCancelled = vm.order.orderStatus === 'CANCELLED';
      var isOrderCompleted = vm.order.orderStatus === 'COMPLETED';
      var isOrderDelivered = vm.order.orderStatus === 'DELIVERED';
      return !isOrderCancelled && !isOrderCompleted && !isOrderDelivered && !isUserAdmin;

    }

  }
}());

/**
 * Created by cristinapatino on 7/14/16.
 */
(function () {
  angular.module('Cargo77.orders').component('cargo77OrderRouteMap', {
    templateUrl: 'app/components/orders/components/common/orderRouteMap/orderRouteMap.html',
    controller: OrderRouteMapController,
    bindings: {
      order: '<',
    },
  });

  /** @ngInject */
  function OrderRouteMapController($q, uiGmapGoogleMapApi, uiGmapIsReady, $firebaseObject) {
    var vm = this;
    var map;
    var mapApi;
    var directionsService;
    var directionsDisplay;
    var marker;

    vm.map = {
      center: {latitude: -0.25, longitude: -78.5},
      zoom: 10,
      options: {
        scrollwheel: false,
        navigationControl: false,
        draggable: true,
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
      },
    };
    vm.directionMarkers = {};

    vm.$onInit = onInit;
    drawDirectionInMap();

    function setPosition() {
      vm.directionMarkers.transportPosition = {
        id: marker.$id,
        options: {
          icon: {
            url: 'assets/images/transporting.png',
            scaledSize: {width: 30, height: 37.5},
          },
        },
        coords: {
          latitude: marker.lat,
          longitude: marker.lng,
        },
      };
    }

    function onInit() {
      if (vm.order.orderStatus === 'IN_TRANSIT') {
        var markerQuery = firebase.database().ref('routes/' + vm.order.id);
        marker = $firebaseObject(markerQuery);
        marker.$watch(setPosition);
      }
    }

    function drawDirectionInMap() {
      $q.all([initializeMapInstance(), initializeGoogleMapServices()])
        .then(function () {
          directionsDisplay.setMap(map);
        });
    }

    function initializeMapInstance() {
      return uiGmapIsReady.promise(1).then(function (instances) {
        instances.forEach(function (inst) {
          map = inst.map;
        });
      });
    }

    function initializeGoogleMapServices() {
      return uiGmapGoogleMapApi.then(function (maps) {
        mapApi = maps;
        directionsService = new mapApi.DirectionsService();
        directionsDisplay = new mapApi.DirectionsRenderer({'map': map});
        calculateDirectionForRoute();
      });
    }

    function calculateDirectionForRoute() {
      var origin = getLatLng(vm.order.route.segments[0].fromLocationInstance.coordinates, vm.order.route.segments[0].fromLocationInstance.coordinates);
      var destination = getLatLng(vm.order.route.segments.slice(-1)[0].toLocationInstance.coordinates, vm.order.route.segments.slice(-1)[0].toLocationInstance.coordinates);
      var locations = [];
      if (vm.order.route.segments.length > 1) {
        vm.order.route.segments.forEach(function (segment) {
          locations.push({
            location: getLatLng(segment.toLocationInstance.coordinates, segment.toLocationInstance.coordinates),
            stopover: true,
          });
        });
        locations.splice(-1, 1);
      }
      directionsService.route({
        origin: origin,
        destination: destination,
        waypoints: locations,
        travelMode: 'DRIVING',
      }, function (calcRoute) {
        directionsDisplay.setDirections(calcRoute);
      });
    }

    function getLatLng(lat, lng) {
      return new mapApi.LatLng(lat, lng);
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77OrderRouteDetails', {
    templateUrl: 'app/components/orders/components/common/orderRouteDetails/orderRouteDetails.html',
    controller: OrderRouteDetailsController,
    bindings: {
      order: '<',
    },
  });

  /** @ngInject */
  function OrderRouteDetailsController(OrderCommonService) {
    var vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.getEncodedURI = getEncodedURI;

    function onInit() {
      vm.getSegmentDetails = OrderCommonService.getOrderDetails;
      vm.getSegmentFiles = OrderCommonService.getOrderFiles;
      vm.areFilesRelatedToOrderDetail = OrderCommonService.areFilesRelatedToOrderDetail;
      if(vm.order && vm.order.id) {
        vm.orderExtraFieldsDefinitions = vm.order.ownerCompany.extraFields;
      }
    }

    function onChanges(changes) {
      var orderWasNotDefined = !vm.order ||
        (changes.order && (!changes.order.previousValue || (changes.order.previousValue && !changes.order.previousValue.id)));
      var orderIsNowDefined = changes.order && changes.order.currentValue && changes.order.currentValue.id;
      if(orderWasNotDefined && orderIsNowDefined) {
        vm.order = changes.order.currentValue;
        vm.orderExtraFieldsDefinitions = vm.order.ownerCompany.extraFields;
      }
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77OrderClient', {
    templateUrl: 'app/components/orders/components/common/orderClient/orderClient.html',
    controller: OrderClientController,
    bindings: {
      client: '<',
      orderId: '<?',
    },
  });
  function OrderClientController(Order, $state, Profile) {
    var vm = this;
    vm.joinChat = joinChat;
    vm.getEncodedURI = getEncodedURI;

    function joinChat() {
      Order.startChat({orderId: vm.orderId}, {carrierCompanyId: Profile.getCargoCompanyId()}).$promise
        .then(function (response) {
          $state.go('cargo.chat', {chatId: response.chatId});
        });
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77OfferCard', {
    templateUrl: 'app/components/orders/components/common/offerCard/offer-card.html',
    controller: OfferCardController,
    bindings: {
      offer: '<',
      isAccepted: '<',
    },
  });

  /** @ngInject */
  function OfferCardController(Cargo77Dictionary, moment, Order, $state) {
    var vm = this;
    vm.getVehicleType = getVehicleType;
    vm.getTimeFromNow = getTimeFromNow;
    vm.joinChat = joinChat;
    vm.getEncodedURI = getEncodedURI;

    function joinChat() {
      Order.startChat({orderId: vm.offer.orderId}, {carrierCompanyId: vm.offer.cargoCompanyId}).$promise.then(function (response) {
        $state.go('cargo.chat', {chatId: response.chatId});
      });
    }

    function getVehicleType(type) {
      return Cargo77Dictionary.getTitleForObjectLabel('drawerTypes', type).title;
    }

    function getTimeFromNow(time) {
      return moment(time).fromNow();
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }
}());

/**
 * Created by cristinapatino on 7/21/16.
 */

(function () {
  angular.module('Cargo77.orders').component('cargo77MakeOfferCard', {
    templateUrl: 'app/components/orders/components/common/makeOfferCard/make-offer-card.html',
    controller: MakeOfferCardController,
    bindings: {
      offer: '=',
    },
  });

  /** @ngInject */
  function MakeOfferCardController(CreateOfferService) {
    var vm = this;
    vm.drivers = CreateOfferService.getDrivers();
    vm.vehicles = CreateOfferService.getVehicles();
    vm.setDefaultVehicle = setDefaultVehicle;

    function setDefaultVehicle(item) {
      var defaultVehicle = _.find(vm.vehicles, {driverId: item.id});
      if (defaultVehicle) {
        vm.offer.vehicle = defaultVehicle;
      }
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').controller('AssignationModalController', AssignationModalController);

  /** @ngInject */
  function AssignationModalController(Order, Cargo77Toast,$mdDialog, $state) {
    var vm = this;
    vm.assignResources = assignResources;
    vm.$onInit = onInit;
    vm.getContextInfo = getContextInfo;
    vm.getResourceName = getResourceName;
    vm.getEncodedURI = getEncodedURI;
    var contextDictionary = {
      'main': {
        'vehicle':{iconLabel:'directions_bus', title: 'vehículo'},
        'driver': {iconLabel:'account_box', title:'conductor'},
        'trailer': {iconLabel:'rv_hookup', title: 'arrastre'},
      },
      'secondary': {
        'vehicle': {iconLabel:'account_box', title: 'conductor'},
        'driver': {iconLabel:'directions_bus', title: 'vehículo'},
      },
    };

    function onInit() {
      vm.shouldAssignSecondaryResource = false;
      vm.shouldAssignTrailer = false;
      vm.selectedSegment = 'all';
      vm.assignationDetails = '';
      vm.trailer = getTrailerByContext();
    }

    function getContextInfo(hierarchy, type) {
      return contextDictionary[hierarchy][vm.context][type];
    }

    function getResourceName() {
      if (vm.context === 'vehicle') {
        return vm.mainResource.brand + ' ' + vm.mainResource.model;
      }
      if (vm.context === 'trailer') {
        return vm.mainResource.name + ' ' + vm.mainResource.identification;
      }
      if (vm.context === 'driver') {
        return vm.mainResource.firstName + ' ' + vm.mainResource.lastName;
      }
    }

    function getTrailerByContext() {
      if(vm.context === 'driver' && vm.secondaryResource) {
        return vm.secondaryResource.defaultTrailer;
      }
      if(vm.context === 'vehicle') {
        return vm.mainResource.defaultTrailer;
      }
      if(vm.context === 'trailer') {
        return null;
      }
    }

    function assignResources() {
      var assignmentData = {
        'notes': vm.assignationDetails,
        'segmentsIds': [],
      };
      assignmentData = getAssignmentIds(assignmentData);
      if(vm.selectedSegment === 'all') {
        vm.order.route.segments.forEach(function(segment) {
          assignmentData.segmentsIds.push(segment.id);
        });
      } else {
        assignmentData.segmentsIds.push(vm.selectedSegment);
      }

       return Order.prototype$assignResources({id: vm.order.id}, assignmentData).$promise
        .then(function() {
          $mdDialog.hide();
          $state.go('cargo.orderDetails', {id:vm.order.id, tab: 1});
          Cargo77Toast.successToast('Las asignaciones se han realizado con exito.');
        })
        .catch(function() {
          $mdDialog.hide();
          $state.go('cargo.orderDetails', {id:vm.order.id, tab: 1});
          Cargo77Toast.errorToast('Ha ocurrido un error al crear las asignaciones.');
        });
    }

    function getAssignmentIds(assignmentData) {

      var mainResourceId = vm.mainResource.id;
      var secondaryResourceId = vm.shouldAssignSecondaryResource ? vm.secondaryResource.id : null;
      var trailerId = vm.shouldAssignTrailer ? vm.trailer.id : null;

      var assignmentDictionary = {
        'vehicle': {
          vehicleId: mainResourceId,
          driverId: secondaryResourceId,
          trailerId: trailerId,
        },
        'driver': {
          vehicleId: secondaryResourceId,
          driverId: mainResourceId,
          trailerId: trailerId,
        },
        'trailer': {
          vehicleId: null,
          driverId: null,
          trailerId: mainResourceId,
        },
      };

      for(var key in assignmentDictionary[vm.context]) {
        assignmentData[key] = assignmentDictionary[vm.context][key];
      }
      return assignmentData;
    }
    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77AssignationDetailCard', {
    templateUrl: 'app/components/orders/components/common/assignationDetailCard/assignation-detail-card.html',
    controller: AssignationDetailController,
    bindings: {
      company: '<',
      title: '<',
      type: '<',
      icon: '<',
      info: '<',
      segmentsWithoutInfo: '<',
      disableAssignment: '<',
    },
  });

  /** @ngInject */
  function AssignationDetailController(Cargo77Dictionary, $stateParams, $state) {
    var vm = this;
    vm.orderId = $stateParams.id;
    vm.$onChanges = onChanges;
    vm.getTrailerTypeName = getTrailerTypeName;
    vm.assigment = assigment;
    vm.getEncodedURI = getEncodedURI;

    function onChanges(changes) {
      if ((changes.company && changes.company.currentValue) ||
        (changes.info && changes.info.currentValue) ||
        (changes.segmentsWithoutInfo && changes.segmentsWithoutInfo.currentValue)) {
        vm.allSegmentsHasData = vm.company && vm.info.length && !vm.segmentsWithoutInfo.length;
      }
    }

    function getTrailerTypeName(type) {
      return Cargo77Dictionary.getTitleForObjectLabel('trailerTypes', type).title;
    }

    function assigment() {
      if (vm.type === 'driver') {
        $state.go('cargo.listDriversByCompany', {id: vm.orderId, companyId: vm.company.id} );
        return;
      }
      if (vm.type === 'vehicle') {
        $state.go('cargo.listVehiclesByCompany', {id: vm.orderId, companyId: vm.company.id} );
        return;
      }
      $state.go('cargo.listTrailersByCompany', {id: vm.orderId, companyId: vm.company.id} );
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }
}());

/**
 * Created by Leonel Gonçalves on 7/5/16.
 */

(function () {

  angular.module('Cargo77.orders').service('CreateOfferService', CreateOfferService);

  /** @ngInject */
  function CreateOfferService(Offer, Vehicle, CargoUser, Profile) {
    var self = this;

    self.sendOffer = sendOffer;
    self.getOffer = getOffer;
    self.updateOffer = updateOffer;
    self.getVehicles = getVehicles;
    self.getDrivers = getDrivers;

    function getOffer(id) {
      return Offer.findById({id: id, filter: {include: ['vehicle', 'driver', 'order']}});
    }

    function updateOffer(offer) {
      return Offer.prototype$updateAttributes(angular.copy(offer)).$promise;
    }

    function sendOffer(offer) {
      var offerToSend = {
        orderId: offer.orderId,
        cargoCompanyId: Profile.getCargoCompanyId(),
        creatorId: Profile.getId(),
        price: offer.price,
        detail: offer.detail,
      };
      if (angular.isDefined(offer.vehicle) && offer.vehicle !== null) {
        offerToSend.vehicleId = offer.vehicle.id;
      }

      if (angular.isDefined(offer.driver) && offer.driver !== null) {
        offerToSend.driverId = offer.driver.id;
      }

      return Offer.create(offerToSend).$promise;
    }

    function getVehicles() {
      return Vehicle.find({filter: {where: {cargoCompanyId: Profile.getCargoCompanyId()}}});
    }

    function getDrivers() {
      return CargoUser.find({filter: {where: {roles: {inq: ['DRIVER']}, cargoCompanyId: Profile.getCargoCompanyId()}}});
    }

  }
}());

/**
 * Created by Leonel Gonçalves on 7/7/16.
 */
(function () {
  angular.module('Cargo77.orders').service('CarrierOrderListService', CarrierOrderListService);
  angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 2000);

  /** @ngInject */
  function CarrierOrderListService(CargoUser, Profile, Order, $q, Offer) {
    var self = this;
    var orderList;
    var ordersBackup = [];
    var isListEnd;
    self.cargoUserId = Profile.getId();
    self.cargoCompanyId = Profile.getCargoCompanyId();
    self.getSortedOrdersByScheduledDate = getSortedOrdersByScheduledDate;
    self.getFilterForStatus = getFilterForStatus;
    self.OrdersList = OrdersList;
    self.readOrder = readOrder;

    CargoUser.prototype$resetUnviewedOrdersCount({id: self.cargoUserId});

    function getFilterForStatus(status) {
      var statusType = {
        READ: {readBy: self.cargoUserId},
        NOT_READ: {readBy: {neq: self.cargoUserId}},
        OFFER_NOT_SENT: {'offersSentBy': {neq: self.cargoCompanyId}},
        OFFER_SENT: {'offersSentBy': self.cargoCompanyId},
      };
      return statusType[status];
    }

    function getFilterForLoadSize(size) {
      return {'size.label': size };
    }

    function readOrder(orderId) {
      return Order.markAsRead({id: orderId}).$promise;
    }

    function findOrders(filters, skip) {
      if(filters.and.length === 0) {
        delete filters.and;
      }
      return Order.find({
        filter: {
          include: [
            {
              relation: 'offers',
              scope: {
                where: {
                  and: [
                    {isAccepted: false}, /*{creatorId: self.cargoCompanyId}*/
                    ],
                },
                fields: [
                  'price',
                  'id',
                ],
                include: {
                  relation: 'creator',
                  scope: {
                    fields: [
                      'id',
                    ],
                  },
                },
              },
            },
            {
              relation: 'creator',
              scope: {
                include: {
                  relation: 'cargoCompany',
                  scope: {
                    fields: ['id', 'name'],
                  },
                },
                fields: ['firstName', 'photo', 'lastName', 'cargoCompanyId'],
              },
            },
          ],
          where: filters,
          limit: 10,
          skip: skip || 0,
          order: ['createdAt DESC'],
        },
      }).$promise;
    }

    function getSortedOrdersByScheduledDate(passedFilters, skip, reset) {
      var deferred = $q.defer();
      var filters = Object.assign({}, angular.copy(passedFilters));
      var searchText = filters.searchText;
      filters.orderStatus = {
        inq : [],
      };
      filters.orderStatus.inq.push('REQUESTING_OFFERS');
      filters.orderStatus.inq.push('PROCESSING_PAYMENT');
      if (passedFilters.status) {
        filters.and.push(getFilterForStatus(passedFilters.status));
      }
      if (passedFilters.loadSize) {
        filters.and.push(getFilterForLoadSize(passedFilters.loadSize));
      }

      delete filters.searchText;
      delete filters.status;
      delete filters.loadSize;
      filters.or = [];
      filters.or.push({'id': {like: searchText, options: 'i'}});

      findOrders(filters, skip)
        .then(function (orders) {
          if (reset) {
            ordersBackup = [];
            isListEnd = false;
          }
          if (orders.length === 0) {
            isListEnd = true;
          }
          ordersBackup = _.uniqBy(ordersBackup.concat(orders), 'id');
          deferred.resolve(ordersBackup);
        });

      return deferred.promise;
    }

    function OrdersList(filters) {
      ordersBackup = [];
      orderList = this;
      orderList.items = [];
      orderList.init = true;
      orderList.busy = false;
      orderList.skip = 0;
      orderList.filters = filters;
      isListEnd = false;
    }

    function getOrderRelatedOffer (order) {
      return Offer.findById({'id':order.acceptedOfferSummary.offerId}).$promise;
    }

    OrdersList.prototype.nextPage = function () {

      if (orderList.busy || (isListEnd && !orderList.busy)) {
        return;
      }

      orderList.busy = true;

      self.getSortedOrdersByScheduledDate(orderList.filters, orderList.skip)
        .then(function (response) {
          response.forEach(function (order) {
            if(order.orderStatus === 'PROCESSING_PAYMENT'){
              getOrderRelatedOffer(order)
                .then(function(secondResponse){
                  order.processingPaymentPrice = secondResponse.price;
                });
            }
          });
          orderList.items = response;
          orderList.busy = false;
          orderList.init = false;
          orderList.skip = orderList.skip + 5;
        });
    };
  }
}());

/**
 * Created by Leonel Gonçalves on 7/6/16.
 */
(function () {
  angular.module('Cargo77.orders').component('cargo77CarrierOrderListCard',
    {
      templateUrl: 'app/components/orders/components/carrierOrderList/components/carrier-order-list-card.html',
      controller: CarrierOrderListController,
      bindings: {
        order: '=',
      },
    });

  /** @ngInject */
  function CarrierOrderListController(CarrierOrderListService, Cargo77Dictionary, LocationsHelper) {
    var vm = this;

    vm.getOrderScheduledDateLabel = getOrderScheduledDateLabel;
    vm.getOrderScheduledDate = getOrderScheduledDate;
    vm.getStatusForOrder = getStatusForOrder;
    vm.drawerTypes = getDrawerTypes();
    vm.isOrderRead = isOrderRead;
    vm.readOrder = readOrder;
    vm.isProcessingPayment = isProcessingPayment;
    vm.getFormattedStringTime = LocationsHelper.getFormattedStringTime;

    function isOrderRead() {
      if (angular.isDefined(vm.order.readBy)) {
        return vm.order.readBy.indexOf(CarrierOrderListService.cargoUserId) >= 0;
      }
      return false;
    }

    function readOrder() {
      if (!isOrderRead()) {
        CarrierOrderListService.readOrder(vm.order.id)
          .then(function () {
            if (angular.isUndefined(vm.order.readBy)) {
              vm.order.readBy = [];
            }
            vm.order.readBy.push(CarrierOrderListService.cargoUserId);
          });
      }
    }

    function getOrderScheduledDateLabel() {
      return Cargo77Dictionary.getTitleForObjectLabel('times', vm.order.scheduledDate.label).title;
    }

    function getDrawerTypes() {
      var drawerTypes = _.find(vm.order.options, function (option) {
        return option.label === 'vehicleTypes';
      });
      if (drawerTypes) {
        drawerTypes = _.map(drawerTypes.selectedTypes, function (element) {
          return Cargo77Dictionary.getTitleForObjectLabel('drawerTypes', element).title;
        });
        return drawerTypes;
      }
    }

    function getOrderScheduledDate() {
      return moment(vm.order.scheduledDate.date).format('ddd, DD MMM, YYYY');
    }

    function getStatusForOrder() {
      return Cargo77Dictionary.getTitleForObjectLabel('status', vm.order.orderStatus);
    }

    function isProcessingPayment(order){
      return order.orderStatus === 'PROCESSING_PAYMENT';
    }

  }

}());

/**
 * Created by Leonel Gonçalves on 7/7/16.
 */
(function () {
  angular.module('Cargo77.orders').service('CarrierAcceptedOrderListService', CarrierAcceptedOrderListService);
  angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 2000);

  /** @ngInject */
  function CarrierAcceptedOrderListService(Profile, Order, $q, CargoCompany, CargoUser, OrdersCommonService) {
    var self = this;
    var ordersBackup = [];
    var skipStep = 10;

    self.getSortedOrdersByScheduledDate = getSortedOrdersByScheduledDate;
    self.getFirstOrderCreated = getFirstOrderCreated;
    self.OrdersList = OrdersList;
    self.currentCompanyId = Profile.getCargoCompanyId();

    function getFirstOrderCreated() {
      var deferred = $q.defer();
      var filters = {};
      filters.and = [];
      filters.and.push({ orderStatus: 'DELIVERED' });

      findOrdersASC(filters)
        .$promise
        .then(function (orders) {
          return OrdersCommonService.convertOrderDatesToLocalFormat(orders);
        })
        .then(function (orders) {
          deferred.resolve({ orders: orders});
        })
        .catch(function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    function getSortedOrdersByScheduledDate(passedFilters, skip, reset) {
      var deferred = $q.defer();
      var filters = angular.copy(passedFilters);
      var searchText = filters.searchText;
      var searchNumber = Number(filters.searchText);
      delete filters.searchText;

      if (filters.orderStatus) {
        filters.and = [];
        filters.and.push({ orderStatus: filters.orderStatus });
        delete filters.orderStatus;
      }

      if (searchText.length > 0) {
        filters.or = [];
        filters.or.push({ 'extraFields.value': { 'like': searchText, 'options': 'i' } });
        filters.or.push({ 'extraFields.value': searchNumber });
        filters.or.push({ 'route.segments.extraFields.value': { 'like': searchText, 'options': 'i' } });
        filters.or.push({ 'route.segments.extraFields.value': searchNumber });
        filters.or.push({ 'orderNumber': searchText });
      }

      findOrders(filters, skip)
        .$promise
        .then(function (orders) {
          OrdersCommonService.appendDefinitionToExtraFieldEntries(orders);
          OrdersCommonService.calculateTimeBetweenStopovers(orders);
          return OrdersCommonService.convertOrderDatesToLocalFormat(orders);
        })
        .then(function (orders) {
          if (reset) {
            ordersBackup = [];
            skip = 0;
            orderList.isListEnded = false;
          }
          if (orders.length < skipStep) {
            orderList.isListEnded = true;
          }
          ordersBackup = _.uniqBy(ordersBackup.concat(orders));
          deferred.resolve({ orders: OrdersCommonService.groupOrdersByDayAndMonth(ordersBackup), skip: (skip || 0) + skipStep });
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function findOrders(filters, skip) {
      return Order.findWithSegmentsResources({
        filter: {
          include: [
            {
              relation: 'shipperCompany',
              scope: {
                fields: [
                  'photoURL',
                  'name',
                ],
              },
            },
            {
              relation: 'mainCarrierCompany',
            },
            {
              relation: 'secondaryCarrierCompany',
            },
            {
              relation: 'creator',
              scope: {
                include: {
                  relation: 'cargoCompany',
                  scope: {
                    fields: [
                      'id',
                      'name',
                      'extraFields',
                    ],
                  },
                },
                fields: [
                  'firstName',
                  'lastName',
                  'cargoCompanyId',
                ],
              },
            },
            {
              relation: 'offers',
              where: {
                and: [
                  {
                    isAccepted: true,
                  },
                ],
              },
            },
            {
              relation: 'extraFieldsEntries',
            },
            {
              relation: 'stopoverHistory',
              scope: {
                include: {
                  relation: 'stopoverLocation',
                  scope: {
                    fields: [
                      'id',
                      'name',
                    ],
                  },
                },
              },
            },
          ],
          limit: skipStep,
          order: ['scheduledDate DESC', 'duplicatesDetails DESC'],
          where: filters,
          skip: skip || 0,
        },
      });
    }

    function findOrdersASC(filters) {
      return Order.findWithSegmentsResources({
        filter: {
          include: [
            {
              relation: 'shipperCompany',
              scope: {
                fields: [
                  'photoURL',
                  'name',
                ],
              },
            },
            {
              relation: 'mainCarrierCompany',
            },
            {
              relation: 'secondaryCarrierCompany',
            },
            {
              relation: 'creator',
              scope: {
                include: {
                  relation: 'cargoCompany',
                  scope: {
                    fields: [
                      'id',
                      'name',
                      'extraFields',
                    ],
                  },
                },
                fields: [
                  'firstName',
                  'lastName',
                  'cargoCompanyId',
                ],
              },
            },
            {
              relation: 'offers',
              where: {
                and: [
                  {
                    isAccepted: true,
                  },
                ],
              },
            },
            {
              relation: 'extraFieldsEntries',
            },
            {
              relation: 'stopoverHistory',
              scope: {
                include: {
                  relation: 'stopoverLocation',
                  scope: {
                    fields: [
                      'id',
                      'name',
                    ],
                  },
                },
              },
            },
          ],
          limit: 1,
          order: ['scheduledDate ASC', 'duplicatesDetails ASC'],
          where: filters,
        },
      });
    }

    var orderList;

    function OrdersList(filters) {
      orderList = this;
      orderList.isListEnded = false;
      orderList.items = [];
      orderList.init = true;
      orderList.busy = false;
      orderList.skip = 0;
      orderList.filters = filters;
      ordersBackup = [];
    }

    OrdersList.prototype.nextPage = function () {
      if (orderList.busy || (orderList.isListEnded && !orderList.busy)) {
        return;
      }

      orderList.busy = true;

      self.getSortedOrdersByScheduledDate(orderList.filters, orderList.skip)
        .then(function (response) {
          orderList.items = response.orders;
          orderList.busy = false;
          orderList.init = false;
          orderList.skip = response.skip;
        });
    };

  }
}());

(function () {
  angular.module('Cargo77.payments', [
    'ui.router',
    'ngMaterial',
    'ui.utils.masks',
    'infinite-scroll',
    'ngResource',
    'lbServices',
    'ngMdIcons',
    'Common',
  ]).config(Routing);

  /** @ngInject */
  function Routing($stateProvider) {
    $stateProvider
      .state('cargo.payments', {
        url: '/payments',
        template: '<cargo77-payments-list></cargo77-payments-list>',
        data: {
          pageTitle: 'Pagos',
          permissions: {
            only: ['CARGO_ADMIN'],
          },
        },
      });
  }
}());

(function () {
  angular.module('Cargo77.payments').component('cargo77PaymentsListCard', {
    templateUrl: 'app/components/payments/components/paymentList/components/payments-list-card.html',
    controller: PaymentsListCardController,
    bindings: {
      order: '=',
      onAcceptPayment: '&',
      onUndoPayment: '&',
      onRejectPayment: '&',
    },
  });
  /** @ngInject */
  function PaymentsListCardController(Cargo77Dictionary, $mdDialog) {

    var vm = this;
    vm.getPaymentStatusForOrder = getPaymentStatusForOrder;
    vm.getPaymentTypeForOrder = getPaymentTypeForOrder;
    vm.acceptPayment = acceptPayment;
    vm.isPaymentAccepted = isPaymentAccepted;
    vm.showFullImage = showFullImage;
    vm.rejectPayment = rejectPayment;
    vm.undoPayment = undoPayment;
    vm.isPaymentRejected = isPaymentRejected;
    vm.isOrderCompletedOrDelivered = isOrderCompletedOrDelivered;
    vm.getEncodedURI = getEncodedURI;

    function showFullImage() {
      $mdDialog.show({
        clickOutsideToClose: true,
        locals: {
          image: vm.order.payment.voucherPhoto,
        },
        controllerAs: '$ctrl',
        bindToController: true,
        templateUrl: 'app/components/payments/components/paymentList/components/image-popup.html',
        controller: function DialogController() {
          this.close = function () {
            $mdDialog.hide();
          };
        },
      });
    }

    function getPaymentTypeForOrder() {
      return Cargo77Dictionary.getTitleForObjectLabel('paymentTypes', vm.order.payment.type);
    }

    function getPaymentStatusForOrder() {
      return Cargo77Dictionary.getTitleForObjectLabel('status', vm.order.payment.status);
    }

    function acceptPayment() {
      return vm.onAcceptPayment({orderId: vm.order.id});
    }

    function rejectPayment() {
      vm.onRejectPayment({orderId: vm.order.id});
    }

    function undoPayment() {
      vm.onUndoPayment({orderId: vm.order.id});
    }

    function isPaymentAccepted() {
      return ['VERIFYING', 'FAILED', 'UNPAID'].indexOf(vm.order.payment.status) < 0;
    }
    function isPaymentRejected() {
      return ['FAILED'].indexOf(vm.order.payment.status) >= 0;
    }

    function isOrderCompletedOrDelivered() {
      var orderStatus = Cargo77Dictionary.getTitleForObjectLabel('status', vm.order.orderStatus);
      return (orderStatus.label === 'DELIVERED' || orderStatus.label === 'COMPLETED') && orderStatus.title;
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }
}());

/**
 * Created by Leonel Gonçalves on 7/7/16.
 */
(function () {
  angular.module('Cargo77.orders').service('AdminOrderListService', AdminOrderListService);
  angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 2000);

  /** @ngInject */
  function AdminOrderListService(Order, $q, CargoCompany, CargoUser, OrdersCommonService) {
    var self = this;
    var skipStep = 10;
    var ordersBackup = [];

    self.getSortedOrdersByScheduledDate = getSortedOrdersByScheduledDate;
    self.OrdersList = OrdersList;

    function getSortedOrdersByScheduledDate(passedFilters, skip, reset) {
      var deferred = $q.defer();
      var filters = angular.copy(passedFilters);
      var searchText = filters.searchText;
      var searchNumber = Number(filters.searchText);
      delete filters.searchText;

      if(searchText.length > 0) {
        filters.or = [];
        filters.or.push({ 'extraFields.value': { 'like': searchText, 'options': 'i' } });
        filters.or.push({ 'extraFields.value': searchNumber });
        filters.or.push({ 'route.segments.extraFields.value': { 'like': searchText, 'options': 'i' } });
        filters.or.push({ 'route.segments.extraFields.value': searchNumber });
        filters.or.push({ 'orderNumber': searchText });
        filters.or.push({ 'id': { 'like': searchText, 'options': 'i' } });
        filters.or.push({ 'id': searchText });
      }

      Order.findWithSegmentsResources({
        filter: {
          include: [
            {
              relation: 'shipperCompany',
              scope: {
                fields: [
                  'photoURL',
                  'name',
                ],
              },
            },
            {
              relation: 'mainCarrierCompany',
            },
            {
              relation: 'secondaryCarrierCompany',
            },
            {
              relation: 'creator',
              scope: {
                include: {
                  relation: 'cargoCompany',
                  scope: {
                    fields: [
                      'id',
                      'name',
                      'extraFields',
                    ],
                  },
                },
                fields: [
                  'firstName',
                  'lastName',
                  'cargoCompanyId',
                ],
              },
            },
            {
              relation: 'offers',
              where: {
                and: [
                  {
                    isAccepted: true,
                  },
                ],
              },
            },
            {
              relation: 'extraFieldsEntries',
            },
            {
              relation: 'stopoverHistory',
              scope: {
                include: {
                  relation: 'stopoverLocation',
                  scope: {
                    fields: [
                      'id',
                      'name',
                    ],
                  },
                },
              },
            },
          ],
          limit: skipStep,
          order: ['scheduledDate DESC','duplicatesDetails DESC'],
          where: filters,
          skip: skip || 0,
        },
      })
        .$promise
        .then(function (response) {
          return OrdersCommonService.getOrdersWithCarrierCompanies(response);
        })
        .then(function (response) {
          return getDriverCompanyFromAcceptedOfferSummary(response);
        })
        .then(function (response) {
          OrdersCommonService.calculateTimeBetweenStopovers(response);
          return OrdersCommonService.convertOrderDatesToLocalFormat(response);
        })
        .then(function (orders) {
          if (reset) {
            ordersBackup = [];
            skip = 0;
            orderList.hasListEnded = false;
          }
          if (orders.length < skipStep) {
            orderList.hasListEnded = true;
          }

          ordersBackup = _.uniqBy(ordersBackup.concat(orders));

          deferred.resolve({orders: OrdersCommonService.groupOrdersByDayAndMonth(ordersBackup), skip: (skip || 0) + skipStep});
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    var orderList;

    function OrdersList(filters) {
      orderList = this;
      orderList.hasListEnded = false;
      orderList.items = [];
      orderList.init = true;
      orderList.busy = false;
      orderList.skip = 0;
      orderList.filters = filters;
      ordersBackup = [];
    }

    OrdersList.prototype.nextPage = function () {
      if (orderList.busy || (orderList.hasListEnded && !orderList.busy)) {
        return;
      }

      orderList.busy = true;

      self.getSortedOrdersByScheduledDate(orderList.filters, orderList.skip)
        .then(function (response) {
          orderList.items = response.orders;
          orderList.busy = false;
          orderList.init = false;
          orderList.skip = response.skip;
        });
    };

    function getDriverCompanyFromAcceptedOfferSummary (orders) {
      var deferred = $q.defer();
      var ordersWithCargoCompany = [];

      orders.forEach(function (order) {
        if (order.acceptedOfferSummary && order.acceptedOfferSummary.driverId) {
          CargoUser.findById({id: order.acceptedOfferSummary.driverId})
            .$promise
            .then(function (response) {
              return response.cargoCompanyId;
            })
            .then(function (response) {
              order.driverCompany = CargoCompany.findById({id: response});
            });
        }
        ordersWithCargoCompany.push(order);
      });

      deferred.resolve(ordersWithCargoCompany);

      return deferred.promise;
    }

  }
}());

(function () {
  angular.module('Cargo77.locations', [
    'ui.router',
    'ngMaterial',
    'firebase',
    'ui.utils.masks',
    'infinite-scroll',
    'ngFileUpload',
    'ngMessages',
    'ngResource',
    'lbServices',
    'ngMdIcons',
    'Common',
    'uiGmapgoogle-maps',
    'Main.module',
  ]).config(Routing)
    .run(['$templateCache', function ($templateCache) {
      $templateCache.put('searchbox.tpl.html', '<input id="pac-input" class="pac-controls" type="text" placeholder="Buscar">');
    }]);

  /** @ngInject */
  function Routing($stateProvider) {

    $stateProvider
      .state('cargo.listLocations', {
        url: '/locations',
        template: '<cargo77-locations-list></cargo77-locations-list>',
        data: {
          pageTitle: 'Ubicaciones',
          permissions: {
            only: function() {
              if(isChildCompanyUser()) {
                return ['CARGO_ADMIN', 'SHIPPER_USER', 'SHIPPER_OWNER'];
              }
              return ['CARGO_ADMIN', 'CARRIER_OWNER', 'CARRIER_USER', 'SHIPPER_USER', 'SHIPPER_OWNER'];
            },
          },
          fabMenuRedirectionState: 'cargo.createLocation',
        },
      });

    $stateProvider
      .state('cargo.createLocation', {
        url: '/locations/create-location',
        template: '<cargo77-create-location></cargo77-create-location>',
        data: {
          pageTitle: 'Crear Ubicación',
          permissions: {
            only: ['CARGO_ADMIN', 'CARRIER_OWNER', 'CARRIER_USER', 'SHIPPER_USER', 'SHIPPER_OWNER'],
          },
        },
      });
    $stateProvider
      .state('cargo.editLocation', {
        url: '/locations/{id}',
        template: '<cargo77-edit-location></cargo77-edit-location>',
        data: {
          pageTitle: 'Editar Ubicación',
          permissions: {
            only: ['CARGO_ADMIN', 'CARRIER_OWNER', 'CARRIER_USER', 'SHIPPER_USER', 'SHIPPER_OWNER'],
          },
        },
      });

  }
  function isChildCompanyUser () {
    /* istanbul ignore next */
    var localStorageUserEntry = '$Cargo77$currentUser';
    var currentUserJSON = localStorage.getItem(localStorageUserEntry);
    var currentUser = JSON.parse(currentUserJSON);
    return !!currentUser.parentCompanyId;
  }
}());

(function () {
  angular.module('Cargo77.locations').service('LocationsListService', LocationsListService);

  /** @ngInject */
  function LocationsListService(Location, Profile) {
    var self = this;
    self.getLocations = getLocations;

    function getLocations() {
      var where = {ownerCompanyId: Profile.getCargoCompanyId()};
      if (Profile.getUserRole().indexOf('CARGO_ADMIN') >= 0) {
        delete where.ownerCompanyId;
      }
      return Location.getAllLocations(where);
    }
  }
}());

(function () {
  angular.module('Cargo77.locations').component('cargo77LocationsListCard', {
    templateUrl: 'app/components/locations/components/locationsList/components/locations-list-card.html',
    controller: Cargo77LocationsListCardController,
    bindings: {
      location: '<',
    },
  });

  /** @ngInject */
  function Cargo77LocationsListCardController() {
    var vm = this;
    vm.getEncodedURI = getEncodedURI;

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }
}());

(function () {
  angular.module('Cargo77.locations').component('cargo77UpsertLocationCard', {
    templateUrl: 'app/components/locations/components/common/upsert-card/upsert-location-card.html',
    controller: LocationCardController,
    bindings: {
      location: '<',
      onSaveAction: '&',
      onDeleteAction: '&?',
    },
  });

  /** @ngInject */
  function LocationCardController() {
    var vm = this;
    vm.location = vm.location || {areTurnsRequired:false};
    vm.locationError = false;
    vm.saveLocation = saveLocation;
    vm.deleteLocation = deleteLocation;
    vm.deleteLocation = deleteLocation;
    vm.toggleManagementMenu = toggleManagementMenu;
    vm.onExactLocationChange = onExactLocationChange;

    function deleteLocation() {
      vm.onDeleteAction({id: vm.location.id});
    }

    function onExactLocationChange(location) {
      vm.location.coordinates = location.coordinates;
      vm.location.address = location.address;
      vm.locationError = false;
    }

    function saveLocation() {
      if(!vm.location.coordinates) {
        vm.locationError = true;
        return;
      }
      if(!vm.location.name || vm.location.name.length === 0) {
        return;
      }
      var locationToSave = {
        name:vm.location.name,
        ownerCompanyId: vm.location.company.id,
        coordinates:vm.location.coordinates,
        areTurnsRequired: vm.location.areTurnsRequired ? true : false,
      };
      if(vm.location.id) {
        locationToSave.id = vm.location.id;
      }
      vm.onSaveAction({location: locationToSave});
    }
    function toggleManagementMenu ($mdOpenMenu) {
      $mdOpenMenu();
    }
  }
}());

(function () {
  angular.module('Cargo77.companies', [
    'ngMessages',
    'ngResource',
    'lbServices',
    'ui.router',
    'ngMaterial',
    'ngFileUpload',
    'ngImgCrop',
    'Common']).config(Routing);

  /** @ngInject */
  function Routing($stateProvider) {
    $stateProvider
      .state('cargo.createCompany', {
        url: '/companies/create',
        template: '<cargo77-create-company></cargo77-create-company>',
        data: {
          pageTitle: 'Registrar Compañía',
          permissions: {
            only: ['CARGO_ADMIN','CARRIER_OWNER'],
          },
        },
      });

    $stateProvider
      .state('cargo.shipperCompanies', {
        url: '/companies/shippers',
        template: '<cargo77-list-companies type-filter="\'SHIPPER\'"></cargo77-list-companies>',
        data: {
          pageTitle: 'Clientes',
          permissions: {
            only: function() {
              if(isChildCompanyUser()) {
                return ['CARGO_ADMIN'];
              }
              return ['CARRIER_OWNER','CARRIER_USER'];
            },
          },
          fabMenuRedirectionState: 'cargo.createShipperChildCompany',
        },
      });

    $stateProvider
      .state('cargo.createShipperChildCompany', {
        url: '/companies/createShipper',
        template: '<cargo77-create-child-company type="\'SHIPPER\'"></cargo77-create-child-company>',
        data: {
          pageTitle: 'Crear Cliente',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
        },
      });

    $stateProvider
      .state('cargo.carrierCompanies', {
        url: '/companies/carriers',
        template: '<cargo77-list-companies type-filter="\'CARRIER\'"></cargo77-list-companies>',
        data: {
          pageTitle: 'Transportistas',
          permissions: {
            only: function() {
              if(isChildCompanyUser()) {
                return ['CARGO_ADMIN'];
              }
              return ['CARRIER_OWNER','CARRIER_USER'];
            },
          },
          fabMenuRedirectionState: 'cargo.createCarrierChildCompany',
        },
      });

    $stateProvider
      .state('cargo.listCompanies', {
        url: '/companies',
        template: '<cargo77-list-companies></cargo77-list-companies>',
        data: {
          pageTitle: 'Compañías',
          permissions: {
            only: ['CARGO_ADMIN'],
          },
        },
      });

    $stateProvider
      .state('cargo.createCarrierChildCompany', {
        url: '/companies/createCarrier',
        template: '<cargo77-create-child-company type="\'CARRIER\'"></cargo77-create-child-company>',
        data: {
          pageTitle: 'Crear Transportista',
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER', 'CARGO_ADMIN'],
          },
        },
      });

    $stateProvider
      .state('cargo.editChildCompany', {
        url: '/companies/edit/{id}',
        template: '<cargo77-edit-child-company></cargo77-edit-child-company>',
        data: {
          pageTitle: 'Editar Compañía',
          permissions: {
            only: ['CARRIER_OWNER','CARRIER_USER','CARGO_ADMIN'],
          },
        },
      });

    $stateProvider
      .state('cargo.editCurrentCompany', {
        url: '/company/company-profile/{tab}',
        template: '<cargo77-edit-current-company></cargo77-edit-current-company>',
        data: {
          pageTitle: 'Perfil de Empresa',
          permissions: {
            only: ['CARRIER_OWNER', 'SHIPPER_OWNER'],
          },
        },
      });

    $stateProvider
      .state('cargo.createFieldByCompany', {
        url: '/company/company-profile/field/create',
        template: '<cargo77-create-field-by-company></cargo77-create-setting-by-company>',
        data: {
          pageTitle: 'Agregar campo personalizado de Empresa',
          permissions: {
            only: ['CARRIER_OWNER'],
          },
        },
      });

    $stateProvider
      .state('cargo.editFieldByCompany', {
        url: '/company/company-profile/field/{id}',
        template: '<cargo77-edit-field-by-company></cargo77-edit-setting-by-company>',
        data: {
          pageTitle: 'Editar campo personalizado de Empresa',
          permissions: {
            only: ['CARRIER_OWNER'],
          },
        },
      });
  }
  function isChildCompanyUser () {
    /* istanbul ignore next */
    var localStorageUserEntry = '$Cargo77$currentUser';
    var currentUserJSON = localStorage.getItem(localStorageUserEntry);
    var currentUser = JSON.parse(currentUserJSON);
    return !!currentUser.parentCompanyId;
  }
}());

(function () {
  angular.module('Cargo77.companies').component('cargo77ListFieldsByCompany', {
    templateUrl: 'app/components/companies/components/listFieldsByCompany/components/list-fields-by-company.html',
    controller: CompanyListFieldsController,
    bindings: {
      company: '<',
    },
  });

  /** @ngInject */
  function CompanyListFieldsController(Cargo77Dictionary, ExtraFieldCompaniesService, Cargo77Toast, $state) {
    var vm = this;
    vm.$onInit = onInit;
    vm.getDataForExtraFields = getDataForExtraFields;
    vm.changeFieldStatus = changeFieldStatus;
    vm.deleteField = deleteField;

    function onInit() {
      if (angular.isUndefined(vm.company)) {
        vm.company = {};
      }
    }

    function getDataForExtraFields(title, subtitle, label) {
      return Cargo77Dictionary.getDataForExtraFields(title, subtitle, label).title;
    }

    function changeFieldStatus(extraField) {
      extraField.isActive = !extraField.isActive;
      extraField.isRequired = false;
      ExtraFieldCompaniesService.updateField(vm.company.id, extraField.id, extraField)
        .then(function () {
          $state.go('cargo.editCurrentCompany', {tab: 1});
          if(extraField.isActive) {
            Cargo77Toast.successToast('El campo ha sido activado con éxito.');
          } else {
            Cargo77Toast.successToast('El campo ha sido desactivado con éxito.');
          }
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function deleteField(extraField) {

      ExtraFieldCompaniesService.deleteField(vm.company.id, extraField.id)
        .then(function () {
          $state.reload();
          Cargo77Toast.successToast('El campo ha sido eliminado con éxito.');
        })
        .catch(function (error) {
          if(error.data && error.data.error) {
            Cargo77Toast.errorToast(null, error.data.error);
            return;
          }
          Cargo77Toast.errorToast('Ha ocurrido un error al eliminar este campo.');
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.companies').component('cargo77ListCompaniesCard', {
    templateUrl: 'app/components/companies/components/listCompanies/components/list-companies-card.html',
    controller: Cargo77ListCompaniesCardController,
    bindings: {
      company: '<',
    },
  });
  /** @ngInject */
  function Cargo77ListCompaniesCardController() {
    var vm = this;
    vm.getEncodedURI = getEncodedURI;

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }
}());

(function () {
  angular.module('Cargo77.companies').component('cargo77UpsertCompanyCard', {
    templateUrl: 'app/components/companies/components/common/profileCard/upsert-company-card.html',
    controller: CompanyCardController,
    bindings: {
      companyType: '<',
      company: '<',
      onSaveAction: '&',
      onDeleteAction: '&?',
      parentCompany: '<',
    },
  });

  /** @ngInject */
  function CompanyCardController(Profile, Cargo77Toast, Order, CreateOrderService, CompaniesService, $state) {
    var vm = this;
    vm.$onInit = onInit;
    vm.saveChanges = saveChanges;
    vm.deleteCompany = deleteCompany;
    vm.changeCompanyStatus = changeCompanyStatus;
    vm.toggleManagementMenu = toggleManagementMenu;
    vm.isCarrierCompany = isCarrierCompany;
    vm.userIsAdmin = userIsAdmin;
    vm.getEncodedURI = getEncodedURI;
    vm.onFileSelect = onFileSelect;
    vm.removeFile = removeFile;
    vm.showFileInput = showFileInput;

    function onInit() {
      vm.value = null;
      vm.saving = false;
      vm.showDeleteButton = false;
      vm.allFilesUploaded = [];
      vm.logoURLAux = [];
      if (angular.isUndefined(vm.company)) {
        vm.isCreating = true;
        vm.company = {};
      }
      initOperationExpirationDate();
      vm.company.type = vm.company.type || vm.companyType;
    }

    function initOperationExpirationDate() {
      if (vm.company.$promise) {
        vm.company.$promise.then(function (company) {
          if (company.permissionValidUntil) {
            vm.permissionValidUntilInit = moment(company.permissionValidUntil).toISOString();
          }
        });
      }
    }

    function deleteCompany() {
      vm.onDeleteAction({ company: vm.company });
    }

    function changeCompanyStatus(isActive) {
      vm.company.isActive = isActive;
      vm.onSaveAction({ company: vm.company });
    }

    function saveChanges() {
      if (vm.allFilesUploaded.length > 0) {
        vm.company.logoURL = vm.allFilesUploaded[0].url;
        vm.company.logoFileName = vm.auxLogoFileName;
      }
      if (!vm.picFile) {
        vm.company.photo = undefined;
      } else {
        vm.company.photo = vm.photo;
        vm.company.photoFileName = vm.picFile.name;
      }

      if (angular.isDefined(vm.company.phone) && vm.company.phone[0] !== '+') {
        vm.company.phone = '+' + vm.company.phone;
      }

      if (angular.isDefined(vm.permissionValidUntil)) {
        vm.company.permissionValidUntil = new Date(moment(vm.permissionValidUntil)).toISOString();
      }
      if (Profile.getUserRole().indexOf('CARGO_ADMIN') >= 0) {
        CompaniesService.updateCompany(vm.company)
          .then(function () {
            $state.go('cargo.listCompanies');
            Cargo77Toast.successToast('La información de la compañía ha sido actualizada.');
          })
          .catch(function (error) {
            Cargo77Toast.errorToast(null, error.data.error);
          });
      } else {
        vm.onSaveAction({ company: vm.company, parentCompanyId: getSelectedCompanyId() });
      }

      vm.logoURLAux.forEach(function (element) {
        CreateOrderService.deleteFileFromStorage(element);
      });
      vm.logoURL = [];

    }

    function toggleManagementMenu($mdOpenMenu) {
      $mdOpenMenu();
    }

    function isCarrierCompany() {
      return vm.company.type === 'CARRIER';
    }

    function getSelectedCompanyId() {
      if (angular.isUndefined(vm.selectedCompany) || vm.selectedCompany === null) {
        return undefined;
      }
      return vm.selectedCompany.id;
    }

    function userIsAdmin() {
      if (Profile.getUserRole().indexOf('CARGO_ADMIN') >= 0) {
        return true;
      }
      return false;
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }

    function onFileSelect(files) {
      vm.saving = true;
      var file = files[0];
      var fileName = 'No file choosen';
      if (file) {
        fileName = file.name;
        //Verify if the file size is lower than the max size
        var maxSize = 4 * 1024 * 1024;
        if (!fileValidation(fileName)) {
          Cargo77Toast.errorToast('Tipo de archivo NO permitido');
          vm.value = null;
        } else {
          if (file.size > maxSize) {
            vm.value = null;
            Cargo77Toast.errorToast('El archivo: ' + fileName + ', es muy pesado. (Tamaño Max. 4Mb)');
          } else {
            getFileInBase64(file, fileName);
          }
        }
      }
    }

    function getFileInBase64(file, fileName) {
      vm.auxLogoFileName = fileName;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        var fileInBase64 = reader.result;
        Order.uploadFiles({}, {
          fileName: fileName,
          fileInBase64: fileInBase64,
        })
          .$promise
          .then(function (response) {
            vm.saving = false;
            removeFile(false, null);
            vm.allFilesUploaded.push(response);
            Cargo77Toast.successToast('Se ha subido el archivo: ' + fileName);
            vm.showDeleteButton = true;
          });
      };
    }

    function fileValidation(fileName) {
      var file = fileName;
      var allowedExtensions = /(.jpg|.jpeg|.png|.svg)$/i;
      if (!allowedExtensions.exec(file)) {
        return false;
      } else {
        return true;
      }
    }

    function removeFile(emptyFileName, company) {
      if (company) {
        vm.logoURLAux.push(company.logoURL);
      }
      if (emptyFileName) {
        vm.company.logoFileName = null;
        vm.company.logoURL = null;
        vm.value = null;
      }
      var showMessage = false;
      vm.allFilesUploaded.forEach(function (element) {
        CreateOrderService.deleteFileFromStorage(element.url);
        showMessage = true;
      });
      if (!emptyFileName || company == null) {
        showMessage = false;
      }
      if (showMessage) {
        Cargo77Toast.successToast('Archivo eliminado');
      }
      vm.allFilesUploaded = [];
    }

    function showFileInput(company) {
      if (company) {
        vm.logoURLAux.push(company.logoURL);
      }
      vm.company.logoFileName = null;
      vm.company.logoURL = null;
      vm.value = null;
    }

  }
}());

(function () {
  angular.module('Common').component('cargo77MultipleTextSelector', {
    templateUrl: 'app/components/companies/components/common/multiple-text-selector/multiple-text-selector.html',
    controller: MultipleTextSelectorController,
    bindings: {
      'options': '=',
      'onChangeOptions': '&',
    },
  });

  function MultipleTextSelectorController() {
    var vm = this;
    vm.currentOptions = []; 
    vm.$onInit = onInit;
    vm.addNewOption = addNewOption;
    vm.changeOption = changeOption;
    vm.deleteOption = deleteOption;

    function onInit() {
      vm.totalOfOptions = 1;
      vm.invalidFields = false;
      if(vm.options && vm.options.length > 0) {
        vm.options.forEach(function(option) {
          vm.currentOptions.push({index: vm.totalOfOptions - 1, value: option});
          vm.totalOfOptions++;
        });
        return;
      }
      vm.currentOptions = [
        {index: 0,  value: null},
      ];
    }

    function addNewOption() {
      var arePreviousFieldsInvalid = areFieldsInvalid();
      if(arePreviousFieldsInvalid) {
        vm.invalidFields = true;
        return;
      }
      vm.invalidFields = false;
      var newOption = {
        index: vm.totalOfOptions,
        value: null,
      };
      vm.totalOfOptions++;
      vm.currentOptions.push(newOption);
      createFinalOptions();
    }

    function areFieldsInvalid() {
      var areFieldsMissing = false;
      vm.currentOptions.forEach(function(option) {
        if(!option.value) {
          areFieldsMissing = true;
        }
      });
      return areFieldsMissing;
    }

    function deleteOption(optionIndex) {
      var indexToDelete = getIndexInArray(optionIndex);
      vm.currentOptions.splice(indexToDelete, 1);
      createFinalOptions();
    }

    function changeOption(optionIndex, value) {
      var objectIndexToToChange = getIndexInArray(optionIndex);

      vm.currentOptions[objectIndexToToChange].value = value;
      createFinalOptions();
    }

    function createFinalOptions() {
      vm.options = [];
      vm.currentOptions.map(function(option) {
        if(option.value) {
          vm.options.push(option.value);
        }
      });
      vm.onChangeOptions({options: vm.options});
    }

    function getIndexInArray(objectIndex) {
      return vm.currentOptions.findIndex(function(option) {
        return option.index === objectIndex;
      });
    }
  }

}());

(function () {
  angular.module('Cargo77.companies').component('cargo77UpsertCompanyFieldCard', {
    templateUrl: 'app/components/companies/components/common/fieldCard/upsert-company-field-card.html',
    controller: CompanyEditFieldCardController,
    bindings: {
      field: '<',
      onSaveAction: '&',
      onDeleteAction: '&?',
      parentCompany: '<',
    },
  });

  /** @ngInject */
  function CompanyEditFieldCardController(ExtraFieldCompaniesService) {
    var vm = this;
    vm.sectionTypes = ExtraFieldCompaniesService.sectionTypes;
    vm.inputTypes = ExtraFieldCompaniesService.inputTypes;
    vm.optionalFields = ExtraFieldCompaniesService.optionalFields;

    vm.$onInit = onInit;
    vm.onOptionChange = onOptionChange;
    vm.saveChanges = saveChanges;
    vm.changeFieldStatus = changeFieldStatus;
    vm.deleteField = deleteField;
    vm.toggleManagementMenu = toggleManagementMenu;
    vm.changeInputType = changeInputType;

    function onInit() {
      if (angular.isUndefined(vm.field)) {
        vm.isCreating = true;
        vm.field = {};
      }
    }

    function onOptionChange(options) {
      vm.field.dropdownOptions = options;
    }

    function saveChanges() {
      if(vm.field.inputType !== 'DROPDOWN') {
        vm.field.dropdownOptions = [];
      }
      vm.onSaveAction({field: vm.field});
    }

    function changeFieldStatus(isActive) {
      var newField = angular.copy(vm.field);
      newField.isActive = isActive;
      newField.isRequired = false;
      vm.onSaveAction({field: newField});
    }

    function deleteField() {
      vm.onDeleteAction({field: vm.field});
    }

    function toggleManagementMenu ($mdOpenMenu) {
      $mdOpenMenu();
    }

    function changeInputType(type) {
      if (type !== 'FILE') {
        vm.field['willSendNotificationOnChange'] = false;
      }
    }
  }
}());

(function () {
  angular
    .module("Common")
    .service("Cargo77GraphicsService", Cargo77GraphicsService);

  /** @ngInject */
  function Cargo77GraphicsService(
    CompanyDashboard,
    Profile,
    Cargo77ReportsService
  ) {
    var self = this;
    self.saveGraphic = saveGraphic;
    self.updateGraphic = updateGraphic;
    self.deleteGraphic = deleteGraphic;
    self.getAllGraphics = getAllGraphics;
    self.processTripsGraphicData = processTripsGraphicData;
    self.processTimesGraphicData = processTimesGraphicData;
    self.getChartSubtitle = getChartSubtitle;
    self.updatesAllGraphics = updatesAllGraphics;
    self.getFilters = getFilters;

    function saveGraphic(graphic) {
      var newGraphic = createNewDashboardGraphic(graphic);
      return CompanyDashboard.create(newGraphic).$promise;
    }

    function createNewDashboardGraphic(graphic) {
      var newGraphic = angular.copy(graphic);
      newGraphic.ownerCompanyId = Profile.getCargoCompanyId();

      if (angular.isDefined(newGraphic.ownerCompany)) {
        newGraphic.ownerCompanyId = newGraphic.ownerCompany.id;
        delete newGraphic.ownerCompany;
      }
      return newGraphic;
    }

    function deleteGraphic(id) {
      return CompanyDashboard.destroyById({ id: id }).$promise;
    }

    function updateGraphic(graphic) {
      return CompanyDashboard.prototype$updateAttributes(graphic).$promise;
    }

    function updatesAllGraphics(allGraphics) {
      var updated = 0;
      allGraphics.forEach(function (element) {
        updateGraphic(element);
        updated += 1;
      });
      return updated;
    }

    // TRIPS GRAPHIC
    function processTripsGraphicData(filters, actualYear, actualMonth) {
      return Cargo77ReportsService.getOrders(filters)
        .then(function (data) {
          return Cargo77ReportsService.findVehicles().then(function (vehicles) {
            var filters = Cargo77ReportsService.datesFilter(
              actualYear,
              actualMonth
            );
            return Cargo77ReportsService.getOrders({ and: filters }).then(
              function (allOrders) {
                return Cargo77ReportsService.groupAllSegments(
                  data,
                  allOrders,
                  vehicles
                );
              }
            );
          });
        })
        .then(function (data) {
          return Cargo77ReportsService.groupSegmentsByDriverAndVehicles(data);
        })
        .then(function (data) {
          return Cargo77ReportsService.getCategoriesAndSeriesForTripsReport(
            data.tripsGroupedByDriver
          );
        });
    }

    // TIMES GRAPHIC
    function processTimesGraphicData(
      filters,
      fromLocationFilter,
      toLocationsFilter
    ) {
      var company = _.find(filters.and, function (element) {
        return element.secondaryCarrierCompanyId != undefined;
      });
      var companyId;
      if (company != undefined) {
        companyId = company.secondaryCarrierCompanyId;
      }
      return Cargo77ReportsService.getOrders(filters)
        .then(function (data) {
          return Cargo77ReportsService.groupSegmentsBelongsToLocations(
            data,
            fromLocationFilter,
            toLocationsFilter
          );
        })
        .then(function (data) {
          return Cargo77ReportsService.groupSegmentsByDriver(data, companyId);
        })
        .then(function (data) {
          return Cargo77ReportsService.groupTripsByDriverAndSegments(data);
        })
        .then(function (data) {
          return Cargo77ReportsService.getCategoriesAndSeriesForTimesReport(
            data
          );
        });
    }

    // CHART TITLE
    function getChartSubtitle(chartSubtitleText) {
      return Array(
        chartSubtitleText.split("<br>")[0],
        chartSubtitleText.split("<br>")[2],
        chartSubtitleText.split("<br>")[3]
      );
    }

    function getAllGraphics() {
      return CompanyDashboard.find({
        filter: {
          include: {
            relation: "ownerCompany",
            scope: {
              fields: ["id", "name"],
            },
          },
          order: ["dataType ASC"],
        },
      }).$promise;
    }

    function getFilters(year, month, companyId) {
      var filters = [];
      filters = Cargo77ReportsService.datesFilter(year, month);

      if (!_.isEmpty(companyId)) {
        filters.push({ secondaryCarrierCompanyId: companyId });
      }
      return _.isEmpty(filters) ? null : { and: filters };
    }
  } // End Cargo77GraphicsService
})(); // End Function

(function () {
  angular.module('Common').component('cargo77SegmentDetails', {
    templateUrl: 'app/components/common/route-with-details-selector/route-segment-details/segment-details/segment-details.html',
    controller: SegmentDetailsController,
    bindings: {
      segment: '<',
      segmentIndex: '<',
      onFieldChange: '<',
      onExtraFieldChange: '<',
      onSavingFiles: '&',
      finalSegments: '<',
      onAreValidExtraFieldChange: '<',
      carrierCompanyId: '=',
    },
  });

  function SegmentDetailsController() {
    var vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.changeSegment = changeSegment;
    vm.changeExtraField = changeExtraField;
    vm.areValidExtraFieldsChange = areValidExtraFieldsChange;
    vm.onSavingSegmentFiles = onSavingSegmentFiles;
    function onInit() {
      if(vm.segment.id) {
        vm.weight = vm.segment.cargoDetails.weight.value;
        vm.description = vm.segment.cargoDetails.description;
        vm.time = getInitialTime(vm.segment.scheduledDate);
        vm.date = getInitialDate(vm.segment.scheduledDate);
        if (vm.segmentIndex !== 0) {
          vm.minDate = getMinDatetime(vm.finalSegments[vm.segmentIndex - 1].scheduledDate);
        }
        return;
      }

      vm.weight = 0;
      vm.description = '';
      vm.time = '';
      vm.date = '';
      vm.minDate = null;
      if (vm.segmentIndex !== 0) {
        vm.minDate = getMinDatetime(vm.finalSegments[vm.segmentIndex - 1].scheduledDate);
      }

    }

    function onChanges(changes) {
      if(vm.segmentIndex === 0) {
        return;
      }
      vm.minDate = getMinDatetime(changes.finalSegments.currentValue[vm.segmentIndex - 1].scheduledDate);
    }
    
    function changeSegment(field) {
      var newValue = vm[field];
      var timeStringLength = 5;
      if (field === 'time') {
        newValue = moment(newValue).format('HH:mm');
      }
      if(field === 'time' && newValue.length !== timeStringLength) {
        return;
      }
      vm.onFieldChange(field, newValue, vm.segmentIndex);
    }

    function changeExtraField(extraFields) {
      vm.onExtraFieldChange(extraFields, vm.segmentIndex);
    }

    function areValidExtraFieldsChange(areValidExtraFields) {
      vm.onAreValidExtraFieldChange(areValidExtraFields, vm.segmentIndex);
    }

    function onSavingSegmentFiles(saved, saving){
      vm.onSavingFiles({'saved': saved, 'saving': saving});
    }

    function getMinDatetime (datetime) {
      var date = moment(datetime).local().format('YYYY-MM-DD');
      var newDatetime = new Date(date);
      var result = newDatetime.toISOString();
      return result;
    }

    function getInitialTime(datetime) {
      return new Date(datetime)
    }

    function getInitialDate(datetime) {
      return moment(datetime).format('DD/MM/YYYY');
    }

  }

}());

(function () {
  angular.module('Common').component('cargo77SegmentLocationSelector', {
    templateUrl: 'app/components/common/route-with-details-selector/route-locations-selector/segment-location-selector/segment-location-selector.html',
    controller: SegmentLocationSelectorController,
    bindings: {
      pointIndex:  '=',
      locations: '<',
      onPointChange: '<',
      onDeletePoint: '<',
      finalLocations: '<',
    },
  });

  function SegmentLocationSelectorController() {
    var vm = this;
    var pointIndex;
    vm.changePoint = changePoint;
    vm.deletePoint = deletePoint;
    vm.$onChanges = onChanges;
    vm.$onInit = onInit;

    function onInit() {
      vm.search = '';
      vm.location = {};
      pointIndex = vm.pointIndex;
      vm.mayPointBeDeleted = pointIndex > 1 && pointIndex === vm.finalLocations.length - 1;
    }

    function changePoint(field) {
      vm.search = '';
      var newValue = vm[field];
      vm.onPointChange(pointIndex, field, newValue);
    }

    function deletePoint() {
      vm.onDeletePoint(pointIndex);
    }

    function onChanges(changes) {
      var finalLocationChanges = changes.finalLocations;
      if (finalLocationChanges && finalLocationChanges.currentValue.length !== finalLocationChanges.previousValue.length) {
        vm.mayPointBeDeleted = pointIndex > 1 && pointIndex === changes.finalLocations.currentValue.length - 1;
      }
    }

  }

}());

(function () {
  angular.module('Cargo77.dashboard').component('cargo77OrdersPerUser', {
    templateUrl: 'app/components/dashboard/components/ordersPerDriver/ordersPerDriver.html',
    controller: OrdersPerUserController,
  });

  /** @ngInject */
  function OrdersPerUserController($timeout, DashboardService, $window) {
    var vm = this;
    vm.$onInit = onInit;

    function onInit() {
      $timeout(function () {
        DashboardService.getOrdersCountPerDriver()
          .then(function (response) {
            vm.chartConfig = {
              options: {
                colors: [
                  '#4FC3F7', '#4DD0E1', '#4DB6AC',
                  '#81C784', '#AED581', '#DCE775',
                  '#FFF176', '#FFD54F', '#FFB74D',
                  '#FF8A65',
                  '#E57373', '#F06292', '#BA68C8',
                  '#9575CD', '#7986CB', '#64B5F6',
                ],
                chart: {
                  type: 'pie',
                  height:getScreenRelatedHeight(),
                },
                legend: {
                  layout: 'vertical',
                  verticalAlign: 'middle',
                  align: 'right',
                },
                exporting: false,
                plotOptions: {
                  pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                      enabled: false,
                    },
                    showInLegend: true,
                  },
                },
              },
              series: [{
                name: 'Fletes',
                data: [],
              }],
              title: {
                text: '',
              },
              credits: {enabled: false},
              loading: false,
            };
            vm.chartConfig.series[0].data = transformData(response);
          });
      });
    }

    function transformData(data) {
      var seriesData = [];
      for (var key in data) {
        /* istanbul ignore else */
        if (data.hasOwnProperty(key)) {
          seriesData.push({
            name: data[key].firstName + ' ' + data[key].lastName,
            y: data[key].count,
          });
        }
      }
      return seriesData;
    }

    function getScreenRelatedHeight() {
      if($window.innerHeight < 600){
        return 150;
      }
      return null;
    }

  }
}());

(function () {
  angular.module('Cargo77.dashboard').component('cargo77OrdersPerCompany', {
    templateUrl: 'app/components/dashboard/components/ordersPerCompany/ordersPerCompany.html',
    controller: OrdersPerCompanyController,
  });

  /** @ngInject */
  function OrdersPerCompanyController($timeout, DashboardService, $window) {
    var vm = this;

    vm.$onInit = onInit;

    function onInit() {
      $timeout(function () {
        DashboardService.getOrdersCountPerCompany()
          .then(function (response) {

            vm.chartConfig = {
              options: {
                colors: [
                  '#4FC3F7', '#4DD0E1', '#4DB6AC',
                  '#81C784', '#AED581', '#DCE775',
                  '#FFF176', '#FFD54F', '#FFB74D',
                  '#FF8A65',
                  '#E57373', '#F06292', '#BA68C8',
                  '#9575CD', '#7986CB', '#64B5F6',
                ],
                chart: {
                  type: 'pie',
                  height: getScreenRelatedHeight(),
                },
                legend: {
                  layout: 'vertical',
                  verticalAlign: 'middle',
                  align: 'right',
                },
                exporting: false,
                plotOptions: {
                  pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                      enabled: false,
                    },
                    showInLegend: true,
                  },
                },
              },
              series: [{
                name: 'Fletes',
                data: [],
              }],
              title: {
                text: '',
              },
              credits: {enabled: false},
              loading: false,
            };
            vm.chartConfig.series[0].data = transformData(response);
          });
      });
    }

    function transformData(data) {
      var seriesData = [];
      for (var key in data) {
        /* istanbul ignore else */
        if (data.hasOwnProperty(key)) {
          seriesData.push({
            name: data[key].name,
            y: data[key].count,
          });
        }
      }
      return seriesData;
    }

    function getScreenRelatedHeight() {

      if($window.innerHeight < 600){
        return 250;
      }
      return null;
    }
  }
}());

(function () {
  angular.module('Cargo77.dashboard').component('cargo77MobileDownloadCard', {
    templateUrl: 'app/components/dashboard/components/mobileDownloadCard/mobileDownloadCard.html',
  });
}());

(function () {
  angular.module('Cargo77.dashboard').component('cargo77DashboardTotalCard', {
    templateUrl: 'app/components/dashboard/components/dashboardTotalCard/dashboardTotalCard.html',
    bindings: {
      title: '<',
      total: '<',
      icon: '<',
      align: '<',
    },
  });
}());

(function () {
  angular.module("Cargo77.dashboard").component("cargo77DashboardGraphics", {
    templateUrl:
      "app/components/dashboard/components/dashboardGraphics/dashboardGraphics.html",
    controller: dashboardGraphicsController,
  });

  /** @ngInject */
  function dashboardGraphicsController(
    Cargo77GraphicsService,
    Cargo77ReportsService,
    Cargo77Toast,
    Cargo77Dictionary,
    $state
  ) {
    var vm = this;
    var graphicReportTypes = Cargo77Dictionary.getGraphicReportTypes();
    var chartDataTypes = Cargo77Dictionary.getGraphicDataTypes();
    var chartsColors = Cargo77Dictionary.getChartColors();
    vm.$onInit = onInit;
    vm.allGraphics = Cargo77GraphicsService.getAllGraphics();
    vm.updateAllGraphics = updateAllGraphics;

    function onInit() {
      vm.showGraphics = false;
      vm.barChart = graphicReportTypes.BAR_CHART;
      loadAllGraphics();
      vm.showGraphics = true;
    }

    function loadAllGraphics() {
      vm.dashboardGraphics = [];
      vm.showUpdateAllBtn = false;
      vm.allGraphics.then(function (graphics) {
        if (graphics.length > 0) {
          vm.showUpdateAllBtn = true;
        }
        graphics.forEach(function (element) {
          vm.dashboardGraphics.push(element);
        });
      });
    }

    function updateAllGraphics() {
      // Actual Dates
      vm.cont = 0;
      var now = new Date();
      vm.actualYear = now.getFullYear().toString();
      vm.actualMonth = (now.getMonth() + 1).toString();
      vm.isUpdatingGraphics = true;
      vm.showGraphics = false;
      vm.dashboardGraphics.forEach(function (graphic) {
        updateGraphic(graphic);
      });
    }

    function updateGraphic(graphic) {
      vm.chartConfig = graphic.graphicConfig;
      const graphicEdit = graphic;
      var chartDataType = graphicEdit.dataType;
      var graphicType = graphicEdit.graphicType;
      const graphicFilters = JSON.parse(graphic.filters);
      var company = _.find(
        graphicFilters.generalFilter.and,
        function (element) {
          return element.secondaryCarrierCompanyId != undefined;
        }
      );
      var companyId;
      if (company != undefined) {
        companyId = company.secondaryCarrierCompanyId;
      }

      var newFilters = Cargo77GraphicsService.getFilters(
        vm.actualYear,
        vm.actualMonth,
        companyId
      );

      newFilters = graphicFilters.generalFilter;

      if (
        chartDataType === chartDataTypes.TRIPS &&
        graphicType === vm.barChart
      ) {
        Cargo77GraphicsService.processTripsGraphicData(
          newFilters,
          vm.actualYear,
          vm.actualMonth
        )
          .then(function (seriesAndCategories) {
            if (!_.isEmpty(seriesAndCategories)) {
              configBarChart(
                newFilters,
                graphic,
                companyId,
                seriesAndCategories,
                chartsColors.TRIPS
              );
            }
          })
          .catch(function (error) {
            Cargo77Toast.errorToast(null, error.data.error);
          });
      }

      if (
        chartDataType === chartDataTypes.TIMES &&
        graphicType === vm.barChart
      ) {
        Cargo77GraphicsService.processTimesGraphicData(
          newFilters,
          graphicFilters.fromLocationFilter,
          graphicFilters.toLocationsFilter
        )
          .then(function (seriesAndCategories) {
            if (!_.isEmpty(seriesAndCategories)) {
              configBarChart(
                newFilters,
                graphic,
                companyId,
                seriesAndCategories,
                chartsColors.TIMES
              );
            }
          })
          .catch(function (error) {
            Cargo77Toast.errorToast(null, error.data.error);
          });
      }
    }

    // CONFIG BAR CHART GRAPHIC
    function configBarChart(
      newFilters,
      graphic,
      company,
      seriesAndCategories,
      chartColors
    ) {
      var month = Cargo77ReportsService.getMonthName(vm.actualMonth);
      // Setup graphic with new values
      vm.chartConfig = JSON.parse(graphic.graphicConfig);
      var rawSubtitles = Cargo77GraphicsService.getChartSubtitle(
        vm.chartConfig.options.subtitle.text
      );
      var tripsPerDriver = _.find(
        seriesAndCategories.series,
        function (element) {
          return element.name === "Viajes";
        }
      );
      var totalTrips = 0;
      if (tripsPerDriver) {
        tripsPerDriver.data.forEach(function (trips) {
          totalTrips += trips;
        });
      }
      vm.chartConfig.options.subtitle.text =
        rawSubtitles[0] +
        " <br>" +
        month +
        " " +
        vm.actualYear +
        " <br>" +
        "Total de Viajes: " +
        totalTrips +
        " <br>" +
        rawSubtitles[2];
      vm.chartConfig.options.chart.height =
        Cargo77ReportsService.calculateChartHeight(
          seriesAndCategories.categories,
          seriesAndCategories.series,
          company
        );
      vm.chartConfig.options.colors = chartColors;
      vm.chartConfig.options.xAxis.categories = seriesAndCategories.categories;
      vm.chartConfig.series = seriesAndCategories.series;

      // Setup Filters
      vm.chartFilters = JSON.parse(graphic.filters);
      vm.chartFilters.generalFilter = newFilters;

      // Save graphic with new configuration
      graphic.graphicConfig = JSON.stringify(vm.chartConfig);
      graphic.filters = JSON.stringify(vm.chartFilters);
      graphic.lastUpdated = new Date();
      Cargo77GraphicsService.updateGraphic(graphic)
        .then(function () {
          vm.cont += 1;
          if (vm.cont == vm.dashboardGraphics.length) {
            $state.reload();
            Cargo77Toast.successToast(
              "Todos los gráficos han sido ACTUALIZADOS"
            );
          }
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
  }
})();

(function () {
  angular.module('Cargo77.dashboard').component('cargo77DailyOrders', {
    templateUrl: 'app/components/dashboard/components/dailyOrders/dailyOrders.html',
    controller: DailyOrdersController,
  });

  /** @ngInject */
  function DailyOrdersController($timeout, DashboardService, moment, $window) {
    var vm = this;
    var format = {
      date: {
        days: 'DD MMM',
        weeks: 'DD MMM',
        months: 'MMM YYYY',
      },
      text: {
        days: 'día',
        weeks: 'semana',
        months: 'mes',
      },
    };
    var lastDate = moment();
    var lastAction = '';

    vm.timeType = 'days';

    vm.$onInit = init;
    vm.getTodayAcceptedOrders = getTodayAcceptedOrders;
    vm.getPrevAcceptedOrders = getPrevAcceptedOrders;
    vm.getNextAcceptedOrders = getNextAcceptedOrders;
    vm.onSelectChange = onSelectChange;

    function init() {
      $timeout(function () {
        vm.chartConfig = {
          options: {
            tooltip: {
              valueDecimals: 0,
            },
            colors: [
              '#4FC3F7', '#4DD0E1', '#4DB6AC',
              '#81C784', '#AED581', '#DCE775',
              '#FFF176', '#FFD54F', '#FFB74D',
              '#FF8A65',
              '#E57373', '#F06292', '#BA68C8',
              '#9575CD', '#7986CB', '#64B5F6',
            ],
            chart: {
              renderTo: 'daily',
              type: 'line',
              height:getScreenRelatedHeight(),
            },
            legend: {
              enabled: false,
            },
            exporting: false,
          },
          series: [],
          title: {
            text: '',
          },
          loading: true,

          yAxis: {
            title: {text: 'Nº de fletes'},
            min: 0,
            minRange: 5,
          },
          credits: {enabled: false},
        };
        var min = angular.copy(lastDate).subtract(7, 'days');
        initEmptyChartValues(min, lastDate);
        DashboardService.getAcceptedOrderForDateRange(min.format('YYYY-MM-DD'), lastDate.format('YYYY-MM-DD'))
          .$promise.then(updateChartWithData);
      });
    }

    function onSelectChange() {
      var min = angular.copy(lastDate).subtract(7, vm.timeType);
      var max = lastDate;

      if (lastAction === 'add') {
        min = lastDate;
        max = angular.copy(lastDate).add(7, vm.timeType);
      }

      updateGraph(min, max);
    }

    function getTodayAcceptedOrders() {
      lastDate = moment();
      vm.timeType = 'days';
      var min = angular.copy(lastDate).subtract(7, 'days');
      initEmptyChartValues(min, lastDate);
      DashboardService.getAcceptedOrderForDateRange(min.format('YYYY-MM-DD'), lastDate.format('YYYY-MM-DD'))
        .$promise.then(updateChartWithData);
    }

    function getPrevAcceptedOrders() {
      lastAction = 'subtract';
      lastDate = lastDate.subtract(7, vm.timeType);
      var min = angular.copy(lastDate).subtract(7, vm.timeType);
      updateGraph(min, lastDate);
    }

    function getNextAcceptedOrders() {
      lastAction = 'add';
      var max = angular.copy(lastDate).add(7, vm.timeType);
      updateGraph(lastDate, max);
      lastDate = max;
    }

    //PRIVATE FUNCTIONS
    function initEmptyChartValues(min, max) {
      var diff = max.diff(min, vm.timeType);
      var days = getDays(min, diff);

      vm.chartConfig.xAxis = {
        categories: days,
        allowDecimals: false,
      };

      vm.chartConfig.series[0] = {
        name: 'Fletes por ' + format.text[vm.timeType],
        data: _.fill(new Array(diff), 0.00001),
      };

    }

    function getDays(min, diff) {
      var days = [];
      var day = moment(min);

      if (vm.timeType === 'weeks') {
        day = day.weekday(0);
      }
      for (var i = 0; i < diff; i++) {
        days.push(day.format(format.date[vm.timeType]));
        day = moment(day).add(1, vm.timeType);
      }

      return days;
    }

    function updateChartWithData(response) {
      var offers = groupOffersPerDay(response);

      var offersCount = [];
      var days = Object.keys(offers);
      for (var i = 0; i < days.length; i++) {
        offersCount.push(offers[days[i]]);
        var index = vm.chartConfig.xAxis.categories.indexOf(days[i]);
        if (index >= 0) {
          vm.chartConfig.series[0].data[index] = offers[days[i]];
        }

      }
      vm.chartConfig.loading = false;
    }

    function groupOffersPerDay(offers) {
      var offersDays = {};

      for (var i = 0; i < offers.length; i++) {
        var obj = offers[i];
        var day = moment(obj.orderDate);

        if (vm.timeType === 'weeks') {
          day = day.weekday(0);
        }

        day = day.format(format.date[vm.timeType]);

        if (offersDays.hasOwnProperty(day)) {
          offersDays[day] += 1;
        } else {
          offersDays[day] = 1;
        }
      }

      return offersDays;
    }

    function updateGraph(min, max) {
      initEmptyChartValues(min, max);
      DashboardService.getAcceptedOrderForDateRange(min.format('YYYY-MM-DD'), max.format('YYYY-MM-DD'))
        .$promise.then(updateChartWithData);
    }

    function getScreenRelatedHeight() {
      if($window.innerHeight < 600){
        return 250;
      }
      return null;
    }

  }
}());

(function () {
  angular.module('Cargo77.vehicles').component('cargo77VehicleList', {
    templateUrl: 'app/components/vehicles/components/vehicleList/vehicle-list.html',
    controller: VehicleListController,
  });

  /** @ngInject */
  function VehicleListController(VehicleListService, Cargo77Toast) {
    var vm = this;

    //Pagination
    var filters = {
      searchText: '',
      ownerCompanyId: '',
    };

    vm.initialSearchText = '';
    vm.$onInit = onInit;
    vm.updateSearchText = updateSearchText;
    vm.filterVehiclesByCompany = filterVehiclesByCompany;
    vm.vehicles = new VehicleListService.VehiclesList(filters);

    function onInit(){
      updateSearchText(vm.initialSearchText);
    }

    function updateVehicles(){
      vm.vehicles.items = [];
      vm.isLoadingVehicles = true;
      vm.vehicles.skip = 0;
      VehicleListService.getVehicles(filters, vm.vehicles.skip, true)
      .then(function(response){
        vm.vehicles.items = response.vehicles;
        vm.vehicles.skip = 20;
        vm.isLoadingVehicles = false;
      })
      .catch(function() {
        Cargo77Toast.errorToast('Ha ocurrido un error al consultar los vehiculos.');
      });
    }

    function updateSearchText(searchText) {
      filters.searchText = searchText;
      updateVehicles();
    }

    function filterVehiclesByCompany(company) {
      if (!company.id) {
        filters.ownerCompanyId = '';
      } else {
        filters.ownerCompanyId = company.id;
      }
      updateVehicles();
    }
  }
}());

(function () {
  angular.module('Cargo77.vehicles').component('cargo77EditVehicle', {
    templateUrl: 'app/components/vehicles/components/editVehicle/edit-vehicle.html',
    controller: EditVehicleController,
  });

  /** @ngInject */
  function EditVehicleController(VehicleService, Cargo77Toast, $state, $stateParams) {
    var vm = this;

    vm.saveAction = saveVehicle;
    vm.deleteAction = deleteAction;
    vm.vehicle = VehicleService.getVehicle($stateParams.id);

    function deleteAction(id) {
      VehicleService.deleteVehicle(id)
        .then(function () {
          $state.go('cargo.listVehicles');
          Cargo77Toast.successToast('El vehículo ha sido eliminado con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function saveVehicle(vehicle) {
      VehicleService.updateVehicle(vehicle)
        .then(function () {
          $state.go('cargo.listVehicles');
          Cargo77Toast.successToast('El vehículo ha sido modificado con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.vehicles').component('cargo77CreateVehicle', {
    templateUrl: 'app/components/vehicles/components/createVehicle/create-vehicle.html',
    controller: CreateVehicleController,
  });

  /** @ngInject */
  function CreateVehicleController(VehicleService, Cargo77Toast, $state) {
    var vm = this;

    vm.saveAction = saveVehicle;

    function saveVehicle(vehicle) {
      VehicleService.saveVehicle(vehicle)
        .then(function () {
          $state.go('cargo.listVehicles');
          Cargo77Toast.successToast('El vehículo ha sido creado con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.vehicles').component('cargo77UpsertVehicleCard', {
    templateUrl: 'app/components/vehicles/components/common/upsert-vehicle-card.html',
    controller: VehicleCardController,
    bindings: {
      vehicle: '<',
      onSaveAction: '&',
      onDeleteAction: '&?',
    },
  });

  /** @ngInject */
  function VehicleCardController(VehicleService, TrailersListService) {
    var vm = this;
    vm.vehicle = vm.vehicle || {size: {}};
    vm.vehicleTypes = VehicleService.vehicleTypes;
    vm.sizes = VehicleService.sizes;
    vm.saveChanges = saveChanges;
    vm.deleteVehicle = deleteVehicle;
    vm.changeVehicleStatus = changeVehicleStatus;
    vm.toggleManagementMenu = toggleManagementMenu;
    vm.$onInit = onInit;
    vm.filterTrailers = filterTrailers;
    vm.getEncodedURI = getEncodedURI;

    function filterTrailers() {
      if(!vm.vehicle.company) {
        return;
      }
      var vehicleCompanyId = vm.vehicle.company.id;
      vm.trailers = vm.initialTrailers.filter(function(trailer) {
        return trailer.ownerCompanyId.toString() === vehicleCompanyId.toString();
      });
    }

    function onInit() {
      vm.initialTrailers = TrailersListService.getAllTrailers();
      vm.trailers = vm.initialTrailers;
      initPlateExpirationDate();
      initInsuranceExpirationDate();
    }

    function initPlateExpirationDate() {
      vm.vehicle.$promise.then(function(vehicle) {
        if(vehicle.plateValidUntil) {
          vm.plateValidUntilInit = moment(vehicle.plateValidUntil).toISOString();
        }
      });
    }

    function initInsuranceExpirationDate() {
      vm.vehicle.$promise.then(function(vehicle) {
        if(vehicle.insuranceValidUntil) {
          vm.insuranceValidUntilInit = moment(vehicle.unsuranceValidUntil).toISOString();
        }
      });
    }

    function deleteVehicle() {
      vm.onDeleteAction({id: vm.vehicle.id});
    }

    function changeVehicleStatus(isActive) {
      vm.vehicle.isActive = isActive;
      vm.onSaveAction({vehicle: vm.vehicle});
    }

    function saveChanges() {
      if (!vm.picFile) {
        vm.vehicle.photo = undefined;
      } else {
        vm.vehicle.photo = vm.photo;
        vm.vehicle.photoFileName = vm.picFile.name;
      }

      if(vm.plateValidUntil) {
        vm.vehicle.plateValidUntil = new Date(moment(vm.plateValidUntil)).toISOString();
      }

      if(vm.insuranceValidUntil) {
        vm.vehicle.insuranceValidUntil = new Date(moment(vm.insuranceValidUntil)).toISOString();
      }

      vm.onSaveAction({vehicle: vm.vehicle});
    }
    function toggleManagementMenu ($mdOpenMenu) {
      $mdOpenMenu();
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }
}());

(function () {
  angular.module('Cargo77.users').component('cargo77UserList', {
    templateUrl: 'app/components/users/components/userList/user-list.html',
    controller: UserListController,
  });

  /** @ngInject */
  function UserListController(UserListService, Cargo77Toast) {
    var vm = this;

    //Pagination
    var filters = {
      searchText: '',
      cargoCompanyId: '',
    };
    //--

    vm.initialSearchText = '';
    vm.$onInit = onInit;
    vm.updateSearchText = updateSearchText;
    vm.filterUsersByRole = filterUsersByRole;
    vm.filterUsersByCompany = filterUsersByCompany;
    vm.users = new UserListService.UsersList(filters);

    function onInit(){
      updateSearchText(vm.initialSearchText);
    }

    function updateUsers(){
      vm.users.items = [];
      vm.isLoadingUsers = true;
      vm.users.skip = 0;
      UserListService.getUsers(filters, vm.users.skip, true)
      .then(function(response){
        vm.users.items = response.users;
        vm.users.skip = 20;
        vm.isLoadingUsers = false;
      })
      .catch(function() {
        Cargo77Toast.errorToast('Ha ocurrido un error al consultar los usuarios.');
      });
    }

    function updateSearchText(searchText) {
      filters.searchText = searchText;
      updateUsers();
    }

    function filterUsersByRole(role) {
      filters.roles = role;
      updateUsers();
    }

    function filterUsersByCompany(company) {
      if (!company.id) {
        filters.cargoCompanyId = '';
      } else {
        filters.cargoCompanyId = company.id;
      }
      updateUsers();
    }
  }
}());

(function () {
  angular.module('Cargo77.users').component('cargo77UpdatePassword', {
    templateUrl: 'app/components/users/components/updatePassword/update-password.html',
    controller: UpdatePasswordController,
  });

  /** @ngInject */
  function UpdatePasswordController(UserService, Cargo77Toast, $state) {
    var vm = this;
    vm.user = UserService.getUser(UserService.getCurrentUserId());

    vm.saveChanges = saveChanges;

    function saveChanges () {
      UserService.updateUser(vm.user)
        .then(function () {
          $state.go('cargo.editCurrentUser');
          Cargo77Toast.successToast('La contraseña ha sido actualizada con éxito.');
        })
        .catch(function () {
          Cargo77Toast.errorToast('La contraseña actual es incorrecta.');
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.users').component('cargo77EditUser', {
    templateUrl: 'app/components/users/components/editUser/edit-user.html',
    controller: EditUserController,
  });

  /** @ngInject */
  function EditUserController(UserService, Vehicle, CargoUser, Cargo77Toast, $state, $stateParams) {
    var vm = this;

    vm.saveAction = saveUser;
    vm.sendRecoveryEmail = sendRecoveryEmail;

    vm.user = UserService.getUser($stateParams.id);
    vm.deleteAction = deleteAction;
    vm.refreshAuthenticationCode = refreshAuthenticationCode;

    function deleteAction(id) {
      UserService.deleteUser(id)
        .then(function () {
          $state.go('cargo.listUsers');
          Cargo77Toast.successToast('El usuario ha sido eliminado con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function sendRecoveryEmail () {
      if (!vm.user.email) {
        return Cargo77Toast.errorToast('Ingrese su email en el campo de texto correspondiente.');
      }

      CargoUser.resetPassword({}, {email: vm.user.email.toLowerCase()}).$promise
        .then(function () {
          Cargo77Toast.defaultToast('El email de recuperación ha sido enviado al usuario.', 'mail');
        })
        .catch(function (response) {
          Cargo77Toast.errorToast(null, response.data.error);
        });
    }

    function saveUser(user) {
      UserService.updateUser(user)
        .then(function () {
          $state.go('cargo.listUsers');
          Cargo77Toast.successToast('El usuario ha sido actualizado con éxito.');
        })
        .catch(function (error) {
          var toastError = error.data.error;
          if (error.data.error && error.data.error.message.includes('Details: `email`  already exists')) {
            toastError.message = 'email already exists';
          }
          Cargo77Toast.errorToast(null, toastError);
        });
    }

    function refreshAuthenticationCode(phone) {
      return UserService.refreshAutheticationCodeByPhone(phone).$promise
        .then(function (response) {
          vm.user.phoneAuthentication = response.phoneAuthentication;
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.users').component('cargo77EditCurrentUser', {
    templateUrl: 'app/components/users/components/editCurrentUser/edit-current-user.html',
    controller: EditCurrentUserController,
  });

  /** @ngInject */
  function EditCurrentUserController(UserService, Cargo77Toast, $state, NavBarService) {
    var vm = this;

    vm.saveAction = saveUser;

    vm.onChangePassword = onChangePassword;
    vm.user = UserService.getUser(UserService.getCurrentUserId());

    function onChangePassword() {
      $state.go('cargo.updatePassword');
    }

    function saveUser(user) {
      UserService.updateUser(user)
        .then(function () {
          roleRelatedRedirection(user);
          NavBarService.updateUser();
          Cargo77Toast.successToast('El usuario ha sido actualizado con éxito.');
        })
        .catch(function (error) {
          var toastError = error.data.error;
          if (error.data.error && error.data.error.message.includes('Details: `email`  already exists')) {
            toastError.message = 'email already exists';
          }
          Cargo77Toast.errorToast(null, toastError);
        });
    }
    function roleRelatedRedirection (user){
      var userRole = user.roles[0];
      if(userRole == 'DRIVER' || userRole == 'SHIPPER_USER' ) {
        $state.go('cargo.dashboard');
        return;
      }
      $state.go('cargo.listUsers');
    }
  }
}());

(function () {
  angular.module('Cargo77.users').component('cargo77CreateUser', {
    templateUrl: 'app/components/users/components/createUser/create-user.html',
    controller: CreateUserController,
  });

  /** @ngInject */
  function CreateUserController(UserService, Cargo77Toast, $state) {
    var vm = this;

    vm.saveAction = saveUser;

    function saveUser(user) {
      UserService.saveUser(user)
        .then(function () {
          $state.go('cargo.listUsers');
          Cargo77Toast.successToast('El usuario ha sido creado con éxito.');
        })
        .catch(function (error) {
          var toastError = error.data.error;
          if (error.data.error && error.data.error.message.includes('Details: `email`  already exists')) {
            toastError.message = 'email already exists';
          }
          Cargo77Toast.errorToast(null, toastError);
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.users').component('cargo77UpsertUserCard', {
    templateUrl: 'app/components/users/components/common/upsert-user-card.html',
    controller: UserCardController,
    bindings: {
      user: '<',
      onChangePasswordAction: '&?',
      onSaveAction: '&',
      onDeleteAction: '&?',
      onRefreshAuthenticationCode: '&?',
    },
  });

  /** @ngInject */
  function UserCardController(UserService, Vehicle, Profile) {
    var vm = this;
    vm.canEditUser = true;
    vm.showCompany = true;
    vm.companyVehicles = [];
    vm.userTypes = UserService.userTypes;
    vm.saveChanges = saveChanges;
    vm.getEncodedURI = getEncodedURI;
    vm.deleteUser = deleteUser;
    vm.isCurrentUser = isCurrentUser;
    vm.changeUserStatus = changeUserStatus;
    vm.toggleManagementMenu = toggleManagementMenu;
    vm.onRefreshPhoneAutenticationCode = onRefreshPhoneAutenticationCode;
    vm.$onInit = onInit;

    function onInit(){
      vm.isAuthenticationCodeExpired = true;
      if(!angular.isDefined(vm.user)){
        vm.user = {size: {}, roles: []};
      } else {
        initLicenseExpirationDate();
        checkForEditionPermissions();
        checkIfCompanyMustShow();
      }
      vm.companyVehicles = getVehicles();
    }

    function isCurrentUser() {
      return UserService.isCurrentUser(vm.user.id);
    }

    function checkForEditionPermissions() {
      vm.user.$promise.then(function(user) {
        checkForExpiredAuthenticationCode();
        if(Profile.getUserRole().indexOf('CARRIER_USER') >= 0 &&
        user.roles.indexOf('CARRIER_OWNER') >= 0 &&
        user.cargoCompanyId.toString() === Profile.getCargoCompanyId().toString()
        ) {
          vm.canEditUser = false;
        }
      });
    }

    function initLicenseExpirationDate() {
      vm.user.$promise.then(function(user) {
        if(user.licenseValidUntil) {
          vm.licenseValidUntilInit = moment(user.licenseValidUntil).toISOString();
        }
      });
    }

    function getVehicles() {
      var where = {};
      if (Profile.getUserRole().indexOf('CARGO_ADMIN') < 0) {
        where = {ownerCompanyId: Profile.getCargoCompanyId()};
      }
      return Vehicle.find({filter: {include: 'ownerCompany', where: where}});
    }

    function deleteUser() {
      vm.onDeleteAction({id: vm.user.id});
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }

    function changeUserStatus(isActive) {
      vm.user.isActive = isActive;
      vm.onSaveAction({user: vm.user});
    }

    function saveChanges() {
      if (!vm.picFile) {
        vm.user.photo = undefined;
      } else {
        vm.user.photoFileName = vm.picFile.name;
        vm.user.photo = vm.photo;
      }

      if (angular.isDefined(vm.user.phone) && vm.user.phone[0] !== '+') {
        vm.user.phone = '+' + vm.user.phone;
      }
      if(vm.user.defaultVehicle) {
        vm.user.defaultVehicleId = vm.user.defaultVehicle.id;
        delete vm.user.defaultVehicle;
      }

      if(vm.licenseValidUntil) {
        vm.user.licenseValidUntil = new Date(moment(vm.licenseValidUntil)).toISOString();
      }

      vm.onSaveAction({user: vm.user});
    }

    function toggleManagementMenu ($mdOpenMenu) {
      $mdOpenMenu();
    }

    function checkIfCompanyMustShow () {

      vm.user.$promise.then(function(user) {
        if(Profile.getUserRole().indexOf('CARGO_ADMIN') >= 0 &&
          user.id.toString() === Profile.getId().toString()) {
            vm.showCompany = false;
        }
      });
    }

    function onRefreshPhoneAutenticationCode ()  {
      vm.onRefreshAuthenticationCode({'phone': vm.user.phone}).then(function() {
        checkForExpiredAuthenticationCode();
      });
    }

    function checkForExpiredAuthenticationCode() {
      var currentDatetime = moment().toISOString();
      vm.isAuthenticationCodeExpired = currentDatetime > vm.user.phoneAuthentication.expireTime;
    }
  }
}());

(function () {
  angular.module('Cargo77.trailers').component('cargo77TrailersList', {
    templateUrl: 'app/components/trailers/components/trailersList/trailers-list.html',
    controller: TrailersListController,
  });

  /** @ngInject */
  function TrailersListController(TrailersListService, Cargo77Toast) {
    var vm = this;

    //Pagination
    var filters = {
      searchText: '',
      ownerCompanyId: '',
    };

    vm.initialSearchText = '';
    vm.$onInit = onInit;
    vm.updateSearchText = updateSearchText;
    vm.filterTrailersByCompany = filterTrailersByCompany;
    vm.trailers = new TrailersListService.TrailersList(filters);

    function onInit(){
      updateSearchText(vm.initialSearchText);
    }

    function updateTrailers(){
      vm.trailers.items = [];
      vm.isLoadingTrailers = true;
      vm.trailers.skip = 0;
      TrailersListService.getTrailers(filters, vm.trailers.skip, true)
      .then(function(response){
        vm.trailers.items = response.trailers;
        vm.trailers.skip = 20;
        vm.isLoadingTrailers = false;
      })
      .catch(function() {
        Cargo77Toast.errorToast('Ha ocurrido un error al consultar los usuarios.');
      });
    }

    function updateSearchText(searchText) {
      filters.searchText = searchText;
      updateTrailers();
    }

    function filterTrailersByCompany(company) {
      if (!company.id) {
        filters.ownerCompanyId = '';
      } else {
        filters.ownerCompanyId = company.id;
      }
      updateTrailers();
    }
  }
}());

(function () {
  angular.module('Cargo77.trailers').component('cargo77EditTrailer', {
    templateUrl: 'app/components/trailers/components/editTrailer/edit-trailer.html',
    controller: EditTrailerController,
  });

  /** @ngInject */
  function EditTrailerController(TrailerService, Cargo77Toast, $state, $stateParams) {
    var vm = this;

    vm.saveAction = saveTrailer;
    vm.deleteAction = deleteAction;

    vm.trailer = TrailerService.getTrailer($stateParams.id);

    function deleteAction(id) {
      TrailerService.deleteTrailer(id)
        .then(function () {
          $state.go('cargo.listTrailers');
          Cargo77Toast.successToast('El arrastre ha sido eliminado con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function saveTrailer(trailer) {
      TrailerService.updateTrailer(trailer)
        .then(function () {
          $state.go('cargo.listTrailers');
          Cargo77Toast.successToast('El arrastre ha sido modificado con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.trailers').component('cargo77CreateTrailer', {
    templateUrl: 'app/components/trailers/components/createTrailer/create-trailer.html',
    controller: CreateTrailerController,
  });

  /** @ngInject */
  function CreateTrailerController(TrailerService, Cargo77Toast, $state) {
    var vm = this;

    vm.saveAction = saveTrailer;

    function saveTrailer(trailer) {
      TrailerService.saveTrailer(trailer)
        .then(function () {
          $state.go('cargo.listTrailers');
          Cargo77Toast.successToast('El arrastre ha sido creado con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.trailers').component('cargo77UpsertTrailerCard', {
    templateUrl: 'app/components/trailers/components/common/upsert-trailer-card.html',
    controller: TrailerCardController,
    bindings: {
      trailer: '<',
      onSaveAction: '&',
      onDeleteAction: '&?',
    },
  });

  /** @ngInject */
  function TrailerCardController(TrailerService) {
    var vm = this;
    vm.trailer = vm.trailer || {};
    vm.trailerTypes = TrailerService.trailerTypes.sort(typesNameAscendingComparator);

    vm.saveChanges = saveChanges;
    vm.deleteTrailer = deleteTrailer;
    vm.changeTrailerStatus = changeTrailerStatus;
    vm.toggleManagementMenu = toggleManagementMenu;
    vm.getEncodedURI = getEncodedURI;

    function deleteTrailer() {
      vm.onDeleteAction({id: vm.trailer.id});
    }

    function changeTrailerStatus(isActive) {
      vm.trailer.isActive = isActive;
      vm.onSaveAction({trailer: vm.trailer});
    }

    function saveChanges() {
      if (!vm.picFile) {
        vm.trailer.photo = undefined;
      } else {
        vm.trailer.photo = vm.photo;
        vm.trailer.photoFileName = vm.picFile.name;
      }
      vm.onSaveAction({trailer: vm.trailer});
    }

    function toggleManagementMenu ($mdOpenMenu) {
      $mdOpenMenu();
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }

    function typesNameAscendingComparator(typeA, typeB) {
      if (typeA.title > typeB.title) {
        return 1;
      }
      if(typeA.title < typeB.title) {
        return -1;
      }
      return 0;
    }

  }
}());

(function () {
  angular.module("Cargo77.reports").component("cargo77TripsReport", {
    templateUrl:
      "app/components/reports/components/tripsReport/trips-report.html",
    controller: TripsReportController,
  });

  /** @ngInject */
  function TripsReportController(
    Profile,
    CompaniesService,
    Cargo77Dictionary,
    Cargo77ReportsService,
    Cargo77GraphicsService,
    Cargo77Toast,
    $state
  ) {
    var vm = this;
    var graphicReportTypes = Cargo77Dictionary.getGraphicReportTypes();
    var graphicDataTypes = Cargo77Dictionary.getGraphicDataTypes();
    var chartsColors = Cargo77Dictionary.getChartColors();
    vm.$onInit = onInit;
    vm.selectedCarrierItem = null;
    vm.selectedShipperItem = null;
    vm.carrierSearchText = null;
    vm.shipperSearchText = null;
    vm.graphic = vm.graphic || {};
    vm.resetFilters = resetFilters;
    vm.isParentCompany = isParentCompany;
    vm.generateReport = generateReport;
    vm.downloadExcel = downloadExcel;
    vm.addGraphicToDashboard = addGraphicToDashboard;
    vm.isGeneratingReport = false;
    vm.timeLapseFilter = {};
    vm.getLimitTimelapse = getLimitTimelapse;
    var reportHeadersData = {};
    vm.filtersToSave = {};
    vm.allGraphics = Cargo77GraphicsService.getAllGraphics();

    var TRIPS_REPORT = {
      KEY: {
        CARRIER_COMPANY: "carrier_company",
        DRIVER: "driver",
        VEHICLE: "vehicle",
        MONTH: "month",
        TIME_LAPSE: "time_lapse",
        YEAR: "year",
        MONTHLY_TRIPS: "monthly_trips",
        TRIPS: "trips",
        PERCENTAGE: "percentage",
      },
    };

    function onInit() {
      vm.months = Cargo77ReportsService.getMonths();
      vm.years = Cargo77ReportsService.getYears();
      vm.company = CompaniesService.getCurrentCompany();
      vm.carrierCompanyFilter = "all";
      vm.shipperCompanyFilter = "all";
      vm.timeFilter = "months";
      vm.monthFilter = null;
      vm.yearFilter = null;
      vm.carrierCompaniesArray = [];
      vm.shipperCompaniesArray = [];
      vm.showGraphics = false;
      vm.showAddToDashboardBtn = true;
      vm.isSavingGraphic = false;
      vm.sortingKeys = [];
      vm.headerLabels = [];
      vm.maxStartDate = getMaxStartDate();
      vm.maxEndDate = vm.maxStartDate;
      vm.progressPercentage = 0;
      getCompanies();
    }

    // Get Max start date
    function getMaxStartDate() {
      return moment().format("MM/DD/YYYY");
    }

    // Get Limit timelapse date
    function getLimitTimelapse() {
      var yearAfter = moment(vm.timeLapseFilter.start)
        .add(1, "years")
        .calendar();
      yearAfter = yearAfter.split("/");
      yearAfter = yearAfter[1] + "/" + yearAfter[0] + "/" + yearAfter[2];
      if (moment(yearAfter).isAfter(vm.maxStartDate)) {
        vm.maxEndDate = vm.maxStartDate;
        vm.timeLapseFilter.end = vm.maxStartDate;
      } else {
        vm.maxEndDate = yearAfter;
        vm.timeLapseFilter.end = yearAfter;
      }
    }

    // Generate report
    function generateReport() {
      vm.isSavingGraphic = false;
      vm.showGraphics = false;
      vm.showAddToDashboardBtn = false;
      vm.isGeneratingReport = true;
      vm.isReportEmpty = false;
      if (vm.timeFilter === "months") {
        vm.timeLapseFilter = {};
      }
      var filters = getFilters(
        vm.yearFilter,
        vm.monthFilter,
        vm.timeLapseFilter
      );
      var box = document.querySelector("#buttons-box");
      box.scrollIntoView();
      vm.progressPercentage = 5;
      getReportData(filters, vm.yearFilter, vm.monthFilter, vm.timeLapseFilter)
        .then(function (data) {
          if (_.isEmpty(data.tripsGroupedByDriver)) {
            vm.progressPercentage = 100;
            vm.isReportEmpty = true;
            vm.progressPercentage = 0;
          } else {
            graphicsConfig(data, vm.monthFilter);
          }
          vm.progressPercentage = 100;
          vm.isGeneratingReport = false;
          vm.progressPercentage = 0;
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    // Download report in excel file
    function downloadExcel() {
      var box = document.querySelector("#buttons-box");
      box.scrollIntoView();
      var filters = getFilters(
        vm.yearFilter,
        vm.monthFilter,
        vm.timeLapseFilter
      );
      vm.progressPercentage = 10;
      createExcelReport(filters);
    }

    // Create Excel and Generate the graphics
    function createExcelReport(filters) {
      vm.isGeneratingReport = true;
      vm.isReportEmpty = false;
      if (vm.timeFilter === "months") {
        vm.timeLapseFilter = {};
      }
      getReportData(filters, vm.yearFilter, vm.monthFilter, vm.timeLapseFilter)
        .then(function (dataToReport) {
          if (_.isEmpty(dataToReport.tripsGroupedByDriver)) {
            vm.progressPercentage = 100;
            vm.isReportEmpty = true;
            vm.progressPercentage = 0;
          } else {
            vm.progressPercentage = 80;

            var data = dataToReport.tripsGroupedByDriver;

            var driverVehicleReport = buildReportEntries(data);

            var worksheet = XLSX.utils.json_to_sheet(driverVehicleReport, {
              header: vm.sortingKeys,
            });

            var range = XLSX.utils.decode_range(worksheet["!ref"]);

            for (var column = range.s.c; column <= range.e.c; ++column) {
              var address = XLSX.utils.encode_col(column) + "1";

              if (
                _.isEmpty(worksheet[address]) &&
                _.isEmpty(reportHeadersData[worksheet[address].v])
              ) {
                continue;
              }

              worksheet[address].v = reportHeadersData[worksheet[address].v]
                ? reportHeadersData[worksheet[address].v].value
                : "Error!";
            }

            worksheet["!cols"] = fitColumnsWidth(driverVehicleReport);

            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte");
            XLSX.writeFile(workbook, getReportFilename());
          }
          vm.progressPercentage = 100;
          vm.isGeneratingReport = false;
          vm.progressPercentage = 0;
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function getReportData(filters, year, month, timeLapse) {
      return Cargo77ReportsService.getOrders(filters)
        .then(function (data) {
          vm.progressPercentage = 45;
          return Cargo77ReportsService.findVehicles().then(function (vehicles) {
            var filters = Cargo77ReportsService.datesFilter(
              year,
              month,
              timeLapse
            );
            return Cargo77ReportsService.getOrders({ and: filters }).then(
              function (allOrders) {
                vm.progressPercentage = 70;
                return Cargo77ReportsService.groupAllSegments(
                  data,
                  allOrders,
                  vehicles
                );
              }
            );
          });
        })
        .then(function (data) {
          vm.progressPercentage = 80;
          return Cargo77ReportsService.groupSegmentsByDriverAndVehicles(
            data,
            vm.carrierCompanyFilter.value
          );
        });
    }

    // Setting excel report entries
    function buildReportEntries(filteredData) {
      var orderFilteredData = _.orderBy(
        filteredData,
        ["carrierCompanyName"],
        ["asc"]
      );
      var reportEntries = [];
      reportHeadersData = {};

      setTripsHeaders();

      var month = Cargo77ReportsService.getMonthName(vm.monthFilter);

      orderFilteredData.forEach(function (element) {
        var reportRow = {};
        reportRow[TRIPS_REPORT.KEY.CARRIER_COMPANY] =
          element.carrierCompanyName;
        reportRow[TRIPS_REPORT.KEY.DRIVER] = element.driver.toUpperCase();
        reportRow[TRIPS_REPORT.KEY.VEHICLE] = element.vehicle
          ? element.vehicle.toUpperCase()
          : "NO HAY REGISTRO";
        reportRow[TRIPS_REPORT.KEY.TIME_LAPSE] = _.isEmpty(vm.timeLapseFilter)
          ? "NO APLICA"
          : moment(vm.timeLapseFilter.start).format("YYYY-MM-DD") +
            " - " +
            moment(vm.timeLapseFilter.end).format("YYYY-MM-DD").toUpperCase();
        reportRow[TRIPS_REPORT.KEY.MONTH] = _.isEmpty(vm.timeLapseFilter)
          ? month
          : "NO APLICA";
        reportRow[TRIPS_REPORT.KEY.YEAR] = _.isEmpty(vm.timeLapseFilter)
          ? vm.yearFilter
          : "NO APLICA";
        reportRow[TRIPS_REPORT.KEY.MONTHLY_TRIPS] = element.monthlyTrips;
        reportRow[TRIPS_REPORT.KEY.TRIPS] = element.trips;
        reportRow[TRIPS_REPORT.KEY.PERCENTAGE] = element.percentage;
        reportEntries.push(reportRow);
      });

      var result = generateSortingAndLabelsArrays();
      vm.sortingKeys = result.sortArray;
      vm.headerLabels = result.labels;
      return reportEntries;
    }

    // Fit excel file columns size
    function fitColumnsWidth(data) {
      var keys = Object.keys(reportHeadersData);
      return _.map(keys, function (key) {
        var lengthValues = [reportHeadersData[key].value.toString().length];

        _.forEach(data, function (element) {
          lengthValues.push(element[key].toString().length);
        });

        return { wch: _.max(lengthValues) + 5 };
      });
    }

    // Sorting the result to show in excel file
    function generateSortingAndLabelsArrays() {
      var keys = Object.keys(reportHeadersData);
      var indexesSortingArray = [];
      var headersArray = [];

      keys.forEach(function (key) {
        var index = reportHeadersData[key].index;
        var label = reportHeadersData[key].value;
        indexesSortingArray[index] = key;
        headersArray[index] = label;
      });
      return {
        sortArray: indexesSortingArray,
        labels: headersArray,
      };
    }

    // Setting the exel file name
    function getReportFilename() {
      moment.locale("es");
      var currentDate = moment().format("DD-MM-YYYY_HH-mm");
      return (
        "Reporte de Viajes por Conductor y Unidad " + currentDate + ".xlsx"
      );
    }

    // Setting excel headers
    function setTripsHeaders() {
      var COMMON_HEADERS;
      COMMON_HEADERS = [
        {
          key: TRIPS_REPORT.KEY.CARRIER_COMPANY,
          value: "empresa transportista",
        },
        {
          key: TRIPS_REPORT.KEY.DRIVER,
          value: "conductor",
        },
        {
          key: TRIPS_REPORT.KEY.VEHICLE,
          value: "vehiculo",
        },
        {
          key: TRIPS_REPORT.KEY.TIME_LAPSE,
          value: "fechas",
        },
        {
          key: TRIPS_REPORT.KEY.MONTH,
          value: "mes",
        },
        {
          key: TRIPS_REPORT.KEY.YEAR,
          value: "año",
        },
        {
          key: TRIPS_REPORT.KEY.MONTHLY_TRIPS,
          value: "num. de viajes estimados",
        },
        {
          key: TRIPS_REPORT.KEY.TRIPS,
          value: "viajes realizados",
        },
        {
          key: TRIPS_REPORT.KEY.PERCENTAGE,
          value: "porcentaje de utilización (%)",
        },
      ];
      COMMON_HEADERS.forEach(function (keyValueHeader) {
        insertHeader(keyValueHeader);
      });
    }

    function insertHeader(newHeader) {
      if (angular.isDefined(reportHeadersData[newHeader.key])) {
        return;
      }
      var entriesCount = Object.keys(reportHeadersData).length;
      reportHeadersData[newHeader.key] = {
        index: entriesCount,
        value: newHeader.value.toUpperCase(),
      };
    }

    // Graphics
    function graphicsConfig(dataToProcess, month) {
      const data = dataToProcess.tripsGroupedByDriver;
      var reportTitle = "Viajes por Conductor y Unidad";
      var categoryX = "Conductores y Unidades";
      month = Cargo77ReportsService.getMonthName(month);
      var timeLapse = _.isEmpty(vm.timeLapseFilter)
        ? null
        : moment(vm.timeLapseFilter.start).format("YYYY-MM-DD") +
          " - " +
          moment(vm.timeLapseFilter.end).format("YYYY-MM-DD");
      var chartDate = timeLapse ? timeLapse : month + " " + vm.yearFilter;
      var companyName =
        vm.carrierCompanyFilter === "all"
          ? "TODAS LAS EMPRESAS"
          : vm.carrierCompaniesArray.map(function (company) {
              return company.label;
            });
      var clientCompany =
        vm.shipperCompanyFilter === "all"
          ? "TODOS LOS CLIENTES"
          : vm.shipperCompaniesArray.map(function (company) {
              return company.label;
            });
      var totalTrips = 0;
      data.forEach(function (data) {
        totalTrips += data.trips;
      });
      var seriesAndCategories =
        Cargo77ReportsService.getCategoriesAndSeriesForTripsReport(data);
      var chartHeight = Cargo77ReportsService.calculateChartHeight(
        seriesAndCategories.categories,
        seriesAndCategories.series,
        vm.carrierCompanyFilter
      );

      vm.chartConfig = {
        options: {
          chart: {
            type: "bar",
            height: chartHeight,
          },
          colors: chartsColors.TRIPS,
          title: {
            text: reportTitle.toUpperCase(),
          },
          subtitle: {
            text:
              "<strong> Transportista: " +
              companyName +
              "</strong>" +
              "<br>" +
              chartDate +
              "<br>Total de  Viajes: " +
              totalTrips +
              "<br><strong>Clientes: <strong>" +
              "<strong> " +
              clientCompany +
              "</strong>",
          },
          xAxis: {
            categories: seriesAndCategories.categories,
            title: {
              text: categoryX,
            },
          },
          yAxis: {
            min: 0,
            title: {
              text: "<strong>Viajes</strong>",
              align: "high",
            },
            labels: {
              overflow: "justify",
            },
          },
          legend: {
            layout: "horizontal",
            align: "center",
            verticalAlign: "top",
            x: 0,
            y: 100,
            floating: false,
            borderWidth: 1,
            backgroundColor: "#FFFFFF",
            shadow: true,
          },
          plotOptions: {
            bar: {
              dataLabels: {
                enabled: true,
              },
            },
          },
          credits: {
            enabled: false,
          },
          loading: false,
        },
        series: seriesAndCategories.series,
      };
      vm.showGraphics = true;
      vm.showAddToDashboardBtn = true;
      vm.isGeneratingReport = false;
    }

    // Carrier Companies
    function getCompanies() {
      var userId = Profile.getCargoCompanyId();
      if (
        angular.isDefined(Profile.getParentCompanyId()) &&
        Profile.getParentCompanyId().length > 0
      ) {
        userId = Profile.getParentCompanyId();
      }

      vm.carrierCompanies = [];
      vm.shipperCompanies = [];
      Cargo77ReportsService.findCompanyById(userId).then(function (
        cargoCompany
      ) {
        vm.currentCargoCompany = cargoCompany;
        vm.carrierCompanies.push({
          label: cargoCompany.name,
          value: cargoCompany.id,
        });
        cargoCompany.childCompanies.forEach(function (childCompany) {
          if (childCompany.type === "SHIPPER") {
            vm.shipperCompanies.push({
              label: childCompany.name,
              value: childCompany.id,
            });
            return;
          }
          vm.carrierCompanies.push({
            label: childCompany.name,
            value: childCompany.id,
          });
        });
      });
    }

    // Parent Company
    function isParentCompany() {
      return !vm.company.parentCompanyId;
    }

    // FILTERS
    function getFilters(year, month, timeLapse) {
      var filters = [];
      var shipperFilters = [];
      filters = Cargo77ReportsService.datesFilter(year, month, timeLapse);
      var carrierCompaniesIds = vm.carrierCompaniesArray.map(function (
        company
      ) {
        return company.value;
      });
      var shipperCompaniesIds = vm.shipperCompaniesArray.map(function (
        company
      ) {
        return company.value;
      });

      if (vm.carrierCompanyFilter !== "all") {
        filters = carrierCompaniesIds.map(function (id) {
          return filters.concat({ secondaryCarrierCompanyId: id });
        });
      }
      if (vm.shipperCompanyFilter !== "all") {
        if (!Array.isArray(filters[0])) {
          filters = Array(filters);
        }
        filters.forEach(function (filter) {
          shipperCompaniesIds.forEach(function (id) {
            shipperFilters.push(filter.concat({ shipperCompanyId: id }));
          });
        });
        filters = shipperFilters;
      }

      if (carrierCompaniesIds.length > 1 || shipperCompaniesIds.length > 1) {
        filters = filters.map(function (filter) {
          return { and: filter };
        });
        filters = { or: filters };
      } else {
        filters = { and: Array.isArray(filters[0]) ? filters[0] : filters };
      }
      return filters;
    }

    function resetFilters() {
      vm.carrierCompanyFilter = null;
      vm.monthFilter = null;
      vm.yearFilter = null;
      vm.showGraphics = false;
      vm.isReportEmpty = false;
    }

    // ADD GRAPHIC TO DASHBOARD
    function addGraphicToDashboard() {
      // Actual Dates
      vm.isSavingGraphic = true;
      vm.showAddToDashboardBtn = false;
      // var dashboardGraphicsLimit =
      vm.allGraphics.then(function (graphics) {
        if (graphics.length > 4) {
          Cargo77Toast.errorToast(
            "Haz alcanzado el máximo de gráficos en el dashboard"
          );
          vm.isSavingGraphic = false;
          vm.showAddToDashboardBtn = true;
        } else {
          var now = new Date();
          var actualYear = now.getFullYear().toString();
          var actualMonth = (now.getMonth() + 1).toString();
          var filters = getFilters(actualYear, actualMonth);
          getReportData(filters, actualYear, actualMonth)
            .then(function (data) {
              if (!_.isEmpty(data)) {
                graphicsConfig(data, actualMonth);
                vm.graphic.graphicType = graphicReportTypes.BAR_CHART;
                vm.graphic.dataType = graphicDataTypes.TRIPS;
                var settingFilters = {
                  generalFilter: filters,
                };
                vm.graphic.filters = JSON.stringify(settingFilters);
                vm.graphic.graphicConfig = JSON.stringify(vm.chartConfig);

                Cargo77GraphicsService.saveGraphic(vm.graphic)
                  .then(function () {
                    vm.isSavingGraphic = false;
                    $state.go("cargo.dashboard");
                    Cargo77Toast.successToast("Gráfico añadido al Dashboard.");
                  })
                  .catch(function (error) {
                    Cargo77Toast.errorToast(null, error.data.error);
                  });
              } else {
                vm.isReportEmpty = true;
                vm.isGeneratingReport = false;
              }
            })
            .catch(function (error) {
              Cargo77Toast.errorToast(null, error.data.error);
            });
        }
      });
    }
  } // End DriverReportController
})(); // End Function

(function () {
    angular.module('Cargo77.reports').component('cargo77TimesReport', {
        templateUrl: 'app/components/reports/components/timesReport/times-report.html',
        controller: TimesReportController,
    });

    /** @ngInject */
    function TimesReportController(Profile, CargoCompany, CompaniesService, LocationsListService, Cargo77ReportsService,
        Cargo77Dictionary, Cargo77GraphicsService, $state, Cargo77Toast) {
        var vm = this;
        var graphicReportTypes = Cargo77Dictionary.getGraphicReportTypes();
        var graphicDataTypes = Cargo77Dictionary.getGraphicDataTypes();
        var chartsColors = Cargo77Dictionary.getChartColors();
        vm.$onInit = onInit;
        vm.resetFilters = resetFilters;
        vm.isParentCompany = isParentCompany;
        vm.generateReport = generateReport;
        vm.getLocationsTo = getLocationsTo;
        vm.downloadExcel = downloadExcel;
        vm.addGraphicToDashboard = addGraphicToDashboard;
        vm.isGeneratingReport = false;
        vm.graphic = vm.graphic || {};
        var reportHeadersData = {};

        var TIMES_REPORT = {
            KEY: {
                CARRIER_COMPANY: 'carrier_company',
                DRIVER: 'driver',
                MONTH: 'month',
                YEAR: 'year',
                SEGMENT: 'segment',
                TRIPS: 'trips',
                TIME: 'time',
                TIME_IN_HOURS: 'total_hours',
                ONTRIP_AVERAGE_TIME: 'ontrip_average_time',
            },
        };

        function onInit() {
            vm.company = CompaniesService.getCurrentCompany();
            vm.carrierCompanyFilter = null;
            vm.fromLocationFilter = null;
            vm.toLocationsFilter = null;
            vm.monthFilter = null;
            vm.yearFilter = null;
            vm.searchLocation1 = '';
            vm.searchLocation2 = '';
            vm.showGraphics = false;
            vm.showAddToDashboardBtn = true;
            vm.isSavingGraphic = false;
            vm.months = Cargo77ReportsService.getMonths();
            vm.years = Cargo77ReportsService.getYears();
            getCompanies();
            getLocationsFrom();
        }

        function generateReport() {
            vm.isSavingGraphic = false;
            vm.showGraphics = false;
            vm.isGeneratingReport = true;
            vm.isReportEmpty = false;
            var filters = getFilters(vm.yearFilter, vm.monthFilter);
            getReportData(filters)
                .then(function (data) {
                    if (_.isEmpty(data)) {
                        vm.isReportEmpty = true;
                    }
                    graphicsConfig(data, vm.monthFilter);
                    vm.isGeneratingReport = false;
                }).catch(function (error) {
                    Cargo77Toast.errorToast(null, error.data.error);
                });
        }

        function downloadExcel() {
            var filters = getFilters(vm.yearFilter, vm.monthFilter);
            createExcelReport(filters);
        }

        // Create Excel and Generate the graphics
        function createExcelReport(filters) {
            vm.isGeneratingReport = true;
            vm.isReportEmpty = false;

            getReportData(filters)
                .then(function (data) {
                    if (_.isEmpty(data)) {
                        vm.isReportEmpty = true;
                    } else {
                        var timesReport = buildReportEntries(data);

                        var worksheet = XLSX.utils.json_to_sheet(timesReport, { header: vm.sortingKeys });

                        var range = XLSX.utils.decode_range(worksheet['!ref']);

                        for (var column = range.s.c; column <= range.e.c; ++column) {
                            var address = XLSX.utils.encode_col(column) + '1';

                            if (_.isEmpty(worksheet[address]) && _.isEmpty(reportHeadersData[worksheet[address].v])) {
                                continue;
                            }
                            worksheet[address].v = reportHeadersData[worksheet[address].v].value;
                        }

                        worksheet['!cols'] = fitColumnsWidth(timesReport);
                        var workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte');
                        XLSX.writeFile(workbook, getReportFilename());
                    }
                    vm.isGeneratingReport = false;
                }).catch(function (error) {
                    Cargo77Toast.errorToast(null, error.data.error);
                });
        }

        function getReportData(filters) {
            return Cargo77ReportsService.getOrders(filters)
                .then(function (data) {
                    return Cargo77ReportsService.groupSegmentsBelongsToLocations(data, vm.fromLocationFilter, vm.toLocationsFilter);
                }).then(function (data) {
                    return Cargo77ReportsService.groupSegmentsByDriver(data, vm.carrierCompanyFilter.value);
                }).then(function (data) {
                    return Cargo77ReportsService.groupTripsByDriverAndSegments(data);
                });
        }

        function buildReportEntries(filteredData) {
            var orderFilteredData = _.orderBy(filteredData, ['carrierCompanyName'], ['asc']);
            var reportEntries = [];
            reportHeadersData = {};

            setDriverVehicleHeaders();

            var month = Cargo77ReportsService.getMonthName(vm.monthFilter);

            orderFilteredData.forEach(function (element) {
                var segments = element.segments;
                segments.forEach(function (seg) {
                    var reportRow = {};
                    reportRow[TIMES_REPORT.KEY.CARRIER_COMPANY] = element.carrierCompanyName;
                    reportRow[TIMES_REPORT.KEY.DRIVER] = element.driverName.toUpperCase();
                    reportRow[TIMES_REPORT.KEY.MONTH] = month;
                    reportRow[TIMES_REPORT.KEY.YEAR] = vm.yearFilter;
                    reportRow[TIMES_REPORT.KEY.SEGMENT] = seg.segment;
                    reportRow[TIMES_REPORT.KEY.TRIPS] = seg.trips;
                    reportRow[TIMES_REPORT.KEY.TIME] = seg.timeDetails;
                    reportRow[TIMES_REPORT.KEY.TIME_IN_HOURS] = seg.timeInHours;
                    reportRow[TIMES_REPORT.KEY.ONTRIP_AVERAGE_TIME] = seg.averageTime;
                    reportEntries.push(reportRow);
                });
            });

            var result = generateSortingAndLabelsArrays();
            vm.sortingKeys = result.sortArray;
            vm.headerLabels = result.labels;
            return reportEntries;
        }

        function fitColumnsWidth(data) {
            var keys = Object.keys(reportHeadersData);

            return _.map(keys, function (key) {
                var lengthValues = [reportHeadersData[key].value.toString().length];

                _.forEach(data, function (element) {
                    lengthValues.push(element[key].toString().length);
                });

                return { wch: _.max(lengthValues) + 5 };
            });
        }

        function generateSortingAndLabelsArrays() {
            var keys = Object.keys(reportHeadersData);
            var indexesSortingArray = [];
            var headersArray = [];

            keys.forEach(function (key) {
                var index = reportHeadersData[key].index;
                var label = reportHeadersData[key].value;
                indexesSortingArray[index] = key;
                headersArray[index] = label;
            });
            return {
                sortArray: indexesSortingArray,
                labels: headersArray,
            };
        }

        function getReportFilename() {
            moment.locale('es');
            var currentDate = moment().format('DD-MM-YYYY_HH-mm');
            return 'Reporte Tiempo de Transito Promedio ' + currentDate + '.xlsx';
        }

        function setDriverVehicleHeaders() {
            var COMMON_HEADERS = [
                {
                    'key': TIMES_REPORT.KEY.CARRIER_COMPANY,
                    'value': 'empresa transportista',
                },
                {
                    'key': TIMES_REPORT.KEY.DRIVER,
                    'value': 'conductor',
                },
                {
                    'key': TIMES_REPORT.KEY.MONTH,
                    'value': 'mes',
                },
                {
                    'key': TIMES_REPORT.KEY.YEAR,
                    'value': 'año',
                },
                {
                    'key': TIMES_REPORT.KEY.SEGMENT,
                    'value': 'segmento',
                },
                {
                    'key': TIMES_REPORT.KEY.TRIPS,
                    'value': 'viajes realizados',
                },
                {
                    'key': TIMES_REPORT.KEY.TIME,
                    'value': 'tiempo empleado',
                },
                {
                    'key': TIMES_REPORT.KEY.TIME_IN_HOURS,
                    'value': 'total tiempo empleado (horas)',
                },
                {
                    'key': TIMES_REPORT.KEY.ONTRIP_AVERAGE_TIME,
                    'value': 'tiempo promedio de viajes (horas)',
                },
            ];
            COMMON_HEADERS.forEach(function (keyValueHeader) {
                insertHeader(keyValueHeader);
            });
        }

        function insertHeader(newHeader) {
            if (angular.isDefined(reportHeadersData[newHeader.key])) {
                return;
            }
            var entriesCount = Object.keys(reportHeadersData).length;
            reportHeadersData[newHeader.key] = {
                index: entriesCount,
                value: newHeader.value.toUpperCase(),
            };
        }

        // Graphic
        function graphicsConfig(data, month) {
            var reportTitle = 'Tránsito Promedio por Conductor';
            var month = Cargo77ReportsService.getMonthName(month);
            var companyName = _.isEmpty(vm.carrierCompanyFilter) ? 'TODAS LAS EMPRESAS' : vm.carrierCompanyFilter.company;
            var seriesAndCategories = Cargo77ReportsService.getCategoriesAndSeriesForTimesReport(data);
            var chartHeight = Cargo77ReportsService.calculateChartHeight(seriesAndCategories.categories, seriesAndCategories.series, vm.carrierCompanyFilter.value);

            vm.chartConfig = {
                options: {
                    chart: {
                        type: 'bar',
                        height: chartHeight,
                    },
                    colors: chartsColors.TIMES,
                    title: {
                        text: reportTitle.toUpperCase(),
                    },
                    subtitle: {
                        text: '<strong> ' + companyName + '</strong> <br>' + month + ' ' + vm.yearFilter,
                    },
                    xAxis: {
                        title: {
                            text: 'Conductores',
                        },
                        categories: seriesAndCategories.categories,
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: '<strong>Tiempo promedio de viaje (horas)</strong>',
                            align: 'high',
                        },
                        labels: {
                            overflow: 'justify',
                        },
                    },
                    tooltip: {
                        valueSuffix: ' horas',
                    },
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'top',
                        x: 0,
                        y: 80,
                        borderWidth: 1,
                        backgroundColor: '#FFFFFF',
                        shadow: true,
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                enabled: true,
                                format: '{y} h',
                            },
                        },
                    },
                    credits: {
                        enabled: false,
                    },
                    loading: false,
                },
                series: seriesAndCategories.series,
            };
            vm.showGraphics = true;
            vm.isGeneratingReport = false;
        }

        // Companies
        function getCompanies() {
            var userId = Profile.getCargoCompanyId();
            if (angular.isDefined(Profile.getParentCompanyId()) && Profile.getParentCompanyId().length > 0) {
                userId = Profile.getParentCompanyId();
            }

            vm.carrierCompanies = [];
            vm.shipperCompanies = [];
            CargoCompany.findById({
                'id': userId,
                filter: {
                    include: {
                        relation: 'childCompanies',
                        scope: {
                            fields: ['id', 'name', 'type'],
                        },
                    },
                    fields: ['id', 'name', 'extraFields'],
                },
            })
                .$promise
                .then(function (cargoCompany) {
                    vm.currentCargoCompany = cargoCompany;
                    vm.carrierCompanies.push({
                        label: cargoCompany.name,
                        value: cargoCompany.id,
                    });
                    cargoCompany.childCompanies.forEach(function (childCompany) {
                        if (childCompany.type === 'SHIPPER') {
                            vm.shipperCompanies.push({
                                label: childCompany.name,
                                value: childCompany.id,
                            });
                            return;
                        }
                        vm.carrierCompanies.push({
                            label: childCompany.name,
                            value: childCompany.id,
                        });
                    });
                });
        }

        // Location 1
        function getLocationsFrom() {
            var ownerCompanyId = Profile.getCargoCompanyId();
            LocationsListService.getLocations()
                .$promise
                .then(function (locations) {
                    vm.allLocations = [];
                    vm.ownerCompanyLocations = [];
                    return locations.forEach(function (element) {
                        vm.allLocations.push({
                            name: element.name,
                            label: element.name + ' (' + element.company.name + ')',
                            value: element.id,
                            company: element.company.id,
                        });

                        if (element.company.id == ownerCompanyId) {
                            vm.ownerCompanyLocations.push({
                                name: element.name,
                                label: element.name + ' (' + element.company.name + ')',
                                value: element.id,
                                company: element.company.id,
                            });
                        }
                    });

                });
        }

        // Location 2
        function getLocationsTo() {
            vm.searchLocation1 = '';
            vm.selectedLocationItems = [];
            var auxLocations = [];
            var ownerCompanyId = Profile.getCargoCompanyId();

            if (vm.fromLocationFilter.company != ownerCompanyId) {

                vm.selectedLocationItems = _.filter(vm.allLocations, function (location) {
                    return location.company === vm.fromLocationFilter.company && location.value != vm.fromLocationFilter.value;
                });

                vm.ownerCompanyLocations.forEach(function (location) {
                    vm.selectedLocationItems.push(location);
                });

            } else {
                if (vm.fromLocationFilter.company == ownerCompanyId) {
                    auxLocations = _.filter(vm.allLocations, function (location) {
                        return location.value != vm.fromLocationFilter.value;
                    });

                    auxLocations.forEach(function (element) {
                        vm.selectedLocationItems.push(
                            {
                                name: element.label,
                                label: element.label,
                                value: element.id,
                                company: element.company,
                            }
                        )
                    });
                }
            }

        }

        // Parent Company
        function isParentCompany() {
            return !vm.company.parentCompanyId;
        }

        // Filters
        function getFilters(year, month) {
            var filters = [];
            filters = Cargo77ReportsService.datesFilter(year, month);

            if (!_.isEmpty(vm.carrierCompanyFilter)) {
                filters.push({ secondaryCarrierCompanyId: vm.carrierCompanyFilter.value });
            }
            return _.isEmpty(filters) ? null : { and: filters };
        }

        function resetFilters() {
            vm.searchLocation2 = '';
            vm.carrierCompanyFilter = null;
            vm.fromLocationFilter = null;
            vm.toLocationsFilter = null;
            vm.monthFilter = null;
            vm.yearFilter = null;
            vm.showGraphics = false;
        }

        // ADD GRAPHIC TO DASHBOARD
        function addGraphicToDashboard() {
            // Actual Dates
            vm.isSavingGraphic = true;
            vm.showAddToDashboardBtn = false;
            var now = new Date();
            var actualYear = now.getFullYear().toString();
            var actualMonth = (now.getMonth() + 1).toString();
            var filters = getFilters(actualYear, actualMonth);

            getReportData(filters)
                .then(function (data) {
                    graphicsConfig(data, actualMonth);
                    vm.graphic.graphicType = graphicReportTypes.BAR_CHART;
                    vm.graphic.dataType = graphicDataTypes.TIMES;
                    var settingFilters = {
                        generalFilter: filters,
                        toLocationsFilter: vm.toLocationsFilter,
                        fromLocationFilter: vm.fromLocationFilter,
                    };
                    vm.graphic.filters = JSON.stringify(settingFilters);
                    vm.graphic.graphicConfig = JSON.stringify(vm.chartConfig);

                    Cargo77GraphicsService.saveGraphic(vm.graphic)
                        .then(function () {
                            vm.isSavingGraphic = false;
                            $state.go('cargo.dashboard');
                            Cargo77Toast.successToast('Gráfico añadido al Dashboard.');
                        })
                        .catch(function (error) {
                            Cargo77Toast.errorToast(null, error.data.error);
                        });
                }).catch(function (error) {
                    Cargo77Toast.errorToast(null, error.data.error);
                });

        }

    } // End TimesReportController

}()); // End Function
(function () {
  angular.module("Cargo77.reports").component("cargo77OrderReport", {
    templateUrl: "app/components/reports/components/orders/order-report.html",
    controller: OrderReportController,
  });

  /** @ngInject */
  function OrderReportController(
    $state,
    $stateParams,
    Cargo77Dictionary,
    CargoCompany,
    CompaniesService,
    Profile,
    Order,
    $mdDialog,
    OrdersCommonService
  ) {
    var vm = this;
    vm.$onInit = onInit;
    vm.generateReport = generateReport;
    vm.isGeneratingReport = false;
    vm.isReportEmpty = false;
    vm.resetFilters = resetFilters;
    vm.isParentCompany = isParentCompany;
    var reportHeadersData = {};
    vm.extraFieldOptionKeys = {
      all: "all",
      active: "active",
      inactive: "inactive",
    };

    vm.extraFieldsStateOptions = [
      {
        key: vm.extraFieldOptionKeys.all,
        label: "Todos los campos extra",
      },
      {
        key: vm.extraFieldOptionKeys.active,
        label: "Activos",
      },
      {
        key: vm.extraFieldOptionKeys.inactive,
        label: "Inactivos",
      },
    ];
    vm.cargoCompanyId = Profile.getCargoCompanyId();
    vm.startTimestamp = undefined;
    function onInit() {
      vm.showFilterOptions = true;
      vm.company = CompaniesService.getCurrentCompany();
      vm.shouldShowDateFilter = false;
      vm.shipperCompanyFilter = null;
      vm.carrierCompanyFilter = null;
      vm.statusFilter = null;
      vm.extraFieldsState = null;
      vm.dateFilter = {
        start: null,
        end: null,
      };
      vm.sortingKeys = [];
      vm.headerLabels = [];
      vm.extraFieldsStateOptionsLabels = Object.values(
        vm.extraFieldsStateOptions
      );

      getFormattedStatuses();
      getCompanies();

      //Verificar el tipo de Usuario para mostrar filtros en el reporte
      if (Profile.getUserRole().indexOf("SHIPPER_USER") >= 0) {
        vm.showFilterOptions = false;
      }
    }

    function isParentCompany() {
      return !vm.company.parentCompanyId;
    }

    var REPORT = {
      KEY: {
        ORDER_NUMBER: "order_number",
        ORDER_STATUS: "order_status",
        CREATED_BY: "created_by",
        SHIPPER_COMPANY: "shipper_company",
        CARRIER_COMPANY: "carrier_company",
        DRIVER: "driver",
        VEHICLE: "vehicle",
        TRAILER: "trailer",
        WEIGHT: "weight",
        DISTANCE: "aprox_distance",
        START_TIMESTAMP: "start_timestamp",
        ORIGIN_LOCATION: "origin_location",
        DESTINATION_LOCATION: "destination_location",
        ORIGIN_ARRIVAL_TIME: "origin_arrival_timestamp",
        FIRST_WAIT_TIME: "first_wait_time",
        ESTIMATION_TIME: "calculo_de_horas_de_espera",
        ORIGIN_DEPARTURE_TIME: "origin_departure_timestamp",
        ONTRIP_TIME: "ontrip_time",
        DESTINATION_ARRIVAL_TIME: "destination_arrival_timestamp",
        SECOND_WAIT_TIME: "second_wait_time",
        DESTINATION_DEPARTURE_TIME: "destination_departure_timestamp",
      },
      LABEL: {
        ORIGIN_LOCATION: "ubicación de origen",
        DESTINATION_LOCATION: "ubicación de destino",
        ORIGIN_ARRIVAL_TIME: "entrada a origen",
        ORIGIN_DEPARTURE_TIME: "salida de origen",
        DESTINATION_ARRIVAL_TIME: "entrada a destino",
        DESTINATION_DEPARTURE_TIME: "salida de destino",
        WAIT_TIME: "tiempo de espera",
        ONTRIP_TIME: "tiempo de viaje",
      },
    };

    function getReportFilename() {
      moment.locale("es");
      var currentDate = moment().format("DD-MM-YYYY_HH-mm");
      return "Reporte de fletes " + currentDate + ".xlsx";
    }

    function setReportStaticHeaders() {
      var COMMON_HEADERS = [
        {
          key: REPORT.KEY.ORDER_NUMBER,
          value: "número de orden",
        },
        {
          key: REPORT.KEY.ORDER_STATUS,
          value: "estado",
        },
        {
          key: REPORT.KEY.CREATED_BY,
          value: "creado por",
        },
        {
          key: REPORT.KEY.SHIPPER_COMPANY,
          value: "cliente",
        },
        {
          key: REPORT.KEY.CARRIER_COMPANY,
          value: "empresa transportista",
        },
        {
          key: REPORT.KEY.DRIVER,
          value: "conductor",
        },
        {
          key: REPORT.KEY.VEHICLE,
          value: "vehículo",
        },
        {
          key: REPORT.KEY.TRAILER,
          value: "arrastre",
        },
        {
          key: REPORT.KEY.WEIGHT,
          value: "peso",
        },
        {
          key: REPORT.KEY.DISTANCE,
          value: "distancia aproximada",
        },
        {
          key: REPORT.KEY.START_TIMESTAMP,
          value: "hora esperada de inicio",
        },
        {
          key: REPORT.KEY.ORIGIN_LOCATION,
          value: REPORT.LABEL.ORIGIN_LOCATION,
        },
        {
          key: REPORT.KEY.DESTINATION_LOCATION,
          value: REPORT.LABEL.DESTINATION_LOCATION,
        },
        {
          key: REPORT.KEY.ORIGIN_ARRIVAL_TIME,
          value: REPORT.LABEL.ORIGIN_ARRIVAL_TIME,
        },
        {
          key: REPORT.KEY.FIRST_WAIT_TIME,
          value: REPORT.LABEL.WAIT_TIME,
        },
        {
          key: REPORT.KEY.ESTIMATION_TIME,
          value: "calculo de horas de espera",
        },
        {
          key: REPORT.KEY.ORIGIN_DEPARTURE_TIME,
          value: REPORT.LABEL.ORIGIN_DEPARTURE_TIME,
        },
        {
          key: REPORT.KEY.ONTRIP_TIME,
          value: REPORT.LABEL.ONTRIP_TIME,
        },
        {
          key: REPORT.KEY.DESTINATION_ARRIVAL_TIME,
          value: REPORT.LABEL.DESTINATION_ARRIVAL_TIME,
        },
        {
          key: REPORT.KEY.SECOND_WAIT_TIME,
          value: REPORT.LABEL.WAIT_TIME,
        },
        {
          key: REPORT.KEY.DESTINATION_DEPARTURE_TIME,
          value: REPORT.LABEL.DESTINATION_DEPARTURE_TIME,
        },
      ];

      COMMON_HEADERS.forEach(function (keyValueHeader) {
        insertHeader(keyValueHeader);
      });
    }

    function generateSortingAndLabelsArrays() {
      var keys = Object.keys(reportHeadersData);
      var indexesSortingArray = [];
      var headersArray = [];

      keys.forEach(function (key) {
        var index = reportHeadersData[key].index;
        var label = reportHeadersData[key].value;
        indexesSortingArray[index] = key;
        headersArray[index] = label;
      });

      return {
        sortArray: indexesSortingArray,
        labels: headersArray,
      };
    }

    function resetFilters() {
      vm.dateFilter = {
        start: null,
        end: null,
      };
      vm.shipperCompanyFilter = null;
      vm.carrierCompanyFilter = null;
      vm.statusFilter = null;
      vm.extraFieldsState = vm.extraFieldOptionKeys.active;
    }

    function generateReport() {
      vm.isReportEmpty = false;

      var filters = getFilters();

      countOrders(filters)
        .then(function (response) {
          if (response.count > 1000) {
            return $mdDialog.show({
              templateUrl:
                "app/components/reports/components/common/orderReportConfirmModal/orderReportConfirmModal.html",
              controller: "OrderReportConfirmModalController",
              locals: {
                count: response.count,
              },
              bindToController: true,
              controllerAs: "$ctrl",
            });
          } else if (response.count <= 0) {
            vm.isReportEmpty = true;
          } else {
            createExcelReport(filters);
          }

          return false;
        })
        .then(function (response) {
          if (response) {
            createExcelReport(filters);
          }
        });
    }

    function createExcelReport(filters) {
      vm.isGeneratingReport = true;

      getOrders(filters).then(function (orders) {
        vm.isGeneratingReport = false;

        var ordersReport = buildReportEntries(orders);

        var worksheet = XLSX.utils.json_to_sheet(ordersReport, {
          header: vm.sortingKeys,
        });

        var range = XLSX.utils.decode_range(worksheet["!ref"]);

        for (var column = range.s.c; column <= range.e.c; ++column) {
          var address = XLSX.utils.encode_col(column) + "1";

          if (
            _.isEmpty(worksheet[address]) &&
            _.isEmpty(reportHeadersData[worksheet[address].v])
          ) {
            continue;
          }

          worksheet[address].v = reportHeadersData[worksheet[address].v].value;
        }

        worksheet["!cols"] = fitColumnsWidth(ordersReport);

        var workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte");
        XLSX.writeFile(workbook, getReportFilename());
      });
    }

    function fitColumnsWidth(orders) {
      var keys = Object.keys(reportHeadersData);

      return _.map(keys, function (key) {
        var lengthValues = [reportHeadersData[key].value.toString().length];

        _.forEach(orders, function (order) {
          lengthValues.push(order[key].toString().length);
        });

        return { wch: _.max(lengthValues) + 5 };
      });
    }

    function getFilters() {
      var filters = [];

      if (!_.isEmpty(vm.shipperCompanyFilter)) {
        filters.push({ shipperCompanyId: vm.shipperCompanyFilter });
      }

      if (!_.isEmpty(vm.carrierCompanyFilter)) {
        filters.push({ secondaryCarrierCompanyId: vm.carrierCompanyFilter });
      }

      if (!_.isEmpty(vm.statusFilter)) {
        filters.push({ orderStatus: vm.statusFilter });
      }

      if (!_.isEmpty(vm.dateFilter.start)) {
        var dateStart = new Date(vm.dateFilter.start);
        filters.push({
          scheduledDate: {
            gte: moment(dateStart).format("YYYY-MM-DD 00:00:00"),
          },
        });
      }

      if (!_.isEmpty(vm.dateFilter.end)) {
        var dateEnd = new Date(vm.dateFilter.end);
        filters.push({
          scheduledDate: {
            lte: moment(dateEnd).format("YYYY-MM-DD 23:59:59"),
          },
        });
      }

      return _.isEmpty(filters) ? {} : { and: filters };
    }

    function insertHeader(newHeader) {
      if (angular.isDefined(reportHeadersData[newHeader.key])) {
        return;
      }
      var entriesCount = Object.keys(reportHeadersData).length;
      reportHeadersData[newHeader.key] = {
        index: entriesCount,
        value: newHeader.value.toUpperCase(),
      };
    }

    function ascendingSortComparator(extraFieldA, extraFieldB) {
      if (extraFieldA.name.toLowerCase() > extraFieldB.name.toLowerCase()) {
        return 1;
      }
      if (extraFieldA.name.toLowerCase() < extraFieldB.name.toLowerCase()) {
        return -1;
      }
      return 0;
    }

    function separateOrderAndSegmentExtraFields(companyExtraFields) {
      var SECTION = {
        order: "ORDER",
        segment: "SEGMENT",
      };
      var segmentExtraFields = [];
      var orderExtraFields = [];

      companyExtraFields.forEach(function (extraField) {
        if (extraField.section === SECTION.order) {
          orderExtraFields.push(extraField);
        } else if (extraField.section === SECTION.segment) {
          segmentExtraFields.push(extraField);
        }
      });

      orderExtraFields.sort(ascendingSortComparator);
      segmentExtraFields.sort(ascendingSortComparator);

      return {
        segmentExtraFields: segmentExtraFields,
        orderExtraFields: orderExtraFields,
      };
    }

    function appendExtraFieldColumnHeaders() {
      var extraFieldsData = separateOrderAndSegmentExtraFields(
        vm.currentCargoCompany.extraFields
      );

      extraFieldsData.orderExtraFields.forEach(function (companyExtraField) {
        if (doesExtraFieldMatchFilter(companyExtraField)) {
          insertHeader({
            key: companyExtraField.id.toString(),
            value: companyExtraField.name + "(F)",
          });
        }
      });

      extraFieldsData.segmentExtraFields.forEach(function (companyExtraField) {
        if (doesExtraFieldMatchFilter(companyExtraField)) {
          insertHeader({
            key: companyExtraField.id.toString(),
            value: companyExtraField.name + "(S)",
          });
        }
      });
    }

    function doesExtraFieldMatchFilter(extraFieldDefinition) {
      if (
        vm.extraFieldsState === null ||
        vm.extraFieldsState === vm.extraFieldOptionKeys.all
      ) {
        return true;
      } else if (vm.extraFieldsState === vm.extraFieldOptionKeys.active) {
        return extraFieldDefinition.isActive === true;
      } else if (vm.extraFieldsState === vm.extraFieldOptionKeys.inactive) {
        return extraFieldDefinition.isActive === false;
      }
      return false;
    }

    function buildReportEntries(filteredOrders) {
      var reportEntries = [];
      reportHeadersData = {};
      setReportStaticHeaders();
      appendExtraFieldColumnHeaders();

      filteredOrders.forEach(function (order) {
        order.route.segments.forEach(function (segment, index) {
          var segmentData = getSegmentResourcesAndStats(segment);
          var carrierCompany = order.secondaryCarrierCompany
            ? order.secondaryCarrierCompany.name
            : order.mainCarrierCompany.name;
          var orderStatus = getOrderStatus(order);
          var creatorName = [
            order.creator.firstName,
            order.creator.lastName,
          ].join(" ");

          var reportRow = {};
          reportRow[REPORT.KEY.ORDER_NUMBER] = order.orderNumber;
          reportRow[REPORT.KEY.ORDER_STATUS] = orderStatus;
          reportRow[REPORT.KEY.CREATED_BY] = creatorName;
          reportRow[REPORT.KEY.SHIPPER_COMPANY] = order.shipperCompany.name;
          reportRow[REPORT.KEY.CARRIER_COMPANY] = carrierCompany;
          reportRow[REPORT.KEY.DRIVER] = segmentData.assignedDriver;
          reportRow[REPORT.KEY.VEHICLE] = segmentData.assignedVehicle;
          reportRow[REPORT.KEY.TRAILER] = segmentData.assignedTrailer;
          reportRow[REPORT.KEY.WEIGHT] = segmentData.segmentWeight;
          reportRow[REPORT.KEY.DISTANCE] = segmentData.distance;

          generateExtraFieldsColumnsData(order, segment).forEach(function (
            reportEntry
          ) {
            reportRow[reportEntry.key] = reportEntry.value;
          });

          vm.startTimestamp = segment.scheduledDate;
          reportRow[REPORT.KEY.START_TIMESTAMP] = moment(
            segment.scheduledDate
          ).format("DD/MM/YYYY HH:mm:ss");

          var stopoverBySegment = _.slice(
            order.stopoverHistory,
            index * 2,
            index * 2 + 4
          );
          generateStopoverColumnsData(stopoverBySegment, segment).forEach(
            function (reportEntry) {
              reportRow[reportEntry.key] = reportEntry.value;
            }
          );

          reportEntries.push(reportRow);
        });
      });

      var result = generateSortingAndLabelsArrays();
      vm.sortingKeys = result.sortArray;
      vm.headerLabels = result.labels;
      return reportEntries;
    }

    function getSegmentResourcesAndStats(segment) {
      var NO_ASIGNADO = "no asignado";
      var NOT_AVAILABLE = "n/a";
      var KG = " Kg";

      var assignedDriver = segment.currentAssignedDriverInstance
        ? [
            segment.currentAssignedDriverInstance.firstName,
            segment.currentAssignedDriverInstance.lastName,
          ].join(" ")
        : NO_ASIGNADO;

      var assignedVehicle =
        segment.currentAssignedVehicleInstance &&
        segment.currentAssignedVehicleInstance.plate != undefined
          ? segment.currentAssignedVehicleInstance.plate.toUpperCase()
          : NO_ASIGNADO;

      var assignedTrailer = segment.currentAssignedTrailerInstance
        ? getCurrentTrailerName(segment.currentAssignedTrailerInstance)
        : NO_ASIGNADO;

      var segmentWeight = segment.cargoDetails.weight.value
        ? segment.cargoDetails.weight.value + KG
        : NOT_AVAILABLE;
      var distance = segment.distance ? segment.distance.text : NOT_AVAILABLE;

      return {
        assignedDriver: assignedDriver,
        assignedVehicle: assignedVehicle,
        assignedTrailer: assignedTrailer,
        segmentWeight: segmentWeight,
        distance: distance,
      };
    }

    function generateExtraFieldsColumnsData(order, segment) {
      var NOT_AVAILABLE = "n/a";
      var extraFieldsEntries = [];
      var rowEntry;
      vm.currentCargoCompany.extraFields.forEach(function (companyExtraField) {
        if (doesExtraFieldMatchFilter(companyExtraField)) {
          var foundExtraField;
          rowEntry = {};

          if (companyExtraField.section === "ORDER") {
            foundExtraField = _.find(
              order.extraFields,
              function (orderExtraField) {
                return (
                  orderExtraField.definitionId.toString() ===
                  companyExtraField.id.toString()
                );
              }
            );
          }

          if (companyExtraField.section === "SEGMENT") {
            foundExtraField = _.find(
              segment.extraFields,
              function (segmentExtraField) {
                return (
                  segmentExtraField.definitionId.toString() ===
                  companyExtraField.id.toString()
                );
              }
            );
          }

          rowEntry.key = companyExtraField.id.toString();
          rowEntry.value = foundExtraField
            ? foundExtraField.value
            : NOT_AVAILABLE;

          extraFieldsEntries.push(rowEntry);
        }
      });

      return extraFieldsEntries;
    }

    function generateStopoverColumnsData(stopoverHistory, segment) {
      var fromLocationArrivalStopoverEntry =
        stopoverHistory[0] &&
        stopoverHistory[0].type === "ARRIVAL" &&
        stopoverHistory[0].locationId.toString() ===
          segment.fromLocationId.toString() &&
        stopoverHistory[0];
      var firstArrivalTime = fromLocationArrivalStopoverEntry
        ? fromLocationArrivalStopoverEntry.datetime
        : undefined;

      var fromLocationDepartureStopoverEntry =
        stopoverHistory[1] &&
        stopoverHistory[1].type === "DEPARTURE" &&
        stopoverHistory[1].locationId.toString() ===
          segment.fromLocationId.toString() &&
        stopoverHistory[1];

      var firstDepartureTime = fromLocationDepartureStopoverEntry
        ? fromLocationDepartureStopoverEntry.datetime
        : undefined;

      var toLocationArrivalStopoverEntry =
        stopoverHistory[2] &&
        stopoverHistory[2].type === "ARRIVAL" &&
        stopoverHistory[2].locationId.toString() ===
          segment.toLocationId.toString() &&
        stopoverHistory[2];

      var secondArrivalTime = toLocationArrivalStopoverEntry
        ? toLocationArrivalStopoverEntry.datetime
        : undefined;

      var toLocationDepartureStopoverEntry =
        stopoverHistory[3] &&
        stopoverHistory[3].type === "DEPARTURE" &&
        stopoverHistory[3].locationId.toString() ===
          segment.toLocationId.toString() &&
        stopoverHistory[3];

      var secondDepartureTime = toLocationDepartureStopoverEntry
        ? toLocationDepartureStopoverEntry.datetime
        : undefined;

      var segmentFromLocation = segment.fromLocationInstance.name;
      var segmentToLocation = segment.toLocationInstance.name;

      var stopoverEntries = [];
      var NO_REGISTERED = "Hora no registrada";

      stopoverEntries.push({
        key: REPORT.KEY.ORIGIN_LOCATION,
        value: segmentFromLocation,
      });
      stopoverEntries.push({
        key: REPORT.KEY.DESTINATION_LOCATION,
        value: segmentToLocation,
      });
      stopoverEntries.push({
        key: REPORT.KEY.ORIGIN_ARRIVAL_TIME,
        value: fromLocationArrivalStopoverEntry
          ? moment(fromLocationArrivalStopoverEntry.datetime).format(
              "DD/MM/YYYY HH:mm:ss"
            )
          : NO_REGISTERED,
      });

      if (
        vm.cargoCompanyId === "5b748a573c0f781900afd9c5" &&
        moment(vm.startTimestamp).isAfter(firstArrivalTime)
      ) {
        stopoverEntries.push({
          key: REPORT.KEY.FIRST_WAIT_TIME,
          value:
            vm.startTimestamp != undefined && firstDepartureTime != undefined
              ? OrdersCommonService.calculateTime(
                  vm.startTimestamp,
                  firstDepartureTime
                )
              : NO_REGISTERED,
        });
      } else {
        stopoverEntries.push({
          key: REPORT.KEY.FIRST_WAIT_TIME,
          value:
            firstArrivalTime != undefined && firstDepartureTime != undefined
              ? OrdersCommonService.calculateTime(
                  firstArrivalTime,
                  firstDepartureTime
                )
              : NO_REGISTERED,
        });
      }
      if (segment.scheduledDate > firstArrivalTime) {
        var estimationTime = OrdersCommonService.calculateTime(
          segment.scheduledDate,
          secondArrivalTime
        );
      } else {
        var estimationTime = OrdersCommonService.calculateTime(
          secondArrivalTime,
          secondDepartureTime
        );
      }

      stopoverEntries.push({
        key: REPORT.KEY.ESTIMATION_TIME,
        value: estimationTime != undefined ? estimationTime : NO_REGISTERED,
      });
      stopoverEntries.push({
        key: REPORT.KEY.ORIGIN_DEPARTURE_TIME,
        value: fromLocationDepartureStopoverEntry
          ? moment(fromLocationDepartureStopoverEntry.datetime).format(
              "DD/MM/YYYY HH:mm:ss"
            )
          : NO_REGISTERED,
      });
      stopoverEntries.push({
        key: REPORT.KEY.ONTRIP_TIME,
        value:
          firstDepartureTime != undefined && secondArrivalTime != undefined
            ? OrdersCommonService.calculateTime(
                firstDepartureTime,
                secondArrivalTime
              )
            : NO_REGISTERED,
      });
      stopoverEntries.push({
        key: REPORT.KEY.DESTINATION_ARRIVAL_TIME,
        value: toLocationArrivalStopoverEntry
          ? moment(toLocationArrivalStopoverEntry.datetime).format(
              "DD/MM/YYYY HH:mm:ss"
            )
          : NO_REGISTERED,
      });
      stopoverEntries.push({
        key: REPORT.KEY.SECOND_WAIT_TIME,
        value:
          secondArrivalTime != undefined && secondDepartureTime != undefined
            ? OrdersCommonService.calculateTime(
                secondArrivalTime,
                secondDepartureTime
              )
            : NO_REGISTERED,
      });
      stopoverEntries.push({
        key: REPORT.KEY.DESTINATION_DEPARTURE_TIME,
        value: toLocationDepartureStopoverEntry
          ? moment(toLocationDepartureStopoverEntry.datetime).format(
              "DD/MM/YYYY HH:mm:ss"
            )
          : NO_REGISTERED,
      });

      return stopoverEntries;
    }

    function getFormattedStatuses() {
      vm.orderStatus = Cargo77Dictionary.getOrderStatus();
      vm.orderStatus.forEach(function (status) {
        status.title =
          status.title.charAt(0).toUpperCase() + status.title.slice(1);
      });
    }

    function getCompanies() {
      var userId = Profile.getCargoCompanyId();
      if (
        angular.isDefined(Profile.getParentCompanyId()) &&
        Profile.getParentCompanyId().length > 0
      ) {
        userId = Profile.getParentCompanyId();
      }
      vm.carrierCompanies = [];
      vm.shipperCompanies = [];
      CargoCompany.findById({
        id: userId,
        filter: {
          include: {
            relation: "childCompanies",
            scope: {
              fields: ["id", "name", "type"],
            },
          },
          fields: ["id", "name", "extraFields"],
        },
      }).$promise.then(function (cargoCompany) {
        vm.currentCargoCompany = cargoCompany;
        vm.carrierCompanies.push({
          label: cargoCompany.name,
          value: cargoCompany.id,
        });
        cargoCompany.childCompanies.forEach(function (childCompany) {
          if (childCompany.type === "SHIPPER") {
            vm.shipperCompanies.push({
              label: childCompany.name,
              value: childCompany.id,
            });
            return;
          }
          vm.carrierCompanies.push({
            label: childCompany.name,
            value: childCompany.id,
          });
        });
      });
    }

    function countOrders(filters) {
      if (Profile.getUserRole().indexOf("SHIPPER_USER") >= 0) {
        filters.and.push({ shipperCompanyId: Profile.getCargoCompanyId() });
      } else {
        if (Profile.getUserRole().indexOf("CARGO_ADMIN") < 0) {
          filters.and.push({
            mainCarrierCompanyId: Profile.getCargoCompanyId(),
          });
        }
      }

      //console.log(filters);
      return Order.count({ where: filters }).$promise;
    }

    function getOrders(filters) {
      return Order.findWithSegmentsResources({
        filter: {
          where: filters,
          include: [
            {
              relation: "shipperCompany",
              scope: {
                fields: ["id", "name"],
              },
            },
            {
              relation: "mainCarrierCompany",
              scope: {
                fields: ["id", "name"],
              },
            },
            {
              relation: "secondaryCarrierCompany",
              scope: {
                fields: ["id", "name"],
              },
            },
            {
              relation: "creator",
              scope: {
                fields: ["firstName", "lastName"],
              },
            },
            {
              relation: "stopoverHistory",
            },
          ],
        },
      }).$promise;
    }

    function getCurrentTrailerName(trailer) {
      var currentTrailerType = Cargo77Dictionary.getTitleForObjectLabel(
        "trailerTypes",
        trailer.type
      ).title;
      var currentTrailer =
        currentTrailerType.toUpperCase() + " - " + trailer.identification;
      return currentTrailer;
    }

    function getOrderStatus(order) {
      var availableOrderStatus = Cargo77Dictionary.getOrderStatus();
      var relatedStatus = _.find(
        availableOrderStatus,
        function (availableStatus) {
          return availableStatus.label === order.orderStatus;
        }
      );
      return (
        relatedStatus.title.charAt(0).toUpperCase() +
        relatedStatus.title.slice(1)
      );
    }
  }
})();

(function () {
  angular.module('Cargo77.orders').component('cargo77StopoversHistoryTab', {
    templateUrl: 'app/components/orders/components/stopoversHistoryTab/stopovers-history-tab.html',
    controller: StopoversHistoryTabController,
    bindings: {
      'order':'<',
      'updateOrder': '&',
    },
  });

  /** @ngInject */
  function StopoversHistoryTabController(Cargo77Dictionary, Profile) {
    var vm = this;
    vm.error = false;
    vm.getOrderStatusLabel = getOrderStatusLabel;
    vm.isCarrierViewer = isCarrierViewer;

    function getOrderStatusLabel(orderStatus) {
      return Cargo77Dictionary.getTitleForObjectLabel('status', orderStatus).title;
    }

    function isCarrierViewer() {
      return Profile.getUserPrimaryRole() === 'CARRIER_VIEWER';
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77ShipperOrderOverviewTab', {
    templateUrl: 'app/components/orders/components/shipperOrderOverviewTab/shipper-order-overview-tab.html',
    controller: ShipperOrderOverviewController,
    bindings: {
      'order': '<',
    },
  });

  /** @ngInject */
  function ShipperOrderOverviewController($stateParams, $state, Order, NavBarService, OrdersCommonService, Cargo77Toast, Profile) {
    var vm = this;

    vm.error = false;
    vm.getRouteText = getRouteText;
    vm.onCancelOrder = onCancelOrder;
    vm.mayUserCancelOrder = mayUserCancelOrder;
    vm.mayOffersBeAccepted = mayOffersBeAccepted;
    vm.$onInit = onInit;

    function onInit() {
      if(!vm.order || vm.order && !vm.order.id) {
        vm.error = true;
        return;
      }
      NavBarService.currentPageTitle = 'Detalles de la orden ' +  (vm.order.orderNumber || vm.order.id);
    }

    function onCancelOrder() {
      // TODO: verify cancel method is defined in order instance. Prev implementation: Order.cancel({id: vm.order.id})
      vm.order.cancel()
        .$promise
        .then(function () {
          $state.go('cargo.listShipperOrders');
          Cargo77Toast.successToast('Tu orden ha sido cancelada.');
        }).catch(function (error) {
        Cargo77Toast.errorToast(null, error.data.error);
      });
    }

    function getRouteText(location) {
      return OrdersCommonService.getRouteTextForOrder(vm.order, location);
    }
    function mayUserCancelOrder () {
      var isUserOrderCreator = vm.order.cargoUserId === Profile.getId();
      var isUserShipperOwner = Profile.getUserPrimaryRole() === 'SHIPPER_OWNER';
      var isOrderOnSentStatus = vm.order.orderStatus === 'REQUESTING_OFFERS';
      return isOrderOnSentStatus && (isUserOrderCreator || isUserShipperOwner);
    }
    function mayOffersBeAccepted() {
      var isOfferCancelled = vm.order.orderStatus === 'CANCELLED';
      var isOfferExpired = vm.order.orderStatus === 'EXPIRED';
      return !isOfferCancelled && !isOfferExpired;
    }

  }
}());

/**
 * Created by Leonel Gonçalves on 7/6/16.
 */
(function () {
  angular.module('Cargo77.orders').component('cargo77ShipperOrderList',
    {
      templateUrl: 'app/components/orders/components/shipperOrderList/shipper-order-list.html',
      controller: ShipperOrderListController,
    });

  /** @ngInject */
  function ShipperOrderListController(ShipperOrderListService, OrdersCommonService, Cargo77Dictionary, Cargo77Toast,
                                      LocationsHelper, SearchBarService) {
    var vm = this;
    var filters = {
      searchText: '',
    };

    vm.$onInit = onInit;
    vm.initialSearchText = '';
    vm.status = Cargo77Dictionary.getOrderStatus();
    vm.getFormattedStringTime = LocationsHelper.getFormattedStringTime;
    vm.getOrderScheduledDate = getOrderScheduledDate;
    vm.getStatusForOrder = getStatusForOrder;
    vm.updateStatusFilter = updateStatusFilter;
    vm.updateSearchText = updateSearchText;
    vm.getAcceptedOffer = getAcceptedOffer;
    vm.getRouteText = getRouteText;
    vm.isOrderCancelled = isOrderCancelled;
    vm.getStopoverType = getStopoverType;

    vm.orders = new ShipperOrderListService.OrdersList(filters);

    function onInit() {
      vm.initialSearchText = SearchBarService.getSearchText();
      updateSearchText(vm.initialSearchText);
    }

    function updateOrders() {
      vm.orders.items = [];
      vm.isLoadingOrders = true;
      vm.orders.skip = 0;
      ShipperOrderListService.getSortedOrdersByScheduledDate(filters, vm.orders.skip, true)
        .then(function (response) {
          vm.orders.items = response.orders;
          vm.orders.skip = 10;
          vm.isLoadingOrders = false;
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function getAcceptedOffer(order) {
      return _.find(order.offers, function (offer) {
        return offer.isAccepted;
      });
    }

    function getRouteText (order, location) {
      return OrdersCommonService.getRouteTextForOrder(order, location);
    }

    function updateStatusFilter(status) {
      filters.orderStatus = status;
      updateOrders();
    }

    function updateSearchText(searchText) {
      filters.searchText = searchText;
      SearchBarService.setSearchText(searchText);
      updateOrders();
    }

    function getOrderScheduledDate(label) {
      return Cargo77Dictionary.getTitleForObjectLabel('times', label).title;
    }

    function getStatusForOrder(status) {
      if(status === 'REQUESTING_OFFERS') {
        return;
      }
      return Cargo77Dictionary.getTitleForObjectLabel('status', status.toUpperCase());
    }

    function isOrderCancelled(order) {
      return order.orderStatus === 'CANCELLED';
    }

    function getStopoverType(stopoverType) {
      return Cargo77Dictionary.getTitleForObjectLabel('arrivalDepartureLabels', stopoverType.toUpperCase());
    }
  }

}());

(function () {
  angular.module('Cargo77.orders').component('cargo77ShipperOrderDetails', {
    templateUrl: 'app/components/orders/components/shipperOrderDetails/shipper-order-details.html',
    controller: ShipperOrderDetailsController,
    controllerAs: 'shipperOrderDetails',
  });
  /** @ngInject */
  function ShipperOrderDetailsController(Order, $stateParams) {
    var vm = this;
    vm.order = null;
    vm.$onInit = onInit;
    vm.updateOrder = updateOrder;

    function onInit() {
      var activeTab = $stateParams.tab;
      getOrder();
      vm.activeTab = 0;
      if(activeTab) {
        vm.activeTab = activeTab;
      }
    }

    function getOrder() {
      Order.findWithSegmentsResources({
        filter: {
          include: [
            {
              relation: 'offers',
              scope: {
                fields: ['id', 'orderId', 'price'],
                where: {
                  isAccepted: true,
                },
              },
            },
            {
              relation: 'assignmentHistory',
            },
            {

              relation: 'stopoverHistory',
              scope: {
                include: {
                  relation: 'stopoverLocation',
                  scope: {
                    fields: ['id', 'name'],
                  },
                },
              },
            },
            {
              relation: 'shipperCompany',
              scope: {
                fields: ['id', 'name', 'email', 'phone', 'address', 'photoURL'],
              },
            },
            {
              relation: 'ownerCompany',
              scope: {
                fields: ['id', 'name', 'extraFields'],
              },
            },
            {
              relation: 'mainCarrierCompany',
              scope: {
                fields: ['id', 'name'],

              },
            },
            {
              relation: 'secondaryCarrierCompany',
              scope: {
                fields: ['id', 'name'],
              },
            },
          ],
          where: {'id': $stateParams.id},
        },
        includeResourcesImages: true,
      })
      .$promise
      .then(function (response) {
        vm.order = response[0];
      });
    }

    function updateOrder() {
      getOrder();
    }
  }
}());

/**
 * Created by Leonel Gonçalves on 7/3/16.
 */
(function () {
  angular.module('Cargo77.orders').component('cargo77ShipperCreateOrder', {
    templateUrl: 'app/components/orders/components/shipperCreateOrder/shipper-create-order.html',
    controller: CreateOrderController,
  });

  /** @ngInject */
  function CreateOrderController(ShipperCreateOrderService, CompaniesService, $state, Cargo77Toast) {
    var vm = this;
    vm.areValidExtraFieldsForOrder = true;
    vm.userLoggedCompany = CompaniesService.getCurrentCompany();

    vm.getCarrierCompanyId = getCarrierCompanyId;
    vm.saveOrder = saveOrder;
    vm.createOrder = createOrder;
    vm.onRouteChange = onRouteChange;
    vm.onExtraFieldChange = onExtraFieldChange;
    vm.areValidExtraFieldsChange = areValidExtraFieldsChange;
    vm.validateOrderRoute = validateOrderRoute;
    vm.validateAllFields = validateAllFields;
    vm.isSaving = false;

    vm.order = {
      route: {
        segments:[],
      },
    };

    onInit();

    function getCarrierCompanyId() {
      if (vm.userLoggedCompany.parentCompanyId) {
        return vm.userLoggedCompany.parentCompanyId;
      }
      return null;
    }

    function createOrder(order){
      vm.isSaving = true;
      return ShipperCreateOrderService.createOrder(order)
        .then(function () {
          vm.isSaving = false;
          $state.go('cargo.listShipperOrders');
          Cargo77Toast.successToast('El flete se ha creado con éxito.');
        })
        .catch(function (error) {
          vm.isSaving = false;
          if(!error || error && !error.data || error && error.data && !error.data.error) {
            Cargo77Toast.errorToast('Ha ocurrido un error al crear la orden');
          }
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function saveOrder() {
      var newOrder = {};

      newOrder.details = vm.order.details || '';
      newOrder.route = vm.order.route;
      newOrder.extraFields = vm.order.extraFields || [];

      if (vm.order.id) {
        newOrder.id = vm.order.id;
      }

      if(vm.order.extraFields) {
        newOrder.extraFields = vm.order.extraFields;
      }

      if (vm.order.duplicatesAmount) {
        for (var i = 0; i < vm.order.duplicatesAmount; i++) {
          newOrder.duplicatesDetails = i + 1 + ' de ' + vm.order.duplicatesAmount;
          var duplicatedOrder = newOrder;
          vm.createOrder(duplicatedOrder);
        }
      } else {
        vm.createOrder(newOrder);
      }
    }

    function onRouteChange(segments) {
      vm.order.route.segments = segments;
    }

    function onExtraFieldChange(extraFields) {
      vm.order.extraFields = extraFields;
    }

    function areValidExtraFieldsChange(areValidExtraFields) {
      vm.areValidExtraFieldsForOrder = areValidExtraFields;
    }

    function validateOrderRoute() {
      var areSegmentsValid = vm.order.route.segments && vm.order.route.segments.length > 0 && areValidExtraFieldsForAllSegments();
      return areSegmentsValid;
    }

    function areValidExtraFieldsForAllSegments() {
      var areValidExtraFields = true;
      vm.order.route.segments.forEach(function(segment) {
        if (segment.areValidExtraFields === false) {
          areValidExtraFields = false;
        }
      });
      return areValidExtraFields;
    }

    function validateAllFields() {
      return vm.areValidExtraFieldsForOrder && vm.validateOrderRoute();
    }

    function onInit() {
      var duplicates = _.find(vm.order.options, function (option) {
        return option.label === 'duplicates';
      });
      if (duplicates) {
        vm.order.needDuplicates = true;
        vm.order.duplicatesAmount = duplicates.amount;
      }
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77ShipperAcceptOffer', {
    templateUrl: 'app/components/orders/components/shipperAcceptOffer/shipper-accept-offer.html',
    controller: ShipperAcceptController,
  });

  /** @ngInject */
  function ShipperAcceptController($state,
                                   $stateParams,
                                   Order,
                                   Cargo77Toast,
                                   NavBarService,
                                   CargoCompany,
                                   Profile,
                                   OrdersCommonService) {
    var vm = this;

    vm.getRouteText = getRouteText;
    vm.acceptOffer = acceptOffer;
    vm.creditCard = {};
    vm.$onInit = onInit;

    function acceptOffer() {

      if (vm.type === 'PAYMENT_AGREEMENT') {
        vm.photo = null;
        vm.documentNumber = null;
        vm.creditCard = {};
      }

      if (vm.type === 'CREDIT_CARD') {
        vm.isProcessingPayment = true;
        delete vm.photo;
        delete vm.documentNumber;
      }

      if (vm.type === 'DEPOSIT_OR_WIRE_TRANSFER') {
        vm.creditCard = {};
      }

      Order.acceptOffer(
        {id: $stateParams.id, offerId: $stateParams.offerId},
        {type: vm.type, voucherPhoto: vm.photo, documentNumber: vm.documentNumber, creditCard: vm.creditCard}
      ).$promise
        .then(function () {
          $state.go('cargo.listShipperOrders');
          Cargo77Toast.successToast('Oferta aceptada con éxito.');
        })
        .catch(function (response) {
          Cargo77Toast.errorToast(null, response.data.error);
        })
        .finally(function () {
          vm.isProcessingPayment = false;
        });
    }

    function onInit() {
      getOrder();
      vm.company = CargoCompany.findById({
        id: Profile.getCurrentUser().cargoCompanyId,
        filter: {fields: ['hasPaymentAgreement']},
      });
      vm.company.$promise.then(function (data) {
        if (data.hasPaymentAgreement) {
          vm.type = 'PAYMENT_AGREEMENT';
        }
      });
    }

    function getOrder() {
      Order.findById({
        id: $stateParams.id,
        filter: {
          fields: ['id', 'route'],
        },
      })
        .$promise
        .then(function (response) {
          vm.order = response;
          NavBarService.currentPageTitle = 'Pago - #' + vm.order.id;
        });
    }

    function getRouteText(location) {
      return OrdersCommonService.getRouteTextForOrder(vm.order, location);
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77CreateOrder', {
    templateUrl: 'app/components/orders/components/createOrder/create-order.html',
    controller: CreateOrderController,
  });

  /** @ngInject */
  function CreateOrderController(CreateOrderService, CompaniesService, $state, Cargo77Toast, $stateParams) {
    var vm = this;
    vm.userLoggedCompany = CompaniesService.getCurrentCompany();

    vm.getCarrierCompanyId = getCarrierCompanyId;
    vm.validateOrderShipper = validateOrderShipper;
    vm.validateOrderCarrier = validateOrderCarrier;
    vm.validateOrderRoute = validateOrderRoute;
    vm.validateAllFields = validateAllFields;
    vm.saveOrder = saveOrder;
    vm.createOrder = createOrder;
    vm.onRouteChange = onRouteChange;
    vm.onExtraFieldChange = onExtraFieldChange;
    vm.areValidExtraFieldsChange = areValidExtraFieldsChange;
    vm.onSavingOrderFiles = onSavingOrderFiles;
    vm.onSavingSegmentFiles = onSavingSegmentFiles;
    vm.haveDetailsFullfilled = haveDetailsFullfilled;
    vm.isSaving = false;

    vm.order = {
      route: {
        segments:[],
      },
    };

    onInit();

    function createOrder(order){
      vm.isSaving = true;
      return CreateOrderService.createOrder(order).$promise
        .then(function (order) {
          vm.isSaving = false;
          $state.go('cargo.listAcceptedOrders');
          Cargo77Toast.successToast('El flete ' + order.orderNumber + ' se ha creado con éxito.');
        })
        .catch(function (error) {
          vm.isSaving = false;
          if(!error || error && !error.data || error && error.data && !error.data.error) {
            Cargo77Toast.errorToast('Ha ocurrido un error al crear la orden');
          }
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function saveOrder() {
      var newOrder = {};

      newOrder.details = vm.order.details || '';

      if(vm.order.cargoCompany) {
        newOrder.shipperCompanyId = vm.order.cargoCompany.id;
      }

      if(vm.order.extraFields) {
        newOrder.extraFields = vm.order.extraFields;
      }

      if (vm.order.id) {
        newOrder.id = vm.order.id;
      }

      newOrder.route = vm.order.route;

      if(vm.order.carrierCompany) {
        newOrder.secondaryCarrierCompanyId = vm.order.carrierCompany.id;
      }

      if (vm.order.duplicatesAmount) {
        for (var i = 0; i < vm.order.duplicatesAmount; i++) {
          newOrder.duplicatesDetails = i + 1 + ' de ' + vm.order.duplicatesAmount;
          var duplicatedOrder = newOrder;
          vm.createOrder(duplicatedOrder);
        }
      } else {
        vm.createOrder(newOrder);
      }
    }

    function getCarrierCompanyId() {
      if (isParentCompany()) {
        return vm.userLoggedCompany.id;
      }
      return null;
    }

    function isParentCompany() {
      return !vm.userLoggedCompany.parentCompanyId;
    }

    function validateOrderShipper() {
      return angular.isDefined(vm.order.cargoCompany) && vm.order.cargoCompany !== null;
    }

    function validateOrderCarrier() {
      return angular.isDefined(vm.order.carrierCompany) && vm.order.carrierCompany !== null;
    }

    function validateOrderRoute() {
      var areSegmentsExtraFieldsValid = vm.order.route.segments && vm.order.route.segments.length > 0 && areValidExtraFieldsForAllSegments();
      var areDatesValid = areSegmentDatesValid(vm.order.route.segments);
      return areSegmentsExtraFieldsValid && areDatesValid;
    }

    function areSegmentDatesValid(segments) {
      var areDatesValid = true;
      segments.forEach(function(segment) {
        var formattedDate = new Date(segment.scheduledDate);
        var dateYear = formattedDate.getFullYear();
        if(dateYear < 1800) {
          areDatesValid = false;
        }
      });
      return areDatesValid;
    }

    function areValidExtraFieldsForAllSegments() {
      var areValidExtraFields = true;
      vm.order.route.segments.forEach(function(segment) {
        if (segment.areValidExtraFields === false) {
          areValidExtraFields = false;
        }
      });
      return areValidExtraFields;
    }

    function validateAllFields() {
      return vm.validateOrderShipper() && vm.areValidExtraFieldsForOrder && vm.validateOrderRoute();
    }

    function onRouteChange(segments) {
      vm.order.route.segments = segments;
    }

    function onExtraFieldChange(extraFields) {
      /*
      Si se ha eliminado todos los extrafields, entonces se debe eliminar del storage todos los arhivos
      que han sido previamente cargados
      */
      if (extraFields.length === 0) {
        vm.allExtraFieldsUploaded.forEach(function (element) {
          CreateOrderService.deleteFileFromStorage(element.fileContents);
        });
        vm.allExtraFieldsUploaded = [];
      } else {
        extraFields.forEach(function (element) {
          if (element.inputType === 'FILE') {
            //Verifica y añade un nuevo elemento a la lista auxiliar.
            if (!verifyIfTheFileExist(element)) {
              vm.allExtraFieldsUploaded.push(element);
            }
          }
        });
        if (vm.allExtraFieldsUploaded.length != extraFields.length) {
          vm.allExtraFieldsUploaded.forEach(function (element, index) {
            deleteOldExtraFields(extraFields, element, index);
          });
        }
        vm.order.extraFields = extraFields;
      }
    }

    function onSavingOrderFiles(saved, saving){
      if (saved === saving) {
        vm.allOrderFilesSaved = true;
      } else {
        vm.allOrderFilesSaved = false;
      }
    }

    function onSavingSegmentFiles(saved, saving){
      if (saved === saving) {
        vm.allSegmentFilesSaved = true;
      } else {
        vm.allSegmentFilesSaved = false;
      }
    }

    // Verifica si el elemento existe en la lista auxiliar.
    function verifyIfTheFileExist(extraField){
      var resp = false;
        vm.allExtraFieldsUploaded.forEach(function (element){
          if (element.definitionId === extraField.definitionId && element.fileContents === extraField.fileContents) {
            resp = true;
          }
        });
      return resp;
    }

    //Verifica si un elemento de la lista auxiliar se encuentra en la lista actual, caso contrario lo elimina
    function deleteOldExtraFields(newExtraFieldsList, oldExtraField, index){
      var resp = false;
      newExtraFieldsList.forEach(function (element) {
        if (element.definitionId === oldExtraField.definitionId && element.fileContents === oldExtraField.fileContents) {
          resp = true;
        }
      });
      if (!resp) {
        CreateOrderService.deleteFileFromStorage(oldExtraField.fileContents);
        vm.allExtraFieldsUploaded.splice(index, 1);
      }
    }

    function haveDetailsFullfilled() {
      return vm.areValidExtraFieldsForOrder;
    }

    function areValidExtraFieldsChange(areValidExtraFields) {
      vm.areValidExtraFieldsForOrder = areValidExtraFields;
    }

    function onInit() {
      vm.allOrderFilesSaved = true;
      vm.allSegmentFilesSaved = true;
      vm.allExtraFieldsUploaded = []; // Lista auxiliar que almacena los archivos cargados al storage
      vm.areValidExtraFieldsForOrder = true;
      initializeConstantVariables();
      if (angular.isDefined($stateParams.id)) {
        // TODO: check if edition is working.
        CreateOrderService.getAcceptedOrder($stateParams.id)
          .$promise
          .then(function (order) {
            vm.order = order;
            vm.canEdit = false;
            /* istanbul ignore else */
            vm.order.cargoCompany = order.shipper;
          });
      }
      var duplicates = _.find(vm.order.options, function (option) {
        return option.label === 'duplicates';
      });
      if (duplicates) {
        vm.order.needDuplicates = true;
        vm.order.duplicatesAmount = duplicates.amount;
      }
    }

    function initializeConstantVariables() {
      vm.canEdit = true;
    }

  }
}());

/**
 * Created by cristinapatino on 7/14/16.
 */

(function () {
  angular.module('Cargo77.orders').component('cargo77CarrierSendOffer', {
    templateUrl: 'app/components/orders/components/carrierSendOffer/carrier-send-offer.html',
    controller: CarrierSendOfferController,
  });

  /** @ngInject */
  function CarrierSendOfferController($stateParams, $state, Order, CreateOfferService,
                                      Cargo77Toast, OrdersCommonService, NavBarService) {
    var vm = this;

    vm.error = false;
    vm.sendOffer = sendOffer;
    vm.getRouteText = getRouteText;
    vm.isNotInProcessingPayment = isNotInProcessingPayment;
    vm.offer = {    };

    vm.$onInit = init;

    function init() {
      getOrder();
      if (isUpdate()) {
        vm.offer = CreateOfferService.getOffer($stateParams.offerId);
      }
    }

    function isUpdate() {
      return $stateParams.offerId;
    }

    function updateOrCreate() {
      if (isUpdate()) {
        return CreateOfferService.updateOffer(vm.offer);
      }
      return CreateOfferService.sendOffer(vm.offer);
    }

    function sendOffer() {
      updateOrCreate()
        .then(function () {
          $state.go('cargo.listOrders');
          Cargo77Toast.successToast('Oferta enviada con éxito.');
        })
        .catch(function () {
          Cargo77Toast.errorToast('Error al crear la oferta.');
        });
    }

    function getOrder() {
      Order.findById({
        id: $stateParams.id,
        filter: {
          include: [
            {
              relation: 'offers',
              scope: {
                fields: ['id', 'driverId', 'vehicleId', 'orderId', 'price'],
                include: [
                  {
                    relation: 'driver',
                    scope: {
                      fields: ['id', 'firstName', 'lastName', 'photo'],
                    },
                  },
                  {
                    relation: 'vehicle',
                    scope: {
                      fields: ['id', 'model', 'type', 'year', 'brand', 'photo'],
                    },
                  }],
                where: {
                  isAccepted: true,
                },
              },
            },
            {
              relation: 'cargoUser',
              scope: {
                include: {
                  relation: 'cargoCompany',
                  scope: {
                    fields: ['id', 'name'],
                  },
                },
                fields: ['id', 'firstName', 'lastName', 'phone', 'photo', 'email', 'cargoCompanyId'],
              },
            },
          ],
          fields: ['id', 'size', 'details', 'route', 'orderStatus', 'scheduledDate', 'size', 'cargoUserId', 'options'],
        },
      })
        .$promise
        .then(function (response) {
          vm.order = response;
          vm.offer.orderId = response.id;
          NavBarService.currentPageTitle = generateTitle();
        })
        .catch(function () {
          vm.error = true;
        });
    }

    function getRouteText (location) {
      return OrdersCommonService.getRouteTextForOrder(vm.order, location);
    }

    function generateTitle() {
      var title = '#' + vm.order.id + ' ';
      title += OrdersCommonService.getRouteTextForOrder(vm.order, 'pickup');
      title += ' a ' + OrdersCommonService.getRouteTextForOrder(vm.order, 'delivery');
      return title;
    }
    function isNotInProcessingPayment () {
      return vm.order.orderStatus !== 'PROCESSING_PAYMENT';
    }

  }
}());

/**
 * Created by Leonel Gonçalves on 7/6/16.
 */
(function () {
  angular.module('Cargo77.orders').component('cargo77CarrierOrderList',
    {
      templateUrl: 'app/components/orders/components/carrierOrderList/carrier-order-list.html',
      controller: CarrierOrderListController,
    });

  /** @ngInject */
  function CarrierOrderListController(CarrierOrderListService, Cargo77Dictionary, Cargo77Toast) {
    var vm = this;
    var filters = {
      searchText: '',
      and: [],
    };
    vm.updateStatusFilter = updateStatusFilter;
    vm.updateSearchText = updateSearchText;
    vm.updateDateFilter = updateDateFilter;
    vm.isInProcessingPaymentStatus = isInProcessingPaymentStatus;
    vm.orders = new CarrierOrderListService.OrdersList(filters);
    vm.offerStatus = Cargo77Dictionary.getOfferStatus();
    vm.updateLoadSizeFilter = updateLoadSizeFilter;

    function updateDateFilter(date) {
      if (angular.isDefined(date)) {
        filters['scheduledDate.date'] = {between: [date.min, date.max]};
      } else {
        delete filters['scheduledDate.date'];
      }
      updateOrders();
    }

    function updateOrders() {
      vm.orders.items = [];
      vm.isLoadingOrders = true;
      vm.orders.skip = 0;
      CarrierOrderListService.getSortedOrdersByScheduledDate(filters, vm.orders.skip, true)
        .then(function (response) {
          vm.orders.items = response;
          vm.orders.skip = 10;
          vm.isLoadingOrders = false;
        })
        .catch(function () {
          Cargo77Toast.errorToast('Ha ocurrido un error al consultar los fletes.');
        });
    }

    function updateStatusFilter(status) {
      filters.status = status;
      updateOrders();
    }

    function updateSearchText(searchText) {
      filters.searchText = searchText;
      updateOrders();
    }

    function isInProcessingPaymentStatus (order) {
      return order.orderStatus === 'PROCESSING_PAYMENT';
    }

    function updateLoadSizeFilter(size) {
      filters.loadSize = size;
      updateOrders();
    }

  }

}());

(function () {
  angular.module('Cargo77.orders').component('cargo77CarrierAcceptedOrderTrackingTab', {
    templateUrl: 'app/components/orders/components/carrierAcceptedOrderTrackingTab/carrier-accepted-order-tracking-tab.html',
    controller: CarrierOrderTrackingController,
    bindings: {
      'order':'<',
    },
  });

  /** @ngInject */
  function CarrierOrderTrackingController() {
    var vm = this;
    vm.error = false;
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77CarrierAcceptedOrderOverviewTab', {
    templateUrl: 'app/components/orders/components/carrierAcceptedOrderOverviewTab/carrier-accepted-order-overview-tab.html',
    controller: CarrierOrderOverviewController,
    bindings: {
      'order': '<',
    },
  });

  /** @ngInject */
  function CarrierOrderOverviewController(Profile, $state, NavBarService, OrdersCommonService, Cargo77Toast) {
    var vm = this;

    vm.error = false;
    vm.editOrder = editOrder;
    vm.getRouteText = getRouteText;
    vm.cancelOrder = cancelOrder;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    function onInit() {
      if(!vm.order || vm.order && !vm.order.id) {
        vm.error = true;
        return;
      }
      NavBarService.currentPageTitle = 'Detalles de la orden ' +  (vm.order.orderNumber || vm.order.id);
      vm.shouldHideUpdateStatusButton = vm.order.orderStatus === 'COMPLETED';
    }

    function onChanges(changes) {
      var orderWasNotDefined = !vm.order ||
        (changes.order && (!changes.order.previousValue || (changes.order.previousValue && !changes.order.previousValue.id)));
      var orderIsNowDefined = changes.order && changes.order.currentValue && changes.order.currentValue.id;
      if(orderWasNotDefined && orderIsNowDefined) {
        vm.order = changes.order.currentValue;
        vm.shouldHideUpdateStatusButton = vm.order.orderStatus === 'COMPLETED';
        NavBarService.currentPageTitle = 'Detalles de la orden ' +  (vm.order.orderNumber || vm.order.id);
      }
    }

    function editOrder() {
      $state.go('cargo.editAcceptedOrder', {id: vm.order.id});
    }

    function getRouteText(location) {
      return OrdersCommonService.getRouteTextForOrder(vm.order, location);
    }
    function cancelOrder(){
      // TODO check for order.cancel function existence. Previous implemetation was: Order.cancel({id: vm.order.id})
      vm.order.cancel()
        .$promise
        .then(function () {
          $state.go('cargo.listAcceptedOrders');
          Cargo77Toast.successToast('Tu orden ha sido cancelada.');
        }).catch(function (error) {
        Cargo77Toast.errorToast(null, error.data.error);
      });
    }
  }
}());

/**
 * Created by Leonel Gonçalves on 7/6/16.
 */
(function () {
  angular.module('Cargo77.orders').component('cargo77CarrierAcceptedOrderList',
    {
      templateUrl: 'app/components/orders/components/carrierAcceptedOrderList/carrier-accepted-order-list.html',
      controller: CarrierAcceptedOrderListController,
    });

  /** @ngInject */
  function CarrierAcceptedOrderListController(Profile, CarrierAcceptedOrderListService, Cargo77Dictionary, Cargo77Toast,
                                              LocationsHelper, SearchBarService) {
    var vm = this;
    var filters = {
      searchText: '',
    };

    vm.initialSearchText = '';
    vm.$onInit = onInit;
    vm.status = Cargo77Dictionary.getOrderStatus();
    vm.getFormattedStringTime = LocationsHelper.getFormattedStringTime;
    vm.getOrderScheduledDate = getOrderScheduledDate;
    vm.getStatusForOrder = getStatusForOrder;
    vm.updateStatusFilter = updateStatusFilter;
    vm.updateDateFilter = updateDateFilter;
    vm.updateSearchText = updateSearchText;
    vm.updateDriverCarrierOrderFilter = updateDriverCarrierOrderFilter;
    vm.hideFabMenuIfDriverOrChildCarrier = hideFabMenuIfDriverOrChildCarrier;
    vm.getStopoverType = getStopoverType;
    vm.getEncodedURI = getEncodedURI;
    vm.orders = new CarrierAcceptedOrderListService.OrdersList(filters);

    vm.currentCompanyId = Profile.getCargoCompanyId();

    function onInit() {
      vm.initialSearchText = SearchBarService.getSearchText();
      updateSearchText(vm.initialSearchText);
    }

    function updateOrders() {
      vm.orders.items = [];
      vm.isLoadingOrders = true;
      vm.orders.skip = 0;
      CarrierAcceptedOrderListService.getSortedOrdersByScheduledDate(filters, vm.orders.skip, true)
        .then(function (response) {
          vm.orders.items = response.orders;
          vm.orders.skip = 10;
          vm.isLoadingOrders = false;
        })
        .catch(function () {
          Cargo77Toast.errorToast('Ha ocurrido un error al consultar los fletes.');
        });
    }

    function updateStatusFilter(status) {
      filters.orderStatus = status;
      updateOrders();
    }

    function updateSearchText(searchText) {
      filters.searchText = searchText;
      SearchBarService.setSearchText(searchText);
      updateOrders();
    }

    function updateDateFilter(date) {
      if (angular.isDefined(date)) {
        filters.scheduledDate = {between: [date.min, date.max]};
      } else {
        delete filters.scheduledDate;
      }

      updateOrders();
    }

    function getOrderScheduledDate(label) {
      return Cargo77Dictionary.getTitleForObjectLabel('times', label).title;
    }

    function getStatusForOrder(status) {
      return Cargo77Dictionary.getTitleForObjectLabel('status', status.toUpperCase());
    }

    function getStopoverType(stopoverType) {
      return Cargo77Dictionary.getTitleForObjectLabel('arrivalDepartureLabels', stopoverType.toUpperCase());
    }

    function hideFabMenuIfDriverOrChildCarrier () {
      return Profile.getUserPrimaryRole() === 'DRIVER' || Profile.getParentCompanyId() !== '';
    }

    function updateDriverCarrierOrderFilter (showOwnOrdersValue) {
      filters.driverId = undefined;

      if(showOwnOrdersValue) {
        filters.driverId = Profile.getCurrentUser().id;
      }

      updateOrders();
    }
    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }

}());

(function () {
  angular.module('Cargo77.orders').component('cargo77CarrierOrderInformationTab', {
    templateUrl: 'app/components/orders/components/carrierAcceptedOrderInformationTab/carrier-accepted-order-information-tab.html',
    controller: CarrierOrderInformationController,
    bindings: {
      'order': '<',
    },
  });

  /** @ngInject */
  function CarrierOrderInformationController(Profile, Order, Cargo77Toast, $state) {
    var vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.onOrderExtraFieldChange = onOrderExtraFieldChange;
    vm.areValidExtraFieldsChange = areValidExtraFieldsChange;
    vm.saveOrderChanges = saveOrderChanges;
    vm.changeSegmentMainDetail = changeSegmentMainDetail;
    vm.segmentDetailChange = segmentDetailChange;
    vm.isCarrierViewer = isCarrierViewer;
    vm.isShipperViewer = isShipperViewer;
    vm.onSavingOrderFiles = onSavingOrderFiles;
    vm.onSavingSegmentFiles = onSavingSegmentFiles;

    //TODO test onChanges function branches and validations functions

    function areExtraFieldsValid(extraFields) {
      var areExtraFieldsValid = true;
      var mandatoryExtraFields = _.filter(extraFields, function(extraField) {
        return extraField.isRequired === true;
      }) || [];

      mandatoryExtraFields.forEach(function(mandatoryExtraField) {
        if(mandatoryExtraField.inputType !== 'FILE' && !mandatoryExtraField.value) {
          areExtraFieldsValid = false;
        }
        if(mandatoryExtraField.inputType === 'FILE' && !mandatoryExtraField.value && !mandatoryExtraField.fileContents) {
          areExtraFieldsValid = false;
        }
      });
      return areExtraFieldsValid;
    }

    function areValidExtraFieldsChange(areValidExtraFields) {
      vm.areValidExtraFieldsForOrder = areValidExtraFields;
    }

    function onSavingOrderFiles(saved, saving){
      if (saved === saving) {
        vm.allOrderFilesSaved = true;
      } else {
        vm.allOrderFilesSaved = false;
      }
    }

    function onSavingSegmentFiles(saved, saving){
      if (saved === saving) {
        vm.allSegmentFilesSaved = true;
      } else {
        vm.allSegmentFilesSaved = false;
      }
    }

    function onChanges(changes) {
      var orderWasNotDefined = !vm.order ||
        (changes.order && (!changes.order.previousValue || (changes.order.previousValue && !changes.order.previousValue.id)));
      var orderIsNowDefined = changes.order && changes.order.currentValue && changes.order.currentValue.id;
      if(orderWasNotDefined && orderIsNowDefined) {
        vm.order = changes.order.currentValue;
        vm.orderCopy = angular.copy(vm.order);
        vm.carrierCompanyId = vm.orderCopy.mainCarrierCompanyId;
      }
    }

    function segmentDetailChange(segmentExtraFieldsChange) {
      var orderSegment = vm.order.route.segments[segmentExtraFieldsChange.segmentIndex];
      orderSegment.extraFields = segmentExtraFieldsChange.extraFields;
      processExtraFieldsFiles(orderSegment.extraFields);

    }

    function onOrderExtraFieldChange(extraFields) {
      vm.order.extraFields = extraFields;
      processExtraFieldsFiles(vm.order.extraFields);
    }

    function processExtraFieldsFiles(extraFields) {
      extraFields.forEach(function(extraField) {
        if(extraField.inputType !== 'FILE') {
          return;
        }
        if(extraField.fileContents && isFileAlreadyStoraged(extraField.fileContents)) {
          extraField.value = extraField.fileContents;
          delete extraField.fileContents;
        }
      });
    }

    function onInit() {
      vm.allOrderFilesSaved = true;
      vm.allSegmentFilesSaved = true;
      vm.orderCopy = angular.copy(vm.order);
      vm.carrierCompanyId = (angular.isDefined(vm.orderCopy) && vm.orderCopy !== null) ? vm.orderCopy.mainCarrierCompanyId : '';
      vm.validationError = '';
      vm.shouldDisableButton = false;
      vm.isSaving = false;
    }

    function saveOrderChanges() {
      var segmentsExtraFields = getAllSegmentsExtraFields(vm.order.route.segments);
      var areSegmentExtraFieldsValid = areExtraFieldsValid(segmentsExtraFields);
      var areOrderExtraFieldsValid = areExtraFieldsValid(vm.order.extraFields);
      vm.validationError = '';
      if(!areSegmentExtraFieldsValid) {
        vm.validationError = 'Los campos extra obligatorios de los segmentos no han sido completados';
        return;
      }
      if(!areOrderExtraFieldsValid) {
        vm.validationError = 'Los campos extra obligatorios de la orden no han sido completados';
        return;
      }
      vm.isSaving = true;
      var orderToUpdate = {
        id: vm.order.id,
        details: vm.order.details,
        extraFields: vm.order.extraFields,
        route: vm.order.route,
      };
      vm.shouldDisableButton = true;

      Order.prototype$updateAttributes(orderToUpdate).$promise
        .then(function(){
          $state.reload();
          vm.shouldDisableButton = false;
          Cargo77Toast.successToast('La orden se ha editado con exito.');
          vm.isSaving = false;
        })
        .catch(function(error) {
          vm.shouldDisableButton = false;
          if(!error || error && !error.data || error && error.data && !error.data.error) {
            Cargo77Toast.errorToast('Ha ocurrido un error al editar la orden. Por favor, intente de nuevo.');
            vm.isSaving = false;
            return;
          }
          vm.isSaving = false;
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function getAllSegmentsExtraFields(segments) {
      var extraFields = [];
      segments.forEach(function(segment) {
        extraFields = extraFields.concat(segment.extraFields);
      });
      return extraFields;
    }

    function changeSegmentMainDetail(segments) {
      segments.forEach(function(editedSegment,index) {
        vm.order.route.segments[index].cargoDetails = editedSegment.cargoDetails;
        vm.order.route.segments[index].scheduledDate = editedSegment.scheduledDate;
      });
    }

    function isFileAlreadyStoraged(fieldValue) {
      return fieldValue.indexOf('https:') > -1;
    }

    function isCarrierViewer() {
      return Profile.getUserPrimaryRole() === 'CARRIER_VIEWER';
    }

    function isShipperViewer() {
      return Profile.getUserPrimaryRole() === 'SHIPPER_VIEWER';
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77CarrierAcceptedOrderDetails', {
    templateUrl: 'app/components/orders/components/carrierAcceptedOrderDetails/carrier-accepted-order-details.html',
    controller: CarrierOrderDetailsController,
    controllerAs: 'carrierOrderDetails',
  });
  /** @ngInject */
  function CarrierOrderDetailsController(Order, $stateParams) {
    var vm = this;
    vm.order = null;
    vm.$onInit = onInit;
    vm.updateOrder = updateOrder;

    function onInit() {
      var activeTab = $stateParams.tab;
      getOrder();
      vm.activeTab = 0;
      if(activeTab) {
        vm.activeTab = activeTab;
      }
    }

    function getOrder() {
      Order.findWithSegmentsResources({
        filter: {
          include: [
            {
              relation: 'offers',
              scope: {
                fields: ['id', 'orderId', 'price'],
                where: {
                  isAccepted: true,
                },
              },
            },
            {
              relation: 'assignmentHistory',
            },
            {

              relation: 'stopoverHistory',
              scope: {
                include: {
                  relation: 'stopoverLocation',
                  scope: {
                    fields: ['id', 'name'],
                  },
                },
              },
            },
            {
              relation: 'shipperCompany',
              scope: {
                fields: ['id', 'name', 'email', 'phone', 'address', 'photoURL'],
              },
            },
            {
              relation: 'ownerCompany',
              scope: {
                fields: ['id', 'name', 'extraFields'],
              },
            },
            {
              relation: 'mainCarrierCompany',
              scope: {
                fields: ['id', 'name'],

              },
            },
            {
              relation: 'secondaryCarrierCompany',
              scope: {
                fields: ['id', 'name'],
              },
            },
          ],
          where: {'id': $stateParams.id},
        },
        includeResourcesImages: true,
      })
      .$promise
      .then(function (response) {
        vm.order = response[0];
      });
    }

    function updateOrder() {
      getOrder();
    }
  }
}());

(function () {
  angular.module('Cargo77.orders').component('cargo77CarrierAcceptedOrderAssignationTab', {
    templateUrl: 'app/components/orders/components/carrierAcceptedOrderAssignationTab/carrier-accepted-order-assignation-tab.html',
    controller: CarrierOrderAssignationController,
    bindings: {
      companySelected: '<',
      segments: '<',
      order: '<',
    },
  });

  /** @ngInject */
  function CarrierOrderAssignationController(Cargo77Dictionary, CompaniesService, Profile) {
    var vm = this;
    vm.assignmentTypes = Cargo77Dictionary.assignmentTypes;
    vm.assignmentTypeSelected = vm.assignmentTypes[0].value;
    vm.driversInfo = [];
    vm.vehiclesInfo = [];
    vm.trailersInfo = [];
    vm.segmentsWithoutInfo = {
      drivers: [],
      vehicles: [],
      trailers: [],
    };
    vm.isCarrierViewer = isCarrierViewer;

    vm.$onChanges = onChanges;

    function onChanges(changes) {
      var orderWasNotDefined = !vm.order ||
        (changes.order && (!changes.order.previousValue || (changes.order.previousValue && !changes.order.previousValue.id)));
      var orderIsNowDefined = changes.order && changes.order.currentValue && changes.order.currentValue.id;
      if(orderWasNotDefined && orderIsNowDefined) {
        vm.order = changes.order.currentValue;
        assignCompany();
      }

      if (changes.companySelected && changes.companySelected.currentValue) {
        getCompanyInfo(changes.companySelected.currentValue);
      }
      if (changes.segments && changes.segments.currentValue) {
        processInfo();
      }
    }

    function getCompanyInfo(companyId) {
      CompaniesService.getCompany(companyId).$promise.then(function(response) {
        vm.company = response;
      });
    }

    function processInfo() {
      vm.segments.forEach(function(segment, index) {
        var segmentName = segment.description;
        addDriverInfo(segment.currentAssignedDriverInstance, segmentName, index);
        addVehicleInfo(segment.currentAssignedVehicleInstance, segmentName, index);
        addTrailerInfo(segment.currentAssignedTrailerInstance, segmentName, index);
      });
    }

    function addDriverInfo(driver, segmentName, segmentNumber) {
      if (driver === undefined)  {
        vm.segmentsWithoutInfo.drivers.push({name: segmentName});
        return;
      }
      var index = getIndex(driver.id, vm.driversInfo);
      if (index === -1) {
        vm.driversInfo.push({
          segment: segmentNumber, id: driver.id, name: driver.firstName + ' ' + driver.lastName, photoURL: driver.photoURL, phone: driver.phone,
          segments: [{
            name: segmentName,
          }],
        });
        return;
      }
      vm.driversInfo[index].segments.push({name: segmentName});
    }

    function addVehicleInfo(vehicle, segmentName, segmentNumber) {
      if (vehicle === undefined) {
        vm.segmentsWithoutInfo.vehicles.push({name: segmentName});
        return;
      }
      var index = getIndex(vehicle.id, vm.vehiclesInfo);
      if (index === -1) {
        vm.vehiclesInfo.push({
          segment: segmentNumber, id: vehicle.id, name: vehicle.plate, brand: vehicle.brand, year: vehicle.year, photoURL: vehicle.photoURL,
          segments: [{
            name: segmentName,
          }],
        });
        return;
      }
      vm.vehiclesInfo[index].segments.push({name: segmentName});
    }

    function assignCompany() {
      vm.company = vm.order && vm.order.secondaryCarrierCompany ? vm.order.secondaryCarrierCompany : vm.order.mainCarrierCompany;
    }

    function addTrailerInfo(trailer, segmentName, segmentNumber) {
      if (trailer === undefined) {
        vm.segmentsWithoutInfo.trailers.push({name: segmentName});
        return;
      }
      var index = getIndex(trailer.id, vm.trailersInfo);
      if (index === -1) {
        vm.trailersInfo.push({
          segment: segmentNumber, id: trailer.id, name: trailer.name, photoURL: trailer.photoURL, trailerType: trailer.type,
          segments: [{
            name: segmentName,
          }],
        });
        return;
      }
      vm.trailersInfo[index].segments.push({name: segmentName});
    }

    function getIndex(id, array) {
      return array.findIndex(function(option) {
        return option.id.toString() ===  id.toString();
      });
    }

    function isCarrierViewer() {
      return Profile.getUserPrimaryRole() === 'CARRIER_VIEWER';
    }
  }
}());

/**
 * Created by Leonel Gonçalves on 7/6/16.
 */
(function () {
  angular.module('Cargo77.orders').component('cargo77AdminOrderList',
    {
      templateUrl: 'app/components/orders/components/adminListOrders/admin-order-list.html',
      controller: AdminOrderListController,
    });

  /** @ngInject */
  function AdminOrderListController(AdminOrderListService, Cargo77Dictionary, Cargo77Toast, LocationsHelper) {
    var vm = this;
    var filters = {
      searchText: '',
    };

    vm.$onInit = onInit;
    vm.status = Cargo77Dictionary.getOrderStatus();
    vm.getFormattedStringTime = LocationsHelper.getFormattedStringTime;
    vm.getOrderScheduledDate = getOrderScheduledDate;
    vm.getStatusForOrder = getStatusForOrder;
    vm.updateStatusFilter = updateStatusFilter;
    vm.updateDateFilter = updateDateFilter;
    vm.updateSearchText = updateSearchText;
    vm.getStopoverType = getStopoverType;
    vm.getEncodedURI = getEncodedURI;

    vm.orders = new AdminOrderListService.OrdersList(filters);

    function onInit(){
      updateOrders();
    }

    function updateOrders() {
      vm.orders.items = [];
      vm.isLoadingOrders = true;
      vm.orders.skip = 0;
      AdminOrderListService.getSortedOrdersByScheduledDate(filters, vm.orders.skip, true)
        .then(function (response) {
          vm.orders.items = response.orders;
          vm.orders.skip = 10;
          vm.isLoadingOrders = false;
        })
        .catch(function () {
          Cargo77Toast.errorToast('Ha ocurrido un error al consultar los fletes.');
        });
    }

    function updateStatusFilter(status) {
      filters.orderStatus = status;
      updateOrders();
    }

    function updateSearchText(searchText) {
      filters.searchText = searchText;
      updateOrders();
    }

    function updateDateFilter(date) {
      if (angular.isDefined(date)) {
        filters.scheduledDate = {between: [date.min, date.max]};
      } else {
        delete filters.scheduledDate;
      }
      updateOrders();
    }

    function getOrderScheduledDate(label) {
      return Cargo77Dictionary.getTitleForObjectLabel('times', label).title;
    }

    function getStatusForOrder(status) {
      return Cargo77Dictionary.getTitleForObjectLabel('status', status.toUpperCase());
    }

    function getStopoverType(stopoverType) {
      return Cargo77Dictionary.getTitleForObjectLabel('arrivalDepartureLabels', stopoverType.toUpperCase());
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }
  }

}());

(function () {
  angular.module('Cargo77.payments').component('cargo77PaymentsList', {
    templateUrl: 'app/components/payments/components/paymentList/payments-list.html',
    controller: PaymentsListController,
  });

  /** @ngInject */
  function PaymentsListController(Cargo77Dictionary, PaymentsService, Cargo77Toast) {
    var vm = this;
    var filters = {
      searchText: '',
    };
    filters.and = [];

    vm.updateStatusFilter = updateStatusFilter;
    vm.updateSearchText = updateSearchText;

    vm.orders = new PaymentsService.OrdersList(filters);
    vm.orderPaymentStatus = Cargo77Dictionary.getOrderPaymentStatus();
    vm.acceptPayment = acceptPayment;
    vm.rejectPayment = rejectPayment;
    vm.setToVerifyingStatus = setToVerifyingStatus;

    function setToVerifyingStatus(orderId) {
      PaymentsService.setToVerifyingStatus(orderId)
        .then(function () {
          Cargo77Toast.successToast('El pago ha sido cambiado al estado por verificar.');
          updateOrders();
        })
        .catch(function (response) {
          Cargo77Toast.errorToast(null, response.data.error);
        });
    }

    function acceptPayment(orderId) {
      PaymentsService.acceptPayment(orderId)
        .then(function () {
          Cargo77Toast.successToast('El pago ha sido aceptado.');
          updateOrders();
        })
        .catch(function (response) {
          Cargo77Toast.errorToast(null, response.data.error);
        });
    }

    function rejectPayment (orderId) {
      PaymentsService.rejectPayment(orderId)
        .then(function () {
          Cargo77Toast.successToast('El pago ha sido rechazado.');
          updateOrders();
        })
        .catch(function (response) {
          Cargo77Toast.errorToast(null, response.data.error);
        });
    }

    function updateOrders() {
      vm.orders.items = [];
      vm.isLoadingOrders = true;
      vm.orders.skip = 0;
      PaymentsService.getSortedOrdersByScheduledDate(filters, vm.orders.skip, true)
        .then(function (response) {
          vm.orders.items = response;
          vm.orders.skip = 10;
          vm.isLoadingOrders = false;
        })
        .catch(function () {
          Cargo77Toast.errorToast('Ha ocurrido un error al consultar los fletes.');
        });
    }

    function updateStatusFilter(status) {
      filters.status = status;
      updateOrders();
    }

    function updateSearchText(searchText) {
      filters.searchText = searchText;
      updateOrders();
    }
  }
}());

(function () {
  angular.module('Cargo77.notificationInbox').component('cargo77NotificationInboxList', {
    templateUrl: 'app/components/notification-inbox/components/notificationInboxList/notification-inbox-list.html',
    controller: NotificationInboxListController,
  });

  /** @ngInject */
  function NotificationInboxListController(NotificationsService) {
    var vm = this;

    vm.updateSearchText = updateSearchText;
    vm.searchNotification = searchNotification;
    vm.markAsRead = markAsRead;
    vm.$onInit = onInit;
    vm.loadMoreNotifications = loadMoreNotifications;

    function onInit(){
      vm.skip = 20;
      vm.loadMore = true;
      vm.isFiltering = false;
      vm.loadMoreResults = false;
      NotificationsService.markAllRead();
    }

    function loadMoreNotifications(notifications, size){
      if (notifications.length > vm.skip) {
        vm.skip = vm.skip + 20;
        if (vm.isFiltering) {
          vm.loadMore = false;
          if (size > vm.skip) {
            vm.loadMoreResults = true;
          } else {
            vm.loadMoreResults = false;
          }
        } else {
          vm.loadMore = true;
        }
      } else {
        vm.loadMore = false;
        vm.loadMoreResults = false;
      }
    }

    function updateSearchText(searchText) {
      vm.searchText = searchText;
      vm.skip = 20;
      if (vm.searchText.length === 0) {
        vm.isFiltering = false;
        vm.loadMore = true;
      } else {
        vm.loadMoreResults = true;
        vm.loadMore = false;
        vm.isFiltering = true;
      }
    }

    function searchNotification(notification) {
      if (!vm.searchText ||
        (String(notification.extraFieldFileName).toLowerCase().indexOf(vm.searchText.toLowerCase()) != -1) ||
        (String(notification.orderNumber).toLowerCase().indexOf(vm.searchText.toLowerCase()) != -1)) {
        return true;
      }
      return false;
    }

    function markAsRead(notification) {
      NotificationsService.markAsRead(notification);
    }

    Object.defineProperty(vm, 'user', {
      get: function () {
        return NotificationsService.user;
      },
    });

    Object.defineProperty(vm, 'notifications', {
      get: function () {
        return NotificationsService.notifications;
      },
    });

  }
}());

(function () {
  angular.module('Cargo77.locations').component('cargo77LocationsList', {
    templateUrl: 'app/components/locations/components/locationsList/locations-list.html',
    controller: LocationsListController,
  });

  /** @ngInject */
  function LocationsListController(LocationsListService) {
    var vm = this;
    vm.locations = LocationsListService.getLocations();
  }
}());

(function () {
  angular.module('Cargo77.locations').component('cargo77EditLocation', {
    templateUrl: 'app/components/locations/components/editLocation/edit-location.html',
    controller: EditLocationController,
  });

  /** @ngInject */
  function EditLocationController(LocationService, Cargo77Toast, $state, $stateParams) {
    var vm = this;

    vm.saveAction = saveLocation;
    vm.deleteAction = deleteLocation;
    vm.$onInit = onInit;

    function onInit() {
      LocationService.getLocation($stateParams.id).$promise
        .then(function(resp){
          vm.location = resp;
          vm.location.address = resp.address ? resp.address.address : '';
        })
        .catch(function(error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function deleteLocation(id) {
      LocationService.deleteLocation(id)
        .then(function(){
          $state.go('cargo.listLocations');
          Cargo77Toast.successToast('La ubicación ha sido eliminada con éxito.');
        })
        .catch(function(error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function saveLocation(location) {
      LocationService.updateLocation(location)
        .then(function () {
          $state.go('cargo.listLocations');
          Cargo77Toast.successToast('La ubicación ha sido modificado con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.locations').component('cargo77CreateLocation', {
    templateUrl: 'app/components/locations/components/create/create-location.html',
    controller: CreateLocationController,
  });

  /** @ngInject */
  function CreateLocationController(LocationService, Cargo77Toast, $state) {
    var vm = this;

    vm.saveLocation = saveLocation;
    function saveLocation(location) {
      LocationService.saveLocation(location)
        .then(function () {
          $state.go('cargo.listLocations');
          Cargo77Toast.successToast('La ubicación se ha grabado con exito');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.companies').service('ExtraFieldCompaniesService', ExtraFieldCompaniesService);

  /** @ngInject */
  function ExtraFieldCompaniesService(Cargo77Dictionary, CargoCompany, Order) {
    var self = this;

    self.sectionTypes = Cargo77Dictionary.orderExtraFields.sectionTypes;
    self.inputTypes = Cargo77Dictionary.orderExtraFields.inputTypes;
    self.optionalFields = Cargo77Dictionary.orderExtraFields.optionalFields;

    self.saveField = saveExtraFieldDefinition;
    self.getField = getExtraFieldDefinition;
    self.updateField = updateExtraFieldDefinition;
    self.deleteField = deleteExtraFieldDefinition;
    self.getAllFields = getAllExtraFieldsDefinitions;
    self.deleteFileFromStorage = deleteFileFromStorage;

    function saveExtraFieldDefinition(cargoCompanyId, field) {
      return CargoCompany.extraFieldsDefinitions.create({id: cargoCompanyId}, field).$promise;
    }

    function getExtraFieldDefinition(cargoCompanyId, fk) {
      return CargoCompany.extraFieldsDefinitions.findById({id: cargoCompanyId, fk: fk});
    }

    function updateExtraFieldDefinition(cargoCompanyId, fk, field) {
      return CargoCompany.extraFieldsDefinitions.updateById({id: cargoCompanyId, fk: fk}, field).$promise;
    }

    function deleteExtraFieldDefinition (cargoCompanyId, fk) {
      return CargoCompany.extraFieldsDefinitions.destroyById({id: cargoCompanyId, fk: fk}).$promise;
    }

    function getAllExtraFieldsDefinitions(cargoCompanyId, filter) {
      return CargoCompany.extraFieldsDefinitions({id: cargoCompanyId, filter: filter});
    }
    
    function deleteFileFromStorage(fileUrl){
      Order.deleteFiles({'fileUrl': fileUrl}).$promise;
    }

  }
}());

(function () {
  angular.module('Cargo77.companies').service('CompaniesService', CompaniesService);
  /** @ngInject */
  function CompaniesService(Cargo77Dictionary, CargoCompany, Profile) {
    var self = this;

    self.getCompany = getCompany;
    self.getCurrentCompany = getCurrentCompany;
    self.updateCompany = updateCompany;
    self.getAllCompanies = getAllCompanies;
    self.saveCompany = saveCompany;
    self.deleteCompany = deleteCompany;
    self.getChildCompanies = getChildCompanies;
    self.getChildCompany = getChildCompany;
    self.saveChildCompany = saveChildCompany;
    self.updateChildCompany = updateChildCompany;
    self.deleteChildCompany = deleteChildCompany;

    function deleteCompany (id) {
      return CargoCompany.destroyById({id: id}).$promise;
    }
    function getCurrentCompany() {
      return CargoCompany.findById({id: Profile.getCargoCompanyId()});
    }

    function getCompany(id) {
      return CargoCompany.findById({id: id});
    }

    function updateCompany(company) {
      return CargoCompany.prototype$updateAttributes(angular.copy(company)).$promise;
    }

    function saveCompany(company) {
      return CargoCompany.create(angular.copy(company)).$promise;
    }

    function getAllCompanies() {
      return CargoCompany.find(
        {filter: 
          {
            order:['name ASC'],
          },
        });
    }

    function getChildCompanies(parentId, where) {
      return CargoCompany.childCompanies({ id: parentId, filter: { where: where, order: ['name ASC']}});
    }

    function saveChildCompany(id, company){
      return CargoCompany.childCompanies.create({id: id},company).$promise;
    }

    function updateChildCompany(parentId, fk, company) {
      return CargoCompany.childCompanies.updateById({id: parentId, fk: fk}, company).$promise;
    }

    function getChildCompany(parentId, fk) {
      return CargoCompany.childCompanies.findById({id: parentId, fk: fk});
    }

    function deleteChildCompany(parentId, fk) {
      return CargoCompany.childCompanies.destroyById({id: parentId, fk: fk}).$promise;
    }

  }
}());

(function () {
  angular.module('Cargo77.companies').component('cargo77ListCompanies', {
    templateUrl: 'app/components/companies/components/listCompanies/list-companies.html',
    controller: ListCompaniesController,
    bindings: {
      typeFilter: '<',
    },
  });

  /** @ngInject */
  function ListCompaniesController(CompaniesService, Profile) {
    var vm = this;
    var companyTypeFilter = {};
    vm.$onInit = onInit;

    if(angular.isDefined(vm.typeFilter)){
      companyTypeFilter = {'type': vm.typeFilter};
    }

    vm.updateSearchText = updateSearchText;

    function onInit() {
      vm.companies = getCompanies();
    }

    function updateSearchText(searchText) {
      vm.searchText = searchText;
    }

    function getCompanies() {
      if(Profile.getUserRole().indexOf('CARGO_ADMIN') >= 0 ) {
        return CompaniesService.getAllCompanies(buildFilterQuery());
      }
      return CompaniesService.getChildCompanies(Profile.getCargoCompanyId(), companyTypeFilter);
    }

    function buildFilterQuery() {
      return {
        and: [
          {
            parentCompanyId: { exists: true },
            type: vm.typeFilter,
          },
        ],
      };
    }

  }
}());

(function () {
  angular.module('Cargo77.companies').component('cargo77EditFieldByCompany', {
    templateUrl: 'app/components/companies/components/editFieldByCompany/edit-field-by-company.html',
    controller: EditCompanyController,
  });

  /** @ngInject */
  function EditCompanyController(ExtraFieldCompaniesService, Profile, Cargo77Toast, $state, $stateParams) {
    var vm = this;
    vm.cargoCompanyId = Profile.getCargoCompanyId();
    vm.field = ExtraFieldCompaniesService.getField(vm.cargoCompanyId, $stateParams.id);

    vm.saveAction = saveField;
    vm.deleteAction = deleteAction;

    function saveField(field) {
      field.dropdownOptions.sort();
      ExtraFieldCompaniesService.updateField(vm.cargoCompanyId, $stateParams.id, field)
        .then(function () {
          $state.go('cargo.editCurrentCompany', {tab: 1});
          Cargo77Toast.successToast('El campo ha sido modificado con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function deleteAction() {
      ExtraFieldCompaniesService.deleteField(vm.cargoCompanyId, $stateParams.id)
        .then(function () {
          $state.go('cargo.editCurrentCompany', {tab: 1});
          Cargo77Toast.successToast('El campo ha sido eliminado con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.companies').component('cargo77EditCurrentCompany', {
    templateUrl: 'app/components/companies/components/editCurrentCompany/edit-current-company.html',
    controller: EditCurrentCompanyController,
  });

  /** @ngInject */
  function EditCurrentCompanyController($state, CompaniesService, Profile, Cargo77Toast, $stateParams) {
    var vm = this;

    vm.$onInit = onInit;
    vm.isParentCompany = isParentCompany;
    vm.isCarrierOwner = isCarrierOwner;
    vm.updateCompany = updateCompany;

    function onInit() {
      vm.activeTab = $stateParams.tab || 0;
      vm.company = CompaniesService.getCurrentCompany();
    }

    function isParentCompany() {
      return !vm.company.parentCompanyId;
    }

    function isCarrierOwner() {
      return Profile.getUserRole().indexOf('CARRIER_OWNER') > -1;
    }

    function updateCompany(company) {
      CompaniesService.updateCompany(company)
        .then(function () {
          $state.go('cargo.dashboard');
          Cargo77Toast.successToast('La información de la compañía ha sido actualizada.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.companies').component('cargo77EditCompany', {
    templateUrl: 'app/components/companies/components/editCompany/edit-company.html',
    controller: EditCompanyController,
  });

  /** @ngInject */
  function EditCompanyController(CompaniesService, Cargo77Toast, $state, $stateParams) {
    var vm = this;

    vm.saveAction = saveCompany;
    vm.company = CompaniesService.getCompany($stateParams.id);
    vm.deleteAction = deleteAction;

    function deleteAction(id) {
      CompaniesService.deleteCompany(id)
        .then(function () {
          $state.go('cargo.listCompanies');
          Cargo77Toast.successToast('La compañía ha sido eliminado con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
    function saveCompany(company) {
      CompaniesService.updateCompany(company)
        .then(function () {
          $state.go('cargo.listCompanies');
          Cargo77Toast.successToast('La compañía ha sido modificada con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

  }
}());

(function () {
  angular.module('Cargo77.companies').component('cargo77EditChildCompany', {
    templateUrl: 'app/components/companies/components/editChildCompany/edit-child-company.html',
    controller: EditChildCompanyController,
  });

  /** @ngInject */
  function EditChildCompanyController($state, $stateParams, CompaniesService, Cargo77Toast, Profile) {
    var vm = this;

    vm.$onInit = onInit;
    vm.updateCompany = updateCompany;
    vm.deleteCompany = deleteCompany;

    function onInit() {
      vm.company = getCompany($stateParams.id);
      vm.stateRedirect = 'cargo.shipperCompanies';
      vm.company.$promise.then(function (company) {
        if(company.type === 'CARRIER'){
          vm.stateRedirect = 'cargo.carrierCompanies';
        }
        setParentCompany(company.parentCompanyId);
      });
    }

    function updateCompany(company) {
      CompaniesService.updateChildCompany(company.parentCompanyId, $stateParams.id, company)
        .then(function () {
          $state.go(vm.stateRedirect);
          Cargo77Toast.successToast('La información de la compañía ha sido actualizada.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function deleteCompany(company) {
      CompaniesService.deleteChildCompany(company.parentCompanyId, company.id)
        .then(function () {
          $state.go(vm.stateRedirect);
          Cargo77Toast.successToast('La compañía ha sido eliminado con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function getCompany(id) {
      if(Profile.getUserRole().indexOf('CARGO_ADMIN') >= 0 ) {
        return CompaniesService.getCompany(id);
      }
      return CompaniesService.getChildCompany(Profile.getCargoCompanyId(), id);
    }

    function setParentCompany(id) {
      CompaniesService.getCompany(id).$promise.then(function(company){
        vm.parentCompany = company;
      })
      .catch(function(){
        vm.parentCompany = {};
      });
    }

  }
}());

(function () {
  angular.module('Cargo77.companies').component('cargo77CreateFieldByCompany', {
    templateUrl: 'app/components/companies/components/createFieldByCompany/create-field-by-company.html',
    controller: CreateCompanyController,
  });

  /** @ngInject */
  function CreateCompanyController(ExtraFieldCompaniesService, Profile, Cargo77Toast, $state) {
    var vm = this;
    vm.cargoCompanyId = Profile.getCargoCompanyId();

    vm.saveAction = saveField;

    function saveField(field) {
      field.dropdownOptions.sort();
      ExtraFieldCompaniesService.saveField(vm.cargoCompanyId, field)
        .then(function () {
          $state.go('cargo.editCurrentCompany', {tab: 1});
          Cargo77Toast.successToast('El campo ha sido creado con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.companies').component('cargo77CreateCompany', {
    templateUrl: 'app/components/companies/components/createCompany/create-company.html',
    controller: CreateCompanyController,
  });

  /** @ngInject */
  function CreateCompanyController(CompaniesService, Cargo77Toast, $state) {
    var vm = this;

    vm.saveAction = saveCompany;

    function saveCompany(company) {
      CompaniesService.saveCompany(company)
        .then(function () {
          $state.go('cargo.listCompanies');
          Cargo77Toast.successToast('La compañía ha sido creada con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
  }
}());

(function () {
  angular.module('Cargo77.companies').component('cargo77CreateChildCompany', {
    templateUrl: 'app/components/companies/components/createChildCompany/create-child-company.html',
    controller: CreateChildCompanyController,
    bindings: {
      type: '<',
    },
  });

  /** @ngInject */
  function CreateChildCompanyController(CompaniesService, Cargo77Toast, $state, Profile) {
    var vm = this;

    vm.saveAction = saveCompany;
    vm.$onInit = onInit;

    function onInit() {
      vm.parentCompanyId = Profile.getCargoCompanyId();
      vm.stateRedirect = 'cargo.shipperCompanies';
      if ($state.current.url.indexOf('createCarrier') >= 0){
        vm.stateRedirect = 'cargo.carrierCompanies';
      }
    }

    function saveCompany(company, parentCompanyId) {
      CompaniesService.saveChildCompany(parentCompanyId || vm.parentCompanyId, company)
        .then(function () {
          $state.go(vm.stateRedirect);
          Cargo77Toast.successToast('La compañía ha sido creada con éxito.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
  }
}());

/**
 * Created by Leonel Gonçalves on 7/5/16.
 */

(function () {
  angular.module('Common')
    .service('Cargo77Toast', Cargo77Toast);
  /** @ngInject */
  function Cargo77Toast($mdToast) {
    var self = this;

    var CONSTANTS = {
      SUCCESS: {
        COLOR: '#009688',
        ICON: 'check',
      },
      ERROR: {
        COLOR: '#FF1744',
        ICON: 'error',
      },
    };

    var ERRORS = {
      'INVALID_PROPERTY_VALUE': {message: 'La orden no puede cambiarse al estado seleccionado.'},
      'LOGIN_FAILED_EMAIL_NOT_VERIFIED': {message: 'Revisa tu correo electrónico. Tu cuenta no ha sido verificada.'},
      'INVALID_STATUS': {message: 'El usuario con el que deseas ingresar está deshabilitado.'},
      'LOGIN_FAILED': {message: 'El usuario o la contraseña son incorrectos.'},
      'MISSING_SCHEDULE_LABEL': {message: 'Necesita ingresar el tipo de la hora de la entrega.'},
      'MISSING_SCHEDULE_TIME': {message: 'Necesita ingresar la hora de la entrega.'},
      'MISSING_SCHEDULE_DATE': {message: 'Fecha de entrega inválida.'},
      'INVALID_SCHEDULE_LABEL': {message: 'INVALID_SCHEDULE_LABEL.'},
      'INVALID_ORDER_DATE': {message: 'Fecha de la orden inválida.'},
      'INVALID_LATLNG_COORDS': {message: 'Coordenadas inválidas.'},
      'USER_NOT_FOUND': {message: 'Usuario no encontrado.'},
      'AUTHORIZATION_REQUIRED': {message: 'No tienes permisos para realizar esta acción.'},
      'EMPTY_OPTIONS_ARRAY': {message: 'Las opciones no pueden estar vacáas.'},
      'INVALID_OPTION_VALUE': {message: 'La opción seleccionada no está permitida.'},
      'MISSING_PROPERTY_IN_OPTION': {message: 'MISSING_PROPERTY_IN_OPTION'},
      'MISSING_OPTION_LABEL': {message: 'MISSING_OPTION_LABEL'},
      'MISSING_REQUIRED_FIELD': {message: 'Ha ocurrido un error. Complete todos los campos requeridos.'},
      'INVALID_OPTION_LABEL': {message: 'INVALID_OPTION_LABEL'},
      'ORDER_NOT_FOUND': {message: 'Flete no encontrado'},
      'OFFER_NOT_FOUND': {message: 'Oferta no encontra'},
      'OBJECT_NOT_FOUND': {message: 'Usuario no encontrado.'},
      'INVALID_VEHICLE_TYPE': {message: 'Tipo de vehículo inválido'},
      'MISSING_ORDER_FIELD': {message: 'MISSING_ORDER_FIELD'},
      'MISSING_EXTERNALCLIENT_FIELD': {message: 'Es necesario que especifíques el cliente.'},
      'MISSING_OFFER_FIELD': {message: 'MISSING_OFFER_FIELD'},
      'MISSING_SIZE_LABEL': {message: 'MISSING_SIZE_LABEL'},
      'INVALID_SIZE_LABEL': {message: 'El tamaño no es válido.'},
      'VEHICLE_DEFAULT_VEHICLE_CONFLICT': {message: 'El arrastre seleccionado no pertenece a la compañía seleccionada.'},
      'UNKNOWN': {message: 'Ha ocurrido un error desconocido.'},
      'INVALID_USER_STATUS': {message: 'Tu usuario se encuentra deshabilitado.'},
      'INVALID_CURRENT_ORDER_STATUS': {message: 'La orden se encuentra en un estado inválido para realizar esta acción.'},
      'PERMISSION_DENIED': {message: 'Tu usuario no tiene los permisos necesarios.'},
      'EMAIL_NOT_FOUND': {message: 'El email ingresado no está registrado.'},
      'auth/wrong-password': {message: 'El usuario o la contraseña son incorrectos.'},
      'request entity too large': {message: 'Los archivos a subirse son muy pesados.'},
      'Invalid date': {message: 'La fecha seleccionada es inválida.'},
      'email already exists': {message: 'El email seleccionado ya existe.'},
    };

    var toastConfig = {
      templateUrl: 'app/components/common/services/cargo-toast/cargo-toast.html',
      bindToController: true,
      controller: /* istanbul ignore next */
        function () {
        },
      controllerAs: 'toast',
      position: 'bottom right',
    };

    self.successToast = successToast;
    self.errorToast = errorToast;
    self.defaultToast = defaultToast;

    function successToast(message) {
      var toast = angular.copy(toastConfig);
      toast.locals = {
        type: CONSTANTS.SUCCESS.COLOR,
        icon: CONSTANTS.SUCCESS.ICON,
        message: message,
      };
      return $mdToast.show(toast);
    }

    function buildErrorMessageForRelatedModelsConflict (relatedModels, toast) {
      var errorMessage = 'No se puede eliminar porque está relacionado con';
      var models = {
        'orders': 'fletes',
        'offers': 'ofertas',
        'users': 'usuarios',
        'vehicles': 'vehículos',
      };

      if (relatedModels) {
        for (var model in relatedModels) {
          errorMessage = errorMessage + ' ' + relatedModels[model] + ' ' + models[model] + ',';
        }
        errorMessage = errorMessage.substr(0, errorMessage.length - 1) + '.';
        toast.locals.message = errorMessage;
      }
    }

    function errorToast(message, error) {
      var toast = angular.copy(toastConfig);
      var errorConstant;

      toast.locals = {
        type: CONSTANTS.ERROR.COLOR,
        icon: CONSTANTS.ERROR.ICON,
      };

      if (angular.isDefined(error)) {
        var errorMessage = error.code ? error.code : error.message;
        errorConstant = ERRORS[errorMessage];

        if (!errorConstant && error.details) {
          buildErrorMessageForRelatedModelsConflict(error.details.relatedModels, toast);
        } else if (!errorConstant) {
          toast.locals.message = ERRORS.UNKNOWN.message;
        } else {
          toast.locals.message = errorConstant.message;
        }
      } else {
        toast.locals.message = message;
      }

      return $mdToast.show(toast);
    }

    function defaultToast(message, icon) {
      var toast = angular.copy(toastConfig);
      toast.locals = {
        type: '#2196F3',
        icon: icon,
        message: message,
      };
      return $mdToast.show(toast);
    }

  }
}());

(function () {
  angular
    .module("Common")
    .service("Cargo77ReportsService", Cargo77ReportsService);

  /** @ngInject */
  function Cargo77ReportsService(
    Cargo77Dictionary,
    CarrierAcceptedOrderListService,
    Vehicle,
    Order,
    CargoCompany,
    Profile
  ) {
    var self = this;
    self.groupAllSegments = groupAllSegments;
    self.groupSegmentsByDriver = groupSegmentsByDriver;
    self.groupSegmentsByDriverAndVehicles = groupSegmentsByDriverAndVehicles;
    self.groupSegmentsBelongsToLocations = groupSegmentsBelongsToLocations;
    self.groupTripsByDriverAndSegments = groupTripsByDriverAndSegments;
    self.calculateChartHeight = calculateChartHeight;
    self.getMonthName = getMonthName;
    self.getMonths = getMonths;
    self.getYears = getYears;
    self.getReportTypes = getReportTypes;
    self.getTimeFromMilliseconds = getTimeFromMilliseconds;
    self.findVehicles = findVehicles;
    self.getOrders = getOrders;
    self.findCompanyById = findCompanyById;
    self.datesFilter = datesFilter;
    self.getCategoriesAndSeriesForTripsReport =
      getCategoriesAndSeriesForTripsReport;
    self.getCategoriesAndSeriesForTimesReport =
      getCategoriesAndSeriesForTimesReport;

    // ORDERS
    function getOrders(filters) {
      if (!_.isEmpty(filters)) {
        return Order.findWithSegmentsResources({
          filter: {
            where: filters,
            include: [
              {
                relation: "mainCarrierCompany",
                scope: {
                  fields: ["id", "name"],
                },
              },
              {
                relation: "secondaryCarrierCompany",
                scope: {
                  fields: ["id", "name"],
                },
              },
              {
                relation: "shipperCompany",
                scope: {
                  fields: ["id", "name"],
                },
              },
            ],
          },
        }).$promise;
      }
    }

    // VEHICLES
    function findVehicles() {
      var filters = {};
      filters.and = [];
      filters.and.push({ isActive: true });

      return Vehicle.find({
        filter: {
          include: "ownerCompany",
          where: filters,
          order: ["plate ASC"],
        },
      }).$promise;
    }

    // COMPANY
    function findCompanyById(id) {
      return CargoCompany.findById({
        id: id,
        filter: {
          include: {
            relation: "childCompanies",
            scope: {
              fields: ["id", "name", "type"],
            },
          },
          fields: ["id", "name", "extraFields"],
        },
      }).$promise;
    }

    // REPORTE DE TIEMPO DE TRANSITO
    function groupSegmentsBelongsToLocations(
      orders,
      locationFrom,
      locationsTo
    ) {
      var allSegments = [];
      orders.forEach(function (order) {
        if (order.route) {
          var segments = order.route.segments;
          segments.forEach(function (element) {
            if (
              validateSegment(element, locationFrom, locationsTo) &&
              order.secondaryCarrierCompanyId
            ) {
              element.carrierCompany = order.secondaryCarrierCompany;
              allSegments.push(element);
            }
          });
        }
      });
      return allSegments;
    }

    function validateSegment(segment, locationFrom, locationsTo) {
      var segmentToLocationId = segment.toLocationId;
      var segmentFromLocationId = segment.fromLocationId;
      var relatedStatusObject = _.find(locationsTo, function (location) {
        return location.value === segmentToLocationId;
      });
      if (segmentFromLocationId == locationFrom.value && relatedStatusObject) {
        return true;
      }
      return false;
    }

    function groupSegmentsByDriver(allSegments, selectedCompany) {
      var showCompanyInCategories =
        showCompanyNameInCategories(selectedCompany);
      var auxList = [];
      auxList = _.groupBy(allSegments, function (element) {
        return element.currentAssignedDriverId;
      });

      var tripsGroupedByDriver = [];
      for (var key in auxList) {
        if (key != "undefined" && auxList.hasOwnProperty(key)) {
          const segments = auxList[key];
          if (segments[0].currentAssignedDriverInstance) {
            var carrierCompany = segments[0].carrierCompany.name;
            var driverName =
              segments[0].currentAssignedDriverInstance.firstName +
              " " +
              segments[0].currentAssignedDriverInstance.lastName;
            var driver = driverName.toUpperCase();
            if (showCompanyInCategories) {
              driver =
                driverName.toUpperCase() +
                '<br> <p style="font-size:10px;color: #B7B0B0;">' +
                carrierCompany +
                "</p>";
            }
            var driverItem = _.find(tripsGroupedByDriver, {
              carrierCompanyName: carrierCompany,
              category: driver,
              driverName: driverName,
            });
            if (angular.isDefined(driverItem)) {
              driverItem.trips = segments.length;
              driverItem.tripsDetails = segments;
            } else {
              driverItem = {
                carrierCompanyName: carrierCompany,
                category: driver,
                driverName: driverName,
                trips: "",
                tripsDetails: {},
              };
              driverItem.trips = segments.length;
              driverItem.tripsDetails = segments;
              tripsGroupedByDriver.push(driverItem);
            }
          }
        }
      }
      tripsGroupedByDriver = _.orderBy(
        tripsGroupedByDriver,
        ["trips"],
        ["desc"]
      );
      return tripsGroupedByDriver;
    }

    function groupTripsByDriverAndSegments(data) {
      var auxList = [];
      var tripsByDriverAndSegments = [];
      data.forEach(function (element) {
        var trips = element.tripsDetails;
        auxList = _.groupBy(trips, function (trip) {
          return trip.description;
        });
        var newElement = {
          carrierCompanyName: element.carrierCompanyName,
          category: element.category,
          driverName: element.driverName,
          segments: "",
        };
        newElement.segments = groupTripsPerSegment(auxList);
        tripsByDriverAndSegments.push(newElement);
      });
      return tripsByDriverAndSegments;
    }

    // Group trips per segments to each driver
    function groupTripsPerSegment(trips) {
      var tripsGroupedBySegment = [];
      for (var key in trips) {
        if (trips.hasOwnProperty(key)) {
          const element = trips[key];

          var totalTimesInSeconds = sumSegmentTimes(element);
          var timesInHours = Math.round(totalTimesInSeconds / 3600);
          var averageTimeInHours = Math.round(timesInHours / element.length);
          var milliseconds = totalTimesInSeconds * 1000;
          var timeDetails = getTimeFromMilliseconds(milliseconds);

          var segmentItem = _.find(tripsGroupedBySegment, {
            segment: element[0].description,
          });

          if (angular.isDefined(segmentItem)) {
            segmentItem.trips = element.length;
            segmentItem.tripsDetails = element;
            segmentItem.timeInHours = timesInHours;
            segmentItem.averageTime = averageTimeInHours;
            segmentItem.timeDetails = timeDetails;
          } else {
            segmentItem = { segment: element[0].description, trips: "" };
            segmentItem.trips = element.length;
            segmentItem.tripsDetails = element;
            segmentItem.timeInHours = timesInHours;
            segmentItem.averageTime = averageTimeInHours;
            segmentItem.timeDetails = timeDetails;
            tripsGroupedBySegment.push(segmentItem);
          }
        }
      }
      return tripsGroupedBySegment;
    }

    // REPORTE POR CONDUCTOR, UNIDAD Y % DE UTILIZACION DE FLOTA
    function groupAllSegments(filteredOrders, trips, vehicles) {
      var allSegments = [];
      filteredOrders.forEach(function (order) {
        if (order.route) {
          var segments = order.route.segments;
          segments.forEach(function (element) {
            if (order.secondaryCarrierCompanyId) {
              element.orderId = order.id;
              element.carrierCompany = order.secondaryCarrierCompany;
              allSegments.push(element);
            }
          });
        }
      });
      var totaltrips = trips.length;
      var totalVehicles = vehicles.length;
      var tripsPerDriver = Math.round((totaltrips / totalVehicles) * 100) / 100;
      return {
        segments: allSegments,
        trips: totaltrips,
        vehicles: totalVehicles,
        tripsPerDriver: tripsPerDriver,
      };
    }

    function groupSegmentsByDriverAndVehicles(data, companyFilter) {
      var allSegments = data.segments;
      var tripsPerDriver = data.tripsPerDriver;
      var showCompanyInCategories = showCompanyNameInCategories(companyFilter);
      var auxList = [];
      auxList = _.groupBy(allSegments, function (element) {
        return element.currentAssignedDriverId;
      });

      var tripsGroupedByDriver = [];
      for (var key in auxList) {
        if (key != "undefined" && auxList.hasOwnProperty(key)) {
          const segments = auxList[key];
          if (segments[0].currentAssignedDriverInstance) {
            var carrierCompany = segments[0].carrierCompany;
            var plate = segments[0].currentAssignedVehicleInstance
              ? segments[0].currentAssignedVehicleInstance.plate
              : "Sin asignar";
            var driver =
              segments[0].currentAssignedDriverInstance.firstName +
              " " +
              segments[0].currentAssignedDriverInstance.lastName;
            var driverAndPlate = driver + " (" + plate + ")";
            var driverItem = _.find(tripsGroupedByDriver, {
              carrierCompanyName: carrierCompany.name,
              driver: driver,
              vehicle: plate,
              monthlyTrips: tripsPerDriver,
            });

            // Group segments by order ID
            ordersList = _.groupBy(segments, function (element) {
              return element.orderId;
            });
            var totalTrips = 0;
            for (var key in ordersList) {
              if (key != "undefined" && ordersList.hasOwnProperty(key)) {
                totalTrips += 1;
              }
            }

            // Calculate percentage

            var percent = (tripsPerDriver * 100) / totalTrips;

            if (angular.isDefined(driverItem)) {
              driverItem.trips = totalTrips;
              driverItem.percentage = Math.round(percent * 100) / 100;
              driverItem.tripsDetails = segments;
            } else {
              driverItem = {
                carrierCompanyName: carrierCompany.name,
                driver: driver,
                vehicle: plate,
                category: "",
                monthlyTrips: tripsPerDriver,
                trips: 0,
                percentage: 0,
                tripsDetails: {},
              };
              driverItem.trips = totalTrips;
              driverItem.percentage = Math.round(percent * 100) / 100;
              driverItem.category =
                driverAndPlate.toUpperCase() +
                "<br> " +
                driverItem.percentage +
                " %";
              if (showCompanyInCategories) {
                driverItem.category =
                  driverAndPlate.toUpperCase() +
                  "<br> " +
                  // driverItem.percentage +
                  // " %" +
                  '<br> <p style="font-size:10px;color: #B7B0B0;">' +
                  carrierCompany.name +
                  "</p>";
              }
              driverItem.tripsDetails = segments;
              tripsGroupedByDriver.push(driverItem);
            }
          }
        }
      }
      tripsGroupedByDriver = _.orderBy(
        tripsGroupedByDriver,
        ["trips"],
        ["desc"]
      );
      return {
        tripsGroupedByDriver: tripsGroupedByDriver,
        totalTrips: data.trips,
        tripsPerDriver: tripsPerDriver,
        random: "value",
      };
    }

    // GRAPHICS CONFIG
    // Get chart height
    function calculateChartHeight(categories, series, selectedCompany) {
      if (_.isEmpty(categories) && _.isEmpty(series)) {
        return 150;
      }
      var height = 420; // min height
      if (_.isEmpty(selectedCompany)) {
        height = 550; // min height
      }
      var numOfCategories = categories.length;
      var numOfSeriesPerCategorie = series.length;
      if (numOfSeriesPerCategorie >= 3 && numOfCategories >= 4) {
        height = numOfCategories * 100;
      } else {
        if (numOfSeriesPerCategorie <= 2 && numOfCategories >= 4) {
          var newHeight = numOfCategories * 50;
          if (newHeight > height) {
            height = newHeight;
          }
        }
      }
      return height;
    }

    // MONTH NAME TO EXCEL FILE
    function getMonthName(monthValue) {
      var month;
      if (_.isEmpty(monthValue)) {
        month = "Ene - Dic";
      } else {
        var monthObject = Cargo77Dictionary.getMonthName(monthValue);
        month = monthObject.name.toUpperCase();
      }
      return month;
    }

    // Categories and Series for DRIVER REPORT
    function getCategoriesAndSeriesForTripsReport(data) {
      var allCategories = [];
      var allSeries = [];
      var seriesData = [];
      data.forEach(function (element) {
        allCategories.push(element.category);
        seriesData.push(element.trips);
      });
      if (seriesData.length > 0) {
        allSeries = [
          {
            name: "Viajes",
            data: seriesData,
          },
        ];
      }
      return {
        categories: allCategories,
        series: allSeries,
      };
    }

    function getCategoriesAndSeriesForTimesReport(reportData) {
      var allCategories = [];
      var seriesData = [];
      reportData.forEach(function (element) {
        var segments = element.segments;
        allCategories.push(element.category);
        segments.forEach(function (seg) {
          var exist = _.find(seriesData, function (serie) {
            return serie.name === seg.segment;
          });
          if (!exist) {
            seriesData.push({ name: seg.segment, data: [] });
          }
        });

        seriesData.forEach(function (serie) {
          var data = serie.data;
          var exist = _.find(segments, function (seg) {
            return seg.segment === serie.name;
          });
          if (exist) {
            data.push(exist.averageTime);
          } else {
            data.push(0);
          }
        });
      });
      return {
        categories: allCategories,
        series: seriesData,
      };
    }

    //CALCULATE TIMES
    // Sum Segment Times
    function sumSegmentTimes(segment) {
      var seconds = 0;
      segment.forEach(function (element) {
        seconds += element.times.trip;
      });
      return seconds;
    }

    // Get Days, Hours and minutes from milliseconds
    function getTimeFromMilliseconds(milliseconds) {
      var milliseconds = moment.duration(milliseconds);
      var h = milliseconds.hours();
      var m = milliseconds.minutes();
      var s = milliseconds.seconds();
      var days = milliseconds.days();
      var hours = h >= 0 && h <= 9 ? "0" + h : h;
      var minutes = m >= 0 && m <= 9 ? "0" + m : m;
      var seconds = s >= 0 && s <= 9 ? "0" + s : s;
      if (days > 0) {
        return days * 24 + h + ":" + minutes + ":" + seconds;
      }
      return hours + ":" + minutes + ":" + seconds;
    }

    // FILTERS PARAMETERS
    // Get months
    function getMonths() {
      return Cargo77Dictionary.getMonths();
    }

    // Get years
    function getYears() {
      var years = [];
      CarrierAcceptedOrderListService.getFirstOrderCreated().then(function (
        element
      ) {
        if (element.orders) {
          var date = element.orders[0].createdAt;
          var year = date.split("-")[0];
          var currentYear = new Date().getFullYear();
          do {
            years.push({
              value: currentYear,
            });
            currentYear--;
          } while (currentYear >= year);
        }
      });
      return years;
    }

    // Report types
    function getReportTypes() {
      return Cargo77Dictionary.getReportTypes();
    }

    // UTILS

    // Get Initiall and Final Dates
    // if timeLapse argument is given, yearFilter and monthFilter will be ignored
    function datesFilter(yearFilter, monthFilter, timeLapse) {
      var filters = [];
      var dateStart;
      var dateEnd;
      if (timeLapse && Object.values(timeLapse).length > 0) {
        filters.push({
          scheduledDate: {
            gte: moment(timeLapse.start).format("YYYY-MM-DD 00:00:00"),
          },
        });
        filters.push({
          scheduledDate: {
            lte: moment(timeLapse.end).format("YYYY-MM-DD 23:59:59"),
          },
        });
        filters.push({ orderStatus: "DELIVERED" });
        return filters;
      }
      if (!_.isEmpty(monthFilter) && !_.isEmpty(yearFilter)) {
        dateStart = new Date(yearFilter, monthFilter - 1, 1);
        filters.push({
          scheduledDate: {
            gte: moment(dateStart).format("YYYY-MM-DD 00:00:00"),
          },
        });
        dateEnd = new Date(yearFilter, monthFilter, 0);
        filters.push({
          scheduledDate: {
            lte: moment(dateEnd).format("YYYY-MM-DD 23:59:59"),
          },
        });
      }

      if (_.isEmpty(monthFilter) && !_.isEmpty(yearFilter)) {
        dateStart = new Date(yearFilter, 0, 1);
        filters.push({
          scheduledDate: {
            gte: moment(dateStart).format("YYYY-MM-DD 00:00:00"),
          },
        });
        dateEnd = new Date(yearFilter, 12, 0);
        filters.push({
          scheduledDate: {
            lte: moment(dateEnd).format("YYYY-MM-DD 23:59:59"),
          },
        });
      }
      filters.push({ orderStatus: "DELIVERED" });
      return filters;
    }

    function showCompanyNameInCategories(reportCompany) {
      if (_.isEmpty(reportCompany) || reportCompany === undefined) {
        return true;
      }
      return false;
    }
  } // End Cargo77ReportsService
})(); // End Function

(function () {
  angular.module('Common').service('Cargo77Dictionary', Cargo77Dictionary);

  function Cargo77Dictionary() {
    var self = this;
    self.getTitleForObjectLabel = getTitleForObjectLabel;
    self.getOrderStatus = getOrderStatus;
    self.getOfferStatus = getOfferStatus;
    self.getOrderPaymentStatus = getOrderPaymentStatus;
    self.getHourRangeLabel = getHourRangeLabel;
    self.getTimeObjectForHour = getTimeObjectForHour;
    self.getDataForExtraFields = getDataForExtraFields;
    self.getOrderExtraFieldsInputTypes = getOrderExtraFieldsInputTypes;
    self.getOrderStatusObject = getOrderStatusObject;
    self.getOrderArrivalDepartureStatuses = getOrderArrivalDepartureStatuses;
    self.getOrderArrivalDepartureLabels = getOrderArrivalDepartureLabels;
    self.getChangeableOrderStatus = getChangeableOrderStatus;
    self.getAvailableStatuses = getAvailableStatuses;
    self.getMonths = getMonths;
    self.getGraphicReportTypes = getGraphicReportTypes;
    self.getGraphicDataTypes = getGraphicDataTypes;
    self.getMonthName = getMonthName;
    self.getChartColors = getChartColors;

    var timePath = 'assets/images/time/';
    self.times = [
      {
        title: 'mañana',
        label: 'morning',
        min: '06:00',
        max: '12:00',
        image: timePath + 'ma-a@3x.png',
      },
      {
        title: 'tarde',
        label: 'afternoon',
        min: '12:00',
        max: '18:00',
        image: timePath + 'ta-a@3x.png',
      },
      {
        title: 'noche',
        label: 'evening',
        min: '18:00',
        max: '23:59',
        image: timePath + 'no-a@3x.png',
      },
      {
        title: 'hora específica',
        label: 'specificTime',
      },
    ];
    self.drawerTypes = [
      { title: 'cabezal', label: 'TRAILER_HEAD' },
      { title: 'cajón', label: 'STAKE_BODY' },
      { title: 'camioneta', label: 'PICKUP' },
      { title: 'frigorífico', label: 'REFRIGERATED' },
      { title: 'furgón', label: 'BOX' },
      { title: 'grúa', label: 'TOW' },
      { title: 'tanquero', label: 'TANK' },
      { title: 'van', label: 'VAN' },
      { title: 'volqueta', label: 'DUMP' },
      { title: 'otro', label: 'OTHER' },
    ];
    self.trailerTypes = [
      { title: 'chasis', label: 'CHASIS' },
      { title: 'plataforma', label: 'FLATBED' },
      { title: 'bañera', label: 'TUB' },
      { title: 'tanquero', label: 'TANK' },
      { title: 'container', label: 'CONTAINER' },
      { title: 'niñera', label: 'STORK' },
      { title: 'otro', label: 'OTHER' },
    ];
    self.assignmentTypes = [
      { label: 'Directa', value: 'DIRECT', disabled: false },
    ];

    self.statusDependencies = {
      'NEW': ['CANCELLED'],
      'ACTIVE': ['IN_TRANSIT', 'CANCELLED'],
      'IN_TRANSIT': ['ACTIVE', 'DELIVERED', 'CANCELLED'],
      'DELIVERED': ['CANCELLED'],
      'COMPLETED': ['CANCELLED'],
      'CANCELLED': ['ACTIVE'],
      'PROCESSING_PAYMENT': ['CANCELLED'],
      'REQUESTING_OFFERS': ['CANCELLED'],
    };

    self.chartsColors = {
      'TIMES': ['#58F927', '#F97D27', '#118FFB', '#F5F750', '#99978F', '#62E4BA'],
      'TRIPS': ['#5CC1F8'],
    };

    self.status = [
      { label: 'NEW', type: 'order', title: 'nueva', class: 'new-order' },
      { label: 'IN_TRANSIT', type: 'order', title: 'en tránsito', class: 'in-transit', changeable: true },
      { label: 'ACTIVE', type: 'order', title: 'flete activo', class: 'active', changeable: true },
      { label: 'DELIVERED', type: 'order', title: 'entregado', class: 'delivered', changeable: true },
      { label: 'CANCELLED', type: 'order', title: 'cancelada', class: 'cancelled', changeable: true },
      { label: 'REQUESTING_OFFERS', type: 'order', title: 'solicitando ofertas', class: 'requesting-offers' },
      { label: 'PROCESSING_PAYMENT', type: 'order', title: 'procesando pago', class: 'processing-payment' },
      { label: 'WAITING_PROVIDER_ACCEPTANCE', type: 'order', title: 'esperando proveedor', class: 'waiting-provider' },
      { label: 'REQUESTING_PROVIDER', type: 'order', title: 'solicitando proveedor', class: 'requesting-provider' },
      { label: 'COMPLETED', type: 'order', title: 'completada', class: 'completed' },
      { label: 'EXPIRED', type: 'order', title: 'caducada', class: 'expired' },
      { label: 'CREATED_BY_SHIPPER', title: 'Creado por solicitante' },
      { label: 'CREATED_BY_CARRIER', title: 'Creado por transportista' },
      // TODO: add classes if needed. pickup-pending class was removed and replaced by in-transit.
      { label: 'NOT_RATED', title: 'no calificado', class: 'in-transit' },
      { label: 'RATED', title: 'calificado', class: 'in-transit' },
      { label: 'UNPAID', type: 'orderPayment', title: 'no pagado', class: 'unpaid' },
      { label: 'VERIFYING', type: 'orderPayment', title: 'en verificación', class: 'verifying' },
      { label: 'PAID', type: 'orderPayment', title: 'pagado', class: 'paid' },
      { label: 'VERIFIED', type: 'orderPayment', title: 'verificado', class: 'verified' },
      { label: 'FAILED', type: 'orderPayment', title: 'rechazado', class: 'failed' },
      { label: 'DIRECT_DOWNPAYMENT_MADE', type: 'orderPayment', title: 'anticipo pagado', class: 'direct-downpayment' },
      { label: 'DIRECT_PAYMENT_MADE', type: 'orderPayment', title: 'pagado', class: 'direct-payment' },
      { label: 'READ', title: 'leidas', type: 'offer' },
      { label: 'NOT_READ', title: 'no leidas', type: 'offer' },
      { label: 'OFFER_NOT_SENT', title: 'oferta no enviada', class: 'offer-not-sent', type: 'offer' },
      { label: 'OFFER_SENT', title: 'oferta enviada', type: 'offer' },
    ];

    self.changeableStatus = [
      { label: 'ACTIVE', type: 'order', title: 'flete activo', class: 'active' },
      { label: 'IN_TRANSIT', type: 'order', title: 'en tránsito', class: 'in-transit' },
      { label: 'DELIVERED', type: 'order', title: 'entregado', class: 'delivered' },
      { label: 'CANCELLED', type: 'order', title: 'cancelada', class: 'cancelled' },
    ];

    self.paymentTypes = [
      { label: 'PAYMENT_AGREEMENT', title: 'Convenio de pago' },
      { label: 'DEPOSIT_OR_WIRE_TRANSFER', title: 'Deposito o transferencía' },
      { label: 'CREDIT_CARD', title: 'Tarjeta de crédito' },
    ];
    self.arrivalDepartureStatuses = {
      onTime: 'A tiempo',
      delayed: 'Retrasado',
    };
    self.arrivalDepartureLabels = [
      { label: 'ARRIVAL', title: 'Ingreso' },
      { label: 'DEPARTURE', title: 'Salida' },
    ];
    self.orderExtraFields = {
      sectionTypes: [
        { label: 'ORDER', title: 'Flete' },
        { label: 'SEGMENT', title: 'Segmento de ruta' },
      ],
      inputTypes: [
        { label: 'TEXT', title: 'Texto' },
        { label: 'FILE', title: 'Archivo' },
        { label: 'INTEGER', title: 'Número entero' },
        { label: 'NUMBER', title: 'Número decimal' },
        { label: 'DROPDOWN', title: 'Selector (Dropdown)' },
        {label: 'CONTAINER', title: 'Numero de Contenedor'},
      ],
      optionalFields: [
        {
          label: 'isAlwaysVisible', title: 'Siempre visible',
          description: 'Indique si el campo debe estar siempre visible en el formulario de creación de flete. Caso contrario se mostrará dentro de "Otros Requerimientos".',
        },
        {
          label: 'isFieldForDriver', title: 'Solicitar al Conductor',
          description: 'Indica si el campo debe ser llenado por el conductor a través de la aplicación móvil.',
        },
        {
          label: 'isRequired', title: 'Requerido en la Creación',
          description: 'Indica si el campo es obligatorio al momento de crear el flete.',
        },
        {
          label: 'isRequiredForDriver', title: 'Requerido para el Conductor',
          description: 'Indica si el campo es obligatorio para ser llenado por el conductor.',
        },
        {
          label: 'isVisibleInList', title: 'Visible en listado de fletes',
          description: 'Indica si el campo se mostrará en el listado de fletes.',
        },
        {
          label: 'willSendNotificationOnChange', title: 'Notificar al realizar un cambio',
          description: 'Indica que se enviará una notificacíon si el campo cambia',
        },
      ],
    };
    self.orderExtraFieldsInputTypes = {
      'FILE': 'FILE',
      'TEXT': 'TEXT',
      'INTEGER': 'INTEGER',
      'FLOAT': 'FLOAT',
      'DROPDOWN': 'DROPDOWN',
      'CONTAINER': 'TEXT',
    };
    self.months = [
      {
        name: 'Enero',
        value: 1,
      },
      {
        name: 'Febrero',
        value: 2,
      },
      {
        name: 'Marzo',
        value: 3,
      },
      {
        name: 'Abril',
        value: 4,
      },
      {
        name: 'Mayo',
        value: 5,
      },
      {
        name: 'Junio',
        value: 6,
      },
      {
        name: 'Julio',
        value: 7,
      },
      {
        name: 'Agosto',
        value: 8,
      },
      {
        name: 'Septiembre',
        value: 9,
      },
      {
        name: 'Octubre',
        value: 10,
      },
      {
        name: 'Noviembre',
        value: 11,
      },
      {
        name: 'Diciembre',
        value: 12,
      },
    ];
    self.graphicReportTypes = {
      'BAR_CHART': 'BAR_CHART',
    };
    self.graphicDataTypes = {
      'TRIPS': 'TRIPS',
      'TIMES': 'TIMES',
    };
    Object.defineProperties(self.status, {
      'offer': {
        value: _.filter(this, function (item) {
          return item.type === 'offer';
        }),
      },
      'order': {
        value: _.filter(this, function (item) {
          return item.type === 'order';
        }),
      },
    });

    Object.freeze(self.times);
    Object.freeze(self.drawerTypes);
    Object.freeze(self.status);
    Object.freeze(self.paymentTypes);

    function getTitleForObjectLabel(title, label) {
      return _.find(self[title], function (item) {
        return item.label === label;
      }) || {};
    }
    function getOfferStatus() {
      return _.filter(self.status, function (item) {
        return item.type === 'offer';
      });
    }

    function getOrderExtraFieldsInputTypes() {
      return self.orderExtraFieldsInputTypes;
    }

    function getOrderStatus() {
      return _.filter(self.status, function (item) {
        return item.type === 'order';
      });
    }

    function getChangeableOrderStatus() {
      return _.filter(self.status, function (item) {
        return item.type === 'order' && item.changeable;
      });
    }

    function getOrderPaymentStatus() {
      return _.filter(self.status, function (item) {
        return item.type === 'orderPayment';
      });
    }

    function getHourRangeLabel(hour) {
      var label = '';
      switch (hour) {
        case 12:
          label = 'morning';
          break;
        case 18:
          label = 'afternoon';
          break;
        case 23:
          label = 'evening';
          break;
      }
      return label;
    }

    function getOrderStatusObject(statusLabel) {
      return _.find(self.status, function (orderStatus) {
        return orderStatus.label === statusLabel;
      });
    }

    function getTimeObjectForHour(maxHour) {
      return _.find(self.times, function (item) {
        return item.max === maxHour;
      }) || {};
    }

    function getDataForExtraFields(title, subTitle, label) {
      return _.find(self[title][subTitle], function (item) {
        return item.label === label;
      }) || {};
    }

    function getOrderArrivalDepartureStatuses() {
      return self.arrivalDepartureStatuses;
    }

    function getOrderArrivalDepartureLabels() {
      return self.arrivalDepartureLabels;
    }

    function getAvailableStatuses(currentStatus) {
      var availableStatuses = [];
      var currentStatusAbleStatusesToChange = self.statusDependencies[currentStatus];
      currentStatusAbleStatusesToChange.forEach(function (relatedStatus) {
        var relatedStatusObject = _.find(self.status, function (orderStatus) {
          return orderStatus.label === relatedStatus;
        });
        availableStatuses.push(relatedStatusObject);
      });
      return availableStatuses;
    }

    function getMonths() {
      return self.months;
    }

    function getGraphicReportTypes() {
      return self.graphicReportTypes;
    }

    function getGraphicDataTypes() {
      return self.graphicDataTypes;
    }

    function getMonthName(monthValue) {
      return _.find(self.months, function (month) {
        return month.value == monthValue;
      });
    }

    function getChartColors() {
      return self.chartsColors;
    }

  }

}());

(function () {
  angular.module('Common').service('Cargo77Companies', Cargo77Companies);

  function Cargo77Companies($q, Profile, CargoCompany) {
    var self = this;
    self.getParentAndChildren = getParentAndChildren;

    function getParentAndChildren(filter){
      var deferred = $q.defer();
      var childCompanies = [];

      var companies = CargoCompany.find({filter:{where: filter}}).$promise
      .then(function(result){
        return result;
      })
      .catch(function() {
        return [];
      });

      if (Profile.getUserRole().indexOf('CARGO_ADMIN') < 0) {
        //we are using same query for childCompanies even though it could be more compact
        childCompanies = CargoCompany.childCompanies({id: Profile.getCargoCompanyId(),filter:{where: filter}}).$promise
          .then(function(result){
            return result;
          })
          .catch(function(){
            return [];
          });
      }

      $q.all([companies, childCompanies]).then(function(response){
        var results = [];
        response.forEach(function(item){
          results = [].concat.apply(results, item);
        });
        deferred.resolve(results);
      });

      return deferred.promise;
    }
  }

}());

(function () {
  angular.module('Common').component('cargo77RouteSegmentDetails', {
    templateUrl: 'app/components/common/route-with-details-selector/route-segment-details/route-segment-details.html',
    controller: RouteSegmentDetailsController,
    bindings: {
      routeLocations: '<',
      routeSegments: '=',
      onRouteDetailsChange: '&',
      onSegmentDetailsChange: '&',
      onSavingSegmentFiles: '&',
      selectedCompanyId: '<',
      carrierCompanyId: '=',
    },
  });

  function RouteSegmentDetailsController() {
    var vm = this;
    var defaultDate = '1000-01-01T00:00:00.000Z';
    var currentISODate = moment(defaultDate).toISOString(true);
    var initialCargoDetails = {'weight': {value: 0, units: ''}, description:''};
    vm.$onChanges = onChanges;
    vm.$onInit = onInit;
    vm.detailsFieldChange = detailsFieldChange;
    vm.extraFieldChange = extraFieldChange;
    vm.onSavingFiles = onSavingFiles;
    vm.areValidExtraFieldsChange = areValidExtraFieldsChange;

    function onInit() {
      if(vm.routeSegments && vm.routeSegments.length > 0) {
        vm.currentSegments = angular.copy(vm.routeSegments);
        return;
      }
      vm.currentSegments = [];
      vm.routeSegments = [];
    }

    function onChanges(changes) {
      var areInitialLocationsInitialized = changes.routeLocations && changes.routeLocations.currentValue && changes.routeLocations.currentValue.length > 0;
      var areLocationsValid = areInitialLocationsInitialized && changes.routeLocations.currentValue[0].location.name &&
        changes.routeLocations.currentValue[1].location.name;
      var selectedCompanyChange = changes.selectedCompanyId;
      var validCompanyChange = selectedCompanyChange && selectedCompanyChange.currentValue
        && selectedCompanyChange.currentValue !== selectedCompanyChange.previousValue;

      if(validCompanyChange) {
        vm.currentSegments = [];
      }
      if(areLocationsValid) {
        manageSegments(changes.routeLocations);
      }
    }

    function manageSegments(routeChanges) {
      if(!vm.currentSegments) {
        return;
      }
      var shouldInitializeSegments = vm.currentSegments.length === 0;
      var locationHasBeenRemoved = routeChanges.currentValue.length < routeChanges.previousValue.length;
      var locationHasBeenAdded = routeChanges.currentValue.length > routeChanges.previousValue.length;

      if(shouldInitializeSegments) {
        initializeSegments(routeChanges.currentValue);
        return;
      }
      if(locationHasBeenRemoved) {
        deleteSegment();
        return;
      }
      if(locationHasBeenAdded) {
        addSegment(routeChanges.currentValue);
      }
      changeSegmentLocations(routeChanges);
    }

    function initializeSegments(initialLocations) {
      var initialSegment = {
        from: initialLocations[0].location,
        to: initialLocations[1].location,
        scheduledDate:currentISODate,
        cargoDetails:angular.copy(initialCargoDetails),
      };
      vm.currentSegments.push(initialSegment);
      createFinalSegments();
    }

    function deleteSegment() {
      vm.currentSegments.pop();
      createFinalSegments();
    }

    function addSegment(currentLocations) {
      var currentNumberOfLocations = currentLocations.length;
      var segmentToAdd = {
        from: currentLocations[currentNumberOfLocations - 2].location,
        to: currentLocations[currentNumberOfLocations - 1].location,
        scheduledDate:currentISODate,
        cargoDetails: angular.copy(initialCargoDetails),
      };
      vm.currentSegments.push(segmentToAdd);
      createFinalSegments();
    }

    function changeSegmentLocations(routeChanges) {
      var previousValues = routeChanges.previousValue;
      var currentValues = routeChanges.currentValue;
      var currentNumberOfLocations = currentValues.length;
      previousValues.forEach(function(previousLocation, index) {
        var currentLocation = currentValues[index].location;
        var currentLocationName = currentLocation.name;
        var previousLocationName =  previousLocation.location.name;

        if (previousLocationName && previousLocationName === currentLocationName) {
          return;
        }
        if (index === 0) {
          vm.currentSegments[0].from = currentLocation;
          return;
        }
        if(index === 1 && !vm.currentSegments[1]) {
          vm.currentSegments[0].to = currentLocation;
          return;
        }
        if(index === currentNumberOfLocations - 1) {
          vm.currentSegments[index - 1].to = currentLocation;
          return;
        }
        vm.currentSegments[index - 1].to = currentLocation;
        vm.currentSegments[index].from = currentLocation;
      });
      createFinalSegments();
    }

    function detailsFieldChange(field, value, segmentIndex) {
      if(field === 'time') {
        manageTimeChange(segmentIndex, value);
      }
      if(field === 'date') {
        manageDateChange(segmentIndex, value);
      }
      if(field === 'weight') {
        vm.currentSegments[segmentIndex].cargoDetails.weight.value = value;
      }
      if(field !== 'date' && field !== 'time' && field !== 'weight') {
        vm.currentSegments[segmentIndex].cargoDetails[field] = value;
      }
      createFinalSegments();
    }

    function extraFieldChange(extraFields, segmentIndex) {
      vm.currentSegments[segmentIndex].extraFields = extraFields;
      if(vm.onSegmentDetailsChange) {
        var segmentExtraFieldsChange = {
          segmentIndex: segmentIndex,
          extraFields: extraFields,
        };
        vm.onSegmentDetailsChange({segmentExtraFieldsChange: segmentExtraFieldsChange});
      }

      createFinalSegments();
    }

    function onSavingFiles(saved, saving){
      vm.onSavingSegmentFiles({'saved': saved, 'saving': saving});
    }

    function areValidExtraFieldsChange(areValidExtraFields, segmentIndex) {
      vm.currentSegments[segmentIndex].areValidExtraFields = areValidExtraFields;
      createFinalSegments();
    }

    function manageDateChange(pointIndex, newDate) {
      var currentMomentDate = moment(vm.currentSegments[pointIndex].scheduledDate);
      var dateComponents = newDate.split('/');
      var day = dateComponents[0];
      var month = dateComponents[1] - 1;
      var year = dateComponents[2];

      currentMomentDate.set('year', year);
      currentMomentDate.set('month', month);
      currentMomentDate.set('date', day);

      var newDatetime = currentMomentDate.toISOString(false);

      vm.currentSegments[pointIndex].scheduledDate = newDatetime;
    }

    function manageTimeChange(pointIndex, newTime) {
      var currentMomentDate = moment(vm.currentSegments[pointIndex].scheduledDate);
      var timeComponents = newTime.split(':');
      var hour = parseInt(timeComponents[0]);
      var minute = parseInt(timeComponents[1]);

      currentMomentDate.set('hour', hour);
      currentMomentDate.set('minute', minute);
      currentMomentDate.set('second', 0);

      var ISOdatetime = currentMomentDate.toISOString(false);
      vm.currentSegments[pointIndex].scheduledDate = ISOdatetime;
    }

    function createFinalSegments() {
      var segmentToAdd;
      vm.routeSegments = vm.currentSegments.map(function(segment){
        segmentToAdd = angular.copy(segment);
        segmentToAdd.fromLocationId = segmentToAdd.from ? segmentToAdd.from.id : segmentToAdd.fromLocationId ;
        segmentToAdd.toLocationId = segmentToAdd.to ? segmentToAdd.to.id : segmentToAdd.toLocationId;
        delete segmentToAdd.areValidExtraFields;
        delete segmentToAdd.from;
        delete segmentToAdd.to;
        delete segmentToAdd.$$hashKey;
        return segmentToAdd;
      });
      vm.onRouteDetailsChange({segments: vm.routeSegments});
    }
  }

}());

(function () {
  angular.module('Common').component('cargo77RouteLocationsSelector', {
    templateUrl: 'app/components/common/route-with-details-selector/route-locations-selector/route-locations-selector.html',
    controller: RouteLocationsSelectorController,
    bindings: {
      'route': '=',
      'onRouteChange': '&',
      'selectedCompanyId': '<',
      'isShipperOrder': '<',
      'routeSegments': '<',
    },
  });

  function RouteLocationsSelectorController(LocationsListService, Profile) {
    var vm = this;
    vm.addNewPoint = addNewPoint;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.changePoint = changePoint;
    vm.deletePoint = deletePoint;
    vm.shouldShowSelectors = shouldShowSelectors;

    function shouldShowSelectors() {
      return vm.isShipperOrder || !vm.isShipperOrder && !!vm.selectedCompanyId;
    }

    function onChanges(changes) {
      if(!changes.selectedCompanyId) {
        return;
      }
      var selectedCompanyChange = changes.selectedCompanyId;
      var validCompanyChange = selectedCompanyChange.currentValue
        && selectedCompanyChange.currentValue !== selectedCompanyChange.previousValue;

      if (validCompanyChange) {
        var selectedCompanyId = changes.selectedCompanyId.currentValue.toString();
        vm.locations = vm.initialLocations.filter(function(location) {
          var locationCompanyId = location.ownerCompanyId.toString();
          var isLocationFromSelectedCompany = locationCompanyId === selectedCompanyId;
          var isLocationFromUserCompany = locationCompanyId === vm.userCargoCompanyId.toString();
          return isLocationFromSelectedCompany || isLocationFromUserCompany;
        });
        vm.currentRoute = [
          {index: 0,  location: {id: '0'}},
          {index: 1, location: {id: '0'}},
        ];
      }
    }

    function onInit() {
      vm.initialLocations = LocationsListService.getLocations();
      if(vm.isShipperOrder) {
        vm.locations = vm.initialLocations;
      }
      vm.totalOfPoints = 2;
      vm.invalidFields = false;
      vm.userCargoCompanyId = Profile.getCargoCompanyId();
      if(vm.route && vm.route.length > 0) {
        vm.currentRoute = angular.copy(vm.route);
        return;
      }
      vm.currentRoute = [
        {index: 0,  location: {id: '0'}},
        {index: 1, location: {id: '0'}},
      ];
      vm.route = [];
    }

    function addNewPoint() {
      var arePreviousFieldsInvalid = areFieldsInvalid();
      if(arePreviousFieldsInvalid) {
        vm.invalidFields = true;
        return;
      }
      vm.totalOfPoints = vm.currentRoute.length;
      vm.invalidFields = false;
      var newPoint = {
        index: vm.totalOfPoints,
        location: {
          id:'0',
        } ,
      };
      vm.currentRoute.push(newPoint);
      createFinalRoute();
    }

    function areFieldsInvalid() {
      var areFieldsMissing = false;
      vm.currentRoute.forEach(function(point){
        var isLocationInvalid = point.location.id === '0';
        if(isLocationInvalid) {
          areFieldsMissing = true;
        }
      });
      return areFieldsMissing;
    }

    function deletePoint() {
      var indexToDelete = vm.currentRoute.length - 1;
      vm.currentRoute.splice(indexToDelete, 1);
      createFinalRoute();
    }

    function changePoint(pointIndex, field, value) {
      var objectIndexToToChange = getIndexInArray(pointIndex);
      if(field === 'location') {
        vm.currentRoute[objectIndexToToChange][field] = value;
      }
      createFinalRoute();
    }

    function createFinalRoute() {
      var pointToAdd;
      vm.route = vm.currentRoute.map(function(point){
         pointToAdd = angular.copy(point);
         if(pointToAdd.location.id !== 0) {
           delete pointToAdd.location.$$mdSelectId;
         }
         delete pointToAdd.index;
         return pointToAdd;
      });
      vm.onRouteChange({route:vm.route});
    }

    function getIndexInArray(objectIndex) {
      return vm.currentRoute.findIndex(function(point){
        return point.index === objectIndex;
      });
    }
  }

}());

(function () {
  angular.module('Cargo77.notifications').service('NotificationsService', NotificationsService);

  /** @ngInject */
  function NotificationsService($firebaseObject, Profile, $firebaseArray) {
    var self = this;
    var notifications;

    self.init = init;
    self.destroy = destroy;
    self.resetNotificationCount = resetNotificationCount;
    self.markAllRead = markAllRead;
    self.markAsRead = markAsRead;

    function markAsRead(notification) {
      var notificationToUpdate = _.find(notifications, {$id: notification.$id});
      notificationToUpdate.isRead = true;
      notifications.$save(notificationToUpdate);
    }

    function resetNotificationCount() {
      self.user.newNotifications = 0;
      self.user.$save();
    }

    function markAllRead() {
      if (notifications) {
        for (var i = 0; i < notifications.length; i++) {
          var notificationToUpdate = notifications[i];
          notificationToUpdate.isRead = true;
          notifications.$save(notificationToUpdate);
        }
      }
    }

    function init(notificationCode) {
      getNotificationsCount(notificationCode);
    }

    function destroy() {
      notifications.$destroy();
      self.user.$destroy();
    }

    function getNotificationsCount(notificationCode) {
      console.log(Profile.getCurrentUser().id)
      var userInfo = firebase.database().ref('users/' + Profile.getCurrentUser().id);
      console.log(userInfo)
      self.user = $firebaseObject(userInfo);
      self.user.$loaded().then(function () {
        getNotifications(notificationCode);
      });
    }

    function getNotifications(notificationCode) {
      var notificationRef = firebase.database().ref('notifications/' + self.user.$id);

      if (!_.isEmpty(notificationCode)) {
        notificationRef = notificationRef.orderByChild('code').equalTo(notificationCode);
      }

      notifications = $firebaseArray(notificationRef);

      notifications.$loaded().then(function (response) {
        self.notifications = response;
        defineProperties(self.notifications);
      });
    }

    function defineProperties(notifications) {
      for (var i = 0; i < notifications.length; i++) {
        Object.defineProperty(notifications[i], 'timeFromNow', {
          get: function () {
            return moment(this.timestamp).fromNow();
          },
        });

        Object.defineProperty(notifications[i], 'fullDate', {
          get: function () {
            return moment(this.timestamp).format('dddd, LL, HH:mm');
          },
        });

        Object.defineProperty(notifications[i], 'smallFullDate', {
          get: function () {
            return moment(this.timestamp).format('L, HH:mm');
          },
        });
      }

      Object.defineProperty(notifications, 'sort', {
        value: function () {
          return _.orderBy(this, ['timestamp'], ['desc']);
        },
      });

      Object.defineProperty(notifications, 'countUnread', {
        get: function () {
          return _.filter(this, function (n) {
            return !n.isRead;
          }).length;
        },
      });
    }
  }
}());

(function () {
  angular.module('Cargo77.notifications').component('cargo77Notifications', {
    templateUrl: 'app/components/common/notifications/notificationsComponent/notifications.html',
    controller: NotificationsController,
  });

  /** @ngInject */
  function NotificationsController(NotificationsService) {
    var vm = this;
    vm.$onInit = onInit;
    vm.$onDestroy = onDestroy;
    vm.markAsRead = markAsRead;
    vm.markAllRead = markAllRead;
    vm.resetNotificationCount = NotificationsService.resetNotificationCount;

    function markAllRead() {
      NotificationsService.markAllRead();
    }

    function markAsRead(notification) {
      NotificationsService.markAsRead(notification);
    }

    function onInit() {
      NotificationsService.init();
    }

    function onDestroy() {
      NotificationsService.destroy();

    }

    Object.defineProperty(vm, 'user', {
      get: function () {
        return NotificationsService.user;
      },
    });

    Object.defineProperty(vm, 'notifications', {
      get: function () {
        return NotificationsService.notifications;
      },
    });

  }
}());

/**
 * Created by Leonel Gonçalves on 6/29/16.
 */

(function () {
  angular.module('Sidebar.component', ['ngMaterial', 'permission']);
}());


/**
 * Created by Leonel Gonçalves on 6/29/16.
 */

(function () {
  angular.module('Sidebar.component').service('SidebarService', SidebarService);

  function SidebarService ($mdSidenav) {
    var self = this;

    self.closeSidebar = closeSidebar;
    self.toggleSidebar = buildToggler;

    self.elements = [];

    function closeSidebar (id) {
      return $mdSidenav(id).close();
    }

    function buildToggler (navID) {
      return function () {
        $mdSidenav(navID).toggle();
      };
    }
  }

}());


(function () {
  angular.module('Sidebar.component').component('sideBar', {
    templateUrl: 'app/components/common/navigation/sidebar/sidebar.html',
    bindings: {menuItems: '<'},
    controller: SidebarController,
    controllerAs: 'sidebar',
  });

  /** @ngInject */
  function SidebarController (SidebarService, CompaniesService) {
    var vm = this;
    vm.$onInit = onInit;
    vm.close = close;

    function onInit() {
      getHomeLogo();
    }

    function getHomeLogo(){
      vm.company = CompaniesService.getCurrentCompany();
    }

    function close () {
      SidebarService.closeSidebar('left');
    }

  }
}());

/**
 * Created by Leonel Gonçalves on 6/28/16.
 */

(function () {
  'use strict';

  angular.module('NavBar.component', ['ngMaterial','Cargo77.profile', 'Cargo77.config', 'Cargo77.chat', 'lbServices','Sidebar.component']);
}());

/**
 * Created by Leonel Gonçalves on 6/28/16.
 */
(function () {
  angular.module('NavBar.component').service('NavBarService', NavBarService);

  /** @ngInject */
  function NavBarService(Profile, CargoUser, Chat) {
    var vm = this;

    vm.currentPageTitle = '';
    vm.user = Profile.getCurrentUser;

    vm.newMessages = 0;
    vm.updateUser = updateUser;
    vm.unreadMessages = unreadMessages;
    vm.resetChatMessages = Chat.resetChatMessages;
    vm.init = init;
    vm.destroy = destroy;

    function init() {
      updateUser();
      Chat.init();
    }

    function destroy() {
      Chat.user.$destroy();
    }

    function unreadMessages() {
      return Chat.user.unreadMessages;
    }

    function updateUser() {
      CargoUser.findById({
        id: Profile.getId(),
        filter: {
          include: [
            {
              relation: 'cargoCompany',
              scope: {
                fields: [
                  'id',
                  'parentCompanyId',
                ],
              },
            },
          ],
        },
      })
      .$promise
      .then(function (response) {
        if (response.cargoCompany && response.cargoCompany.parentCompanyId) {
          response.parentCompanyId = response.cargoCompany.parentCompanyId;
        }
        Profile.save(response);
        vm.user = Profile.getCurrentUser;
      });
    }
  }
}());

(function () {

  angular.module('NavBar.component').component('navBar', {
    templateUrl: 'app/components/common/navigation/nav-bar/navbar.html',
    bindings: {},
    controller: NavBarController,
  });

  /** @ngInject */
  function NavBarController(NavBarService, SidebarService, $state, CargoUser, SearchBarService, NotificationsService) {
    var vm = this;
    vm.currentPageTitle = currentPageTitle;
    vm.toggleMenu = SidebarService.toggleSidebar('left');
    vm.unreadMessages = NavBarService.unreadMessages;
    vm.resetChatMessages = NavBarService.resetChatMessages;
    vm.resetUnreadOrdersCounter = resetUnreadOrdersCounter;
    vm.user = NavBarService.user;
    vm.$onInit = onInit;
    vm.$onDestroy = onDestroy;
    vm.logout = logout;

    function onDestroy() {
      NavBarService.destroy();
      NotificationsService.destroy();
    }

    function onInit() {
      NavBarService.init();
      NotificationsService.init('EXTRAFIELD_CHANGED');
      initVariables();
    }

    function logout() {
      SearchBarService.clearSearchText();
      CargoUser.logout();
      $state.go('login');
    }

    function initVariables() {
      vm.newMessages = NavBarService.newMessages;
      vm.areUnreadOrdersAvailable = true;
      vm.shouldShowBackButton = true;
    }

    function currentPageTitle() {
      var currentURL = $state.current.url;
      var URLSlashCount = (currentURL.match(/\//ig) || []).length;
      var isInCompaniesList = currentURL.indexOf('companies') > -1 && URLSlashCount === 2;
      vm.shouldShowBackButton = URLSlashCount > 1 && !isInCompaniesList;
      return $state.current.data.pageTitle || NavBarService.currentPageTitle;
    }

    function resetUnreadOrdersCounter () {
      vm.areUnreadOrdersAvailable = false;
    }

    function getEncodedURI(uri) {
      return encodeURI(uri);
    }

    Object.defineProperty(vm, 'notifications', {
      get: function () {
        return NotificationsService.notifications;
      },
    });
  }
}());

(function () {
  angular.module('Common').component('cargo77AddFieldSelector', {
    templateUrl: 'app/components/common/add-extra-fields-selector/add-field-selector/add-field-selector.html',
    controller: AddFieldSelectorController,
    bindings: {
      field: '=',
      onChangeField: '<',
      onSavingFile: '<',
      onDeleteField: '<',
      canBeDeleted: '=',
    },
  });

  function AddFieldSelectorController(Order, Cargo77Toast) {
    var vm = this;
    var optionIndex;
    vm.$onInit = onInit;
    vm.changeField = changeField;
    vm.deleteField = deleteField;
    vm.onFileSelect = onFileSelect;
    vm.getNameTruncated = getNameTruncated;
    vm.showFileInput = showFileInput;
    vm.removeFile = removeFile;

    function onInit() {
      optionIndex = vm.field.index;
      vm.value = vm.field.value;
      vm.search = '';
      vm.saving = false;
      vm.shouldShowFileEditor = vm.field.inputType === 'FILE' && vm.value && vm.value.length > 0;
    }

    function removeFile() {
      vm.value = null;
      vm.shouldShowFileEditor = false;
      changeField();
    }

    function showFileInput() {
      vm.shouldShowFileEditor = false;
    }

    function changeField() {
      var newValue = vm.value;
      vm.search = '';
      vm.onChangeField(optionIndex, newValue);
    }

    function deleteField() {
      vm.onDeleteField(optionIndex, vm.field.id);
    }

    function onFileSelect(files) {
      vm.saving = true;
      var file = files[0];
      var fileName = 'No file choosen';
      if (file) {
        fileName = file.name;
        //Verify if the file size is lower than the max size
        var maxSize = 4 * 1024 * 1024;
        if (!fileValidation(fileName)) {
          Cargo77Toast.errorToast('Tipo de archivo NO permitido');
          vm.value = null;
        } else {
          if(file.size > maxSize){
            vm.value = null;
            Cargo77Toast.errorToast('El archivo: ' + fileName + ', es muy pesado. (Tamaño Max. 4Mb)');
          } else {
            vm.onSavingFile(optionIndex, true);
            getFileInBase64(file, fileName, vm.onChangeField);
          }
        }
      }
    }

    function getFileInBase64(file, fileName, cb) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        var fileInBase64 = reader.result;
        Order.uploadFiles({},{
          fileName: fileName,
          fileInBase64: fileInBase64,
        })
        .$promise
        .then(function (response){
          cb(optionIndex, response.url, fileName);
          vm.saving = false;
          Cargo77Toast.successToast('Se ha subido el archivo: ' + fileName );
          vm.onSavingFile(optionIndex, false);
        });
      };
    }

    function fileValidation(fileName){
      var file = fileName;
      var allowedExtensions = /(.jpg|.jpeg|.png|.pdf|.xml|.xlsx|.xls|.docx|.doc)$/i;
      if(!allowedExtensions.exec(file)){
        return false;
      } else {
        return true;
      }
    }

    function getNameTruncated(name, maxLength) {
      return _.truncate(name, {
        length: maxLength,
      });
    }

  }

}());

(function () {
  angular.module('Cargo77.chat', [
    'ngResource',
    'lbServices',
    'ui.router',
    'ngMaterial',
    'firebase',
    'Common',
    'Cargo77.profile',
    'Cargo77.config',
  ])
    .config(Routing);

  /** @ngInject */
  function Routing($stateProvider) {
    $stateProvider
      .state('cargo.chat', {
        url: '/chat?chatId',
        template: '<cargo77-chat></cargo77-chat>',
        data: {
          pageTitle: 'Chat',
        },
      });

  }
}());

(function () {
  angular.module('Cargo77.chat').component('cargo77ChatTile', {
    templateUrl: 'app/components/chat/components/chatTile/chatTile.html',
    controller: ChatTileController,
    bindings: {
      chat: '<',
    },
  });

  /** @ngInject */
  function ChatTileController(Chat) {
    var vm = this;
    vm.getUnreadMessages = getUnreadMessages;
    vm.getCompanyTitle = Chat.getCompanyTitle;

    setChatLastMessageDate();

    function getUnreadMessages () {
      /* istanbul ignore else */
      if(vm.chat.unreadMessages) {
        return vm.chat.unreadMessages[Chat.user.$id];
      }

    }

    function setChatLastMessageDate () {
      Chat.getChatLastMessage(vm.chat.$id)
        .then(function(message){
          if(message.length > 0){
            vm.chat.timestamp = message[0].timestamp;
          }

        });
    }

  }
}());

(function () {
  angular.module('Cargo77.chat').component('cargo77ChatLoading', {
    templateUrl: 'app/components/chat/components/chatLoading/chatLoading.html',
    bindings: {
      chatCount: '&',
    },
  });
}());

(function () {
  angular.module('Cargo77.chat').component('cargo77ChatContainer', {
    templateUrl: 'app/components/chat/components/chatContainer/chatContainer.html',
    controller: ChatContainerController,
    bindings: {
      chat: '<',
      messages: '<',
      sendMessage: '&',
      getUserId: '&',
      backAction: '&?',
    },
  });

  /** @ngInject */
  function ChatContainerController($timeout,$state, $stateParams) {
    var vm = this;
    var ownerTitleColor = {};
    var colorList = [
      '2196F3',
      'FFC107',
      '00BCD4',
      '26A69A',
      '8BC34A',
      'FF5722',
      '607D8B',
      'FF9800',
      'FFC107',
      '8BC34A',
      'FF5722',
      '2196F3',
      '03A9F4',
    ];
    vm.$onInit = onInit;
    vm.scrollToBottom = scrollToBottom;
    vm.isMessageFromUser = isMessageFromUser;
    vm.getMessageOwnerColor = getMessageOwnerColor;
    vm.redirectAccordingOfferStatus = redirectAccordingOfferStatus;
    vm.sendNewMessage = sendNewMessage;

    function getMessageOwnerColor(owner) {

      if (ownerTitleColor.hasOwnProperty(owner)) {
        return ownerTitleColor[owner];
      }

      ownerTitleColor[owner] = colorList[Object.keys(ownerTitleColor).length];
      return ownerTitleColor[owner];
    }

    function scrollToBottom() {
      $timeout(function () {
        angular.element('.messages-container').scrollTop(angular.element('.messages-container')[0].scrollHeight);
      });
    }

    function isMessageFromUser(user) {
      return vm.getUserId() === user;
    }

    function onInit() {
      angular.element('#messageTextArea').keypress(function (event) {
        if (event.which == 13) {
          event.preventDefault();
          vm.sendMessage({message: vm.message});
          vm.message = '';
        }
      });
    }
    function redirectAccordingOfferStatus () {

      var orderId = $stateParams.chatId.split('|')[0];

      if(vm.chat.isOfferAccepted == true) {
        $state.go('cargo.orderDetails', {id:orderId});
        return;
      }
      if(vm.chat.isOfferAccepted == false) {
        $state.go('cargo.editOffer', {id:orderId, offerId: vm.chat.offerId});
        return;
      }
      /* istanbul ignore else */
      if(vm.chat.isOfferAccepted == undefined) {
        $state.go('cargo.createOffer', {id:orderId} );

      }
    }

    function sendNewMessage() {
      vm.sendMessage({message: vm.message});
      vm.message = undefined;
    }

  }
}());

(function () {
  angular.module('Cargo77.calendar', [
    'ngResource',
    'lbServices',
    'ui.router',
    'ngMaterial',
    'ui.calendar',
    'Common',
    'Cargo77.profile',
  ]).config(Routing);

  /** @ngInject */
  function Routing($stateProvider) {

    $stateProvider
      .state('cargo.calendar', {
        abstract: true,
        url: '/calendar',
        templateUrl: 'app/components/calendar/calendar.html',
        data: {
          permissions: {
            only: ['CARRIER_OWNER', 'CARRIER_USER'],
          },
        },
      });

    $stateProvider
      .state('cargo.calendar.month', {
        url: '/month',
        template: '<cargo77-month-calendar></cargo77-month-calendar>',
        data: {pageTitle: 'Calendario'},
      });

  }
}());

(function () {
  angular.module('Cargo77.calendar').component('cargo77MonthCalendar', {
    templateUrl: 'app/components/calendar/components/monthCalendar/month-calendar.html',
    controller: MonthCalendarController,
  });

  /** @ngInject */
  function MonthCalendarController($state, Cargo77Dictionary, CalendarService) {
    var vm = this;
    vm.goToWeek = goToWeek;
    vm.events = [onChangeMonth];
    vm.calendar = {
      buttonText: {today: 'HOY'},
      editable: true,
      header: {
        left: 'title',
        center: '',
        right: 'today prev,next',
      },
      eventRender: eventRender,
      getRouteLocalities: getRouteLocalities,
      getDriverFullName: getDriverFullName,
      windowResize: resizeHeight,
      viewRender: resizeHeight,
      eventClick: eventClick,
    };

    function goToWeek(date) {
      $state.go('cargo.calendar.agenda', {date: date});
    }

    function onChangeMonth(start, end, timezone, callback) {
      CalendarService.getOrders({min: start.format('MM-DD-YYYY'), max: end.format('MM-DD-YYYY')})
        .$promise
        .then(function (orders) {
          callback(transformDataForCalendar(orders));
        });
    }

    function eventClick(calEvent) {
      $state.go('cargo.orderDetails', {id: calEvent.id});
    }

    function eventRender(event, element) {
      element.find('.fc-title').remove();
      element.find('.fc-time').remove();
      var orderStatus =  getOrderStatus(event);
      var driverFullName = getDriverFullName(event);
      var routeLocalities = getRouteLocalities(event);
      var timeImage = getTimeImage(event);
      element.addClass(getScheduledDateTimeLabel(event));
      var new_description =
        '<div class="order-status">#' + event.id + ' - ' + orderStatus + '</div>'
        + '<h1 class="hide-xs driver-name">' + driverFullName + '</h1>'
        + '<div class="hide-xs route">' + routeLocalities + '</div>';

      if (event.scheduledDate.flexibleTime) {

        new_description += '<div class="hide-xs image"><img src="' + timeImage + '"/></div>';

      } else {
        new_description += '<div class="hide-xs image">' + getScheduleDateTime(event) + '</div>';
      }

      element.append(new_description);
    }

    function transformDataForCalendar(orders) {
      var transformedOrders = _.filter(orders, function (order) {
        return order.offers.length > 0;
      });
      transformedOrders.forEach(function (order) {
        order.scheduledDate.date = getLocalDate(order);
      });
      for (var i = 0; i < transformedOrders.length; i++) {
        var order = transformedOrders[i];
        order.start = order.scheduledDate.date;
      }
      return transformedOrders;
    }

    function resizeHeight() {
      var height = angular.element('.calendar-container').height();
      angular.element('.calendar').fullCalendar('option', 'contentHeight', height - 60);
    }

    function getScheduleDateTime (event) {
      return moment.utc(event.scheduledDate.date).format('HH:mm a');
    }

    function getScheduledDateTimeLabel(event) {
      if (event.scheduledDate.flexibleTime) {
        var hourString = moment.utc(event.scheduledDate.date).format('HH');
        var hour = parseInt(hourString);
        return Cargo77Dictionary.getHourRangeLabel(hour);
      } else {
        return 'specificTime';
      }
    }

    function getOrderStatus(event) {
      return Cargo77Dictionary.getTitleForObjectLabel('status', event.orderStatus).title;
    }

    function getDriverFullName (event) {
      var eventOffer = event.offers[0];
      /* istanbul ignore else */
      if(eventOffer && eventOffer.driver){
        return event.offers[0].driver.firstName + ' ' + event.offers[0].driver.lastName;
      }
      return 'No asignado';
    }

    function getRouteLocalities(event) {
      var pickupLocality = event.route.pickupAddress.locality || event.route.pickupAddress.state;
      var deliveryLocality = event.route.deliveryAddress.locality || event.route.deliveryAddress.state;
      /* istanbul ignore else */
      if(pickupLocality === deliveryLocality){
        return deliveryLocality;
      }
      return pickupLocality + ' -> ' + deliveryLocality;
    }

    function getTimeImage(event) {
      return Cargo77Dictionary.getTitleForObjectLabel('times',getScheduledDateTimeLabel(event)).image;
    }

    function getLocalDate(event) {
      var dateTimestamp =  Date.parse(event.scheduledDate.date);
      var summerOffset = event.route.pickupTimeZone.dstOffset * 1000;
      var timeZoneOffset =  moment.tz(event.route.pickupTimeZone.timeZoneId).utcOffset() * 60 * 1000;
      var locationOffset = timeZoneOffset - summerOffset;
      return new Date(dateTimestamp + locationOffset).toISOString();
    }

  }
}());

(function () {
  angular.module('Cargo77.dashboard').service('DashboardService', DashboardService);

  /** @ngInject */
  function DashboardService(Profile, CargoCompany, Offer, Order, Vehicle, CargoUser, $q) {
    var self = this;

    self.getVehiclesCount = getVehiclesCount;
    self.getDriversCount = getDriversCount;
    self.getAcceptedOrderCount = getAcceptedOrderCount;
    self.getOrdersCountPerDriver = getOrdersCountPerDriver;
    self.getAcceptedOrderForDateRange = getAcceptedOrderForDateRange;
    self.getOrdersCountPerCompany = getOrdersCountPerCompany;
    self.getCurrentUserOrderCount = getCurrentUserOrderCount;
    self.getCurrentUserTotalOffers = getCurrentUserTotalOffers;
    self.getCurrentUserCompletedOrders = getCurrentUserCompletedOrders;
    self.getUserRole = getUserRole;

    function getUserRole() {
      return Profile.getUserRole()[0].split('_')[0];
    }

    function getCurrentUserOrderCount() {
      return Order.count({
        where: {
          cargoUserId: Profile.getId(),
        },
      });
    }

    function getCurrentUserCompletedOrders() {
      return Order.count({
        where: {
          orderStatus: {inq: ['COMPLETED','DELIVERED']},
          'ownerCompanyId': Profile.getCargoCompanyId(),
        },
      });
    }

    function getCurrentUserTotalOffers() {

      return Order.find({
        filter: {
          fields: ['id'],
          where: {
            cargoUserId: Profile.getId(),
          },
          include: {
            relation: 'offers',
            scope: {
              fields: ['orderId', 'id'],
            },
          },
        },
      }).$promise;
    }

    function getAcceptedOrderForDateRange(minDate, maxDate) {

      var where = {
        cargoCompanyId: Profile.getCargoCompanyId(),
        isAccepted: true,
        orderDate: {between: [minDate, maxDate]},
      };

      if (Profile.getUserRole().indexOf('CARGO_ADMIN') >= 0) {
        delete where.cargoCompanyId;
      }

      return Offer.find({
        filter: {
          fields: ['orderDate', 'id'],
          where: where,
        },
      });
    }

    function getVehiclesCount() {
      var where = {ownerCompanyId: Profile.getCargoCompanyId()};

      if (Profile.getUserRole().indexOf('CARGO_ADMIN') >= 0) {
        where = {};
      }
      return Vehicle.count({where: where});
    }

    function getOrdersCountPerCompany() {
      var deferred = $q.defer();

      CargoCompany.find({
        filter: {
          include: {
            relation: 'offers',
            scope: {
              fields: ['id', 'cargoCompanyId'],
              where: {
                isAccepted: true,
              },
            },
          },
          fields: ['id', 'name'],
        },
      }).$promise.then(function (response) {
        deferred.resolve(groupOrdersByCompany(response));
      });

      return deferred.promise;
    }

    function getOrdersCountPerDriver() {
      var deferred = $q.defer();

      CargoUser.find({
        filter: {
          include: {
            relation: 'driverOffers',
            scope: {
              fields: ['id', 'driverId'],
              where: {
                isAccepted: true,
              },
            },
          },
          where: {
            roles: {inq: ['DRIVER']},
            cargoCompanyId: Profile.getCargoCompanyId(),
          },
          fields: ['id', 'name', 'firstName', 'lastName'],
        },
      }).$promise.then(function (response) {
        deferred.resolve(groupOrdersByDriver(response));
      });

      return deferred.promise;
    }

    function groupOrdersByDriver(drivers) {
      var groupedDrivers = {};
      for (var i = 0; i < drivers.length; i++) {
        var driver = drivers[i];

        groupedDrivers[driver.id] = Object.assign({}, {count: driver.driverOffers.length}, driver);
        delete groupedDrivers[driver.id].driverOffers;

      }

      return groupedDrivers;
    }

    function groupOrdersByCompany(companies) {
      var groupedCompanies = {};
      for (var i = 0; i < companies.length; i++) {
        var company = companies[i];

        groupedCompanies[company.id] = Object.assign({}, {count: company.offers.length}, company);
        delete groupedCompanies[company.id].offers;

      }

      return groupedCompanies;
    }

    function getAcceptedOrderCount() {
      var where = {
        orderStatus: {inq: ['COMPLETED','DELIVERED']},
        'mainCarrierCompanyId': Profile.getCargoCompanyId(),
      };

      if (Profile.getUserRole().indexOf('CARGO_ADMIN') >= 0) {
        where = {orderStatus: {inq: ['COMPLETED','DELIVERED']}};
      }

      return Order.count({
        where: where,
      });
    }

    function getDriversCount() {
      var where = {
        roles: {inq: ['DRIVER']},
        cargoCompanyId: Profile.getCargoCompanyId(),
      };

      if (Profile.getUserRole().indexOf('CARGO_ADMIN') >= 0) {
        delete where.cargoCompanyId;
      }
      return CargoUser.count({
        where: where,
      });
    }

  }
}());

(function () {
  angular.module('Cargo77.dashboard').component('cargo77Dashboard', {
    templateUrl: 'app/components/dashboard/components/dashboard.html',
    controller: DashboardController,
  });

  /** @ngInject */
  function DashboardController(DashboardService, Profile) {
    var vm = this;

    vm.$onInit = onInit;
    vm.hideFabMenuIfDriver = hideFabMenuIfDriver;

    function onInit() {
      if (DashboardService.getUserRole() === 'CARRIER') {
        initializeCarrierVariables();
        return;
      }

      if (DashboardService.getUserRole() === 'SHIPPER') {
        initializeShipperVariables();
        return;
      }

      initializeAdminVariables();

    }

    function initializeAdminVariables() {
      vm.driversCount = DashboardService.getDriversCount();
      vm.vehiclesCount = DashboardService.getVehiclesCount();
      vm.completedOrdersCount = DashboardService.getAcceptedOrderCount();
    }

    function initializeShipperVariables() {
      vm.ordersCount = DashboardService.getCurrentUserOrderCount();
      vm.completedShipperOrdersCount = DashboardService.getCurrentUserCompletedOrders();
      DashboardService.getCurrentUserTotalOffers().then(function (data) {
        vm.totalOffers = _.reduce(data, function (prev, current) {
          return prev + current.offers.length;
        }, 0);
      });
    }

    function initializeCarrierVariables() {
      vm.driversCount = DashboardService.getDriversCount();
      vm.vehiclesCount = DashboardService.getVehiclesCount();
      vm.completedOrdersCount = DashboardService.getAcceptedOrderCount();
    }

    function hideFabMenuIfDriver() {
      return Profile.getUserPrimaryRole() === 'DRIVER';
    }

  }
}());

(function () {
  angular.module('Cargo77.vehicles').service('VehicleService', VehicleService);
  /** @ngInject */
  function VehicleService(Cargo77Dictionary, Vehicle) {
    var self = this;

    self.vehicleTypes = Cargo77Dictionary.drawerTypes;
    self.saveVehicle = saveVehicle;
    self.updateVehicle = updateVehicle;
    self.getVehicle = getVehicle;
    self.deleteVehicle = deleteVehicle;

    function deleteVehicle (id) {
      return Vehicle.destroyById({id: id}).$promise;
    }

    function saveVehicle(vehicle) {
      var newVehicle = createNewVehicle(vehicle);
      return Vehicle.create(newVehicle).$promise;
    }

    function updateVehicle(vehicle) {

      var newVehicle = createNewVehicle(vehicle);

      return Vehicle.prototype$updateAttributes(newVehicle).$promise;
    }

    function getVehicle(vehicleId) {
      return Vehicle.findById({id: vehicleId, filter: {include: 'ownerCompany'}});
    }

    function createNewVehicle(vehicle) {
      var newVehicle = angular.copy(vehicle);
      newVehicle.ownerCompanyId = newVehicle.ownerCompany.id;
      delete newVehicle.ownerCompany;
      return newVehicle;
    }

  }
}());

(function () {
  angular.module('Cargo77.users').service('UserService', UserService);
  /** @ngInject */
  function UserService(Cargo77Dictionary, CargoUser, CargoCompany, Profile) {
    var self = this;

    self.userTypes = Cargo77Dictionary.drawerTypes;
    self.saveUser = saveUser;
    self.updateUser = updateUser;
    self.getUser = getUser;
    self.getCurrentUserId = Profile.getId;
    self.deleteUser = deleteUser;
    self.isCurrentUser = isCurrentUser;
    self.getCurrentUserCompany = getCurrentUserCompany;
    self.refreshAutheticationCodeByPhone = refreshAuthenticationCodeByPhone;

    function getCurrentUserCompany() {
      var companyId = Profile.getCargoCompanyId();
      if (companyId) {
        return CargoCompany.findById({id: companyId});
      }
    }

    function deleteUser(id) {
      return CargoUser.destroyById({id: id}).$promise;
    }

    function isCurrentUser(id) {
      return Profile.getId() === id;
    }

    function saveUser(user) {
      var companyId = Profile.getCargoCompanyId();
      if (angular.isDefined(user.cargoCompany) && user.cargoCompany !== null) {
        companyId = user.cargoCompany.id;
      }

      var newUser = createNewUser(user);

      if (Profile.getUserRole().indexOf('SUPER_ADMIN') >= 0 && newUser.roles.indexOf('CARGO_ADMIN') >= 0) {
        return CargoUser.create(newUser).$promise;
      } else {
        return CargoCompany.createUser({id: companyId}, newUser).$promise;
      }
    }

    function updateUser(user) {
      return CargoUser.prototype$updateAttributes(createNewUser(user)).$promise;
    }

    function getUser(userId) {
      return CargoUser.findById({id: userId, filter: {include: ['cargoCompany', 'defaultVehicle']}});
    }

    function createNewUser(user) {
      var newUser = angular.copy(user);
      newUser.cargoCompanyId = Profile.getCargoCompanyId();

      if (angular.isDefined(newUser.cargoCompany) && newUser.cargoCompany !== null) {
        newUser.cargoCompanyId = newUser.cargoCompany.id;
        delete newUser.cargoCompany;
      }

      return newUser;
    }

    function refreshAuthenticationCodeByPhone(phoneNumber) {
      return CargoUser.sendPhoneAuthenticationCode({'phone': phoneNumber });
    }

  }
}());

(function () {
  angular.module('Cargo77.trailers').service('TrailerService', TrailerService);
  /** @ngInject */
  function TrailerService(Cargo77Dictionary, Trailer, Profile) {
    var self = this;

    self.trailerTypes = Cargo77Dictionary.trailerTypes;

    self.saveTrailer = saveTrailer;
    self.updateTrailer = updateTrailer;
    self.getTrailer = getTrailer;
    self.deleteTrailer = deleteTrailer;

    function deleteTrailer (id) {
      return Trailer.destroyById({id: id}).$promise;
    }

    function saveTrailer(trailer) {
      var newTrailer = createNewTrailer(trailer);

      return Trailer.create(newTrailer).$promise;
    }

    function updateTrailer(trailer) {
      var newTrailer = createNewTrailer(trailer);

      return Trailer.prototype$updateAttributes(newTrailer).$promise;
    }

    function getTrailer(trailerId) {
      return Trailer.findById({id: trailerId, filter: {include: 'ownerCompany'}});
    }

    function createNewTrailer(trailer) {
      var newTrailer = angular.copy(trailer);
      newTrailer.ownerCompanyId = Profile.getCargoCompanyId();

      if (angular.isDefined(newTrailer.ownerCompany)) {
        newTrailer.ownerCompanyId = newTrailer.ownerCompany.id;
        delete newTrailer.ownerCompany;
      }

      return newTrailer;
    }

  }
}());

/**
 * Created by Leonel Gonçalves on 6/30/16.
 */
(function () {
  angular
    .module("Cargo77.signUp", [
      "ngMaterial",
      "ngMessages",
      "ui.router",
      "lbServices",
      "ngResource",
      "Common",
      "Cargo77.profile",
    ])
    .config(Routing);
  /** @ngInject */
  function Routing($stateProvider) {
    $stateProvider.state("signUp", {
      url: "/sign-up/",
      template: "<cargo77-sign-up></cargo77-sign-up>",
    });
    $stateProvider.state("confirm", {
      url: "/confirm?uid&token",
      template: "<cargo77-confirm></cargo77-confirm>",
    });
    $stateProvider.state("privacyPolicy", {
      url: "/privacidad",
      template: "<cargo77-privacy-policy></cargo77-privacy-policy>",
    });
  }
})();

/**
 * Created by Leonel Gonçalves on 6/29/16.
 */

(function () {
  angular.module('Cargo77.signUp').component('signUpCard', {
    templateUrl: 'app/components/sign-up/sign-up-card/sign-up-card.html',
    bindings: {
      userType: '<',
    },
    controller: SignUpCardController,
    controllerAs: 'signUpCard',
  });

  /** @ngInject */
  function SignUpCardController(SignUpService, $mdDialog, GlobalSettings) {
    var vm = this;
    vm.save = save;
    vm.showTerms = showTerms;
    vm.user = {};

    function save() {
      SignUpService.createAccount(vm.user, vm.company, vm.userType, vm.secret);
    }

    function showTerms() {
      return GlobalSettings.findOne()
        .$promise
        .then(function (response) {
          return $mdDialog.show({
            templateUrl: 'app/components/common/termsAndConditions/termsConditions.html',
            controller: 'TermsDialogController',
            locals: {
              terms: response[vm.userType.toLowerCase() + 'SignUpTerms'],
            },
            bindToController: true,
            controllerAs: '$ctrl',
          });
        })
        .then(function () {
          vm.areTermsAccepted = true;
        })
        .catch(function () {
          vm.areTermsAccepted = false;
        });
    }

  }
}());

/**
 * Created by Leonel Gonçalves on 6/29/16.
 */

(function () {
  angular.module('Cargo77.signUp').component('cargo77SignUp', {
    templateUrl: 'app/components/sign-up/sign-up/sign-up.html',
    controller: SignUpController,
    controllerAs: 'signUp',
  });

  function SignUpController ($timeout, $window) {
    var vm = this;
    vm.isCarrier = true;
    vm.focusNameInput = focusNameInput;
    vm.isTouchSupported = isTouchSupported;

    function focusNameInput (index) {
      $timeout(function () {
        $('.nameInput:eq(' + index + ')').focus();
      }, 500);
    }

    function isTouchSupported () {
      var msTouchEnabled = $window.navigator.msMaxTouchPoints;
      var generalTouchEnabled = 'ontouchstart' in $window.document.createElement('div');

      return msTouchEnabled || generalTouchEnabled;
    }
  }
}());

/**
 * Created by Leonel Gonçalves on 7/1/16.
 */

(function () {
  angular.module('Cargo77.signUp').service('SignUpService', SignUpService);
  /** @ngInject */
  function SignUpService(Account, $state, Cargo77Toast) {
    var self = this;

    self.createAccount = createAccount;

    function createAccount(user, company, type, secret) {
      var userObject = {
        user: user,
        type: type,
        secret:secret,
      };
      if (angular.isDefined(company)) {
        userObject.company = company;
      }

      return Account.create(userObject)
        .$promise
        .then(function () {
          $state.go('confirm');
          if (type === 'carrier') {
            Cargo77Toast.successToast('Gracias por registrarte en Cargo77. Por favor revisa tu correo para completar tu registro.');
          } else {
            Cargo77Toast.successToast('Gracias por registrarte en Cargo77');
          }
        })
        .catch(function () {
          Cargo77Toast.errorToast('Hubo un error en la creación de usuario.');
        });

    }
  }

}());

(function () {
  angular.module('Cargo77.signUp').component('cargo77PrivacyPolicy', {
    templateUrl: 'app/components/sign-up/privacy-policy/privacy-policy.html',
    controller: PrivacyPolicyController,
    controllerAs: '$ctrl',
  });

  function PrivacyPolicyController(GlobalSettings) {
    var vm = this;
    vm.$onInit = onInit;
    vm.terms = '';
    function onInit() {
      GlobalSettings.findOne().$promise.then(function (response) {
        vm.terms = response['carrier' + 'SignUpTerms'];
      });
    }
  }
})();

/**
 * Created by Leonel Gonçalves on 6/29/16.
 */

(function () {
  angular.module('Cargo77.signUp').component('cargo77Confirm', {
    templateUrl: 'app/components/sign-up/confirm/confirm.html',
    controller: ConfirmController,
  });

  /** @ngInject */
  function ConfirmController(CargoUser, $stateParams, Cargo77Toast) {
    var vm = this;
    vm.$onInit = onInit;

    function onInit() {
      CargoUser.confirm({uid: $stateParams.uid, token: $stateParams.token})
        .$promise
        .then(function () {
          Cargo77Toast.successToast('Su cuenta ha sido activada.');
        });
    }
  }

}());

(function () {
    angular.module('Cargo77.reports').component('cargo77Reports', {
      templateUrl: 'app/components/reports/components/reports.html',
    });
  }());
(function () {
  angular.module('Cargo77.payments').service('PaymentsService', PaymentsService);
  angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 2000);
  
  /** @ngInject */
  function PaymentsService(Order, $q) {

    var self = this;
    var orderList;
    var ordersBackup = [];
    var isListEnd;
    self.getSortedOrdersByScheduledDate = getSortedOrdersByScheduledDate;
    self.acceptPayment = acceptPayment;
    self.rejectPayment = rejectPayment;
    self.setToVerifyingStatus = setToVerifyingStatus;
    self.OrdersList = OrdersList;

    // TODO. this function should be refactored. and perhaps use an order instance to call for verifyPayment
    function acceptPayment(id) {
      // TODO: verifyPayment is defined in Order.prototype. Previously was implemented as:
      // TODO: Order.verifyPayment({id: id}).$promise;
      return $q.resolve(true);
    }

    function rejectPayment(id) {
      return Order.rejectPayment({id: id}).$promise;
    }
    function setToVerifyingStatus(id) {
      return Order.setToVerifyingStatus({id: id}).$promise;
    }

    function findOrders(filters, skip) {
      return Order.find({
        filter: {
          include: [
            {
              relation: 'offers',
              scope: {
                where: {
                  and: [{isAccepted: true}],
                },
                fields: ['price', 'creatorId', 'orderId', 'id'],
              },
            },
            {
              relation: 'cargoUser',
              scope: {
                fields: ['firstName', 'photo', 'lastName'],
              },
            },
            {
              relation: 'cargoCompany',
              scope: {
                fields: ['name', 'documentNumber'],
              },
            },
          ],
          where: filters,
          limit: 10,
          skip: skip || 0,
          order: ['createdAt DESC'],
        },
      }).$promise;
    }

    function getSortedOrdersByScheduledDate(passedFilters, skip, reset) {
      var deferred = $q.defer();
      var filters = Object.assign({}, angular.copy(passedFilters));
      var searchText = filters.searchText;
      filters.and.push({acceptedOfferSummary: {neq: null}});
      filters.and.push({'payment.status':passedFilters.status});
      filters.and.push({'createdByCompanyType': {neq: 'CARRIER'}});
      delete filters.searchText;
      delete filters.status;

      filters.or = [];
      filters.and.push({
        or: [
          {and: [{orderStatus: 'REQUESTING_OFFERS'}, {'payment.status': 'FAILED'}]},
          {orderStatus: {inq: ['PROCESSING_PAYMENT', 'ACTIVE','COMPLETED', 'DELIVERED']}},
        ],
      });

      filters.or.push({'id': {like: searchText, options: 'i'}});
      filters.or.push({'route.pickupAddress.locality': {like: searchText, options: 'i'}});
      filters.or.push({'route.pickupAddress.subLocality': {like: searchText, options: 'i'}});
      filters.or.push({'route.pickupAddress.neighborhood': {like: searchText, options: 'i'}});
      filters.or.push({'cargoCompany.name': {like: searchText, options: 'i'}});

      findOrders(filters, skip)
        .then(function (orders) {
          if (reset) {
            ordersBackup = [];
            isListEnd = false;
          }
          if (orders.length === 0) {
            isListEnd = true;
          }
          ordersBackup = _.uniqBy(ordersBackup.concat(orders), 'id');
          deferred.resolve(ordersBackup);
        });

      return deferred.promise;
    }

    function OrdersList(filters) {
      ordersBackup = [];
      orderList = this;
      orderList.items = [];
      orderList.init = true;
      orderList.busy = false;
      orderList.skip = 0;
      orderList.filters = filters;
      isListEnd = false;
    }

    OrdersList.prototype.nextPage = function () {

      if (orderList.busy || (isListEnd && !orderList.busy)) {
        return;
      }

      orderList.busy = true;

      self.getSortedOrdersByScheduledDate(orderList.filters, orderList.skip)
        .then(function (response) {
          orderList.items = response;
          orderList.busy = false;
          orderList.init = false;
          orderList.skip = orderList.skip + 5;
        });
    };

  }
}());

(function () {

  angular.module('Cargo77.orders').service('OrderCommonService', OrderCommonService);

  /** @ngInject */
  function OrderCommonService($http, $q, cargo77Config, Cargo77Dictionary) {
    var self = this;
    var extraFieldsTypes = Cargo77Dictionary.getOrderExtraFieldsInputTypes();
    self.setOrderPickupTimezone = setOrderPickupTimezone;
    self.getOrderDetails = getOrderDetails;
    self.areFilesRelatedToOrderDetail = areFilesRelatedToOrderDetail;
    self.getOrderFiles = getOrderFiles;

    function setOrderPickupTimezone (pickupCoordinates, pickupDateTimestamp) {

      var latitude = pickupCoordinates.lat;
      var longitude = pickupCoordinates.lng;
      var timestamp = pickupDateTimestamp / 1000 ;
      var APIKey = cargo77Config. googleMapsAPIKey;
      var googleMapsBaseURL = cargo77Config.googleMapsBaseURL;
      var requestDirection = googleMapsBaseURL + latitude + ',' + longitude + '&timestamp=' + timestamp + '&key=' + APIKey;

      return $http.get(requestDirection);
    }
    function getOrderDetails(extraFields, extraFieldsDefinitions) {
      if(!extraFields) {
        return;
      }
      var relatedDefinition;
      var result = {};
      extraFields.forEach(function(extraField) {
        relatedDefinition = _.find(extraFieldsDefinitions, function(extraFieldDefinition) {
            return  extraFieldDefinition.id.toString() === extraField.definitionId.toString();
        });

        if(!relatedDefinition || !relatedDefinition.isActive) {
          return;
        }

        if(relatedDefinition.inputType !== extraFieldsTypes.FILE) {
          result[relatedDefinition.name] = extraField.value;
        }
      });
      return result;
    }

    function areFilesRelatedToOrderDetail(extraFields, extraFieldsDefinitions) {
      if(!extraFields) {
        return false;
      }
      var detailsHaveFile = false;
      var firstFileExtraFieldFound;
      var extraFieldDefinitionsWithFileType = _.filter(extraFieldsDefinitions, function (extraFieldDefinition) {
        return extraFieldDefinition.inputType === extraFieldsTypes.FILE;
      });

      extraFieldDefinitionsWithFileType.forEach(function(definitionWithFileType) {
        firstFileExtraFieldFound = _.find(extraFields, function(extraField) {
          return extraField.definitionId.toString() === definitionWithFileType.id.toString();
        });
        if(firstFileExtraFieldFound) {
          detailsHaveFile = true;
        }
      });
      return detailsHaveFile;
    }

    function getOrderFiles(extraFields, extraFieldsDefinitions) {
      if(!extraFields) {
        return;
      }
      var relatedDefinition;
      var result = {};
      extraFields.forEach(function(extraField) {
        relatedDefinition = _.find(extraFieldsDefinitions, function(extraFieldDefinition) {
          return  extraFieldDefinition.id.toString() === extraField.definitionId.toString()
            && extraFieldDefinition.inputType === extraFieldsTypes.FILE;
        });

        if(relatedDefinition) {
          result[relatedDefinition.name] = extraField.value;
        }
      });
      return result;
    }
  }
}());

/**
 * Created by Leonel Gonçalves on 6/30/16.
 */
(function () {

  angular.module('Cargo77.login', [
    'ngMaterial',
    'ngMessages',
    'ui.router',
    'lbServices',
    'ngResource',
    'Cargo77.profile',
    'Common'])
    .config(Routing);
  /** @ngInject */
  function Routing ($stateProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        template: '<cargo77-login></cargo77-login>',
      });
    $stateProvider
      .state('recoveryPasswordEmail', {
        url: '/recoveryPasswordEmail',
        template: '<cargo77-recovery-password-email></cargo77-recovery-password-email>',
      });
    $stateProvider
      .state('forgotPassword', {
        url: '/forgot-password?accessTokenId',
        template: '<cargo77-forgot-password></cargo77-forgot-password>',
      });
  }

}());

(function () {
  angular.module('Cargo77.login').component('cargo77RecoveryPasswordEmail', {
    templateUrl: 'app/components/login/recoveryPasswordEmail/recoveryPasswordEmail.html',
    controller: RecoveryPasswordEmailController,
  });

  /** @ngInject */
  function RecoveryPasswordEmailController(Cargo77Toast, CargoUser, $state) {
    var vm = this;

    vm.sendRecoveryEmail = sendRecoveryEmail;

    function sendRecoveryEmail () {
      CargoUser.resetPassword({}, {email: vm.email.toLowerCase()}).$promise
        .then(function () {
          Cargo77Toast.defaultToast('El email ha sido enviado, revisa tu bandeja de entrada.', 'mail');
          $state.go('login');
        })
        .catch(function (response) {
          Cargo77Toast.errorToast(null, response.data.error);
        });
    }
  }

}());

/**
 * Created by Leonel Gonçalves on 6/29/16.
 */

(function () {
  angular.module('Cargo77.login').component('loginCard', {
    templateUrl: 'app/components/login/login-card/login-card.html',
    bindings: {},
    controller: LoginCardController,
    controllerAs: 'loginCard',
  });

  /** @ngInject */
  function LoginCardController(CargoUser, $state, $firebaseAuth, Profile, Cargo77Toast, CargoCompany, SearchBarService) {
    var vm = this;

    vm.login = login;
    vm.rememberMe = false;

    function login() {
      vm.user.email = vm.user.email.toLowerCase();
      var fetchedData, loggedUser;
      Profile.clearStorage();
      SearchBarService.clearSearchText();

      CargoUser.login({include: 'user', rememberMe: vm.rememberMe}, vm.user)
        .$promise
        .then(function (data) {
          fetchedData = data;
          loggedUser = angular.copy(fetchedData.user);
          var userRelatedCargoCompanyId = loggedUser.cargoCompanyId ? loggedUser.cargoCompanyId : '';
          return CargoCompany.find({where:{'id':userRelatedCargoCompanyId}}).$promise;
        })
        .then(function(userRelatedCargoCompany) {
          var isUserAdmin = loggedUser.roles.indexOf('CARGO_ADMIN') !== -1;
          var parentCargoCompanyId = userRelatedCargoCompany && userRelatedCargoCompany[0]
          &&  userRelatedCargoCompany[0].parentCompanyId ? userRelatedCargoCompany[0].parentCompanyId : null;
          loggedUser.parentCompanyId = parentCargoCompanyId;
          if(isUserAdmin) {
            loggedUser.parentCompanyId = null;
          }
          Profile.save(loggedUser);
          return $firebaseAuth().$signInWithCustomToken(fetchedData.firebaseToken);
        })
        .then(function () {
          $state.go('cargo.dashboard');
        })
        .catch(function (error) {

          if (error.data.error.code === 'LOGIN_FAILED_EMAIL_NOT_VERIFIED') {
            CargoUser.resendConfirmationEmail({email: vm.user.email});
          }

          Cargo77Toast.errorToast(null, error.data.error);
        });
    }
  }
}());

/**
 * Created by Leonel Gonçalves on 6/29/16.
 */

(function () {
  angular.module('Cargo77.login').component('cargo77ForgotPassword', {
    templateUrl: 'app/components/login/forgotPassword/forgotPassword.html',
    controller: ForgotPasswordController,
  });

  /** @ngInject */
  function ForgotPasswordController(Cargo77Toast, $state, $stateParams, CargoUser, LoopBackAuth) {
    var vm = this;

    vm.resetPassword = resetPassword;

    function resetPassword() {
      LoopBackAuth.setUser($stateParams.accessTokenId);
      LoopBackAuth.save();
      CargoUser.resetUserPassword({}, {
        password: vm.password,
      })
        .$promise
        .then(function () {
          $state.go('login');
          Cargo77Toast.successToast('Tu contraseña fue actualizada correctamente.');
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error);
        });
    }

  }

}());

(function () {
  angular.module('Cargo77.locations').service('LocationService', LocationService);
  /** @ngInject */
  function LocationService(Location) {
    var self = this;

    self.saveLocation = saveLocation;
    self.getLocation = getLocation;
    self.updateLocation = updateLocation;
    self.deleteLocation = deleteLocation;

    function getLocation(locationId) {
      return Location.findById({'id':locationId, filter: {include: 'company'}});
    }

    function saveLocation(location) {
      return Location.create(location).$promise;
    }
    function updateLocation(location) {
      return Location.prototype$updateAttributes(location).$promise;
    }
    function deleteLocation(locationId) {
      return Location.destroyById({'id': locationId}).$promise;
    }
  }
}());

/**
 * Created by Leonel Gonçalves on 7/3/16.
 */

(function () {
  angular.module('Common').component('cargo77VehicleSelector', {
    templateUrl: 'app/components/common/vehicle-selector/vehicle-selector.html',
    controller: VehicleSelectorController,
    bindings: {
      vehicles: '<',
      selectedVehicle: '=ngModel',
      cargoCompanyId: '<',
    },
  });

  function VehicleSelectorController() {
    var vm = this;
    vm.selectVehicle = selectVehicle;
    function selectVehicle(vehicle) {
      vm.selectedVehicle = vehicle;
    }

  }

}());

(function () {
  angular.module('Common').component('cargo77VehicleSearchSelector', {
    templateUrl: 'app/components/common/vehicle-search-selector/vehicle-search-selector.html',
    controller: VehicleSearchSelectorController,
    bindings: {
      vehicles: '<',
      selectedVehicle: '=ngModel',
      cargoCompanyId: '<',
      disabled: '<',
      selection: '@',
      formReference: '<',
      required: '@',
    },
  });

  function VehicleSearchSelectorController() {
    var vm = this;
    vm.$onInit = onInit;
    vm.selectVehicle = selectVehicle;
    vm.required = !!vm.required;
    vm.searchTextChange = searchTextChange;
    vm.changeVehicle = changeVehicle;

    function onInit() {
      if (vm.selectedVehicle) {
        vm.previousSearchText = vm.selectedVehicle.plate;
      }
    }

    function changeVehicle() {
      if (vm.selectedVehicle) {
        vm.previousSearchText = vm.selectedVehicle.name;
      }
    }

    function searchTextChange() {
      if (!vm.vehicleSearchText) {
        return;
      }
      if (vm.previousSearchText && vm.vehicleSearchText.length < vm.previousSearchText.length) {
        vm.vehicleSearchText = '';
      }
      vm.previousSearchText = vm.vehicleSearchText;
    }

    function selectVehicle(vehicle) {
      vm.selectedVehicle = vehicle;
    }
  }
}());

/**
 * Created by Leonel Gonçalves on 7/3/16.
 */

(function () {
  angular.module('Common').component('cargo77TimeSelector', {
    templateUrl: 'app/components/common/time-selector/time-selector.html',
    controller: TimeController,
    bindings: {
      times: '<',
      selectedDate: '=',
      selectedTime: '=',
      isOwnOrder:'<',
    },
  });
  /** @ngInject */
  function TimeController(moment) {
    var vm = this;
    vm.minDate = moment();

    vm.selectTime = selectTime;
    vm.format = format;
    vm.validateTimes = validateTimes;

    function selectTime(time) {
      vm.selectedTime = time;
    }

    function format(time) {
      return moment(time).format('h:mm a');
    }

    function validateTimes() {

      if (moment() < vm.selectedDate) {
        vm.availableTimes = vm.times;
        vm.minTime = undefined;
        return;
      }

      var currentTime = moment().add(2, 'hours').format('HH:mm');
      var availableTimes = [];
      for (var i = 0; i < vm.times.length; i++) {
        var time = vm.times[i];
        if (angular.isDefined(time.min) && angular.isDefined(time.max)) {
          if ((currentTime > time.min && currentTime < time.max) || (currentTime < time.min)
            || (currentTime > time.min && time.label === 'evening')) {
            availableTimes.push(time);
          }
        }
      }
      vm.minTime = moment().add(2, 'hours');
      vm.availableTimes = availableTimes;
    }
  }
}());

(function () {
  angular.module('Common').controller('TermsDialogController', TermsDialogController);

  /** @ngInject */
  function TermsDialogController($mdDialog) {
    var self = this;
    self.close = close;
    self.accept = accept;

    function close() {
      $mdDialog.cancel();
    }

    function accept() {
      $mdDialog.hide();
    }
  }
}());

(function () {
    angular.module('Common').service('SearchBarService', SearchBarService);
  
    /** @ngInject */
    function SearchBarService() {
      var searchText = '';
  
      function setSearchText(value) {
        searchText = value;
      }
  
      function getSearchText() {
        return searchText;
      }
  
      function clearSearchText() {
        searchText = '';
      }
  
      return {
        setSearchText: setSearchText,
        getSearchText: getSearchText,
        clearSearchText: clearSearchText,
      };
    }
  }());
  
/**
 * Created by Leonel Gonçalves on 7/8/16.
 */

(function () {
  angular.module('Common').component('cargo77SearchBar', {
    templateUrl: 'app/components/common/search-bar/search-bar.html',
    controller: SearchBarController,
    controllerAs: 'searchBar',
    bindings: {
      userType: '<',
      statusFilterOptions: '<',
      sizesFilterOptions: '<',
      onStatusFilterChange: '&?',
      onDateFilterChange: '&?',
      onSearchTextFilterChange: '&?',
      onRoleFilterChange: '&?',
      onDriverCarrierShowOwnOrdersFilterChange: '&?',
      onLoadSizeFilterChange: '&?',
      onParentCompanyFilterChange: '&?',
      companyType: '@?',
      initialSearchText: '@?',
    },
  });

  /** @ngInject */
  function SearchBarController (Profile, Cargo77Companies) {
    var vm = this;
    var customDate = new Date();
    var dates = {
      week: {min: moment().day(1), max: moment().day(7)},
      today: {min: moment().hour(0).minutes(0), max: moment().hours(23).minute(59)},
      month: {min: moment().date(1), max: moment().date(moment().daysInMonth())},
      custom: {min: moment(customDate).minutes(0), max: moment(customDate).add(1, 'd').hours(0).minute(0)},
    };

    Object.defineProperty(vm, 'customDate', {
      get: function () {
        return customDate;
      },
      set: function (newValue) {
        customDate = newValue;
        dates.custom = {
          min: moment(customDate).hours(0).minutes(0),
          max: moment(customDate).add(1, 'd').hours(0).minute(0),
        };
        vm.changeDate('custom');
      },
    });

    switch (Profile.getUserPrimaryRole()) {
      case 'CARRIER_USER':
      case 'CARRIER_OWNER':
        vm.isCarrier = true; break;
      case 'SHIPPER_OWNER':
      case 'SHIPPER_USER':
        vm.isShipper = true; break;
      case 'CARGO_ADMIN':
        vm.isAdmin = true; break;
      case 'DRIVER':
        vm.isDriver = true; break;
      default:
        vm.isSuperadmin = true;
    }

    vm.$onInit = onInit;
    vm.status = vm.statusFilterOptions || [];
    vm.loadSizes = vm.sizesFilterOptions;
    vm.isSearchOpen = false;
    vm.changeStatus = changeStatus;
    vm.changeLoadSize = changeLoadSize;
    vm.changeDate = changeDate;
    vm.changeRole = changeRole;
    vm.openSearch = openSearch;
    vm.changeDriverCarrierShowOnlyValue = changeDriverCarrierShowOnlyValue;
    vm.isUserCarrierAndDriver = isUserCarrierAndDriver;
    vm.companies = [];
    vm.changeParentCompany = changeParentCompany;

    var searchText = '';
    vm.searchText = searchTextGetterSetter;

    function onInit() {
      vm.status.forEach(function(status) {
        status.title = status.title.charAt(0).toUpperCase() + status.title.slice(1);
      });
      searchText = vm.initialSearchText;
      getCompanies();
    }

    function searchTextGetterSetter (newValue) {
      if (!arguments.length) {
        return searchText;
      }

      searchText = newValue;
      vm.onSearchTextFilterChange({searchText: searchText});
    }

    function openSearch() {
      $('.search-input').css('max-width', '200px');
      $('.search-input').focus();
    }

    function changeStatus (status) {
      vm.onStatusFilterChange({status: status.label});
    }

    function changeLoadSize(size) {
      vm.onLoadSizeFilterChange({loadSize: size.label});
    }

    function formatDates (dates) {
      return {
        min: dates.min.format('YYYY-MM-DD HH:mm'),
        max: dates.max.format('YYYY-MM-DD HH:mm'),
      };
    }

    function changeDate (date) {
      if (date !== 'all') {
        return vm.onDateFilterChange({date: formatDates(dates[date])});
      }
      vm.onDateFilterChange({date: undefined});
    }

    function changeRole (role) {
      if (role !== 'ALL') {
        return vm.onRoleFilterChange({role: role});
      }
      vm.onRoleFilterChange({role: undefined});
    }

    function changeDriverCarrierShowOnlyValue () {
      vm.onDriverCarrierShowOwnOrdersFilterChange({showOwnOrdersValue: !vm.isShowingDriverCarrierOnlyOwnOrders});
    }

    function isUserCarrierAndDriver () {
      var userRoles =  Profile.getCurrentUser().roles;
      return (_.includes(userRoles, 'CARRIER_OWNER') || _.includes(userRoles, 'CARRIER_USER')) && _.includes(userRoles, 'DRIVER');
    }

    function changeParentCompany (company) {
      vm.onParentCompanyFilterChange({company: company});
    }

    function getCompanies () {
      if(!angular.isDefined(vm.onParentCompanyFilterChange)){
        return;
      }

      Cargo77Companies.getParentAndChildren(buildFilterQuery(vm.companyType)).then(function(results) {
        vm.companies = results;
      });
    }

    function buildFilterQuery(companyType) {
      if(companyType !== 'SHIPPER' && companyType !== 'CARRIER') {
        return {};
      }

      return {
        or: [
          {
            and:[
              {
                parentCompanyId: { exists: false },
                type: 'CARRIER',
              },
            ],
          },
          {
            and:[
              {
                parentCompanyId: { exists: true },
                type: companyType,
              },
            ],
          },
        ],
      };
    }

  }
}());

(function () {
  angular.module('Common').component('cargo77RouteWithDetailsSelector', {
    templateUrl: 'app/components/common/route-with-details-selector/route-with-details-selector.html',
    controller: RouteWithDetailsSelectorController,
    bindings: {
      'route': '=',
      'onChangeRoute': '&',
      'onSavingSegmentFiles': '&',
      'selectedCompanyId': '<',
      'isShipperOrder': '<',
      'carrierCompanyId': '=',
    },
  });

  function RouteWithDetailsSelectorController() {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.changeRouteLocations = changeRouteLocations;
    vm.changeRouteSegments = changeRouteSegments;
    vm.shouldShowContent = shouldShowContent;
    vm.savingSegmentFiles = savingSegmentFiles;

    function onChanges(changes) {
      if(!changes.selectedCompanyId) {
        return;
      }
      var selectedCompanyChange = changes.selectedCompanyId;
      var validCompanyChange = selectedCompanyChange.currentValue
        && selectedCompanyChange.currentValue !== selectedCompanyChange.previousValue;

      if (validCompanyChange) {
        vm.route = {
          locations: [],
          segments: [],
        };
        vm.onChangeRoute({segments: vm.route.segments});
      }
    }

    function shouldShowContent() {
      return vm.isShipperOrder || !vm.isShipperOrder && !!vm.selectedCompanyId;
    }

    function onInit() {
      if(!vm.route || !vm.route.locations || !vm.route.segments) {
        vm.route = {
          locations: [],
          segments: [],
        };
      }
    }

    function changeRouteLocations(locations) {
      if(!locations) {
        return;
      }
      vm.route.locations = locations;
    }

    function changeRouteSegments(segments) {
      if(!segments) {
        return;
      }
      vm.route.segments = segments;
      vm.onChangeRoute({segments: segments});
    }

    function savingSegmentFiles(saved, saving){
      vm.onSavingSegmentFiles({'saved': saved, 'saving': saving});
    }
  }

}());

/**
 * Created by Leonel Gonçalves on 7/9/16.
 */

(function () {
  angular.module('Common').service('RouteSelectorService', RouteSelectorService);

  /** @ngInject */
  function RouteSelectorService (uiGmapGoogleMapApi, $q) {
    var self = this;
    var mapApi;
    var distanceService;
    var geocodeService;
    self.calculateDistance = calculateDistance;
    self.getGeocoding = getGeocoding;
    self.getMapBasicData = getMapBasicData;
    uiGmapGoogleMapApi.then(function (maps) {
      mapApi = maps;
      distanceService = new mapApi.DistanceMatrixService();
      geocodeService = new mapApi.Geocoder();
    });

    function calculateDistance (from, to) {
      var deferred = $q.defer();

      if (angular.isDefined(from) && angular.isDefined(to)) {
        var origin = new mapApi.LatLng(from.latitude, from.longitude);
        var destination = new mapApi.LatLng(to.latitude, to.longitude);

        distanceService.getDistanceMatrix({
          origins: [origin],
          destinations: [destination],
          travelMode: mapApi.DirectionsTravelMode.DRIVING,
        }, function (response) {
          deferred.resolve(response.rows[0].elements[0]);
        });
      } else {
        deferred.reject();
      }

      return deferred.promise;

    }

    function getGeocoding (coordinates) {
      var deferred = $q.defer();
      var coords = new mapApi.LatLng(coordinates.latitude, coordinates.longitude);
      geocodeService.geocode({location: coords}, function (response) {
        deferred.resolve(response[0]);
      });

      return deferred.promise;

    }

    function getMapBasicData () {
      return {
        center: {latitude: 0, longitude: 0},
        zoom: 11,
        options: {
          mapTypeControl: false,
          streetViewControl: false,
        },
        clickedMarker: {
          id: 0,
          options: {},
        },
        searchbox: {
          template: 'searchbox.tpl.html',
          options: {
            autocomplete: true,
          },
        },
      };
    }
  }
}());

/**
 * Created by Leonel Gonçalves on 7/9/16.
 */
(function () {
  angular.module('Common').component('cargo77RouteSelector', {
    templateUrl: 'app/components/common/route-selector/route-selector.html',
    controller: RouteSelectorController,
    controllerAs: 'routeSelector',
    bindings: {
      route: '<',
      onRouteChange: '&',
      isOwnOrder: '<',
    },
  });
  /** @ngInject */
  function RouteSelectorController($window, $scope, RouteSelectorService) {
    var vm = this;
    var isInitialized = false;

    vm.$onChanges = onChanges;
    vm.$onInit = onInit;

    function onChanges(changes) {
      if (changes.route.currentValue.pickupCoordinates && changes.route.currentValue.deliveryCoordinates) {
        initExistingRoute();
        isInitialized = true;
      }
    }

    function getBounds(latitude, longitude) {
      return {
        northeast: {
          latitude: latitude + 0.0025,
          longitude: longitude + 0.0025,
        },
        southwest: {
          latitude: latitude - 0.0025,
          longitude: longitude - 0.0025,
        },
      };
    }

    function processClickEvent(event, routeType) {

      var coordinates = {
        latitude: event.latLng.lat(),
        longitude: event.latLng.lng(),
      };

      updateRouteTypeInfo(routeType, coordinates);

      RouteSelectorService
        .calculateDistance(vm.pickupMapOptions.clickedMarker.coords, vm.deliveryMapOptions.clickedMarker.coords)
        .then(setDistance);

    }

    function updateRouteTypeInfo(routeType, coordinates) {
      vm.route[routeType + 'Coordinates'] = {
        lat: coordinates.latitude,
        lng: coordinates.longitude,
      };

      vm[routeType + 'MapOptions'].clickedMarker = {
        id: 0,
        coords: coordinates,
      };

      RouteSelectorService.getGeocoding(vm[routeType + 'MapOptions'].clickedMarker.coords)
        .then(function (direction) {
          vm.route[routeType + 'Address'].address = direction.formatted_address;
          vm.onRouteChange({route: vm.route});
        });
    }

    function setDistance(data) {
      vm.routeDistance = data.distance;
    }

    function onInit() {
      initializeMapVariables();
      $window.navigator.geolocation.getCurrentPosition(function (response) {
        if (!isInitialized) {
          vm.pickupMapOptions.center = {
            latitude: response.coords.latitude,
            longitude: response.coords.longitude,
          };
          vm.deliveryMapOptions.center = {
            latitude: response.coords.latitude,
            longitude: response.coords.longitude,
          };
          $scope.$evalAsync();
        }
      });
    }

    function initExistingRoute() {
      vm.deliveryMapOptions.clickedMarker = {
        id: 0,
        coords: {latitude: vm.route.deliveryCoordinates.lat, longitude: vm.route.deliveryCoordinates.lng},
      };

      vm.deliveryMapOptions.center = vm.deliveryMapOptions.clickedMarker.coords;
      vm.deliveryMapOptions.zoom = 15;

      vm.pickupMapOptions.clickedMarker = {
        id: 0, coords: {latitude: vm.route.pickupCoordinates.lat, longitude: vm.route.pickupCoordinates.lng},
      };

      vm.pickupMapOptions.center = vm.pickupMapOptions.clickedMarker.coords;
      vm.pickupMapOptions.zoom = 15;

      vm.routeDistance = vm.route.distance;
      $scope.$evalAsync();
    }

    function initializeMapVariables() {
      initializePickupMap();
      initializeDeliveryMap();
    }

    function initializePickupMap() {
      vm.pickupMapOptions = angular.copy(RouteSelectorService.getMapBasicData());
      vm.pickupMapOptions.center = {latitude: -0.1865937, longitude: -78.5706251};
      vm.pickupMapOptions.options.disableDefaultUI = false;
      vm.pickupMapOptions.events = {
        click: function (mapModel, eventName, originalEventArgs) {
          processClickEvent(originalEventArgs[0], 'pickup');
          $scope.$evalAsync();
        },
      };

      vm.pickupMapOptions.searchbox.events = {
        place_changed: function (autoComplete) {
          var place = autoComplete.getPlace();
          if (place.address_components) {
            vm.pickupMapOptions.clickedMarker = {
              id: 0,
              coords: {
                latitude: place.geometry.location.lat(),
                longitude: place.geometry.location.lng(),
              },
            };
            vm.route.pickupCoordinates = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            };
            RouteSelectorService
              .getGeocoding(vm.pickupMapOptions.clickedMarker.coords)
              .then(function (direction) {
                vm.route.pickupAddress.address = direction.formatted_address;
                vm.onRouteChange({route: vm.route});
              });
            RouteSelectorService
              .calculateDistance(vm.pickupMapOptions.clickedMarker.coords, vm.deliveryMapOptions.clickedMarker.coords)
              .then(setDistance);
            vm.pickupMapOptions.bounds = getBounds(place.geometry.location.lat(), place.geometry.location.lng());
          }
        },
      };
    }

    function initializeDeliveryMap() {
      vm.deliveryMapOptions = angular.copy(RouteSelectorService.getMapBasicData());
      vm.deliveryMapOptions.center = {latitude: -0.1865937, longitude: -78.5706251};
      vm.deliveryMapOptions.events = {
        click: function (mapModel, eventName, originalEventArgs) {
          processClickEvent(originalEventArgs[0], 'delivery');
          $scope.$evalAsync();
        },
      };
      vm.deliveryMapOptions.searchbox.events = {
        place_changed: function (autoComplete) {

          var place = autoComplete.getPlace();
          if (place.address_components) {
            vm.deliveryMapOptions.clickedMarker = {
              id: 0,
              coords: {
                latitude: place.geometry.location.lat(),
                longitude: place.geometry.location.lng(),
              },
            };

            vm.route.deliveryCoordinates = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            };
            RouteSelectorService.getGeocoding(vm.deliveryMapOptions.clickedMarker.coords)
              .then(function (direction) {
                vm.route.deliveryAddress.address = direction.formatted_address;
                vm.onRouteChange({route: vm.route});
              });
            RouteSelectorService
              .calculateDistance(vm.pickupMapOptions.clickedMarker.coords, vm.deliveryMapOptions.clickedMarker.coords)
              .then(setDistance);
            vm.deliveryMapOptions.bounds = getBounds(place.geometry.location.lat(), place.geometry.location.lng());
          }
        },
      };
    }
  }
}());

(function () {
  angular.module('Common').component('cargo77RoleSelector', {
    templateUrl: 'app/components/common/role-selector/role-selector.html',
    controller: RoleSelectorController,
    bindings: {
      company: '<',
      selectedRoles: '=ngModel',
    },
  });

  function RoleSelectorController() {
    var vm = this;
    vm.exists = exists;
    vm.toggle = toggle;
    vm.selectableRoles = [];
    vm.setSelectableRoles = setSelectableRoles;

    // vm.company.currentValue.type;

    function setSelectableRoles() {
      vm.selectableRoles = [];

      if (!vm.selectedRoles || vm.selectedRoles.length === 0) {
        vm.selectableRoles = ['CARGO_ADMIN', 'SHIPPER_OWNER', 'SHIPPER_USER', 'CARRIER_USER', 'CARRIER_OWNER', 'DRIVER', 'CARRIER_VIEWER', 'SHIPPER_VIEWER'];
        return;
      }

      var selectableRoles = {
        'CARRIER_OWNER': ['CARRIER_OWNER', 'DRIVER'],
        'CARRIER_USER': ['CARRIER_USER', 'DRIVER'],
        'SHIPPER_OWNER': ['SHIPPER_OWNER'],
        'SHIPPER_USER': ['SHIPPER_USER'],
        'DRIVER': ['DRIVER', 'CARRIER_OWNER', 'CARRIER_USER'],
        'CARGO_ADMIN': ['CARGO_ADMIN'],
        'CARRIER_VIEWER': ['CARRIER_VIEWER'],
        'SHIPPER_VIEWER' : ['SHIPPER_VIEWER'],
      };

      for (var i = 0; i < vm.selectedRoles.length; i++) {
        vm.selectableRoles = _.union(vm.selectableRoles, selectableRoles[vm.selectedRoles[i]]);
      }
      if (_.includes(vm.selectedRoles, 'CARRIER_OWNER')) {
        _.pull(vm.selectableRoles, 'CARRIER_USER');
      }

      if (_.includes(vm.selectedRoles, 'CARRIER_USER')) {
        _.pull(vm.selectableRoles, 'CARRIER_OWNER');
      }

      return vm.selectableRoles;
    }

    function exists(role) {
      if (angular.isArray(vm.selectedRoles)) {
        return vm.selectedRoles.indexOf(role) >= 0;
      }

      return false;
    }

    function toggle(role) {
      var exist = vm.selectedRoles.indexOf(role);
      if (exist >= 0) {
        vm.selectedRoles.splice(exist, 1);
        setSelectableRoles();
        return;
      }
      vm.selectedRoles.push(role);
      setSelectableRoles();
    }

  }

}());

(function () {
  angular.module('Common').service('LocationSelectorService', LocationSelectorService);

  /** @ngInject */
  function LocationSelectorService (uiGmapGoogleMapApi, $q) {
    var self = this;
    var mapApi;
    var geocodeService;
    self.getGeocoding = getGeocoding;
    self.getMapBasicData = getMapBasicData;
    uiGmapGoogleMapApi.then(function (maps) {
      mapApi = maps;
      geocodeService = new mapApi.Geocoder();
    });

    function getGeocoding (coordinates) {
      var deferred = $q.defer();
      var coords = new mapApi.LatLng(coordinates.latitude, coordinates.longitude);
      geocodeService.geocode({location: coords}, function (response) {
        deferred.resolve(response[0]);
      });

      return deferred.promise;
    }

    function getMapBasicData () {
      return {
        center: {latitude: 0, longitude: 0},
        zoom: 11,
        options: {
          mapTypeControl: false,
          streetViewControl: false,
          zoomControl: true,
        },
        clickedMarker: {
          id: 0,
          options: {},
        },
        searchbox: {
          template: 'searchbox.tpl.html',
          options: {
            autocomplete: true,
            componentRestrictions: {
              country: ['ec', 'col', 'pe'],
            },
          },
        },
      };
    }
  }
}());

(function () {
  angular.module('Common').component('cargo77LocationSelector', {
    templateUrl: 'app/components/common/location-selector/location-selector.html',
    controller: LocationSelectorController,
    controllerAs: 'locationSelector',
    bindings: {
      location: '<',
      onLocationChange: '&',
      showRequiredError: '=',
    },
  });
  /** @ngInject */
  function LocationSelectorController($window, $scope, LocationSelectorService) {
    var vm = this;
    var isInitialized = false;

    vm.$onInit = onInit;

    function onInit() {
      initializeMapVariables();

      $window.navigator.geolocation.getCurrentPosition(function(response) {
        if (!isInitialized) {
          vm.mapOptions.center = {
            latitude: response.coords.latitude,
            longitude: response.coords.longitude,
          };
          $scope.$evalAsync();
        }
        if (vm.location.coordinates) {
          initExistingLocation();
          isInitialized = true;
        }
      });
    }

    function getBounds(latitude, longitude) {
      return {
        northeast: {
          latitude: latitude + 0.0025,
          longitude: longitude + 0.0025,
        },
        southwest: {
          latitude: latitude - 0.0025,
          longitude: longitude - 0.0025,
        },
      };
    }

    function processClickEvent(event) {
      var coordinates = {
        latitude: event.latLng.lat(),
        longitude: event.latLng.lng(),
      };

      updateLocationTypeInfo(coordinates);
    }

    function updateLocationTypeInfo(coordinates) {
      vm.location.coordinates = {
        lat: coordinates.latitude,
        lng: coordinates.longitude,
      };

      vm.mapOptions.clickedMarker = {
        id: 0,
        coords: coordinates,
      };

      LocationSelectorService.getGeocoding(vm.mapOptions.clickedMarker.coords)
        .then(function (direction) {
          vm.location.address = direction.formatted_address;
          vm.onLocationChange({location: vm.location});
        });
    }

    function initExistingLocation() {
      vm.mapOptions.clickedMarker = {
        id: 0, coords: {latitude: vm.location.coordinates.lat, longitude: vm.location.coordinates.lng},
      };

      vm.mapOptions.center = vm.mapOptions.clickedMarker.coords;
      vm.mapOptions.zoom = 15;
      $scope.$evalAsync();
    }

    function initializeMapVariables() {
      initializePickupMap();
    }

    function initializePickupMap() {
      vm.mapOptions = angular.copy(LocationSelectorService.getMapBasicData());
      vm.mapOptions.center = {latitude: -0.1865937, longitude: -78.5706251};
      vm.mapOptions.options.disableDefaultUI = true;
      vm.mapOptions.events = {
        click: function (mapModel, eventName, originalEventArgs) {
          processClickEvent(originalEventArgs[0]);
          $scope.$evalAsync();
        },
      };

      vm.mapOptions.searchbox.events = {
        place_changed: function (autoComplete) {
          var place = autoComplete.getPlace();
          if (place.address_components) {
            vm.mapOptions.clickedMarker = {
              id: 0,
              coords: {
                latitude: place.geometry.location.lat(),
                longitude: place.geometry.location.lng(),
              },
            };
            vm.location.coordinates = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            };
            LocationSelectorService
              .getGeocoding(vm.mapOptions.clickedMarker.coords)
              .then(function (direction) {
                vm.location.address = direction.formatted_address;
                vm.onLocationChange({location: vm.location});
              });
            vm.mapOptions.bounds = getBounds(place.geometry.location.lat(), place.geometry.location.lng());
          }
        },
      };
    }

  }
}());

/**
 * Created by Leonel Gonçalves on 7/6/16.
 */
(function () {
  angular.module('Common').component('cargo77FabMenu', {
    templateUrl: 'app/components/common/fab-menu/fab-menu.html',
    controller: FabMenuController,
    controllerAs: 'fabMenu',
  });
  /** @ngInject */
  function FabMenuController($state) {
    var vm = this;

    vm.getIcon = getIcon;
    vm.fabIcon = 'add';
    vm.isOnDashboard = isOnDashboard;
    vm.redirectionState = redirectionState;

    function getIcon() {
      return vm.isOpen ? 'close' : 'add';
    }
    function isOnDashboard() {
      return $state.current.data.isOnDashboard;
    }
    function redirectionState () {
      return $state.current.data.fabMenuRedirectionState;
    }
  }
}());

/**
 * Created by Leonel Gonçalves on 7/3/16.
 */

(function () {
  angular.module('Common').component('cargo77DrawerTypeSelector', {
    templateUrl: 'app/components/common/drawer-type-selector/drawer-type-selector.html',
    controller: DrawerTypeController,
    bindings: {
      drawerTypes: '=',
      needDrawer: '=',
      isOwnOrder:'<',
    },
  });

  function DrawerTypeController() {
    this.getSelectedDrawerCount = getSelectedDrawerCount;

    function getSelectedDrawerCount() {
      return _.filter(this.drawerTypes, function (drawer) {
        return drawer.isSelected;
      }).length;
    }
  }

}());

(function () {
  angular.module('Common').component('cargo77CompanySelector', {
    templateUrl: 'app/components/common/company-selector/company-selector.html',
    controller: CompanySelectorController,
    bindings: {
      selectedCompany: '=ngModel',
      isDriver: '<',
      disabled: '<',
      childrenType: '@',
      selection: '@',
      formReference: '<',
      required: '@',
    },
  });

  function CompanySelectorController(Cargo77Companies) {
    var vm = this;
    vm.$onInit = onInit;
    vm.selectCompany = selectCompany;
    vm.required = !!vm.required;
    vm.searchTextChange = searchTextChange;
    vm.changeCompany = changeCompany;

    function onInit() {
      vm.companies = [];
      getAllCompanies();
      if(vm.selectedCompany) {
        vm.previousSearchText = vm.selectedCompany.name;
      }
    }

    function changeCompany() {
      if(vm.selectedCompany) {
        vm.previousSearchText =  vm.selectedCompany.name;
      }
    }

    function searchTextChange() {

      if(!vm.companySearchText) {
        return;
      }
      if( vm.previousSearchText && vm.companySearchText.length < vm.previousSearchText.length) {
        vm.companySearchText = '';
      }
      vm.previousSearchText = vm.companySearchText;
    }

    function getAllCompanies() {
      var queryFilter = buildFilterQuery(vm.childrenType, vm.selection);

      Cargo77Companies.getParentAndChildren(queryFilter).then(function(results) {
        vm.companies = results;
        if(vm.selectedCompany) {
          vm.companies.forEach(function(company) {
            if(company.id == vm.selectedCompany.cargoCompanyId) {
              vm.selectedCompany = company;
            }
          });
        }
      });
    }

    function selectCompany(company) {
      vm.selectedCompany = company;
    }

    function isValidChildrenType(companyType) {
      return (companyType === 'SHIPPER' || companyType === 'CARRIER');
    }

    function buildFilterQuery(companyType, selection) {
      var query = {};

      switch(selection) {
        case 'parentOnly': {
          query.parentCompanyId = {exists: false};
          break;
        }
        case 'childrenOnly': {
          query.parentCompanyId = {exists: true};
          if(isValidChildrenType(companyType)){
            query.type = companyType;
          }
          break;
        }
        default: {
          if(isValidChildrenType(companyType)){
            query = {
              or: [
                {
                  parentCompanyId: { exists: false },
                },
                {
                  and:[
                    {
                      parentCompanyId: { exists: true },
                      type: companyType,
                    },
                  ],
                },
              ],
            };
          }
        }
      }

      return query;
    }

  }

}());

(function () {
  angular.module('Common').component('cargo77BackButton', {
    templateUrl: 'app/components/common/back-button/back-button.html',
    controller: BackButtonController,
    controllerAs: 'backButton',
    bindings: {
    },
  });
  /** @ngInject */
  function BackButtonController ($window) {
    var vm = this;
    vm.goBack = goBack;

    function goBack() {
      $window.history.back();
    }

  }
}());

(function () {
  angular.module('Common').component('cargo77AddExtraFieldsSelector', {
    templateUrl: 'app/components/common/add-extra-fields-selector/add-extra-fields-selector.html',
    controller: AddExtraFieldsSelectorController,
    bindings: {
      onChangeFields: '&',
      onAreValidExtraFieldChange: '&',
      onSavingFiles: '&',
      onSavingSegmentFiles: '&',
      carrierCompanyId: '=',
      section: '=',
      order: '<',
      segment: '<',
    },
  });

  function AddExtraFieldsSelectorController(ExtraFieldCompaniesService, Cargo77Toast) {
    var vm = this;
    vm.fieldSelected = {};
    vm.optionalExtraFields = [];
    vm.selectedExtraFields = [];
    vm.areValidExtraFields = true;
    vm.getAllExtraFields = ExtraFieldCompaniesService.getAllFields(vm.carrierCompanyId, {'where': {and: [{'section': vm.section}, {isActive: true}]}});

    vm.$onInit = onInit;
    vm.addNewField = addNewField;
    vm.deleteField = deleteField;
    vm.changeField = changeField;
    vm.getNameTruncated = getNameTruncated;
    vm.savingFile = savingFile;

    function onInit() {
      vm.orderSavedFiles = 0;
      vm.orderSavingFiles = 0;
      vm.segmentSavedFiles = 0;
      vm.segmentSavingFiles = 0;
      vm.uploadedFiles = [];
      vm.totalOfFields = 1;
      vm.getAllExtraFields.$promise.then(function (extraFields) {
        extraFields.sort(extraFieldNameAscendingComparator);
        extraFields.forEach(function(field) {
          field.index = vm.totalOfFields;
          if (field.isRequired) {
            vm.areValidExtraFields = false;
          }
          if (field.isRequired || field.isAlwaysVisible) {
            field.enabled = false;
            vm.selectedExtraFields.push(field);
          } else {
            field.enabled = true;
            vm.optionalExtraFields.push(field);
          }
          if(vm.order) {
           var relatedOrderExtraField =  _.find(vm.order.extraFields, function(orderExtraField) {
              return orderExtraField.definitionId.toString() === field.id.toString();
            });
           relatedOrderExtraField = relatedOrderExtraField ? relatedOrderExtraField : {};
           field.value = relatedOrderExtraField.value;
           if(field.inputType === 'FILE') {
             field.fileName = relatedOrderExtraField.fileName;
           }
          }
          if(vm.segment) {
            var relatedSegmentExtraField =  _.find(vm.segment.extraFields, function(segmentExtraField) {
              return segmentExtraField.definitionId.toString() === field.id.toString();
            });
            relatedSegmentExtraField = relatedSegmentExtraField ? relatedSegmentExtraField : {};
            field.value = relatedSegmentExtraField.value;
            if(field.inputType === 'FILE') {
              field.fileName = relatedSegmentExtraField.fileName;
            }
            if(field.value && !(field.isRequired || field.isAlwaysVisible)) {
              field.enabled = false;
              vm.selectedExtraFields.push(field);
            }
          }
          vm.totalOfFields++;
        });
        vm.onAreValidExtraFieldChange({areValidExtraFields: vm.areValidExtraFields});
      });
    }

    function extraFieldNameAscendingComparator(extraFieldA, extraFieldB) {
      if (extraFieldA.name > extraFieldB.name) {
        return 1;
      }
      if(extraFieldA.name < extraFieldB.name) {
        return -1;
      }
      return 0;
    }

    function addNewField(fieldSelected) {
      vm.fieldSelected = {};

      var newOption = fieldSelected;
      newOption.index = vm.totalOfFields;

      vm.totalOfFields++;
      vm.selectedExtraFields.push(newOption);
      updateOptionalExtraField(fieldSelected.id, false);
      cleanExtraFieldsForSubmit();
    }

    function deleteField(optionIndex, idOptionalFieldDeleted) {
      var indexToDelete = getIndexInArray(optionIndex);
      vm.selectedExtraFields.splice(indexToDelete, 1);
      updateOptionalExtraField(idOptionalFieldDeleted, true);
      cleanExtraFieldsForSubmit();
    }

    function savingFile(optionIndex, save){
      var objectIndex = getIndexInArray(optionIndex);
      if (vm.selectedExtraFields[objectIndex].section === 'ORDER') {
        if (!save) {
          vm.orderSavedFiles++;
        } else {
          vm.orderSavingFiles++;
        }
        vm.onSavingFiles({'saved': vm.orderSavedFiles, 'saving': vm.orderSavingFiles});
      } else {
        if (vm.selectedExtraFields[objectIndex].section === 'SEGMENT') {
          if (!save) {
            vm.segmentSavedFiles++;
          } else {
            vm.segmentSavingFiles++;
          }
          vm.onSavingSegmentFiles({'saved': vm.segmentSavedFiles, 'saving': vm.segmentSavingFiles});
        }
      }
    }

    function changeField(optionIndex, value, fileName) {
      var objectIndexToChange = getIndexInArray(optionIndex);
      if (vm.selectedExtraFields[objectIndexToChange].inputType === 'FILE') {
        if (value === null ) {
          Cargo77Toast.successToast('Archivo eliminado');
        }
        if (vm.uploadedFiles.length === 0 && value !== null) {
          vm.uploadedFiles.push(vm.selectedExtraFields[objectIndexToChange]);
        } else {
          verifyIfExtraFieldChanged(vm.selectedExtraFields[objectIndexToChange], value);
          if (value != null) {
            vm.uploadedFiles.push(vm.selectedExtraFields[objectIndexToChange]);
          }
        }
      }

      vm.selectedExtraFields[objectIndexToChange].value = value;
      if (fileName) {
        vm.selectedExtraFields[objectIndexToChange].fileName = fileName;
      }
      cleanExtraFieldsForSubmit();
    }

    function verifyIfExtraFieldChanged(extraField, newFile){
      var indexToDelete = -1;
      vm.uploadedFiles.forEach(function (element, index) {
        if (element.id === extraField.id) {
          if (newFile === null || newFile != element.value) {
            ExtraFieldCompaniesService.deleteFileFromStorage(element.value);
            indexToDelete = index;
          }
        }
      });
      if (indexToDelete > -1) {
        vm.uploadedFiles.splice(indexToDelete, 1);
      }
    }

    function updateOptionalExtraField(optionalFieldIdSelected, enabledField) {
      var index = getIndexForOptionalFields(optionalFieldIdSelected);
      vm.optionalExtraFields[index].enabled = enabledField;
    }

    function getIndexForOptionalFields(optionalFieldIdSelected) {
      return vm.optionalExtraFields.findIndex(function(field) {
        return field.id === optionalFieldIdSelected;
      });
    }

    function cleanExtraFieldsForSubmit() {
      vm.areValidExtraFields = true;
      var extraFieldsFilled = [];
      vm.selectedExtraFields.forEach(function(field) {
        if (field.isRequired && !field.value) {
          vm.areValidExtraFields = false;
        }
        if(field.value) {
          var newField = {
            definitionId: field.id,
            value: field.value,
            isRequired:field.isRequired,
            inputType: field.inputType,
            name: field.name,
          };
          if(field.fileName) {
            newField.fileName = field.fileName;
            newField.fileContents = newField.value;
            delete newField.value;
          }
          extraFieldsFilled.push(newField);
        }
      });
      vm.onChangeFields({extraFields: extraFieldsFilled});
      vm.onAreValidExtraFieldChange({areValidExtraFields: vm.areValidExtraFields});
    }

    function getIndexInArray(objectIndex) {
      return vm.selectedExtraFields.findIndex(function(option) {
        return option.index === objectIndex;
      });
    }

    function getNameTruncated(name, maxLength) {
      return _.truncate(name, {
        length: maxLength,
      });
    }
  }

}());

(function () {
  angular.module('Cargo77.chat').service('Chat', ChatService);

  /** @ngInject */
  function ChatService(Profile,Order, $firebaseArray, $firebaseObject, $q) {
    var self = this;

    var messages = [];
    var currentChat;

    onControllerInit();

    function onControllerInit () {
      self.user = {};
      self.init = init;
      self.getChats = getChats;
      self.sendMessageToChat = sendMessageToChat;
      self.getMessagesForChat = getMessagesForChat;
      self.resetUnreadMessageForChat = resetUnreadMessageForChat;
      self.resetChatMessages = resetChatMessages;
      self.getCompanyTitle = getCompanyTitle;
      self.getChatRelatedOffer = getChatRelatedOffer;
      self.getChatLastMessage = getChatLastMessage;
    }

    function getCompanyTitle(chat) {
      if (isCarrier()) {
        return chat.shipperCompany;
      } else {
        return chat.carrierCompany;
      }
    }

    function isCarrier() {
      return (Profile.getUserRole().indexOf('CARRIER_OWNER') >= 0 || Profile.getUserRole().indexOf('CARRIER_USER') >= 0);
    }

    function init() {
      var userInfo = firebase.database().ref('users/' + Profile.getCurrentUser().id);
      self.user = $firebaseObject(userInfo);
      return self.user.$loaded();
    }

    function resetChatMessages() {
      self.user.unreadMessages = 0;
      self.user.$save();
    }

    function sendMessageToChat(message) {
      var newMessage = $firebaseObject(messages.push());
      Object.assign(newMessage, {
        username: Profile.getCurrentUser().firstName + ' ' + Profile.getCurrentUser().lastName,
        message: message,
        timestamp: firebase.database.ServerValue.TIMESTAMP,
        user: self.user.$id,
      });
      return newMessage.$save();
    }

    function getChats() {
      return getUserInfo().then(getUserChats);
    }

    function getMessagesForChat(chat) {
      messages = firebase.database().ref('messages/' + chat);
      var array = $firebaseArray(messages);
      currentChat = chat;
      array.$watch(resetCount);
      return array;
    }

    function resetCount(event) {
      if (event.event === 'child_added') {
        self.resetUnreadMessageForChat(currentChat);
      }
    }

    function resetUnreadMessageForChat(chatId) {
      return $firebaseObject(firebase.database().ref('chats/' + chatId))
        .$loaded()
        .then(function (chat) {
          chat.unreadMessages[self.user.$id] = 0;
          return chat.$save();
        });
    }

    function getChatLastMessage (chat) {
      return $firebaseArray(firebase.database().ref('messages/' + chat).limitToLast(1)).$loaded();
    }

    //PRIVATE FUNCTIONS
    function getUserInfo() {
      return self.user.$loaded();
    }

    function getUserChats(userInfo) {
      var chatPromises = [];
      for (var chat in userInfo.chats) {
        /* istanbul ignore else */
        if (userInfo.chats.hasOwnProperty(chat)) {
          chatPromises = chatPromises.concat(getChat(chat));
        }
      }
      return $q.all(chatPromises);
    }

    function getChat(chat) {
      return $firebaseObject(firebase.database().ref('chats/' + chat)).$loaded();
    }

   function getChatRelatedOffer (chatId) {

     var index = chatId.indexOf('|');
     var orderId = chatId.slice(0,index);
     var cargoCompanyId = chatId.slice(index + 1,chatId.length);

     return Order.offers(
       {
         id: orderId,
         filter: {
           where: {
             cargoCompanyId: cargoCompanyId,
           },
       },
     }).$promise;
   }

  }

}());

(function () {
  angular.module('Cargo77.chat').component('cargo77Chat', {
    templateUrl: 'app/components/chat/components/chat.html',
    controller: ChatController,
  });

  /** @ngInject */
  function ChatController(Cargo77Toast, Chat, $stateParams) {
    var vm = this;
    vm.isLoading = true;
    vm.$onInit = onInit;
    vm.sendMessage = sendMessage;
    vm.getUserId = getUserId;
    vm.getMessagesForChat = getMessagesForChat;
    vm.chatCount = chatCount;
    vm.backAction = backAction;

    function backAction() {
      vm.selectedChat = undefined;
    }

    function chatCount() {
      if (angular.isDefined(Chat.user.chats)) {
        return Object.keys(Chat.user.chats);
      }
      return null;
    }

    function sendMessage(message) {
      Chat.sendMessageToChat(message, vm.selectedChat.$id)
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function getUserId() {
      return Chat.user.$id;
    }

    function getMessagesForChat(chat) {

      vm.selectedChat = chat;
      Chat.resetUnreadMessageForChat(chat.$id);
      vm.messages = Chat.getMessagesForChat(chat.$id);
    }

    function getChats() {
      Chat.getChats()
        .then(function (response) {
          vm.chats = response;
          vm.isLoading = false;

          if ($stateParams.chatId) {
            vm.getMessagesForChat(_.find(vm.chats, {$id: $stateParams.chatId}));
          }
          changeChatOfferStatus ();
        })
        .catch(function (error) {
          Cargo77Toast.errorToast(null, error.data.error);
        });
    }

    function onInit() {
      Chat.init().then(getChats);
    }

    function changeChatOfferStatus () {

      vm.chats.forEach(function(chat){
        Chat.getChatRelatedOffer(chat.$id)
          .then(function(response){

            if(response[0] && response[0].isAccepted === false){
              chat.isOfferAccepted = false;
              chat.offerId = response[0].id;
              return;
            }
            /* istanbul ignore else */
            if(response[0] && response[0].isAccepted === true){
              chat.isOfferAccepted = true;
            }
          });
      });
    }
  }
}());

(function () {
  angular.module('Cargo77.calendar').service('CalendarService', CalendarService);

  /** @ngInject */
  function CalendarService(Profile, Order) {
    var self = this;

    self.getOrders = getOrders;

    function getOrders(dateRange) {

      return Order.find({
        filter: {
          fields: ['id', 'scheduledDate', 'route', 'orderStatus'],
          include: [
            {
              relation: 'offers',

              scope: {
                fields: ['orderId', 'vehicleId', 'driverId', 'id'],
                include: [
                  {
                    relation: 'vehicle',
                    scope: {
                      fields: ['brand', 'model'],
                    },
                  },
                  {
                    relation: 'driver',
                    scope: {
                      fields: ['firstName', 'lastName'],
                    },
                  },
                ],
              },
            },
          ],
          where:
            {
              'scheduledDate.date': { between: [dateRange.min, dateRange.max]},
              'acceptedOfferSummary.carrierCompanyId': { eq: Profile.getCargoCompanyId()},
            },
          },
      });
    }

  }
}());

(function () {
  angular.module('Cargo77.security', [
    'Common', 'ui.router',
    'permission',
    'lbServices',
    'Cargo77.profile',
    'Cargo77.config'])
    .config(Routing);
  /** @ngInject */
  function Routing($stateProvider,
                   LoopBackResourceProvider,
                   cargo77Config) {
    // Use a custom auth header instead of the default 'Authorization'
    LoopBackResourceProvider.setAuthHeader('X-Access-Token');
    // Change the URL where to access the LoopBack REST API server
    LoopBackResourceProvider.setUrlBase(cargo77Config.loopback);

    $stateProvider
      .state('sec', {
        abstract: true,
        url: '/sec',
        templateUrl: 'app/security/views/main.html',
      })
      .state('sec.unauthorized', {
        url: '/unauthorized',
        templateUrl: 'app/security/views/403.html',
      })
      .state('sec.not_found', {
        url: '/not_found',
        templateUrl: 'app/security/views/404.html',
      })
      .state('sec.invalid_user', {
        url: '/invalid_user',
        templateUrl: 'app/security/views/401.html',
      })
      .state('sec.server_error', {
        url: '/server_error',
        templateUrl: 'app/security/views/500.html',
      });
  }

}());

(function () {
  angular.module('Cargo77.security').service('PermissionsService', PermissionsService);
  /** @ngInject */
  function PermissionsService(PermPermissionStore, PermRoleStore, Profile) {
    var self = this;
    var permissions = [];

    self.hasPermissions = false;
    self.hasRoles = false;
    self.clearPermissions = clearPermissions;
    self.clearRoles = clearRoles;
    self.definePermissions = definePermissions;
    self.defineRoles = defineRoles;

    function clearPermissions() {
      self.hasPermissions = false;

      PermPermissionStore.clearStore();
    }

    function clearRoles() {
      self.hasRoles = false;
      PermRoleStore.clearStore();
    }

    function definePermissions(newPermissions) {
      self.hasPermissions = true;
      permissions = newPermissions;
      PermPermissionStore.defineManyPermissions(permissions, function (permissionName) {
        return _.includes(permissions, permissionName);
      });
    }

    function defineRoles(roles) {
      self.hasRoles = true;
      for (var i = 0; i < roles.length; i++) {
        var role = roles[i];
        PermRoleStore.defineRole(role, function (roleName) {
          return Profile.getUserRole().indexOf(roleName) > -1;
        });
      }
    }
  }
}());

(function () {
  angular.module('Cargo77.security').service('permissions', permissions);
  /** @ngInject */
  function permissions() {
    var self = this;

    self.getPermissions = getPermissions;

    var permissions = {
      CARRIER_OWNER: [],
      CARRIER_USER: [],
      SHIPPER_OWNER: [],
      SHIPPER_USER: [],
    };

    function getPermissions(role){
      return permissions[role] || [];
    }
  }
}());


(function () {
  angular.module('Cargo77.profile', ['angular-storage', 'lbServices']);
}());
(function () {
  angular.module('Cargo77.profile')
    .factory('Profile', Profile);
  /** @ngInject */
  function Profile($window, LoopBackAuth) {
    var props = ['id', 'cargoCompanyId', 'roles', 'parentCompanyId'];
    var propsPrefix = '$Cargo77$';
    var currentUser;
    try {
      currentUser = JSON.parse($window.localStorage.getItem(propsPrefix + 'currentUser'));
    } catch (e){
      currentUser = {};
    }

    function save(name, value) {
      var key = propsPrefix + name;

      if (value === null || angular.isUndefined(value)) {
        value = '';
      }

      $window.localStorage.setItem(key, value);
    }

    return {
      isLogged: function () {
        return angular.isString(LoopBackAuth.accessTokenId) &&
          LoopBackAuth.accessTokenId !== '';
      },
      save: function (profile) {
        currentUser = profile;

        $window.localStorage.setItem(propsPrefix + 'currentUser', JSON.stringify(profile));
        props.forEach(function (name) {
          save(name, profile[name]);
        });
      },
      clearStorage: function () {
        save('currentUser', null);
        currentUser = null;
        LoopBackAuth.clearUser();
        LoopBackAuth.clearStorage();
        props.forEach(function (name) {
          save(name, null);
        });
      },
      getUserPrimaryRole: function () {
        if (_.includes(currentUser.roles, 'CARRIER_OWNER')) {
          return 'CARRIER_OWNER';
        }
        if (_.includes(currentUser.roles, 'CARRIER_USER')) {
          return 'CARRIER_USER';
        }
        if (_.includes(currentUser.roles, 'SHIPPER_OWNER')) {
          return 'SHIPPER_OWNER';
        }
        if (_.includes(currentUser.roles, 'SHIPPER_USER')) {
          return 'SHIPPER_USER';
        }
        if (_.includes(currentUser.roles, 'CARGO_ADMIN') && !_.includes(currentUser.roles, 'SUPER_ADMIN')) {
          return 'CARGO_ADMIN';
        }
        if (_.includes(currentUser.roles, 'CARRIER_VIEWER')) {
          return 'CARRIER_VIEWER';
        }
        if (_.includes(currentUser.roles, 'SHIPPER_VIEWER')) {
          return 'SHIPPER_VIEWER';
        }
        return 'SUPER_ADMIN';
      },
      getCurrentUser: function () {
        return currentUser;
      },
      getId: function () {
        return $window.localStorage.getItem(propsPrefix + 'id');
      },
      getCargoCompanyId: function () {
        return $window.localStorage.getItem(propsPrefix + 'cargoCompanyId');
      },
      getUserRole: function () {
        return currentUser.roles;
      },
      getParentCompanyId: function () {
        return $window.localStorage.getItem(propsPrefix + 'parentCompanyId');
      },
    };
  }

}());

/**
 * Created by Leonel Gonçalves on 6/29/16.
 */

(function () {
  angular.module('Cargo77.login').component('cargo77Login', {
    templateUrl: 'app/components/login/login.html',
  });
}());
(function () {
  angular.module("Cargo77.security").run(Run);

  /** @ngInject */
  function Run(
    PermissionsService,
    Profile,
    $rootScope,
    $state,
    PermTransitionProperties,
    Cargo77Toast,
    $firebaseAuth,
    permissions
  ) {
    var forbiddenPageMessage =
      "Disculpe, no tiene permiso para acceder a esa página.";

    $rootScope.$on("$stateChangeStart", function (event, toState) {
      var pageFoundCount = [
        "login",
        "signUp",
        "forgotPassword",
        "recoveryPasswordEmail",
        "confirm",
        "privacyPolicy",
      ].indexOf(toState.name);

      if (!Profile.isLogged() && pageFoundCount < 0) {
        PermissionsService.clearPermissions();
        PermissionsService.clearRoles();
        $state.go("login");
        $firebaseAuth().$signOut();
        Cargo77Toast.errorToast(forbiddenPageMessage);
        return;
      }

      if (pageFoundCount >= 0) {
        $firebaseAuth().$signOut();
        PermissionsService.clearPermissions();
        PermissionsService.clearRoles();
        return;
      }

      if (!PermissionsService.hasRoles) {
        PermissionsService.defineRoles(Profile.getUserRole());
        PermissionsService.definePermissions(
          permissions.getPermissions(Profile.getUserRole())
        );
      }
    });

    $rootScope.$on("$stateChangePermissionDenied", function () {
      $state.go(PermTransitionProperties.fromState.name || "cargo.dashboard");
      Cargo77Toast.errorToast(forbiddenPageMessage);
    });
  }
})();

(function () {

  angular.module('Main.module', ['Cargo77.config', 'Cargo77.security', 'ui.router'])
    .config(Routing)
    .run(Run);
  /** @ngInject */
  function Routing($stateProvider) {
    $stateProvider
      .state('cargo', {
        abstract: true,
        url: '/cargo',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: '$ctrl',
      });
  }

  /** @ngInject */
  function Run(cargo77Config) {
    var config = {
      apiKey: cargo77Config.firebaseApiKey,
      authDomain: cargo77Config.firebaseAuthDomain,
      databaseURL: cargo77Config.firebaseDatabaseURL,
      storageBucket: cargo77Config.firebaseStorageBucket,
    };
    /* istanbul ignore next */
    if (!firebase.apps.length) {
      firebase.initializeApp(config);
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('Main.module')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController() {
    this.menuItems = [
      {title: 'dashboard', state: 'cargo.dashboard', icon: 'dashboard'},
      {title: 'bandeja de notificaciones', state: 'cargo.notificationInbox', icon: 'inbox'},
      {title: 'fletes', state: 'cargo.listShipperOrders', icon: 'near_me'},
      {title: 'fletes', state: 'cargo.listAcceptedOrders', icon: 'near_me'},
      {title: 'fletes', state: 'cargo.listAcceptedOrdersViewOnly', icon: 'near_me'},
      {title: 'fletes', state: 'cargo.listAdminOrders', icon: 'near_me'},
      {title: 'clientes', state: 'cargo.shipperCompanies', icon: 'account_balance'},
      {title: 'ubicaciones', state: 'cargo.listLocations', icon: 'map_marker'},
      {title: 'usuarios y conductores', state: 'cargo.listUsers', icon: 'group'},
      {title: 'unidades', state: 'cargo.listVehicles', icon: 'directions_bus'},
      {title: 'arrastres', state: 'cargo.listTrailers', icon: 'rv_hookup'},
      {title: 'transportistas subcontratados', state: 'cargo.carrierCompanies', icon: 'account_balance'},
      {title: 'perfil de empresa', state: 'cargo.editCurrentCompany', icon: 'account_balance'},
      {title: 'reportes', state: 'cargo.reports', icon: 'description'},
      {title: 'reporte', state: 'cargo.orderReport', icon: 'description'},
      {title: 'pagos', state: 'cargo.payments', icon: 'account_balance_wallet'},
      {title: 'compañias', state: 'cargo.listCompanies', icon: 'account_balance'},
      {title: 'mi perfil',class: 'profile-sidebar-item', state: 'cargo.editCurrentUser', icon: 'account_circle'},
      {title: 'salir', class:'logout-sidebar-item', state: 'login', icon: 'exit_to_app'},
    ];
    this.notShownItems = [
      {title: 'agenda', state: 'cargo.calendar.month', icon: 'date_range'},
      {title: 'solicitudes', state: 'cargo.listOrders', icon: 'archive'},
    ];
  }

})();

// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "/api";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }

  var urlBaseHost = getHost(urlBase) || location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.Vehicle
 * @header lbServices.Vehicle
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Vehicle` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Vehicle",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Vehicles/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Vehicle.defaultTrailer() instead.
            "prototype$__get__defaultTrailer": {
              url: urlBase + "/Vehicles/:id/defaultTrailer",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.ownerCompany() instead.
            "prototype$__get__ownerCompany": {
              url: urlBase + "/Vehicles/:id/ownerCompany",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.cargoUser.findById() instead.
            "prototype$__findById__cargoUser": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/cargoUser/:fk",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.cargoUser.destroyById() instead.
            "prototype$__destroyById__cargoUser": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/cargoUser/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Vehicle.cargoUser.updateById() instead.
            "prototype$__updateById__cargoUser": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/cargoUser/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Vehicle.defaultDriver() instead.
            "prototype$__get__defaultDriver": {
              url: urlBase + "/Vehicles/:id/defaultDriver",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.defaultDriver.create() instead.
            "prototype$__create__defaultDriver": {
              url: urlBase + "/Vehicles/:id/defaultDriver",
              method: "POST",
            },

            // INTERNAL. Use Vehicle.defaultDriver.update() instead.
            "prototype$__update__defaultDriver": {
              url: urlBase + "/Vehicles/:id/defaultDriver",
              method: "PUT",
            },

            // INTERNAL. Use Vehicle.defaultDriver.destroy() instead.
            "prototype$__destroy__defaultDriver": {
              url: urlBase + "/Vehicles/:id/defaultDriver",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#prototype$__findById__assignments
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Find a related item by id for assignments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `fk` – `{*}` - Foreign key for assignments
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "prototype$__findById__assignments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/assignments/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#prototype$__destroyById__assignments
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Delete a related item by id for assignments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `fk` – `{*}` - Foreign key for assignments
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__assignments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/assignments/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#prototype$__updateById__assignments
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Update a related item by id for assignments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `fk` – `{*}` - Foreign key for assignments
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "prototype$__updateById__assignments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/assignments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Vehicle.cargoUser() instead.
            "prototype$__get__cargoUser": {
              isArray: true,
              url: urlBase + "/Vehicles/:id/cargoUser",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.cargoUser.create() instead.
            "prototype$__create__cargoUser": {
              url: urlBase + "/Vehicles/:id/cargoUser",
              method: "POST",
            },

            // INTERNAL. Use Vehicle.cargoUser.destroyAll() instead.
            "prototype$__delete__cargoUser": {
              url: urlBase + "/Vehicles/:id/cargoUser",
              method: "DELETE",
            },

            // INTERNAL. Use Vehicle.cargoUser.count() instead.
            "prototype$__count__cargoUser": {
              url: urlBase + "/Vehicles/:id/cargoUser/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#prototype$__get__assignments
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Queries assignments of Vehicle.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "prototype$__get__assignments": {
              isArray: true,
              url: urlBase + "/Vehicles/:id/assignments",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#prototype$__create__assignments
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Creates a new instance in assignments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "prototype$__create__assignments": {
              url: urlBase + "/Vehicles/:id/assignments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#prototype$__delete__assignments
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Deletes all assignments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__assignments": {
              url: urlBase + "/Vehicles/:id/assignments",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#prototype$__count__assignments
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Counts assignments of Vehicle.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__assignments": {
              url: urlBase + "/Vehicles/:id/assignments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#create
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Vehicles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#createMany
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Vehicles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#replaceOrCreate
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Vehicles/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#upsertWithWhere
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Vehicles/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#findById
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Vehicles/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#replaceById
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Vehicles/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#find
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Vehicles",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#deleteById
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Vehicles/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#count
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Vehicles/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#prototype$updateAttributes
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Vehicles/:id",
              method: "PUT",
            },

            // INTERNAL. Use Trailer.defaultVehicle() instead.
            "::get::Trailer::defaultVehicle": {
              url: urlBase + "/Trailers/:id/defaultVehicle",
              method: "GET",
            },

            // INTERNAL. Use Trailer.defaultVehicle.create() instead.
            "::create::Trailer::defaultVehicle": {
              url: urlBase + "/Trailers/:id/defaultVehicle",
              method: "POST",
            },

            // INTERNAL. Use Trailer.defaultVehicle.createMany() instead.
            "::createMany::Trailer::defaultVehicle": {
              isArray: true,
              url: urlBase + "/Trailers/:id/defaultVehicle",
              method: "POST",
            },

            // INTERNAL. Use Trailer.defaultVehicle.update() instead.
            "::update::Trailer::defaultVehicle": {
              url: urlBase + "/Trailers/:id/defaultVehicle",
              method: "PUT",
            },

            // INTERNAL. Use Trailer.defaultVehicle.destroy() instead.
            "::destroy::Trailer::defaultVehicle": {
              url: urlBase + "/Trailers/:id/defaultVehicle",
              method: "DELETE",
            },

            // INTERNAL. Use Offer.vehicle() instead.
            "::get::Offer::vehicle": {
              url: urlBase + "/Offers/:id/vehicle",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.vehicles.findById() instead.
            "::findById::CargoCompany::vehicles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/vehicles/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.vehicles.destroyById() instead.
            "::destroyById::CargoCompany::vehicles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/vehicles/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.vehicles.updateById() instead.
            "::updateById::CargoCompany::vehicles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/vehicles/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoCompany.vehicles() instead.
            "::get::CargoCompany::vehicles": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/vehicles",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.vehicles.create() instead.
            "::create::CargoCompany::vehicles": {
              url: urlBase + "/CargoCompanies/:id/vehicles",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.vehicles.createMany() instead.
            "::createMany::CargoCompany::vehicles": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/vehicles",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.vehicles.destroyAll() instead.
            "::delete::CargoCompany::vehicles": {
              url: urlBase + "/CargoCompanies/:id/vehicles",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.vehicles.count() instead.
            "::count::CargoCompany::vehicles": {
              url: urlBase + "/CargoCompanies/:id/vehicles/count",
              method: "GET",
            },

            // INTERNAL. Use CargoUser.defaultVehicle() instead.
            "::get::CargoUser::defaultVehicle": {
              url: urlBase + "/CargoUsers/:id/defaultVehicle",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Vehicle#patchOrCreateWithWhere
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#destroyById
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#removeById
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#patchAttributes
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Vehicle#modelName
        * @propertyOf lbServices.Vehicle
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Vehicle`.
        */
        R.modelName = "Vehicle";


            /**
             * @ngdoc method
             * @name lbServices.Vehicle#defaultTrailer
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Fetches belongsTo relation defaultTrailer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
        R.defaultTrailer = function() {
          var TargetResource = $injector.get("Trailer");
          var action = TargetResource["::get::Vehicle::defaultTrailer"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle#ownerCompany
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Fetches belongsTo relation ownerCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.ownerCompany = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::get::Vehicle::ownerCompany"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Vehicle.cargoUser
     * @header lbServices.Vehicle.cargoUser
     * @object
     * @description
     *
     * The object `Vehicle.cargoUser` groups methods
     * manipulating `CargoUser` instances related to `Vehicle`.
     *
     * Call {@link lbServices.Vehicle#cargoUser Vehicle.cargoUser()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Vehicle#cargoUser
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Queries cargoUser of Vehicle.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.cargoUser = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::get::Vehicle::cargoUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.cargoUser#count
             * @methodOf lbServices.Vehicle.cargoUser
             *
             * @description
             *
             * Counts cargoUser of Vehicle.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.cargoUser.count = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::count::Vehicle::cargoUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.cargoUser#create
             * @methodOf lbServices.Vehicle.cargoUser
             *
             * @description
             *
             * Creates a new instance in cargoUser of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.cargoUser.create = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::create::Vehicle::cargoUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.cargoUser#createMany
             * @methodOf lbServices.Vehicle.cargoUser
             *
             * @description
             *
             * Creates a new instance in cargoUser of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.cargoUser.createMany = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::createMany::Vehicle::cargoUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.cargoUser#destroyAll
             * @methodOf lbServices.Vehicle.cargoUser
             *
             * @description
             *
             * Deletes all cargoUser of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.cargoUser.destroyAll = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::delete::Vehicle::cargoUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.cargoUser#destroyById
             * @methodOf lbServices.Vehicle.cargoUser
             *
             * @description
             *
             * Delete a related item by id for cargoUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `fk` – `{*}` - Foreign key for cargoUser
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.cargoUser.destroyById = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::destroyById::Vehicle::cargoUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.cargoUser#findById
             * @methodOf lbServices.Vehicle.cargoUser
             *
             * @description
             *
             * Find a related item by id for cargoUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `fk` – `{*}` - Foreign key for cargoUser
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.cargoUser.findById = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::findById::Vehicle::cargoUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.cargoUser#updateById
             * @methodOf lbServices.Vehicle.cargoUser
             *
             * @description
             *
             * Update a related item by id for cargoUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `fk` – `{*}` - Foreign key for cargoUser
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.cargoUser.updateById = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::updateById::Vehicle::cargoUser"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Vehicle.defaultDriver
     * @header lbServices.Vehicle.defaultDriver
     * @object
     * @description
     *
     * The object `Vehicle.defaultDriver` groups methods
     * manipulating `CargoUser` instances related to `Vehicle`.
     *
     * Call {@link lbServices.Vehicle#defaultDriver Vehicle.defaultDriver()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Vehicle#defaultDriver
             * @methodOf lbServices.Vehicle
             *
             * @description
             *
             * Fetches hasOne relation defaultDriver.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.defaultDriver = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::get::Vehicle::defaultDriver"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.defaultDriver#create
             * @methodOf lbServices.Vehicle.defaultDriver
             *
             * @description
             *
             * Creates a new instance in defaultDriver of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.defaultDriver.create = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::create::Vehicle::defaultDriver"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.defaultDriver#createMany
             * @methodOf lbServices.Vehicle.defaultDriver
             *
             * @description
             *
             * Creates a new instance in defaultDriver of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.defaultDriver.createMany = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::createMany::Vehicle::defaultDriver"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.defaultDriver#destroy
             * @methodOf lbServices.Vehicle.defaultDriver
             *
             * @description
             *
             * Deletes defaultDriver of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.defaultDriver.destroy = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::destroy::Vehicle::defaultDriver"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vehicle.defaultDriver#update
             * @methodOf lbServices.Vehicle.defaultDriver
             *
             * @description
             *
             * Update defaultDriver of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vehicle id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.defaultDriver.update = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::update::Vehicle::defaultDriver"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Trailer
 * @header lbServices.Trailer
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Trailer` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Trailer",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Trailers/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Trailer.defaultVehicle() instead.
            "prototype$__get__defaultVehicle": {
              url: urlBase + "/Trailers/:id/defaultVehicle",
              method: "GET",
            },

            // INTERNAL. Use Trailer.defaultVehicle.create() instead.
            "prototype$__create__defaultVehicle": {
              url: urlBase + "/Trailers/:id/defaultVehicle",
              method: "POST",
            },

            // INTERNAL. Use Trailer.defaultVehicle.update() instead.
            "prototype$__update__defaultVehicle": {
              url: urlBase + "/Trailers/:id/defaultVehicle",
              method: "PUT",
            },

            // INTERNAL. Use Trailer.defaultVehicle.destroy() instead.
            "prototype$__destroy__defaultVehicle": {
              url: urlBase + "/Trailers/:id/defaultVehicle",
              method: "DELETE",
            },

            // INTERNAL. Use Trailer.ownerCompany() instead.
            "prototype$__get__ownerCompany": {
              url: urlBase + "/Trailers/:id/ownerCompany",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#prototype$__findById__assignments
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Find a related item by id for assignments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Trailer id
             *
             *  - `fk` – `{*}` - Foreign key for assignments
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
            "prototype$__findById__assignments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Trailers/:id/assignments/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#prototype$__destroyById__assignments
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Delete a related item by id for assignments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Trailer id
             *
             *  - `fk` – `{*}` - Foreign key for assignments
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__assignments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Trailers/:id/assignments/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#prototype$__updateById__assignments
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Update a related item by id for assignments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Trailer id
             *
             *  - `fk` – `{*}` - Foreign key for assignments
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
            "prototype$__updateById__assignments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Trailers/:id/assignments/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#prototype$__get__assignments
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Queries assignments of Trailer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Trailer id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
            "prototype$__get__assignments": {
              isArray: true,
              url: urlBase + "/Trailers/:id/assignments",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#prototype$__create__assignments
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Creates a new instance in assignments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Trailer id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
            "prototype$__create__assignments": {
              url: urlBase + "/Trailers/:id/assignments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#prototype$__delete__assignments
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Deletes all assignments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Trailer id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__assignments": {
              url: urlBase + "/Trailers/:id/assignments",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#prototype$__count__assignments
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Counts assignments of Trailer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Trailer id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__assignments": {
              url: urlBase + "/Trailers/:id/assignments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#create
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Trailers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#createMany
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Trailers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#replaceOrCreate
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Trailers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#upsertWithWhere
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Trailers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#findById
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Trailers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#replaceById
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Trailers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#find
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Trailers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#deleteById
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Trailers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#count
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Trailers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Trailer#prototype$updateAttributes
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Trailers/:id",
              method: "PUT",
            },

            // INTERNAL. Use Vehicle.defaultTrailer() instead.
            "::get::Vehicle::defaultTrailer": {
              url: urlBase + "/Vehicles/:id/defaultTrailer",
              method: "GET",
            },

            // INTERNAL. Use Offer.trailer() instead.
            "::get::Offer::trailer": {
              url: urlBase + "/Offers/:id/trailer",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Trailer#patchOrCreateWithWhere
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Trailer#destroyById
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Trailer#removeById
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Trailer#patchAttributes
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Trailer#modelName
        * @propertyOf lbServices.Trailer
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Trailer`.
        */
        R.modelName = "Trailer";

    /**
     * @ngdoc object
     * @name lbServices.Trailer.defaultVehicle
     * @header lbServices.Trailer.defaultVehicle
     * @object
     * @description
     *
     * The object `Trailer.defaultVehicle` groups methods
     * manipulating `Vehicle` instances related to `Trailer`.
     *
     * Call {@link lbServices.Trailer#defaultVehicle Trailer.defaultVehicle()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Trailer#defaultVehicle
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Fetches hasOne relation defaultVehicle.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Trailer id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R.defaultVehicle = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::get::Trailer::defaultVehicle"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Trailer.defaultVehicle#create
             * @methodOf lbServices.Trailer.defaultVehicle
             *
             * @description
             *
             * Creates a new instance in defaultVehicle of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Trailer id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R.defaultVehicle.create = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::create::Trailer::defaultVehicle"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Trailer.defaultVehicle#createMany
             * @methodOf lbServices.Trailer.defaultVehicle
             *
             * @description
             *
             * Creates a new instance in defaultVehicle of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Trailer id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R.defaultVehicle.createMany = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::createMany::Trailer::defaultVehicle"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Trailer.defaultVehicle#destroy
             * @methodOf lbServices.Trailer.defaultVehicle
             *
             * @description
             *
             * Deletes defaultVehicle of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Trailer id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.defaultVehicle.destroy = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::destroy::Trailer::defaultVehicle"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Trailer.defaultVehicle#update
             * @methodOf lbServices.Trailer.defaultVehicle
             *
             * @description
             *
             * Update defaultVehicle of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Trailer id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R.defaultVehicle.update = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::update::Trailer::defaultVehicle"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Trailer#ownerCompany
             * @methodOf lbServices.Trailer
             *
             * @description
             *
             * Fetches belongsTo relation ownerCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Trailer id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.ownerCompany = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::get::Trailer::ownerCompany"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.GlobalSettings
 * @header lbServices.GlobalSettings
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `GlobalSettings` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "GlobalSettings",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/GlobalSettings/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.GlobalSettings#replaceOrCreate
             * @methodOf lbServices.GlobalSettings
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GlobalSettings` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/GlobalSettings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GlobalSettings#upsertWithWhere
             * @methodOf lbServices.GlobalSettings
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GlobalSettings` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/GlobalSettings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GlobalSettings#replaceById
             * @methodOf lbServices.GlobalSettings
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GlobalSettings` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/GlobalSettings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GlobalSettings#findOne
             * @methodOf lbServices.GlobalSettings
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GlobalSettings` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/GlobalSettings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GlobalSettings#prototype$updateAttributes
             * @methodOf lbServices.GlobalSettings
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GlobalSettings id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GlobalSettings` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/GlobalSettings/:id",
              method: "PUT",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.GlobalSettings#patchOrCreateWithWhere
             * @methodOf lbServices.GlobalSettings
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GlobalSettings` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.GlobalSettings#patchAttributes
             * @methodOf lbServices.GlobalSettings
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GlobalSettings id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GlobalSettings` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.GlobalSettings#modelName
        * @propertyOf lbServices.GlobalSettings
        * @description
        * The name of the model represented by this $resource,
        * i.e. `GlobalSettings`.
        */
        R.modelName = "GlobalSettings";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Order
 * @header lbServices.Order
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Order` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Order",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Orders/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Order.offers.findById() instead.
            "prototype$__findById__offers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Orders/:id/offers/:fk",
              method: "GET",
            },

            // INTERNAL. Use Order.acceptedOffer() instead.
            "prototype$__get__acceptedOffer": {
              url: urlBase + "/Orders/:id/acceptedOffer",
              method: "GET",
            },

            // INTERNAL. Use Order.oldAcceptedOffer() instead.
            "prototype$__get__oldAcceptedOffer": {
              url: urlBase + "/Orders/:id/oldAcceptedOffer",
              method: "GET",
            },

            // INTERNAL. Use Order.ownerCompany() instead.
            "prototype$__get__ownerCompany": {
              url: urlBase + "/Orders/:id/ownerCompany",
              method: "GET",
            },

            // INTERNAL. Use Order.shipperCompany() instead.
            "prototype$__get__shipperCompany": {
              url: urlBase + "/Orders/:id/shipperCompany",
              method: "GET",
            },

            // INTERNAL. Use Order.mainCarrierCompany() instead.
            "prototype$__get__mainCarrierCompany": {
              url: urlBase + "/Orders/:id/mainCarrierCompany",
              method: "GET",
            },

            // INTERNAL. Use Order.secondaryCarrierCompany() instead.
            "prototype$__get__secondaryCarrierCompany": {
              url: urlBase + "/Orders/:id/secondaryCarrierCompany",
              method: "GET",
            },

            // INTERNAL. Use Order.creator() instead.
            "prototype$__get__creator": {
              url: urlBase + "/Orders/:id/creator",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__findById__extraFieldsEntries
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Find a related item by id for extraFieldsEntries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for extraFieldsEntries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$__findById__extraFieldsEntries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Orders/:id/extraFieldsEntries/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__destroyById__extraFieldsEntries
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Delete a related item by id for extraFieldsEntries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for extraFieldsEntries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__extraFieldsEntries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Orders/:id/extraFieldsEntries/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__updateById__extraFieldsEntries
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Update a related item by id for extraFieldsEntries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `fk` – `{*}` - Foreign key for extraFieldsEntries
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$__updateById__extraFieldsEntries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Orders/:id/extraFieldsEntries/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__findById__stopoverHistory
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Find a related item by id for stopoverHistory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for stopoverHistory
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$__findById__stopoverHistory": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Orders/:id/stopoverHistory/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__destroyById__stopoverHistory
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Delete a related item by id for stopoverHistory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for stopoverHistory
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__stopoverHistory": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Orders/:id/stopoverHistory/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__updateById__stopoverHistory
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Update a related item by id for stopoverHistory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `fk` – `{*}` - Foreign key for stopoverHistory
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$__updateById__stopoverHistory": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Orders/:id/stopoverHistory/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Order.offers() instead.
            "prototype$__get__offers": {
              isArray: true,
              url: urlBase + "/Orders/:id/offers",
              method: "GET",
            },

            // INTERNAL. Use Order.offers.create() instead.
            "prototype$__create__offers": {
              url: urlBase + "/Orders/:id/offers",
              method: "POST",
            },

            // INTERNAL. Use Order.offers.count() instead.
            "prototype$__count__offers": {
              url: urlBase + "/Orders/:id/offers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__get__extraFieldsEntries
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Queries extraFieldsEntries of Order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$__get__extraFieldsEntries": {
              isArray: true,
              url: urlBase + "/Orders/:id/extraFieldsEntries",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__create__extraFieldsEntries
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Creates a new instance in extraFieldsEntries of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$__create__extraFieldsEntries": {
              url: urlBase + "/Orders/:id/extraFieldsEntries",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__delete__extraFieldsEntries
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Deletes all extraFieldsEntries of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__extraFieldsEntries": {
              url: urlBase + "/Orders/:id/extraFieldsEntries",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__count__extraFieldsEntries
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Counts extraFieldsEntries of Order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__extraFieldsEntries": {
              url: urlBase + "/Orders/:id/extraFieldsEntries/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__get__stopoverHistory
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Queries stopoverHistory of Order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$__get__stopoverHistory": {
              isArray: true,
              url: urlBase + "/Orders/:id/stopoverHistory",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__create__stopoverHistory
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Creates a new instance in stopoverHistory of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$__create__stopoverHistory": {
              url: urlBase + "/Orders/:id/stopoverHistory",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$__count__stopoverHistory
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Counts stopoverHistory of Order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__stopoverHistory": {
              url: urlBase + "/Orders/:id/stopoverHistory/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#create
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Orders",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#createMany
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Orders",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#findById
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Orders/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#replaceById
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Orders/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#find
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Orders",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#count
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Orders/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$updateAttributes
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Orders/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#uploadFiles
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Upload the file to the storage.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `url` – `{string=}` -
             */
            "uploadFiles": {
              url: urlBase + "/Orders/uploadFiles",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#deleteFiles
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Delete a file from the storage.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `fileUrl` – `{string}` - Url File
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "deleteFiles": {
              url: urlBase + "/Orders/deleteFiles",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#acceptOffer
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Accept offer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` - Order id
             *
             *  - `offerId` – `{string}` - Id of the Offer to be accepted
             *
             * @param {Object} postData Request data.
             *
             *  - `payment` – `{object}` - Object containing the properties `type`=DEPOSIT_OR_WIRE_TRANSFER | PAYMENT_AGREEMENT | CREDIT_CARD and [`voucherPhoto` or `documentNumber` when type is for deposit], [`creditCard` when type is credit card. When `id` is not present in `creditCard`, all other fields are required: `number`, `expire_month`, `expire_year` and `cvv2` ]
             *
             *  - `accessToken` – `{object=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "acceptOffer": {
              url: urlBase + "/Orders/:id/acceptOffer",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#getAcceptedOffer
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Get the accepted offer for the order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` - Order id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "getAcceptedOffer": {
              url: urlBase + "/Orders/:id/acceptedOffer",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$cancel
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Cancels an order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$cancel": {
              url: urlBase + "/Orders/:id/cancel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$verifyPayment
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Verify the payment of an order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$verifyPayment": {
              url: urlBase + "/Orders/:id/:id/verifyPayment",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$rejectPayment
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Rejects the payment of an order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$rejectPayment": {
              url: urlBase + "/Orders/:id/rejectPayment",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#markAsRead
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Marks an order as read by a user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` - Order id.
             *
             * @param {Object} postData Request data.
             *
             *  - `accessToken` – `{object=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` - Returns 200 http code if success.
             */
            "markAsRead": {
              url: urlBase + "/Orders/:id/read",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#scoreCarrier
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Scores the carrier company that managed the order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` - Order id.
             *
             * @param {Object} postData Request data.
             *
             *  - `score` – `{object}` - An object containing the score `value` and `comment`.
             *
             *  - `accessToken` – `{object=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `averageCompanyScore` – `{object=}` - Object containing the carrier average company score.
             */
            "scoreCarrier": {
              url: urlBase + "/Orders/:id/score",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$changeStatus
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Updates the status of an order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `incomingData` – `{object}` - The new status for the order.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$changeStatus": {
              url: urlBase + "/Orders/:id/changeStatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#setToVerifyingStatus
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Undo the last action made for a payment (verify or reject).
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` - Order id
             *
             * @param {Object} postData Request data.
             *
             * This method does not accept any data. Supply an empty object.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "setToVerifyingStatus": {
              url: urlBase + "/Orders/:id/setToVerifyingStatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#startChat
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Creates a new chat for the involved users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `orderId` – `{string}` - Order id.
             *
             * @param {Object} postData Request data.
             *
             *  - `incomingData` – `{object}` - Object containing the carrier company id.
             *
             *  - `accessToken` – `{object=}` - Don't supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `chatId` – `{object=}` - Object containing the chat `id`.
             */
            "startChat": {
              url: urlBase + "/Orders/:orderId/chat",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$assignResources
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Allow to assign resources (vehicles, drivers, trailers) to route segments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `assignmentData` – `{object}` - Object containing driverId (optional), vehicleId (optional), trailerId (optional), segmentsIds (array), notes (string, optional)
             *
             *  - `accessToken` – `{object}` - Don't supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$assignResources": {
              isArray: true,
              url: urlBase + "/Orders/:id/assignResources",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#findWithSegmentsResources
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Get orders with resources data on each segment
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `includeResourcesImages` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "findWithSegmentsResources": {
              isArray: true,
              url: urlBase + "/Orders/findWithSegmentsResources",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$createSegmentExtraField
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Patch a segment extra field.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `segmentId` – `{*}` - Segment id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `extraFieldEntryData` – `{object}` - Object containing single extra field entry data value and definitionId.
             *
             *  - `segmentIdInResponse` – `{boolean=}` - Don't supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$createSegmentExtraField": {
              isArray: true,
              params: {
                'segmentId': '@segmentId',
              },
              url: urlBase + "/Orders/:id/segment/:segmentId/extraField",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$updateSegmentExtraField
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Patch a segment extra field.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `segmentId` – `{*}` - Segment id
             *
             *  - `extraFieldId` – `{*}` - Extrafield id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `extraFieldEntryData` – `{object}` - Object containing single extra field entry data value and definitionId.
             *
             *  - `segmentIdInResponse` – `{boolean=}` - Don't supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$updateSegmentExtraField": {
              isArray: true,
              params: {
                'segmentId': '@segmentId',
                'extraFieldId': '@extraFieldId',
              },
              url: urlBase + "/Orders/:id/segment/:segmentId/extraField/:extraFieldId",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Order#prototype$retrieveSegmentExtraFields
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Get extrafields of a segment of and order
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `definitionId` – `{string=}` - Filter for definitionId like: 1d08e8c1-1f8b-42ba-8a5d-c0b32ae62581
             *
             *  - `segmentId` – `{*}` - Segment id
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
            "prototype$retrieveSegmentExtraFields": {
              isArray: true,
              url: urlBase + "/Orders/:id/segment/:segmentId/extraField",
              method: "GET",
            },

            // INTERNAL. Use Offer.order() instead.
            "::get::Offer::order": {
              url: urlBase + "/Offers/:id/order",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.orders.findById() instead.
            "::findById::CargoCompany::orders": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/orders/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.orders.destroyById() instead.
            "::destroyById::CargoCompany::orders": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/orders/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.orders.updateById() instead.
            "::updateById::CargoCompany::orders": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/orders/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoCompany.orders() instead.
            "::get::CargoCompany::orders": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/orders",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.orders.create() instead.
            "::create::CargoCompany::orders": {
              url: urlBase + "/CargoCompanies/:id/orders",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.orders.createMany() instead.
            "::createMany::CargoCompany::orders": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/orders",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.orders.destroyAll() instead.
            "::delete::CargoCompany::orders": {
              url: urlBase + "/CargoCompanies/:id/orders",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.orders.count() instead.
            "::count::CargoCompany::orders": {
              url: urlBase + "/CargoCompanies/:id/orders/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Order#patchAttributes
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Order#modelName
        * @propertyOf lbServices.Order
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Order`.
        */
        R.modelName = "Order";

    /**
     * @ngdoc object
     * @name lbServices.Order.offers
     * @header lbServices.Order.offers
     * @object
     * @description
     *
     * The object `Order.offers` groups methods
     * manipulating `Offer` instances related to `Order`.
     *
     * Call {@link lbServices.Order#offers Order.offers()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Order#offers
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Queries offers of Order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.offers = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::get::Order::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order.offers#count
             * @methodOf lbServices.Order.offers
             *
             * @description
             *
             * Counts offers of Order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.offers.count = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::count::Order::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order.offers#create
             * @methodOf lbServices.Order.offers
             *
             * @description
             *
             * Creates a new instance in offers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.offers.create = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::create::Order::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order.offers#createMany
             * @methodOf lbServices.Order.offers
             *
             * @description
             *
             * Creates a new instance in offers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.offers.createMany = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::createMany::Order::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order.offers#findById
             * @methodOf lbServices.Order.offers
             *
             * @description
             *
             * Find a related item by id for offers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for offers
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.offers.findById = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::findById::Order::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order#acceptedOffer
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Fetches belongsTo relation acceptedOffer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.acceptedOffer = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::get::Order::acceptedOffer"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order#oldAcceptedOffer
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Fetches belongsTo relation oldAcceptedOffer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.oldAcceptedOffer = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::get::Order::oldAcceptedOffer"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order#ownerCompany
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Fetches belongsTo relation ownerCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.ownerCompany = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::get::Order::ownerCompany"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order#shipperCompany
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Fetches belongsTo relation shipperCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.shipperCompany = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::get::Order::shipperCompany"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order#mainCarrierCompany
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Fetches belongsTo relation mainCarrierCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.mainCarrierCompany = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::get::Order::mainCarrierCompany"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order#secondaryCarrierCompany
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Fetches belongsTo relation secondaryCarrierCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.secondaryCarrierCompany = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::get::Order::secondaryCarrierCompany"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Order#creator
             * @methodOf lbServices.Order
             *
             * @description
             *
             * Fetches belongsTo relation creator.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Order id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.creator = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::get::Order::creator"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.SocialMedia
 * @header lbServices.SocialMedia
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `SocialMedia` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "SocialMedia",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/SocialMedias/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.SocialMedia#facebookLogin
             * @methodOf lbServices.SocialMedia
             *
             * @description
             *
             * Performs Facebook login.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SocialMedia` object.)
             * </em>
             */
            "facebookLogin": {
              url: urlBase + "/SocialMedias/facebook/login",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.SocialMedia#modelName
        * @propertyOf lbServices.SocialMedia
        * @description
        * The name of the model represented by this $resource,
        * i.e. `SocialMedia`.
        */
        R.modelName = "SocialMedia";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Offer
 * @header lbServices.Offer
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Offer` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Offer",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Offers/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Offer.order() instead.
            "prototype$__get__order": {
              url: urlBase + "/Offers/:id/order",
              method: "GET",
            },

            // INTERNAL. Use Offer.vehicle() instead.
            "prototype$__get__vehicle": {
              url: urlBase + "/Offers/:id/vehicle",
              method: "GET",
            },

            // INTERNAL. Use Offer.trailer() instead.
            "prototype$__get__trailer": {
              url: urlBase + "/Offers/:id/trailer",
              method: "GET",
            },

            // INTERNAL. Use Offer.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/Offers/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Offer.creator() instead.
            "prototype$__get__creator": {
              url: urlBase + "/Offers/:id/creator",
              method: "GET",
            },

            // INTERNAL. Use Offer.driver() instead.
            "prototype$__get__driver": {
              url: urlBase + "/Offers/:id/driver",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Offer#create
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Offers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Offer#createMany
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Offers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Offer#replaceOrCreate
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Offers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Offer#upsertWithWhere
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Offers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Offer#findById
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Offers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Offer#replaceById
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Offers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Offer#find
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Offers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Offer#count
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Offers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Offer#prototype$updateAttributes
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Offers/:id",
              method: "PUT",
            },

            // INTERNAL. Use Order.offers.findById() instead.
            "::findById::Order::offers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Orders/:id/offers/:fk",
              method: "GET",
            },

            // INTERNAL. Use Order.acceptedOffer() instead.
            "::get::Order::acceptedOffer": {
              url: urlBase + "/Orders/:id/acceptedOffer",
              method: "GET",
            },

            // INTERNAL. Use Order.oldAcceptedOffer() instead.
            "::get::Order::oldAcceptedOffer": {
              url: urlBase + "/Orders/:id/oldAcceptedOffer",
              method: "GET",
            },

            // INTERNAL. Use Order.offers() instead.
            "::get::Order::offers": {
              isArray: true,
              url: urlBase + "/Orders/:id/offers",
              method: "GET",
            },

            // INTERNAL. Use Order.offers.create() instead.
            "::create::Order::offers": {
              url: urlBase + "/Orders/:id/offers",
              method: "POST",
            },

            // INTERNAL. Use Order.offers.createMany() instead.
            "::createMany::Order::offers": {
              isArray: true,
              url: urlBase + "/Orders/:id/offers",
              method: "POST",
            },

            // INTERNAL. Use Order.offers.count() instead.
            "::count::Order::offers": {
              url: urlBase + "/Orders/:id/offers/count",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.offers.findById() instead.
            "::findById::CargoCompany::offers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/offers/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.offers.destroyById() instead.
            "::destroyById::CargoCompany::offers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/offers/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.offers.updateById() instead.
            "::updateById::CargoCompany::offers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/offers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoCompany.offers() instead.
            "::get::CargoCompany::offers": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/offers",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.offers.create() instead.
            "::create::CargoCompany::offers": {
              url: urlBase + "/CargoCompanies/:id/offers",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.offers.createMany() instead.
            "::createMany::CargoCompany::offers": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/offers",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.offers.destroyAll() instead.
            "::delete::CargoCompany::offers": {
              url: urlBase + "/CargoCompanies/:id/offers",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.offers.count() instead.
            "::count::CargoCompany::offers": {
              url: urlBase + "/CargoCompanies/:id/offers/count",
              method: "GET",
            },

            // INTERNAL. Use CargoUser.offers.findById() instead.
            "::findById::CargoUser::offers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoUsers/:id/offers/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoUser.offers.updateById() instead.
            "::updateById::CargoUser::offers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoUsers/:id/offers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoUser.driverOffers.findById() instead.
            "::findById::CargoUser::driverOffers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoUsers/:id/driverOffers/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoUser.driverOffers.destroyById() instead.
            "::destroyById::CargoUser::driverOffers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoUsers/:id/driverOffers/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CargoUser.driverOffers.updateById() instead.
            "::updateById::CargoUser::driverOffers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoUsers/:id/driverOffers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoUser.offers() instead.
            "::get::CargoUser::offers": {
              isArray: true,
              url: urlBase + "/CargoUsers/:id/offers",
              method: "GET",
            },

            // INTERNAL. Use CargoUser.offers.create() instead.
            "::create::CargoUser::offers": {
              url: urlBase + "/CargoUsers/:id/offers",
              method: "POST",
            },

            // INTERNAL. Use CargoUser.offers.createMany() instead.
            "::createMany::CargoUser::offers": {
              isArray: true,
              url: urlBase + "/CargoUsers/:id/offers",
              method: "POST",
            },

            // INTERNAL. Use CargoUser.offers.count() instead.
            "::count::CargoUser::offers": {
              url: urlBase + "/CargoUsers/:id/offers/count",
              method: "GET",
            },

            // INTERNAL. Use CargoUser.driverOffers() instead.
            "::get::CargoUser::driverOffers": {
              isArray: true,
              url: urlBase + "/CargoUsers/:id/driverOffers",
              method: "GET",
            },

            // INTERNAL. Use CargoUser.driverOffers.create() instead.
            "::create::CargoUser::driverOffers": {
              url: urlBase + "/CargoUsers/:id/driverOffers",
              method: "POST",
            },

            // INTERNAL. Use CargoUser.driverOffers.createMany() instead.
            "::createMany::CargoUser::driverOffers": {
              isArray: true,
              url: urlBase + "/CargoUsers/:id/driverOffers",
              method: "POST",
            },

            // INTERNAL. Use CargoUser.driverOffers.destroyAll() instead.
            "::delete::CargoUser::driverOffers": {
              url: urlBase + "/CargoUsers/:id/driverOffers",
              method: "DELETE",
            },

            // INTERNAL. Use CargoUser.driverOffers.count() instead.
            "::count::CargoUser::driverOffers": {
              url: urlBase + "/CargoUsers/:id/driverOffers/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Offer#patchOrCreateWithWhere
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Offer#patchAttributes
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Offer#modelName
        * @propertyOf lbServices.Offer
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Offer`.
        */
        R.modelName = "Offer";


            /**
             * @ngdoc method
             * @name lbServices.Offer#order
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Fetches belongsTo relation order.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Offer id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R.order = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::get::Offer::order"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Offer#vehicle
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Fetches belongsTo relation vehicle.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Offer id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R.vehicle = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::get::Offer::vehicle"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Offer#trailer
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Fetches belongsTo relation trailer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Offer id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Trailer` object.)
             * </em>
             */
        R.trailer = function() {
          var TargetResource = $injector.get("Trailer");
          var action = TargetResource["::get::Offer::trailer"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Offer#company
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Offer id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::get::Offer::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Offer#creator
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Fetches belongsTo relation creator.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Offer id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.creator = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::get::Offer::creator"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Offer#driver
             * @methodOf lbServices.Offer
             *
             * @description
             *
             * Fetches belongsTo relation driver.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Offer id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.driver = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::get::Offer::driver"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CargoCompany
 * @header lbServices.CargoCompany
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CargoCompany` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CargoCompany",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/CargoCompanies/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use CargoCompany.orders.findById() instead.
            "prototype$__findById__orders": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/orders/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.orders.destroyById() instead.
            "prototype$__destroyById__orders": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/orders/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.orders.updateById() instead.
            "prototype$__updateById__orders": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/orders/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoCompany.offers.findById() instead.
            "prototype$__findById__offers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/offers/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.offers.destroyById() instead.
            "prototype$__destroyById__offers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/offers/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.offers.updateById() instead.
            "prototype$__updateById__offers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/offers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoCompany.vehicles.findById() instead.
            "prototype$__findById__vehicles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/vehicles/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.vehicles.destroyById() instead.
            "prototype$__destroyById__vehicles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/vehicles/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.vehicles.updateById() instead.
            "prototype$__updateById__vehicles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/vehicles/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoCompany.parentCompany() instead.
            "prototype$__get__parentCompany": {
              url: urlBase + "/CargoCompanies/:id/parentCompany",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.childCompanies.findById() instead.
            "prototype$__findById__childCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/childCompanies/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.childCompanies.destroyById() instead.
            "prototype$__destroyById__childCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/childCompanies/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.childCompanies.updateById() instead.
            "prototype$__updateById__childCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/childCompanies/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoCompany.cargoUsers.findById() instead.
            "prototype$__findById__cargoUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/cargoUsers/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.cargoUsers.updateById() instead.
            "prototype$__updateById__cargoUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/cargoUsers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoCompany.locations.findById() instead.
            "prototype$__findById__locations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/locations/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.locations.destroyById() instead.
            "prototype$__destroyById__locations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/locations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.locations.updateById() instead.
            "prototype$__updateById__locations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/locations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions.findById() instead.
            "prototype$__findById__extraFieldsDefinitions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions.destroyById() instead.
            "prototype$__destroyById__extraFieldsDefinitions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions.updateById() instead.
            "prototype$__updateById__extraFieldsDefinitions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoCompany.orders() instead.
            "prototype$__get__orders": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/orders",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.orders.create() instead.
            "prototype$__create__orders": {
              url: urlBase + "/CargoCompanies/:id/orders",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.orders.destroyAll() instead.
            "prototype$__delete__orders": {
              url: urlBase + "/CargoCompanies/:id/orders",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.orders.count() instead.
            "prototype$__count__orders": {
              url: urlBase + "/CargoCompanies/:id/orders/count",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.offers() instead.
            "prototype$__get__offers": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/offers",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.offers.create() instead.
            "prototype$__create__offers": {
              url: urlBase + "/CargoCompanies/:id/offers",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.offers.destroyAll() instead.
            "prototype$__delete__offers": {
              url: urlBase + "/CargoCompanies/:id/offers",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.offers.count() instead.
            "prototype$__count__offers": {
              url: urlBase + "/CargoCompanies/:id/offers/count",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.vehicles() instead.
            "prototype$__get__vehicles": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/vehicles",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.vehicles.create() instead.
            "prototype$__create__vehicles": {
              url: urlBase + "/CargoCompanies/:id/vehicles",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.vehicles.destroyAll() instead.
            "prototype$__delete__vehicles": {
              url: urlBase + "/CargoCompanies/:id/vehicles",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.vehicles.count() instead.
            "prototype$__count__vehicles": {
              url: urlBase + "/CargoCompanies/:id/vehicles/count",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.childCompanies() instead.
            "prototype$__get__childCompanies": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/childCompanies",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.childCompanies.create() instead.
            "prototype$__create__childCompanies": {
              url: urlBase + "/CargoCompanies/:id/childCompanies",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.cargoUsers() instead.
            "prototype$__get__cargoUsers": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/cargoUsers",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.locations() instead.
            "prototype$__get__locations": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/locations",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.locations.create() instead.
            "prototype$__create__locations": {
              url: urlBase + "/CargoCompanies/:id/locations",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.locations.destroyAll() instead.
            "prototype$__delete__locations": {
              url: urlBase + "/CargoCompanies/:id/locations",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.locations.count() instead.
            "prototype$__count__locations": {
              url: urlBase + "/CargoCompanies/:id/locations/count",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions() instead.
            "prototype$__get__extraFieldsDefinitions": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions.create() instead.
            "prototype$__create__extraFieldsDefinitions": {
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions.destroyAll() instead.
            "prototype$__delete__extraFieldsDefinitions": {
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions.count() instead.
            "prototype$__count__extraFieldsDefinitions": {
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#create
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/CargoCompanies",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#createMany
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/CargoCompanies",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#replaceOrCreate
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/CargoCompanies/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#upsertWithWhere
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/CargoCompanies/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#exists
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/CargoCompanies/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#findById
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/CargoCompanies/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#replaceById
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/CargoCompanies/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#find
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/CargoCompanies",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#deleteById
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/CargoCompanies/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#prototype$updateAttributes
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/CargoCompanies/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#createUser
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Creates a new SHIPPER_USER, CARRIER_USER or DRIVER account for a company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` - Company id where the user will be created.
             *
             * @param {Object} postData Request data.
             *
             *  - `user` – `{object}` - Object with the user data. `roles` is a list with the desired roles for the user. If creating a shipper user, do not provide this field. If creating a carrier user who will also be a driver, provide ['CARRIER_USER', 'DRIVER']. If creating only a carrier user, this field is not required.
             *
             *  - `accessToken` – `{object=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
            "createUser": {
              url: urlBase + "/CargoCompanies/:id/users",
              method: "POST",
            },

            // INTERNAL. Use Vehicle.ownerCompany() instead.
            "::get::Vehicle::ownerCompany": {
              url: urlBase + "/Vehicles/:id/ownerCompany",
              method: "GET",
            },

            // INTERNAL. Use Trailer.ownerCompany() instead.
            "::get::Trailer::ownerCompany": {
              url: urlBase + "/Trailers/:id/ownerCompany",
              method: "GET",
            },

            // INTERNAL. Use Order.ownerCompany() instead.
            "::get::Order::ownerCompany": {
              url: urlBase + "/Orders/:id/ownerCompany",
              method: "GET",
            },

            // INTERNAL. Use Order.shipperCompany() instead.
            "::get::Order::shipperCompany": {
              url: urlBase + "/Orders/:id/shipperCompany",
              method: "GET",
            },

            // INTERNAL. Use Order.mainCarrierCompany() instead.
            "::get::Order::mainCarrierCompany": {
              url: urlBase + "/Orders/:id/mainCarrierCompany",
              method: "GET",
            },

            // INTERNAL. Use Order.secondaryCarrierCompany() instead.
            "::get::Order::secondaryCarrierCompany": {
              url: urlBase + "/Orders/:id/secondaryCarrierCompany",
              method: "GET",
            },

            // INTERNAL. Use Offer.company() instead.
            "::get::Offer::company": {
              url: urlBase + "/Offers/:id/company",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.parentCompany() instead.
            "::get::CargoCompany::parentCompany": {
              url: urlBase + "/CargoCompanies/:id/parentCompany",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.childCompanies.findById() instead.
            "::findById::CargoCompany::childCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/childCompanies/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.childCompanies.destroyById() instead.
            "::destroyById::CargoCompany::childCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/childCompanies/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.childCompanies.updateById() instead.
            "::updateById::CargoCompany::childCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/childCompanies/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoCompany.childCompanies() instead.
            "::get::CargoCompany::childCompanies": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/childCompanies",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.childCompanies.create() instead.
            "::create::CargoCompany::childCompanies": {
              url: urlBase + "/CargoCompanies/:id/childCompanies",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.childCompanies.createMany() instead.
            "::createMany::CargoCompany::childCompanies": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/childCompanies",
              method: "POST",
            },

            // INTERNAL. Use CargoUser.cargoCompany() instead.
            "::get::CargoUser::cargoCompany": {
              url: urlBase + "/CargoUsers/:id/cargoCompany",
              method: "GET",
            },

            // INTERNAL. Use Location.company() instead.
            "::get::Location::company": {
              url: urlBase + "/Locations/:id/company",
              method: "GET",
            },

            // INTERNAL. Use CompanyDashboard.ownerCompany() instead.
            "::get::CompanyDashboard::ownerCompany": {
              url: urlBase + "/CompanyDashboards/:id/ownerCompany",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#patchOrCreateWithWhere
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#destroyById
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#removeById
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#patchAttributes
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.CargoCompany#modelName
        * @propertyOf lbServices.CargoCompany
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CargoCompany`.
        */
        R.modelName = "CargoCompany";

    /**
     * @ngdoc object
     * @name lbServices.CargoCompany.orders
     * @header lbServices.CargoCompany.orders
     * @object
     * @description
     *
     * The object `CargoCompany.orders` groups methods
     * manipulating `Order` instances related to `CargoCompany`.
     *
     * Call {@link lbServices.CargoCompany#orders CargoCompany.orders()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#orders
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Queries orders of CargoCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R.orders = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::get::CargoCompany::orders"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.orders#count
             * @methodOf lbServices.CargoCompany.orders
             *
             * @description
             *
             * Counts orders of CargoCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.orders.count = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::count::CargoCompany::orders"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.orders#create
             * @methodOf lbServices.CargoCompany.orders
             *
             * @description
             *
             * Creates a new instance in orders of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R.orders.create = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::create::CargoCompany::orders"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.orders#createMany
             * @methodOf lbServices.CargoCompany.orders
             *
             * @description
             *
             * Creates a new instance in orders of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R.orders.createMany = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::createMany::CargoCompany::orders"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.orders#destroyAll
             * @methodOf lbServices.CargoCompany.orders
             *
             * @description
             *
             * Deletes all orders of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.orders.destroyAll = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::delete::CargoCompany::orders"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.orders#destroyById
             * @methodOf lbServices.CargoCompany.orders
             *
             * @description
             *
             * Delete a related item by id for orders.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for orders
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.orders.destroyById = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::destroyById::CargoCompany::orders"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.orders#findById
             * @methodOf lbServices.CargoCompany.orders
             *
             * @description
             *
             * Find a related item by id for orders.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for orders
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R.orders.findById = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::findById::CargoCompany::orders"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.orders#updateById
             * @methodOf lbServices.CargoCompany.orders
             *
             * @description
             *
             * Update a related item by id for orders.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for orders
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Order` object.)
             * </em>
             */
        R.orders.updateById = function() {
          var TargetResource = $injector.get("Order");
          var action = TargetResource["::updateById::CargoCompany::orders"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.CargoCompany.offers
     * @header lbServices.CargoCompany.offers
     * @object
     * @description
     *
     * The object `CargoCompany.offers` groups methods
     * manipulating `Offer` instances related to `CargoCompany`.
     *
     * Call {@link lbServices.CargoCompany#offers CargoCompany.offers()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#offers
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Queries offers of CargoCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.offers = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::get::CargoCompany::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.offers#count
             * @methodOf lbServices.CargoCompany.offers
             *
             * @description
             *
             * Counts offers of CargoCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.offers.count = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::count::CargoCompany::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.offers#create
             * @methodOf lbServices.CargoCompany.offers
             *
             * @description
             *
             * Creates a new instance in offers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.offers.create = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::create::CargoCompany::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.offers#createMany
             * @methodOf lbServices.CargoCompany.offers
             *
             * @description
             *
             * Creates a new instance in offers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.offers.createMany = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::createMany::CargoCompany::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.offers#destroyAll
             * @methodOf lbServices.CargoCompany.offers
             *
             * @description
             *
             * Deletes all offers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.offers.destroyAll = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::delete::CargoCompany::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.offers#destroyById
             * @methodOf lbServices.CargoCompany.offers
             *
             * @description
             *
             * Delete a related item by id for offers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for offers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.offers.destroyById = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::destroyById::CargoCompany::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.offers#findById
             * @methodOf lbServices.CargoCompany.offers
             *
             * @description
             *
             * Find a related item by id for offers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for offers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.offers.findById = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::findById::CargoCompany::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.offers#updateById
             * @methodOf lbServices.CargoCompany.offers
             *
             * @description
             *
             * Update a related item by id for offers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for offers
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.offers.updateById = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::updateById::CargoCompany::offers"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.CargoCompany.vehicles
     * @header lbServices.CargoCompany.vehicles
     * @object
     * @description
     *
     * The object `CargoCompany.vehicles` groups methods
     * manipulating `Vehicle` instances related to `CargoCompany`.
     *
     * Call {@link lbServices.CargoCompany#vehicles CargoCompany.vehicles()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#vehicles
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Queries vehicles of CargoCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R.vehicles = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::get::CargoCompany::vehicles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.vehicles#count
             * @methodOf lbServices.CargoCompany.vehicles
             *
             * @description
             *
             * Counts vehicles of CargoCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.vehicles.count = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::count::CargoCompany::vehicles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.vehicles#create
             * @methodOf lbServices.CargoCompany.vehicles
             *
             * @description
             *
             * Creates a new instance in vehicles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R.vehicles.create = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::create::CargoCompany::vehicles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.vehicles#createMany
             * @methodOf lbServices.CargoCompany.vehicles
             *
             * @description
             *
             * Creates a new instance in vehicles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R.vehicles.createMany = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::createMany::CargoCompany::vehicles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.vehicles#destroyAll
             * @methodOf lbServices.CargoCompany.vehicles
             *
             * @description
             *
             * Deletes all vehicles of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.vehicles.destroyAll = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::delete::CargoCompany::vehicles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.vehicles#destroyById
             * @methodOf lbServices.CargoCompany.vehicles
             *
             * @description
             *
             * Delete a related item by id for vehicles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for vehicles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.vehicles.destroyById = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::destroyById::CargoCompany::vehicles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.vehicles#findById
             * @methodOf lbServices.CargoCompany.vehicles
             *
             * @description
             *
             * Find a related item by id for vehicles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for vehicles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R.vehicles.findById = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::findById::CargoCompany::vehicles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.vehicles#updateById
             * @methodOf lbServices.CargoCompany.vehicles
             *
             * @description
             *
             * Update a related item by id for vehicles.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for vehicles
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R.vehicles.updateById = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::updateById::CargoCompany::vehicles"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#parentCompany
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Fetches belongsTo relation parentCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.parentCompany = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::get::CargoCompany::parentCompany"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.CargoCompany.childCompanies
     * @header lbServices.CargoCompany.childCompanies
     * @object
     * @description
     *
     * The object `CargoCompany.childCompanies` groups methods
     * manipulating `CargoCompany` instances related to `CargoCompany`.
     *
     * Call {@link lbServices.CargoCompany#childCompanies CargoCompany.childCompanies()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#childCompanies
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Queries childCompanies of CargoCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.childCompanies = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::get::CargoCompany::childCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.childCompanies#create
             * @methodOf lbServices.CargoCompany.childCompanies
             *
             * @description
             *
             * Creates a new instance in childCompanies of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.childCompanies.create = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::create::CargoCompany::childCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.childCompanies#createMany
             * @methodOf lbServices.CargoCompany.childCompanies
             *
             * @description
             *
             * Creates a new instance in childCompanies of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.childCompanies.createMany = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::createMany::CargoCompany::childCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.childCompanies#destroyById
             * @methodOf lbServices.CargoCompany.childCompanies
             *
             * @description
             *
             * Delete a related item by id for childCompanies.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for childCompanies
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.childCompanies.destroyById = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::destroyById::CargoCompany::childCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.childCompanies#findById
             * @methodOf lbServices.CargoCompany.childCompanies
             *
             * @description
             *
             * Find a related item by id for childCompanies.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for childCompanies
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.childCompanies.findById = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::findById::CargoCompany::childCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.childCompanies#updateById
             * @methodOf lbServices.CargoCompany.childCompanies
             *
             * @description
             *
             * Update a related item by id for childCompanies.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for childCompanies
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.childCompanies.updateById = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::updateById::CargoCompany::childCompanies"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.CargoCompany.cargoUsers
     * @header lbServices.CargoCompany.cargoUsers
     * @object
     * @description
     *
     * The object `CargoCompany.cargoUsers` groups methods
     * manipulating `CargoUser` instances related to `CargoCompany`.
     *
     * Call {@link lbServices.CargoCompany#cargoUsers CargoCompany.cargoUsers()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#cargoUsers
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Queries cargoUsers of CargoCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.cargoUsers = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::get::CargoCompany::cargoUsers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.cargoUsers#findById
             * @methodOf lbServices.CargoCompany.cargoUsers
             *
             * @description
             *
             * Find a related item by id for cargoUsers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for cargoUsers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.cargoUsers.findById = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::findById::CargoCompany::cargoUsers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.cargoUsers#updateById
             * @methodOf lbServices.CargoCompany.cargoUsers
             *
             * @description
             *
             * Update a related item by id for cargoUsers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for cargoUsers
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R.cargoUsers.updateById = function() {
          var TargetResource = $injector.get("CargoUser");
          var action = TargetResource["::updateById::CargoCompany::cargoUsers"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.CargoCompany.locations
     * @header lbServices.CargoCompany.locations
     * @object
     * @description
     *
     * The object `CargoCompany.locations` groups methods
     * manipulating `Location` instances related to `CargoCompany`.
     *
     * Call {@link lbServices.CargoCompany#locations CargoCompany.locations()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#locations
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Queries locations of CargoCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
        R.locations = function() {
          var TargetResource = $injector.get("Location");
          var action = TargetResource["::get::CargoCompany::locations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.locations#count
             * @methodOf lbServices.CargoCompany.locations
             *
             * @description
             *
             * Counts locations of CargoCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.locations.count = function() {
          var TargetResource = $injector.get("Location");
          var action = TargetResource["::count::CargoCompany::locations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.locations#create
             * @methodOf lbServices.CargoCompany.locations
             *
             * @description
             *
             * Creates a new instance in locations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
        R.locations.create = function() {
          var TargetResource = $injector.get("Location");
          var action = TargetResource["::create::CargoCompany::locations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.locations#createMany
             * @methodOf lbServices.CargoCompany.locations
             *
             * @description
             *
             * Creates a new instance in locations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
        R.locations.createMany = function() {
          var TargetResource = $injector.get("Location");
          var action = TargetResource["::createMany::CargoCompany::locations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.locations#destroyAll
             * @methodOf lbServices.CargoCompany.locations
             *
             * @description
             *
             * Deletes all locations of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.locations.destroyAll = function() {
          var TargetResource = $injector.get("Location");
          var action = TargetResource["::delete::CargoCompany::locations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.locations#destroyById
             * @methodOf lbServices.CargoCompany.locations
             *
             * @description
             *
             * Delete a related item by id for locations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for locations
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.locations.destroyById = function() {
          var TargetResource = $injector.get("Location");
          var action = TargetResource["::destroyById::CargoCompany::locations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.locations#findById
             * @methodOf lbServices.CargoCompany.locations
             *
             * @description
             *
             * Find a related item by id for locations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for locations
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
        R.locations.findById = function() {
          var TargetResource = $injector.get("Location");
          var action = TargetResource["::findById::CargoCompany::locations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.locations#updateById
             * @methodOf lbServices.CargoCompany.locations
             *
             * @description
             *
             * Update a related item by id for locations.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for locations
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
        R.locations.updateById = function() {
          var TargetResource = $injector.get("Location");
          var action = TargetResource["::updateById::CargoCompany::locations"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.CargoCompany.extraFieldsDefinitions
     * @header lbServices.CargoCompany.extraFieldsDefinitions
     * @object
     * @description
     *
     * The object `CargoCompany.extraFieldsDefinitions` groups methods
     * manipulating `ExtraFieldDefinition` instances related to `CargoCompany`.
     *
     * Call {@link lbServices.CargoCompany#extraFieldsDefinitions CargoCompany.extraFieldsDefinitions()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.CargoCompany#extraFieldsDefinitions
             * @methodOf lbServices.CargoCompany
             *
             * @description
             *
             * Queries extraFieldsDefinitions of CargoCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExtraFieldDefinition` object.)
             * </em>
             */
        R.extraFieldsDefinitions = function() {
          var TargetResource = $injector.get("ExtraFieldDefinition");
          var action = TargetResource["::get::CargoCompany::extraFieldsDefinitions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.extraFieldsDefinitions#count
             * @methodOf lbServices.CargoCompany.extraFieldsDefinitions
             *
             * @description
             *
             * Counts extraFieldsDefinitions of CargoCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.extraFieldsDefinitions.count = function() {
          var TargetResource = $injector.get("ExtraFieldDefinition");
          var action = TargetResource["::count::CargoCompany::extraFieldsDefinitions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.extraFieldsDefinitions#create
             * @methodOf lbServices.CargoCompany.extraFieldsDefinitions
             *
             * @description
             *
             * Creates a new instance in extraFieldsDefinitions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExtraFieldDefinition` object.)
             * </em>
             */
        R.extraFieldsDefinitions.create = function() {
          var TargetResource = $injector.get("ExtraFieldDefinition");
          var action = TargetResource["::create::CargoCompany::extraFieldsDefinitions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.extraFieldsDefinitions#createMany
             * @methodOf lbServices.CargoCompany.extraFieldsDefinitions
             *
             * @description
             *
             * Creates a new instance in extraFieldsDefinitions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExtraFieldDefinition` object.)
             * </em>
             */
        R.extraFieldsDefinitions.createMany = function() {
          var TargetResource = $injector.get("ExtraFieldDefinition");
          var action = TargetResource["::createMany::CargoCompany::extraFieldsDefinitions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.extraFieldsDefinitions#destroyAll
             * @methodOf lbServices.CargoCompany.extraFieldsDefinitions
             *
             * @description
             *
             * Deletes all extraFieldsDefinitions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.extraFieldsDefinitions.destroyAll = function() {
          var TargetResource = $injector.get("ExtraFieldDefinition");
          var action = TargetResource["::delete::CargoCompany::extraFieldsDefinitions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.extraFieldsDefinitions#destroyById
             * @methodOf lbServices.CargoCompany.extraFieldsDefinitions
             *
             * @description
             *
             * Delete a related item by id for extraFieldsDefinitions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for extraFieldsDefinitions
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.extraFieldsDefinitions.destroyById = function() {
          var TargetResource = $injector.get("ExtraFieldDefinition");
          var action = TargetResource["::destroyById::CargoCompany::extraFieldsDefinitions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.extraFieldsDefinitions#findById
             * @methodOf lbServices.CargoCompany.extraFieldsDefinitions
             *
             * @description
             *
             * Find a related item by id for extraFieldsDefinitions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for extraFieldsDefinitions
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExtraFieldDefinition` object.)
             * </em>
             */
        R.extraFieldsDefinitions.findById = function() {
          var TargetResource = $injector.get("ExtraFieldDefinition");
          var action = TargetResource["::findById::CargoCompany::extraFieldsDefinitions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoCompany.extraFieldsDefinitions#updateById
             * @methodOf lbServices.CargoCompany.extraFieldsDefinitions
             *
             * @description
             *
             * Update a related item by id for extraFieldsDefinitions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoCompany id
             *
             *  - `fk` – `{*}` - Foreign key for extraFieldsDefinitions
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExtraFieldDefinition` object.)
             * </em>
             */
        R.extraFieldsDefinitions.updateById = function() {
          var TargetResource = $injector.get("ExtraFieldDefinition");
          var action = TargetResource["::updateById::CargoCompany::extraFieldsDefinitions"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CargoUser
 * @header lbServices.CargoUser
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CargoUser` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CargoUser",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/CargoUsers/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use CargoUser.cargoCompany() instead.
            "prototype$__get__cargoCompany": {
              url: urlBase + "/CargoUsers/:id/cargoCompany",
              method: "GET",
            },

            // INTERNAL. Use CargoUser.offers.findById() instead.
            "prototype$__findById__offers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoUsers/:id/offers/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoUser.offers.updateById() instead.
            "prototype$__updateById__offers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoUsers/:id/offers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoUser.driverOffers.findById() instead.
            "prototype$__findById__driverOffers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoUsers/:id/driverOffers/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoUser.driverOffers.destroyById() instead.
            "prototype$__destroyById__driverOffers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoUsers/:id/driverOffers/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CargoUser.driverOffers.updateById() instead.
            "prototype$__updateById__driverOffers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoUsers/:id/driverOffers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoUser.defaultVehicle() instead.
            "prototype$__get__defaultVehicle": {
              url: urlBase + "/CargoUsers/:id/defaultVehicle",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#prototype$__findById__assignments
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Find a related item by id for assignments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for assignments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "prototype$__findById__assignments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoUsers/:id/assignments/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#prototype$__destroyById__assignments
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Delete a related item by id for assignments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for assignments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__assignments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoUsers/:id/assignments/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#prototype$__updateById__assignments
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Update a related item by id for assignments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `fk` – `{*}` - Foreign key for assignments
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "prototype$__updateById__assignments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoUsers/:id/assignments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoUser.offers() instead.
            "prototype$__get__offers": {
              isArray: true,
              url: urlBase + "/CargoUsers/:id/offers",
              method: "GET",
            },

            // INTERNAL. Use CargoUser.offers.create() instead.
            "prototype$__create__offers": {
              url: urlBase + "/CargoUsers/:id/offers",
              method: "POST",
            },

            // INTERNAL. Use CargoUser.offers.count() instead.
            "prototype$__count__offers": {
              url: urlBase + "/CargoUsers/:id/offers/count",
              method: "GET",
            },

            // INTERNAL. Use CargoUser.driverOffers() instead.
            "prototype$__get__driverOffers": {
              isArray: true,
              url: urlBase + "/CargoUsers/:id/driverOffers",
              method: "GET",
            },

            // INTERNAL. Use CargoUser.driverOffers.create() instead.
            "prototype$__create__driverOffers": {
              url: urlBase + "/CargoUsers/:id/driverOffers",
              method: "POST",
            },

            // INTERNAL. Use CargoUser.driverOffers.destroyAll() instead.
            "prototype$__delete__driverOffers": {
              url: urlBase + "/CargoUsers/:id/driverOffers",
              method: "DELETE",
            },

            // INTERNAL. Use CargoUser.driverOffers.count() instead.
            "prototype$__count__driverOffers": {
              url: urlBase + "/CargoUsers/:id/driverOffers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#prototype$__get__assignments
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Queries assignments of CargoUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "prototype$__get__assignments": {
              isArray: true,
              url: urlBase + "/CargoUsers/:id/assignments",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#prototype$__create__assignments
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Creates a new instance in assignments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "prototype$__create__assignments": {
              url: urlBase + "/CargoUsers/:id/assignments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#prototype$__delete__assignments
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Deletes all assignments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__assignments": {
              url: urlBase + "/CargoUsers/:id/assignments",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#prototype$__count__assignments
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Counts assignments of CargoUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__assignments": {
              url: urlBase + "/CargoUsers/:id/assignments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#create
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/CargoUsers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#createMany
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/CargoUsers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#replaceOrCreate
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/CargoUsers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#upsertWithWhere
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/CargoUsers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#exists
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/CargoUsers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#findById
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/CargoUsers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#replaceById
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/CargoUsers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#find
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/CargoUsers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#deleteById
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/CargoUsers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#count
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/CargoUsers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#prototype$updateAttributes
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/CargoUsers/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#login
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `U+007BUserU+007D` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/CargoUsers/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#logout
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/CargoUsers/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#confirm
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Confirm a user registration with email verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/CargoUsers/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#resetPassword
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/CargoUsers/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#addDeviceToken
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Adds a new device token for a user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `incomingData` – `{object}` - Object containing the new `deviceToken`.
             *
             *  - `accessToken` – `{object=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "addDeviceToken": {
              url: urlBase + "/CargoUsers/addDeviceToken",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#loginWithPhone
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Login an driver with phone number and secret token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "loginWithPhone": {
              url: urlBase + "/CargoUsers/loginWithPhone",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#loginWithToken
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Login an user with token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "loginWithToken": {
              url: urlBase + "/CargoUsers/loginWithToken",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#recentRoutes
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Get recent routes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` - Cargo User id
             *
             *  - `limit` – `{number=}` - Number of routes to get. (default: 3)
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "recentRoutes": {
              isArray: true,
              url: urlBase + "/CargoUsers/:id/recentRoutes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#prototype$resetUnviewedOrdersCount
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Reset unviewed orders count to zero.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "prototype$resetUnviewedOrdersCount": {
              url: urlBase + "/CargoUsers/:id/resetUnviewedOrdersCount",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#resendConfirmationEmail
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Resend the account confirmation email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `email` – `{string}` - CargoUser email
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "resendConfirmationEmail": {
              url: urlBase + "/CargoUsers/resendConfirmationEmail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#resetUserPassword
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Reset user password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `incomingData` – `{object}` - An object containing the password
             *
             *  - `accessToken` – `{object=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
            "resetUserPassword": {
              url: urlBase + "/CargoUsers/resetPassword",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#sendPhoneAuthenticationCode
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Sends a sms with an authentication code to the specified phone number.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `incomingData` – `{object}` - Object containing the `phoneNumber`.
             *
             *  - `accessToken` – `{object=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `phoneAuthentication` – `{string=}` -
             */
            "sendPhoneAuthenticationCode": {
              url: urlBase + "/CargoUsers/sendPhoneAuthenticationCode",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#prototype$assignedOrderIds
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Retrieve the orders ids where the logged user is assigned.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `results` – `{object=}` -
             */
            "prototype$assignedOrderIds": {
              url: urlBase + "/CargoUsers/:id/assignedOrderIds",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.cargoUser.findById() instead.
            "::findById::Vehicle::cargoUser": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/cargoUser/:fk",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.cargoUser.destroyById() instead.
            "::destroyById::Vehicle::cargoUser": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/cargoUser/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Vehicle.cargoUser.updateById() instead.
            "::updateById::Vehicle::cargoUser": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vehicles/:id/cargoUser/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Vehicle.defaultDriver() instead.
            "::get::Vehicle::defaultDriver": {
              url: urlBase + "/Vehicles/:id/defaultDriver",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.defaultDriver.create() instead.
            "::create::Vehicle::defaultDriver": {
              url: urlBase + "/Vehicles/:id/defaultDriver",
              method: "POST",
            },

            // INTERNAL. Use Vehicle.defaultDriver.createMany() instead.
            "::createMany::Vehicle::defaultDriver": {
              isArray: true,
              url: urlBase + "/Vehicles/:id/defaultDriver",
              method: "POST",
            },

            // INTERNAL. Use Vehicle.defaultDriver.update() instead.
            "::update::Vehicle::defaultDriver": {
              url: urlBase + "/Vehicles/:id/defaultDriver",
              method: "PUT",
            },

            // INTERNAL. Use Vehicle.defaultDriver.destroy() instead.
            "::destroy::Vehicle::defaultDriver": {
              url: urlBase + "/Vehicles/:id/defaultDriver",
              method: "DELETE",
            },

            // INTERNAL. Use Vehicle.cargoUser() instead.
            "::get::Vehicle::cargoUser": {
              isArray: true,
              url: urlBase + "/Vehicles/:id/cargoUser",
              method: "GET",
            },

            // INTERNAL. Use Vehicle.cargoUser.create() instead.
            "::create::Vehicle::cargoUser": {
              url: urlBase + "/Vehicles/:id/cargoUser",
              method: "POST",
            },

            // INTERNAL. Use Vehicle.cargoUser.createMany() instead.
            "::createMany::Vehicle::cargoUser": {
              isArray: true,
              url: urlBase + "/Vehicles/:id/cargoUser",
              method: "POST",
            },

            // INTERNAL. Use Vehicle.cargoUser.destroyAll() instead.
            "::delete::Vehicle::cargoUser": {
              url: urlBase + "/Vehicles/:id/cargoUser",
              method: "DELETE",
            },

            // INTERNAL. Use Vehicle.cargoUser.count() instead.
            "::count::Vehicle::cargoUser": {
              url: urlBase + "/Vehicles/:id/cargoUser/count",
              method: "GET",
            },

            // INTERNAL. Use Order.creator() instead.
            "::get::Order::creator": {
              url: urlBase + "/Orders/:id/creator",
              method: "GET",
            },

            // INTERNAL. Use Offer.creator() instead.
            "::get::Offer::creator": {
              url: urlBase + "/Offers/:id/creator",
              method: "GET",
            },

            // INTERNAL. Use Offer.driver() instead.
            "::get::Offer::driver": {
              url: urlBase + "/Offers/:id/driver",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.cargoUsers.findById() instead.
            "::findById::CargoCompany::cargoUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/cargoUsers/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.cargoUsers.updateById() instead.
            "::updateById::CargoCompany::cargoUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/cargoUsers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoCompany.cargoUsers() instead.
            "::get::CargoCompany::cargoUsers": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/cargoUsers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#getCurrent
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/CargoUsers" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.CargoUser#patchOrCreateWithWhere
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#destroyById
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#removeById
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#patchAttributes
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoUser` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.CargoUser#getCachedCurrent
         * @methodOf lbServices.CargoUser
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.CargoUser#login} or
         * {@link lbServices.CargoUser#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A CargoUser instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.CargoUser#isAuthenticated
         * @methodOf lbServices.CargoUser
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.CargoUser#getCurrentId
         * @methodOf lbServices.CargoUser
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.CargoUser#modelName
        * @propertyOf lbServices.CargoUser
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CargoUser`.
        */
        R.modelName = "CargoUser";


            /**
             * @ngdoc method
             * @name lbServices.CargoUser#cargoCompany
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Fetches belongsTo relation cargoCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.cargoCompany = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::get::CargoUser::cargoCompany"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.CargoUser.offers
     * @header lbServices.CargoUser.offers
     * @object
     * @description
     *
     * The object `CargoUser.offers` groups methods
     * manipulating `Offer` instances related to `CargoUser`.
     *
     * Call {@link lbServices.CargoUser#offers CargoUser.offers()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.CargoUser#offers
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Queries offers of CargoUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.offers = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::get::CargoUser::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoUser.offers#count
             * @methodOf lbServices.CargoUser.offers
             *
             * @description
             *
             * Counts offers of CargoUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.offers.count = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::count::CargoUser::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoUser.offers#create
             * @methodOf lbServices.CargoUser.offers
             *
             * @description
             *
             * Creates a new instance in offers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.offers.create = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::create::CargoUser::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoUser.offers#createMany
             * @methodOf lbServices.CargoUser.offers
             *
             * @description
             *
             * Creates a new instance in offers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.offers.createMany = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::createMany::CargoUser::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoUser.offers#findById
             * @methodOf lbServices.CargoUser.offers
             *
             * @description
             *
             * Find a related item by id for offers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for offers
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.offers.findById = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::findById::CargoUser::offers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoUser.offers#updateById
             * @methodOf lbServices.CargoUser.offers
             *
             * @description
             *
             * Update a related item by id for offers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `fk` – `{*}` - Foreign key for offers
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.offers.updateById = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::updateById::CargoUser::offers"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.CargoUser.driverOffers
     * @header lbServices.CargoUser.driverOffers
     * @object
     * @description
     *
     * The object `CargoUser.driverOffers` groups methods
     * manipulating `Offer` instances related to `CargoUser`.
     *
     * Call {@link lbServices.CargoUser#driverOffers CargoUser.driverOffers()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.CargoUser#driverOffers
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Queries driverOffers of CargoUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.driverOffers = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::get::CargoUser::driverOffers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoUser.driverOffers#count
             * @methodOf lbServices.CargoUser.driverOffers
             *
             * @description
             *
             * Counts driverOffers of CargoUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.driverOffers.count = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::count::CargoUser::driverOffers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoUser.driverOffers#create
             * @methodOf lbServices.CargoUser.driverOffers
             *
             * @description
             *
             * Creates a new instance in driverOffers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.driverOffers.create = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::create::CargoUser::driverOffers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoUser.driverOffers#createMany
             * @methodOf lbServices.CargoUser.driverOffers
             *
             * @description
             *
             * Creates a new instance in driverOffers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.driverOffers.createMany = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::createMany::CargoUser::driverOffers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoUser.driverOffers#destroyAll
             * @methodOf lbServices.CargoUser.driverOffers
             *
             * @description
             *
             * Deletes all driverOffers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.driverOffers.destroyAll = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::delete::CargoUser::driverOffers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoUser.driverOffers#destroyById
             * @methodOf lbServices.CargoUser.driverOffers
             *
             * @description
             *
             * Delete a related item by id for driverOffers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for driverOffers
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.driverOffers.destroyById = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::destroyById::CargoUser::driverOffers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoUser.driverOffers#findById
             * @methodOf lbServices.CargoUser.driverOffers
             *
             * @description
             *
             * Find a related item by id for driverOffers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for driverOffers
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.driverOffers.findById = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::findById::CargoUser::driverOffers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoUser.driverOffers#updateById
             * @methodOf lbServices.CargoUser.driverOffers
             *
             * @description
             *
             * Update a related item by id for driverOffers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `fk` – `{*}` - Foreign key for driverOffers
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Offer` object.)
             * </em>
             */
        R.driverOffers.updateById = function() {
          var TargetResource = $injector.get("Offer");
          var action = TargetResource["::updateById::CargoUser::driverOffers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CargoUser#defaultVehicle
             * @methodOf lbServices.CargoUser
             *
             * @description
             *
             * Fetches belongsTo relation defaultVehicle.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CargoUser id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vehicle` object.)
             * </em>
             */
        R.defaultVehicle = function() {
          var TargetResource = $injector.get("Vehicle");
          var action = TargetResource["::get::CargoUser::defaultVehicle"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Account
 * @header lbServices.Account
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Account` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Account",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Accounts/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Account#create
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Creates a new account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Accounts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#createMany
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Creates a new account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Accounts",
              method: "POST",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Account#modelName
        * @propertyOf lbServices.Account
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Account`.
        */
        R.modelName = "Account";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Location
 * @header lbServices.Location
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Location` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Location",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Locations/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Location.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/Locations/:id/company",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#create
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Locations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#createMany
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Locations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#upsert
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Locations",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#replaceOrCreate
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Locations/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#upsertWithWhere
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Locations/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#exists
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Locations/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#findById
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Locations/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#replaceById
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Locations/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#findOne
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Locations/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#updateAll
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Locations/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#deleteById
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Locations/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#count
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Locations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#prototype$updateAttributes
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Location id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Locations/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#createChangeStream
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Locations/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Location#getAllLocations
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Get all locations corresponding to a user company and the locations from that companies children
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
            "getAllLocations": {
              isArray: true,
              url: urlBase + "/Locations/getAllLocations",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.locations.findById() instead.
            "::findById::CargoCompany::locations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/locations/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.locations.destroyById() instead.
            "::destroyById::CargoCompany::locations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/locations/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.locations.updateById() instead.
            "::updateById::CargoCompany::locations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/locations/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoCompany.locations() instead.
            "::get::CargoCompany::locations": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/locations",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.locations.create() instead.
            "::create::CargoCompany::locations": {
              url: urlBase + "/CargoCompanies/:id/locations",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.locations.createMany() instead.
            "::createMany::CargoCompany::locations": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/locations",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.locations.destroyAll() instead.
            "::delete::CargoCompany::locations": {
              url: urlBase + "/CargoCompanies/:id/locations",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.locations.count() instead.
            "::count::CargoCompany::locations": {
              url: urlBase + "/CargoCompanies/:id/locations/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Location#patchOrCreate
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Location#updateOrCreate
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Location#patchOrCreateWithWhere
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Location#update
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Location#destroyById
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Location#removeById
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Location#patchAttributes
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Location id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Location` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Location#modelName
        * @propertyOf lbServices.Location
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Location`.
        */
        R.modelName = "Location";


            /**
             * @ngdoc method
             * @name lbServices.Location#company
             * @methodOf lbServices.Location
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Location id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::get::Location::company"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ExtraFieldDefinition
 * @header lbServices.ExtraFieldDefinition
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ExtraFieldDefinition` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ExtraFieldDefinition",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ExtraFieldDefinitions/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions.findById() instead.
            "::findById::CargoCompany::extraFieldsDefinitions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions/:fk",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions.destroyById() instead.
            "::destroyById::CargoCompany::extraFieldsDefinitions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions.updateById() instead.
            "::updateById::CargoCompany::extraFieldsDefinitions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions() instead.
            "::get::CargoCompany::extraFieldsDefinitions": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions",
              method: "GET",
            },

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions.create() instead.
            "::create::CargoCompany::extraFieldsDefinitions": {
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions.createMany() instead.
            "::createMany::CargoCompany::extraFieldsDefinitions": {
              isArray: true,
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions",
              method: "POST",
            },

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions.destroyAll() instead.
            "::delete::CargoCompany::extraFieldsDefinitions": {
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions",
              method: "DELETE",
            },

            // INTERNAL. Use CargoCompany.extraFieldsDefinitions.count() instead.
            "::count::CargoCompany::extraFieldsDefinitions": {
              url: urlBase + "/CargoCompanies/:id/extraFieldsDefinitions/count",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.ExtraFieldDefinition#modelName
        * @propertyOf lbServices.ExtraFieldDefinition
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ExtraFieldDefinition`.
        */
        R.modelName = "ExtraFieldDefinition";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CompanyDashboard
 * @header lbServices.CompanyDashboard
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CompanyDashboard` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CompanyDashboard",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/CompanyDashboards/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use CompanyDashboard.ownerCompany() instead.
            "prototype$__get__ownerCompany": {
              url: urlBase + "/CompanyDashboards/:id/ownerCompany",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#create
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CompanyDashboard` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/CompanyDashboards",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#createMany
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CompanyDashboard` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/CompanyDashboards",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#replaceOrCreate
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CompanyDashboard` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/CompanyDashboards/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#upsertWithWhere
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CompanyDashboard` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/CompanyDashboards/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#findById
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CompanyDashboard` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/CompanyDashboards/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#replaceById
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CompanyDashboard` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/CompanyDashboards/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#find
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CompanyDashboard` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/CompanyDashboards",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#deleteById
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CompanyDashboard` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/CompanyDashboards/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#count
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/CompanyDashboards/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#prototype$updateAttributes
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CompanyDashboard` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/CompanyDashboards/:id",
              method: "PUT",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#patchOrCreateWithWhere
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CompanyDashboard` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#destroyById
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CompanyDashboard` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#removeById
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CompanyDashboard` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#patchAttributes
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CompanyDashboard` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.CompanyDashboard#modelName
        * @propertyOf lbServices.CompanyDashboard
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CompanyDashboard`.
        */
        R.modelName = "CompanyDashboard";


            /**
             * @ngdoc method
             * @name lbServices.CompanyDashboard#ownerCompany
             * @methodOf lbServices.CompanyDashboard
             *
             * @description
             *
             * Fetches belongsTo relation ownerCompany.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CompanyDashboard id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CargoCompany` object.)
             * </em>
             */
        R.ownerCompany = function() {
          var TargetResource = $injector.get("CargoCompany");
          var action = TargetResource["::get::CompanyDashboard::ownerCompany"];
          return action.apply(R, arguments);
        };


        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && host !== urlBaseHost) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);

(function () {
  angular.module('Common').service('LocationsHelper', LocationsHelper);

  function LocationsHelper () {
    var self = this;
    self.getFormattedStringTime = getFormattedStringTime;

    function getFormattedStringTime (referenceDate, comparativeDate) {
      var locationTime;

      var referenceDateMoment = getMomentFromDate(referenceDate);
      var comparativeDateMoment = getMomentFromDate(comparativeDate);
      moment.locale('es');
      var hoursAndMinutes = comparativeDateMoment.format('HH:mm');
      var locationMonth = comparativeDateMoment.format('MMM');
      var monthAndDay = comparativeDateMoment.format('DD') + ' ' + locationMonth;
      var monthDayHoursMinutes = monthAndDay + ' ' + hoursAndMinutes;
      var monthDayYearHoursMinutes = monthAndDay + ' ' + comparativeDateMoment.format('YYYY') + ', ' + hoursAndMinutes;

      if (comparativeDateMoment.isSame(referenceDateMoment, 'year')) {
        locationTime = monthDayHoursMinutes;
      } else {
        locationTime = monthDayYearHoursMinutes;
      }

      if (locationTime) return locationTime.toString();
    }

    function getMomentFromDate(utcDate) {
      return moment(new Date(utcDate));
    }
  }

}());

(function () {
  angular.module('Cargo77.config', [])
    .constant('cargo77Config', {
      'baseUrl': 'any',
      'loopback': 'https://api.cargo77.com/api',
      'firebaseApiKey': 'AIzaSyDFPUetuXv_LvjPNRrWN908LdUxIjl0Pe0',
      'firebaseAuthDomain': 'voltaic-plating-210613.firebaseapp.com',
      'firebaseDatabaseURL': 'https://voltaic-plating-210613.firebaseio.com',
      'firebaseStorageBucket': 'voltaic-plating-210613.appspot.com',
      'googleMapsAPIKey': 'AIzaSyBNeQ4239bA1GvUFfIyHw1WgL3yVIeAT0A',
      'googleMapsBaseURL': 'https://maps.googleapis.com/maps/api/timezone/json?location=',
/*
        'loopback': 'https://api.cargo77.com/api',
        'firebaseApiKey': 'AIzaSyDFPUetuXv_LvjPNRrWN908LdUxIjl0Pe0',
        'firebaseAuthDomain': 'voltaic-plating-210613.firebaseapp.com',
        'firebaseDatabaseURL': 'https://voltaic-plating-210613.firebaseio.com',
        'firebaseStorageBucket': 'voltaic-plating-210613.appspot.com',
        'googleMapsAPIKey': 'AIzaSyBNeQ4239bA1GvUFfIyHw1WgL3yVIeAT0A',
        'googleMapsBaseURL': 'https://maps.googleapis.com/maps/api/timezone/json?location=',
 */
    });
}());

(function () {
  'use strict';

  angular
    .module('cargo77WebEmpresas', [
      'ngAnimate',
      'ngCookies',
      'ngSanitize',
      'ngResource',
      'ngMessages',
      'ngAria',
      'permission.ui',
      'ui.router',
      'ui.utils.masks',
      'internationalPhoneNumber',
      'ngMaterial',
      'uiGmapgoogle-maps',
      'Common',
      'ngRateIt',
      'focus-if',
      '720kb.datepicker',
      'pikaday',
      'ngMask',
      'lbServices',
      'Main.module',
      'Cargo77.security',
      'Cargo77.config',
      'Cargo77.chat',
      'Cargo77.calendar',
      'Cargo77.vehicles',
      'Cargo77.trailers',
      'Cargo77.users',
      'Cargo77.companies',
      'Cargo77.orders',
      'Cargo77.login',
      'Cargo77.dashboard',
      'Cargo77.payments',
      'Cargo77.signUp',
      'Cargo77.reports',
      'Cargo77.locations',
      'Cargo77.notificationInbox',
    ]);
})();

(function () {
  'use strict';

  angular
    .module('cargo77WebEmpresas')
    .run(runBlock);

  /** @ngInject */
  function runBlock() {
    moment.locale('es');
  }

})();

(function () {
  'use strict';

  angular
    .module('cargo77WebEmpresas')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig ($urlRouterProvider) {
    $urlRouterProvider.otherwise('login');
  }

})();

(function () {
  'use strict';

  angular
    .module('cargo77WebEmpresas');

})();

(function () {
  'use strict';

  angular
    .module('cargo77WebEmpresas')
    .config(config);

  /** @ngInject */
  function config($logProvider, $mdThemingProvider, uiGmapGoogleMapApiProvider, $mdIconProvider, ipnConfig, cargo77Config) {
    // Enable log
    ipnConfig.defaultCountry = 'ec';
    ipnConfig.nationalMode = false;
    ipnConfig.preferredCountries = ['ec', 'co'];
    $logProvider.debugEnabled(true);
    $mdIconProvider
      .defaultIconSet('assets/mdi.svg');
    uiGmapGoogleMapApiProvider.configure({
      key: cargo77Config.googleMapsAPIKey,
      libraries: 'places',
    });

    var cargoAccent = $mdThemingProvider.extendPalette('red', {
      'A100': '#009688',
    });

    $mdThemingProvider.definePalette('cargoAccent', cargoAccent);

    $mdThemingProvider.theme('default')
      .primaryPalette('blue-grey', {
        'default': '800',
      })
      .backgroundPalette('grey', {
        'default': '50',
      })
      .accentPalette('cargoAccent');
  }

})();

angular.module("cargo77WebEmpresas").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div layout=row class=page-container layout-wrap><side-bar menu-items=$ctrl.menuItems></side-bar><section flex layout=column layout-wrap><header><nav-bar></nav-bar></header><md-content class=main-md-content flex layout=row layout-align=\"center start\" layout-fill><div flex=100 ui-view></div></md-content></section></div>");
$templateCache.put("app/components/calendar/calendar.html","<div ui-view></div>");
$templateCache.put("app/components/login/login.html","<header flex=100><md-toolbar id=login-navbar class=md-whiteframe-3dp layout=row layout-align=\"start center\"><div layout=row layout-align=\"start center\" flex=15 flex-md=25 flex-sm=35 flex-xs=50 class=logo-container><img flex class=logo src=assets/images/cargo77-logo.svg></div></md-toolbar></header><md-content flex=100 layout-align=\"center center\" layout=row><div class=background-image></div><div class=background-overlay></div><section flex layout-fill class=page-wrapper layout=row layout-wrap layout-align=\"space-around center\"><login-card class=login-card flex=45 flex-sm=80 flex-xs=90></login-card></section></md-content>");
$templateCache.put("app/security/views/401.html","<md-card layout=column layout-align=\"space-between start\"><md-card-content flex layout=row layout-wrap layout-align=\"space-around center\" layout-fill><section flex=50 flex-xs=100><img style=\"max-width: 100%\" src=assets/images/truck.png></section><section flex=30 flex-xs=100><h1 class=md-headline>Cuenta inválida - Error 401</h1><h1>Lo sentimos, la cuenta introducida es inválida.</h1><md-button class=\"md-accent md-raised\" ui-sref=login>Regresar al inicio</md-button></section></md-card-content></md-card>");
$templateCache.put("app/security/views/403.html","<md-card layout=column layout-align=\"space-between start\"><md-card-content flex layout=row layout-wrap layout-align=\"space-around center\" layout-fill><section flex=50 flex-xs=100><img style=\"max-width: 100%\" src=assets/images/truck.png></section><section flex=30 flex-xs=100><h1 class=md-headline>No autorizado - Error 403</h1><h1>Lo sentimos, no está autorizado para realizar la acción.</h1><md-button class=\"md-accent md-raised\" ui-sref=login>Regresar al inicio</md-button></section></md-card-content></md-card>");
$templateCache.put("app/security/views/404.html","<md-card layout=column layout-align=\"space-between start\"><md-card-content flex layout=row layout-wrap layout-align=\"space-around center\" layout-fill><section flex=50 flex-xs=100><img style=\"max-width: 100%\" src=assets/images/truck.png></section><section flex=30 flex-xs=100><h1 class=md-headline>Página no encontrada - Error 404</h1><h1>Lo sentimos, no se encuentra la página deseada.</h1><md-button class=\"md-accent md-raised\" ui-sref=login>Regresar al inicio</md-button></section></md-card-content></md-card>");
$templateCache.put("app/security/views/500.html","<md-card layout=column layout-align=\"space-between start\"><md-card-content flex layout=row layout-wrap layout-align=\"space-around center\" layout-fill><section flex=50 flex-xs=100><img style=\"max-width: 100%\" src=assets/images/truck.png></section><section flex=30 flex-xs=100><h1 class=md-headline>Opsssss - Error 500</h1><h1>Lo sentimos, el servidor no responde, inténtelo más tarde.</h1><md-button class=\"md-accent md-raised\" ui-sref=login>Regresar al inicio</md-button></section></md-card-content></md-card>");
$templateCache.put("app/security/views/main.html","<section class=cargo77-security layout-fill layout=row layout-wrap><header flex=100><md-toolbar id=login-navbar class=md-whiteframe-3dp layout=row layout-align=\"start center\"><div layout=row layout-align=\"start center\" flex=20 flex-md=30 flex-sm=40 flex-xs=50 class=logo-container><img flex class=logo src=assets/images/cargo77-logo.svg></div></md-toolbar></header><md-content flex=100 layout-align=\"center center\" layout=row><div class=background-image></div><div class=background-overlay></div><section flex layout-fill class=page-wrapper layout=row layout-wrap layout-align=\"space-around center\"><div flex=100 flex-sm=80 flex-xs=90 ui-view></div></section></md-content></section>");
$templateCache.put("app/components/chat/components/chat.html","<md-content layout=row layout-wrap layout-align=\"center center\"><md-card flex=100 layout=row layout-align=\"space-between start\"><section hide-xs hide-sm class=chat-rooms flex-xs=100 flex=45><div ng-if=\"$ctrl.chats.length <= 0\">No tienes ningun chat activo</div><cargo77-chat-tile ng-if=!$ctrl.isLoading ng-click=$ctrl.getMessagesForChat(chat) ng-repeat=\"chat in $ctrl.chats\" chat=chat></cargo77-chat-tile><cargo77-chat-loading ng-if=$ctrl.isLoading chat-count=$ctrl.chatCount()></cargo77-chat-loading></section><section hide-gt-sm ng-if=!$ctrl.selectedChat class=chat-rooms flex-sm=100 flex-xs=100 flex=45><div ng-if=\"$ctrl.chats.length <= 0\">No tienes ningun chat activo</div><cargo77-chat-tile ng-if=!$ctrl.isLoading ng-click=$ctrl.getMessagesForChat(chat) ng-repeat=\"chat in $ctrl.chats\" chat=chat></cargo77-chat-tile><cargo77-chat-loading ng-if=$ctrl.isLoading chat-count=$ctrl.chatCount()></cargo77-chat-loading></section><section class=message-section ng-if=$ctrl.selectedChat layout-fill layout-wrap flex-sm=100 flex-xs=100 flex=55><cargo77-chat-container messages=$ctrl.messages chat=$ctrl.selectedChat get-user-id=$ctrl.getUserId() back-action=$ctrl.backAction() send-message=$ctrl.sendMessage(message)></cargo77-chat-container></section></md-card></md-content>");
$templateCache.put("app/components/common/add-extra-fields-selector/add-extra-fields-selector.html","<section class=dropdown-options-container flex=100 layout=column><section layout=row flex=100 layout-wrap layout-align=\"space-between center\"><cargo77-add-field-selector flex=30 flex-sm=100 flex-xs=100 layout=row layout-align=\"start center\" class=cargo77-segment-selector field=field ng-repeat=\"field in $ctrl.selectedExtraFields track by field.index\" on-change-field=$ctrl.changeField on-saving-file=$ctrl.savingFile on-delete-field=$ctrl.deleteField can-be-deleted=\"!(field.isRequired || field.isAlwaysVisible)\"></cargo77-add-field-selector><section ng-if=\"$ctrl.selectedExtraFields.length === 2 || $ctrl.selectedExtraFields.length % 3 === 2\" flex=30 flex-sm=100 flex-xs=100 layout=row></section></section><section layout=row flex=100 layout-wrap layout-align=\"space-between center\" ng-show=\"enabledFields.length !== 0\"><section flex=30 flex-sm=100 flex-xs=100 layout=row layout-align=\"start center\"><md-input-container flex=100><label>Otros Requerimientos</label><md-select ng-model=$ctrl.fieldSelected ng-change=$ctrl.addNewField($ctrl.fieldSelected)><md-option ng-value=field ng-repeat=\"field in enabledFields = ($ctrl.optionalExtraFields | filter: {enabled: true} | orderBy: \'name\') \">{{ $ctrl.getNameTruncated(field.name, 40) }}</md-option></md-select></md-input-container></section></section></section>");
$templateCache.put("app/components/common/back-button/back-button.html","<span class=back-button-container><md-icon class=back-button ng-click=backButton.goBack() flex=10 flex-sm=5 md-font-icon>arrow_back</md-icon></span>");
$templateCache.put("app/components/common/company-selector/company-selector.html","<md-autocomplete flex class=auto-complete-box md-selected-item=$ctrl.selectedCompany md-search-text=$ctrl.companySearchText md-items=\"item in companiesFiltered = ($ctrl.companies | filter: {name: $ctrl.companySearchText} | orderBy: \'name\') || undefined\" md-item-text=item.name md-min-length=0 md-floating-label=Compañía md-selected-item-change=$ctrl.changeCompany() md-search-text-change=$ctrl.searchTextChange() placeholder=Compañía ng-disabled=$ctrl.disabled md-input-name=companySelector md-no-cache=true md-dropdown-items=\"(companiesFiltered.length || $ctrl.companies.length) > 5 ? 5 : (companiesFiltered.length || $ctrl.companies.length)\" ng-required=$ctrl.required><md-item-template><section layout=row class=company-selector layout-align=\"space-between center\"><div flex=25 layout-fill class=image-container><div flex layout-align=\"center center\" layout=row><md-icon md-font-icon>account_balance</md-icon></div></div><div flex=70><span style=\"text-transform: capitalize\" md-highlight-text=$ctrl.companySearchText md-highlight-flags=^i>{{item.name}}</span></div></section></md-item-template><md-not-found>La búsqueda \"{{$ctrl.companySearchText}}\" no retornó ninguna compañía.</md-not-found><div ng-messages=$ctrl.formReference.companySelector.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-autocomplete>");
$templateCache.put("app/components/common/drawer-type-selector/drawer-type-selector.html","<section layout=row layout-wrap><md-switch ng-disabled=!$ctrl.isOwnOrder ng-model=$ctrl.needDrawer aria-label=\"Tipo de camion\">Escoger un tipo de camion</md-switch><section ng-if=$ctrl.needDrawer layout=column flex-offset=15><md-checkbox ng-disabled=\"$ctrl.getSelectedDrawerCount() === 2 && !drawerType.isSelected\" flex ng-repeat=\"drawerType in $ctrl.drawerTypes\" ng-model=drawerType.isSelected aria-label={{drawerType.title}}><span class=type>{{drawerType.title}}</span></md-checkbox></section></section>");
$templateCache.put("app/components/common/fab-menu/fab-menu.html","<md-fab-speed-dial ng-if=!fabMenu.isOnDashboard() ui-sref={{fabMenu.redirectionState()}} class=md-scale md-open=fabMenu.isOpen md-direction=up ng-mouseenter=\"fabMenu.isOpen=true\" ng-mouseleave=\"fabMenu.isOpen=false\" permission permission-except=\"[\'CARRIER_VIEWER\', \'SHIPPER_VIEWER\']\"><md-fab-trigger><md-button aria-label=menu class=\"md-fab md-accent\"><ng-md-icon icon={{fabMenu.getIcon()}}></ng-md-icon></md-button></md-fab-trigger></md-fab-speed-dial><md-fab-speed-dial ng-if=\"false && fabMenu.isOnDashboard()\" class=md-scale md-open=fabMenu.isOpen md-direction=up ng-mouseenter=\"fabMenu.isOpen=true\" ng-mouseleave=\"fabMenu.isOpen=false\"><md-fab-trigger><md-button aria-label=menu class=\"md-fab md-accent\"><ng-md-icon icon={{fabMenu.getIcon()}}></ng-md-icon></md-button></md-fab-trigger><md-fab-actions><md-button aria-label=\"Agregar flete\" permission permission-sref=\"\'cargo.createOrder\'\" ui-sref=cargo.createOrder class=\"md-fab md-raised md-mini\"><md-tooltip md-direction=left md-visible=tooltipVisible>Agregar Flete</md-tooltip><md-icon class=gray-icon md-font-icon aria-label=\"Agregar Flete\">near_me</md-icon></md-button><md-button aria-label=\"Agregar flete\" permission permission-sref=\"\'cargo.shipperCreateOrder\'\" ui-sref=cargo.shipperCreateOrder class=\"md-fab md-raised md-mini\"><md-tooltip md-direction=left md-visible=tooltipVisible>Agregar Flete</md-tooltip><md-icon class=gray-icon md-font-icon aria-label=\"Agregar Flete\">near_me</md-icon></md-button><md-button aria-label=\"Agregar unidad\" permission permission-sref=\"\'cargo.createVehicle\'\" ui-sref=cargo.createVehicle class=\"md-fab md-raised md-mini\"><md-tooltip md-direction=left md-visible=tooltipVisible>Registrar unidad</md-tooltip><md-icon class=gray-icon md-font-icon aria-label=\"Registrar Unidad\">directions_bus</md-icon></md-button><md-button aria-label=\"Agregar conductor\" permission permission-sref=\"\'cargo.createDriver\'\" ui-sref=cargo.createDriver class=\"md-fab md-raised md-mini\"><md-tooltip md-direction=left md-visible=tooltipVisible>Registrar conductor</md-tooltip><md-icon class=gray-icon md-font-icon aria-label=\"Registrar Conductor\">assignment_ind</md-icon></md-button><md-button aria-label=\"Agregar usuario\" permission permission-sref=\"\'cargo.createUser\'\" ui-sref=cargo.createUser class=\"md-fab md-raised md-mini\"><md-tooltip md-direction=left md-visible=tooltipVisible>Registrar usuario</md-tooltip><md-icon class=gray-icon md-font-icon aria-label=\"Registrar usuario\">account_box</md-icon></md-button><md-button aria-label=\"Agregar compañía\" permission permission-sref=\"\'cargo.createCompany\'\" ui-sref=cargo.createCompany class=\"md-fab md-raised md-mini\"><md-tooltip md-direction=left md-visible=tooltipVisible>Registrar compañía</md-tooltip><md-icon class=gray-icon md-font-icon aria-label=\"Registrar compañía\">account_balance</md-icon></md-button><md-button aria-label=\"Agregar ubicación\" permission permission-sref=\"\'cargo.createLocation\'\" ui-sref=cargo.createLocation class=\"md-fab md-raised md-mini\"><md-tooltip md-direction=left md-visible=tooltipVisible>Registrar ubicación</md-tooltip><md-icon class=gray-icon md-font-icon aria-label=\"Registrar compañía\">map_marker</md-icon></md-button></md-fab-actions></md-fab-speed-dial>");
$templateCache.put("app/components/common/location-selector/location-selector.html","<section layout-padding class=maps layout=row layout-wrap layout-align=\"space-between center\"><div flex=100 flex-sm=100 flex-xs=100 layout=column><h3>Seleccionar ubicación *</h3><div class=map-wrapper><ui-gmap-google-map flex events=locationSelector.mapOptions.events options=locationSelector.mapOptions.options center=locationSelector.mapOptions.center bounds=locationSelector.mapOptions.bounds zoom=locationSelector.mapOptions.zoom disabled><ui-gmap-search-box options=locationSelector.mapOptions.searchbox.options template=locationSelector.mapOptions.searchbox.template events=locationSelector.mapOptions.searchbox.events position=locationSelector.mapOptions.searchbox.position></ui-gmap-search-box><ui-gmap-marker coords=locationSelector.mapOptions.clickedMarker.coords idkey=locationSelector.mapOptions.clickedMarker.id></ui-gmap-marker></ui-gmap-google-map></div><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon class=name>directions</md-icon><input readonly ng-model=locationSelector.location.address></md-input-container></div><p class=required-error ng-if=locationSelector.showRequiredError>* Ubicación es un campo requerido</p></section>");
$templateCache.put("app/components/common/role-selector/role-selector.html","<section layout=row layout-wrap><div flex=100 class=title permission permission-only=\"[\'CARGO_ADMIN\', \'SHIPPER_OWNER\', \'CARRIER_OWNER\', \'CARRIER_USER\', \'SHIPPER_USER\']\" ng-if=$ctrl.company.type layout-align=\"start center\">Roles del usuario</div><div flex=100 class=title ng-if=!$ctrl.company.type permission permission-only=\"[\'SUPER_ADMIN\']\" layout-align=\"start center\">Roles del usuario</div><section layout=column flex-offset=5><md-checkbox permission ng-disabled=\"$ctrl.setSelectableRoles().indexOf(\'SHIPPER_OWNER\') < 0\" permission-only=\"[\'CARGO_ADMIN\', \'SHIPPER_OWNER\', \'CARRIER_OWNER\']\" ng-if=\"$ctrl.company.type === \'SHIPPER\'\" ng-checked=\"$ctrl.exists(\'SHIPPER_OWNER\')\" ng-click=\"$ctrl.toggle(\'SHIPPER_OWNER\')\" class=shipper-owner-checkbox>Administrador de empresa<md-tooltip md-direction=top>El usuario podrá usar todas las funcionalidades, incluyendo desactivar o eliminar la cuenta.</md-tooltip></md-checkbox><md-checkbox permission ng-disabled=\"$ctrl.setSelectableRoles().indexOf(\'SHIPPER_USER\') < 0\" permission-only=\"[\'CARGO_ADMIN\', \'SHIPPER_OWNER\', \'CARRIER_OWNER\', \'CARRIER_USER\', \'SHIPPER_USER\']\" ng-if=\"$ctrl.company.type === \'SHIPPER\'\" ng-checked=\"$ctrl.exists(\'SHIPPER_USER\')\" ng-click=\"$ctrl.toggle(\'SHIPPER_USER\')\" class=shipper-user-checkbox>Operador<md-tooltip md-direction=top>El usuario podrá usar todas las funcionalidades, excepto eliminar la cuenta.</md-tooltip></md-checkbox><md-checkbox permission ng-disabled=\"$ctrl.setSelectableRoles().indexOf(\'CARRIER_OWNER\') < 0\" permission-only=\"[\'CARGO_ADMIN\', \'CARRIER_OWNER\']\" ng-if=\"$ctrl.company.type === \'CARRIER\'\" ng-checked=\"$ctrl.exists(\'CARRIER_OWNER\')\" ng-click=\"$ctrl.toggle(\'CARRIER_OWNER\')\" class=carrier-owner-checkbox>Administrador de empresa<md-tooltip md-direction=top>El usuario podrá usar todas las funcionalidades, incluyendo desactivar o eliminar la cuenta.</md-tooltip></md-checkbox><md-checkbox permission ng-disabled=\"$ctrl.setSelectableRoles().indexOf(\'CARRIER_USER\') < 0\" permission-only=\"[\'CARGO_ADMIN\', \'CARRIER_OWNER\', \'CARRIER_USER\']\" ng-if=\"$ctrl.company.type === \'CARRIER\'\" ng-checked=\"$ctrl.exists(\'CARRIER_USER\')\" ng-click=\"$ctrl.toggle(\'CARRIER_USER\')\" class=carrier-user-checkbox>Operador<md-tooltip md-direction=top>El usuario podrá usar todas las funcionalidades, excepto eliminar la cuenta.</md-tooltip></md-checkbox><md-checkbox permission ng-disabled=\"$ctrl.setSelectableRoles().indexOf(\'DRIVER\') < 0\" permission-only=\"[\'CARGO_ADMIN\', \'CARRIER_OWNER\',\'CARRIER_USER\']\" ng-if=\"$ctrl.company.type === \'CARRIER\'\" ng-checked=\"$ctrl.exists(\'DRIVER\')\" ng-click=\"$ctrl.toggle(\'DRIVER\')\" class=driver-checkbox>Conductor<md-tooltip md-direction=top>El usuario podrá usar la aplicación móvil de conductor, y se le podrán asignar fletes.</md-tooltip></md-checkbox><md-checkbox permission ng-disabled=\"$ctrl.setSelectableRoles().indexOf(\'CARRIER_VIEWER\') < 0\" permission-only=\"[\'CARGO_ADMIN\', \'CARRIER_OWNER\',\'CARRIER_USER\']\" ng-if=\"$ctrl.company.type === \'CARRIER\'\" ng-checked=\"$ctrl.exists(\'CARRIER_VIEWER\')\" ng-click=\"$ctrl.toggle(\'CARRIER_VIEWER\')\" class=driver-checkbox>Espectador<md-tooltip md-direction=top>El usuario podrá unicamente mirar los fletes. No tiene permisos de edición.</md-tooltip></md-checkbox><md-checkbox permission ng-disabled=\"$ctrl.setSelectableRoles().indexOf(\'SHIPPER_VIEWER\') < 0\" permission-only=\"[\'CARGO_ADMIN\', \'SHIPPER_OWNER\', \'SHIPPER_USER\', \'CARRIER_OWNER\', \'CARRIER_USER\']\" ng-if=\"$ctrl.company.type === \'SHIPPER\'\" ng-checked=\"$ctrl.exists(\'SHIPPER_VIEWER\')\" ng-click=\"$ctrl.toggle(\'SHIPPER_VIEWER\')\" class=driver-checkbox>Espectador<md-tooltip md-direction=top>El usuario podrá unicamente mirar los fletes. No tiene permisos de edición.</md-tooltip></md-checkbox><md-checkbox permission ng-disabled=\"$ctrl.setSelectableRoles().indexOf(\'CARGO_ADMIN\') < 0\" permission-only=\"[\'SUPER_ADMIN\']\" ng-if=!$ctrl.company.type ng-checked=\"$ctrl.exists(\'CARGO_ADMIN\')\" ng-click=\"$ctrl.toggle(\'CARGO_ADMIN\')\" class=cargo-admin-checkbox>Administrador del sistema<md-tooltip md-direction=top>El usuario puede administrar todo el sistema.</md-tooltip></md-checkbox></section><section class=alert-note layout=row flex=100 layout-align=\"space-between center\" permission permission-only=\"[\'CARGO_ADMIN\', \'CARRIER_OWNER\', \'SHIPPER_OWNER\', \'CARRIER_USER\', \'SHIPPER_USER\']\" ng-if=$ctrl.company.type><div flex=15 class=icon-container><md-icon md-font-icon>warning</md-icon></div><div class=alert-text flex=85>Cambiar los roles del usuario puede afectar la funcionalidad de las aplicaciones</div></section><section permission permission-only=\"[\'SUPER_ADMIN\']\" ng-if=!$ctrl.company.type class=alert-note layout=row flex=100 layout-align=\"space-between center\"><div flex=15 class=icon-container><md-icon md-font-icon>warning</md-icon></div><div flex=85>Cambiar los roles del usuario puede afectar la funcionalidad de las aplicaciones</div></section></section>");
$templateCache.put("app/components/common/route-selector/route-selector.html","<section layout-padding class=maps layout=row layout-wrap layout-align=\"space-between center\"><div flex=50 flex-sm=100 flex-xs=100 layout=column><h3>Lugar de retiro</h3><span ng-show=routeSelector.isOwnOrder><ui-gmap-google-map flex events=routeSelector.pickupMapOptions.events options=routeSelector.pickupMapOptions.options center=routeSelector.pickupMapOptions.center bounds=routeSelector.pickupMapOptions.bounds zoom=routeSelector.pickupMapOptions.zoom disabled><ui-gmap-search-box options=routeSelector.pickupMapOptions.searchbox.options template=routeSelector.pickupMapOptions.searchbox.template events=routeSelector.pickupMapOptions.searchbox.events position=routeSelector.pickupMapOptions.searchbox.position></ui-gmap-search-box><ui-gmap-marker coords=routeSelector.pickupMapOptions.clickedMarker.coords idkey=routeSelector.pickupMapOptions.clickedMarker.id></ui-gmap-marker></ui-gmap-google-map></span><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon class=name>place</md-icon><input readonly ng-model=routeSelector.route.pickupAddress.address></md-input-container></div><div flex=50 flex-sm=100 flex-xs=100 layout=column><h3>Lugar de entrega</h3><span ng-show=routeSelector.isOwnOrder><ui-gmap-google-map flex events=routeSelector.deliveryMapOptions.events options=routeSelector.deliveryMapOptions.options center=routeSelector.deliveryMapOptions.center bounds=routeSelector.deliveryMapOptions.bounds zoom=routeSelector.deliveryMapOptions.zoom><ui-gmap-search-box options=routeSelector.deliveryMapOptions.searchbox.options template=routeSelector.deliveryMapOptions.searchbox.template events=routeSelector.deliveryMapOptions.searchbox.events position=routeSelector.deliveryMapOptions.searchbox.position></ui-gmap-search-box><ui-gmap-marker coords=routeSelector.deliveryMapOptions.clickedMarker.coords idkey=routeSelector.deliveryMapOptions.clickedMarker.id></ui-gmap-marker></ui-gmap-google-map></span><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon class=name>place</md-icon><input readonly ng-model=routeSelector.route.deliveryAddress.address></md-input-container></div><div flex=100 ng-if=routeSelector.routeDistance layout-padding layout=row layout-align=\"center center\"><div flex=15 flex-xs=100 flex-sm=40 class=distance-container>{{routeSelector.routeDistance.text}}</div></div></section>");
$templateCache.put("app/components/common/route-with-details-selector/route-with-details-selector.html","<section ng-show=$ctrl.shouldShowContent() class=route-with-details-container flex=100 layout=column><cargo77-route-locations-selector on-route-change=$ctrl.changeRouteLocations(route) selected-company-id=$ctrl.selectedCompanyId route-segments=$ctrl.route.segments is-shipper-order=$ctrl.isShipperOrder route=$ctrl.route.locations></cargo77-route-locations-selector><cargo77-route-segment-details on-route-details-change=$ctrl.changeRouteSegments(segments) on-saving-segment-files=\"$ctrl.savingSegmentFiles(saved, saving)\" route-segments=$ctrl.route.segments selected-company-id=$ctrl.selectedCompanyId carrier-company-id=$ctrl.carrierCompanyId route-locations=$ctrl.route.locations></cargo77-route-segment-details></section><section ng-show=!$ctrl.shouldShowContent()><p>Por favor seleccione un cliente.</p></section>");
$templateCache.put("app/components/common/search-bar/search-bar.html","<section flex=100 layout=row layout=column layout-align=\"start center\" class=\"md-whiteframe-3dp search-bar-container\"><div ng-if=searchBar.onStatusFilterChange flex-offset-xs=5 flex-xs=40 flex-md=25 flex-sm=30 flex=20 class=status-filter-container><md-input-container class=md-block><md-select md-container-class=filter-states ng-model=searchBar.selectedStatus placeholder=\"Todos los estados\"><md-option value=\"\" ng-click=searchBar.changeStatus({})>Todos los estados</md-option><md-option ng-repeat=\"status in searchBar.status\" ng-click=searchBar.changeStatus(status) value={{status.label}}>{{status.title}}</md-option></md-select></md-input-container></div><div ng-if=\"searchBar.onParentCompanyFilterChange && searchBar.companies.length > 1\" flex-offset-xs=5 flex-xs=40 flex-md=25 flex-sm=30 flex=20 class=status-filter-container><md-input-container class=md-block><md-select md-container-class=filter-states ng-model=searchBar.selectedStatus placeholder=\"Todas las compañias\"><md-option value=\"\" ng-click=searchBar.changeParentCompany({})>Todas las compañias</md-option><md-option ng-repeat=\"company in searchBar.companies\" ng-click=searchBar.changeParentCompany(company) value={{company.name}}>{{company.name}}</md-option></md-select></md-input-container></div><div ng-if=searchBar.onDateFilterChange flex=20 flex-sm=30 flex-xs=40 class=date-filter-container><div class=\"md-block date-container\"><md-select class=filter-date-selector md-container-class=filter-date ng-model=searchBar.selectedDate placeholder=Todos><md-option value=\"\'all\'\" ng-click=\"searchBar.changeDate(\'all\')\">Todos</md-option><md-option value=\"\'week\'\" ng-click=\"searchBar.changeDate(\'week\')\">Esta semana</md-option><md-option value=\"\'today\'\" ng-click=\"searchBar.changeDate(\'today\')\">Hoy</md-option><md-option value=\"\'month\'\" ng-click=\"searchBar.changeDate(\'month\')\">Este mes</md-option><md-option value=searchBar.customDate><div>Fecha específica <input mdc-datetime-picker date=true time=false type=text format=\"dddd, DD MMM YYYY\" placeholder=\"Fecha específica\" lang=es cancel-text=Cancelar ok-text=Aceptar ng-model=searchBar.customDate class=md-input></div></md-option></md-select></div></div><div ng-if=searchBar.onLoadSizeFilterChange flex-offset-xs=5 flex-xs=40 flex-md=25 flex-sm=30 flex=20 class=status-filter-container><md-input-container class=md-block><md-select md-container-class=filter-size ng-model=searchBar.selectedLoadSize placeholder=\"Tamaño de la carga\"><md-option value=any ng-click=searchBar.changeLoadSize({})>Cualquier tamaño</md-option><md-option ng-repeat=\"size in searchBar.loadSizes\" ng-click=searchBar.changeLoadSize(size) value={{size.title}}>{{size.title}}</md-option></md-select></md-input-container></div><div ng-if=searchBar.onRoleFilterChange flex=20 flex-sm=30 flex-xs=40 class=role-filter-container><div class=\"md-block role-container\" md-no-float><md-select md-container-class=filter-date ng-model=searchBar.selectedDate placeholder=Todos><md-option value=\"\'all\'\" ng-click=\"searchBar.changeRole(\'ALL\')\">Todos</md-option><md-option value=\"\'user\'\" ng-if=searchBar.isCarrier ng-click=\"searchBar.changeRole(\'CARRIER_USER\')\">Operador</md-option><md-option value=\"\'user\'\" ng-if=searchBar.isShipper ng-click=\"searchBar.changeRole(\'SHIPPER_USER\')\">Operador</md-option><md-option value=\"\'user\'\" ng-if=\"searchBar.isAdmin || searchBar.isSuperadmin\" ng-click=\"searchBar.changeRole([\'SHIPPER_USER\', \'CARRIER_USER\'])\">Operador</md-option><md-option value=\"\'driver\'\" ng-if=\"searchBar.isCarrier || searchBar.isAdmin || searchBar.isSuperadmin\" ng-click=\"searchBar.changeRole(\'DRIVER\')\">Conductor</md-option><md-option value=\"\'owner\'\" ng-if=searchBar.isShipper ng-click=\"searchBar.changeRole(\'SHIPPER_OWNER\')\">Administrador de empresa</md-option><md-option value=\"\'owner\'\" ng-if=searchBar.isCarrier ng-click=\"searchBar.changeRole(\'CARRIER_OWNER\')\">Administrador de empresa</md-option><md-option value=\"\'owner\'\" ng-if=\"searchBar.isAdmin || searchBar.isSuperadmin\" ng-click=\"searchBar.changeRole([\'SHIPPER_OWNER\', \'CARRIER_OWNER\'])\">Administrador de empresa</md-option><md-option value=\"\'admin\'\" ng-if=searchBar.isSuperadmin ng-click=\"searchBar.changeRole(\'CARGO_ADMIN\')\">Administrador de Cargo77</md-option><md-option value=\"\'viewer\'\" ng-if=searchBar.isCarrier ng-click=\"searchBar.changeRole(\'CARRIER_VIEWER\')\">Espectador</md-option><md-option value=\"\'viewer\'\" ng-if=searchBar.isShipper ng-click=\"searchBar.changeRole(\'SHIPPER_VIEWER\')\">Espectador</md-option><md-option value=\"\'viewer\'\" ng-if=\"searchBar.isAdmin || searchBar.isSuperadmin\" ng-click=\"searchBar.changeRole([\'CARRIER_VIEWER\', \'SHIPPER_VIEWER\'])\">Espectador</md-option></md-select></div></div><div ng-if=\"searchBar.onSearchTextFilterChange && searchBar.isUserCarrierAndDriver()\" flex=20 flex-sm=30 flex-xs=40 class=search-container-carrier-driver><md-input-container class=\"md-block search-text-filter-input\" md-no-float><md-icon ng-click=searchBar.openSearch() md-font-icon>search</md-icon><input class=search-input ng-model=searchBar.searchText type=search ng-model-options=\"{getterSetter: true, updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 }}\"></md-input-container></div><div ng-if=\"searchBar.onSearchTextFilterChange && !searchBar.isUserCarrierAndDriver()\" flex=20 flex-sm=30 flex-xs=40 class=search-container><md-input-container class=\"md-block search-text-filter-input\" md-no-float><md-icon ng-click=searchBar.openSearch() md-font-icon>search</md-icon><input class=search-input ng-model=searchBar.searchText type=search ng-model-options=\"{getterSetter: true, updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 }}\"></md-input-container></div><div class=show-own-orders-container ng-if=\"searchBar.isUserCarrierAndDriver() && searchBar.onDriverCarrierShowOwnOrdersFilterChange\" flex=50><p class=show-own-orders-label>Mostrar solo mis fletes:</p><md-switch ng-click=searchBar.changeDriverCarrierShowOnlyValue() class=show-own-orders-switch ng-model=searchBar.isShowingDriverCarrierOnlyOwnOrders aria-label=\"Switch 1\"></md-switch></div></section>");
$templateCache.put("app/components/common/termsAndConditions/termsConditions.html","<md-dialog><md-dialog-content class=terms-condition-dialog><div class=md-dialog-content><div ng-bind-html=$ctrl.terms></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=$ctrl.close() class=\"md-accent md-hue-1\">rechazar</md-button><md-button ng-click=$ctrl.accept() class=\"md-accent md-hue-1\">aceptar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/common/time-selector/time-selector.html","<h2 class=size-title>Fecha y horario</h2><section layout=row layout-wrap><div class=date-container flex=35 flex-sm=50 flex-xs=100><md-input-container md-no-float class=\"md-icon-float md-block\"><md-icon md-font-icon>date_range</md-icon><input ng-disabled=!$ctrl.isOwnOrder mdc-datetime-picker date=true time=false type=text format=\"dddd, DD MMM YYYY\" min-date=$ctrl.minDate placeholder=Fecha lang=es cancel-text=Cancelar ok-text=Aceptar ng-model=$ctrl.selectedDate class=md-input></md-input-container></div><md-menu flex=35 flex-sm=50 flex-xs=100><md-button ng-disabled=!$ctrl.isOwnOrder aria-label=\"Selected Time\" ng-click=\"$mdOpenMenu($event); $ctrl.validateTimes();\" class=item><section ng-if=\"$ctrl.selectedTime && $ctrl.selectedTime.label !== \'specificTime\'\" layout-align=\"space-around center\" layout=row layout-wrap><div flex=20 layout=row layout-align=\"center center\"><img class=image ng-src={{$ctrl.selectedTime.image}}></div><div flex=65><h3 class=title>{{$ctrl.selectedTime.title}}</h3><div class=time>{{$ctrl.selectedTime.min}} - {{$ctrl.selectedTime.max}}</div></div><div flex=10 layout=row layout-align=\"center center\"><md-icon style=\"font-size: 2em\" md-font-icon>arrow_drop_down</md-icon></div></section><section ng-if=\"$ctrl.selectedTime.label === \'specificTime\'\" layout-align=\"space-around center\" layout=row layout-wrap><div class=hour-icon flex=20 layout=row layout-align=\"center center\"><md-icon flex md-font-icon>access_time</md-icon></div><div flex=65><h3 class=title>Hora Especifica</h3><div class=time>{{$ctrl.format($ctrl.selectedTime.specificTime)}}</div></div><div flex=10 layout=row layout-align=\"center center\"><md-icon style=\"font-size: 2em\" md-font-icon>arrow_drop_down</md-icon></div></section><section ng-if=!$ctrl.selectedTime layout=row layout-align=\"space-between center\"><h2>Seleccione el horario</h2><div flex=10 layout=row layout-align=\"center center\"><md-icon style=\"font-size: 2em\" md-font-icon>arrow_drop_down</md-icon></div></section></md-button><md-menu-content class=cargo77-time-selector width=5><md-menu-item md-ink-ripple ng-repeat=\"time in $ctrl.times\" ng-click=$ctrl.selectTime(time) layout=row layout-align=\"center center\"><section class=item aria-label={{time.title}} ng-disabled=\"$ctrl.availableTimes.indexOf(time) < 0 && time.label !== \'specificTime\'\"><section ng-if=\"time.label !== \'specificTime\'\" layout-align=\"space-between center\" layout=row layout-wrap layout-fill><div flex=20 layout=row layout-align=\"center center\"><img class=image ng-src={{time.image}}></div><div flex=75><h3 class=title>{{time.title}}</h3><div class=time>{{time.min}} - {{time.max}}</div></div></section><section ng-if=\"time.label === \'specificTime\'\" layout-align=\"space-between center\" layout=row layout-wrap class=specific-time-container><div flex=20 layout=row layout-align=\"center center\"><div><md-icon flex md-font-icon>access_time</md-icon></div></div><div flex=75><h3 class=title>Hora especifica</h3></div><input readonly mdc-datetime-picker class=\"md-input date-time-picker\" date=false time=true type=text placeholder=Date lang=es cancel-text=Cancelar ok-text=Aceptar min-date=$ctrl.minTime ng-model=$ctrl.selectedTime.specificTime></section></section></md-menu-item></md-menu-content></md-menu></section>");
$templateCache.put("app/components/common/vehicle-search-selector/vehicle-search-selector.html","<md-autocomplete flex class=auto-complete-box md-selected-item=$ctrl.selectedVehicle md-search-text=$ctrl.vehicleSearchText md-items=\"item in vehiclesFiltered = ($ctrl.vehicles | filter: {plate: $ctrl.vehicleSearchText, ownerCompanyId: $ctrl.cargoCompanyId} | orderBy: \'plate\') || undefined\" md-item-text=item.plate md-min-length=0 md-floating-label=\"Seleccione una unidad\" md-selected-item-change=$ctrl.changeVehicle() md-search-text-change=$ctrl.searchTextChange() placeholder=\"Seleccione una unidad\" ng-disabled=$ctrl.disabled md-input-name=vehicleSelector md-no-cache=true md-dropdown-items=\"(vehiclesFiltered.length || $ctrl.vehicles.length) > 5 ? 5 : (vehiclesFiltered.length || $ctrl.vehicles.length)\" md-menu-class=vehicle-search-selector md-clear-button=true ng-required=$ctrl.required><md-item-template><section layout-align=\"space-between center\" layout=row layout-wrap layout-fill><div class=image-container flex=20 layout-fill layout=row layout-align=\"center center\"><div flex><md-icon md-font-icon>directions_bus</md-icon></div></div><div flex=75><span class=plate>{{item.plate}}</span> <span class=brand>{{item.brand}} - </span><span class=model>{{item.model}}</span></div></section></md-item-template><md-not-found>La búsqueda \"{{$ctrl.vehicleSearchText}}\" no retornó ninguna unidad.</md-not-found><div ng-messages=$ctrl.formReference.vehicleSelector.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-autocomplete>");
$templateCache.put("app/components/common/vehicle-selector/vehicle-selector.html","<md-menu><md-button ng-click=$mdOpenMenu($event) class=item><h2 class=select-vehicle-title ng-if=!$ctrl.selectedVehicle>Seleccione una unidad</h2><section ng-if=$ctrl.selectedVehicle layout-align=\"space-between center\" layout=row layout-wrap class=info-container><div flex=20 class=image-container layout=row layout-fill layout-align=\"center center\"><div flex><md-icon md-font-icon>directions_bus</md-icon></div></div><div flex=75><h3 class=plate>{{$ctrl.selectedVehicle.plate}}</h3><span class=brand>{{$ctrl.selectedVehicle.brand}} - </span><span class=model>{{$ctrl.selectedVehicle.model}}</span></div></section></md-button><md-menu-content class=cargo77-vehicle-selector width=5><md-menu-item ng-repeat=\"vehicle in $ctrl.vehicles | filter: {ownerCompanyId: $ctrl.cargoCompanyId}\" ng-click=$ctrl.selectVehicle(vehicle) layout=row layout-align=\"center center\"><md-button class=item><section layout-align=\"space-between center\" layout=row layout-wrap layout-fill><div class=image-container flex=20 layout-fill layout=row layout-align=\"center center\"><div flex><md-icon md-font-icon>directions_bus</md-icon></div></div><div flex=75><h3 class=plate>{{vehicle.plate}}</h3><span class=brand>{{vehicle.brand}} - </span><span class=model>{{vehicle.model}}</span></div></section></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/components/dashboard/components/dashboard.html","<md-content layout=row layout-wrap layout-align=\"center start\"><section class=\"page-wrapper list-container\" layout-padding flex=100 layout=row layout-wrap layout-align=\"space-around center\"><md-card flex-sm=100 flex=100 layout=row layout-align=\"center center\" class=welcome permission permission-only=\"[\'SHIPPER_OWNER\', \'SHIPPER_USER\', \'CARGO_ADMIN\']\">Bienvenido a Cargo77</md-card><!--CARRIER USERS-OWNER --><cargo77-mobile-download-card hide-xs flex-sm=100 flex=100 permission permission-except=\"[\'CARGO_ADMIN\']\"></cargo77-mobile-download-card><cargo77-dashboard-total-card permission permission-only=\"[\'CARRIER_OWNER\', \'CARRIER_USER\', \'CARGO_ADMIN\']\" title=\"\'Fletes completados\'\" total=$ctrl.completedOrdersCount.count icon=\"\'near_me\'\" flex=33 flex-xs=100 flex-sm=33></cargo77-dashboard-total-card><cargo77-dashboard-total-card permission permission-only=\"[\'CARRIER_OWNER\', \'CARRIER_USER\', \'CARGO_ADMIN\']\" title=\"\'Conductores\'\" total=$ctrl.driversCount.count icon=\"\'perm_contact_calendar\'\" flex=33 flex-xs=100 flex-sm=33></cargo77-dashboard-total-card><cargo77-dashboard-total-card permission permission-only=\"[\'CARRIER_OWNER\', \'CARRIER_USER\', \'CARGO_ADMIN\']\" title=\"\'Unidades\'\" total=$ctrl.vehiclesCount.count icon=\"\'directions_bus\'\" flex=33 flex-sm=33 flex-xs=100></cargo77-dashboard-total-card><cargo77-daily-orders ng-if=false permission permission-only=\"[\'CARRIER_OWNER\', \'CARRIER_USER\', \'CARGO_ADMIN\']\" flex=50 flex-xs=100 flex-sm=100></cargo77-daily-orders><cargo77-orders-per-user ng-if=false permission permission-only=\"[\'CARRIER_OWNER\', \'CARRIER_USER\']\" class=order-per-driver-card flex=50 flex-xs=100 flex-sm=100></cargo77-orders-per-user><!--SHIPPER USERS-OWNER--><cargo77-dashboard-total-card permission permission-only=\"[\'SHIPPER_OWNER\', \'SHIPPER_USER\']\" align=\"\'column\'\" title=\"\'Solicitudes\'\" total=$ctrl.ordersCount.count icon=\"\'archive\'\" flex=33 flex-xs=100 flex-sm=33></cargo77-dashboard-total-card><cargo77-dashboard-total-card permission permission-only=\"[\'SHIPPER_OWNER\', \'SHIPPER_USER\']\" align=\"\'column\'\" title=\"\'Ofertas\'\" total=$ctrl.totalOffers icon=\"\'directions_bus\'\" flex=33 flex-sm=33 flex-xs=100></cargo77-dashboard-total-card><cargo77-dashboard-total-card permission permission-only=\"[\'SHIPPER_OWNER\', \'SHIPPER_USER\']\" align=\"\'column\'\" title=\"\'Fletes completados\'\" total=$ctrl.completedShipperOrdersCount.count icon=\"\'near_me\'\" flex=33 flex-xs=100 flex-sm=33></cargo77-dashboard-total-card><cargo77-orders-per-company permission permission-only=\"[\'CARGO_ADMIN\']\" flex=50 flex-md=50 flex-xs=100 flex-sm=100></cargo77-orders-per-company><cargo77-dashboard-graphics permission permission-only=\"[\'CARRIER_OWNER\', \'CARRIER_USER\']\" flex-sm=100 flex=100 flex-xs=100></cargo77-dashboard-graphics></section><cargo77-fab-menu ng-hide=$ctrl.hideFabMenuIfDriver()></cargo77-fab-menu></md-content>");
$templateCache.put("app/components/login/forgotPassword/forgotPassword.html","<header flex=100><md-toolbar id=login-navbar class=md-whiteframe-3dp layout=row layout-align=\"start center\"><div layout=row layout-align=\"start center\" flex=15 flex-md=25 flex-sm=35 flex-xs=50 class=logo-container><img flex class=logo src=assets/images/cargo77-logo.svg></div></md-toolbar></header><md-content flex=100 layout-align=\"center center\" layout=row><div class=background-image></div><div class=background-overlay></div><section flex layout-fill class=page-wrapper layout=row layout-wrap layout-align=\"space-around center\"><section flex=45 flex-sm=80 flex-xs=90 class=forgot-container><md-card layout=column layout-wrap layout-align=\"space-between start\"><md-card-title flex=15><md-card-title-text><span class=md-headline>Ingresa tu nueva contraseña</span></md-card-title-text></md-card-title><section class=md-card-content flex layout=column layout-align=\"space-between center\"><form name=loginForm flex layout=row ng-submit=$ctrl.resetPassword() layout-wrap layout-align=\"space-between center\"><section flex=100 class=field-container layout=row layout-wrap><md-input-container flex=100 class=\"md-icon-float md-block\"><label>Contraseña</label><md-icon md-font-icon class=name>lock</md-icon><input required ng-pattern=/^.{6,}$/ ng-model=$ctrl.password type=password focus-if><ng-messages><div ng-message=required>Este campo es obligatorio.</div><div ng-message=pattern>La contraseña debe tener mínimo 6 caracteres.</div></ng-messages></md-input-container></section><section flex=100><md-card-actions layout=row class=actions layout-wrap layout-padding layout-align=\"space-between end\"><md-button ng-disabled=loginForm.$invalid flex flex-xs=100 class=\"no-padding md-raised md-accent\" type=submit>Restablecer contraseña</md-button></md-card-actions></section></form></section></md-card></section></section></md-content>");
$templateCache.put("app/components/login/login-card/login-card.html","<md-card layout=column layout-wrap layout-align=\"space-between start\"><md-card-title flex=15><md-card-title-text><span class=md-headline>Ingresar</span></md-card-title-text></md-card-title><md-card-content flex=80 layout=column layout-align=\"space-between center\"><form name=loginForm flex=80 layout=column layout-align=\"space-between center\"><section flex class=field-container layout-align=\"center center\" layout=row layout-wrap><md-input-container flex=100 class=\"md-icon-float md-block\"><label>Correo</label><md-icon md-font-icon class=name>account_circle</md-icon><input ng-model=loginCard.user.email type=text flex-xs=90 focus-if></md-input-container><md-input-container flex=100 class=\"md-icon-float md-block\"><label>Contraseña</label><md-icon md-font-icon class=name>lock</md-icon><input ng-model=loginCard.user.password type=password flex-xs=90></md-input-container><div class=forgot-password-container layout=row flex=100 layout-align=\"end center\"><md-button ui-sref=recoveryPasswordEmail class=\"forgot-password md-accent md-hue-1\">Olvide mi contraseña</md-button></div></section><section flex=20 layout-align=\"end end\" layout=row class=actions><md-card-actions layout=row class=actions layout-wrap layout-padding layout-align=\"space-between end\"><md-checkbox flex flex-xs=100 ng-model=loginCard.rememberMe aria-label=Recordarme>Recordarme</md-checkbox><md-button flex flex-xs=100 class=\"no-padding md-raised md-accent\" type=submit ng-click=loginCard.login()>Ingresar</md-button></md-card-actions></section></form></md-card-content></md-card><section class=register-button flex=100 layout=row layout-align=\"center center\"><a ui-sref=signUp>Registrarme</a></section>");
$templateCache.put("app/components/login/recoveryPasswordEmail/recoveryPasswordEmail.html","<header flex=100><md-toolbar id=login-navbar class=md-whiteframe-3dp layout=row layout-align=\"start center\"><div layout=row layout-align=\"start center\" flex=15 flex-md=25 flex-sm=35 flex-xs=50 class=logo-container><img flex class=logo src=assets/images/cargo77-logo.svg></div></md-toolbar></header><md-content flex=100 layout-align=\"center center\" layout=row><div class=background-image></div><div class=background-overlay></div><section flex layout-fill class=page-wrapper layout=row layout-wrap layout-align=\"space-around center\"><section flex=45 flex-sm=80 flex-xs=90 class=forgot-container><md-card class=forgot-password-card layout=column layout-wrap layout-align=\"space-between start\"><md-card-title flex=15><md-card-title-text><span class=md-headline>Recuperar contraseña</span></md-card-title-text></md-card-title><section class=\"md-card-content recover-password-section\" flex layout=column layout-align=\"space-between center\"><form name=loginForm flex layout=row layout-wrap layout-align=\"space-between center\"><section class=recover-password-mail-input flex=100 class=field-container layout=row layout-wrap><md-input-container class=recover-password-mail-input flex=100 flex-xs=85 class=\"md-icon-float md-block\"><label>Email de registro</label><md-icon md-font-icon class=name>email</md-icon><input required ng-model=$ctrl.email type=email focus-if flex-xs=90><ng-messages><div ng-message=required>Este campo es obligatorio.</div></ng-messages></md-input-container></section><section flex=100><md-card-actions layout=row class=actions layout-wrap layout-padding layout-align=\"space-between end\"><md-button flex flex-xs=85 class=\"recover-password-send-button no-padding md-raised md-accent\" type=submit ng-click=$ctrl.sendRecoveryEmail()>Enviar email</md-button></md-card-actions></section></form></section></md-card></section></section></md-content>");
$templateCache.put("app/components/reports/components/reports.html","<md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><cargo77-report-types-card permission permission-only=\"[\'CARRIER_OWNER\', \'CARRIER_USER\', \'CARGO_ADMIN\']\" title=\"\'Reporte de Fletes\'\" description=\"\'Permite obtener un reporte de fletes bajo diferentes parámetros de búsqueda\'\" icon=\"\'description\'\" flex=33 flex-xs=100 flex-sm=33 ui-sref=cargo.orders></cargo77-report-types-card><cargo77-report-types-card permission permission-only=\"[\'CARRIER_OWNER\', \'CARRIER_USER\', \'CARGO_ADMIN\']\" title=\"\'Reporte Tiempo de Tránsito\'\" description=\"\'Permite obtener un reporte del tiempo de transito promedio por conductor\'\" icon=\"\'schedule\'\" flex=33 flex-xs=100 flex-sm=33 ui-sref=cargo.timesReport></cargo77-report-types-card><cargo77-report-types-card permission permission-only=\"[\'CARRIER_OWNER\', \'CARRIER_USER\', \'CARGO_ADMIN\']\" title=\"\'Reporte Viajes por Conductor y Unidad\'\" description=\"\'Permite obtener un reporte mensual y anual de los viajes realizados por conductor y por unidad y el porcentaje de utilización de flota\'\" icon=\"\'perm_contact_calendar\'\" flex=33 flex-xs=100 flex-sm=33 ui-sref=cargo.tripsReport></cargo77-report-types-card></md-content>");
$templateCache.put("app/components/sign-up/confirm/confirm.html","<section class=cargo77-confirm-container layout-fill layout=row layout-wrap><header flex=100><md-toolbar id=login-navbar class=md-whiteframe-3dp layout=row layout-align=\"start center\"><div layout=row layout-align=\"start center\" flex=15 flex-md=20 flex-sm=30 flex-xs=60 class=logo-container><img flex class=logo src=assets/images/cargo77-logo.svg></div></md-toolbar></header><md-content flex=100 layout-align=\"center center\" layout=row><section flex layout-fill class=page-wrapper layout=row layout-wrap layout-align=\"space-around center\"><div flex=100 flex-sm=80 flex-xs=90><md-card layout=column layout-align=\"space-between start\"><md-card-content flex layout=column layout-wrap layout-align=\"space-around center\" layout-fill><section layout=row layout-align=\"center center\" flex><img style=\"height: 150px\" src=assets/images/cargo-77-logo-perfil.png></section><section layout=column layout-align=\"start center\" flex><h1 class=md-headline>Gracias por registrarte en Cargo 77</h1><section layout=row layout-wrap layout-align=\"center center\"><div flex-xs=100><md-button class=\"md-accent md-raised\" ui-sref=login>ingresar</md-button></div></section></section></md-card-content></md-card></div></section></md-content></section>");
$templateCache.put("app/components/sign-up/privacy-policy/privacy-policy.html","<header flex=100><md-toolbar id=login-navbar class=md-whiteframe-3dp layout=row layout-align=\"start center\"><div layout=row layout-align=\"start center\" flex=20 flex-md=30 flex-sm=40 flex-xs=50 class=logo-container><img flex class=logo src=assets/images/cargo77-logo.svg></div></md-toolbar></header><md-content flex=100 layout-align=\"center center\" layout-fill layout=row><div class=background-image></div><div class=background-overlay></div><div class=terms-and-conditions ng-bind-html=$ctrl.terms></div></md-content>");
$templateCache.put("app/components/sign-up/sign-up/sign-up.html","<header flex=100><md-toolbar id=login-navbar class=md-whiteframe-3dp layout=row layout-align=\"start center\"><div layout=row layout-align=\"start center\" flex=20 flex-md=30 flex-sm=40 flex-xs=50 class=logo-container><img flex class=logo src=assets/images/cargo77-logo.svg></div></md-toolbar></header><md-content flex=100 layout-align=\"center center\" layout-fill layout=row><div class=background-image></div><div class=background-overlay></div><section flex=90 layout-fill class=page-wrapper layout=row layout-wrap layout-align=\"space-around center\"><section hide-sm hide-md hide-xs class=description-container layout-fill layout=column layout-align=\"center center\" flex=50 flex-sm=80 flex-xs=90><div ng-if=signUp.isCarrier layout=column layout-align=\"center start\"><div flex><h1 class=title>Maneja con Cargo77</h1></div><div flex><ul><li><span>Recibe más pedidos de carga</span></li><li><span>Administra tu tiempo y envía tus ofertas fácilmente.</span></li><li><span>Recibe tus pagos a tiempo y de manera segura.</span></li></ul></div></div><div ng-if=!signUp.isCarrier layout=column layout-align=\"center start\"><div flex><h1 class=title>Envía tu carga con Cargo77</h1></div><div flex><ul><li><span>Solicita el transporte de tu carga facilmente</span></li><li><span>Escoge el mejor precio entre múltiples ofertas</span></li><li><span>Tu carga se transportará de manera segura, a tiempo y con la garantía de Cargo77</span></li></ul></div></div></section><md-tabs md-no-pagination md-dynamic-height md-swipe-content={{signUp.isTouchSupported()}} md-center-tabs flex=45 flex-sm=80 flex-xs=90><md-tab><md-tab-label><div flex ng-click=\"signUp.isCarrier = true; signUp.focusNameInput(0)\" layout=column layout-align=\"center center\" layout-fill><h2>Soy transportista</h2><span hide-xs>Proveo transporte de carga</span></div></md-tab-label><md-tab-body><sign-up-card user-type=\"\'carrier\'\"></sign-up-card></md-tab-body></md-tab><md-tab><md-tab-label><div flex ng-click=\"signUp.isCarrier = false; signUp.focusNameInput(1)\" layout=column layout-align=\"center center\" layout-fill><h2>Soy solicitante</h2><span hide-xs>Necesito transporte de carga</span></div></md-tab-label><md-tab-body><sign-up-card user-type=\"\'shipper\'\"></sign-up-card></md-tab-body></md-tab></md-tabs></section></md-content>");
$templateCache.put("app/components/sign-up/sign-up-card/sign-up-card.html","<md-card layout=column layout-wrap layout-align=\"space-between start\"><section flex layout=column layout-align=\"space-between center\"><form name=signUpForm layout=row layout-wrap layout-align=\"space-between center\"><section flex=100 class=field-container layout=row layout-wrap><md-input-container flex=100 class=\"md-icon-float md-block\"><label>Nombre</label><md-icon md-font-icon class=name>account_circle</md-icon><input required name=name class=nameInput ng-model=signUpCard.user.firstName type=text focus-if><div ng-messages=signUpForm.name.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><md-input-container flex=100 class=\"md-icon-float md-block\"><label>Apellido</label><md-icon md-font-icon class=name></md-icon><input required name=lastName ng-model=signUpCard.user.lastName type=text><div ng-messages=signUpForm.name.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><md-input-container flex=100 class=\"phone-container md-icon-float md-block\"><label for=phone>Teléfono</label><md-icon md-font-icon>phone</md-icon><input id=phone international-phone-number ng-model=signUpCard.user.phone type=text></md-input-container><md-input-container flex=100 class=\"md-icon-float md-block\"><label>Correo electrónico</label><md-icon md-font-icon class=name>email</md-icon><input required ng-pattern=/^.+@.+\\..+$/ name=email ng-model=signUpCard.user.email type=email><div ng-messages=signUpForm.email.$error><div ng-message=required>Este campo es obligatorio.</div><div ng-message=pattern>El email que ingresó esta incorrecto.</div></div></md-input-container><md-input-container flex=100 class=\"md-icon-float md-block\"><label>Contraseña</label><md-icon md-font-icon class=name>lock</md-icon><input name=password ng-pattern=/^.{6,}$/ required ng-model=signUpCard.user.password type=password><div ng-messages=signUpForm.password.$error><div ng-message=required>Este campo es obligatorio.</div><div ng-message=pattern>La contraseña debe tener minimo 6 caracteres.</div></div></md-input-container><!--TODO: This input compares against a harcoded value defined in the backend--><md-input-container flex=100 class=\"md-icon-float md-block\"><label>Secreto</label><md-icon md-font-icon class=name>vpn_key</md-icon><input required name=secret ng-model=signUpCard.secret type=password focus-if><div ng-messages=signUpForm.secret.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><md-switch flex=100 ng-model=signUpCard.isCompanyAccount aria-label=ruc>Crear cuenta empresarial</md-switch><section flex=100 ng-if=signUpCard.isCompanyAccount><md-input-container class=\"md-icon-float md-block\"><label>Nombre de la empresa</label><md-icon md-font-icon class=name>account_balance</md-icon><input required ng-pattern=/^.{3,35}$/ name=company ng-model=signUpCard.company.name type=text><div ng-messages=signUpForm.company.$error><div ng-message=required>Este campo es obligatorio.</div><div ng-message=pattern>El nombre de la empresa debe contener al menos 3 caracteres validos</div></div></md-input-container><md-input-container flex=100 class=\"md-icon-float md-block\"><label>RUC</label><md-icon md-font-icon class=name>assignment</md-icon><input required ng-pattern=/^([0-9]){13,}$/ name=documentNumber ng-model=signUpCard.company.documentNumber type=string><div ng-messages=signUpForm.documentNumber.$error><div ng-message=required>Este campo es obligatorio.</div><div ng-message=pattern>El RUC debe ser unicamente numerico y contener 13 digitos.</div></div></md-input-container></section><div flex=100 layout=row layout-align=\"start center\"><md-checkbox ng-model=signUpCard.areTermsAccepted aria-label=\"Terminos y condiciones\">Acepto los <span class=terms-link ng-click=signUpCard.showTerms()>Terminos y Condiciones</span></md-checkbox></div></section><md-card-actions layout=row flex class=actions layout-padding layout-align=\"end end\"><md-button flex=40 flex-xs=60 ng-disabled=\"signUpForm.$invalid || !signUpCard.areTermsAccepted\" class=\"no-padding md-raised md-accent\" type=submit ng-click=signUpCard.save()>registrarme</md-button></md-card-actions></form></section></md-card>");
$templateCache.put("app/components/calendar/components/monthCalendar/month-calendar.html","<md-content layout=row layout-wrap layout-align=\"center center\"><md-card flex layout-fill class=\"page-wrapper calendar-container\"><div class=calendar ng-model=$ctrl.events ui-calendar=$ctrl.calendar></div></md-card></md-content>");
$templateCache.put("app/components/chat/components/chatContainer/chatContainer.html","<section class=chat-messages layout=row layout-wrap layout-fill layout-align=\"center start\"><section layout=row layout-align=\"space-between center\" class=title flex=100><div ng-click=$ctrl.backAction() flex-sm=5 flex-xs=10 hide-gt-sm><md-icon class=\"info back-arrow\" md-font-icon>arrow_back</md-icon></div><div layout=row class=chat-title ng-click=$ctrl.redirectAccordingOfferStatus() layout-wrap flex-xs=90 flex=90 permission permission-only=\"[\'CARRIER_USER\', \'CARRIER_OWNER\', \'ADMIN\', \'SUPER_ADMIN\']\"><div flex=100>{{$ctrl.chat.companyName}}</div><div flex=100 class=address>#{{$ctrl.chat.orderId}} {{$ctrl.chat.title}}</div></div><div layout=row class=chat-title ui-sref=\"cargo.shipperOrderDetails({id: $ctrl.chat.orderId})\" layout-wrap flex-xs=90 flex=90 permission permission-only=\"[\'SHIPPER_USER\', \'SHIPPER_OWNER\']\"><div flex=100>{{$ctrl.chat.companyName}}</div><div flex=100 class=address>#{{$ctrl.chat.orderId}} {{$ctrl.chat.title}}</div></div></section><section class=messages-container flex=100 layout-align=\"start end\" layout-wrap layout=row><div ng-if=$ctrl.messages ng-init=$ctrl.scrollToBottom() class=messages layout=row layout-wrap layout-align=\"start center\" flex=100 ng-repeat=\"message in $ctrl.messages\"><section ng-if=!$ctrl.isMessageFromUser(message.user) layout=row layout-align=\"start center\" flex=100 class=others-message><div class=content><div class=message-owner ng-style=\"{color: \'#\'+$ctrl.getMessageOwnerColor(message.user)}\">{{::message.username}}</div><div class=message>{{::message.message}}</div><div class=time>{{::message.timestamp | date: \'h:mm a\'}}</div></div></section><section ng-if=$ctrl.isMessageFromUser(message.user) layout=row layout-align=\"end center\" flex=100 class=my-message><div class=content><div class=message>{{::message.message}}</div><div class=time>{{::message.timestamp | date: \'h:mm a\'}}</div></div></section></div></section><form flex=100 layout=row><md-input-container class=message-input-textarea layout=column layout-align=\"center center\" md-no-float flex-xs=80 flex=85><textarea id=messageTextArea md-no-resize name=message ng-model=$ctrl.message placeholder=\"Escribe tu mensaje\" max-rows=2></textarea></md-input-container><div flex=15 class=send-message-arrow-container flex-xs=20 layout-align=\"center center\" layout=row><md-button ng-click=$ctrl.sendNewMessage() class=md-fab><md-icon md-font-icon>send</md-icon></md-button></div></form></section>");
$templateCache.put("app/components/chat/components/chatLoading/chatLoading.html","<section class=loading><div layout=row layout-wrap layout-align=\"start center\" class=timeline-wrapper><div flex=100 ng-if=\"$ctrl.chatCount() === null\" class=timeline-item><div class=\"animated-background facebook\"><div class=\"background-masker order-bottom\"></div><div class=\"background-masker header-left\"></div><div class=\"background-masker header-right\"></div><div class=\"background-masker header-bottom\"></div><div class=\"background-masker subheader-left\"></div><div class=\"background-masker subheader-right\"></div><div class=\"background-masker subheader-bottom\"></div><div class=\"background-masker content-left\"></div><div class=\"background-masker content-right\"></div><div class=\"background-masker content-bottom\"></div></div></div><div flex=100 ng-if=\"$ctrl.chatCount() !== null\" ng-repeat=\"i in $ctrl.chatCount()\" class=timeline-item><div class=\"animated-background facebook\"><div class=\"background-masker order-bottom\"></div><div class=\"background-masker header-left\"></div><div class=\"background-masker header-right\"></div><div class=\"background-masker header-bottom\"></div><div class=\"background-masker subheader-left\"></div><div class=\"background-masker subheader-right\"></div><div class=\"background-masker subheader-bottom\"></div><div class=\"background-masker content-left\"></div><div class=\"background-masker content-right\"></div><div class=\"background-masker content-bottom\"></div></div></div></div></section>");
$templateCache.put("app/components/chat/components/chatTile/chatTile.html","<div layout=row layout-align=\"space-between start\" class=chat-room-tile layout-wrap><div class=order-number flex-order-md=0 layout=row layout-align=\"start start\" flex-md=70 flex-xs=20 flex=15><div flex>#{{$ctrl.chat.orderId}}</div></div><div layout=row layout-wrap flex-order-md=2 flex-md=70 flex-xs=55 flex=65 class=chat-room-info><div class=title flex=100>{{$ctrl.getCompanyTitle($ctrl.chat)}}</div><div ng-class=\"{\'bold\': $ctrl.getUnreadMessages() > 0}\" class=last-message flex=100><p>{{$ctrl.chat.title.split(\'|\')[0]}}</p></div><div ng-class=\"{\'bold\': $ctrl.getUnreadMessages() > 0}\" class=last-message flex=100><p>{{$ctrl.chat.title.split(\'|\')[1]}}</p></div></div><div layout-align=\"center start\" flex-order-md=1 layout=row flex-md=30 flex-xs=25 flex=20 class=time-elapsed layout-wrap><div ng-class=\"{\'green\': $ctrl.getUnreadMessages() > 0}\" flex=100 layout-align=\"end start\" layout=row><time am-time-ago=$ctrl.chat.timestamp></time></div><div flex=100 ng-if=\"$ctrl.getUnreadMessages() > 99\" layout-align=\"end center\" layout=row class=unread-message-count><div class=badge layout-align=\"center center\" layout=row>+99</div></div><div flex=100 ng-if=\"$ctrl.getUnreadMessages() < 99 && $ctrl.getUnreadMessages() > 0\" layout-align=\"end center\" layout=row class=unread-message-count><div class=badge layout-align=\"center center\" layout=row>{{$ctrl.getUnreadMessages()}}</div></div></div></div>");
$templateCache.put("app/components/common/add-extra-fields-selector/add-field-selector/add-field-selector.html","<form name=editField flex=\"$ctrl.canBeDeleted ? 95 : 100\" layout=row layout-align=\"start center\"><md-input-container flex=100 flex-xs=100 flex-md=100 flex-sm=100><label show-xs hide-gt-xs style=\"white-space: normal\">{{ $ctrl.getNameTruncated($ctrl.field.name, 45) }}</label><label ng-if=\"!$ctrl.shouldShowFileEditor && $ctrl.field.inputType != \'FILE\'\" hide-xs>{{ $ctrl.field.name }}</label><label ng-if=\"$ctrl.field.inputType === \'FILE\' && !$ctrl.shouldShowFileEditor\" hide-xs>{{ $ctrl.field.name }} (max. 4Mb)</label><input ng-if=\"$ctrl.field.inputType === \'TEXT\'\" ng-model=$ctrl.value name=field type=text ng-required=\"$ctrl.field.isRequired ? \'required\' : \'\' \" ng-change=$ctrl.changeField() autocomplete=off> <input ng-if=\"$ctrl.field.inputType === \'INTEGER\'\" ng-model=$ctrl.value name=field type=number ng-required=\"$ctrl.field.isRequired ? \'required\' : \'\' \" ng-pattern=/^\\d+$/ ng-change=$ctrl.changeField()> <input ng-if=\"$ctrl.field.inputType === \'NUMBER\'\" ng-model=$ctrl.value name=field type=number ng-required=\"$ctrl.field.isRequired ? \'required\' : \'\' \" ng-change=$ctrl.changeField()> <input ng-if=\"$ctrl.field.inputType === \'CONTAINER\'\" ng-model=$ctrl.value name=field type=text ng-required=\"$ctrl.field.isRequired ? \'required\' : \'\' \" ng-pattern=/^[A-Za-z]{4}\\d{7}$/ ng-change=$ctrl.changeField()><div ng-messages=editField.field.$error><div ng-message=pattern>Debe tener 4 letras seguidas de 7 números.</div></div><md-select ng-if=\"$ctrl.field.inputType === \'DROPDOWN\'\" name=field ng-model=$ctrl.value ng-required=\"$ctrl.field.isRequired ? \'required\' : \'\' \" ng-change=$ctrl.changeField()><md-select-header class=select-header><input name=search ng-model=$ctrl.search placeholder=Buscar... type=text ng-keydown=$event.stopPropagation() autocomplete=off class=\"header-searchbox md-text\"></md-select-header><md-option ng-value=opt ng-repeat=\"opt in $ctrl.field.dropdownOptions | filter: $ctrl.search\"><p show-xs hide-gt-xs style=\"white-space: normal\">{{ $ctrl.getNameTruncated(opt, 55) }}</p><p hide-xs>{{ opt }}</p></md-option><div flex=100 layout=column layout-align=\"center center\" class=search-empty ng-if=\"($ctrl.field.dropdownOptions | filter: $ctrl.search).length === 0\"><div class=report-empty-title style=\"margin-top: 2%\">No hay resultados</div><div class=report-empty-title ng-if=\"$ctrl.field.dropdownOptions.length > 0\">para \"{{$ctrl.search}}\"</div></div></md-select><div class=uploadFile layout=row><div class=file><input ng-if=\"$ctrl.field.inputType === \'FILE\' && !$ctrl.shouldShowFileEditor\" placeholder=\"{{ $ctrl.field.name }}\" ng-model=$ctrl.value name=field type=file ng-required=\"$ctrl.field.isRequired ? \'required\' : \'\' \" ngf-select=$ctrl.onFileSelect($files)></div><div class=progress><md-progress-circular md-mode=indeterminate ng-if=\"$ctrl.field.inputType === \'FILE\' && !$ctrl.shouldShowFileEditor \n          && $ctrl.value && $ctrl.saving\" md-diameter=20px style=\"margin-right: 5px\" class=md-accent></md-progress-circular></div><div class=delete-file-button ng-if=\"$ctrl.field.inputType === \'FILE\' \n          && $ctrl.value && !$ctrl.shouldShowFileEditor && !$ctrl.saving\"><md-tooltip md-direction=top>Eliminar archivo</md-tooltip><md-icon md-font-icon ng-click=$ctrl.removeFile($ctrl.value)>clear</md-icon></div></div><div layout=column ng-if=$ctrl.shouldShowFileEditor><p class=file-placeholder>{{$ctrl.field.name}} (max. 4Mb)</p><div class=file-editor-secondary-row layout=row><a class=file-link target=_blank href={{$ctrl.value}}>{{$ctrl.field.fileName}}</a><div class=file-editor-button><md-tooltip md-direction=top>Editar archivo</md-tooltip><md-icon md-font-icon ng-click=$ctrl.showFileInput()>edit</md-icon></div><div class=delete-file-button><md-tooltip md-direction=top>Eliminar archivo</md-tooltip><md-icon md-font-icon ng-click=$ctrl.removeFile()>clear</md-icon></div></div></div><div class=errors ng-messages=editField.field.$error><div ng-message=required>Este campo es requerido.</div><div ng-message=pattern ng-if=\"$ctrl.field.inputType === \'INTEGER\'\">Este campo solo puede contener números enteros.</div></div></md-input-container></form>");
$templateCache.put("app/components/common/navigation/nav-bar/navbar.html","<md-toolbar id=navBar flex=100 class=md-whiteframe-3dp layout=row layout-align=\"center center\" layout-align-xs=\"space-between center\" layout-align-sm=\"space-between left\"><div flex-xs=60 flex layout=row layout-align=\"start center\"><md-button hide-gt-sm ng-click=$ctrl.toggleMenu() class=\"md-icon-button open-menu\" aria-label=Toggle><md-icon class=material-icons>menu</md-icon></md-button><cargo77-back-button ng-if=$ctrl.shouldShowBackButton></cargo77-back-button><label class=page-title layout-padding>{{$ctrl.currentPageTitle()}}</label></div><section flex=40 flex-sm=50 class=info-section flex layout-padding layout=row layout-align=\"end center\"><md-button ng-if=false ng-click=$ctrl.resetUnreadOrdersCounter() permission permission-only=\"[\'CARRIER_OWNER\', \'CARRIER_USER\']\" ui-sref=cargo.listAcceptedOrders layout=row layout-align=\"center center\" class=\"chat-notification md-icon-button\"><md-tooltip md-direction=bottom>Nuevas ordenes</md-tooltip><md-icon flex class=material-icons>archive</md-icon><div ng-show=$ctrl.areUnreadOrdersAvailable class=badge layout=row layout-align=\"center center\" ng-if=\"$ctrl.user().unviewedOrdersCount < 10 && $ctrl.user().unviewedOrdersCount > 0\">{{$ctrl.user().unviewedOrdersCount}}</div><div ng-show=$ctrl.areUnreadOrdersAvailable class=badge layout=row layout-align=\"center center\" ng-if=\"$ctrl.user().unviewedOrdersCount >= 10\">+9</div></md-button><md-button ng-if=false ui-sref=cargo.chat ng-click=$ctrl.resetChatMessages() layout=row layout-align=\"center center\" class=\"chat-notification md-icon-button\"><md-tooltip md-direction=bottom>Nuevos mensajes</md-tooltip><md-icon flex class=material-icons>message</md-icon><div class=badge layout=row ng-if=\"$ctrl.unreadMessages() < 10 && $ctrl.unreadMessages() > 0\" layout-align=\"center center\">{{$ctrl.unreadMessages()}}</div><div class=badge layout=row ng-if=\"$ctrl.unreadMessages() >= 10\" layout-align=\"center center\">+9</div></md-button><cargo77-notifications ng-if=false permission permission-except=\"\'CARGO_ADMIN\'\"></cargo77-notifications><md-button permission permission-only=\"[\'SHIPPER_OWNER\', \'SHIPPER_USER\', \'CARRIER_OWNER\', \'CARRIER_USER\']\" ui-sref=cargo.notificationInbox layout=row layout-align=\"center center\" class=\"chat-notification md-icon-button\"><md-tooltip md-direction=bottom>Bandeja de Notificaciones</md-tooltip><md-icon flex class=material-icons>inbox</md-icon><div class=badge layout=row layout-align=\"center center\" ng-if=\"$ctrl.notifications.countUnread < 10 && $ctrl.notifications.countUnread > 0\">{{$ctrl.notifications.countUnread}}</div><div class=badge layout=row layout-align=\"center center\" ng-if=\"$ctrl.notifications.countUnread >= 10\">+9</div></md-button><div flex=60 flex-sm=50 class=name-photo-container layout=row layout-align=\"start center\" hide-xs ng-class=\"{\'name-photo-positioning\': !$ctrl.user().photoURL}\"><md-button flex-sm=100 flex=100 class=name-container><span layout=row layout-align=\"center center\" flex-sm=15 flex=10 class=avatar ng-style=\"{\'background-image\': \'url(\'+$ctrl.getEncodedURI($ctrl.user().photoURL)+\')\'}\"><md-icon ng-if=!$ctrl.user().photoURL flex=20 class=material-icons>account_circle</md-icon></span><label layout-align=\"center center\" flex=50 title=\"{{$ctrl.user().firstName}} {{$ctrl.user().lastName}}\" class=user-name ng-class=\"{\'user-name-positioning\': $ctrl.user().photoURL}\">{{$ctrl.user().firstName}} {{$ctrl.user().lastName}}</label><drop position=\"\'bottom right\'\"><section><md-button ui-sref=cargo.editCurrentUser class=navbar-user-dropdown-item><md-icon class=material-icons>account_circle</md-icon>Mi Perfil</md-button></section><section class=navbar-user-dropdown-item><md-button ng-click=$ctrl.logout() class=navbar-user-dropdown-item><md-icon class=material-icons>exit_to_app</md-icon>Salir</md-button></section></drop></md-button></div></section></md-toolbar>");
$templateCache.put("app/components/common/navigation/sidebar/sidebar.html","<md-sidenav class=\"sidebar md-sidenav-left\" md-component-id=left md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-whiteframe=4><md-toolbar class=md-whiteframe-3dp layout-align=\"center center\"><img class=logo src={{sidebar.company.logoURL}} ng-if=sidebar.company.logoURL> <img class=logo src=assets/images/cargo77-logo.svg ng-if=!sidebar.company.logoURL></md-toolbar><md-content><md-list><md-list-item permission permission-sref=item.state ng-repeat=\"item in sidebar.menuItems\" layout=row layout-align=\"start center\"><div class={{item.class}} layout=row layout-align=\"start center\" flex=100 ui-sref={{item.state}} ng-if=item.state><div class=icon-container flex=15><md-icon md-font-icon>{{item.icon}}</md-icon></div><h3>{{item.title}}</h3></div><div layout=row layout-align=\"start center\" flex=100 ng-if=!item.state><div class=icon-container flex=15><md-icon md-font-icon>{{item.icon}}</md-icon></div><h3>{{item.title}}</h3></div></md-list-item></md-list></md-content></md-sidenav>");
$templateCache.put("app/components/common/notifications/notificationsComponent/notifications.html","<md-button id=button class=md-icon-button ng-click=$ctrl.resetNotificationCount()><md-icon md-font-icon>notifications</md-icon><md-tooltip md-direction=bottom>Nuevas notificaciones</md-tooltip><div class=badge layout=row layout-align=\"center center\" ng-if=\"$ctrl.user.newNotifications < 10 && $ctrl.user.newNotifications > 0\">{{$ctrl.user.newNotifications}}</div><div class=badge layout=row layout-align=\"center center\" ng-if=\"$ctrl.user.newNotifications >= 10\">+9</div><drop position=\"\'bottom right\'\"><section class=cargo77-notifications layout=row layout-align=\"center center\" layout-wrap><section flex=100 class=action-header layout=row layout-align=\"space-between center\"><div flex=40 class=title>Notificaciones</div><div flex=60 layout=row layout-align=end class=action><md-button ng-click=$ctrl.markAllRead() class=\"md-accent md-hue-1\">marcar como leidas</md-button></div></section><md-divider></md-divider><section flex=100 ng-if=\"$ctrl.notifications.length <=0 \"><p>No tienes notificaciones.</p></section><section layout=row layout-wrap layout-align=\"center center\" class=notifications-container><section flex=100 ng-repeat=\"notification in $ctrl.notifications.sort()\"><cargo77-offer-received flex=100 ng-if=\"notification.code ===\'OFFER_RECEIVED\'\" ui-sref=\"cargo.shipperOrderDetails({id: notification.orderId})\" ng-click=$ctrl.markAsRead(notification) notification=notification></cargo77-offer-received><cargo77-payment-status flex=100 ng-click=$ctrl.markAsRead(notification) ui-sref=\"cargo.shipperOrderDetails({id: notification.orderId})\" ng-if=\"notification.code === \'PAYMENT_REJECTED\' || notification.code ===\'PAYMENT_VERIFIED\'\" notification=notification></cargo77-payment-status><cargo77-notification-order-status flex=100 ui-sref=\"cargo.shipperOrderDetails({id: notification.orderId})\" ng-click=$ctrl.markAsRead(notification) ng-if=\"notification.code === \'DELIVERED\'\" notification=notification></cargo77-notification-order-status><cargo77-offer-accepted flex=100 ng-if=\"notification.code ===\'OFFER_ACCEPTED\'\" ui-sref=\"cargo.orderDetails({id: notification.orderId})\" ng-click=$ctrl.markAsRead(notification) notification=notification></cargo77-offer-accepted><cargo77-new-score flex=100 ng-if=\"notification.code ===\'NEW_SCORE\'\" ng-click=$ctrl.markAsRead(notification) ui-sref=\"cargo.orderDetails({id: notification.orderId})\" notification=notification></cargo77-new-score><cargo77-order-assigned flex=100 ng-if=\"notification.code ===\'ORDER_ASSIGNED_TO_DRIVER\'\" ng-click=$ctrl.markAsRead(notification) ui-sref=\"cargo.orderDetails({id: notification.orderId})\" notification=notification></cargo77-order-assigned><cargo77-order-reminder flex=100 ng-if=\"notification.code ===\'ORDER_REMINDER_FOR_DRIVER\'\" ng-click=$ctrl.markAsRead(notification) ui-sref=\"cargo.orderDetails({id: notification.orderId})\" notification=notification></cargo77-order-reminder><cargo77-order-daily-reminder flex=100 ng-if=\"notification.code ===\'DAILY_REMINDER_FOR_DRIVER\'\" ng-click=$ctrl.markAsRead(notification) ui-sref=cargo.listAcceptedOrders() notification=notification></cargo77-order-daily-reminder><cargo77-stopover-registry-notification flex=100 ng-if=\"notification.code ===\'STOPOVER_REGISTERED\'\" ng-click=$ctrl.markAsRead(notification) ui-sref=\"cargo.orderDetails({id: notification.orderId, tab: 5})\" notification=notification></cargo77-stopover-registry-notification><md-divider></md-divider></section></section></section></drop></md-button>");
$templateCache.put("app/components/common/route-with-details-selector/route-locations-selector/route-locations-selector.html","<section class=route-selector-container flex=100 layout=column><cargo77-segment-location-selector ng-if=$ctrl.shouldShowSelectors() class=cargo77-segment-selector point-index=point.index ng-repeat=\"point in $ctrl.currentRoute track by point.index\" locations=$ctrl.locations on-point-change=$ctrl.changePoint on-delete-point=$ctrl.deletePoint final-locations=$ctrl.route></cargo77-segment-location-selector><p class=missing-fields-button-error ng-if=$ctrl.invalidFields>* Por favor complete las ubicaciones previas</p><section layout=row layout-align=\"start start\"><md-button class=add-location-button flex-gt-sm=45 flex=90 ng-click=$ctrl.addNewPoint()>Agregar nuevo destino</md-button></section></section>");
$templateCache.put("app/components/common/route-with-details-selector/route-segment-details/route-segment-details.html","<section class=route-details-container flex=100 layout=column><div class=title><h3>Información de la ruta</h3></div><cargo77-segment-details segment-index=$index ng-repeat=\"segment in $ctrl.currentSegments\" on-field-change=$ctrl.detailsFieldChange on-saving-files=\"$ctrl.onSavingFiles(saved, saving)\" on-extra-field-change=$ctrl.extraFieldChange on-are-valid-extra-field-change=$ctrl.areValidExtraFieldsChange carrier-company-id=$ctrl.carrierCompanyId final-segments=$ctrl.routeSegments segment=segment></cargo77-segment-details></section>");
$templateCache.put("app/components/common/services/cargo-toast/cargo-toast.html","<md-toast><i ng-if=toast.icon style=\"font-size: 1.5rem; margin-right: 15px\" ng-style=\"{color: toast.type}\" class=material-icons>{{toast.icon}}</i> <span class=md-toast-text>{{toast.message}}</span></md-toast>");
$templateCache.put("app/components/companies/components/createChildCompany/create-child-company.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-company-card class=page-wrapper on-save-action=\"$ctrl.saveAction(company, parentCompanyId)\" flex=90 company-type=$ctrl.type></cargo77-upsert-company-card></md-content>");
$templateCache.put("app/components/companies/components/createCompany/create-company.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-company-card class=page-wrapper on-save-action=$ctrl.saveAction(company) flex=90></cargo77-upsert-company-card></md-content>");
$templateCache.put("app/components/companies/components/createFieldByCompany/create-field-by-company.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-company-field-card class=page-wrapper flex=90 on-save-action=$ctrl.saveAction(field)></cargo77-upsert-company-field-card></md-content>");
$templateCache.put("app/components/companies/components/editChildCompany/edit-child-company.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-company-card class=page-wrapper company=$ctrl.company on-save-action=$ctrl.updateCompany(company) flex=90 on-delete-action=$ctrl.deleteCompany(company) parent-company=$ctrl.parentCompany></cargo77-upsert-company-card></md-content>");
$templateCache.put("app/components/companies/components/editCompany/edit-company.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-company-card class=page-wrapper company=$ctrl.company on-save-action=$ctrl.saveAction(company) on-delete-action=$ctrl.deleteAction(id) flex=90></cargo77-upsert-company-card></md-content>");
$templateCache.put("app/components/companies/components/editCurrentCompany/edit-current-company.html","<md-tabs md-no-pagination md-dynamic-height md-selected=$ctrl.activeTab md-center-tabs md-align-tabs=top class=tabs-container><md-tab id=tab1><md-tab-label>Perfil</md-tab-label><md-tab-body><md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-company-card class=page-wrapper company=$ctrl.company on-save-action=$ctrl.updateCompany(company) flex=90></cargo77-upsert-company-card></md-content></md-tab-body></md-tab><md-tab id=tab2 ng-if=\"$ctrl.isCarrierOwner() && $ctrl.isParentCompany()\"><md-tab-label>Configuración</md-tab-label><md-tab-body><md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-list-fields-by-company class=page-wrapper company=$ctrl.company flex=90></cargo77-list-fields-by-company></md-content></md-tab-body></md-tab></md-tabs>");
$templateCache.put("app/components/companies/components/editFieldByCompany/edit-field-by-company.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-company-field-card class=page-wrapper flex=90 field=$ctrl.field on-delete-action=$ctrl.deleteAction() on-save-action=$ctrl.saveAction(field)></cargo77-upsert-company-field-card></md-content>");
$templateCache.put("app/components/companies/components/listCompanies/list-companies.html","<cargo77-search-bar on-search-text-filter-change=$ctrl.updateSearchText(searchText)></cargo77-search-bar><md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><section class=\"list-container page-wrapper\" layout=row layout-wrap layout-align=\"start center\"><cargo77-list-companies-card flex-xs=100 flex-sm=33 flex-md=33 flex=20 driver=driver company=company ng-repeat=\"company in $ctrl.companies | filter: {name:$ctrl.searchText}\" ui-sref=\"cargo.editChildCompany({id: company.id})\"></cargo77-list-companies-card></section><section><cargo77-fab-menu></cargo77-fab-menu></section></md-content>");
$templateCache.put("app/components/dashboard/components/dailyOrders/dailyOrders.html","<md-card layout=row layout-fill layout-wrap layout-align=\"start center\"><div flex=100 layout-wrap layout-align=\"space-between center\" layout=row><div flex=40 flex-xs=90 flex-offset=5><md-select md-container-class=order-range-select ng-change=$ctrl.onSelectChange() ng-model=$ctrl.timeType><md-option selected value=days><em>Fletes Diarios</em></md-option><md-option value=weeks><em>Fletes Semanales</em></md-option><md-option value=months><em>Fletes Mensuales</em></md-option></md-select></div><div layout=row layout-align=\"end start\" flex-offset-xs=5 flex-xs=100 flex=50><div flex=20 flex-order-xs=2><md-button class=today ng-click=$ctrl.getTodayAcceptedOrders() flex>Hoy</md-button></div><div flex=20 flex-order-xs=0><md-button ng-click=$ctrl.getPrevAcceptedOrders() class=\"md-accent md-hue-1\"><md-icon md-font-icon>chevron_left</md-icon></md-button></div><div flex=20 flex-order-xs=0><md-button ng-click=$ctrl.getNextAcceptedOrders() class=\"md-accent md-hue-1\"><md-icon md-font-icon>chevron_right</md-icon></md-button></div></div></div><highchart flex=100 config=$ctrl.chartConfig></highchart></md-card>");
$templateCache.put("app/components/dashboard/components/dashboardGraphics/dashboardGraphics.html","<div class=container layout=row layout-wrap><!-- <md-card flex=\"100\" class=\"page-wrapper\" ng-if=\"$ctrl.showUpdateAllButton\"> --><div layout=row flex=100 layout-align=\"end center\" ng-if=$ctrl.showUpdateAllBtn><md-button type=submit class=\"md-raised md-accent\" ng-click=$ctrl.updateAllGraphics() ng-disabled=$ctrl.isUpdatingGraphics>Actualizar todos los Gráficos</md-button><md-progress-circular md-mode=indeterminate ng-show=$ctrl.isUpdatingGraphics md-diameter=30px></md-progress-circular></div><!-- </md-card> --><div class=row ng-if=$ctrl.showGraphics flex=100 layout-align=\"center start\"><cargo77-add-dashboard-graphic flex=100 graphic=graphic ng-repeat=\"graphic in $ctrl.dashboardGraphics track by $index\"></cargo77-add-dashboard-graphic></div></div>");
$templateCache.put("app/components/dashboard/components/dashboardTotalCard/dashboardTotalCard.html","<md-card layout=row layout-wrap layout-align=\"space-around center\" ng-class=\"{\'column\': $ctrl.align === \'column\'}\"><section flex=30 flex-sm=100 flex-xs=35 layout=column layout-align=\"center center\"><div class=icon-container layout=column layout-align=\"center center\"><md-icon md-font-icon>{{$ctrl.icon}}</md-icon></div></section><section flex=65 flex-sm=100 flex-xs=60 layout=column layout-align-sm=\"center center\" ng-class=\"{\'flex-100 layout-align-center-center\': $ctrl.align === \'column\'}\" layout-align=\"space-around start\" class=info-section><div class=total>{{$ctrl.total}}</div><div class=title>{{$ctrl.title}}</div></section></md-card>");
$templateCache.put("app/components/dashboard/components/mobileDownloadCard/mobileDownloadCard.html","<md-card layout=row layout-align=\"space-around center\"><section flex=15 layout=column layout-align=\"center center\"><div class=icon-container layout=column layout-align=\"center center\"><img class=cargo-image src=assets/images/cargo-app.svg></div></section><section flex=60 layout=row layout-wrap layout-align=\"start center\" class=info-section><h1 flex=100>Descárgate la aplicación móvil</h1><div class=info flex=100 layout-align=\"start center\" layout=row><md-icon flex=5 md-font-icon>arrow_forward</md-icon><div flex=95><label>Recibe notificaciones directamente en tu celular</label></div></div><div class=info flex=100 layout-align=\"start center\" layout=row><md-icon flex=5 md-font-icon>arrow_forward</md-icon><div flex=95><label>Navega utilizando el mapa de direcciones</label></div></div></section><section flex=25 layout-align=\"center center\" layout=row><a flex layout-align=\"center center\" layout=row href=\"https://play.google.com/store/apps/details?id=com.cargo77.driver\"><img alt=\"Get it on Google Play\" src=https://play.google.com/intl/es/badges/images/generic/es_badge_web_generic.png></a></section></md-card>");
$templateCache.put("app/components/dashboard/components/ordersPerCompany/ordersPerCompany.html","<md-card layout=row layout-fill layout-wrap layout-align=\"start center\"><div flex=100><h1>Nº de fletes por empresa</h1></div><div layout=row layout-fill layout-wrap layout-align=\"center start\" flex=100><highchart flex-md=100 flex=80 config=$ctrl.chartConfig></highchart></div></md-card>");
$templateCache.put("app/components/dashboard/components/ordersPerDriver/ordersPerDriver.html","<md-card layout=row layout-fill layout-wrap layout-align=\"start center\"><div flex=100><h1>Nº de fletes por conductor</h1></div><div layout=row layout-fill layout-wrap layout-align=\"center start\" flex=100><highchart flex-xs=100 flex=80 config=$ctrl.chartConfig></highchart></div></md-card>");
$templateCache.put("app/components/locations/components/create/create-location.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-location-card class=page-wrapper on-save-action=$ctrl.saveLocation(location) flex=90></cargo77-upsert-location-card></md-content>");
$templateCache.put("app/components/locations/components/editLocation/edit-location.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-location-card ng-if=$ctrl.location.address flex=90 location=$ctrl.location permission permission-only=\"[\'CARRIER_USER\', \'SHIPPER_USER\']\" on-save-action=$ctrl.saveAction(location)></cargo77-upsert-location-card><cargo77-upsert-location-card ng-if=$ctrl.location.address flex=90 location=$ctrl.location permission permission-only=\"[\'CARGO_ADMIN\', \'CARRIER_OWNER\', \'SHIPPER_OWNER\']\" on-delete-action=$ctrl.deleteAction(id) on-save-action=$ctrl.saveAction(location)></cargo77-upsert-location-card></md-content>");
$templateCache.put("app/components/locations/components/locationsList/locations-list.html","<md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><section class=\"list-container page-wrapper\" layout=row layout-wrap layout-align=\"start center\"><cargo77-locations-list-card flex-xs=100 flex-sm=50 flex-md=45 flex=30 flex-xl=25 location=location ng-repeat=\"location in $ctrl.locations | orderBy: \'name\'\" ui-sref=\"cargo.editLocation({id: location.id})\"></cargo77-locations-list-card></section><section><cargo77-fab-menu></cargo77-fab-menu></section></md-content>");
$templateCache.put("app/components/notification-inbox/components/notificationInboxList/notification-inbox-list.html","<cargo77-search-bar on-search-text-filter-change=$ctrl.updateSearchText(searchText)></cargo77-search-bar><md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><section ng-if=$ctrl.notifications class=\"page-wrapper list-container\" flex=100 layout=row layout-wrap layout-align=\"st center\"><section layout-fill layout=column layout-align=\"start center\" flex=100 ng-repeat=\"notification in $ctrl.notifications.sort() | filter: $ctrl.searchNotification | limitTo: $ctrl.skip\"><cargo77-extrafield-changed-notification flex ng-if=\"notification.code ===\'EXTRAFIELD_CHANGED\'\" notification=notification ui-sref=\"cargo.orderDetails({id: notification.orderId, tab: 2})\" ng-click=$ctrl.markAsRead(notification)></cargo77-extrafield-changed-notification></section></section><div flex=100 layout=row layout-wrap layout-align=\"center center\"><md-progress-circular md-mode=indeterminate ng-if=!$ctrl.notifications></md-progress-circular></div><div flex=100 layout=column layout-align=\"center center\" class=search-empty ng-if=\"($ctrl.notifications.sort() | filter: $ctrl.searchNotification).length === 0\"><div class=report-empty-title style=\"margin-top: 15%\">No hay resultados</div><div class=report-empty-title ng-if=\"$ctrl.notifications.length > 0\">para \"{{$ctrl.searchText}}\"</div></div><div layout-align=\"center center\" ng-show=\"$ctrl.loadMore && !$ctrl.isFiltering\" ng-if=\"$ctrl.skip < $ctrl.notifications.length\"><md-button class=\"md-accent md-hue-1\" ng-click=$ctrl.loadMoreNotifications($ctrl.notifications)>Cargar más</md-button></div><div layout-align=\"center center\" ng-show=\"$ctrl.loadMoreResults && !$ctrl.loadMore\" ng-if=\"$ctrl.isFiltering && $ctrl.loadMoreResults \n       && ($ctrl.notifications.sort() | filter: $ctrl.searchNotification).length != 0\n       && ($ctrl.notifications.sort() | filter: $ctrl.searchNotification).length > 20\"><md-button class=\"md-accent md-hue-1\" ng-click=\"$ctrl.loadMoreNotifications($ctrl.notifications, ($ctrl.notifications.sort() | filter: $ctrl.searchNotification).length)\">Mostrar más resultados</md-button></div></md-content>");
$templateCache.put("app/components/orders/components/adminListOrders/admin-order-list.html","<cargo77-search-bar status-filter-options=$ctrl.status on-status-filter-change=$ctrl.updateStatusFilter(status) on-date-filter-change=$ctrl.updateDateFilter(date) on-search-text-filter-change=$ctrl.updateSearchText(searchText)></cargo77-search-bar><md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><div flex=100 layout=column layout-align=\"center center\" class=report-empty ng-if=\"$ctrl.orders.items.length === 0\" ng-show=!$ctrl.isLoadingOrders><div class=report-empty-title style=\"margin-top: 15%\">No hay resultados.</div></div><section infinite-scroll=$ctrl.orders.nextPage() ng-if=!$ctrl.isLoadingOrders class=\"page-wrapper list-container\" flex=100 layout=row layout-wrap layout-align=\"center center\"><section class=month-container flex=100 layout=row layout-wrap layout-align=\"center center\" ng-repeat=\"month in $ctrl.orders.items\"><div flex=100 layout-xs=row layout-align-xs=\"center center\"><h2 class=month-title>{{::month.label}}</h2></div><section ng-repeat=\"(dayKey, dayOrders) in month.orders\" class=month flex=100 layout=row layout-wrap layout-align=\"space-between start\"><section flex-xs=15 flex-md=10 flex-sm=10 flex=5><div layout=column layout-align=\"start center\"><div flex><h1>{{::dayKey.split(\' \')[0]}}</h1></div><div flex><h4>{{::dayKey.split(\' \')[1]}}</h4></div></div></section><section flex=95 flex-md=90 flex-sm=90 flex-xs=85 layout=column layout-align=\"start center\"><md-card ng-repeat=\"order in dayOrders\" ui-sref=\"cargo.orderDetails({id: order.id})\" flex layout=row layout-wrap><div flex=100 layout=row layout-wrap><div flex=90 flex-md=80 flex-sm=80 flex-xs=100 layout=row layout-align=\"start center\" class=order-id-container layout-wrap><div class=size-container layout=column><img class=size-container ng-if=order.mainCarrierCompany.photoURL ng-src={{::$ctrl.getEncodedURI(order.mainCarrierCompany.photoURL)}}><md-icon ng-if=!order.mainCarrierCompany.photoURL>account_balance</md-icon></div><div flex=90 flex-xs=70 flex=100 layout=column layout-wrap layout-align=\"space-between start\"><div flex=100 layout=row layout-wrap layout-align=\"space-between start\"><div class=generate-id>{{order.id}}</div><div layout=row layout-wrap><span class=\"customer-name bold\" ng-if=order.mainCarrierCompanyId>| {{order.mainCarrierCompany.name}}</span> <span class=customer-name>| {{order.shipperCompany.name}}</span></div></div><div class=order-hour-container><span><strong>Hora</strong> <span>: {{order.scheduledDate | date:\'HH:mm\'}}</span></span></div></div></div><div flex-xs=100 flex=10 flex-md=20 flex-sm=20 layout-wrap layout=column layout-xs=row layout-align-xs=\"end center\" layout-align=\"space-around center\" class=cta-section><div flex-xs=40 class=state ng-class=[$ctrl.getStatusForOrder(order.orderStatus).class]><div>{{::$ctrl.getStatusForOrder(order.orderStatus).title}}</div></div><div ng-if=false flex=25 flex-sm=30 flex-xs=35 flex-md=25 class=rating-empty><span>Sin calificación</span></div><span ng-if=false flex=25 flex-sm=30 flex-xs=35 flex-md=25 class=rating-stars><ng-rate-it layout-fill min=0 max=5 read-only=true ng-model=order.score.value></ng-rate-it></span></div><div layout=row flex=100><div flex=66 flex-xs=100 flex-sm=50 flex-md=50 layout=row layout-align=\"center start\" class=orders-accepted-margin><div flex=100 layout=row layout-align=\"start center\"><div flex=100 layout=column class=order-details><div class=order-iterator ng-repeat=\"segmentItem in order.route.segments\"><div layout-xs=column layout-gt-md=row flex=100 layout-align=\"space-between start\" layout-align-xs=\" none\"><div flex=100 layout=column class=segment-details layout-align=\" none\"><div class=\"segment direction-title\">{{segmentItem.description}}</div><div class=distance-weight-details layout=row><div>{{segmentItem.distance.text}}, {{segmentItem.cargoDetails.weight.value}} kilogramo<span ng-if=\"segmentItem.cargoDetails.weight.value !== 1\">s</span></div></div></div><div flex=100 layout=row layout-gt-xs=row layout-align=\"space-between end\" layout-align-xs=\" none\"><div flex=70 layout=row class=person-details><section ng-if=segmentItem.currentAssignedDriverInstance flex=100 layout=row layout-align=\"start center\"><div layout-align=\"center center\"><md-icon md-font-icon>account_box</md-icon></div><div layout=column><div class=person-name><span>{{::segmentItem.currentAssignedDriverInstance.firstName}} {{::segmentItem.currentAssignedDriverInstance.lastName}}</span></div><div class=person-phone><span>{{::segmentItem.currentAssignedDriverInstance.phone}}</span></div></div></section><section ng-if=!segmentItem.currentAssignedDriverInstance flex=100 layout=row layout-align=\"start center\"><div layout-align=\"center center\"><md-icon md-font-icon>account_box</md-icon></div><div><div class=person-name><span>Conductor no asignado</span></div><div class=person-phone><span></span></div></div></section></div><div flex=30 layout=row class=vehicle-details><section ng-if=segmentItem.currentAssignedVehicleInstance flex=100 layout=row layout-align=\"start center\"><div layout-align=\"center center\"><md-icon md-font-icon>directions_bus</md-icon></div><div layout=column><div class=\"vehicle-brand vehicle-plate\"><span>{{::segmentItem.currentAssignedVehicleInstance.plate}}</span></div><div class=vehicle-brand><span>{{::segmentItem.currentAssignedTrailerInstance.identification}}</span></div></div></section><section ng-if=!segmentItem.currentAssignedVehicleInstance flex=100 layout=row layout-align=\"start center\"><div layout-align=\"center center\"><md-icon md-font-icon>directions_bus</md-icon></div><div class=vehicle-brand><span>vehículo no asignado</span></div></section></div></div></div></div></div></div></div><div hide-xs><md-divider class=vertical-divider></md-divider></div><div flex=33 flex-xs=100 flex-sm=50 flex-md=50 layout=row hide-xs layout-wrap layout-align=\"start start\"><div class=location-iterator ng-repeat=\"stopoverEntry in order.stopoverHistory\" layout=row flex=100 layout-align=\"space-between start\"><div flex=70 layout=row layout-align=\"start start\"><div layout-align=\"center center\" layout=column><md-icon md-font-icon ng-if=stopoverEntry.time></md-icon><md-icon md-font-icon style=\"padding-top: 6px\">adjust</md-icon></div><div layout=column style=height:100%><div class=times-stopovers><span ng-if=\"stopoverEntry.type === \'ARRIVAL\' && stopoverEntry.time\">Tiempo de viaje</span> <span ng-if=\"stopoverEntry.type === \'DEPARTURE\' && stopoverEntry.time\">Tiempo de espera</span></div><span style=\"padding-top: 3px\">{{::$ctrl.getStopoverType(stopoverEntry.type).title}}: {{stopoverEntry.stopoverLocation.name}}</span></div></div><div flex=30 layout=column layout-align=\"end none\" style=\"text-align: end; margin-right: 10px\"><span class=times-stopovers ng-if=stopoverEntry.time>{{stopoverEntry.time}}</span> <span style=\"padding-top: 6px\">{{$ctrl.getFormattedStringTime(order.scheduledDate, stopoverEntry.datetime)}}</span></div></div></div></div></div><div layout=row flex=100 class=code-details layout-align=\"end center\"><div class=code-label ng-if=order.duplicatesDetails>{{order.duplicatesDetails}}</div></div></md-card></section></section></section><div layout-align=\"center center\" ng-show=!$ctrl.orders.busy ng-if=!$ctrl.orders.hasListEnded><md-button class=\"md-accent md-hue-1\" ng-click=$ctrl.orders.nextPage()>Cargar más</md-button></div></section><div ng-show=\"$ctrl.orders.busy || $ctrl.isLoadingOrders\" layout-align=\"center center\" layout=column flex=100><md-progress-circular md-mode=indeterminate class=\"md-accent md-hue-1\"></md-progress-circular><span>Cargando...</span></div></md-content>");
$templateCache.put("app/components/orders/components/carrierAcceptedOrderAssignationTab/carrier-accepted-order-assignation-tab.html","<md-content layout=row layout-wrap layout-align=\"center start\"><section class=\"page-wrapper list-container\" layout-padding flex=100 layout=row layout-wrap layout-align=\"space-around start\"><md-card layout=row flex=100 layout-align=\"center start\"><form name=AsignationInfo flex=100 layout=row layout-align=\"space-around start\" layout-wrap><section flex=100 class=\"assignation-title md-icon-float md-block\"><h2><strong>Asignación</strong></h2></section><md-input-container flex=45 flex-sm=90 flex-xs=90 class=\"md-icon-float md-block\"><md-radio-group ng-model=$ctrl.assignmentTypeSelected ng-required=true><md-radio-button ng-repeat=\"type in $ctrl.assignmentTypes\" ng-value=type.value aria-label={{type.label}} ng-disabled=type.disabled>{{ type.label }}</md-radio-button></md-radio-group></md-input-container><div flex=45 flex-sm=90 flex-xs=90 layout=row class=\"md-icon-float md-block\"><div flex=100 layout=row layout-align=\"space-around start\" layout-wrap><div flex=100><cargo77-company-selector ng-model=$ctrl.company children-type=CARRIER form-reference=AsignationInfo disabled required></cargo77-company-selector></div></div></div></form></md-card><cargo77-assignation-detail-card flex=33 flex-sm=33 flex-xs=100 company=$ctrl.company title=\"\'Conductor(es)\'\" type=\"\'driver\'\" icon=\"\'person\'\" info=$ctrl.driversInfo segments-without-info=$ctrl.segmentsWithoutInfo.drivers disable-assignment=$ctrl.isCarrierViewer()></cargo77-assignation-detail-card><cargo77-assignation-detail-card flex=33 flex-sm=33 flex-xs=100 company=$ctrl.company title=\"\'Vehículo(s)\'\" type=\"\'vehicle\'\" icon=\"\'directions_bus\'\" info=$ctrl.vehiclesInfo segments-without-info=$ctrl.segmentsWithoutInfo.vehicles disable-assignment=$ctrl.isCarrierViewer()></cargo77-assignation-detail-card><cargo77-assignation-detail-card flex=33 flex-sm=33 flex-xs=100 company=$ctrl.company title=\"\'Arrastre(s)\'\" type=\"\'trailer\'\" icon=\"\'rv_hookup\'\" info=$ctrl.trailersInfo segments-without-info=$ctrl.segmentsWithoutInfo.trailers disable-assignment=$ctrl.isCarrierViewer()></cargo77-assignation-detail-card></section></md-content>");
$templateCache.put("app/components/orders/components/carrierAcceptedOrderDetails/carrier-accepted-order-details.html","<md-tabs class=tabs-container md-dynamic-height md-selected=carrierOrderDetails.activeTab md-align-tabs=top><md-tab id=tab1><md-tab-label>Visión General</md-tab-label><md-tab-body><cargo77-carrier-accepted-order-overview-tab order=carrierOrderDetails.order></cargo77-carrier-accepted-order-overview-tab></md-tab-body></md-tab><md-tab id=tab2><md-tab-label>Asignación</md-tab-label><md-tab-body><cargo77-carrier-accepted-order-assignation-tab order=carrierOrderDetails.order company-selected=carrierOrderDetails.order.carrierCompanyId segments=carrierOrderDetails.order.route.segments></cargo77-carrier-accepted-order-assignation-tab></md-tab-body></md-tab><md-tab id=tab3><md-tab-label>Información</md-tab-label><md-tab-body><cargo77-carrier-order-information-tab order=carrierOrderDetails.order></cargo77-carrier-order-information-tab></md-tab-body></md-tab><md-tab ng-if=false id=tab4><md-tab-label>Facturación</md-tab-label><md-tab-body>Detalle del tab Facturación</md-tab-body></md-tab><md-tab ng-if=false id=tab5><md-tab-label>Indicadores</md-tab-label><md-tab-body>Detalle del tab Indicadores</md-tab-body></md-tab><md-tab id=tab6><md-tab-label>Seguimiento</md-tab-label><md-tab-body><cargo77-carrier-accepted-order-tracking-tab order=carrierOrderDetails.order></cargo77-carrier-accepted-order-tracking-tab></md-tab-body></md-tab><md-tab id=tab7><md-tab-label>Ingresos y Salidas</md-tab-label><md-tab-body><cargo77-stopovers-history-tab order=carrierOrderDetails.order update-order=carrierOrderDetails.updateOrder()></cargo77-stopovers-history-tab></md-tab-body></md-tab></md-tabs>");
$templateCache.put("app/components/orders/components/carrierAcceptedOrderInformationTab/carrier-accepted-order-information-tab.html","<md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><section class=\"page-wrapper list-container\" layout-padding ng-if=$ctrl.order flex=100 layout=row layout-wrap layout-align=\"space-around center\"><md-card class=information-tab-container layout-margin=\"\" layout=column flex=100><!--TODO: The following markup must be removed along with cargo77-update=timeline=events-card--><section ng-if=false class=order-transit-section layout-margin><p layout-margin class=section-headers>Itinerario</p><div class=order-transit-container><cargo77-update-timeline-events-card order=$ctrl.order></cargo77-update-timeline-events-card></div></section><fieldset ng-disabled=\"$ctrl.isCarrierViewer() || $ctrl.isShipperViewer()\"><section layout-margin><h3 class=card-main-title>Información de la orden</h3></section><section class=order-route-details-section><p layout-margin class=section-headers>Detalles Generales</p><md-input-container layout=row flex=100><input ng-model=$ctrl.order.details></md-input-container></section><section class=order-route-details-section><p layout-margin class=section-headers>Información Adicional</p><div flex=100 class=order-extra-fields-container layout=row><cargo77-add-extra-fields-selector ng-if=$ctrl.carrierCompanyId flex=100 carrier-company-id=$ctrl.carrierCompanyId on-change-fields=$ctrl.onOrderExtraFieldChange(extraFields) order=$ctrl.orderCopy on-saving-files=\"$ctrl.onSavingOrderFiles(saved, saving)\" on-are-valid-extra-field-change=$ctrl.areValidExtraFieldsChange(areValidExtraFields) section=\"\'ORDER\'\"></cargo77-add-extra-fields-selector></div></section><section ng-if=\"$ctrl.orderCopy && $ctrl.orderCopy.route\" class=order-segment-details-section layout-margin layout=column><cargo77-route-segment-details route-locations=$ctrl.orderCopy.route.locations carrier-company-id=$ctrl.carrierCompanyId on-segment-details-change=$ctrl.segmentDetailChange(segmentExtraFieldsChange) on-saving-segment-files=\"$ctrl.onSavingSegmentFiles(saved, saving)\" on-route-details-change=$ctrl.changeSegmentMainDetail(segments) route-segments=$ctrl.orderCopy.route.segments></cargo77-route-segment-details></section><section layout=row layout-align=end><div ng-show=\"!$ctrl.allOrderFilesSaved || !$ctrl.allSegmentFilesSaved\" layout-align=\"center center\" layout=row flex=100><md-progress-circular md-mode=indeterminate class=\"md-accent md-hue-1\" style=\"margin-right: 10dp\"></md-progress-circular><span>Cargando archivo(s), espere...</span></div><div ng-show=$ctrl.isSaving layout-align=\"center center\" layout=row flex=100><md-progress-circular md-mode=indeterminate class=\"md-accent md-hue-1\"></md-progress-circular><span>Guardando cambios...</span></div><p class=validation-error ng-if=\"$ctrl.validationError.length > 0\">{{$ctrl.validationError}}</p><md-button ng-if=!$ctrl.isCarrierViewer() ng-disabled=\"ctrl.shouldDisableButton || !$ctrl.allOrderFilesSaved || !$ctrl.allSegmentFilesSaved\" ng-click=$ctrl.saveOrderChanges() class=\"md-accent md-raised save-info-button\">GUARDAR</md-button></section></fieldset></md-card></section></md-content>");
$templateCache.put("app/components/orders/components/carrierAcceptedOrderList/carrier-accepted-order-list.html","<cargo77-search-bar status-filter-options=$ctrl.status on-status-filter-change=$ctrl.updateStatusFilter(status) on-date-filter-change=$ctrl.updateDateFilter(date) on-search-text-filter-change=$ctrl.updateSearchText(searchText) on-driver-carrier-show-own-orders-filter-change=$ctrl.updateDriverCarrierOrderFilter(showOwnOrdersValue) initial-search-text={{$ctrl.initialSearchText}}></cargo77-search-bar><md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><div flex=100 layout=column layout-align=\"center center\" class=report-empty ng-if=\"$ctrl.orders.items.length === 0\" ng-show=!$ctrl.isLoadingOrders><div class=report-empty-title style=\"margin-top: 15%\">No hay resultados.</div></div><section ng-if=!$ctrl.isLoadingOrders class=\"page-wrapper list-container\" flex=100 layout=row layout-wrap layout-align=\"center center\"><section class=month-container flex=100 layout=row layout-wrap layout-align=\"center center\" ng-repeat=\"month in $ctrl.orders.items\"><div flex=100 layout-xs=row layout-align-xs=\"center center\"><h2 class=month-title>{{::month.label}}</h2></div><section ng-repeat=\"(dayKey, dayOrders) in month.orders\" class=month flex=100 layout=row layout-wrap layout-align=\"space-between start\"><section flex-xs=15 flex-md=10 flex-sm=10 flex=5><div layout=column layout-align=\"start center\"><div flex><h1>{{::dayKey.split(\' \')[0]}}</h1></div><div flex><h4>{{::dayKey.split(\' \')[1]}}</h4></div></div></section><section flex=95 flex-md=90 flex-sm=90 flex-xs=85 layout=column layout-align=\"start center\"><md-card ng-repeat=\"order in dayOrders\" ui-sref=\"cargo.orderDetails({id: order.id})\" flex layout=row layout-wrap><div flex=100 layout=row layout-wrap><div flex=90 flex-md=80 flex-sm=80 flex-xs=100 layout=row layout-align=\"start center\" class=order-id-container layout-wrap><div class=size-container layout=column><img class=size-container ng-if=order.shipperCompany.photoURL ng-src={{::$ctrl.getEncodedURI(order.shipperCompany.photoURL)}}><md-icon ng-if=!order.shipperCompany.photoURL>account_balance</md-icon></div><div flex=90 flex-xs=70 flex=100 layout=column layout-wrap layout-align=\"start none\"><div flex=100 layout=row layout-align=\"none start\"><div class=generate-id>{{order.orderNumber}}</div><div layout=row layout-wrap><span class=customer-name>| {{order.shipperCompany.name}}</span> <span ng-if=\"order.secondaryCarrierCompanyId && order.secondaryCarrierCompanyId !== order.mainCarrierCompanyId\" class=customer-name>| {{order.secondaryCarrierCompany.name}}</span></div></div><div class=order-extra-fields-container layout-wrap layout=row><div><span><strong>Hora</strong> <span>: {{order.scheduledDate | date:\'HH:mm\'}}</span></span></div><div ng-repeat=\"extraField in order.extraFields\" ng-if=\"extraField.definition.isVisibleInList === true && extraField.definition.isActive === true\"><span><strong>{{extraField.definition.name}}</strong> <span ng-if=\"extraField.definition.inputType === \'FILE\'\"><a target=_blank ng-href={{extraField.value}} onclick=event.stopPropagation()><md-icon class=file-icon md-font-icon>attach_file</md-icon></a></span><span ng-if=\"extraField.inputType === \'TEXT\' || extraField.inputType === \'DROPDOWN\'\">: {{extraField.value}}</span> <span ng-if=\"extraField.definition.inputType === \'FILE\' && !extraField.name\">{{extraField.definition.name}}</span></span></div></div></div></div><div flex-xs=100 flex=10 flex-md=20 flex-sm=20 layout=column layout-xs=row layout-align-xs=\"end center\" layout-align=\"space-around center\" class=cta-section><div flex-xs=40 class=state ng-class=[$ctrl.getStatusForOrder(order.orderStatus).class]><div>{{::$ctrl.getStatusForOrder(order.orderStatus).title}}</div></div><div ng-if=false flex=25 flex-sm=30 flex-xs=35 flex-md=25 class=rating-empty><span>Sin calificación</span></div><span ng-if=false flex=25 flex-sm=30 flex-xs=35 flex-md=25 class=rating-stars><ng-rate-it layout-fill min=0 max=5 read-only=true ng-model=order.score.value></ng-rate-it></span></div><div layout=row flex=100><div flex=66 flex-xs=100 flex-sm=50 flex-md=50 layout=row layout-align=\"center start\" class=orders-accepted-margin><div flex=100 layout=row layout-align=\"start center\"><div flex=100 layout=column class=order-details><div class=order-iterator ng-repeat=\"segmentItem in order.route.segments\"><div layout-xs=column layout-gt-md=row flex=100 layout-align=\"space-between start\" layout-align-xs=\" none\"><div flex=100 layout=column class=segment-details layout-align=\" none\"><div class=\"segment direction-title\">{{segmentItem.description}}</div><div class=distance-weight-details layout=row><div>{{segmentItem.distance.text}}, {{segmentItem.cargoDetails.weight.value}} kilogramo<span ng-if=\"segmentItem.cargoDetails.weight.value !== 1\">s</span><div class=segment-extra-fields-container layout-wrap layout=row><div ng-repeat=\"extraField in segmentItem.extraFields\"><span ng-if=\"extraField.definition.isVisibleInList === true && extraField.definition.isActive === true\"><strong>{{extraField.definition.name}}</strong> <span ng-if=\"extraField.definition.inputType === \'FILE\'\"><a target=_blank ng-href={{extraField.value}} onclick=event.stopPropagation()><md-icon class=file-icon md-font-icon>attach_file</md-icon></a></span><span ng-if=\"extraField.definition.inputType !== \'FILE\' \">: {{extraField.value}}</span></span></div></div></div></div></div><div flex=100 layout=row layout-gt-xs=row layout-align=\"space-between end\" layout-align-xs=\" none\"><div flex=70 layout=row class=person-details><section ng-if=segmentItem.currentAssignedDriverInstance flex=100 layout=row layout-align=\"start center\"><div layout-align=\"center center\"><md-icon md-font-icon>account_box</md-icon></div><div layout=column><div class=person-name><span>{{::segmentItem.currentAssignedDriverInstance.firstName}} {{::segmentItem.currentAssignedDriverInstance.lastName}}</span></div><div class=person-phone><span>{{::segmentItem.currentAssignedDriverInstance.phone}}</span></div></div></section><section ng-if=!segmentItem.currentAssignedDriverInstance flex=100 layout=row layout-align=\"start center\"><div layout-align=\"center center\"><md-icon md-font-icon>account_box</md-icon></div><div><div class=person-name><span>Conductor no asignado</span></div><div class=person-phone><span></span></div></div></section></div><div flex=30 layout=row class=vehicle-details><section ng-if=segmentItem.currentAssignedVehicleInstance flex=100 layout=row layout-align=\"start center\"><div layout-align=\"center center\"><md-icon md-font-icon>directions_bus</md-icon></div><div layout=column><div class=\"vehicle-brand vehicle-plate\"><span>{{::segmentItem.currentAssignedVehicleInstance.plate}}</span></div><div class=vehicle-brand><span>{{::segmentItem.currentAssignedTrailerInstance.identification}}</span></div></div></section><section ng-if=!segmentItem.currentAssignedVehicleInstance flex=100 layout=row layout-align=\"start center\"><div layout-align=\"center center\"><md-icon md-font-icon>directions_bus</md-icon></div><div class=vehicle-brand><span>vehículo no asignado</span></div></section></div></div></div></div></div></div></div><div hide-xs><md-divider class=vertical-divider></md-divider></div><div flex=33 flex-xs=100 flex-sm=50 flex-md=50 layout=row hide-xs layout-wrap layout-align=\"start start\"><div class=location-iterator ng-repeat=\"stopoverEntry in order.stopoverHistory\" layout=row flex=100 layout-align=\"space-between start\"><div flex=70 layout=row layout-align=\"start start\"><div layout-align=\"center center\" layout=column><md-icon md-font-icon ng-if=stopoverEntry.time></md-icon><md-icon md-font-icon style=\"padding-top: 6px\">adjust</md-icon></div><div layout=column><div class=times-stopovers><span ng-if=\"stopoverEntry.type === \'ARRIVAL\' && stopoverEntry.time\">Tiempo de viaje</span> <span ng-if=\"stopoverEntry.type === \'DEPARTURE\' && stopoverEntry.time\">Tiempo de espera</span></div><span style=\"padding-top: 3px\">{{::$ctrl.getStopoverType(stopoverEntry.type).title}}: {{stopoverEntry.stopoverLocation.name}}</span></div></div><div flex=30 layout=column layout-align=\"end none\" style=\"text-align: end; margin-right: 10px\"><span class=times-stopovers ng-if=stopoverEntry.time>{{stopoverEntry.time}}</span> <span style=\"padding-top: 3px\">{{$ctrl.getFormattedStringTime(order.scheduledDate, stopoverEntry.datetime)}}</span></div></div></div></div></div><div layout=row flex=100 class=code-details layout-align=\"end center\"><div class=code-label ng-if=order.duplicatesDetails>{{order.duplicatesDetails}}</div></div></md-card></section></section></section><div layout-align=\"center center\" ng-show=!$ctrl.orders.busy ng-if=!$ctrl.orders.isListEnded><md-button class=\"md-accent md-hue-1\" ng-click=$ctrl.orders.nextPage()>Cargar más</md-button></div></section><div ng-show=\"$ctrl.orders.busy || $ctrl.isLoadingOrders\" layout-align=\"center center\" layout=column flex=100><md-progress-circular md-mode=indeterminate class=\"md-accent md-hue-1\"></md-progress-circular><span>Cargando...</span></div><section><cargo77-fab-menu ng-hide=$ctrl.hideFabMenuIfDriverOrChildCarrier()></cargo77-fab-menu></section></md-content>");
$templateCache.put("app/components/orders/components/carrierAcceptedOrderOverviewTab/carrier-accepted-order-overview-tab.html","<md-content id=list-wrapper layout=row layout-wrap flex=100 layout-align=\"center start\"><section class=\"page-wrapper list-container\" layout-padding ng-if=$ctrl.order flex=100 layout=row layout-wrap layout-align=\"space-around center\"><section flex=100 layout=row layout-wrap><cargo77-order-size-id flex-sm=100 flex-xs=100 flex=50 should-hide-update-button=$ctrl.shouldHideUpdateStatusButton status=$ctrl.order.orderStatus order=$ctrl.order></cargo77-order-size-id><cargo77-order-client flex-sm=100 flex-xs=100 flex=50 order-id=$ctrl.order.id client=$ctrl.order.shipperCompany></cargo77-order-client></section><section flex=100 layout=row layout-wrap><cargo77-order-route-details flex-sm=100 flex-xs=100 flex=50 order=$ctrl.order></cargo77-order-route-details><cargo77-order-timeline flex-sm=100 flex-xs=100 flex=50 order=$ctrl.order class=order-timeline-column></cargo77-order-timeline></section></section></md-content>");
$templateCache.put("app/components/orders/components/carrierAcceptedOrderTrackingTab/carrier-accepted-order-tracking-tab.html","<md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><section class=\"page-wrapper list-container\" layout-padding ng-if=$ctrl.order flex=100 layout=row layout-wrap layout-align=\"space-around center\"><cargo77-order-route-map flex-order-xs=4 flex-order-md=4 flex-xs=100 flex=100 order=$ctrl.order></cargo77-order-route-map></section></md-content>");
$templateCache.put("app/components/orders/components/carrierOrderList/carrier-order-list.html","<cargo77-search-bar status-filter-options=$ctrl.offerStatus on-status-filter-change=$ctrl.updateStatusFilter(status) on-date-filter-change=$ctrl.updateDateFilter(date) on-search-text-filter-change=$ctrl.updateSearchText(searchText) sizes-filter-options=$ctrl.loadSizes on-load-size-filter-change=$ctrl.updateLoadSizeFilter(loadSize)></cargo77-search-bar><md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><div flex=100 layout=column layout-align=\"center center\" class=report-empty ng-if=\"$ctrl.orders.items.length === 0\" ng-show=!$ctrl.isLoadingOrders><div class=report-empty-title style=\"margin-top: 15%\">No hay resultados.</div></div><section infinite-scroll=$ctrl.orders.nextPage() infinite-scroll-container=\"\'#list-wrapper\'\" infinite-scroll-disabled=$ctrl.orders.busy infinite-scroll-distance=2 ng-if=!$ctrl.isLoadingOrders class=\"page-wrapper list-container\" flex=100 layout=row layout-wrap layout-align=\"st center\"><section style=\"display: block\" flex=100 layout=column layout-align=\"start center\"><section layout-fill layout=column layout-align=\"start center\" flex=100 ng-repeat=\"order in $ctrl.orders.items\"><cargo77-carrier-order-list-card ng-if=\"!order.offers[0] && !$ctrl.isInProcessingPaymentStatus(order)\" ui-sref=\"cargo.createOffer({id: order.id})\" flex order=order></cargo77-carrier-order-list-card><cargo77-carrier-order-list-card ng-if=order.offers[0] flex order=order ui-sref=\"cargo.editOffer({id: order.id, offerId: order.offers[0].id})\"></cargo77-carrier-order-list-card><cargo77-carrier-order-list-card ng-if=$ctrl.isInProcessingPaymentStatus(order) flex order=order ui-sref=\"cargo.orderDetails({id: order.id})\"></cargo77-carrier-order-list-card></section></section><div ng-show=$ctrl.orders.busy layout-align=\"center center\" layout=row flex=100><md-progress-circular md-mode=indeterminate class=\"md-accent md-hue-1\"></md-progress-circular></div></section><div flex=100 layout=column layout-wrap layout-align=\"center center\"><md-progress-circular md-mode=indeterminate ng-if=$ctrl.isLoadingOrders></md-progress-circular><span>Cargando...</span></div></md-content>");
$templateCache.put("app/components/orders/components/carrierSendOffer/carrier-send-offer.html","<md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><section class=\"page-wrapper list-container\" layout-padding ng-if=$ctrl.order flex=100 layout=row layout-wrap layout-align=\"space-around center\"><cargo77-order-size-id flex-order-xs=0 order=$ctrl.order flex-sm=100 flex-xs=100 flex-md=35 flex=45 from=\"$ctrl.getRouteText(\'pickup\')\" to=\"$ctrl.getRouteText(\'delivery\')\"></cargo77-order-size-id><cargo77-order-client flex-order-xs=1 order-id=$ctrl.order.id client=$ctrl.order.cargoUser flex-xs=100 flex-sm=70 flex=35 flex-md=45></cargo77-order-client><cargo77-order-time flex-order-xs=2 scheduled-date=$ctrl.order.scheduledDate flex-xs=50 flex-sm=30 order-route=$ctrl.order.route flex=20></cargo77-order-time><cargo77-order-route-details flex-order-xs=4 flex-xs=100 flex=100 order=$ctrl.order></cargo77-order-route-details><cargo77-make-offer-card ng-if=$ctrl.isNotInProcessingPayment() flex-order-xs=5 flex=100 offer=$ctrl.offer></cargo77-make-offer-card><section flex-order-xs=6 flex=100 layout=row layout-align=\"end center\"><md-button ng-if=$ctrl.isNotInProcessingPayment() ng-disabled=!$ctrl.offer.price ng-click=$ctrl.sendOffer() class=\"make-offer-button md-raised md-accent\">realizar oferta</md-button></section></section></md-content>");
$templateCache.put("app/components/orders/components/createOrder/create-order.html","<md-content layout=row layout-align=\"center center\"><md-card flex=95 class=page-wrapper style=\"padding: 30px\"><section layout-padding class=client-info><div class=step-number-container ng-class=\"{\'valid\': $ctrl.validateOrderShipper()}\"><span>1</span></div><div class=container><h1>Seleccionar cliente</h1><form name=clientForm flex=35 flex-sm=100 flex-xs=100><cargo77-company-selector ng-model=$ctrl.order.cargoCompany permission ng-click=\"$ctrl.order.cargoCompany = null\" permission-only=\"[\'CARRIER_OWNER\',\'CARRIER_USER\']\" selection=childrenOnly children-type=SHIPPER></cargo77-company-selector></form></div></section><section layout-padding class=order-details><div class=step-number-container ng-class=\"{\'valid\': $ctrl.haveDetailsFullfilled()}\">2</div><div class=container layout=row layout-wrap><div flex=100><h1>Detalles del flete</h1></div><section flex=100><h2 class=subtitle>Especificaciones</h2><md-input-container class=\"specifications md-icon-float md-block\" md-no-float><md-icon md-font-icon class=name>messages</md-icon><input ng-disabled=!$ctrl.canEdit type=text ng-model=$ctrl.order.details rows=3 md-no-resize placeholder=\"Detalles adicionales y notas del pedido\" autocomplete=off></md-input-container></section><cargo77-add-extra-fields-selector ng-if=$ctrl.getCarrierCompanyId() flex=100 carrier-company-id=$ctrl.getCarrierCompanyId() on-change-fields=$ctrl.onExtraFieldChange(extraFields) on-saving-files=\"$ctrl.onSavingOrderFiles(saved, saving)\" on-are-valid-extra-field-change=$ctrl.areValidExtraFieldsChange(areValidExtraFields) section=\"\'ORDER\'\"></cargo77-add-extra-fields-selector></div></section><section layout-padding class=order-route><div class=step-number-container ng-class=\"{\'valid\': $ctrl.validateOrderRoute()}\">3</div><div class=container layout=column layout-wrap><div><h1>Ruta</h1></div><cargo77-route-with-details-selector selected-company-id=$ctrl.order.cargoCompany.id on-change-route=$ctrl.onRouteChange(segments) on-saving-segment-files=\"$ctrl.onSavingSegmentFiles(saved, saving)\" is-shipper-order=false carrier-company-id=$ctrl.getCarrierCompanyId() route=$ctrl.route></cargo77-route-with-details-selector></div></section><section layout-padding class=client-info><div class=step-number-container ng-class=\"{\'valid\': $ctrl.validateOrderCarrier()}\"><span>4</span></div><div class=container><h1>Asignar transportista</h1><form name=carrierForm flex=35 flex-sm=100 flex-xs=100><cargo77-company-selector ng-model=$ctrl.order.carrierCompany permission ng-click=\"$ctrl.order.carrierCompany = null\" permission-only=\"[\'CARRIER_OWNER\',\'CARRIER_USER\']\" children-type=CARRIER></cargo77-company-selector></form></div></section><section flex-gt-md=50 flex=100 layout=row layout-wrap><md-switch flex=60 flex-md=40 flex-xs=90 ng-click=\"$ctrl.order.duplicatesAmount = 1\" ng-model=$ctrl.order.needDuplicates aria-label=\"Generar duplicados\">Generar duplicados de esta orden:</md-switch><md-input-container flex-offset=5 flex=10 flex-xs=100 ng-if=$ctrl.order.needDuplicates><input min=1 ng-model=$ctrl.order.duplicatesAmount type=number></md-input-container></section><section layout=row layout-align=\"end center\" layout-align-xs=\"center center\"><div ng-show=\"!$ctrl.allOrderFilesSaved || !$ctrl.allSegmentFilesSaved\" layout-align=\"center center\" layout=row flex=100><md-progress-circular md-mode=indeterminate class=\"md-accent md-hue-1\" style=\"margin-right: 10dp\"></md-progress-circular><span>Cargando archivo(s), espere...</span></div><div ng-show=$ctrl.isSaving layout-align=\"center center\" layout=row flex=100><md-progress-circular md-mode=indeterminate class=\"md-accent md-hue-1\" style=\"margin-right: 10dp\"></md-progress-circular><span>Guardando orden...</span></div><md-button ng-disabled=\"!$ctrl.validateAllFields() || $ctrl.isSaving || !$ctrl.allOrderFilesSaved || !$ctrl.allSegmentFilesSaved\" ng-click=$ctrl.saveOrder() layout-margin flex=20 flex-xs=60 class=\"md-raised md-accent create-accepted-order-button\">Guardar</md-button></section></md-card></md-content>");
$templateCache.put("app/components/orders/components/shipperAcceptOffer/shipper-accept-offer.html","<md-content id=list-wrapper layout=row layout-wrap layout-fill layout-align=\"center start\"><section class=page-wrapper layout-padding layout-fill flex=100 layout=row layout-wrap layout-align=\"center center\"><md-card flex=90 flex-xs=100 layout=row layout-fill layout-wrap layout-align=\"center center\"><div flex=90 flex-xs=100 layout=row layout-align=\"space-between center\" layout-fill layout-wrap class=card-content><div flex=100 id=select-payment class=step-container><div layout=row class=step-counter layout-align=\"center center\" flex>1</div><div class=info-container layout=row layout-align=\"start center\" layout-wrap><div flex=100><h1 class=title>Selecciona tu forma de pago</h1></div><div flex=50 flex-md=60 flex-sm=80 flex-xs=100 layout=row layout-align=\"space-around start\" class=payment-container><div flex=30 ng-click=\"$ctrl.type = \'DEPOSIT_OR_WIRE_TRANSFER\'\" ng-class=\"{selected: $ctrl.type === \'DEPOSIT_OR_WIRE_TRANSFER\'}\" class=payment-type layout=column layout-align=\"start center\"><div class=icon-container layout-align=\"center center\" layout=row><md-icon md-font-icon>desktop_windows</md-icon></div><div flex class=type-text>Depósito o transferencia bancaria</div></div><div flex=30 class=payment-type ng-click=\"$ctrl.type = \'CREDIT_CARD\'\" ng-class=\"{selected: $ctrl.type === \'CREDIT_CARD\'}\" layout=column layout-align=\"start center\"><div class=icon-container layout-align=\"center center\" layout=row><md-icon md-font-icon>payment</md-icon></div><div flex class=type-text>Tarjeta de crédito</div></div><div flex=30 ng-click=\"$ctrl.type = \'PAYMENT_AGREEMENT\'\" ng-if=$ctrl.company.hasPaymentAgreement ng-class=\"{selected: $ctrl.type === \'PAYMENT_AGREEMENT\'}\" class=payment-type layout=column layout-align=\"start center\"><div class=icon-container layout-align=\"center center\" layout=row><md-icon md-font-icon>near_me</md-icon></div><div flex class=type-text>Convenio de pago</div></div></div></div></div><cargo77-transfer-payment ng-if=\"$ctrl.type === \'DEPOSIT_OR_WIRE_TRANSFER\'\" photo=$ctrl.photo document-number=$ctrl.documentNumber></cargo77-transfer-payment><cargo77-credit-card-payment ng-if=\"$ctrl.type === \'CREDIT_CARD\'\" credit-card=$ctrl.creditCard></cargo77-credit-card-payment><cargo77-covenant-payment ng-if=\"$ctrl.type === \'PAYMENT_AGREEMENT\'\" are-terms-accepted=$ctrl.areTermsAccepted></cargo77-covenant-payment></div></md-card><div flex=90 flex-xs=100 layout=row layout-align-xs=\"space-between center\" layout-align=\"end center\" class=payment-cta><div flex=20 flex-xs=45><md-button layout-fill class=\"md-accent md-hue-1\">cancelar</md-button></div><div flex=20 flex-xs=45><md-button ng-click=$ctrl.acceptOffer() ng-disabled=\"\n                   (!$ctrl.areTermsAccepted && $ctrl.type === \'PAYMENT_AGREEMENT\') ||\n                   ((!$ctrl.creditCard.number || !$ctrl.creditCard.expire_year || !$ctrl.creditCard.expire_month || !$ctrl.creditCard.cvv2) && !$ctrl.creditCard.id && $ctrl.type === \'CREDIT_CARD\') ||\n                   ($ctrl.type === \'DEPOSIT_OR_WIRE_TRANSFER\' && (!$ctrl.photo && !$ctrl.documentNumber) )\" layout-fill class=\"md-accent md-raised\">aceptar</md-button></div></div></section><div flex=100 layout=row layout-wrap layout-align=\"center center\"><md-progress-circular md-mode=indeterminate ng-if=$ctrl.isProcessingPayment class=\"md-accent md-hue-1\"></md-progress-circular></div></md-content>");
$templateCache.put("app/components/orders/components/shipperCreateOrder/shipper-create-order.html","<md-content layout=row layout-align=\"center center\"><md-card flex=95 class=page-wrapper style=\"padding: 30px\"><section layout-padding class=order-details><div class=step-number-container ng-class=\"{\'valid\': $ctrl.order.details.length > 0}\">1</div><div class=container layout=row layout-wrap><div flex=100><h1>Detalles del flete</h1></div><section flex=100><h2 class=subtitle>Especificaciones</h2><md-input-container class=\"specifications md-icon-float md-block\" md-no-float><md-icon md-font-icon class=name>messages</md-icon><input type=text ng-model=$ctrl.order.details rows=3 md-no-resize placeholder=\"Detalles adicionales y notas del pedido\"></md-input-container></section><cargo77-add-extra-fields-selector ng-if=$ctrl.getCarrierCompanyId() flex=100 carrier-company-id=$ctrl.getCarrierCompanyId() on-change-fields=$ctrl.onExtraFieldChange(extraFields) on-are-valid-extra-field-change=$ctrl.areValidExtraFieldsChange(areValidExtraFields) section=\"\'ORDER\'\"></cargo77-add-extra-fields-selector></div></section><section layout-padding class=order-route><div class=step-number-container ng-class=\"{\'valid\': $ctrl.validateOrderRoute()}\">2</div><div class=container layout=column layout-wrap><div><h1>Ruta</h1></div><cargo77-route-with-details-selector on-change-route=$ctrl.onRouteChange(segments) is-shipper-order=true carrier-company-id=$ctrl.getCarrierCompanyId() route=$ctrl.route></cargo77-route-with-details-selector></div></section><section flex-gt-md=50 flex=100 layout=row layout-wrap><md-switch flex=60 flex-md=40 flex-xs=90 ng-click=\"$ctrl.order.duplicatesAmount = 1\" ng-model=$ctrl.order.needDuplicates aria-label=\"Generar duplicados\">Generar duplicados de esta orden:</md-switch><md-input-container flex-offset=5 flex=10 flex-xs=100 ng-if=$ctrl.order.needDuplicates><input min=1 ng-model=$ctrl.order.duplicatesAmount type=number></md-input-container></section><section layout=row layout-align=\"end center\" layout-align-xs=\"center center\"><div ng-show=$ctrl.isSaving layout-align=\"center center\" layout=row flex=100><md-progress-circular md-mode=indeterminate class=\"md-accent md-hue-1\" style=\"margin-right: 10dp\"></md-progress-circular><span>Enviando solicitud...</span></div><md-button ng-disabled=\"!$ctrl.validateAllFields() || $ctrl.isSaving\" ng-click=$ctrl.saveOrder() layout-margin flex=20 flex-sm=30 flex-xs=80 flex-md=30 class=\"shipper-create-order-button md-raised md-accent\">enviar solicitud</md-button></section></md-card></md-content>");
$templateCache.put("app/components/orders/components/shipperOrderDetails/shipper-order-details.html","<md-tabs class=tabs-container md-dynamic-height md-selected=shipperOrderDetails.activeTab md-center-tabs md-align-tabs=top><md-tab id=tab1><md-tab-label>Visión General</md-tab-label><md-tab-body><cargo77-shipper-order-overview-tab order=shipperOrderDetails.order></cargo77-shipper-order-overview-tab></md-tab-body></md-tab><md-tab id=tab2><md-tab-label>Información</md-tab-label><md-tab-body><cargo77-carrier-order-information-tab order=shipperOrderDetails.order></cargo77-carrier-order-information-tab></md-tab-body></md-tab><md-tab id=tab3><md-tab-label>Seguimiento</md-tab-label><md-tab-body><cargo77-carrier-accepted-order-tracking-tab order=shipperOrderDetails.order></cargo77-carrier-accepted-order-tracking-tab></md-tab-body></md-tab></md-tabs>");
$templateCache.put("app/components/orders/components/shipperOrderList/shipper-order-list.html","<cargo77-search-bar status-filter-options=$ctrl.status on-status-filter-change=$ctrl.updateStatusFilter(status) on-search-text-filter-change=$ctrl.updateSearchText(searchText) initial-search-text={{$ctrl.initialSearchText}}></cargo77-search-bar><md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><div flex=100 layout=column layout-align=\"center center\" class=report-empty ng-if=\"$ctrl.orders.items.length === 0\" ng-show=!$ctrl.isLoadingOrders><div class=report-empty-title style=\"margin-top: 15%\">No hay resultados.</div></div><section ng-if=!$ctrl.isLoadingOrders class=\"page-wrapper list-container\" flex=100 layout=row layout-wrap layout-align=\"center center\"><section class=month-container flex=100 layout=row layout-wrap layout-align=\"center center\" ng-repeat=\"month in $ctrl.orders.items\"><div flex=100 layout-xs=row layout-align-xs=\"center center\"><h2 class=month-title>{{::month.label}}</h2></div><section ng-repeat=\"(dayKey, dayOrders) in month.orders\" class=month flex=100 layout=row layout-wrap layout-align=\"space-between start\"><section flex-xs=15 flex-md=10 flex-sm=10 flex=5><div layout=column layout-align=\"start center\"><div flex><h1>{{::dayKey.split(\' \')[0]}}</h1></div><div flex><h4>{{::dayKey.split(\' \')[1]}}</h4></div></div></section><section flex=95 flex-md=90 flex-sm=90 flex-xs=85 layout=column layout-align=\"start center\"><md-card ng-repeat=\"order in dayOrders\" ui-sref=\"cargo.shipperOrderDetails({id: order.id})\" flex layout=row layout-wrap><div ng-if=\"order.orderStatus === \'REQUESTING_OFFERS\' || order.orderStatus === \'PROCESSING_PAYMENT\'\" flex=100 layout=row><div flex=55 flex-xs=100 layout=row class=orders-margin><div layout=column class=order-details><div class=order-iterator ng-repeat=\"segmentItem in order.route.segments\"><div class=direction-title layout=row layout-align=\"start start\" layout-xs=column layout-align-xs=\"start stretch\"><div layout=row flex-xs=100 layout-align-xs=\"start start\"><div class=segment>{{segmentItem.description}}</div></div></div><div class=order-hour-container><span><strong>Hora</strong> <span>: {{order.scheduledDate | date:\'HH:mm\'}}</span></span></div><div class=distance-weight-details layout=row><div>{{segmentItem.distance.text}}, {{segmentItem.cargoDetails.weight.value}} kilogramo<span ng-if=\"segmentItem.cargoDetails.weight.value !== 1\">s</span></div></div></div></div></div><div class=vertical-divider-container hide-xs><md-divider class=vertical-divider></md-divider></div><div flex=33 flex-xs=100 layout=row hide-xs layout-wrap layout-align=\"start start\"><div class=location-iterator ng-repeat=\"stopoverEntry in order.stopoverHistory\" layout=row flex=100 layout-align=\"space-between start\"><div flex=70 layout=row layout-align=\"start start\"><div layout-align=\"center center\"><md-icon md-font-icon>adjust</md-icon></div><div><span>{{::$ctrl.getStopoverType(stopoverEntry.type).title}}: {{stopoverEntry.stopoverLocation.name}}</span></div></div><div flex=30 layout=row layout-align=\"end none\">{{$ctrl.getFormattedStringTime(order.scheduledDate, stopoverEntry.datetime)}}</div></div></div><div flex=10 flex-xs=30 class=offers-count layout=row layout-align=\"end center\"><span>{{order.offers.length}}&nbsp;Oferta<span ng-if=\"order.offers.length !== 1\">s</span></span></div></div><div ng-if=\"order.orderStatus !== \'REQUESTING_OFFERS\' && order.orderStatus !== \'PROCESSING_PAYMENT\'\" flex=100 layout=row layout-wrap layout-align=\"space-between start\"><div flex=90 flex-md=80 flex-sm=80 flex-xs=100 layout=row layout-align=\"start center\" class=order-id-container layout-wrap><div class=size-container layout=column><md-icon>account_balance</md-icon></div><div flex=90 flex-xs=70 flex=100 layout=column layout-wrap layout-align=\"start none\"><div flex=100 layout=row layout-align=\"none start\"><div class=generate-id>{{order.orderNumber}}</div><div layout=row layout-wrap><span class=customer-name>| {{order.mainCarrierCompany.name}}</span></div></div><div class=order-extra-fields-container layout-wrap layout=row><div><span><strong>Hora</strong> <span>: {{order.scheduledDate | date:\'HH:mm\'}}</span></span></div><div ng-repeat=\"extraField in order.extraFields\" ng-if=\"extraField.definition.isVisibleInList === true && extraField.definition.isActive === true\"><span><strong>{{extraField.definition.name}}</strong> <span ng-if=\"extraField.definition.inputType === \'FILE\'\"><a target=_blank ng-href={{extraField.value}} onclick=event.stopPropagation()><md-icon class=file-icon md-font-icon>attach_file</md-icon></a></span><span ng-if=\"extraField.definition.inputType !== \'FILE\'\">: {{extraField.value}}</span></span></div></div></div></div><div flex-xs=100 flex=10 flex-md=20 flex-sm=20 layout=column layout-xs=row layout-align-xs=\"end center\" layout-align=\"space-around center\" class=cta-section><div class=\"state order-status-label\" ng-class=[$ctrl.getStatusForOrder(order.orderStatus).class]><div>{{::$ctrl.getStatusForOrder(order.orderStatus).title}}</div></div></div><div layout=row flex=100><div flex=66 flex-xs=100 flex-sm=50 flex-md=50 layout=row layout-align=\"center start\" class=orders-accepted-margin><div flex=100 layout=row layout-align=\"start center\"><div flex=100 layout=column class=order-details><div class=order-iterator ng-repeat=\"segmentItem in order.route.segments\"><div layout-xs=column layout-gt-md=row flex=100 layout-align=\"space-between start\" layout-align-xs=\" none\"><div flex=100 layout=column class=segment-details layout-align=\" none\"><div class=\"segment direction-title\">{{segmentItem.description}}</div><div class=distance-weight-details layout=row><div>{{segmentItem.distance.text}}, {{segmentItem.cargoDetails.weight.value}} kilogramo<span ng-if=\"segmentItem.cargoDetails.weight.value !== 1\">s</span><div class=segment-extra-fields-container layout-wrap layout=row><div ng-repeat=\"extraField in segmentItem.extraFields\"><span ng-if=\"extraField.definition.isVisibleInList === true && extraField.definition.isActive === true\"><strong>{{extraField.definition.name}}</strong> <span ng-if=\"extraField.definition.inputType === \'FILE\'\"><a target=_blank ng-href={{extraField.value}} onclick=event.stopPropagation()><md-icon class=file-icon md-font-icon>attach_file</md-icon></a></span><span ng-if=\"extraField.definition.inputType !== \'FILE\'\">: {{extraField.value}}</span></span></div></div></div></div></div><div flex=100 layout=row layout-gt-xs=row layout-align=\"space-between end\" layout-align-xs=\" none\"><div flex=70 layout=row class=person-details><section ng-if=segmentItem.currentAssignedDriverInstance flex=100 layout=row layout-align=\"start center\"><div layout-align=\"center center\"><md-icon md-font-icon>account_box</md-icon></div><div layout=column><div class=person-name><span>{{::segmentItem.currentAssignedDriverInstance.firstName}} {{::segmentItem.currentAssignedDriverInstance.lastName}}</span></div><div class=person-phone><span>{{::segmentItem.currentAssignedDriverInstance.phone}}</span></div></div></section><section ng-if=!segmentItem.currentAssignedDriverInstance flex=100 layout=row layout-align=\"start center\"><div layout-align=\"center center\"><md-icon md-font-icon>account_box</md-icon></div><div><div class=person-name><span>Conductor no asignado</span></div><div class=person-phone><span></span></div></div></section></div><div flex=30 layout=row class=vehicle-details><section ng-if=segmentItem.currentAssignedVehicleInstance flex=100 layout=row layout-align=\"start center\"><div layout-align=\"center center\"><md-icon md-font-icon>directions_bus</md-icon></div><div layout=column><div class=\"vehicle-brand vehicle-plate\"><span>{{::segmentItem.currentAssignedVehicleInstance.plate}}</span></div><div class=vehicle-brand><span>{{::segmentItem.currentAssignedTrailerInstance.identification}}</span></div></div></section><section ng-if=!segmentItem.currentAssignedVehicleInstance flex=100 layout=row layout-align=\"start center\"><div layout-align=\"center center\"><md-icon md-font-icon>directions_bus</md-icon></div><div class=vehicle-brand><span>vehículo no asignado</span></div></section></div></div></div></div></div></div></div><div hide-xs><md-divider class=vertical-divider></md-divider></div><div flex=33 flex-xs=100 flex-sm=50 flex-md=50 layout=row hide-xs layout-wrap layout-align=\"start start\"><div class=location-iterator ng-repeat=\"stopoverEntry in order.stopoverHistory\" layout=row flex=100 layout-align=\"space-between start\"><div flex=70 layout=row layout-align=\"start start\"><div layout-align=\"center center\"><md-icon md-font-icon>adjust</md-icon></div><div><span>{{::$ctrl.getStopoverType(stopoverEntry.type).title}}: {{stopoverEntry.stopoverLocation.name}}</span></div></div><div flex=30 layout=row layout-align=\"end none\">{{$ctrl.getFormattedStringTime(order.scheduledDate, stopoverEntry.datetime)}}</div></div></div></div></div><div layout=row flex=100 class=code-details layout-align=\"end center\"><div class=code-label ng-if=order.duplicatesDetails>{{order.duplicatesDetails}}</div></div></md-card></section></section></section><div layout-align=\"center center\" ng-show=!$ctrl.orders.busy ng-if=!$ctrl.orders.hasListEnded><md-button class=\"md-accent md-hue-1\" ng-click=$ctrl.orders.nextPage()>Cargar más</md-button></div></section><div ng-show=\"$ctrl.orders.busy || $ctrl.isLoadingOrders\" layout-align=\"center center\" layout=column flex=100><md-progress-circular md-mode=indeterminate class=\"md-accent md-hue-1\"></md-progress-circular><span>Cargando...</span></div><section><cargo77-fab-menu></cargo77-fab-menu></section></md-content>");
$templateCache.put("app/components/orders/components/shipperOrderOverviewTab/shipper-order-overview-tab.html","<md-content id=list-wrapper layout=row layout-wrap flex=100 layout-align=\"center start\"><section class=\"page-wrapper list-container\" layout-padding ng-if=$ctrl.order flex=100 layout=row layout-wrap layout-align=\"space-around center\"><section flex=100 layout=row layout-wrap><cargo77-order-size-id should-hide-update-button=true flex-sm=100 flex-xs=100 flex=50 status=$ctrl.order.orderStatus order=$ctrl.order></cargo77-order-size-id><cargo77-order-client flex-sm=100 flex-xs=100 flex=50 order-id=$ctrl.order.id client=$ctrl.order.shipperCompany></cargo77-order-client></section><section flex=100 layout=row layout-wrap><cargo77-order-route-details flex-sm=100 flex-xs=100 flex=50 order=$ctrl.order></cargo77-order-route-details><cargo77-order-timeline flex-sm=100 flex-xs=100 flex=50 order=$ctrl.order class=order-timeline-column></cargo77-order-timeline></section></section></md-content>");
$templateCache.put("app/components/orders/components/stopoversHistoryTab/stopovers-history-tab.html","<md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><section class=\"page-wrapper list-container\" layout-padding ng-if=$ctrl.order flex=100 layout=row layout-wrap layout-align=\"space-around center\"><md-card layout-margin=\"\" layout=column flex=90><cargo77-stopovers-history order=$ctrl.order update-order=$ctrl.updateOrder() disable=$ctrl.isCarrierViewer()></cargo77-stopovers-history><div layout=row layout-align=\"end start\" ng-if=\"$ctrl.order.orderStatus != \'IN_TRANSIT\'\" class=warning><sup>*</sup> <span>La edición está disponible solo en estado:</span> <span class=capitalized>{{$ctrl.getOrderStatusLabel(\'IN_TRANSIT\')}}.</span></div></md-card></section></md-content>");
$templateCache.put("app/components/reports/components/orders/order-report.html","<md-content layout=row layout-align=\"center center\"><md-card flex=100 class=page-wrapper><div layout=row class=main-title layout-margin><h3><strong>Filtros</strong></h3></div><form ng-submit=$ctrl.generateReport() name=orderReportForm layout=column layout-margin><div layout=row layout-wrap layout-align=\"space-between start\"><md-input-container flex=30 flex-xs=100 flex-sm=100><datepicker date-format=MM/dd/yyyy datepicker-class=datepicker><input placeholder=\"Fecha inicio\" name=dateStart required ng-model=$ctrl.dateFilter.start type=text readonly autocomplete=off><div ng-messages=orderReportForm.dateStart.$error><div ng-message=required>Este campo es obligatorio.</div></div></datepicker></md-input-container><md-input-container flex=30 flex-xs=100 flex-sm=100><datepicker date-format=MM/dd/yyyy date-min-limit={{$ctrl.dateFilter.start}} datepicker-class=datepicker><input placeholder=\"Fecha fin\" name=dateEnd required ng-model=$ctrl.dateFilter.end type=text readonly autocomplete=off><div ng-messages=orderReportForm.dateEnd.$error><div ng-message=required>Este campo es obligatorio.</div></div></datepicker></md-input-container><md-input-container flex=30 flex-xs=100 flex-sm=100><label>Estado de la orden</label><md-select ng-model=$ctrl.statusFilter><md-option value={{null}}>Todos los estados</md-option><md-option ng-repeat=\"status in $ctrl.orderStatus\" value={{status.label}}>{{status.title}}</md-option></md-select></md-input-container><div flex=30 flex-xs=100 flex-sm=100 ng-if=$ctrl.showFilterOptions><md-input-container style=\"width: 100%\"><label>Empresa cliente</label><md-select ng-model=$ctrl.shipperCompanyFilter ng-disabled=!$ctrl.isParentCompany()><md-option value={{null}}>Todos los clientes</md-option><md-option ng-repeat=\"shipperCompany in $ctrl.shipperCompanies\" value={{shipperCompany.value}}>{{shipperCompany.label}}</md-option></md-select></md-input-container></div><div flex=30 flex-xs=100 flex-sm=100 ng-if=$ctrl.showFilterOptions><md-input-container style=\"width: 100%\"><label>Empresa transportista</label><md-select ng-model=$ctrl.carrierCompanyFilter ng-disabled=!$ctrl.isParentCompany()><md-option value={{null}}>Todos las empresas</md-option><md-option ng-repeat=\"carrierCompany in $ctrl.carrierCompanies\" value={{carrierCompany.value}}>{{carrierCompany.label}}</md-option></md-select></md-input-container></div><md-input-container flex=30 flex-xs=100 flex-sm=100><label>Tipo de campos extra</label><md-select ng-model=$ctrl.extraFieldsState><md-option ng-repeat=\"option in $ctrl.extraFieldsStateOptions\" value={{option.key}} ng-selected=\"{{option.key === $ctrl.extraFieldOptionKeys.active}}\">{{option.label}}</md-option></md-select></md-input-container></div><div layout=row layout-align=\"end center\"><md-button class=md-icon-button ng-click=$ctrl.resetFilters()><md-icon md-font-icon>delete</md-icon></md-button><md-button type=submit ng-disabled=\"$ctrl.isGeneratingReport || orderReportForm.$invalid\" class=\"md-raised md-accent filter-button\">Generar reporte</md-button><md-progress-circular md-mode=indeterminate ng-show=$ctrl.isGeneratingReport md-diameter=30px></md-progress-circular></div><div flex=100 layout=column layout-align=\"center center\" class=report-empty ng-if=$ctrl.isReportEmpty><div class=report-empty-title>No hay resultados.</div></div></form></md-card></md-content>");
$templateCache.put("app/components/payments/components/paymentList/payments-list.html","<cargo77-search-bar status-filter-options=$ctrl.orderPaymentStatus on-status-filter-change=$ctrl.updateStatusFilter(status) on-search-text-filter-change=$ctrl.updateSearchText(searchText)></cargo77-search-bar><md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><section infinite-scroll=$ctrl.orders.nextPage() infinite-scroll-container=\"\'#list-wrapper\'\" infinite-scroll-disabled=$ctrl.orders.busy infinite-scroll-distance=2 ng-if=!$ctrl.isLoadingOrders class=\"page-wrapper list-container\" flex=100 layout=row layout-wrap layout-align=\"st center\"><section style=\"display: block\" flex=100 layout=column layout-align=\"start center\"><section layout-fill layout=column layout-align=\"start center\" flex=100 ng-repeat=\"order in $ctrl.orders.items\"><cargo77-payments-list-card flex order=order on-reject-payment=$ctrl.rejectPayment(orderId) on-undo-payment=$ctrl.setToVerifyingStatus(orderId) on-accept-payment=$ctrl.acceptPayment(orderId)></cargo77-payments-list-card></section></section><div ng-show=$ctrl.orders.busy layout-align=\"center center\" layout=row flex=100><md-progress-circular md-mode=indeterminate class=\"md-accent md-hue-1\"></md-progress-circular></div></section><div flex=100 layout=row layout-wrap layout-align=\"center center\"><md-progress-circular md-mode=indeterminate ng-if=$ctrl.isLoadingOrders></md-progress-circular></div></md-content>");
$templateCache.put("app/components/reports/components/timesReport/times-report.html","<md-content layout=row layout-align=\"center center\"><section class=\"page-wrapper list-container\" layout-padding flex=100 layout=row layout-wrap layout-align=\"space-around center\"><md-card flex=100 class=page-wrapper><div layout=row class=main-title layout-margin><h3><strong>Filtros</strong></h3></div><form ng-submit=$ctrl.generateReport() name=timesReportForm layout=column layout-margin><div layout=row layout-wrap layout-align=\"space-between start\"><!--Companies--><md-input-container flex=30 flex-xs=100 flex-sm=100><label>Empresa transportista</label><md-select name=company ng-model=$ctrl.carrierCompanyFilter ng-disabled=!$ctrl.isParentCompany() required><md-option value={{null}}>Todos las empresas</md-option><md-option ng-repeat=\"carrierCompany in $ctrl.carrierCompanies\" ng-value=\"{value: carrierCompany.value, company: carrierCompany.label}\">{{carrierCompany.label}}</md-option></md-select><div ng-messages=timesReportForm.company.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><!--Location 1--><md-input-container flex=30 flex-xs=100 flex-sm=100><label>Ubicacion 1</label><md-select name=location1 ng-model=$ctrl.fromLocationFilter ng-change=$ctrl.getLocationsTo() required><md-select-header class=select-header><input name=search ng-model=$ctrl.searchLocation1 placeholder=Buscar... type=text ng-keydown=$event.stopPropagation() autocomplete=off class=\"header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"location in $ctrl.allLocations | filter: { name : $ctrl.searchLocation1 } | orderBy: \'company\'\" ng-value=\"{value: location.value, company: location.company, name: location.name}\">{{location.label}}</md-option></md-select><div ng-messages=timesReportForm.location1.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><!-- </div> --><!--Location 2--><md-input-container flex=30 flex-xs=100 flex-sm=100><label>Ubicacion 2</label><md-select name=location2 ng-model=$ctrl.toLocationsFilter ng-disabled=!$ctrl.fromLocationFilter required multiple><md-select-header class=select-header><input name=search ng-model=$ctrl.searchLocation2 placeholder=Buscar... type=text ng-keydown=$event.stopPropagation() autocomplete=off class=\"header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"location in $ctrl.selectedLocationItems | filter: { name : $ctrl.searchLocation2 } | orderBy: \'company\'\" ng-value=\"{value: location.value, company: location.company, name: location.name}\">{{location.name}}</md-option></md-select><div ng-messages=timesReportForm.location2.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><!-- </div> --><!--Months--><md-input-container flex=30 flex-xs=100 flex-sm=100><label>Mes</label><md-select name=month ng-model=$ctrl.monthFilter required><md-option value={{null}}>Todos los meses</md-option><md-option ng-repeat=\"month in $ctrl.months\" value={{month.value}}>{{month.name}}</md-option></md-select><div ng-messages=timesReportForm.month.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><!--Years--><md-input-container flex=30 flex-xs=100 flex-sm=100><label>Año</label><md-select name=year ng-model=$ctrl.yearFilter required><md-option ng-repeat=\"year in $ctrl.years\" value={{year.value}}>{{year.value}}</md-option></md-select><div ng-messages=timesReportForm.year.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><md-input-container flex=30 flex-xs=100 flex-sm=100></md-input-container></div><!--Generate Report Button--><div layout=row layout-wrap layout-align=\"end center\"><md-button class=md-icon-button ng-click=$ctrl.resetFilters()><md-icon md-font-icon>delete</md-icon></md-button><md-button type=submit ng-disabled=\"$ctrl.isGeneratingReport || timesReportForm.$invalid\" class=\"md-raised md-accent filter-button\">Generar reporte gráfico</md-button><md-button type=submit ng-click=$ctrl.downloadExcel() ng-disabled=\"$ctrl.isGeneratingReport || timesReportForm.$invalid\" class=\"md-raised md-primary filter-button\">Descargar Reporte Excel</md-button><md-progress-circular md-mode=indeterminate ng-show=$ctrl.isGeneratingReport md-diameter=30px></md-progress-circular></div><!--Empty Message--><div flex=100 layout=column layout-align=\"center center\" class=report-empty ng-if=$ctrl.isReportEmpty><div class=report-empty-title>No hay resultados.</div></div></form></md-card><md-card flex=100 class=page-wrapper ng-if=$ctrl.showGraphics><div layout=row layout-align=\"end center\"><md-button type=submit class=\"md-raised md-accent filter-button\" ng-disabled=!$ctrl.showAddToDashboardBtn ng-click=$ctrl.addGraphicToDashboard()>Añadir a Dashboard</md-button><md-progress-circular md-mode=indeterminate ng-show=$ctrl.isSavingGraphic md-diameter=30px></md-progress-circular></div><div layout=row layout-wrap layout-align=\"center start\"><highchart flex-md=100 flex=80 config=$ctrl.chartConfig></highchart></div></md-card></section></md-content>");
$templateCache.put("app/components/reports/components/tripsReport/trips-report.html","<md-content layout=row layout-align=\"center center\"><section class=\"page-wrapper list-container\" layout-padding flex=100 layout=row layout-wrap layout-align=\"space-around center\"><md-card flex=100 class=page-wrapper><div layout=row class=main-title layout-margin><h3><strong>Filtros</strong></h3></div><form ng-submit=$ctrl.generateReport() name=driverReportForm layout=column layout-margin><div layout=row layout-wrap layout-align=\"space-between start\"><!--Carriers--><md-input-container flex=100 flex-xs=100 flex-sm=100><label>Empresa transportista</label><md-select name=company ng-model=$ctrl.carrierCompanyFilter ng-disabled=!$ctrl.isParentCompany() required><md-option value=all>Todos las empresas</md-option><md-option value=company-list>Seleccionar compañia(s)</md-option></md-select><div ng-messages=driverReportForm.company.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><!--Carrier list selector--><md-input-container ng-if=\"$ctrl.carrierCompanyFilter === \'company-list\'\" flex=100 flex-xs=100 flex-sm=100><md-chips name=carrierCompaniesChips ng-model=$ctrl.carrierCompaniesArray placeholder=\"Buscar empresa transportista\" md-require-match=\"\'true\'\" ng-required=true><md-autocomplete md-selected-item=$ctrl.selectedCarrierItem md-search-text=$ctrl.carrierSearchText md-items=\"item in companiesFiltered = $ctrl.carrierSearchText ? ($ctrl.carrierCompanies | filter: {label: $ctrl.carrierSearchText} | orderBy: \'label\') || undefined : $ctrl.carrierCompanies\" md-item-text=item.label md-search-text-change=$ctrl.onChipChange() md-min-length=0 input-aria-describedby=autocompleteTitle placeholder=\"Empresa transportista\"><span md-highlight-text=$ctrl.searchText>{{item.label}}</span></md-autocomplete><md-chip-template><span><strong>{{$chip.label}}</strong></span></md-chip-template></md-chips></md-input-container><!--Shippers--><md-input-container flex=100 flex-xs=100 flex-sm=100><label>Clientes</label><md-select name=shipper ng-model=$ctrl.shipperCompanyFilter ng-disabled=!$ctrl.isParentCompany() required><md-option value=all>Todos los clientes</md-option><md-option value=company-list>Seleccionar cliente(s)</md-option></md-select></md-input-container><!--Shipper list selector--><md-input-container ng-if=\"$ctrl.shipperCompanyFilter === \'company-list\'\" flex=100 flex-xs=100 flex-sm=100><md-chips name=carrierCompaniesChips ng-model=$ctrl.shipperCompaniesArray placeholder=\"Buscar cliente\" md-require-match=\"\'true\'\" ng-required=true><md-autocomplete md-selected-item=$ctrl.selectedShipperItem md-search-text=$ctrl.shipperSearchText md-items=\"item in companiesFiltered = $ctrl.shipperSearchText ? ($ctrl.shipperCompanies | filter: {label: $ctrl.shipperSearchText} | orderBy: \'label\') || undefined : $ctrl.shipperCompanies\" md-item-text=item.label md-search-text-change=$ctrl.onChipChange() md-min-length=0 input-aria-describedby=autocompleteTitle placeholder=Cliente><span md-highlight-text=$ctrl.searchText>{{item.label}}</span></md-autocomplete><md-chip-template><span><strong>{{$chip.label}}</strong></span></md-chip-template></md-chips></md-input-container><!--Time Filter--><md-input-container flex=100 flex-xs=100 flex-sm=100><label>Filtrar por tiempo</label><md-select name=timeFilter ng-model=$ctrl.timeFilter required><md-option value=months>Por meses</md-option><md-option value=timeLapse>Por rango de fecha (máximo 1 año entre fechas)</md-option></md-select><div ng-messages=driverReportForm.company.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><!--Months--><md-input-container flex=45 flex-xs=100 flex-sm=100 ng-if=\"$ctrl.timeFilter === \'months\'\"><label>Mes</label><md-select name=month ng-model=$ctrl.monthFilter required><md-option value={{null}}>Todos los meses</md-option><md-option ng-repeat=\"month in $ctrl.months\" value={{month.value}}>{{month.name}}</md-option></md-select><div ng-messages=driverReportForm.month.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><!--Years--><md-input-container flex=45 flex-xs=100 flex-sm=100 ng-if=\"$ctrl.timeFilter === \'months\'\"><label>Año</label><md-select name=year ng-model=$ctrl.yearFilter required><md-option ng-repeat=\"year in $ctrl.years\" value={{year.value}}>{{year.value}}</md-option></md-select><div ng-messages=driverReportForm.year.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><!--Time lapse--><md-input-container flex=45 flex-xs=100 flex-sm=100 ng-if=\"$ctrl.timeFilter === \'timeLapse\'\"><datepicker date-format=MM/dd/yyyy date-max-limit={{$ctrl.maxStartDate}} datepicker-class=datepicker><input ng-change=$ctrl.getLimitTimelapse() placeholder=\"Fecha inicio\" name=dateStart required ng-model=$ctrl.timeLapseFilter.start type=text readonly autocomplete=off><div ng-messages=driverReportForm.dateStart.$error><div ng-message=required>Este campo es obligatorio.</div></div></datepicker></md-input-container><md-input-container flex=45 flex-xs=100 flex-sm=100 ng-if=\"$ctrl.timeFilter === \'timeLapse\'\"><datepicker date-format=MM/dd/yyyy date-max-limit={{$ctrl.maxEndDate}} date-min-limit={{$ctrl.timeLapseFilter.start}} datepicker-class=datepicker><input placeholder=\"Fecha final\" name=dateEnd required ng-model=$ctrl.timeLapseFilter.end type=text readonly autocomplete=off><div ng-messages=driverReportForm.dateEnd.$error><div ng-message=required>Este campo es obligatorio.</div></div></datepicker></md-input-container></div><!--Generate Report Button--><div id=buttons-box layout=row layout-wrap layout-align=\"end center\"><md-button class=md-icon-button ng-click=$ctrl.resetFilters()><md-icon md-font-icon>delete</md-icon></md-button><md-button type=submit ng-disabled=\"$ctrl.isGeneratingReport || driverReportForm.$invalid || ($ctrl.carrierCompanyFilter === \'company-list\' && $ctrl.carrierCompaniesArray.length === 0) || ($ctrl.shipperCompanyFilter === \'company-list\' && $ctrl.shipperCompaniesArray.length === 0)\" class=\"md-raised md-accent filter-button\">Generar reporte gráfico</md-button><md-button type=submit ng-click=$ctrl.downloadExcel() ng-disabled=\"$ctrl.isGeneratingReport || driverReportForm.$invalid\" class=\"md-raised md-primary filter-button\">Descargar Reporte Excel</md-button><!-- <md-progress-circular\n            md-mode=\"indeterminate\"\n            ng-show=\"$ctrl.isGeneratingReport\"\n            md-diameter=\"30px\"\n          >\n          </md-progress-circular> --></div><!--Loading Message--><div flex=100 layout=column layout-wrap layout-align=\"center start\" class=\"report-empty loading-box\" ng-if=$ctrl.isGeneratingReport><div class=\"main-title loading\">Generando reporte, por favor espere.</div><md-progress-linear md-mode=determinate ng-value=$ctrl.progressPercentage></md-progress-linear></div><!--Empty Message--><div flex=100 layout=column layout-align=\"center center\" class=report-empty ng-if=$ctrl.isReportEmpty><div class=report-empty-title>No hay resultados.</div></div></form></md-card><md-card flex=100 class=page-wrapper ng-if=$ctrl.showGraphics><div layout=row layout-align=\"end center\"><md-button type=submit class=\"md-raised md-accent filter-button\" ng-disabled=!$ctrl.showAddToDashboardBtn ng-click=$ctrl.addGraphicToDashboard()>Añadir a Dashboard</md-button><md-progress-circular md-mode=indeterminate ng-show=$ctrl.isSavingGraphic md-diameter=30px></md-progress-circular></div><div layout=row layout-wrap layout-align=\"center start\"><highchart flex-md=100 flex=80 config=$ctrl.chartConfig></highchart></div></md-card></section></md-content>");
$templateCache.put("app/components/trailers/components/common/upsert-trailer-card.html","<md-card layout=row layout-wrap layout-align=\"space-between center\"><section class=trailer-image flex-xs=100 flex=40 layout=column layout-align=\"space-between center\"><div ngf-drop ng-model=$ctrl.picFile ngf-pattern=image/* class=cropArea><div class=photo ng-style=\"{\'background-image\': \'url(\'+$ctrl.getEncodedURI($ctrl.trailer.photoURL)+\')\'}\" ng-if=\"$ctrl.trailer.photoURL && !$ctrl.picFile\"></div><div class=icon ng-if=\"!$ctrl.trailer.photoURL && !$ctrl.picFile\" layout=row layout-align=\"center start\"><md-icon flex md-font-icon>rv_hookup</md-icon></div><img-crop image=\"$ctrl.picFile | ngfDataUrl\" ng-if=$ctrl.picFile result-image-size=250 area-type=square ng-init=\"$ctrl.photo = \'\'\" result-image=$ctrl.photo></img-crop></div><span class=warning><sup>*</sup>Tamaño máximo 4MB</span><md-button class=md-fab ngf-select ngf-max-size=4MB ng-model=$ctrl.picFile accept=image/*><md-icon md-font-icon>photo_camera</md-icon></md-button></section><section class=trailer-info flex-xs=100 flex=60 layout=column layout-align=\"space-around center\" layout-wrap><section ng-if=$ctrl.onDeleteAction flex=100 layout=row class=trailer-status-management-menu><div ng-hide=$ctrl.trailer.isActive class=trailer-status-badge><div>Desactivado</div></div><md-menu><md-buton class=trailer-status-dropdown-button ng-click=\"$ctrl.toggleManagementMenu($mdOpenMenu, $event)\"><md-icon>more_vert</md-icon></md-buton><md-menu-content><md-menu-item ng-if=$ctrl.trailer.isActive><md-button ng-click=$ctrl.changeTrailerStatus(false)>Desactivar arrastre</md-button></md-menu-item><md-menu-item ng-if=!$ctrl.trailer.isActive><md-button ng-click=$ctrl.changeTrailerStatus(true)>Activar arrastre</md-button></md-menu-item><md-menu-item><md-button ng-click=$ctrl.deleteTrailer() class=delete>Eliminar arrastre</md-button></md-menu-item></md-menu-content></md-menu></section><form name=trailerInfo flex=100 layout=row ng-submit=$ctrl.saveChanges() layout-align=\"space-around center\" layout-wrap><section class=location-company-selector flex=95 flex-md=95 flex-sm=95 flex-xs=90><md-icon flex=5 flex-md=5 flex-sm=10 flex-xs=5 class=company-icon md-font-icon>account_balance</md-icon><cargo77-company-selector ng-model=$ctrl.trailer.ownerCompany children-type=CARRIER form-reference=trailerInfo required></cargo77-company-selector></section><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block\"><md-icon md-font-icon>label</md-icon><label>Tipo</label><md-select required name=type ng-model=$ctrl.trailer.type><md-option class=cargo77-upsert-trailer-card ng-repeat=\"type in $ctrl.trailerTypes\" value={{type.label}}>{{type.title | uppercase}}</md-option></md-select><div class=errors ng-messages=trailerInfo.type.$error><div ng-message=required>Debe seleccionar el tipo de arrastre.</div></div></md-input-container><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block\"><label>Identificación</label><md-icon md-font-icon>bookmark</md-icon><input required name=identification ng-model=$ctrl.trailer.identification type=text autocomplete=off><div class=errors ng-messages=trailerInfo.identification.$error><div ng-message=required>La identificacion del arrastre es requerida.</div></div></md-input-container><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block\"><label>Nombre</label><md-icon md-font-icon>bookmark</md-icon><input name=name required ng-model=$ctrl.trailer.name type=text autocomplete=off><div class=errors ng-messages=trailerInfo.name.$error><div ng-message=required>El nombre del arrastre es requerido.</div></div></md-input-container><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block\"><label>Marca</label><md-icon md-font-icon>directions_bus</md-icon><input name=brand ng-model=$ctrl.trailer.brand type=text autocomplete=off></md-input-container><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block\"><label>Capacidad máxima (tn, kg, lt, gl)</label><md-icon md-font-icon>line_weight</md-icon><input ng-pattern=/^([0-9]){1,}(\\.([0-9]){1,}\\s|\\s)([a-zA-Z]){2}$/ name=weight ng-model=$ctrl.trailer.weight type=text autocomplete=off><div class=errors ng-messages=trailerInfo.weight.$error><div ng-message=required>La capacidad de carga del arrastre es requerida.</div><div ng-message=pattern>Formato requerido 1234 tn/kg/lt/gl.</div></div></md-input-container><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block\"><label>Año de fabricación</label><md-icon md-font-icon>date_range</md-icon><input ng-pattern=/^([0-9]){4}$/ name=trailerYear ng-model=$ctrl.trailer.year type=number><div ng-messages=trailerInfo.trailerYear.$error><div ng-message=pattern>El año debe contener 4 digitos</div><div ng-message=required>El año del arrastre es requerido.</div></div></md-input-container><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block\"><label>Color</label><md-icon md-font-icon>invert_colors</md-icon><input name=color ng-model=$ctrl.trailer.color type=text autocomplete=off><div class=errors ng-messages=trailerInfo.color.$error><div ng-message=required>El color del arrastre es requerido.</div></div></md-input-container><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block\"><md-checkbox flex ng-model=$ctrl.trailer.hasEmergencyTire><span class=type>Tiene llanta de emergencia</span></md-checkbox></md-input-container><div class=cta-container layout=row layout-padding layout-wrap layout-align=\"end center\"><div flex-xs=100 flex=30><md-button type=submit ng-disabled=trailerInfo.$invalid class=\"register-button md-raised md-accent\">Guardar</md-button></div></div></form></section></md-card>");
$templateCache.put("app/components/trailers/components/createTrailer/create-trailer.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-trailer-card class=page-wrapper on-save-action=$ctrl.saveAction(trailer) flex=90></cargo77-upsert-trailer-card></md-content>");
$templateCache.put("app/components/trailers/components/editTrailer/edit-trailer.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-trailer-card class=page-wrapper flex=90 trailer=$ctrl.trailer permission permission-only=\"[\'CARGO_ADMIN\', \'CARRIER_OWNER\', \'CARRIER_USER\']\" on-delete-action=$ctrl.deleteAction(id) on-save-action=$ctrl.saveAction(trailer)></cargo77-upsert-trailer-card></md-content>");
$templateCache.put("app/components/trailers/components/trailersList/trailers-list.html","<cargo77-search-bar on-search-text-filter-change=$ctrl.updateSearchText(searchText) on-parent-company-filter-change=$ctrl.filterTrailersByCompany(company) company-type=CARRIER></cargo77-search-bar><md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><div flex=100 layout=column layout-align=\"center center\" class=report-empty ng-if=\"$ctrl.trailers.items.length === 0\" ng-show=!$ctrl.isLoadingTrailers><div class=report-empty-title style=\"margin-top: 15%\">No hay resultados.</div></div><section ng-if=!$ctrl.isLoadingTrailers class=\"page-wrapper list-container\" flex=100 layout=row layout-wrap layout-align=\"start center\"><cargo77-trailers-list-card flex-xs=100 flex-sm=33 flex-md=33 flex=20 trailer=trailer ng-repeat=\"trailer in $ctrl.trailers.items\" ui-sref=\"cargo.editTrailer({id: trailer.id})\"></cargo77-trailers-list-card></section><div ng-show=\"$ctrl.trailers.busy || $ctrl.isLoadingTrailers\" layout-align=\"center center\" layout=column flex=100><md-progress-circular md-mode=indeterminate class=\"md-accent md-hue-1\"></md-progress-circular><span>Cargando...</span></div><div flex=100 layout=column layout-align=\"center center\" ng-show=!$ctrl.isLoadingTrailers ng-if=!$ctrl.trailers.isListEnded><md-button class=\"md-accent md-hue-1\" ng-click=$ctrl.trailers.nextPage()>Cargar más</md-button></div><section><cargo77-fab-menu></cargo77-fab-menu></section></md-content>");
$templateCache.put("app/components/users/components/common/upsert-user-card.html","<md-card class=upsert-card layout=row layout-align=\"space-between center\" layout-wrap><section class=user-image flex-xs=90 flex=40 layout=column layout-align=\"space-between center\"><div ngf-drop ng-model=$ctrl.picFile ngf-pattern=image/* class=cropArea><div class=photo ng-style=\"{\'background-image\': \'url(\'+$ctrl.getEncodedURI($ctrl.user.photoURL)+\')\'}\" ng-if=\"$ctrl.user.photoURL && !$ctrl.picFile\"></div><div class=icon ng-if=\"!$ctrl.user.photoURL && !$ctrl.picFile\" layout=row layout-align=\"center start\"><md-icon flex md-font-icon>group</md-icon></div><img-crop image=\"$ctrl.picFile | ngfDataUrl\" ng-if=$ctrl.picFile result-image-size=250 area-type=square ng-init=\"$ctrl.photo = \'\'\" result-image=$ctrl.photo></img-crop></div><span class=warning><sup>*</sup>Tamaño máximo 4MB</span><md-button class=md-fab ngf-select ngf-max-size=4MB ng-model=$ctrl.picFile accept=image/*><md-icon md-font-icon>photo_camera</md-icon></md-button></section><section class=user-info flex-xs=90 flex=60 layout=column layout-align=\"space-around center\" layout-wrap><section ng-if=\"$ctrl.onDeleteAction && $ctrl.canEditUser\" flex=100 layout=row class=user-status-management-menu><div ng-hide=$ctrl.user.isActive class=user-status-badge><div>Desactivado</div></div><md-menu ng-hide=$ctrl.isCurrentUser()><md-buton class=user-status-dropdown-button ng-click=\"$ctrl.toggleManagementMenu($mdOpenMenu, $event)\"><md-icon>more_vert</md-icon></md-buton><md-menu-content><md-menu-item ng-if=$ctrl.user.isActive><md-button ng-click=$ctrl.changeUserStatus(false) class=deactivate>Desactivar cuenta</md-button></md-menu-item><md-menu-item ng-if=!$ctrl.user.isActive><md-button ng-click=$ctrl.changeUserStatus(true) class=activate>Activar cuenta</md-button></md-menu-item><md-menu-item><md-button ng-click=$ctrl.deleteUser() class=delete>Eliminar cuenta</md-button></md-menu-item></md-menu-content></md-menu></section><form ng-submit=$ctrl.saveChanges() name=userInfoForm ng-class=\"{profile: !$ctrl.onDeleteAction }\" flex=100 layout=row layout-align=\"space-around center\" layout-wrap><div flex-sm=90 flex-xs=90 flex-md=90 flex=95 class=\"md-icon-float md-block\" layout=row ng-if=$ctrl.showCompany><cargo77-company-selector ng-model=$ctrl.user.cargoCompany form-reference=userInfoForm required></cargo77-company-selector></div><md-input-container flex=90 flex-gt-xs=45 class=\"md-icon-float md-block\"><label>Nombre</label><md-icon md-font-icon>account_box</md-icon><input ng-model=$ctrl.user.firstName name=firstName required type=text><div ng-messages=userInfoForm.firstName.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><md-input-container flex=90 flex-gt-xs=50 class=md-block><label>Apellido</label><md-icon hide-gt-xs md-font-icon>account_box</md-icon><input ng-model=$ctrl.user.lastName name=lastName required type=text><div ng-messages=userInfoForm.lastName.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><md-input-container flex=45 flex-xs=90 class=\"phone-container md-icon-float md-block\"><label for=phone>Teléfono</label><md-icon md-font-icon>phone</md-icon><input id=phone class=phone-input ng-required=\"$ctrl.user.roles.indexOf(\'DRIVER\') >= 0\" international-phone-number ng-model=$ctrl.user.phone type=text></md-input-container><div flex=50 show-md hide-lg></div><md-input-container flex=95 flex-xs=90 flex-gt-md=45 class=\"md-icon-float md-block\"><label for=email>Email</label><md-icon md-font-icon>email</md-icon><input class=email id=email required ng-pattern=/^.+@.+\\..+$/ name=email ng-model=$ctrl.user.email type=email><div ng-messages=userInfoForm.email.$error><div ng-message=required>Este campo es obligatorio.</div><div ng-message=pattern>El correo electrónico que ingresó esta incorrecto.</div></div></md-input-container><div flex=45></div><md-divider flex=100></md-divider><section ng-if=!$ctrl.onChangePasswordAction flex=100 layout=row layout-margin layout-align=\"start start\"><md-input-container flex=100 flex-gt-md=45 class=\"md-icon-float md-block\"><label>Contraseña</label><md-icon md-font-icon>lock</md-icon><input class=password layout=column ng-pattern=/^.{6,}$/ name=newPassword ng-model=$ctrl.user.password type=\"{{showPassword?\'text\':\'password\'}}\"> <span layout=column class=mostrar-contraseña ng-click=\"showPassword = !showPassword\"><md-icon md-font-icon>visibility</md-icon></span><div ng-messages=userInfoForm.newPassword.$error ng-if=\"userInfoForm.$submitted || userInfoForm.newPassword.$dirty\"><div ng-message=pattern>La contraseña debe tener minimo 6 caracteres.</div></div></md-input-container><div flex=45 hide-xs hide-sm hide-md></div></section><cargo77-role-selector layout=column flex-xs=90 ng-model=$ctrl.user.roles flex=45 permission company=$ctrl.user.cargoCompany permission-only=\"[\'CARGO_ADMIN\', \'CARRIER_OWNER\', \'SHIPPER_OWNER\', \'CARRIER_USER\', \'SHIPPER_USER\']\"></cargo77-role-selector><div flex-xs=90 flex=45 layout=column layout-align=space-around><section flex-xs=90 class=default-unit flex=45 layout-margin ng-if=\"$ctrl.user.roles.indexOf(\'DRIVER\') !== -1\"><md-input-container layout=row flex=100><datepicker date-format=MM/dd/yyyy date-set={{$ctrl.licenseValidUntilInit}} datepicker-class=datepicker><input placeholder=\"Caducidad de licencia\" ng-model=$ctrl.licenseValidUntil type=text readonly autocomplete=off></datepicker></md-input-container><h1 class=title>Unidad asignada por defecto</h1><cargo77-vehicle-search-selector ng-if=$ctrl.companyVehicles ng-model=$ctrl.user.defaultVehicle form-reference=userInfoForm vehicles=$ctrl.companyVehicles cargo-company-id=$ctrl.user.cargoCompany.id></cargo77-vehicle-search-selector></section><section ng-if=$ctrl.user.phoneAuthentication.code layout-margin class=phone-authentication><div layout=row><div>Código: {{$ctrl.user.phoneAuthentication.code}}</div><md-icon ng-if=$ctrl.isAuthenticationCodeExpired ng-click=$ctrl.onRefreshPhoneAutenticationCode()>refresh</md-icon></div></section></div><section class=cta-container layout-margin layout-wrap layout=row layout-align-sm=\"space-between center\" layout-align=\"end center\" ng-if=$ctrl.canEditUser><div flex-xs=100 flex-sm=45 flex=30><md-button type=submit ng-disabled=\"$ctrl.user.roles.length === 0\" class=\"register-button md-raised md-accent\">Guardar</md-button></div><div flex-xs=100 flex-sm=45 flex-md=45 flex=30 ng-hide=!$ctrl.onChangePasswordAction><md-button ng-click=$ctrl.onChangePasswordAction() class=\"change-password-button md-raised md-accent\">Cambiar Contraseña</md-button></div></section></form></section></md-card>");
$templateCache.put("app/components/users/components/createUser/create-user.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-user-card class=page-wrapper on-save-action=$ctrl.saveAction(user) flex=90></cargo77-upsert-user-card></md-content>");
$templateCache.put("app/components/users/components/editCurrentUser/edit-current-user.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-user-card class=page-wrapper on-change-password-action=$ctrl.onChangePassword() user=$ctrl.user on-save-action=$ctrl.saveAction(user) flex=90></cargo77-upsert-user-card></md-content>");
$templateCache.put("app/components/users/components/editUser/edit-user.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-user-card class=page-wrapper flex=90 user=$ctrl.user vehicle=$ctrl.vehicle permission permission-only=\"[\'CARGO_ADMIN\', \'CARRIER_OWNER\', \'CARRIER_USER\', \'SHIPPER_OWNER\', \'SHIPPER_USER\']\" on-delete-action=$ctrl.deleteAction(id) on-change-password-action=$ctrl.sendRecoveryEmail(user) on-save-action=\"$ctrl.saveAction(user, vehicle)\" on-refresh-authentication-code=$ctrl.refreshAuthenticationCode(phone)></cargo77-upsert-user-card></md-content>");
$templateCache.put("app/components/users/components/updatePassword/update-password.html","<md-content layout=row layout-wrap layout-align=\"center center\"><section flex-xs=90 flex=50><md-card layout=row layout-align=\"center center\"><section class=user-info flex=90 layout=row layout-align=\"center center\" layout-wrap><form name=userInfoForm ng-submit=$ctrl.saveChanges() flex=100 layout=row layout-align=\"space-around center\" layout-wrap><section class=page-wrapper flex-xs=90 flex=60><md-input-container class=\"md-icon-float md-block\"><label>Contraseña actual</label><md-icon md-font-icon>lock</md-icon><input ng-pattern=/^.{5,}$/ name=currentPassword ng-model=$ctrl.user.currentPassword type=password required><div ng-messages=userInfoForm.currentPassword.$error ng-if=\"userInfoForm.$submitted || userInfoForm.currentPassword.$dirty\"><div ng-message=pattern>La contraseña debe tener mínimo 6 caracteres.</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>Nueva contraseña</label><md-icon md-font-icon>lock</md-icon><input ng-pattern=/^.{6,}$/ name=newPassword ng-model=$ctrl.user.newPassword type=password required><div ng-messages=userInfoForm.newPassword.$error ng-if=\"userInfoForm.$submitted || userInfoForm.newPassword.$dirty\"><div ng-message=pattern>La contraseña debe tener mínimo 6 caracteres.</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>Confirmar nueva contraseña</label><md-icon md-font-icon>lock</md-icon><input ng-pattern=/^.{6,}$/ match-password=newPassword name=confirmPassword ng-model=$ctrl.confirmPassword type=password required><div ng-messages=userInfoForm.confirmPassword.$error ng-if=\"userInfoForm.$submitted || userInfoForm.confirmPassword.$dirty\"><div ng-message=passwordMatch class=\"message slide-left\">Las contraseñas no son iguales</div><div ng-message=pattern>La contraseña debe tener mínimo 6 caracteres.</div></div></md-input-container><div flex-xs=100 flex=100><md-button ng-disabled=userInfoForm.$invalid class=\"register-button md-raised md-accent\" type=submit>Guardar</md-button></div></section></form></section></md-card></section></md-content>");
$templateCache.put("app/components/users/components/userList/user-list.html","<cargo77-search-bar class=user-search-bar on-role-filter-change=$ctrl.filterUsersByRole(role) on-search-text-filter-change=$ctrl.updateSearchText(searchText) on-parent-company-filter-change=$ctrl.filterUsersByCompany(company)></cargo77-search-bar><md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><div flex=100 layout=column layout-align=\"center center\" class=report-empty ng-if=\"$ctrl.users.items.length === 0\" ng-show=!$ctrl.isLoadingUsers><div class=report-empty-title style=\"margin-top: 15%\">No hay resultados.</div></div><section ng-if=!$ctrl.isLoadingUsers class=\"page-wrapper list-container\" flex=100 class=\"list-container page-wrapper\" layout=row layout-wrap layout-align=\"start center\"><cargo77-user-list-card flex-xs=100 flex-sm=33 flex-md=33 flex=20 driver=driver user=user ng-repeat=\"user in $ctrl.users.items\" ui-sref=\"cargo.editUser({id: user.id})\"></cargo77-user-list-card></section><div ng-show=\"$ctrl.users.busy || $ctrl.isLoadingUsers\" layout-align=\"center center\" layout=column flex=100><md-progress-circular md-mode=indeterminate class=\"md-accent md-hue-1\"></md-progress-circular><span>Cargando...</span></div><div flex=100 layout=column layout-align=\"center center\" ng-show=!$ctrl.isLoadingUsers ng-if=!$ctrl.users.isListEnded><md-button class=\"md-accent md-hue-1\" ng-click=$ctrl.users.nextPage()>Cargar más</md-button></div><section><cargo77-fab-menu></cargo77-fab-menu></section></md-content>");
$templateCache.put("app/components/vehicles/components/common/upsert-vehicle-card.html","<md-card layout=row layout-wrap layout-align=\"space-between center\"><section class=vehicle-image flex-xs=100 flex=40 layout=column layout-align=\"space-between center\"><div ngf-drop ng-model=$ctrl.picFile ngf-pattern=image/* class=cropArea><div class=photo ng-style=\"{\'background-image\': \'url(\'+$ctrl.getEncodedURI($ctrl.vehicle.photoURL)+\')\'}\" ng-if=\"$ctrl.vehicle.photoURL && !$ctrl.picFile\"></div><div class=icon ng-if=\"!$ctrl.vehicle.photoURL && !$ctrl.picFile\" layout=row layout-align=\"center start\"><md-icon flex md-font-icon>directions_bus</md-icon></div><img-crop image=\"$ctrl.picFile | ngfDataUrl\" ng-if=$ctrl.picFile result-image-size=250 area-type=square ng-init=\"$ctrl.photo = \'\'\" result-image=$ctrl.photo></img-crop></div><span class=warning><sup>*</sup>Tamaño máximo 4MB</span><md-button class=md-fab ngf-select ngf-max-size=4MB ng-model=$ctrl.picFile accept=image/*><md-icon md-font-icon>photo_camera</md-icon></md-button></section><section class=vehicle-info flex-xs=100 flex=60 layout=column layout-align=\"space-around center\" layout-wrap><section ng-if=$ctrl.onDeleteAction flex=100 layout=row class=vehicle-status-management-menu><div ng-hide=$ctrl.vehicle.isActive class=vehicle-status-badge><div>Desactivado</div></div><md-menu><md-buton class=vehicle-status-dropdown-button ng-click=\"$ctrl.toggleManagementMenu($mdOpenMenu, $event)\"><md-icon>more_vert</md-icon></md-buton><md-menu-content><md-menu-item ng-if=$ctrl.vehicle.isActive><md-button ng-click=$ctrl.changeVehicleStatus(false)>Desactivar vehículo</md-button></md-menu-item><md-menu-item ng-if=!$ctrl.vehicle.isActive><md-button ng-click=$ctrl.changeVehicleStatus(true)>Activar vehículo</md-button></md-menu-item><md-menu-item><md-button ng-click=$ctrl.deleteVehicle() class=delete>Eliminar vehículo</md-button></md-menu-item></md-menu-content></md-menu></section><form name=vehicleInfo flex=100 layout=row ng-submit=$ctrl.saveChanges() layout-align=\"space-around center\" layout-wrap><div flex-xs=90 flex=95 class=\"md-icon-float md-block\" layout=row><md-icon class=company-icon md-font-icon>account_balance</md-icon><cargo77-company-selector ng-model=$ctrl.vehicle.ownerCompany children-type=CARRIER form-reference=vehicleInfo required></cargo77-company-selector></div><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block\"><label>Marca</label><md-icon md-font-icon>directions_bus</md-icon><input name=brand required ng-model=$ctrl.vehicle.brand type=text autocomplete=off><div class=errors ng-messages=vehicleInfo.brand.$error><div ng-message=required>La marca del vehículo es requerida.</div></div></md-input-container><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block\"><label>Modelo</label><md-icon md-font-icon>bookmark</md-icon><input name=model ng-model=$ctrl.vehicle.model type=text autocomplete=off></md-input-container><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block\"><label>Año</label><md-icon md-font-icon>date_range</md-icon><input ng-pattern=/^([0-9]){4}$/ required name=vehicleYear ng-model=$ctrl.vehicle.year type=number><div ng-messages=vehicleInfo.vehicleYear.$error><div ng-message=pattern>El año debe contener 4 digitos</div><div ng-message=required>El año del vehículo es requerido.</div></div></md-input-container><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block\"><label>Placa</label><md-icon md-font-icon>call_to_action</md-icon><input ng-pattern=/^([A-za-z-0-9]){3}([0-9]){3,4}$/ name=vehiclePlate required ng-model=$ctrl.vehicle.plate type=text autocomplete=off><div class=errors ng-messages=vehicleInfo.vehiclePlate.$error><div ng-message=pattern>La placa debe tener formato ABC1234.</div><div ng-message=required>La placa del vehículo es requerida.</div></div></md-input-container><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block\"><label>Carga máxima (toneladas)</label><md-icon md-font-icon>line_weight</md-icon><input max=100 required name=maxSize ng-model=$ctrl.vehicle.maxSize type=number><div class=errors ng-messages=vehicleInfo.maxSize.$error><div ng-message=required>Debe ingresar la carga máxima del vehículo.</div><div ng-message=max>La carga máxima es de 100 toneladas</div></div></md-input-container><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block\"><md-icon md-font-icon>label</md-icon><label>Tipo</label><md-select required name=type ng-model=$ctrl.vehicle.type><md-option ng-repeat=\"type in $ctrl.vehicleTypes\" value={{type.label}}>{{type.title |uppercase}}</md-option></md-select><div class=errors ng-messages=vehicleInfo.type.$error><div ng-message=required>Debe seleccionar el tipo de vehículo.</div></div></md-input-container><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block license-valid-until\" layout=row><label>Vencimiento de matrícula</label><md-icon md-font-icon>payment</md-icon><datepicker date-format=MM/dd/yyyy date-set={{$ctrl.plateValidUntilInit}} datepicker-class=datepicker><input placeholder=\"No definido\" ng-model=$ctrl.plateValidUntil type=text readonly autocomplete=off></datepicker></md-input-container><md-input-container flex-xs=90 flex=45 class=\"md-icon-float md-block license-valid-until\" layout=row><label>Vencimiento del seguro</label><md-icon md-font-icon>event</md-icon><datepicker date-format=MM/dd/yyyy date-set={{$ctrl.insuranceValidUntilInit}} datepicker-class=datepicker><input placeholder=\"No definido\" ng-model=$ctrl.insuranceValidUntil type=text readonly autocomplete=off></datepicker></md-input-container><span class=\"cta-container trailer-container\" layout=row layout-align=\"start start\"><md-input-container class=trailer-input ng-if=$ctrl.vehicle.ownerCompany.id flex-xs=90 flex=45 class=\"md-icon-float md-block\" layout-align=start><md-icon md-font-icon>rv_hookup</md-icon><label>Arrastre por defecto</label><md-select ng-click=$ctrl.filterTrailers() name=trailer ng-value=$ctrl.vehicle.defaultTrailerId ng-model=$ctrl.vehicle.defaultTrailerId><md-option value=\"\">Ninguno</md-option><md-option ng-repeat=\"trailer in $ctrl.trailers\" value={{trailer.id}}>{{trailer.name}}</md-option></md-select></md-input-container></span><div class=cta-container layout=row layout-padding layout-wrap layout-align=\"end center\"><div flex-xs=100 flex=30><md-button type=submit ng-disabled=\"\" class=\"register-button md-raised md-accent\">Guardar</md-button></div></div></form></section></md-card>");
$templateCache.put("app/components/vehicles/components/createVehicle/create-vehicle.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-vehicle-card class=page-wrapper on-save-action=$ctrl.saveAction(vehicle) flex=90></cargo77-upsert-vehicle-card></md-content>");
$templateCache.put("app/components/vehicles/components/editVehicle/edit-vehicle.html","<md-content layout=row layout-wrap layout-align=\"center center\"><cargo77-upsert-vehicle-card class=page-wrapper flex=90 vehicle=$ctrl.vehicle permission permission-only=\"[\'CARGO_ADMIN\', \'CARRIER_OWNER\', \'CARRIER_USER\']\" on-delete-action=$ctrl.deleteAction(id) on-save-action=$ctrl.saveAction(vehicle)></cargo77-upsert-vehicle-card></md-content>");
$templateCache.put("app/components/vehicles/components/vehicleList/vehicle-list.html","<cargo77-search-bar on-search-text-filter-change=$ctrl.updateSearchText(searchText) on-parent-company-filter-change=$ctrl.filterVehiclesByCompany(company) company-type=CARRIER></cargo77-search-bar><md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><div flex=100 layout=column layout-align=\"center center\" class=report-empty ng-if=\"$ctrl.vehicles.items.length === 0\" ng-show=!$ctrl.isLoadingVehicles><div class=report-empty-title style=\"margin-top: 15%\">No hay resultados.</div></div><section class=\"list-container page-wrapper\" layout=row layout-wrap layout-align=\"start center\"><cargo77-vehicle-list-card flex-xs=100 flex-sm=33 flex-md=33 flex=20 vehicle=vehicle ng-repeat=\"vehicle in $ctrl.vehicles.items\" ui-sref=\"cargo.editVehicle({id: vehicle.id})\"></cargo77-vehicle-list-card></section><div ng-show=\"$ctrl.vehicles.busy || $ctrl.isLoadingVehicles\" layout-align=\"center center\" layout=column flex=100><md-progress-circular md-mode=indeterminate class=\"md-accent md-hue-1\"></md-progress-circular><span>Cargando...</span></div><div flex=100 layout=column layout-align=\"center center\" ng-show=!$ctrl.isLoadingVehicles ng-if=!$ctrl.vehicles.isListEnded><md-button class=\"md-accent md-hue-1\" ng-click=$ctrl.vehicles.nextPage()>Cargar más</md-button></div><section><cargo77-fab-menu></cargo77-fab-menu></section></md-content>");
$templateCache.put("app/components/common/route-with-details-selector/route-locations-selector/segment-location-selector/segment-location-selector.html","<section class=location-selector-section layout=row flex=100><div class=location-selector-main-container flex-gt-sm=50 flex=100 layout=row layout-align=space-between><div class=location-container flex=90><md-select ng-change=\"$ctrl.changePoint(\'location\')\" ng-model=$ctrl.location placeholder=Ubicación><md-select-header class=select-header><input name=search ng-model=$ctrl.search placeholder=Buscar... type=text ng-keydown=$event.stopPropagation() autocomplete=off class=\"header-searchbox md-text\"></md-select-header><md-option ng-repeat=\"location in $ctrl.locations | filter: { name : $ctrl.search } | orderBy: \'name\'\" ng-value=\"{name: location.name, id: location.id }\">{{location.name}}</md-option><div flex=100 layout=column layout-align=\"center center\" class=search-empty ng-if=\"($ctrl.locations | filter: $ctrl.search).length === 0\"><div class=report-empty-title style=\"margin-top: 2%\">No hay resultados</div><div class=report-empty-title ng-if=\"$ctrl.locations.length > 0\">para \"{{$ctrl.search}}\"</div></div></md-select></div><md-icon ng-click=$ctrl.deletePoint($ctrl.point) ng-if=$ctrl.mayPointBeDeleted md-font-icon>clear</md-icon></div></section>");
$templateCache.put("app/components/common/route-with-details-selector/route-segment-details/segment-details/segment-details.html","<section class=segment-details-container flex=100 layout=column><div class=segment-description><strong ng-if=\"$ctrl.segment.from && $ctrl.segment.to\">De {{$ctrl.segment.from.name}} a {{$ctrl.segment.to.name}}</strong> <strong ng-if=\"$ctrl.segment.fromLocationId && $ctrl.segment.toLocationId\">{{$ctrl.segment.description}}</strong></div><div layout=row><div class=datepicker-container flex=20 flex-xs=100 flex-md=100><md-input-container><datepicker date-format=dd/MM/yyyy date-min-limit={{$ctrl.minDate}} datepicker-class=datepicker><input placeholder=Fecha ng-model=$ctrl.date ng-change=\"$ctrl.changeSegment(\'date\')\" type=text readonly autocomplete=off></datepicker></md-input-container></div><div class=time-container flex=30 flex-xs=100 flex-md=100><md-input-container><input placeholder=\"Hora (ej: 23:11)\" ng-model=$ctrl.time ng-change=\"$ctrl.changeSegment(\'time\')\" type=time autocomplete=off></md-input-container></div></div><section flex=100 layout=row layout-wrap layout-align=\"space-between center\" class=details><md-input-container class=segment-weight flex=30 flex-sm=100 flex-xs=100 layout=row><input type=number ng-change=\"$ctrl.changeSegment(\'weight\')\" name=weigth placeholder=\"Peso (kilogramos)\" ng-model=$ctrl.weight></md-input-container><md-input-container flex=65 flex-sm=100 flex-xs=100 layout=row><input ng-change=\"$ctrl.changeSegment(\'description\')\" name=details placeholder=Detalles ng-model=$ctrl.description autocomplete=off></md-input-container></section><cargo77-add-extra-fields-selector ng-if=$ctrl.carrierCompanyId flex=100 carrier-company-id=$ctrl.carrierCompanyId on-change-fields=$ctrl.changeExtraField(extraFields) on-saving-segment-files=\"$ctrl.onSavingSegmentFiles(saved, saving)\" on-are-valid-extra-field-change=$ctrl.areValidExtraFieldsChange(areValidExtraFields) segment=$ctrl.segment section=\"\'SEGMENT\'\"></cargo77-add-extra-fields-selector></section>");
$templateCache.put("app/components/companies/components/common/fieldCard/upsert-company-field-card.html","<md-card layout=row layout-align=\"space-between center\" layout-wrap><section class=field-info flex-xs=90 flex=100 layout=column layout-align=\"space-around center\" layout-wrap><section ng-if=$ctrl.onDeleteAction flex=100 layout=row class=field-status-management-menu><div ng-hide=$ctrl.field.isActive class=field-status-badge><div>Desactivado</div></div><md-menu><md-buton class=field-status-dropdown-button ng-click=\"$ctrl.toggleManagementMenu($mdOpenMenu, $event)\"><md-icon>more_vert</md-icon></md-buton><md-menu-content><md-menu-item ng-if=$ctrl.field.isActive><md-button ng-click=$ctrl.changeFieldStatus(false)>Desactivar campo</md-button></md-menu-item><md-menu-item ng-if=!$ctrl.field.isActive><md-button ng-click=$ctrl.changeFieldStatus(true)>Activar campo</md-button></md-menu-item></md-menu-content></md-menu></section><form class=field-info-form name=fieldInfoForm ng-submit=$ctrl.saveChanges() ng-class=\"{profile: !$ctrl.onDeleteAction }\" flex=100 layout=row layout-align=\"space-around center\" layout-wrap><md-input-container flex-xs=90 flex-md=90 flex-sm=90 flex=40 class=\"md-icon-float md-block\"><label>Nombre de Campo</label><input ng-model=$ctrl.field.name name=name required type=text><div ng-messages=fieldInfoForm.name.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><md-input-container flex-xs=90 flex=40 class=\"md-icon-float md-block\"><label>Sección</label><md-select required name=section ng-model=$ctrl.field.section ng-disabled=!$ctrl.isCreating><md-option class=cargo77-upsert-vehicle-card ng-repeat=\"type in $ctrl.sectionTypes\" value={{type.label}}>{{type.title |uppercase}}</md-option></md-select><div class=errors ng-messages=fieldInfoForm.section.$error><div ng-message=required>Debe seleccionar la sección.</div></div></md-input-container><md-input-container flex-xs=90 flex=40 class=\"md-icon-float md-block\"><label>Tipo</label><md-select required name=inputType ng-model=$ctrl.field.inputType ng-disabled=!$ctrl.isCreating ng-change=$ctrl.changeInputType($ctrl.field.inputType)><md-option class=cargo77-upsert-vehicle-card ng-repeat=\"type in $ctrl.inputTypes\" value={{type.label}}>{{type.title |uppercase}}</md-option></md-select><div class=errors ng-messages=fieldInfoForm.inputType.$error><div ng-message=required>Debe seleccionar el tipo.</div></div></md-input-container><md-input-container flex=40 flex-md=90 flex-sm=90 flex-xs=90 class=\"md-icon-float md-block\"></md-input-container><cargo77-multiple-text-selector ng-if=\"$ctrl.field.inputType === \'DROPDOWN\' \" flex=40 flex-md=90 flex-sm=90 flex-xs=90 on-change-options=$ctrl.onOptionChange(options) options=$ctrl.field.dropdownOptions></cargo77-multiple-text-selector><md-input-container flex=40 flex-md=90 flex-sm=90 flex-xs=90 class=\"md-icon-float md-block\"></md-input-container><md-input-container flex-xs=90 flex=90 class=\"md-icon-float md-block\" ng-repeat=\"optionalField in $ctrl.optionalFields\" ng-show=\"(optionalField.label === \'willSendNotificationOnChange\' && $ctrl.field.inputType === \'FILE\') || optionalField.label !== \'willSendNotificationOnChange\'\"><md-checkbox flex ng-model=$ctrl.field[optionalField.label] ng-checked=\"optionalField.label === \'isAlwaysVisible\' && $ctrl.field.section === \'ORDER\'\" ng-disabled=\"optionalField.label === \'isAlwaysVisible\' && $ctrl.field.section === \'ORDER\'\"><span class=field-checkbox-title>{{ optionalField.title }}</span></md-checkbox><div class=field-checkbox-description>{{ optionalField.description }}</div></md-input-container><section class=cta-container layout-margin layout-wrap layout=row layout-align-sm=\"space-between center\" layout-align=\"end center\" flex-sm=100><div flex-xs=100 flex-sm=45 flex=30><md-button type=submit class=\"register-button md-raised md-accent\" ng-disabled=fieldInfoForm.$invalid>Guardar</md-button></div></section></form></section></md-card>");
$templateCache.put("app/components/companies/components/common/multiple-text-selector/multiple-text-selector.html","<section class=dropdown-options-container flex=100 layout=column>Valores posibles para el selector (Dropdown)<div flex=100><cargo77-text-selector class=cargo77-segment-selector option=option ng-repeat=\"option in $ctrl.currentOptions track by option.index\" on-change-option=$ctrl.changeOption on-delete-option=$ctrl.deleteOption></cargo77-text-selector></div><p class=missing-fields-button-error ng-if=$ctrl.invalidFields>* Por favor complete los campos previos antes de agregar otra opción</p><section layout=row layout-align=\"start start\"><md-button flex=95 class=add-new-option-to-dropdown-button ng-click=$ctrl.addNewOption()>Agregar nueva opción</md-button></section></section>");
$templateCache.put("app/components/companies/components/common/profileCard/upsert-company-card.html","<md-card layout=row layout-align=\"space-between center\" layout-wrap><section class=company-image flex-xs=90 flex=40 layout=column layout-align=\"space-between center\"><div ngf-drop ng-model=$ctrl.picFile ngf-pattern=image/* class=cropArea><div class=photo ng-style=\"{\'background-image\': \'url(\'+$ctrl.getEncodedURI($ctrl.company.photoURL)+\')\'}\" ng-if=\"$ctrl.company.photoURL && !$ctrl.picFile\"></div><div class=icon ng-if=\"!$ctrl.company.photoURL && !$ctrl.picFile\" layout=row layout-align=\"center start\"><md-icon flex md-font-icon>account_balance</md-icon></div><img-crop image=\"$ctrl.picFile | ngfDataUrl\" ng-if=$ctrl.picFile result-image-size=250 area-type=square ng-init=\"$ctrl.photo = \'\'\" result-image=$ctrl.photo></img-crop></div><span class=warning><sup>*</sup>Tamaño máximo 4MB</span> <input type=file class=input-fab ngf-select ngf-max-size=4MB ng-model=$ctrl.picFile accept=image/*><md-button class=md-fab><md-icon md-font-icon>photo_camera</md-icon></md-button></section><section class=company-info flex-xs=90 flex=60 layout=column layout-align=\"space-around center\" layout-wrap><section ng-if=$ctrl.onDeleteAction flex=100 layout=row class=company-status-management-menu><div ng-hide=$ctrl.company.isActive class=company-status-badge><div>Desactivado</div></div><md-menu><md-buton class=company-status-dropdown-button ng-click=\"$ctrl.toggleManagementMenu($mdOpenMenu, $event)\"><md-icon>more_vert</md-icon></md-buton><md-menu-content><md-menu-item ng-if=$ctrl.company.isActive><md-button ng-click=$ctrl.changeCompanyStatus(false)>Desactivar compañía</md-button></md-menu-item><md-menu-item ng-if=!$ctrl.company.isActive><md-button ng-click=$ctrl.changeCompanyStatus(true)>Activar compañía</md-button></md-menu-item><md-menu-item><md-button ng-click=$ctrl.deleteCompany()>Eliminar compañía</md-button></md-menu-item></md-menu-content></md-menu></section><form ng-submit=$ctrl.saveChanges() ng-class=\"{profile: !$ctrl.onDeleteAction }\" name=companyInfoForm flex=100 layout=row layout-align=\"space-around center\" layout-wrap><md-input-container flex-xs=90 flex-md=90 flex-sm=90 flex=45 class=\"md-icon-float md-block\" ng-if=!$ctrl.isCreating permission permission-only=\"\'CARGO_ADMIN\'\"><md-icon md-font-icon>account_balance</md-icon><input readonly ng-disabled=true ng-model=$ctrl.parentCompany.name></md-input-container><div ng-if=\"$ctrl.isCreating && $ctrl.userIsAdmin()\" class=company-selector flex-xs=90 flex-md=90 flex-sm=90 flex=45 layout=column><div layout=row><md-icon class=company-icon md-font-icon>account_balance</md-icon><cargo77-company-selector ng-model=$ctrl.selectedCompany selection=parentOnly form-reference=companyInfoForm required></cargo77-company-selector></div></div><md-input-container flex-xs=90 flex-md=90 flex-sm=90 flex=45 class=\"md-icon-float md-block\"><label>Nombre</label><md-icon md-font-icon>account_box</md-icon><input ng-model=$ctrl.company.name name=name required type=text><div ng-messages=companyInfoForm.name.$error><div ng-message=required>Este campo es obligatorio.</div></div></md-input-container><md-input-container flex-xs=90 flex-md=90 flex-sm=90 flex=45 class=\"md-icon-float md-block\"><label>RUC</label><md-icon md-font-icon>picture_in_picture</md-icon><input ng-pattern=/^([0-9]){3,13}$/ ng-model=$ctrl.company.documentNumber name=documentNumber type=text><div ng-messages=companyInfoForm.documentNumber.$error><div ng-message=pattern>Este campo debe contener solo números.</div></div></md-input-container><md-input-container flex-xs=90 flex-md=90 flex-sm=90 flex=45 class=\"phone-container md-icon-float md-block\"><label>Teléfono</label><md-icon md-font-icon>phone</md-icon><input international-phone-number ng-model=$ctrl.company.phone type=text></md-input-container><md-input-container flex-xs=90 flex-md=90 flex-sm=90 flex=45 class=\"md-icon-float md-block\"><label>Email</label><md-icon md-font-icon>email</md-icon><input class=email ng-pattern=/^.+@.+\\..+$/ name=email ng-model=$ctrl.company.email type=email></md-input-container><md-input-container flex-xs=90 flex-md=90 flex-sm=90 flex=45 class=\"md-icon-float md-block\"><label>Dirección</label><md-icon md-font-icon>place</md-icon><input class=email name=address ng-model=$ctrl.company.address type=text></md-input-container><md-input-container layout=row flex-xs=90 flex-md=90 flex-sm=90 flex=45 class=permission-valid-until ng-if=$ctrl.isCarrierCompany()><md-icon md-font-icon>event</md-icon><datepicker flex-xs=50 flex-md=50 flex-sm=50 flex=90 layout-align=left date-format=MM/dd/yyyy date-set={{$ctrl.permissionValidUntilInit}} datepicker-class=datepicker><input placeholder=\"Caducidad permiso de operación\" ng-model=$ctrl.permissionValidUntil type=text readonly autocomplete=off></datepicker></md-input-container><div flex-xs=90 flex-md=90 flex-sm=90 flex=45 layout=row layout-wrap ng-if=!!!$ctrl.company.type><div flex=100><label>Tipo de compañía:</label></div><div class=type-container flex-offset=5><md-radio-group ng-disabled=!$ctrl.isCreating ng-model=$ctrl.company.type><md-radio-button value=CARRIER>Transportista</md-radio-button><md-radio-button value=SHIPPER>Solicitante</md-radio-button></md-radio-group></div></div><div ng-if=false class=rating-container flex-offset-sm=5 flex-offset-md=5 flex-sm=90 flex-xs=100 flex=95 layout=row layout-wrap><span class=rating-icon flex-sm=5 flex-sm=5 flex=5 flex-xs=10><md-icon md-font-icon>star_rate</md-icon></span><span flex=30 flex-sm=50 flex-xs=50 flex-md=45 class=rating-label><label>Calificación de la empresa:</label></span><span flex=25 flex-sm=\"\" flex-xs=35 flex-md=25 class=rating-stars><ng-rate-it layout-fill min=0 max=5 read-only=true ng-model=$ctrl.company.score></ng-rate-it></span></div><md-input-container layout=row flex-xs=90 flex-md=90 flex-sm=90 flex=100 class=\"md-icon-float md-block\" ng-if=$ctrl.userIsAdmin() style=margin-left:20px><label ng-if=\"!$ctrl.company.logoFileName && !$ctrl.company.logoURL\" hide-xs>Logo del Sistema (max. 4Mb) - Recomendado (Formato: SVG - Tamaño: An. 410, Alt. 90)</label><div class=uploadFile layout=row><div class=file><input ng-if=\"!$ctrl.company.logoFileName && !$ctrl.company.logoURL\" placeholder={{$ctrl.company.name}} ng-model=$ctrl.value name=company type=file ngf-select=$ctrl.onFileSelect($files)></div><div class=progress><md-progress-circular md-mode=indeterminate ng-if=$ctrl.saving md-diameter=20px style=\"margin-right: 5px\" class=md-accent></md-progress-circular></div><div class=delete-file-button ng-if=\"!$ctrl.saving && $ctrl.company.logoFileName && $ctrl.showDeleteButton\"><md-tooltip md-direction=top>Eliminar archivo</md-tooltip><md-icon md-font-icon ng-click=\"$ctrl.removeFile(true, null)\">clear</md-icon></div></div><div layout=column ng-if=\"$ctrl.company.logoFileName && $ctrl.company.logoURL\"><p class=file-placeholder>Logo del Sistema (max. 4Mb)</p><div class=file-editor-secondary-row layout=row><a class=file-link target=_blank href={{$ctrl.company.logoURL}}>{{$ctrl.company.logoFileName}}</a><div class=file-editor-button><md-tooltip md-direction=top>Editar archivo</md-tooltip><md-icon md-font-icon ng-click=$ctrl.showFileInput($ctrl.company)>edit</md-icon></div><div class=delete-file-button><md-tooltip md-direction=top>Eliminar archivo</md-tooltip><md-icon md-font-icon ng-click=\"$ctrl.removeFile(true, $ctrl.company)\">clear</md-icon></div></div></div></md-input-container><section class=cta-container layout-margin layout-wrap layout=row layout-align-sm=\"space-between center\" layout-align=\"end center\" flex-sm=100><div flex-xs=100 flex-sm=45 flex=30><md-button type=submit class=\"register-button md-raised md-accent\" ng-disabled=$ctrl.saving>Guardar</md-button></div></section></form></section></md-card>");
$templateCache.put("app/components/companies/components/listCompanies/components/list-companies-card.html","<md-card md-ink-ripple=#607D8B layout=column><div class=photo-container layout=row layout-align=\"center center\"><div class=photo flex ng-if=$ctrl.company.photoURL ng-style=\"{\'background-image\': \'url(\'+$ctrl.getEncodedURI($ctrl.company.photoURL)+\')\', \'background-size\': \'cover\'}\"></div><md-icon flex ng-if=!$ctrl.company.photoURL md-font-icon>account_balance</md-icon></div><section class=info-section><h1 class=name>{{$ctrl.company.name}}</h1></section><section class=info layout=column><div layout=row class=company-type><div class=company-label ng-if=\"$ctrl.company.type === \'SHIPPER\'\">SOLICITANTE</div><div class=company-label ng-if=\"$ctrl.company.type === \'CARRIER\'\">TRANSPORTISTA</div></div><div class=phone layout=row layout-align=\"start center\"><md-icon md-font-icon>phone</md-icon><div flex=90>{{$ctrl.company.phone || \'Sin información\'}}</div></div><div class=email layout=row layout-align=\"start center\"><md-icon md-font-icon>email</md-icon><div flex=90 title={{$ctrl.company.email}}>{{$ctrl.company.email || \'Sin información\'}}</div></div><div class=email layout=row layout-align=\"start center\" ng-if=$ctrl.company.permissionValidUntil><md-icon md-font-icon>event</md-icon><div flex=90>Permiso: {{$ctrl.company.permissionValidUntil | date:\'dd-MMM-yyyy\'}}</div></div></section></md-card>");
$templateCache.put("app/components/companies/components/listFieldsByCompany/components/list-fields-by-company.html","<md-card layout=row layout-align=\"space-between center\" flex-xs=95 layout-wrap><h1 layout=column flex-xs=40 flex=50>Campos personalizados</h1><section class=switch-container layout=row flex=50 flex-xs=60 layout-wrap layout-align=\"end center\">Ver todos los campos<md-switch layout-align=\"end center\" ng-click=$ctrl.extraFields.viewAll ng-model=$ctrl.extraFields.viewAll aria-label=\"Ver campos inactivos\"></md-switch></section><section class=list-fields-container flex=100 layout=row layout-align=\"space-between center\"><div ng-if=\"$ctrl.company.extraFields.length === 0\">Seleccione <strong>AGREGAR</strong> para ingresar un campo</div><table ng-if=\"$ctrl.company.extraFields.length > 0\"><thead><tr><th>Nombre del Campo</th><th>Sección</th><th>Tipo</th><th>Opciones</th><th hide-xs>Valores Posibles</th><th>Acción</th></tr></thead><tbody><tr ng-if=\"orderField.isActive || $ctrl.extraFields.viewAll\" ng-repeat=\"orderField\n                  in $ctrl.company.extraFields | orderBy : [\'section\', \'name\'] track by orderField.id\"><td>{{ orderField.name }}</td><td>{{ $ctrl.getDataForExtraFields(\'orderExtraFields\', \'sectionTypes\', orderField.section) }}</td><td>{{ $ctrl.getDataForExtraFields(\'orderExtraFields\', \'inputTypes\', orderField.inputType) }}</td><td><ul><li ng-if=orderField.isAlwaysVisible>{{ $ctrl.getDataForExtraFields(\'orderExtraFields\', \'optionalFields\', \'isAlwaysVisible\') }}</li><li ng-if=orderField.isFieldForDriver>{{ $ctrl.getDataForExtraFields(\'orderExtraFields\', \'optionalFields\', \'isFieldForDriver\') }}</li><li ng-if=orderField.isRequired>{{ $ctrl.getDataForExtraFields(\'orderExtraFields\', \'optionalFields\', \'isRequired\') }}</li><li ng-if=orderField.isRequiredForDriver>{{ $ctrl.getDataForExtraFields(\'orderExtraFields\', \'optionalFields\', \'isRequiredForDriver\') }}</li><li ng-if=orderField.isVisibleInList>{{ $ctrl.getDataForExtraFields(\'orderExtraFields\', \'optionalFields\', \'isVisibleInList\') }}</li><li ng-if=orderField.willSendNotificationOnChange>{{ $ctrl.getDataForExtraFields(\'orderExtraFields\', \'optionalFields\', \'willSendNotificationOnChange\') }}</li></ul></td><td hide-xs><ol><li ng-repeat=\"option in orderField.dropdownOptions\"><p>{{ option }}</p></li></ol></td><td><md-button type=submit ui-sref=\"cargo.editFieldByCompany({id: orderField.id})\" title=Editar><md-icon md-font-icon>edit</md-icon></md-button><md-button id=activate-button type=submit class=\"md-raised md-primary\" ng-if=!orderField.isActive hide-xs ng-click=$ctrl.changeFieldStatus(orderField) title=Activar>Activar</md-button><md-button id=deactivate-button type=submit class=\"md-raised md-primary\" ng-if=orderField.isActive hide-xs ng-click=$ctrl.changeFieldStatus(orderField) title=Desactivar>Desactivar</md-button></td></tr></tbody></table></section><section class=cta-container layout-margin layout-wrap layout=row layout-align-sm=\"space-between center\" layout-align=\"end center\" flex-xs=90><div flex-xs=100 flex=100><md-button type=submit class=\"add-button md-raised md-accent\" ui-sref=cargo.createFieldByCompany()>Agregar</md-button></div></section></md-card>");
$templateCache.put("app/components/dashboard/components/dashboardGraphics/addDashboardGraphic/addDashboardGraphic.html","<md-card flex=100><div layout=row layout-align=\"space-between start\" style=\"padding-top: 5px\"><md-button class=\"md-raised md-accent md-icon-button\" ng-click=$ctrl.openDeleteGraphicModal()><md-icon md-font-icon>delete</md-icon></md-button><md-button class=\"md-raised md-accent md-icon-button\" ng-click=$ctrl.updateGraphic()><md-icon md-font-icon>autorenew</md-icon></md-button></div><div layout=row layout-wrap layout-align=\"center center\" ng-if=\"$ctrl.graphic.graphicType === $ctrl.barChart\" style=\"width: 100%; margin-top: 5px\"><highchart flex-md=100 flex=80 config=$ctrl.chartConfig></highchart></div></md-card>");
$templateCache.put("app/components/dashboard/components/dashboardGraphics/deleteGraphicModal/deleteGraphicModal.html","<md-dialog class=delete-graphic-modal layout=column><md-dialog-content layout=column layout-align=\"space-between center\"><div layout=column layout-wrap><h2>Eliminar Gráfico</h2><p style=\"text-align: left; font-size: 18px; margin-top: 0%\">¿Está seguro de realizar esta acción?</p></div><md-dialog-actions layout=row layout-align=\"center center\"><md-button ng-click=$ctrl.deleteGraphic() ng-disabled=$ctrl.isDeleting class=\"md-raised md-accent\">Aceptar</md-button><md-button ng-click=$ctrl.closeDialog() ng-disabled=$ctrl.isDeleting class=md-raised>Cancelar</md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/components/locations/components/common/upsert-card/upsert-location-card.html","<md-content layout=row layout-wrap layout-align=\"center start\"><md-card layout=row layout-padding layout-align=\"space-around center\"><section class=location-info flex-xs=90 flex=100 layout=column layout-align=\"space-around center\" layout-wrap><section ng-if=$ctrl.onDeleteAction flex=100 layout=row class=location-status-management-menu><md-menu><md-buton class=location-status-dropdown-button ng-click=\"$ctrl.toggleManagementMenu($mdOpenMenu, $event)\"><md-icon>more_vert</md-icon></md-buton><md-menu-content><md-menu-item><md-button ng-click=$ctrl.deleteLocation() class=delete>Eliminar ubicación</md-button></md-menu-item></md-menu-content></md-menu></section><form class=location-form name=locationInfo flex=100 layout=row ng-submit=$ctrl.saveChanges() layout-align=\"space-around center\" layout-wrap><div class=location-company-selector flex-xs=90 flex=40><md-icon class=company-icon md-font-icon>account_balance</md-icon><cargo77-company-selector children-type=SHIPPER ng-model=$ctrl.location.company form-reference=locationInfo required></cargo77-company-selector></div><md-input-container flex-xs=90 flex=40 class=\"md-icon-float md-block\"><label>Nombre</label><md-icon class=name-icon md-font-icon>place</md-icon><input required name=name required ng-model=$ctrl.location.name><div class=errors ng-messages=locationInfo.name.$error><div ng-message=required>El nombre de la ubicación es requerido.</div></div></md-input-container><md-input-container flex=90 class=\"md-icon-float md-block turn-checkbox\"><md-checkbox flex required ng-model=$ctrl.location.areTurnsRequired><span class=type>Esta ubicación requiere turnos</span></md-checkbox></md-input-container><cargo77-location-selector show-required-error=$ctrl.locationError flex=90 on-location-change=$ctrl.onExactLocationChange(location) location=$ctrl.location></cargo77-location-selector><div flex=45></div><div class=cta-container layout=row layout-padding layout-wrap layout-align=\"end center\"><div flex-xs=100 flex=30><md-button ng-click=$ctrl.saveLocation() type=submit ng-disabled=$ctrl.areFieldsValid class=\"register-button md-raised md-accent\">Guardar</md-button></div></div></form></section></md-card></md-content>");
$templateCache.put("app/components/locations/components/locationsList/components/locations-list-card.html","<md-card layout=row md-ink-ripple=#607D8B><section layout=column flex=35><img ng-if=$ctrl.location.company.photoURL class=company-logo ng-src={{$ctrl.getEncodedURI($ctrl.location.company.photoURL)}}><md-icon ng-if=!$ctrl.location.company.photoURL md-font-icon>account_balance</md-icon><p class=company-name>{{$ctrl.location.company.name}}</p></section><section flex=65 flex-sm=100 flex-xs=60 layout=column class=\"flex-100 info-section\" layout-align=\"space-around start\"><div class=name>{{$ctrl.location.name}}</div><div class=locality>{{$ctrl.location.address.address}}</div></section></md-card>");
$templateCache.put("app/components/orders/components/carrierOrderList/components/carrier-order-list-card.html","<md-card md-ink-ripple=#607D8B ng-click=$ctrl.readOrder() ng-class=\"{\'is-read\': $ctrl.isOrderRead()}\" flex=100 layout=row layout-align=\"space-between center\" layout-wrap layout-fill><div flex=100 layout=row layout-wrap layout-align=\"start center\" class=scheduled-date-and-person-company><div flex=90 flex-md=80 flex-sm=80 flex-xs=70 layout=row><div class=scheduled-date>{{$ctrl.order.scheduledDate | date:\'MMMM dd yyyy\'}}</div><div ng-if=$ctrl.order.cargoUser.cargoCompany><span>{{::$ctrl.order.cargoUser.cargoCompany.name}}</span></div></div><div flex-xs=30 flex=10 flex-md=20 flex-sm=20 layout-wrap layout=column layout-align-md=\"space-around end\" layout-align-xs=\"end center\" layout-align=\"space-around center\" class=cta-section><div class=\"state offer-sent\" ng-if=$ctrl.order.offers.length><div>OFERTA ENVIADA</div></div><div class=\"state processing-payment\" ng-if=$ctrl.isProcessingPayment($ctrl.order)><div>PROCESANDO PAGO</div></div></div></div><div flex=100 layout=row layout-wrap><div flex=50 flex-xs=100 layout=row layout-align=\"start center\"><div layout=column class=order-details><div class=order-iterator ng-repeat=\"segmentItem in $ctrl.order.route.segments\"><div class=direction-title layout=row layout-align=\"start start\"><div layout=row><div class=segment>{{segmentItem.description}}</div></div></div><div class=distance-weight-details layout=row><div>{{segmentItem.distance.text}} {{segmentItem.details.weight ? (\',\' + segmentItem.details.weight + \'kilogramos\') : \'\'}}</div></div></div></div></div><div flex=1 hide-xs><md-divider class=vertical-divider></md-divider></div><div flex=40 hide-xs layout=column class=history-accepted-orders-container><div class=location-iterator ng-repeat=\"locationItem in $ctrl.order.route.locations\" layout-wrap><div layout=row layout-align=\"space-between start\" flex=100 layout-wrap><div flex=50 flex-md=100 flex-sm=100 class=location-name>{{locationItem.location.name}} - Ingreso</div><div flex=50 flex-md=100 flex-sm=100 class=planned-date>Planificado {{$ctrl.getFormattedStringTime($ctrl.order.scheduledDate, locationItem.datetime)}}</div></div></div></div><div flex-xs=100 flex=9 layout=column layout-align=\"space-around center\" layout-align-xs=\"end start\"><div class=order-price ng-if=\"$ctrl.order.offers.length > 0\">{{::$ctrl.order.offers[0].price | currency}}</div><div class=order-price ng-if=$ctrl.order.processingPaymentPrice>{{::$ctrl.order.processingPaymentPrice | currency}}</div></div></div><div layout=row flex=100 layout-align=\"end center\" class=code-details><div class=code-label>Código único:</div>#{{$ctrl.order.id}}</div></md-card>");
$templateCache.put("app/components/orders/components/common/assignationDetailCard/assignation-detail-card.html","<md-card class=assignation-detail-card layout=row layout-wrap layout-align=\"space-around center\"><section flex=60 flex-sm=100 flex-xs=50 layout=column layout-align=\"center start\"><div layout=column layout-align=\"center center\" class=card-title><h2><strong>{{$ctrl.title}}</strong></h2></div></section><section flex=40 flex-sm=100 flex-xs=40 layout=column layout-align=\"space-around end\" layout-align-sm=\"center center\" layout-align-xs=\"center center\" class=info-section><md-button ng-if=$ctrl.segmentsWithoutInfo.length ng-disabled=\"!$ctrl.company && true\" ng-click=$ctrl.assigment() layout-margin flex=40 flex-xs=100 class=\"md-raised md-accent create-accepted-order-button\">Asignar</md-button><md-button ng-if=!$ctrl.segmentsWithoutInfo.length class=reassignation-text layout-margin ng-click=$ctrl.assigment() ng-disabled=$ctrl.disableAssignment>Reasignar</md-button></section><section flex=100 layout=column layout-align=\"center center\" ng-if=!$ctrl.info.length class=without-assignation>Sin Asignación(es)</section><section flex=100 layout=column ng-repeat=\"data in $ctrl.info | orderBy: \'segment\'\"><section flex=100 layout=row layout-wrap layout-align=\"space-around center\" class=individual-data><section flex=30 flex-sm=100 flex-xs=35 layout=column layout-align=\"center center\"><div class=photo-container ng-style=\"{\'background-image\': \'url(\'+$ctrl.getEncodedURI(data.photoURL)+\')\'}\" layout=row layout-align=\"center center\"><md-icon ng-if=!data.photoURL md-font-icon>{{$ctrl.icon}}</md-icon></div></section><section flex=65 flex-sm=100 flex-xs=60 layout=column layout-align-sm=\"center center\" layout-align=\"space-around start\" class=info-section><h3><strong>{{data.name}}</strong></h3><div class=phone>{{data.phone}}</div><div class=brand>{{data.brand}} {{data.year}}</div><div class=trailerType>{{$ctrl.getTrailerTypeName(data.trailerType)}}</div><div ng-repeat=\"segment in data.segments\"><div>{{ segment.name }}</div></div></section></section></section><section flex=100 layout=column ng-if=\"$ctrl.info.length && $ctrl.segmentsWithoutInfo.length\"><section flex=100 layout=row layout-wrap layout-align=\"space-around center\"><section flex=30 flex-sm=100 flex-xs=35 layout=column layout-align=\"center center\"><div class=warning-icon-container layout=column layout-align=\"center center\"><md-icon md-font-icon>warning</md-icon></div></section><section flex=65 flex-sm=100 flex-xs=60 layout=column layout-align-sm=\"center center\" layout-align=\"space-around start\" class=info-section><h3><strong>Falta asignación para</strong></h3><div ng-repeat=\"emptySegment in $ctrl.segmentsWithoutInfo\"><div>{{ emptySegment.name }}</div></div></section></section></section></md-card>");
$templateCache.put("app/components/orders/components/common/assignationModal/assignationModal.html","<md-dialog layout=column class=assignation-modal><h3 layout=row>Asignar {{$ctrl.getContextInfo(\'main\', \'title\')}} {{$ctrl.getResourceName()}}</h3><div flex=100 layout=row layout-wrap layout-align=\"space-around center\"><div flex=70 layout=column><md-radio-group ng-model=$ctrl.selectedSegment layout-margin><md-radio-button md-no-ink value=all class=md-primary>Todo el flete</md-radio-button><md-radio-button md-no-ink ng-repeat=\"segment in $ctrl.order.route.segments\" value={{segment.id}} class=md-primary>{{segment.description}}</md-radio-button></md-radio-group></div><div layout-align=\"center start\" flex=30 layout=column><div ng-style=\"{\'background-image\': \'url(\'+ $ctrl.getEncodedURI($ctrl.mainResource.photoURL)+\')\'}\" class=\"photo-container main-resource-photo\" layout=row><md-icon class=no-main-resource-icon ng-if=!$ctrl.mainResource.photoURL md-font-icon>{{$ctrl.getContextInfo(\'main\', \'iconLabel\')}}</md-icon></div></div></div><div class=details-input-container layout=row><md-input-container class=details-input flex=90><textarea ng-model=$ctrl.assignationDetails placeholder=Notas></textarea></md-input-container></div><div ng-if=\"$ctrl.trailer || $ctrl.secondaryResource\"><div class=order-title><h3>Opciones</h3></div><div ng-if=$ctrl.secondaryResource layout=column class=secondary-resource-section><md-checkbox ng-model=$ctrl.shouldAssignSecondaryResource>Asignar también {{$ctrl.getContextInfo(\'secondary\', \'title\')}} relacionado</md-checkbox><div layout=row><div flex=20 flex-gt-sm=10 class=secondary-resource-image-container><div ng-style=\"{\'background-image\': \'url(\'+ $ctrl.getEncodedURI($ctrl.secondaryResource.photoURL)+\')\'}\" class=\"photo-container secondary-resource-photo\" layout=row><md-icon class=no-icon ng-if=!$ctrl.secondaryResource.photoURL md-font-icon>{{$ctrl.getContextInfo(\'secondary\', \'iconLabel\')}}</md-icon></div></div><div ng-if=\"$ctrl.context === \'driver\'\" layout=column class=secondary-resource-information flex=70 flex-gt-sm=80><p>{{$ctrl.secondaryResource.plate | uppercase}}</p><p>{{$ctrl.secondaryResource.brand}} {{$ctrl.secondaryResource.model}}</p></div><div ng-if=\"$ctrl.context === \'vehicle\'\" layout=column class=secondary-resource-information flex=70 flex-gt-sm=80><p>{{$ctrl.secondaryResource.firstName}} {{$ctrl.secondaryResource.lastName}}</p><p>{{$ctrl.secondaryResource.phone}}</p></div></div></div><div ng-if=$ctrl.trailer layout=column class=default-trailer-section><md-checkbox ng-model=$ctrl.shouldAssignTrailer>Asignar también arrastre relacionado</md-checkbox><div layout=row><div flex=20 flex-gt-sm=10 class=trailer-image-container><div ng-style=\"{\'background-image\': \'url(\'+ $ctrl.getEncodedURI($ctrl.trailer.photoURL)+\')\'}\" class=\"photo-container secondary-resource-photo\" layout=row><md-icon class=no-driver-icon ng-if=!$ctrl.trailer.photoURL md-font-icon>rv_hookup</md-icon></div></div><div layout=column class=trailer-information flex=70 flex-gt-sm=80><p>{{$ctrl.trailer.name}}</p><p>{{$ctrl.trailer.identification}}</p></div></div></div></div><div class=assign-button-container layout=row><md-button ng-click=$ctrl.assignResources() class=\"assign-button md-accent md-raised\">ASIGNAR</md-button></div></md-dialog>");
$templateCache.put("app/components/orders/components/common/makeOfferCard/make-offer-card.html","<md-card><md-card-title><md-card-title-text><h1 class=title>Realizar oferta</h1></md-card-title-text></md-card-title><form flex=100 name=assignForm layout=row layout-wrap layout-align=\"space-between center\"><section flex=30 flex-sm=100 flex-xs=100 layout=row layout-align=\"start center\"><md-icon class=account-icon flex=10 flex-sm=5 md-font-icon>account_box</md-icon><md-autocomplete flex class=auto-complete-box md-selected-item=$ctrl.offer.driver md-selected-item-change=$ctrl.setDefaultVehicle(item) md-search-text=$ctrl.driverSearchText md-items=\"item in $ctrl.drivers | filter: $ctrl.driverSearchText || undefined\" md-item-text=\"item.firstName + \'  \' + item.lastName\" md-min-length=0 md-floating-label=Conductor placeholder=Conductor><md-item-template><span style=\"text-transform: capitalize\" md-highlight-text=$ctrl.driverSearchText md-highlight-flags=^i>{{item.firstName}}</span> <span style=\"text-transform: capitalize\" md-highlight-text=$ctrl.driverSearchText md-highlight-flags=^i>{{item.lastName}}</span></md-item-template><md-not-found>La búsqueda \"{{$ctrl.driverSearchText}}\" no retornó ningun vehículo.</md-not-found></md-autocomplete></section><section class=select-vehicle-section flex=30 flex-sm=100 flex-xs=100 layout=row layout-align=\"start center\"><md-icon class=vehicle-icon flex=10 flex-sm=5 md-font-icon>directions_bus</md-icon><md-autocomplete flex class=auto-complete-box md-selected-item=$ctrl.offer.vehicle md-search-text=$ctrl.vehicleSearchText md-items=\"item in $ctrl.vehicles | filter: $ctrl.vehicleSearchText || undefined\" md-item-text=\"item.brand + \' \' + item.model + item.year\" md-min-length=0 md-floating-label=Unidad placeholder=Unidad><md-item-template><span style=\"text-transform: capitalize\" md-highlight-text=$ctrl.vehicleSearchText md-highlight-flags=^i>{{item.brand}}</span> <span style=\"text-transform: capitalize\" md-highlight-text=$ctrl.vehicleSearchText md-highlight-flags=^i>{{item.model}}</span> <span style=\"text-transform: capitalize\" md-highlight-text=$ctrl.vehicleSearchText md-highlight-flags=^i>{{item.year}}</span></md-item-template><md-not-found>La búsqueda \"{{$ctrl.vehicleSearchText}}\" no retornó ningun vehículo.</md-not-found></md-autocomplete></section><md-input-container flex=30 flex-sm=100 flex-xs=100 class=\"md-icon-float md-block\"><label>Precio (ej: 111.77)</label><md-icon md-font-icon flex=10 flex-sm=5>attach_money</md-icon><input ng-pattern=/^(?!0\\.00)[1-9]\\d{0,}(,\\d{3})*(\\.\\d\\d)?$/ name=price required ng-model=$ctrl.offer.price type=text><div ng-messages=assignForm.price.$error><div ng-message=required>Para crear una oferta debe asignar un precio.</div><div ng-message=pattern>El formato del precio ingresado no es el correcto</div></div></md-input-container><md-input-container flex=100 flex-sm=100 flex-xs=100 md-no-float class=\"md-icon-float md-block\"><md-icon class=offer-detail md-font-icon>messages</md-icon><input placeholder=\"Detalles de la oferta (opcional)\" md-maxlength=200 ng-model=$ctrl.offer.detail type=text></md-input-container></form></md-card>");
$templateCache.put("app/components/orders/components/common/offerCard/offer-card.html","<md-card layout-align=\"space-between center\" layout=row layout-wrap layout-fill ng-if=\"($ctrl.isAccepted.offerId === $ctrl.offer.id) || !$ctrl.isAccepted || !$ctrl.isAccepted.offerId\"><div class=timestamp><time am-time-ago=$ctrl.offer.createdAt></time></div><section flex=30 flex-xs=100 flex-md=30 flex-sm=35 layout=row layout-align=\"space-around start\" layout-wrap class=company-info><div flex=25 layout-fill layout=row layout-align=\"center center\"><div layout=row layout-align=\"center start\" class=icon-container><md-icon ng-if=!$ctrl.offer.company.photoURL md-font-icon>account_balance</md-icon><img ng-if=$ctrl.offer.company.photoURL ng-src={{$ctrl.getEncodedURI($ctrl.offer.company.photoURL)}}></div></div><div flex=70 layout-wrap layout=row layout-align=\"start center\" class=company-info><div class=title flex=100>{{$ctrl.offer.company.name}}</div><div class=score layout=row flex=100 layout-align=\"start center\"><div layout=row flex=50><ng-rate-it layout-fill min=0 max=5 read-only=true ng-model=$ctrl.offer.company.score></ng-rate-it></div></div><div flex=50 flex-xs=100 class=chat-cta><md-button ng-click=$ctrl.joinChat() class=\"md-accent md-hue-1\">CHAT</md-button></div></div></section><section flex=30 flex-xs=100 flex-md=30 flex-sm=35 layout=row layout-align=\"space-around center\" layout-wrap class=vehicle-info><div flex=25 layout-fill layout=row layout-align=\"center center\"><div layout=row layout-align=\"center center\" class=icon-container><md-icon ng-if=!$ctrl.offer.vehicle.photoURL md-font-icon>directions_bus</md-icon><img ng-if=$ctrl.offer.vehicle.photoURL ng-src={{$ctrl.getEncodedURI($ctrl.offer.vehicle.photoURL)}}></div></div><div flex=70 ng-if=$ctrl.offer.vehicle layout-fill layout=row layout-wrap layout-align=\"center center\"><div flex=100 class=brand-plate><span class=brand>{{$ctrl.offer.vehicle.brand}} </span><span class=plate>{{$ctrl.offer.vehicle.plate}} - {{$ctrl.offer.vehicle.year}}</span></div><div flex=100 class=max-size><label>Carga Máxima:</label><span class=size>{{$ctrl.offer.vehicle.maxSize}} toneladas</span></div><div flex=100 class=type><label>Tipo:</label>{{$ctrl.getVehicleType($ctrl.offer.vehicle.type)}}</div></div><div flex=70 ng-if=!$ctrl.offer.vehicle layout-fill layout=row layout-wrap layout-align=\"center center\"><div flex=100 class=brand-plate><span>Vehículo No Asignado</span></div></div></section><section flex=25 flex-xs=100 flex-md=20 flex-sm=20 layout=column layout-align=\"space-between start\" class=offer-description><div flex class=description ng-if=$ctrl.offer.detail>{{$ctrl.offer.detail || \'(Sin detalle)\'}}</div></section><section flex=15 flex-xs=100 flex-md=20 layout-sm=column flex-sm=20 layout=row layout-align=\"center center\" layout-wrap class=offer-price><div layout=row layout-align=\"center center\" layout-fill flex=100><div class=price>$ {{$ctrl.offer.price}}</div></div><div ng-if=\"!$ctrl.isAccepted || !$ctrl.isAccepted.offerId\" layout-fill flex=100><md-button ui-sref=\"cargo.shipperAcceptOffer({id: $ctrl.offer.orderId, offerId: $ctrl.offer.id })\" layout-fill class=\"md-accent md-hue-1\">aceptar oferta</md-button></div></section></md-card>");
$templateCache.put("app/components/orders/components/common/orderClient/orderClient.html","<md-card layout=column layout-margin><h3 class=client-card-title><strong>Cliente</strong></h3><section ng-if=$ctrl.client flex=100 layout=row><section layout=column flex=30 layout-align=\"start center\" class=photo-external-container><div class=photo-container ng-style=\"{\'background-image\': \'url(\'+$ctrl.getEncodedURI($ctrl.client.photoURL)+\')\'}\" layout=row layout-align=\"center center\"><md-icon ng-if=!$ctrl.client.photoURL md-font-icon>account_circle</md-icon></div></section><section class=client-info layout-fill flex=70 layout-align=\"space-around start\" layout=column><p class=client-company-name>{{::$ctrl.client.name}}</p><div class=client-email flex layout=row layout-align=\"start center\"><md-icon class=email-icon md-font-icon>email</md-icon><a href=mailTo:{{::$ctrl.client.email}}><p class=client-email>{{::$ctrl.client.email}}</p></a></div><div class=client-email flex layout=row layout-align=\"start center\"><md-icon md-font-icon>phone</md-icon><a href=tel:{{::$ctrl.client.phone}}><p class=client-email>{{::$ctrl.client.phone}}</p></a></div><div class=client-chat-button flex layout=row layout-align=\"start center\"><md-button ng-click=$ctrl.joinChat() class=\"md-accent md-hue-1\">chat</md-button></div></section></section><section ng-if=!$ctrl.client flex=100 layout-align=\"center start\" layout=column><h1>Esta orden no tiene cliente asignado</h1></section></md-card>");
$templateCache.put("app/components/orders/components/common/orderRouteDetails/orderRouteDetails.html","<md-card class=order-route-details-card flex=100 layout-margin><h3 class=route-details-title><strong>Ruta</strong></h3><div class=route-details-container flex-md=100 layout-padding layout-wrap layout-margin><div class=segment-container layout=column flex-xs=100 flex=100 ng-repeat=\"segment in $ctrl.order.route.segments\"><h3 class=segment-description><strong>{{segment.description}}</strong></h3><p class=distance-and-weight-info>{{segment.distance.text}} | {{segment.cargoDetails.weight.value}} {{segment.cargoDetails.weight.units || \'kg\'}}</p><div class=driver-vehicle-container layout=column layout-gt-xs=row flex=100><div flex=50 flex-xs=100 layout=row class=driver-container><div class=driver-image layout=column flex=20><div layout-align=\"center center\" ng-style=\"{\'background-image\': \'url(\'+$ctrl.getEncodedURI(segment.currentAssignedDriverInstance.photoURL)+\')\'}\" class=person-photo layout=row><md-icon class=no-driver-icon ng-if=!segment.currentAssignedDriverInstance.photoURL md-font-icon>account_box</md-icon></div></div><div class=driver-info layout=column flex=80><p>{{segment.currentAssignedDriverInstance.firstName || \'Conductor\'}} {{segment.currentAssignedDriverInstance.lastName || \'no asignado\'}}</p><p class=driver-phone-number>{{segment.currentAssignedDriverInstance.phone}}</p></div></div><div flex=50 flex-xs=100 layout=row class=vehicle-container><div class=vehicle-image layout=column flex=20><div layout-align=\"center center\" ng-style=\"{\'background-image\': \'url(\'+$ctrl.getEncodedURI(segment.currentAssignedVehicleInstance.photoURL)+\')\'}\" class=vehicle-photo layout=row><md-icon class=no-driver-icon ng-if=!segment.currentAssignedVehicleInstance.photoURL md-font-icon>directions_bus</md-icon></div></div><div class=vehicle-info layout=column flex=80><p class=vehicle-details ng-if=segment.currentAssignedVehicleInstance.plate>{{segment.currentAssignedVehicleInstance.plate | uppercase}}</p><p class=vehicle-details ng-if=!segment.currentAssignedVehicleInstance.plate>Vehículo no asignado</p><p class=vehicle-details>{{segment.currentAssignedTrailerInstance.name || \'Trailer no asignado\'}}</p></div></div></div><span class=segment-detail-field><strong>Detalles</strong>: {{segment.cargoDetails.description}}</span> <span class=segment-detail-field ng-repeat=\"(detailName,value) in $ctrl.getSegmentDetails(segment.extraFields, $ctrl.orderExtraFieldsDefinitions)\"><strong class=detail-title>{{detailName}}</strong> : {{value}} </span><span class=files-container layout=column ng-if=\"$ctrl.areFilesRelatedToOrderDetail(segment.extraFields, $ctrl.orderExtraFieldsDefinitions)\"><strong class=files-title>Archivos:</strong><div class=files-row layout=row layout-wrap><a class=file-item href={{value}} ng-repeat=\"(fileName, value) in $ctrl.getSegmentFiles(segment.extraFields, $ctrl.orderExtraFieldsDefinitions)\"><md-icon class=file-icon md-font-icon>attach_file</md-icon>{{fileName}}</a></div></span></div></div></md-card>");
$templateCache.put("app/components/orders/components/common/orderRouteMap/orderRouteMap.html","<md-card layout-align=start layout=column flex=100><div class=map-title><h3><strong>Seguimiento en tiempo real</strong></h3></div><div class=map-wrapper><ui-gmap-google-map options=$ctrl.map.options center=$ctrl.map.center zoom=$ctrl.map.zoom><ui-gmap-marker ng-repeat=\"(key,marker) in $ctrl.directionMarkers\" idkey=marker.id options=marker.options coords=marker.coords></ui-gmap-marker></ui-gmap-google-map></div></md-card>");
$templateCache.put("app/components/orders/components/common/orderSizeId/orderSizeId.html","<md-card layout-margin layout=column layout-align=\"start none\"><h3 class=order-details-title><strong>Orden</strong></h3><div flex=100 layout=row layout-wrap layout-align=\"center start\"><div class=id-section flex=33 flex-xs=100 layout=row><span class=order-id-container layout=row flex=100><div class=arrow-body layout=row layout-align=\"center center\" flex=100><strong class=order-id>{{$ctrl.order.orderNumber}}</strong></div><div class=arrow-right></div></span></div><div flex=66 flex-xs=100 layout=row layout-align-xs=\"center center\"><span class=order-main-details>{{$ctrl.order.details}}</span></div></div><div flex=100 layout=row layout-wrap layout-align=\"center start\"><div flex=33 layout=column flex-xs=100><div ng-class=$ctrl.status.class class=status layout=column layout-align=\"center center\">{{$ctrl.status.title}}</div><div ng-if=\"$ctrl.order.id && !$ctrl.shouldHideUpdateButton\" class=update_cta layout=column layout-align=\"center center\"><p ng-click=$ctrl.changeStatus() class=update-order-status-label permission permission-except=\"\'CARRIER_VIEWER\'\">ACTUALIZAR</p></div></div><div flex=66 layout=row flex-xs=100 layout-wrap layout-align-xs=space-between><span class=order-detail-field><div layout=row><strong>Hora :</strong><div class=order-detail-field-value>{{$ctrl.order.scheduledDate | date:\'HH:mm\'}}</div></div></span><span class=order-detail-field ng-repeat=\"(detailName,value) in $ctrl.getOrderDetails($ctrl.orderExtraFieldsValues, $ctrl.orderExtraFieldsDefinitions)\"><div layout=row><strong>{{detailName}}:</strong><div class=order-detail-field-value>{{value}}</div></div></span><span layout=row layout-align=\"start start\" ng-if=\"$ctrl.areFilesRelatedToOrderDetail($ctrl.orderExtraFieldsValues, $ctrl.orderExtraFieldsDefinitions)\"><strong class=files-title>Archivos:</strong><div layout=row layout-wrap><a target=_blank class=file-item href={{value}} ng-repeat=\"(fileName, value) in $ctrl.getOrderFiles($ctrl.orderExtraFieldsValues, $ctrl.orderExtraFieldsDefinitions)\"><span layout=row><md-icon class=file-icon md-font-icon>attach_file</md-icon>{{fileName}}</span></a></div></span></div></div><div layout=row flex=100 class=code-details layout-align=\"end center\">Código único:<div class=code-label>{{$ctrl.order.id}}</div></div></md-card>");
$templateCache.put("app/components/orders/components/common/orderState/change-state-popup.html","<md-dialog class=change-status-dialog aria-label=\"Change status\"><form ng-cloak><md-toolbar><div class=md-toolbar-tools><h2>Seleccione el estado de la orden</h2><span flex></span><md-button class=md-icon-button ng-click=$ctrl.cancel()><md-icon md-font-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-radio-group ng-model=$ctrl.state><md-radio-button ng-disabled=\"$ctrl.statusDictionary.indexOf(\'PICKUP_PENDING\') < 0\" class=\"radio pickup-pending\" value=PICKUP_PENDING>Por retirar</md-radio-button><md-radio-button ng-disabled=\"$ctrl.statusDictionary.indexOf(\'DELIVERY_PENDING\') < 0\" class=\"radio delivery-pending\" value=DELIVERY_PENDING>Por entregar</md-radio-button><md-radio-button ng-disabled=\"$ctrl.statusDictionary.indexOf(\'DELIVERED\') < 0\" class=\"radio delivered\" value=DELIVERED>Entregada</md-radio-button></md-radio-group></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=\"md-accent md-hue-1\" ng-click=$ctrl.changeState()>Aceptar</md-button><md-button class=\"md-accent md-hue-1\" ng-click=$ctrl.cancel()>Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/orders/components/common/orderState/orderState.html","<md-card layout-align=\"space-around center\" layout=column layout-wrap flex=80><section class=content-section layout=row layout-wrap layout-align=\"start center\"><div class=title flex=100><h1>Estado</h1></div><div flex=100 layout=row layout-align=\"center center\" ng-class=$ctrl.status.class class=status><div flex>{{$ctrl.status.title}}</div></div></section><md-divider></md-divider><md-button ng-click=$ctrl.showDialog() class=\"md-accent md-hue-1\">Actualizar</md-button></md-card>");
$templateCache.put("app/components/orders/components/common/orderTime/orderTime.html","<md-card layout-align=\"space-around center\" layout=column flex=100><section class=content-section><h2 class=week-day>{{::$ctrl.dayOfWeek}}</h2><h2 class=day-month>{{::$ctrl.dayMonth}}</h2></section><md-divider></md-divider><section ng-if=\"$ctrl.scheduledDate.flexibleTime === false\" class=content-section><h2 ng-if=$ctrl.time class=specific-time>{{::$ctrl.time}}</h2><h2 ng-if=!$ctrl.time class=specific-time>NO DEFINIDA</h2></section><section ng-if=\"$ctrl.scheduledDate.flexibleTime === true\" class=content-section><h2 class=time-day>EN LA {{::$ctrl.label}}</h2></section></md-card>");
$templateCache.put("app/components/orders/components/common/orderTimeline/orderTimeline.html","<md-card class=order-route-timeline-card flex=100 layout-margin><h3 class=timeline-card-title><strong>Línea de tiempo</strong></h3><ul class=timeline-container><li ng-repeat=\"event in $ctrl.events\"><div class=event-info-container layout=column flex=95><div layout-gt-xs=row class=event-title-row layout-align=\"space-between start\"><div>{{event.title}}</div><div class=event-date>{{$ctrl.formatEventDate(event.date)}}</div></div><div ng-if=event.data class=resource-assignation-data-container layout=column><div layout-gt-xs=row class=event-title-row layout-align=\"space-between start\" ng-if=event.data.time><span class=event-date ng-if=\"event.type === \'DEPARTURE\'\">Tiempo de viaje</span> <span class=event-date ng-if=\"event.type === \'ARRIVAL\'\">Tiempo de espera</span><div class=event-date>{{event.data.time}}</div></div><div class=vehicle-info-container ng-repeat=\"resource in event.data\"><p ng-if=\"event.type === \'Vehicle\'\" class=vehicle-name>{{resource.brand}} ({{resource.plate | uppercase}})</p><p ng-if=\"event.type === \'CargoUser\'\" class=driver-name>{{resource.name}}</p><p ng-if=\"event.type === \'Trailer\'\" class=trailer-name>{{resource.name}} ({{resource.identification}})</p><p ng-repeat=\"segment in resource.segments track by $index\">{{segment.description}}</p></div></div></div></li></ul></md-card>");
$templateCache.put("app/components/orders/components/common/shipperOrderIdCard/shipper-order-id-card.html","<md-card layout-align=\"space-around center\" layout=row layout-wrap><section layout-fill layout-wrap layout-align=\"space-around center\" layout=row flex=100><div flex=20 flex-xs=100 layout=column layout-align=\"start center\" layout-wrap><div layout=column layout-align=\"center center\" class=size-container><md-icon>directions_bus</md-icon></div><div flex><h4>#{{$ctrl.order.id}}</h4></div></div><div flex=60 flex-xs=100 layout-align=\"center start\" layout-align-xs=\"center center\" layout=column><h2 class=destination-text>{{$ctrl.from}}</h2><h2>{{$ctrl.to}}</h2><h2 class=distance>{{$ctrl.order.route.distance.text}}</h2></div><div flex=20 flex-xs=100 class=state-cta-container layout-fill layout-align=\"center center\" layout=column><div flex layout=row layout-align=\"center center\" class=state ng-class=[$ctrl.getStatusForOrder($ctrl.order.orderStatus).class]><div flex>{{::$ctrl.getStatusForOrder($ctrl.order.orderStatus).title}}</div></div></div></section><md-button ng-if=$ctrl.mayUserCancelOrder() hide-xs ng-click=$ctrl.onCancelOrder() class=\"cancel-cta md-accent md-hue-1\">cancelar solicitud</md-button><md-button ng-if=$ctrl.mayUserCancelOrder() flex-xs=100 hide-gt-xs ng-click=$ctrl.onCancelOrder() class=\"md-accent md-hue-1\">cancelar solicitud</md-button></md-card>");
$templateCache.put("app/components/orders/components/common/statusModal/statusModal.html","<md-dialog layout=column class=status-modal><div layout=row><h2>Actualizar estado de la orden</h2></div><div layout=column><md-radio-group ng-model=$ctrl.selectedStatus><md-radio-button class=status-option ng-repeat=\"status in $ctrl.availableStatuses\" value={{status.label}}>{{status.title}}</md-radio-button></md-radio-group></div><div class=assign-button-container layout=row><md-button ng-disabled=!$ctrl.selectedStatus ng-click=$ctrl.changeStatus() class=\"assign-button md-accent md-raised\">ASIGNAR</md-button></div></md-dialog>");
$templateCache.put("app/components/orders/components/common/stopovers/stopoversHistory.html","<div layout=row layout-align=\"center center\"><div flex=90 layout-align=\"center center\"><div layout=row layout-wrap class=titles-container><div flex=33></div><div flex=33>Hora de Ingreso</div><div flex=33>Hora de Salida</div></div><div layout=row layout-wrap><div ng-repeat=\"stopover in $ctrl.stopovers\" flex=33 class=entry ng-class=\"{clickable: stopover.clickable}\" ng-click=\"stopover.clickable && $ctrl.openUpsertStopoverModal(_, stopover)\" layout-align=\"end end\"><div ng-if=\"stopover.class === \'data\'\" layout=row class=\"data {{stopover.clickable? \'\' : \'disabled\'}}\" layout-align=\"center center\"><div layout-align=\"center center\">{{::stopover.datetime | date:\'dd MMM y HH:mm\'}}</div><div ng-if=!stopover.datetime class=default-message>{{::stopover.defaultMessage}}</div></div><div ng-if=\"stopover.class === \'title\'\" layout=row layout-align=\"start center\" class=stopover-name><div>{{::stopover.name}}</div></div></div></div></div></div>");
$templateCache.put("app/components/orders/components/common/updateTimelineEventsCard/updateTimelineEventsCard.html","<div class=update-order-timeline-dialog layout=column><div class=main-content-column layout=column layout-margin><div layout=row class=locations-title-row><span flex=15></span><div class=table-header flex=25 layout=row><p><strong>Hora de ingreso</strong> (planificada)</p></div><div class=table-header flex=25 layout=row><p><strong>Hora de ingreso</strong> (real)</p></div><div class=table-header flex=25 layout=row><p><strong>Salida</strong> (real)</p></div></div><div ng-repeat=\"locationRegistry in $ctrl.locationsRegistry track by $index\" layout=row class=location-row><div flex=15 layout=row><p class=location-name><strong>{{locationRegistry.location.name}}</strong></p></div><div class=datetime-container layout=row flex=25><md-input-container flex=45 flex-xs=90 class=location-date-input-container><input class=location-date-input pikaday=$ctrl.dateObj placeholder=Fecha ng-model=locationRegistry.arrivalDate.date type=text></md-input-container><md-input-container flex=25 flex-xs=90 class=location-hour-input-container><input mask=29:59 ng-change=$ctrl.verifyHour(locationRegistry.arrivalDate.hour) ng-model=locationRegistry.arrivalDate.hour restrict=reject class=location-hour-input type=text placeholder=Hora></md-input-container></div><div class=datetime-container layout=row flex=25><md-input-container flex=45 flex-xs=90 class=location-date-input-container><input pikaday=$ctrl.dateObj placeholder=Fecha ng-model=locationRegistry.departureDate.date class=location-date-input type=text></md-input-container><md-input-container flex=25 flex-xs=90 class=location-hour-input-container><input mask=29:59 ng-change=$ctrl.verifyHour(locationRegistry.departureDate.hour) ng-model=locationRegistry.departureDate.hour restrict=reject class=location-hour-input type=text placeholder=Hora></md-input-container></div><div class=datetime-container layout=row flex=35><md-input-container flex=45 flex-xs=90 class=location-date-input-container><input pikaday=$ctrl.dateObj placeholder=Fecha ng-model=locationRegistry.departureDate.date ng-change=\"$ctrl.changePoint(\'date\')\" class=location-date-input type=text></md-input-container><md-input-container flex=25 flex-xs=90 class=location-hour-input-container><input mask=29:59 ng-change=$ctrl.verifyHour(locationRegistry.departureDate.hour) ng-model=locationRegistry.departureDate.hour restrict=reject class=location-hour-input type=text placeholder=Hora></md-input-container><md-button flex=30 class=update-stopover-button layout-margin=\"\">ACTUALIZAR</md-button></div></div></div></div>");
$templateCache.put("app/components/orders/components/reassignment/driversListByCompany/drivers-list-by-company.html","<cargo77-search-bar on-search-text-filter-change=$ctrl.updateSearchText(searchText)></cargo77-search-bar><md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><section class=\"list-container page-wrapper\" layout=row layout-wrap layout-align=\"start start\"><md-card flex=100 ng-if=!$ctrl.users.length layout-align=\"start center\"><p>Por el momento no tiene conductores asignados para la compañia seleccionada o que cumplan con el criterio de búsqueda</p></md-card><cargo77-drivers-list-by-company-card order=$ctrl.order flex=25 flex-md=33 flex-sm=50 flex-xs=100 user=user ng-repeat=\"user in $ctrl.users\"></cargo77-drivers-list-by-company-card></section></md-content>");
$templateCache.put("app/components/orders/components/reassignment/trailersListByCompany/trailers-list-by-company.html","<cargo77-search-bar on-search-text-filter-change=$ctrl.updateSearchText(searchText)></cargo77-search-bar><md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><section class=\"list-container page-wrapper\" layout=row layout-wrap layout-align=\"start start\"><md-card flex=100 ng-if=!$ctrl.trailers.length layout-align=\"start center\"><p>Por el momento no tiene arrastres asignados para la compañia seleccionada o que cumplan con el criterio de búsqueda</p></md-card><cargo77-trailers-list-by-company-card flex=25 flex-md=33 flex-sm=50 flex-xs=100 trailer=trailer ng-repeat=\"trailer in $ctrl.trailers\" order=$ctrl.order></cargo77-trailers-list-by-company-card></section></md-content>");
$templateCache.put("app/components/orders/components/reassignment/vehiclesListByCompany/vehicles-list-by-company.html","<cargo77-search-bar on-search-text-filter-change=$ctrl.updateSearchText(searchText)></cargo77-search-bar><md-content id=list-wrapper layout=row layout-wrap layout-align=\"center start\"><section class=\"list-container page-wrapper\" layout=row layout-wrap layout-align=\"start start\"><md-card flex=100 ng-if=!$ctrl.vehicles.length layout-align=\"start center\"><p>Por el momento no tiene vehículos asignados para la compañia seleccionada o que cumplan con el criterio de búsqueda</p></md-card><cargo77-vehicles-list-by-company-card flex=25 flex-md=33 flex-sm=50 flex-xs=100 vehicle=vehicle ng-repeat=\"vehicle in $ctrl.vehicles\" order=$ctrl.order></cargo77-vehicles-list-by-company-card></section></md-content>");
$templateCache.put("app/components/reports/components/common/orderReportConfirmModal/orderReportConfirmModal.html","<md-dialog class=order-report-confirm-modal><md-dialog-content layout=column layout-align=\"space-between center\"><div layout=column layout-wrap><h2>¿Deseas descargar el reporte?</h2><p>El reporte contiene {{$ctrl.count}} registros, puede tardar varios minutos en completarse la descarga.</p></div><md-dialog-actions><md-button ng-click=$ctrl.accept() class=\"md-raised md-accent\">ACEPTAR</md-button><md-button ng-click=$ctrl.close() class=md-raised>CANCELAR</md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/components/reports/components/common/reportTypesCard/reportTypesCard.html","<md-card layout=row layout-wrap layout-align=\"space-around center\" ng-class=\"{\'column\': $ctrl.align === \'column\'}\"><section flex=30 flex-sm=100 flex-xs=35 layout=column layout-align=\"center center\"><div class=icon-container layout=column layout-align=\"center center\"><md-icon md-font-icon>{{$ctrl.icon}}</md-icon></div></section><section flex=65 flex-sm=100 flex-xs=60 layout=column layout-align-sm=\"center center\" ng-class=\"{\'flex-100 layout-align-center-center\': $ctrl.align === \'column\'}\" layout-align=\"space-around start\" class=info-section><div class=title>{{$ctrl.title | uppercase}}</div><div class=description>{{$ctrl.description}}</div></section></md-card>");
$templateCache.put("app/components/payments/components/paymentList/components/image-popup.html","<md-dialog><md-toolbar><div class=md-toolbar-tools layout-align=\"space-between center\" layout=row><h2>Deposito o transferencia</h2><md-button class=md-icon-button ng-click=$ctrl.close()><md-icon md-font-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-dialog-content layout=row layout-align=\"center center\"><img ng-src={{$ctrl.image}}></md-dialog-content></md-dialog>");
$templateCache.put("app/components/payments/components/paymentList/components/payments-list-card.html","<md-card ng-class=\"{\'is-read\': $ctrl.isOrderRead()}\" flex=100 layout=row layout-align=\"space-between center\" layout-wrap layout-fill><div class=order-id-container flex-xs=30 flex-md=20 flex-sm=20 flex=10 layout=column layout-align=\"start center\" layout-wrap ui-sref=\"cargo.orderDetails({id: $ctrl.order.id})\"><div layout=column layout-align=\"center center\" class=size-container><md-icon>directions_bus</md-icon></div><div flex><span><h4>#{{$ctrl.order.id}}</h4></span></div></div><div flex-xs=70 flex-md=40 flex-sm=40 flex=15 layout=row layout-wrap layout-align=\"center center\" class=order-details ui-sref=\"cargo.orderDetails({id: $ctrl.order.id})\"><div flex=100 class=direction-title><span>{{$ctrl.order.route.pickupAddress.subLocality || order.route.pickupAddress.neighborhood }} - {{::$ctrl.order.route.pickupAddress.locality}}</span></div><div flex=100 class=direction-title><span>{{$ctrl.order.route.deliveryAddress.subLocality || order.route.deliveryAddress.neighborhood }} - {{::$ctrl.order.route.deliveryAddress.locality}}</span></div><div flex=100 class=time-title><span>{{::$ctrl.order.scheduledDate.date | date: \'dd-MM-yyyy\'}}</span></div></div><div flex-xs=100 flex-md=40 flex-sm=40 flex=25 layout=row layout-wrap layout-align=\"space-around center\" class=person-details ui-sref=\"cargo.editUser({id: $ctrl.order.cargoUser.id})\"><section flex=100 layout=row layout-wrap layout-align=\"space-around center\"><div flex-offset-xs=5 flex-xs=20 flex=30><div class=person-photo ng-style=\"{\'background-image\': \'url(\'+$ctrl.getEncodedURI($ctrl.order.cargoUser.photoURL)+\')\'}\"><md-icon md-font-icon ng-if=!$ctrl.order.cargoUser.photoURL>account_circle</md-icon></div></div><div flex=70 flex-xs=70><div ng-if=!$ctrl.order.cargoCompany flex=100 class=person-company><span>Compañía no especificada</span></div><div ng-if=$ctrl.order.cargoCompany flex=100 class=person-company><span>{{::$ctrl.order.cargoCompany.name}}</span></div><div ng-if=$ctrl.order.cargoCompany flex=100 class=person-company><span>RUC: {{::$ctrl.order.cargoCompany.documentNumber}}</span></div><div flex=100 class=person-name><span>{{::$ctrl.order.cargoUser.firstName}} {{::$ctrl.order.cargoUser.lastName}}</span></div></div></section></div><div flex-offset-xs=5 flex-xs=90 flex-md=60 flex-sm=60 flex=30 layout=row layout-wrap layout-align=\"space-between center\" class=payment-type-container><div layout=row flex=80><div flex=30 ng-if=$ctrl.order.payment.voucherPhoto hide-xs><div class=payment-photo ng-click=$ctrl.showFullImage() ng-style=\"{\'background-image\': \'url(\'+$ctrl.order.payment.voucherPhoto+\')\'}\"><div layout=row layout-align=\"center center\" layout-fill><md-icon md-font-icon>visibility</md-icon></div></div></div><div layout=column layout-align=\"center start\" flex=70 class=type-price><strong hide-gt-md=\"\">Tipo de pago:</strong> {{$ctrl.getPaymentTypeForOrder().title}} <span style=\"font-size: 1.2em\">{{$ctrl.order.payment.documentNumber}}</span></div></div><div class=price ng-if=\"$ctrl.order.offers.length > 0\" layout-fill layout=row layout-align=\"end center\" flex-xs=20 flex=20 flex-sm=20><strong hide-gt-md=\"\" class=price-label>Precio:</strong> {{::$ctrl.order.offers[0].price | currency: \'$\' :2}}</div></div><div flex-offset-xs=50 flex-xs=50 flex=15 flex-md=30 flex-sm=30 layout-wrap layout=row layout-align=\"space-around center\" layout-align-md=\"space-around end\" layout-align-xs=\"end center\" class=cta-section ng-if=!$ctrl.isOrderCompletedOrDelivered()><section layout-fill ng-if=\"!$ctrl.isPaymentAccept() && $ctrl.order.payment.status !== \'VERIFIED\' && $ctrl.order.payment.status !== \'FAILED\' && $ctrl.order.acceptedOfferSummary\"><section flex=100 class=approve-cta><md-button ng-click=$ctrl.acceptPayment() layout=row layout-fill layout-align=\"center center\"><md-icon md-font-icon>check_circle</md-icon><div flex>Aprobar</div></md-button></section><section flex=100 class=reject-cta><md-button ng-click=$ctrl.rejectPayment() layout=row layout-fill layout-align=\"center center\"><md-icon md-font-icon>cancel</md-icon><div flex>rechazar</div></md-button></section></section><section layout-fill ng-if=\"(!$ctrl.isPaymentAccept() && $ctrl.order.payment.status === \'VERIFIED\') || (!$ctrl.isPaymentAccept() && $ctrl.order.payment.status === \'FAILED\')\"><section flex=100 class=undo-cta><md-button ng-click=$ctrl.undoPayment() layout=row layout-fill layout-align=\"center center\"><md-icon md-svg-icon=undo-variant></md-icon><div flex>deshacer</div></md-button></section></section><section layout=row layout-align=\"end center\" ng-if=!$ctrl.isPaymentAccepted()></section></div><div flex-offset-xs=50 flex-xs=50 flex=15 flex-md=30 flex-sm=30 layout-wrap layout=row layout-align=\"space-around center\" layout-align-md=\"space-around end\" layout-align-xs=\"end center\" class=cta-section ng-if=$ctrl.isOrderCompletedOrDelivered()><span class=completed-label>{{$ctrl.isOrderCompletedOrDelivered()}}</span></div><section class=payment-status ng-class=[$ctrl.getPaymentStatusForOrder().class] ng-if=$ctrl.isPaymentAccepted()></section><section class=payment-status ng-class=[$ctrl.getPaymentStatusForOrder().class] ng-if=$ctrl.isPaymentRejected()></section></md-card>");
$templateCache.put("app/components/trailers/components/trailersList/components/trailers-list-card.html","<md-card md-ink-ripple=#607D8B><!--TODO: card grows as name and brand gets too large. We should limit the nuber of lines to display--><div class=photo-container layout=row layout-align=\"center center\"><div class=photo flex ng-if=$ctrl.trailer.photoURL ng-style=\"{\'background-image\': \'url(\' + $ctrl.getEncodedURI($ctrl.trailer.photoURL) +\')\', \'background-size\': \'cover\'}\"></div><md-icon flex ng-if=!$ctrl.trailer.photoURL md-font-icon>rv_hookup</md-icon></div><section class=info-section><h2 class=brand-identification>{{$ctrl.trailer.identification}}</h2><h1 class=name>{{$ctrl.trailer.name}}</h1></section><section class=size-type layout=column><div permission ng-if=$ctrl.trailer.type class=type layout=row layout-align=\"space-around center\"><md-icon flex=15 md-font-icon>label</md-icon><div flex=85>{{$ctrl.getTrailerTypeName()}}</div></div><div permission layout=row class=weight layout-align=\"space-around center\"><md-icon flex=15 md-font-icon>line_weight</md-icon><div flex=85 ng-if=$ctrl.trailer.weight>{{$ctrl.trailer.weight}}</div><div flex=85 ng-if=!$ctrl.trailer.weight>Capacidad no especificada</div></div><div layout=row class=company layout-align=\"start center\"><md-icon flex=15 md-font-icon>account_balance</md-icon><div flex=85>{{$ctrl.trailer.ownerCompany.name}}</div></div></section></md-card>");
$templateCache.put("app/components/users/components/userList/components/user-list-card.html","<md-card md-ink-ripple=#607D8B layout=column ng-class=\"!$ctrl.userIsAdmin && \'card-without-company\'\"><div class=photo-container layout=row layout-align=\"center center\"><div class=photo flex ng-if=$ctrl.user.photoURL ng-style=\"{\'background-image\': \'url(\' + $ctrl.getEncodedURI($ctrl.user.photoURL) +\')\', \'background-size\': \'cover\'}\"></div><md-icon flex ng-if=!$ctrl.user.photoURL md-font-icon>person</md-icon></div><section class=info-section><h1 class=name>{{$ctrl.user.firstName}} {{$ctrl.user.lastName}}</h1></section><section class=other-info layout=column><div layout=row class=user-roles><div class=role-label ng-repeat=\"role in $ctrl.user.roles\">{{$ctrl.userRolesMap[role]}}</div></div><div class=phone layout=row layout-align=\"start center\"><md-icon flex=15 md-font-icon>phone</md-icon><div flex=85 ng-if=$ctrl.user.phone>{{$ctrl.user.phone}}</div><div flex=85 ng-if=!$ctrl.user.phone>Sin información</div></div><div ng-if=$ctrl.user.cargoCompany class=company layout-align=\"start center\" layout=row><md-icon flex=15 md-font-icon>account_balance</md-icon><div flex=85>{{$ctrl.user.cargoCompany.name}}</div></div><div ng-if=\"$ctrl.user.licenseValidUntil && $ctrl.user.roles.indexOf(\'DRIVER\') !== -1\" layout-align=\"start center\" layout=row><md-icon flex=15 md-font-icon>event</md-icon><div flex=85>Licencia: {{$ctrl.user.licenseValidUntil | date:\'dd-MMM-yyyy\'}}</div></div></section></md-card>");
$templateCache.put("app/components/vehicles/components/vehicleList/components/vehicle-list-card.html","<md-card md-ink-ripple=#607D8B><div class=photo-container layout=row layout-align=\"center center\"><div class=photo flex ng-if=$ctrl.vehicle.photoURL ng-style=\"{\'background-image\': \'url(\' + $ctrl.getEncodedURI($ctrl.vehicle.photoURL) +\')\',\n         \'background-size\': \'cover\'}\"></div><md-icon flex ng-if=!$ctrl.vehicle.photoURL md-font-icon>directions_bus</md-icon></div><section class=info-section><h1 class=plate>{{$ctrl.vehicle.plate}}</h1><h2 class=model-year>{{$ctrl.vehicle.brand}} - {{$ctrl.vehicle.model}}</h2></section><section class=size-type layout=column><div permission ng-if=$ctrl.vehicle.type class=type layout=row layout-align=\"space-around center\"><md-icon flex=15 md-font-icon>label</md-icon><div flex=85>{{$ctrl.getVehicleTypeName()}}</div></div><div permission ng-if=$ctrl.vehicle.size class=size layout=row layout-align=\"start center\"><md-icon flex=15 md-font-icon>line_weight</md-icon><div flex=85>{{$ctrl.vehicle.maxSize}} Toneladas</div></div><div layout=row layout-align=\"start center\" class=company><md-icon flex=15 md-font-icon>account_balance</md-icon><div flex=85>{{$ctrl.vehicle.ownerCompany.name}}</div></div><div layout=row layout-align=\"start center\" ng-if=$ctrl.vehicle.plateValidUntil><md-icon flex=15 md-font-icon>payment</md-icon><div flex=85>Matrícula: {{$ctrl.vehicle.plateValidUntil | date:\'dd-MMM-yyyy\'}}</div></div><div layout=row layout-align=\"start center\" ng-if=$ctrl.vehicle.insuranceValidUntil><md-icon flex=15 md-font-icon>event</md-icon><div flex=85>Seguro: {{$ctrl.vehicle.insuranceValidUntil | date:\'dd-MMM-yyyy\'}}</div></div></section></md-card>");
$templateCache.put("app/components/common/notifications/notificationsComponent/components/newScore/new-score.html","<section class=\"notification unread\" layout=row flex=100><div flex=20 class=icon-container ng-class=\"{\'read\': $ctrl.notification.isRead}\" layout=row layout-align=\"center center\"><md-icon flex md-font-icon>near_me</md-icon></div><div class=message flex=80 layout-align=\"center center\" layout=row layout-wrap><div class=timestamp-container flex=100 layout=row layout-align=\"end start\"><div class=timestamp>{{$ctrl.notification.timeFromNow}}</div></div><div flex=100 class=title><span>Nueva calificación recibida</span></div><div flex=100 class=subtitle layout=row layout-wrap layout-align=\"start center\"><div flex=100>Calificación: {{$ctrl.notification.score}}</div><div flex=100>Calificación Acumulada: {{$ctrl.notification.companyScore}}</div></div></div></section>");
$templateCache.put("app/components/common/notifications/notificationsComponent/components/offerAccepted/offer-accepted.html","<section class=\"notification unread\" layout=row flex=100><div flex=20 class=icon-container ng-class=\"{\'read\': $ctrl.notification.isRead}\" layout=row layout-align=\"center center\"><md-icon flex md-font-icon>stars</md-icon></div><div class=message flex=80 layout-align=\"center center\" layout=row layout-wrap><div class=timestamp-container flex=100 layout=row layout-align=\"end start\"><div class=timestamp>{{$ctrl.notification.timeFromNow}}</div></div><div flex=100 class=title><span>¡Oferta aceptada!</span></div><div flex=100 class=subtitle layout=row layout-wrap layout-align=\"start center\"><div flex=100><p>#{{$ctrl.notification.orderNumber}} ({{$ctrl.notification.route}})</p></div><div flex=100 class=date><p>{{$ctrl.formatDate()}}</p></div></div></div></section>");
$templateCache.put("app/components/common/notifications/notificationsComponent/components/offerReceived/offer-received.html","<section class=\"notification unread\" layout=row flex=100><div flex=20 class=icon-container ng-class=\"{\'read\': $ctrl.notification.isRead}\" layout=row layout-align=\"center center\"><md-icon flex md-font-icon>archive</md-icon></div><div class=message flex=80 layout-align=\"center center\" layout=row layout-wrap><div class=timestamp-container flex=100 layout=row layout-align=\"end start\"><div class=timestamp>{{$ctrl.notification.timeFromNow}}</div></div><div flex=100 class=title><span>Nueva oferta recibida</span></div><div flex=100 class=subtitle layout=row layout-wrap layout-align=\"start center\"><div flex=100>{{$ctrl.notification.orderNumber}} - {{$ctrl.notification.route}}</div></div><div flex=100 class=subtitle layout=row layout-wrap layout-align=\"start center\"><div flex=100>{{$ctrl.notification.companyName}} - ${{$ctrl.notification.price}}</div></div></div></section>");
$templateCache.put("app/components/common/notifications/notificationsComponent/components/orderAssigned/order-assigned.html","<section class=\"notification unread\" layout=row flex=100><div flex=20 class=icon-container ng-class=\"{\'read\': $ctrl.notification.isRead}\" layout=row layout-align=\"center center\"><md-icon flex md-font-icon>assignment_ind</md-icon></div><div class=message flex=80 layout-align=\"center center\" layout=row layout-wrap><div class=timestamp-container flex=100 layout=row layout-align=\"end start\"><div class=timestamp>{{$ctrl.notification.timeFromNow}}</div></div><div flex=100 class=title><span>Nuevo flete asignado</span></div><div flex=100 class=subtitle layout=row layout-wrap layout-align=\"start center\"><div flex=100><p>#{{$ctrl.notification.orderNumber}} ({{$ctrl.notification.route}})</p></div><div flex=100 class=date><p>{{$ctrl.formatDate()}}</p></div></div></div></section>");
$templateCache.put("app/components/common/notifications/notificationsComponent/components/orderDailyReminder/order-daily-reminder.html","<section class=\"notification unread\" layout=row flex=100><div flex=20 class=icon-container ng-class=\"{\'read\': $ctrl.notification.isRead}\" layout=row layout-align=\"center center\"><md-icon flex md-font-icon>date_range</md-icon></div><div class=message flex=80 layout-align=\"center center\" layout=row layout-wrap><div flex=100 class=title><span>Mañana tienes {{$ctrl.notification.segments.length}} viaje(s).</span></div><div flex=100 class=subtitle layout=row layout-wrap layout-align=\"start center\"><div flex=100><p ng-repeat=\"segment in $ctrl.notification.segments\">{{segment}}</p></div></div></div></section>");
$templateCache.put("app/components/common/notifications/notificationsComponent/components/orderReminder/order-reminder.html","<section class=\"notification unread\" layout=row flex=100><div flex=20 class=icon-container ng-class=\"{\'read\': $ctrl.notification.isRead}\" layout=row layout-align=\"center center\"><md-icon flex md-font-icon>date_range</md-icon></div><div class=message flex=80 layout-align=\"center center\" layout=row layout-wrap><div flex=100 class=title><span>Es hora de iniciar el flete</span></div><div flex=100 class=subtitle layout=row layout-wrap layout-align=\"start center\"><div flex=100><p>#{{$ctrl.notification.orderNumber}} ({{$ctrl.notification.route}})</p><p>{{$ctrl.formatDate()}}</p></div></div></div></section>");
$templateCache.put("app/components/common/notifications/notificationsComponent/components/orderStatus/order-status.html","<section class=\"notification unread\" layout=row flex=100><div flex=20 class=icon-container ng-class=\"{\'read\': $ctrl.notification.isRead}\" layout=row layout-align=\"center center\"><md-icon flex md-font-icon>local_shipping</md-icon></div><div class=message flex=80 layout-align=\"center center\" layout=row layout-wrap><div class=timestamp-container flex=100 layout=row layout-align=\"end start\"><div class=timestamp>{{$ctrl.notification.timeFromNow}}</div></div><div flex=100 class=title><span ng-if=\"$ctrl.notification.code === \'PICKUP_PENDING\'\">Transporte en camino</span> <span ng-if=\"$ctrl.notification.code === \'DELIVERY_PENDING\'\">Carga en camino</span> <span ng-if=\"$ctrl.notification.code === \'DELIVERED\'\">Carga entregada con éxito</span></div><div flex=100 class=subtitle layout=row layout-wrap layout-align=\"start center\"><div flex=100><p>#{{$ctrl.notification.orderNumber}} - {{$ctrl.notification.route}}</p></div><div flex=100 ng-if=\"$ctrl.notification.code !== \'DELIVERED\'\">Tiempo estimado: {{$ctrl.notification.estTime}}</div></div></div></section>");
$templateCache.put("app/components/common/notifications/notificationsComponent/components/paymentStatus/payment-status.html","<section class=\"notification unread\" layout=row flex=100><div flex=20 class=icon-container ng-class=\"{\'read\': $ctrl.notification.isRead}\" layout=row layout-align=\"center center\"><md-icon flex md-font-icon ng-if=\"$ctrl.notification.code === \'PAYMENT_VERIFIED\'\">account_balance_wallet</md-icon><md-icon flex md-font-icon ng-if=\"$ctrl.notification.code === \'PAYMENT_REJECTED\'\">cancel</md-icon></div><div class=message flex=80 layout-align=\"center center\" layout=row layout-wrap><div class=timestamp-container flex=100 layout=row layout-align=\"end start\"><div class=timestamp>{{$ctrl.notification.timeFromNow}}</div></div><div flex=100 class=title><span ng-if=\"$ctrl.notification.code === \'PAYMENT_VERIFIED\'\">Pago verificado</span> <span ng-if=\"$ctrl.notification.code === \'PAYMENT_REJECTED\'\">Pago rechazado</span></div><div flex=100 class=subtitle layout=row layout-wrap layout-align=\"start center\"><div flex=100>#{{$ctrl.notification.orderNumber}} - {{$ctrl.notification.companyName}} (${{$ctrl.notification.price}})</div></div></div></section>");
$templateCache.put("app/components/common/notifications/notificationsComponent/components/stopoverRegistry/stopover-registry-notification.html","<section class=\"notification unread\" layout=row flex=100><div flex=20 class=icon-container ng-class=\"{\'read\': $ctrl.notification.isRead}\" layout=row layout-align=\"center center\"><md-icon flex md-font-icon>date_range</md-icon></div><div class=message flex=80 layout-align=\"center center\" layout=row layout-wrap><div flex=100 class=title><span>{{$ctrl.getMainTitle()}}</span></div><div flex=100 class=subtitle layout=row layout-wrap layout-align=\"start center\"><div flex=100><p>{{$ctrl.getSecondaryDetails()}}</p></div></div></div></section>");
$templateCache.put("app/components/common/notifications/notificationsComponent/components/ordersReminder/orders-reminder.html","<section class=\"notification unread\" layout=row flex=100><div flex=20 class=icon-container ng-class=\"{\'read\': $ctrl.notification.isRead}\" layout=row layout-align=\"center center\"><md-icon flex md-font-icon>date_range</md-icon></div><div class=message flex=80 layout-align=\"center center\" layout=row layout-wrap><div class=timestamp-container flex=100 layout=row layout-align=\"end start\"><div class=timestamp>{{$ctrl.notification.timeFromNow}}</div></div><div flex=100 class=title><span>Es hora de iniciar el flete</span></div><div flex=100 class=subtitle layout=row layout-wrap layout-align=\"start center\"><div ng-repeat=\"order in $ctrl.notifications.orders\" flex=100><p>{{order}})</p></div><div flex=100 class=date><p>{{$ctrl.time}}</p></div></div></div></section>");
$templateCache.put("app/components/companies/components/common/multiple-text-selector/text-selector/text-selector.html","<section class=dropdown-options layout=row><div flex=95 layout=row layout-align=space-between><md-input-container flex=100><input placeholder=\"Ingrese una opción\" ng-model=$ctrl.value type=text required ng-change=$ctrl.changeOption()></md-input-container></div><md-icon flex=5 ng-click=$ctrl.deleteOption($ctrl.option) ng-if=$ctrl.mayOptionBeDeleted md-font-icon>clear</md-icon></section>");
$templateCache.put("app/components/notification-inbox/components/notificationInboxList/components/extrafieldChanged/extrafield-changed.html","<md-card flex=100 layout=row layout-align=\"space-between center\" layout-fill><div class=order-wrapper layout=row layout-align=\"start center\"><div class=order-icon layout=row layout-align=\"center center\"><md-icon>description</md-icon><div class=badge-unread ng-if=!$ctrl.notification.isRead></div></div><div layout=column class=order-number><span class=order-number-title>Orden</span> <span class=order-number-subtitle>{{$ctrl.notification.orderNumber}}</span></div></div><div class=file-wrapper layout=row flex><div class=file-details layout=column layout-wrap><div class=file-field-name>{{$ctrl.notification.extraFieldName}}</div><div class=file-link><a ng-click=\"$ctrl.openFile($event, $ctrl.notification.extraFieldValue, $ctrl.notification)\">{{$ctrl.notification.extraFieldFileName}}<md-tooltip md-direction=right>Descargar archivo</md-tooltip></a></div></div></div><div flex class=details-wrapper layout=column layout-wrap layout-align=\"center end\"><div flex class=details-user-creator layout=row layout-align=\"center center\"><md-icon>person</md-icon><span class=user-creator-name><span class=user-creator-updated-by>Actualizado por:&nbsp; </span>{{$ctrl.notification.creatorFirstName}} {{$ctrl.notification.creatorLastName}}</span></div><div class=\"details-date large\">{{$ctrl.notification.fullDate}}</div><div class=\"details-date small\">{{$ctrl.notification.smallFullDate}}</div></div></md-card>");
$templateCache.put("app/components/orders/components/common/stopovers/upsertStopoverModal/upsertStopoverModal.html","<md-dialog class=upsert-stopover-modal layout=column><md-dialog-content layout=column layout-align=\"space-between center\"><div layout=row layout-wrap><md-input-container layout=row flex=40 flex-xs=40><label>Fecha</label><datepicker date-format=dd/MM/yyyy date-set={{$ctrl.initDate}} datepicker-class=datepicker><input placeholder=Fecha ng-change=$ctrl.setMaxDate() ng-model=$ctrl.date type=text required readonly autocomplete=off></datepicker></md-input-container><md-input-container layout=row flex=40 flex-xs=40><label>Hora</label><input type=time placeholder=HH:mm ng-change=$ctrl.setMaxDate() ng-model=$ctrl.time autocomplete=off required></md-input-container><div class=delete-icon layout=row layout-align=\"end center\" flex=20><md-button ng-if=$ctrl.id ng-click=$ctrl.deleteStopover() ng-disabled=$ctrl.isSaving class=md-icon-button><md-icon md-font-icon>delete</md-icon></md-button></div></div><md-dialog-actions layout=row layout-align=\"center center\"><md-button ng-click=$ctrl.saveStopover() ng-disabled=$ctrl.isSaving class=\"md-raised md-accent\">Aceptar</md-button><md-button ng-click=$ctrl.closeDialog() ng-disabled=$ctrl.isSaving class=md-raised>Cancelar</md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/components/orders/components/reassignment/driversListByCompany/components/drivers-list-by-company-card.html","<md-card ng-click=$ctrl.openDriverModal() layout=row layout-wrap layout-align=\"space-around start\"><section flex=100 layout=row layout-wrap layout-align=\"space-around center\" class=driver-info-section><section flex=30 layout=column layout-align=\"center center\"><div class=\"photo-container driver-photo\" ng-style=\"{\'background-image\': \'url(\'+$ctrl.getEncodedURI($ctrl.user.photoURL)+\')\'}\" layout=row layout-align=\"center center\"><md-icon ng-if=!$ctrl.user.photoURL md-font-icon>account_box</md-icon></div></section><section flex=70 layout=column layout-align=\"space-around start\" class=info-section><h3><strong>{{$ctrl.user.firstName}} {{$ctrl.user.lastName}}</strong></h3><div class=phone>{{$ctrl.user.phone}}</div><section layout-align=\"space-around start\" class=vehicle-label><div ng-if=$ctrl.user.defaultVehicle layout=row>Vehículo asignado<div class=vehicle-plate>: {{$ctrl.user.defaultVehicle.plate}}</div></div><div ng-if=!$ctrl.user.defaultVehicle class=vehicle-label>No tiene vehículo asignado</div></section></section></section></md-card>");
$templateCache.put("app/components/orders/components/reassignment/trailersListByCompany/components/trailers-list-by-company-card.html","<md-card layout=row layout-wrap layout-align=\"space-around start\" ng-click=$ctrl.openTrailerModal()><section flex=100 layout=row layout-wrap layout-align=\"space-around center\" class=trailer-info-section><section flex=35 layout=column layout-align=\"center center\"><div class=\"photo-container trailer-photo\" ng-style=\"{\'background-image\': \'url(\'+$ctrl.getEncodedURI($ctrl.trailer.photoURL)+\')\'}\" layout=row layout-align=\"center center\"><md-icon ng-if=!$ctrl.trailer.photoURL md-font-icon>rv_hookup</md-icon></div></section><section flex=65 layout=column layout-align=\"space-around start\" class=info-section><h3><strong>{{$ctrl.trailer.name}}</strong></h3><div layout=column class=trailer-label>{{$ctrl.trailer.identification}}</div><div layout=column class=trailer-label>{{$ctrl.trailer.brand}}</div></section></section></md-card>");
$templateCache.put("app/components/orders/components/reassignment/vehiclesListByCompany/components/vehicles-list-by-company-card.html","<md-card layout=row layout-wrap layout-align=\"space-around start\" ng-click=$ctrl.openVehicleModal()><section flex=100 layout=row layout-wrap layout-align=\"space-around center\" class=vehicle-info-section><section flex=35 layout=column layout-align=\"center center\"><div class=\"photo-container vehicle-photo\" ng-style=\"{\'background-image\': \'url(\'+ $ctrl.getEncodedURI($ctrl.vehicle.photoURL)+\')\'}\" layout=row layout-align=\"center center\"><md-icon ng-if=!$ctrl.vehicle.photoURL md-font-icon>directions_bus</md-icon></div></section><section flex=65 layout=column layout-align=\"space-around start\" class=info-section><h3><strong>{{$ctrl.vehicle.plate}}</strong></h3><div class=vehicle-label>{{$ctrl.vehicle.brand}} {{$ctrl.vehicle.model}}</div><section layout-align=\"space-around start\" class=trailer-label><div layout=row>Arrastre Asignado</div><div class=trailer-info ng-if=!$ctrl.vehicle.defaultTrailer layout=row>No tiene arrastre asignado</div><div class=trailer-info ng-if=$ctrl.vehicle.defaultTrailer layout=row>{{$ctrl.vehicle.defaultTrailer.name}} | {{$ctrl.vehicle.defaultTrailer.identification}}</div></section></section></section></md-card>");
$templateCache.put("app/components/orders/components/shipperAcceptOffer/components/covenantPayment/covenant-payment.html","<div flex=100 id=transfer-info class=step-container><div layout=row class=step-counter layout-align=\"center center\" flex>2</div><div class=info-container layout=row layout-align=\"start center\" layout-wrap><div flex=100><h1 class=title>Convenio de pago</h1></div><div flex=50 flex-xs=100 layout=row layout-align=\"space-around start\" layout-wrap class=transfer-info-container><div flex=100 class=subtitle>Este flete está sujeto al convenio de pago de Cargo77 con El Cliente S.A.</div><div flex=100 layout=row layout-align=\"start center\"><md-checkbox ng-model=$ctrl.areTermsAccepted aria-label=\"Terminos y condiciones\">Acepto los <span class=terms-link ng-click=$ctrl.showTerms()>Terminos y Condiciones</span></md-checkbox></div></div></div></div>");
$templateCache.put("app/components/orders/components/shipperAcceptOffer/components/creditCardPayment/credit-card-payment.html","<div flex=100 layout-fill id=verify-payment class=step-container><div layout=row class=step-counter layout-align=\"center center\" flex>2</div><div class=info-container layout-fill layout=row layout-align=\"start center\" layout-wrap><div flex=100><h1 class=title>Tarjeta de credito</h1></div><section layout-fill flex=60 ng-if=\"$ctrl.previousCreditCards.length > 0\"><md-radio-group layout-fill ng-model=$ctrl.creditCard><md-radio-button ng-click=\"$ctrl.newCreditCard = false\" flex=100 layout=row ng-value=card ng-repeat=\"card in $ctrl.previousCreditCards\"><div layout-fill layout=row layout-align=\"space-between center\"><div flex=30 class=credit-card ng-class=[card.type]></div><div flex=65>{{card.last4}}</div></div></md-radio-button><md-radio-button layout=row layout-align=\"start center\" ng-value={} ng-click=\"$ctrl.newCreditCard = true; $ctrl.creditCard.id = null;\">Nueva tarjeta</md-radio-button></md-radio-group></section><form name=ccForm ng-if=\"($ctrl.newCreditCard === true) || !$ctrl.previousCreditCards\" flex=50 flex-md=60 flex-sm=80 flex-xs=90 class=subtitle layout=row layout-wrap><section class=credit-cards flex=100 layout=row layout-align=\"start center\"><div flex=15 flex-md=25 flex-sm=20 flex-xs=25 class=\"credit-card amex\" ng-class=\"{\'selected\': ccForm.ccNumber.$ccType === \'American Express\'}\"><img src=/assets/images/creditCards/cc-amex.png></div><div flex=15 flex-md=25 flex-sm=20 flex-xs=25 ng-class=\"{\'selected\': ccForm.ccNumber.$ccType === \'Discover\'}\" class=\"credit-card discover\"><img src=/assets/images/creditCards/cc-discover.png></div><div flex=15 flex-md=25 flex-sm=20 flex-xs=25 ng-class=\"{\'selected\': ccForm.ccNumber.$ccType === \'MasterCard\'}\" class=\"credit-card mastercard\"><img src=/assets/images/creditCards/cc-mastercard.png></div><div flex=15 flex-md=25 flex-sm=20 flex-xs=25 ng-class=\"{\'selected\': ccForm.ccNumber.$ccType === \'Visa\'}\" class=\"credit-card visa\"><img src=/assets/images/creditCards/cc-visa.png></div></section><div flex=100 class=card-number layout=row layout-wrap><md-input-container layout-fill md-no-float flex=100><input type=text id=cardNumber cc-number cc-eager-type name=ccNumber ng-model=$ctrl.creditCard.number placeholder=\"Ingresa el número de tu tarjeta\"></md-input-container></div><div flex=100 layout=row layout-wrap layout-align=\"space-between center\"><section flex=45 flex-xs=100><md-input-container layout-fill><label>Mes</label><md-select md-container-class=credit-card-month ng-model=$ctrl.creditCard.expire_month><md-option ng-repeat=\"month in $ctrl.months\" ng-value=$index+1>{{month}}</md-option></md-select></md-input-container></section><section flex=20 flex-xs=60><md-input-container layout-fill><label>Año</label><md-select md-container-class=credit-card-year ng-model=$ctrl.creditCard.expire_year><md-option ng-repeat=\"year in $ctrl.availableYears\" ng-value=year>{{year}}</md-option></md-select></md-input-container></section><section flex=25 flex-xs=35><md-input-container layout-fill><label>CCV</label><input type=text id=cvc cc-cvc cc-type=ccForm.ccNumber.$ccType name=ccCvc ng-model=$ctrl.creditCard.cvv2></md-input-container></section></div></form></div></div>");
$templateCache.put("app/components/orders/components/shipperAcceptOffer/components/transferPayment/transfer-payment.html","<div flex=100 id=transfer-info class=step-container><div layout=row class=step-counter layout-align=\"center center\" flex>2</div><div class=info-container layout=row layout-align=\"start center\" layout-wrap><div flex=100><h1 class=title>Transferencia bancaria</h1></div><div flex=50 flex-md=70 flex-xs=100 layout=row layout-align=\"space-around start\" layout-wrap class=transfer-info-container><div flex=100 class=subtitle>Realiza el depósito o transferencia con los siguientes datos:</div><div flex=100 class=company-information layout-align=\"start center\" layout=row layout-wrap><div flex=100 layout=row layout-wrap layout-align=\"start center\"><div flex=20 flex-xs=100><label>Nombre:</label></div><div flex=70 flex-xs=90 flex-offset-xs=5>Cargo77 S.A.</div></div><div flex=100 layout=row layout-wrap layout-align=\"start center\"><div flex=20 flex-xs=100><label>RUC:</label></div><div flex=70 flex-xs=90 flex-offset-xs=5>1799999999999001</div></div></div><div flex=100 class=bank-information layout-align=\"start center\" layout=row layout-wrap><section flex=45 flex-md=45 flex-xs=100 class=account-info layout=column layout-align=\"center center\"><div flex class=account-number>123456789</div><div flex class=bank-name>PICHINCHA</div><div flex class=account-type>Corriente</div></section><section flex=45 flex-md=45 flex-xs=100 class=account-info layout=column layout-align=\"center center\"><div flex class=account-number>123456789</div><div flex class=bank-name>PRODUBANCO</div><div flex class=account-type>Ahorro</div></section></div></div></div></div><div flex=100 id=verify-payment class=step-container><div layout=row class=step-counter layout-align=\"center center\" flex>3</div><div class=info-container layout=row layout-align=\"start center\" layout-wrap><div flex=100><h1 class=title>Verifica tu pago</h1></div><div flex=50 flex-md=60 flex-xs=100 layout=row layout-align=\"space-around start\" layout-wrap class=verify-payment-container><div flex=100 class=subtitle>Sube una imagen con el comprobante.</div><div flex=100 layout-wrap layout=row layout-align=\"space-between center\"><div flex=80 flex-xs=100 layout-align=\"center center\" layout=row ngf-resize=\"{width: 800, height: 800, restoreExif: false}\" ngf-resize-if=\"$width > 800 || $height > 800\" ng-disabled=$ctrl.documentNumber ngf-select=$ctrl.getBase64() ngf-max-size=2MB ngf-capture ng-model=$ctrl.photo accept=image/*><md-icon hide-xs md-font-icon>photo_camera</md-icon><md-button flex ng-disabled=$ctrl.documentNumber class=\"md-accent md-hue-1\">ADJUNTA EL COMPROBANTE</md-button></div><img flex=15 flex-xs=90 ngf-src=$ctrl.photo><div class=remove-image ng-click=\"$ctrl.photo = null; $ctrl.base64 = null;\" ng-if=$ctrl.photo><md-icon md-font-icon>cancel</md-icon></div></div></div><div flex=100 class=subtitle layout=row layout-wrap><div flex=100>O ingresa el numero del deposito o transferencia.</div><md-input-container layout-fill md-no-float flex=40 flex-md=50 flex-xs=100><input type=text ng-disabled=$ctrl.photo ng-model=$ctrl.documentNumber></md-input-container></div></div></div>");}]);